/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 3658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var isArray = __webpack_require__(3157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 7045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__(6339);
var defineProperty = __webpack_require__(3070);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 4154:
/***/ (function(module) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8113:
/***/ (function(module) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(648);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 8053:
/***/ (function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 7658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var fails = __webpack_require__(7293);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 6229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(8052);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var validateArgumentsLength = __webpack_require__(8053);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2');

params['delete']('a', 1);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 7330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(8052);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var validateArgumentsLength = __webpack_require__(8053);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

if (params.has('a', 2)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 2062:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var uncurryThis = __webpack_require__(1702);
var defineBuiltInAccessor = __webpack_require__(7045);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),

/***/ 8007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adv-modal-atom[data-v-6255bb6b]{position:fixed;display:flex;justify-content:center;align-items:center;height:100%;width:100%;left:0;top:0;z-index:99999;overflow-y:auto;overflow-x:hidden;flex-wrap:wrap}.adv-modal-atom__modal[data-v-6255bb6b]{display:flex;flex-direction:column;background-color:var(--ace-c-primary-white);border-radius:5px;position:relative}.adv-modal-atom__modal__header[data-v-6255bb6b]{position:sticky;top:0;z-index:999;display:grid;grid-template-columns:minmax(0,max-content) minmax(0,1fr) minmax(0,max-content);grid-template-rows:minmax(80px,max-content);gap:var(--ace-gutter);background:var(--ace-c-section-table-highlight);border-radius:5px 5px 0 0}.adv-modal-atom__modal__header--overflowing[data-v-6255bb6b]{box-shadow:0 3px 6px 0 rgba(0,0,0,.16);border-radius:0}.adv-modal-atom__modal__header__title[data-v-6255bb6b]{display:flex;align-items:center;background:var(--ace-c-section-primary);font-family:var(--ace-font-bold);font-size:20px;line-height:24px;padding:0 32px;border-radius:5px 0 0 0}.adv-modal-atom__modal__header__values[data-v-6255bb6b]{display:flex;align-items:center;gap:var(--ace-gutter);overflow:hidden}.adv-modal-atom__modal__header__values__value[data-v-6255bb6b]{border-left:4px solid var(--ace-c-section-primary);padding-left:16px}.adv-modal-atom__modal__header__values__value__label[data-v-6255bb6b]{font-family:var(--ace-font-bold);font-size:14px;line-height:1;padding-bottom:8px}.adv-modal-atom__modal__header__values__value__value[data-v-6255bb6b]{font-size:18px;line-height:20px}.adv-modal-atom__modal__header__close[data-v-6255bb6b]{padding-right:15px;display:flex;justify-content:center;align-items:center}.adv-modal-atom__modal__header__close__icon[data-v-6255bb6b]{width:15px;height:15px;padding:15px;cursor:pointer}.adv-modal-atom__modal__panel[data-v-6255bb6b]{background:var(--ace-c-section-secondary);padding:30px}.adv-modal-atom__modal__content[data-v-6255bb6b]{padding:30px}.adv-modal-atom__modal__footer[data-v-6255bb6b]{position:sticky;bottom:0;background:var(--ace-c-primary-white);padding:20px 30px;border-radius:0 0 5px 5px;z-index:999}.adv-modal-atom__modal__footer--overflowing[data-v-6255bb6b]{box-shadow:0 -3px 6px 0 rgba(0,0,0,.16);border-radius:0}.adv-modal-atom__modal--sm[data-v-6255bb6b]{width:25%}.adv-modal-atom__modal--md[data-v-6255bb6b]{width:50%}.adv-modal-atom__modal--lg[data-v-6255bb6b]{width:75%}.adv-modal-atom__modal--xl[data-v-6255bb6b]{width:calc(100% - 40px)}@media (max-width:991.98px){.adv-modal-atom__modal--sm[data-v-6255bb6b]{width:60%}.adv-modal-atom__modal--md[data-v-6255bb6b]{width:70%}.adv-modal-atom__modal--lg[data-v-6255bb6b]{width:80%}}@media (max-width:767.98px){.adv-modal-atom__modal--lg[data-v-6255bb6b],.adv-modal-atom__modal--md[data-v-6255bb6b],.adv-modal-atom__modal--sm[data-v-6255bb6b],.adv-modal-atom__modal--xl[data-v-6255bb6b]{width:calc(100% - 40px)}}.adv-modal-atom--regular.adv-modal-atom--active[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-enter-active[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-leave-active[data-v-6255bb6b]{transition:all .4s ease-in-out;background-color:rgba(0,0,0,.3)}.adv-modal-atom--regular.adv-modal-atom-enter-from[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-leave-to[data-v-6255bb6b]{background-color:transparent}.adv-modal-atom--regular.adv-modal-atom--active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-enter-active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-leave-active .adv-modal-atom__modal[data-v-6255bb6b]{transition:all .4s ease-in-out;opacity:1;transform:translateZ(0)}.adv-modal-atom--regular .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-enter-from .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--regular.adv-modal-atom-leave-to .adv-modal-atom__modal[data-v-6255bb6b]{opacity:0;transform:translate3d(0,100%,0)}.adv-modal-atom--nested.adv-modal-atom--active[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-enter-active[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-leave-active[data-v-6255bb6b]{transition:all .4s ease-in-out;opacity:1}.adv-modal-atom--nested[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-enter-from[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-leave-to[data-v-6255bb6b]{opacity:0}.adv-modal-atom--nested.adv-modal-atom--active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-enter-active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-leave-active .adv-modal-atom__modal[data-v-6255bb6b]{transition:all .4s ease-in-out;transform:translateZ(0)}.adv-modal-atom--nested .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-enter-from .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--nested.adv-modal-atom-leave-to .adv-modal-atom__modal[data-v-6255bb6b]{transform:translate3d(100%,0,0)}.adv-modal-atom--stash.adv-modal-atom--active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--stash.adv-modal-atom-enter-active .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--stash.adv-modal-atom-leave-active .adv-modal-atom__modal[data-v-6255bb6b]{transition:all .4s ease-in-out;transform:translate3d(calc(-50vw - 50% + 40px),0,0);filter:blur(3px)}.adv-modal-atom--stash .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--stash.adv-modal-atom-from .adv-modal-atom__modal[data-v-6255bb6b],.adv-modal-atom--stash.adv-modal-atom-leave-to .adv-modal-atom__modal[data-v-6255bb6b]{transform:translateZ(0)}.adv-modal-atom[data-v-6255bb6b] .modal-atom{border-radius:5px}.adv-modal-atom[data-v-6255bb6b] .modal-atom__content{width:-moz-fit-content;width:fit-content}@media (max-width:1350px){.adv-modal-atom[data-v-6255bb6b] .date-input-atom--active:before{width:100%;height:100%}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auto-complete-atom[data-v-5b6dd989]{display:flex;flex-direction:column;font-size:18px;color:var(--ace-c-text-black)}.auto-complete-atom__row[data-v-5b6dd989]{display:flex;flex-direction:row;position:relative}.auto-complete-atom__row__input[data-v-5b6dd989]{flex:1;width:100%;height:36px;padding:0 0 0 16px;font-size:18px;font-family:BrixSansLight;color:inherit;box-shadow:0 0 2 var(--ace-c-primary-gray);border:1px solid var(--ace-c-text-gray);border-top-left-radius:3px;border-bottom-left-radius:3px;border-right:0;outline:0;outline:none;box-sizing:border-box;resize:none}.auto-complete-atom__row__input[data-v-5b6dd989],.auto-complete-atom__row__prefix-dropdown[data-v-5b6dd989]{display:flex;align-items:center;background-color:var(--ace-c-primary-gray);transition:all .2s ease}.auto-complete-atom__row__prefix-dropdown[data-v-5b6dd989]{flex-direction:row;padding-right:7px;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;border-top-right-radius:3px;border-bottom-right-radius:3px;border-right:0;border:1px solid var(--ace-c-text-gray);border-left:transparent}.auto-complete-atom__row__prefix-dropdown__icon[data-v-5b6dd989]{width:16px;height:16px;min-width:16px;min-height:16px;margin:0 7px;color:inherit}.auto-complete-atom--disabled[data-v-5b6dd989]{color:var(--ace-c-text-gray);pointer-events:none}.auto-complete-atom__label--disabled[data-v-5b6dd989]{border-left:2px solid var(--ace-c-text-gray)}.auto-complete-atom--inactive[data-v-5b6dd989]{pointer-events:none}.auto-complete-atom__row--inactive[data-v-5b6dd989]{border-left:2px solid var(--ace-c-section-primary)}.auto-complete-atom__row__input--inactive[data-v-5b6dd989]{background-color:#fff;border:none}.auto-complete-atom__row[data-v-5b6dd989]:focus{border-bottom-right-radius:15px;border-bottom-left-radius:15px}.auto-complete-atom__row:focus .auto-complete-atom__row__prefix-dropdown[data-v-5b6dd989]{border-bottom-right-radius:0;overflow:hidden}.auto-complete-atom__row:focus .auto-complete-atom__row__input[data-v-5b6dd989]{border-bottom-left-radius:0}.auto-complete-atom__row:focus .auto-complete-atom__row__prefix-dropdown[data-v-5b6dd989]:not(:active),.auto-complete-atom__row__input[data-v-5b6dd989]:focus{background:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-blue)}.auto-complete-atom__row:active .auto-complete-atom__row__input[data-v-5b6dd989],.auto-complete-atom__row:active .auto-complete-atom__row__prefix-dropdown[data-v-5b6dd989]{background-color:var(--ace-c-primary-blue-light)}.auto-complete-atom__row[data-v-5b6dd989]:active{border-radius:3px;box-shadow:0 0 0 1px var(--ace-c-text-black)}.auto-complete-atom__options[data-v-5b6dd989]{display:flex;flex-direction:column;position:absolute;width:100%;height:auto;max-height:150px;top:35px;left:0;transform-origin:50% 0;transition:all .2s ease;transform:scale(.975,0);overflow-y:scroll;overflow-x:auto;background-color:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-gray);border:1px solid var(--ace-c-text-gray);box-sizing:border-box;resize:none;z-index:4}.auto-complete-atom__options--is-active[data-v-5b6dd989]{transform:scale(1);border-bottom-left-radius:3px;border-bottom-right-radius:3px}.auto-complete-atom__options__option[data-v-5b6dd989]{cursor:pointer;line-height:26px;padding-left:5px;word-wrap:normal}.auto-complete-atom__options__option[data-v-5b6dd989]:hover{background-color:var(--ace-c-primary-white)}.auto-complete-atom__error[data-v-5b6dd989]{border:1px solid var(--ace-c-primary-white);border-radius:24px;color:var(--ace-c-status-red);font-size:var(--ace-distance-md);text-align:left;min-height:20px;padding-left:var(--ace-distance-xs);box-shadow:0 3px 6px #00000029;z-index:1}.auto-complete-atom__row__input--error[data-v-5b6dd989],.auto-complete-atom__row__prefix-dropdown--error[data-v-5b6dd989]{background:var(--ace-c-status-pink);border-color:var(--ace-c-status-pink)}.auto-complete-atom__row__input--error[data-v-5b6dd989]{padding-right:28px}.auto-complete-atom--inline[data-v-5b6dd989]{width:-moz-fit-content;width:fit-content}.auto-complete-atom--fullwidth[data-v-5b6dd989]{display:block;width:100%;min-width:auto}.auto-complete-atom__options__option--target[data-v-5b6dd989]{background-color:var(--ace-c-primary-blue-light)}.auto-complete-atom--single-row[data-v-5b6dd989]{display:flex;flex-direction:row;align-items:center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-atom[data-v-424b7db8]{border-radius:5px 5px 0 0;border:1px solid var(--ace-c-section-table-highlight)}.box-atom__header[data-v-424b7db8]{display:flex;align-items:center;background:var(--ace-c-section-table-highlight);font-family:BrixSansBlack;font-size:18px;padding:0 16px;line-height:46px;min-height:46px;flex-grow:1}.box-atom__header__label[data-v-424b7db8]{flex:1}.box-atom__header__icon-container[data-v-424b7db8]{margin-left:var(--ace-gutter)}.box-atom__content[data-v-424b7db8]{padding:12px 16px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-atom[data-v-4011c801]{display:flex;align-items:center;outline:none;border:3px solid var(--ace-c-primary-white);padding:3px 24px;cursor:pointer;border-radius:21px;box-shadow:0 3px 6px #00000029;transition:all .1s ease;color:var(--ace-c-text-black);margin:2px;font-size:16px;line-height:24px}.button-atom--truncated[data-v-4011c801]{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-clamp:1;-webkit-line-clamp:1}.button-atom--primary[data-v-4011c801]{background-color:var(--ace-c-primary-blue);font-family:var(--ace-font-bold)}.button-atom--secondary[data-v-4011c801]{background:var(--ace-c-primary-blue-light)}.button-atom[data-v-4011c801]:not(:active):not(:focus):hover{background:var(--ace-c-primary-blue-light);box-shadow:inset 0 0 0 1px var(--ace-c-text-black),0 3px 6px #00000029}.button-atom[data-v-4011c801]:not(:active):focus{background:var(--ace-c-primary-blue-light);box-shadow:0 0 0 2px var(--ace-c-text-black),0 3px 6px #00000029}.button-atom--secondary[data-v-4011c801]:active,.button-atom[data-v-4011c801]:not(.button-atom--secondary):active{background-color:var(--ace-c-text-black);box-shadow:inset 0 0 0 1px var(--ace-c-text-black),0 3px 6px #00000029;color:var(--ace-c-primary-white)}.button-atom--disabled[data-v-4011c801]{cursor:auto;background:var(--ace-c-status-gray);color:var(--ace-c-text-gray);border:3px solid #d6d6d6;pointer-events:none}.button-atom.button-atom--action[data-v-4011c801]{box-shadow:none;background-color:var(--ace-c-primary-white);border:1px solid var(--ace-c-text-black);padding:1px 15px 3px 15px;line-height:20px}.button-atom.button-atom--action[data-v-4011c801]:focus{box-shadow:0 0 0 3px var(--ace-c-primary-white),0 0 0 5px var(--ace-c-text-black)}.button-atom.button-atom--action[data-v-4011c801]:active{font-family:BrixSansBold;background-color:transparent;color:var(--ace-c-text-black);box-shadow:inset 0 0 0 1px var(--ace-c-text-black)}.button-atom--disabled.button-atom--action[data-v-4011c801]{background:var(--ace-c-status-gray);color:var(--ace-c-text-gray);border:1px solid var(--ace-c-text-gray)}.button-atom.button-atom--action[data-v-4011c801] svg{transform:translateY(1px)}.button-atom--action.button-atom--has-svg-first[data-v-4011c801]{padding-left:7px}.button-atom--action.button-atom--has-svg-last[data-v-4011c801]{padding-right:7px}.button-atom--invalid[data-v-4011c801],.button-atom--invalid[data-v-4011c801]:not(:active):focus,.button-atom--invalid[data-v-4011c801]:not(:active):not(:focus):hover{background:var(--ace-c-status-pink)}.button-atom[data-v-4011c801]:not(.button-atom--icon) svg{width:16px;height:16px}.button-atom--has-svg-first[data-v-4011c801] svg{padding-right:8px}.button-atom--has-svg-last[data-v-4011c801] svg{padding-left:8px}.button-atom--icon[data-v-4011c801]{padding:8px;background-color:var(--ace-c-primary-blue)}.button-atom--icon[data-v-4011c801] svg,.button-atom--icon-action[data-v-4011c801] svg,.button-atom--link[data-v-4011c801] svg{width:16px;height:16px}.button-atom--icon-action[data-v-4011c801]{padding:8px;background-color:var(--ace-c-primary-white);border:1px solid var(--ace-c-text-black)}.button-atom.button-atom--icon-action[data-v-4011c801]:focus{box-shadow:0 0 0 3px var(--ace-c-primary-white),0 0 0 5px var(--ace-c-text-black)}.button-atom.button-atom--icon-action[data-v-4011c801]:active{background-color:transparent;color:var(--ace-c-text-black);box-shadow:inset 0 0 0 1px var(--ace-c-text-black)}.button-atom--disabled.button-atom--icon-action[data-v-4011c801]{background:var(--ace-c-status-gray);color:var(--ace-c-text-gray);border:1px solid var(--ace-c-text-gray)}.button-atom--link[data-v-4011c801]{padding:4px;background-color:transparent;border:none;box-shadow:none;color:var(--ace-c-text-blue);border-radius:0}.button-atom.button-atom--link[data-v-4011c801]:active{color:var(--ace-c-text-black);border:none;background:transparent;box-shadow:none}.button-atom.button-atom--link[data-v-4011c801]:not(:active):focus{background-color:transparent;box-shadow:none}.button-atom.button-atom--link[data-v-4011c801]:hover,.button-atom.button-atom--link[data-v-4011c801]:not(:active):not(:focus):hover{background:transparent;border:none;box-shadow:none;text-decoration:underline}.button-atom--disabled.button-atom--link[data-v-4011c801]{background:transparent;color:var(--ace-c-text-gray);border:none}.button-atom[data-v-4011c801]:not(.button-atom--icon-secondary) svg{width:16px;height:16px}.button-atom--icon-secondary[data-v-4011c801]{padding:8px;background-color:var(--ace-c-primary-blue-light)}.button-atom--icon-secondary[data-v-4011c801] svg{width:16px;height:16px}.button-atom--disabled.button-atom--icon-secondary[data-v-4011c801]{cursor:auto;background:var(--ace-c-status-gray);color:var(--ace-c-text-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".check-atom--disabled[data-v-bd366528]{cursor:none;pointer-events:none}.check-atom__wrapper[data-v-bd366528]{display:flex;flex-direction:row;padding:4px 0;cursor:pointer}.check-atom__label[data-v-bd366528]{font-family:BrixSansBlack;font-size:14px;font-weight:bolder;margin-bottom:8px;margin-top:8px;line-height:14px;display:block;flex-direction:column}.check-atom__label--disabled[data-v-bd366528]{color:var(--ace-c-text-gray)}.check-atom__wrapper__button[data-v-bd366528]{width:16px;height:16px;cursor:pointer;background:var(--ace-c-primary-white);border-radius:3px;border:1px solid var(--ace-c-text-black);flex-shrink:0;background:#fff}.check-atom__wrapper__button__icon[data-v-bd366528]{display:block;padding:1px;height:12px;width:12px}.check-atom__wrapper__option[data-v-bd366528]{font-size:16px;margin-left:6px;line-height:16px;flex:1}.check-atom__wrapper__option--disabled[data-v-bd366528]{color:var(--ace-c-text-gray)}.check-atom__wrapper__button[data-v-bd366528]:hover{background-color:var(--ace-c-primary-blue-light)}.check-atom__wrapper__button--checked[data-v-bd366528]:focus,.check-atom__wrapper__button[data-v-bd366528]:focus:hover{box-shadow:0 0 0 2px var(--ace-c-primary-white),0 0 0 4px var(--ace-c-text-black)}.check-atom__wrapper__button--checked[data-v-bd366528]:hover{background-color:var(--ace-c-text-black)}.check-atom__wrapper__button--disabled[data-v-bd366528]{cursor:none;pointer-events:none;background-color:var(--ace-c-status-gray);border:1px solid var(--ace-c-text-gray);border-radius:4px}.check-atom__wrapper__button--checked.check-atom__wrapper__button--disabled[data-v-bd366528]{border-color:var(--ace-c-text-gray)}.check-atom__wrapper__button--checked[data-v-bd366528]{background-color:var(--ace-c-text-black);border-color:var(--ace-c-text-black)}.check-atom__wrapper__button__icon--checked[data-v-bd366528]{background-color:var(--ace-c-text-black);color:var(--ace-c-primary-white)}.check-atom__wrapper__button__icon--disabled[data-v-bd366528]{background-color:var(--ace-c-status-gray);border-radius:3px;color:var(--ace-c-text-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-atom[data-v-1971a400]{display:flex;flex-direction:column}.container-atom__box[data-v-1971a400]{position:relative;border-top:4px solid var(--ace-c-primary-blue);border-radius:5px;background:var(--ace-c-primary-white);flex:1}.container-atom__box--headless[data-v-1971a400]{box-shadow:0 3px 6px 0 rgba(0,0,0,.16);border-left:1px solid var(--ace-c-primary-gray);border-right:1px solid var(--ace-c-primary-gray);border-bottom:1px solid var(--ace-c-primary-gray)}.container-atom__box__step[data-v-1971a400]{display:flex;justify-content:center;align-items:center;border-radius:0 0 4px 4px;position:absolute;top:-3px;width:20px;height:22px;line-height:16px;background-color:var(--ace-c-primary-blue);color:var(--ace-c-primary-white);font-family:BrixSansBold}.container-atom__action-panel[data-v-1971a400]{background:var(--ace-c-primary-blue-light);padding-top:20px;padding-bottom:20px;padding-left:16px;padding-right:16px;display:grid;grid-template-columns:minmax(0,max-content) minmax(0,1fr);align-items:center}.container-atom__action-panel__header[data-v-1971a400]{border-left:4px solid var(--ace-c-primary-blue);padding-left:16px}.container-atom__action-panel__buttons[data-v-1971a400]{display:flex;gap:var(--ace-gutter)}.container-atom__action-panel__buttons--flexer[data-v-1971a400]{flex:1}.container-atom__label[data-v-1971a400]{display:flex;align-items:center;padding-top:20px;padding-bottom:24px;padding-left:16px;padding-right:16px;position:relative}.container-atom__label__header__icon[data-v-1971a400]{color:var(--ace-c-section-primary);fill:var(--ace-c-section-primary)}.container-atom__label__header[data-v-1971a400]{display:flex;flex:1;align-items:center;position:relative}.container-atom__label--has-no-label[data-v-1971a400]{padding:20px 0 0 0}.container-atom__content[data-v-1971a400]{padding:0 16px 12px 16px}.container-atom__label[data-v-1971a400] svg{padding-right:16px;width:24px;height:24px}.container-atom--grid[data-v-1971a400]:last-child{display:flex;flex:1}.container-atom--grid:last-child .container-atom__box[data-v-1971a400]{flex:1}@media (max-width:576px){.container-atom__action-panel[data-v-1971a400]{grid-template-columns:minmax(0,1fr);gap:var(--ace-gutter)}.container-atom__action-panel__buttons[data-v-1971a400]{flex-direction:row-reverse;align-items:center}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-input-atom__today[data-v-3d0dc3c3]{cursor:pointer;padding-left:var(--ace-gutter);color:var(--ace-c-text-blue);padding-bottom:5px}.date-input-atom__today[data-v-3d0dc3c3]:hover{text-decoration:underline}.date-input-atom__wrapper[data-v-3d0dc3c3]{position:relative;display:grid;grid-template-columns:minmax(0,max-content);width:-moz-max-content;width:max-content}.ace-input[data-v-3d0dc3c3]{padding-left:4px;padding-right:4px}.date-input-atom__wrapper__input[data-v-3d0dc3c3]{display:flex;flex-direction:row}.date-input-atom__wrapper__day-label[data-v-3d0dc3c3]{font-size:18px;font-family:BrixSansLight;line-height:34px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.date-input-atom__wrapper__inner-input[data-v-3d0dc3c3]{font-size:18px;font-family:BrixSansLight;box-sizing:border-box;background:transparent;width:98px;text-align:center;border:0}:not(.date-input-atom__wrapper__inner-input,.date-input-atom__wrapper__day-label,.date-input-atom__wrapper__input__button).ace-input--disabled[data-v-3d0dc3c3]{color:var(--ace-c-text-black)}.date-input-atom__wrapper__input__button[data-v-3d0dc3c3]{display:flex;justify-content:center;align-items:center;padding-left:4px;padding-right:4px;cursor:pointer;background:transparent}.date-input-atom__wrapper__inner-input[data-v-3d0dc3c3]:focus-visible{border:0;outline:none}.date-input-atom__wrapper__input__button__icon[data-v-3d0dc3c3]{width:16px;height:16px}.date-input-atom__wrapper__input__button:first-child .date-input-atom__wrapper__input__button__icon[data-v-3d0dc3c3]{transform:rotate(90deg)}.date-input-atom__wrapper__input__button:last-child .date-input-atom__wrapper__input__button__icon[data-v-3d0dc3c3]{transform:rotate(270deg)}input[type=date][data-v-3d0dc3c3]::-webkit-calendar-picker-indicator,input[type=date][data-v-3d0dc3c3]::-webkit-inner-spin-button{display:none;-webkit-appearance:none}.ace-input.ace-input--error[data-v-3d0dc3c3]{max-width:158px}.ace-input.ace-input--error.ace-input--has-navigation[data-v-3d0dc3c3]{max-width:174px}.ace-input.ace-input--error .date-input-atom__wrapper__inner-input[data-v-3d0dc3c3]{padding-right:28px;width:126px}.ace-input-icon--error[data-v-3d0dc3c3]{left:111px}.ace-input-icon--error.ace-input-icon--has-navigation[data-v-3d0dc3c3]{left:133px}.date-input-atom__container--single-row[data-v-3d0dc3c3]{align-items:center;display:grid;grid-template-columns:minmax(0,max-content) minmax(0,max-content)}@media (max-width:1350px){.date-input-atom--active[data-v-3d0dc3c3]:before{content:\"\";background-color:rgba(0,0,0,.3);width:100vw;height:100vh;top:0;left:0;position:fixed;z-index:9999}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-particle[data-v-4da1b9c0]{display:flex;width:100%}.label-particle__label--disabled[data-v-4da1b9c0]{color:var(--ace-c-text-gray);border-left:2px solid var(--ace-c-text-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".matrix-particle__layout[data-v-10669f22]{margin-top:22px;display:grid;grid-template-columns:max-content 7fr;padding-right:8px}.matrix-particle__layout--year[data-v-10669f22]{margin-top:0;grid-template-columns:7fr;padding-right:0}.matrix-particle__container[data-v-10669f22]{display:grid;grid-template-columns:repeat(7,1fr);text-align:center}.matrix-particle__weeks[data-v-10669f22]{display:grid;grid-template-columns:1fr;text-align:center}.matrix-particle__weeks__header[data-v-10669f22]{height:27px}.matrix-particle__weeks__value[data-v-10669f22]{font-size:14px;color:var(--ace-c-text-gray);height:30px;line-height:22px;justify-content:center;align-items:center;display:flex;border-right:1px solid var(--ace-c-primary-gray);padding:0 8px}.matrix-particle__container--year[data-v-10669f22]{margin-top:0}.matrix-particle__header-year[data-v-10669f22]{font-size:14px;margin-top:22px;text-transform:capitalize}.matrix-particle__matrix__header[data-v-10669f22]{font-family:BrixSansLight;font-size:14px;text-align:center;border-bottom:1px solid var(--ace-c-primary-gray)}.matrix-particle__matrix__cell[data-v-10669f22]{height:30px;line-height:22px;justify-content:center;align-items:center;display:flex}.matrix-particle__matrix__cell--year[data-v-10669f22]{height:24px}.matrix-particle__matrix__cell--disabled[data-v-10669f22]{color:var(--ace-c-text-gray)}.matrix-particle__matrix__cell--disabled-date[data-v-10669f22]{color:var(--ace-c-text-gray);background-color:var(--ace-c-status-gray);pointer-events:none}.matrix-particle__matrix__cell--holiday[data-v-10669f22]{color:var(--ace-c-status-red);font-family:BrixSansBold}.matrix-particle__matrix__cell__inner[data-v-10669f22]{border-radius:22px;width:22px;height:22px;text-align:center;font-size:14px;cursor:pointer}.matrix-particle__matrix__cell__inner[data-v-10669f22]:hover{background-color:var(--ace-c-primary-blue-light)}.matrix-particle__matrix__cell__inner[data-v-10669f22]:focus{box-shadow:inset 0 0 0 1px var(--ace-c-primary-blue),inset 0 0 0 2px var(--ace-c-text-black)}.matrix-particle__matrix__cell__inner--selected[data-v-10669f22]{background-color:var(--ace-c-text-black);color:var(--ace-c-primary-white)}.matrix-particle__matrix__cell__inner--selected[data-v-10669f22]:hover{color:var(--ace-c-text-black)}.matrix-particle__matrix__cell__inner--today[data-v-10669f22]{background-color:var(--ace-c-primary-blue);color:var(--ace-c-text-black)}.matrix-particle__matrix__cell__inner--year[data-v-10669f22]{font-size:12px}.matrix-particle__matrix__cell--year-mode[data-v-10669f22]{background:pink}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shell-particle[data-v-75b4afe4]{position:absolute;top:100%;left:0;z-index:9999;border-top:3px solid var(--ace-c-primary-blue);border-radius:5px;background:var(--ace-c-primary-white);width:324px;box-shadow:0 3px 6px #00000029;border-radius:6px;opacity:1}.shell-particle--flip-vertically[data-v-75b4afe4]{top:unset;bottom:100%}.shell-particle--flip-horizontally[data-v-75b4afe4]{left:unset;right:0}.shell-particle--year[data-v-75b4afe4]{border-top:3px solid var(--ace-c-primary-blue);border-radius:5px;background:var(--ace-c-primary-white);width:auto;height:auto;box-shadow:0 3px 6px #00000029;border-radius:6px;opacity:1}.shell-particle__header[data-v-75b4afe4]{height:23px;margin-top:0;margin-bottom:15px;position:relative;justify-content:center;align-items:center;display:flex}.shell-particle__icon-cross[data-v-75b4afe4]{height:8px;width:8px;border-radius:50%;position:absolute;top:8px;right:18px;cursor:pointer}.shell-particle__icon-cross[data-v-75b4afe4]:hover{background:var(--ace-c-primary-blue-light);border-radius:50%;box-shadow:0 0 0 6px var(--ace-c-primary-blue-light)}.shell-particle__header__button[data-v-75b4afe4]{font-size:14px;height:23px;margin:0;padding:4px 16px 4px 16px;background-color:var(--ace-c-primary-white);border-bottom-left-radius:3px;justify-content:center;align-items:center;display:flex;opacity:1;box-shadow:0 3px 5px #64646429;cursor:pointer}.shell-particle__header__button--selected[data-v-75b4afe4]{background-color:var(--ace-c-primary-blue);font-family:var(--ace-font-bold);box-shadow:none}.shell-particle__calendar-date[data-v-75b4afe4]{flex:1;text-align:center;text-transform:capitalize}.shell-particle__wrapper[data-v-75b4afe4]{font-size:14px;font-family:BrixSansBold;line-height:20px;width:150px;display:flex;margin:0 auto;align-items:center}.shell-particle__wrapper-matrix--selected[data-v-75b4afe4]{display:grid;grid-template-columns:200px 200px 200px 200px;grid-column-gap:40px;padding:0 40px 40px 40px}.shell-particle__button-next[data-v-75b4afe4],.shell-particle__button-prev[data-v-75b4afe4]{background:transparent;height:16px;width:16px;border-radius:14px;cursor:pointer;position:relative}.shell-particle__button-next[data-v-75b4afe4]:hover,.shell-particle__button-prev[data-v-75b4afe4]:hover{background:var(--ace-c-primary-blue-light)}.shell-particle__button-next[data-v-75b4afe4]:focus,.shell-particle__button-prev[data-v-75b4afe4]:focus{box-shadow:inset 0 0 0 1px var(--ace-c-primary-blue),inset 0 0 0 2px var(--ace-c-text-black)}.shell-particle__icon-prev[data-v-75b4afe4]{height:16px;width:16px;transform:rotate(90deg);position:absolute;top:0;right:0}.shell-particle__icon-next[data-v-75b4afe4]{height:16px;width:16px;transform:rotate(270deg);position:absolute;top:0;left:0}@media (max-width:1285px){.shell-particle__wrapper-matrix--selected[data-v-75b4afe4]{grid-template-columns:200px 200px 200px}}@media (max-width:1350px){.shell-particle[data-v-75b4afe4]{position:fixed!important;top:50%;left:50%;transform:translate3d(-50%,-50%,0)}.shell-particle__header[data-v-75b4afe4]{margin-bottom:0}.shell-particle__header__button[data-v-75b4afe4]{display:none}}@media (max-width:576px){.shell-particle[data-v-75b4afe4]{width:100%}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-atom--fullscreen[data-v-19cab3a4]{position:fixed;display:flex;justify-content:center;align-items:center;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.3);z-index:999999}.dialog-atom__shell[data-v-19cab3a4]{position:relative;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;padding:25px;padding-left:50px;background-color:#fff;filter:drop-shadow(0 2px 2px lightgray);border-radius:10px;font-size:14px;line-height:18px;max-width:70%;z-index:999999}.dialog-atom--red[data-v-19cab3a4]{color:var(--ace-c-status-red);--ace-c-fill:var(--ace-c-status-pink)}.dialog-atom--brown[data-v-19cab3a4]{color:var(--ace-c-status-brown);--ace-c-fill:var(--ace-c-status-yellow)}.dialog-atom--green[data-v-19cab3a4]{color:var(--ace-c-status-green);--ace-c-fill:var(--ace-c-status-mint)}.dialog-atom--black[data-v-19cab3a4]{color:var(--ace-c-text-black);--ace-c-fill:var(--ace-c-primary-blue)}.dialog-atom__shell__icon[data-v-19cab3a4]{position:absolute;top:27px;left:15px;width:25px;height:25px}.dialog-atom__shell__x[data-v-19cab3a4]{cursor:pointer;position:absolute;top:10px;right:10px;width:12px;aspect-ratio:1}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-atom[data-v-71b958c4]{position:relative}.dropdown-atom--inline[data-v-71b958c4]{width:-moz-fit-content;width:fit-content}.dropdown-atom__wrapper[data-v-71b958c4]{display:inline-block;position:relative;margin:0}.dropdown-atom__option[data-v-71b958c4]{font-family:BrixSansLight;font-size:16px;padding:16px;font:-moz-pull-down-menu}.dropdown-atom__select[data-v-71b958c4]{border:1px solid var(--ace-c-primary-gray);background:var(--ace-c-primary-gray);color:var(--ace-c-text-black);border-radius:2px;padding-left:16px;min-width:148px;height:24px;line-height:24px;font-size:18px;cursor:pointer;font-family:BrixSansLight}.ace-input[data-v-71b958c4],.dropdown-atom__select[data-v-71b958c4]{padding-right:23px;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;outline:none}.dropdown-atom__select[data-v-71b958c4]:active:focus{box-shadow:0 0 0 1px #9dd3ef;border-color:#000}.dropdown-atom__label.dropdown-atom__label--inactive[data-v-71b958c4]{margin:0}.dropdown-atom__wrapper--inactive[data-v-71b958c4]{margin:0;border-left:2px solid var(--ace-c-section-primary)}.dropdown-atom__select--inactive[data-v-71b958c4]{border:none;color:var(--ace-c-text-black);margin:0;border-radius:0;pointer-events:none;font-size:18px;line-height:24px;padding-left:16px;padding-top:6px;opacity:1;background:transparent}.dropdown-atom__select--inactive[data-v-71b958c4]:focus{background:none;border:1px solid #000;border-radius:3px}.dropdown-atom__select--disabled[data-v-71b958c4]{color:var(--ace-c-text-gray);cursor:auto;pointer-events:none;background-color:var(--ace-c-status-gray)}.dropdown-atom__label--disabled[data-v-71b958c4]{color:var(--ace-c-text-gray);border-left:2px solid var(--ace-c-text-gray)}.dropdown-atom__wrapper__arrow[data-v-71b958c4]{top:12px}.dropdown-atom__wrapper__arrow[data-v-71b958c4],.dropdown-atom__wrapper__arrow--active[data-v-71b958c4]{height:15px;width:15px;position:absolute;right:4px;pointer-events:none}.dropdown-atom__wrapper__arrow--active[data-v-71b958c4]{top:11px;transform:rotate(180deg)}.dropdown-atom__select--error[data-v-71b958c4]{background:var(--ace-c-status-pink);border-color:var(--ace-c-status-pink)}.dropdown-atom__error[data-v-71b958c4]{display:block;border:1px solid var(--ace-c-primary-white);border-radius:24px;color:var(--ace-c-status-red);font-size:var(--ace-distance-md);text-align:left;min-height:20px;padding:0 var(--ace-distance-xs);box-shadow:0 3px 6px #00000029;z-index:1;margin:0;width:-moz-fit-content;width:fit-content}.dropdown-atom--loader[data-v-71b958c4]{height:30px;margin:0;width:200px}.dropdown-atom__error--fullwidth[data-v-71b958c4]{width:auto}.dropdown-atom__wrapper--fullwidth[data-v-71b958c4]{display:block}.dropdown-atom__select--fullwidth[data-v-71b958c4]{display:block;width:100%;min-width:auto}.dropdown-atom--single-row[data-v-71b958c4]{display:flex;flex-direction:row;align-items:center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-atom__label[data-v-e07e445c]{display:flex;align-items:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;width:-moz-max-content;width:max-content}.expand-atom__label[data-v-e07e445c]:hover{cursor:pointer}.expand-atom__label__icon--active[data-v-e07e445c]{transform:rotate(180deg)}.expand-atom__label:hover span[data-v-e07e445c]{color:var(--ace-c-text-gray);font-family:BrixSansBold}.expand-atom__label--active[data-v-e07e445c]{color:var(--ace-c-text-black);font-family:BrixSansBold}.expand-atom__label__icon[data-v-e07e445c]{margin-left:8px;width:14px;height:14px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hcp-input-atom[data-v-51995346]{position:relative;display:flex;flex-direction:column}.hcp-input-atom--single-row[data-v-51995346]{flex-direction:row;align-items:center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-atom__main-row[data-v-700ba7ce]{display:grid;grid-template-columns:minmax(0,max-content) minmax(0,1fr) minmax(0,max-content);grid-template-rows:minmax(80px,max-content);gap:var(--ace-gutter);background:var(--ace-c-section-secondary);border-radius:4px 0 0 4px}.header-atom__main-row--expanded[data-v-700ba7ce]{background:var(--ace-c-section-table-highlight)}.header-atom__main-row__title[data-v-700ba7ce]{display:flex;align-items:center;background:var(--ace-c-section-primary);font-family:var(--ace-font-bold);font-size:20px;line-height:24px;padding:0 32px;border-radius:4px 0 0 4px}.header-atom__main-row__fields[data-v-700ba7ce]{display:flex;align-items:center;gap:var(--ace-gutter);overflow:hidden}.header-atom__field[data-v-700ba7ce]{border-left:4px solid var(--ace-c-section-primary);padding-left:16px}.header-atom__field__label[data-v-700ba7ce]{font-family:var(--ace-font-bold);font-size:14px;line-height:1;padding-bottom:8px}.header-atom__field__label__counter[data-v-700ba7ce]{display:inline-block;background:var(--ace-c-section-primary);margin-left:4px;border-radius:16px;padding:0 4px;font-family:BrixSansBlack}.header-atom__field__value[data-v-700ba7ce]{font-size:18px;line-height:1}.header-atom__field__anchor[data-v-700ba7ce]{text-decoration:none;color:var(--ace-c-text-black)}.header-atom__main-row__fields .header-atom__field:first-child .header-atom__field__value[data-v-700ba7ce]{font-family:var(--ace-font-bold)}.header-atom__main-row__buttons[data-v-700ba7ce]{display:flex;align-items:center;padding-right:16px;gap:16px;flex-wrap:wrap}.header-atom__values[data-v-700ba7ce]{background:var(--ace-c-section-secondary);padding:16px;display:grid;gap:32px 16px}@media (max-width:992px){.header-atom__main-row[data-v-700ba7ce]{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(0,min-content);gap:8px;padding-bottom:8px;border-radius:4px 4px 0 0}.header-atom__main-row__title[data-v-700ba7ce]{padding:8px 16px;border-radius:4px 4px 0 0}.header-atom__main-row__buttons[data-v-700ba7ce],.header-atom__main-row__fields[data-v-700ba7ce]{padding:0 16px}.header-atom__main-row__fields--no-fields[data-v-700ba7ce]{display:none}.header-atom__main-row--no-fields[data-v-700ba7ce]{padding-bottom:0}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes rotating-b6c448e2{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.loader-atom[data-v-b6c448e2]{display:flex;align-items:center;justify-content:center}.loader-atom--action[data-v-b6c448e2]{width:16px;height:16px}.loader-atom--inline[data-v-b6c448e2]{width:40px;height:40px}.loader-atom--block[data-v-b6c448e2]{box-shadow:none}.loader-atom--fullheight[data-v-b6c448e2],.loader-atom--fullscreen[data-v-b6c448e2]{top:0;left:0;height:100%;width:100%;background-color:rgba(0,0,0,.3)}.loader-atom--nested[data-v-b6c448e2]{background:none}.loader-atom--fullheight[data-v-b6c448e2]{position:absolute;z-index:999999999999}.loader-atom--fullscreen[data-v-b6c448e2]{position:fixed;z-index:999999999999}.loader-atom__shell[data-v-b6c448e2]{height:inherit;width:inherit;display:flex;flex-direction:column;align-items:center;justify-content:center}.loader-atom__shell--fullheight[data-v-b6c448e2],.loader-atom__shell--fullscreen[data-v-b6c448e2]{background-color:var(--ace-c-primary-white);padding:50px 100px;border-radius:5px;height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content}.loader-atom__shell__icon[data-v-b6c448e2]{height:auto;width:auto;animation:rotating-b6c448e2 2s linear infinite}.loader-atom__shell__icon--block[data-v-b6c448e2],.loader-atom__shell__icon--fullheight[data-v-b6c448e2],.loader-atom__shell__icon--fullscreen[data-v-b6c448e2]{width:70px;aspect-ratio:1}.loader-atom__shell__bold-text[data-v-b6c448e2]{font-family:BrixSansBold;margin-top:35px}.loader-atom__shell__bold-text--block[data-v-b6c448e2]{margin-top:16px}.loader-atom__shell__light-text[data-v-b6c448e2]{font-family:BrixSansLight}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-atom[data-v-f52365b4]{cursor:pointer;width:20px;--menu-atom-width:20px;--menu-atom-height:2px;--menu-atom-margin:4px;--menu-atom-animation-speed:0.3s;--menu-atom-left-rotation-angle:45deg;--menu-atom-left-rotation-y:6px;--menu-atom-right-rotation-angle:-45deg;--menu-atom-right-rotation-y:-6px}.menu-atom__bar[data-v-f52365b4]{background:var(--ace-c-text-blue);width:var(--menu-atom-width);height:var(--menu-atom-height);transition:transform var(--menu-atom-animation-speed) ease-in-out}.menu-atom__bar--second[data-v-f52365b4]{margin:var(--menu-atom-margin) 0}.menu-atom__bar--active.menu-atom__bar--first[data-v-f52365b4]{transform:translateY(var(--menu-atom-left-rotation-y)) rotate(var(--menu-atom-left-rotation-angle))}.menu-atom__bar--active.menu-atom__bar--second[data-v-f52365b4]{transform:scale(0)}.menu-atom__bar--active.menu-atom__bar--third[data-v-f52365b4]{transform:translateY(var(--menu-atom-right-rotation-y)) rotate(var(--menu-atom-right-rotation-angle))}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-atom[data-v-077de218]{display:flex;justify-content:center;align-items:center;height:100%;width:100%;background-color:rgba(0,0,0,.3);left:0;top:0;z-index:99999}.modal-atom--headless[data-v-077de218]{background-color:hsla(0,0%,100%,.9)}.modal-atom__content[data-v-077de218]{display:flex;flex-direction:column;border-top:4px solid var(--ace-c-primary-blue);padding:40px;padding-right:48px;background-color:var(--ace-c-primary-white);border-radius:5px;max-height:75%;position:relative}.modal-atom__content--sm[data-v-077de218]{width:25%}.modal-atom__content--md[data-v-077de218]{width:50%}.modal-atom__content--lg[data-v-077de218]{width:75%}.modal-atom__content--xl[data-v-077de218]{width:calc(100% - 200px)}@media (max-width:991.98px){.modal-atom__content--sm[data-v-077de218]{width:60%}.modal-atom__content--md[data-v-077de218]{width:70%}.modal-atom__content--lg[data-v-077de218]{width:80%}}@media (max-width:767.98px){.modal-atom__content--lg[data-v-077de218],.modal-atom__content--md[data-v-077de218],.modal-atom__content--sm[data-v-077de218],.modal-atom__content--xl[data-v-077de218]{width:calc(100% - 120px)}}@media (max-width:575.98px){.modal-atom__content--lg[data-v-077de218],.modal-atom__content--md[data-v-077de218],.modal-atom__content--sm[data-v-077de218],.modal-atom__content--xl[data-v-077de218]{width:calc(100% - 120px)}}.modal-atom__content--headless[data-v-077de218]{box-shadow:0 3px 6px 0 rgba(0,0,0,.16);border-left:1px solid var(--ace-c-primary-gray);border-right:1px solid var(--ace-c-primary-gray);border-bottom:1px solid var(--ace-c-primary-gray)}.modal-atom__content--is-overlay[data-v-077de218]{max-height:none;max-width:none;width:calc(100% - 100px);height:calc(100% - 100px);padding:0}.modal-atom__content__title[data-v-077de218]{margin-top:8px;margin-bottom:8px}.modal-atom__content__title--is-overlay[data-v-077de218]{margin:0;padding:8px 16px}.modal-atom__content__x[data-v-077de218]{cursor:pointer;width:15px;height:15px;position:absolute;right:22px;top:15px}.modal-atom__content__warning[data-v-077de218]{display:flex;flex-direction:row;justify-content:center;align-items:center;position:absolute;right:40px;top:9px;border-radius:15px;line-height:24px;padding-left:8px;padding-right:8px;box-shadow:0 2px 2px gray;background-color:var(--ace-c-status-yellow);transition:transform .1s ease}.modal-atom__content__warning__icon[data-v-077de218]{width:16px;height:16px;margin-right:4px}.modal-atom__content__ingress-container[data-v-077de218]{width:100%;border-bottom:1px solid var(--ace-c-primary-gray);padding-bottom:10px;margin-bottom:10px}.modal-atom__content__footer[data-v-077de218]{display:flex;flex-direction:row}.modal-atom__content__footer__buttons[data-v-077de218]{display:flex;flex-direction:row-reverse;flex-grow:1}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-atom[data-v-643a801c]{display:inline-block}.notification-atom--has-slot[data-v-643a801c]{position:relative}.notification-atom__notification[data-v-643a801c]{position:relative;display:flex;width:14px;height:14px;padding:4px;border-radius:11px;align-items:center;justify-content:center;transition:all .3s ease-in-out;background-color:#fff;filter:drop-shadow(0 2px 2px lightgray)}.notification-atom__notification--readonly[data-v-643a801c]{cursor:default;pointer-events:none}.notification-atom__notification--has-slot[data-v-643a801c]{position:absolute;top:-10px;right:4px;z-index:100}.notification-atom__notification--red[data-v-643a801c]{color:var(--ace-c-status-red);--ace-c-fill:var(--ace-c-status-pink)}.notification-atom__notification--brown[data-v-643a801c]{color:var(--ace-c-status-brown);--ace-c-fill:var(--ace-c-status-yellow)}.notification-atom__notification--green[data-v-643a801c]{color:var(--ace-c-status-green);--ace-c-fill:var(--ace-c-status-mint)}.notification-atom__notification--black[data-v-643a801c]{color:var(--ace-c-text-black);--ace-c-fill:var(--ace-c-primary-blue)}.notification-atom__notification__content[data-v-643a801c]{cursor:default;position:absolute;transition:all .3s ease-in-out;background-color:#fff;padding:8px;padding-right:22px;font-size:14px;line-height:16px;min-width:150px;width:-moz-max-content;width:max-content;max-width:50vh}.notification-atom__notification__content__text[data-v-643a801c]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.notification-atom__notification__content__text--multiline[data-v-643a801c]{white-space:unset;text-overflow:unset;overflow:unset;width:-moz-max-content;width:max-content;max-width:50vh}.notification-atom__notification__content__header[data-v-643a801c]{font-family:BrixSansBlack}.notification-atom svg.notification-atom__notification__content__x[data-v-643a801c]{cursor:pointer;position:absolute;right:6px;top:6px;width:8px;height:8px;color:#000}.notification-atom svg.notification-atom__notification__icon[data-v-643a801c]{cursor:pointer;padding:0;width:16px;height:16px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".number-input-atom[data-v-f7c21738]{position:relative;display:flex;flex-direction:column}.number-input-atom--single-row[data-v-f7c21738]{flex-direction:row;align-items:center}.remove-arrows[data-v-f7c21738]::-webkit-inner-spin-button,.remove-arrows[data-v-f7c21738]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.remove-arrows[type=number][data-v-f7c21738]{-moz-appearance:textfield}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-atom[data-v-4853b3f6]{display:flex;flex-direction:row;align-items:center;padding:10px}.pagination-atom__previous[data-v-4853b3f6]{width:24px;height:24px;transform:rotate(90deg)}.pagination-atom__end-point[data-v-4853b3f6]{display:flex;flex-direction:row}.pagination-atom__button-box[data-v-4853b3f6]{display:flex;justify-content:center;align-items:center;margin-left:8px;margin-right:8px;width:20px;height:20px}.pagination-atom__index--active[data-v-4853b3f6]{cursor:default;font-weight:900;color:var(--ace-c-status-gray)}.pagination-atom__index--inactive[data-v-4853b3f6]{cursor:pointer}.pagination-atom__next[data-v-4853b3f6]{width:24px;height:24px;transform:rotate(-90deg)}.pagination-atom__element--disabled[data-v-4853b3f6]{color:var(--ace-c-status-gray)}.pagination-atom__element--active[data-v-4853b3f6]{cursor:pointer}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".phone-input-atom[data-v-2a6ab0a6]{display:flex;flex-direction:column;width:100%;font-size:18px;color:var(--ace-c-text-black)}.phone-input-atom__row[data-v-2a6ab0a6]{position:relative;display:flex;flex-direction:row;border-radius:15px}.phone-input-atom__row__input[data-v-2a6ab0a6]{width:100%;height:36px;padding:0;transition:all .2s ease;background-color:var(--ace-c-primary-gray);outline:none;font-size:18px;box-sizing:border-box;resize:none}.phone-input-atom__row__prefix-dropdown[data-v-2a6ab0a6]{-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;display:flex;flex-direction:row;align-items:center;border-top-left-radius:3px;border-bottom-left-radius:3px;padding-right:7px;border-right:0;background-color:var(--ace-c-primary-gray);border:1px solid var(--ace-c-text-gray);border-right:transparent}.phone-input-atom__row__prefix-dropdown__icon[data-v-2a6ab0a6]{color:inherit;height:16px;width:16px;min-height:16px;min-width:16px;margin:0 7px}.phone-input-atom__row__input[data-v-2a6ab0a6]{display:flex;flex:1;align-items:center;padding-left:5px;border:0;outline:0;border-top-right-radius:3px;border-bottom-right-radius:3px;font-family:BrixSansLight;box-shadow:0 0 2 var(--ace-c-primary-gray);border:1px solid var(--ace-c-text-gray);color:inherit;border-left:0}.phone-input-atom--disabled[data-v-2a6ab0a6]{color:var(--ace-c-text-gray);pointer-events:none}.phone-input-atom__label--disabled[data-v-2a6ab0a6]{border-left:2px solid var(--ace-c-text-gray)}.phone-input-atom__inactive-value[data-v-2a6ab0a6]{border-left:2px solid var(--ace-c-section-primary);padding-left:16px;margin:0 4px;line-height:32px}.phone-input-atom__row[data-v-2a6ab0a6]:focus{border-bottom-right-radius:15px;border-bottom-left-radius:15px}.phone-input-atom__row:focus .phone-input-atom__row__prefix-dropdown[data-v-2a6ab0a6]{border-bottom-left-radius:0;overflow:hidden}.phone-input-atom__row:focus .phone-input-atom__row__input[data-v-2a6ab0a6]{border-bottom-right-radius:0}.phone-input-atom__row:focus .phone-input-atom__row__prefix-dropdown[data-v-2a6ab0a6]:not(:active),.phone-input-atom__row__input[data-v-2a6ab0a6]:focus{background:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-blue);border:1px solid var(--ace-c-text-blue)}.phone-input-atom__row__input[data-v-2a6ab0a6]:active,.phone-input-atom__row__prefix-dropdown[data-v-2a6ab0a6]:active{background:var(--ace-c-primary-blue-light);box-shadow:0 0 0 1px var(--ace-c-text-black);border:1px solid var(--ace-c-text-black)}.phone-input-atom__options[data-v-2a6ab0a6]{position:absolute;width:100%;top:35px;left:0;display:flex;flex-direction:column;transform-origin:50% 0;transition:all .2s ease;height:150px;background-color:var(--ace-c-primary-gray);overflow-y:scroll;overflow-x:auto;transform:scale(.975,0);box-shadow:0 0 2 var(--ace-c-primary-gray);border:1px solid var(--ace-c-text-gray);box-sizing:border-box;resize:none;z-index:9999}.phone-input-atom__row:focus .phone-input-atom__options[data-v-2a6ab0a6]{transform:scale(1);border-bottom-left-radius:3px;border-bottom-right-radius:3px}.phone-input-atom__options__option[data-v-2a6ab0a6]{cursor:pointer;line-height:26px;padding-left:5px;word-wrap:normal}.phone-input-atom__options__option[data-v-2a6ab0a6]:nth-child(4){border-bottom:1px solid var(--ace-c-text-gray)}.phone-input-atom__options__option[data-v-2a6ab0a6]:hover{background-color:var(--ace-c-primary-white)}.phone-input-atom__error[data-v-2a6ab0a6]{border:1px solid var(--ace-c-primary-white);border-radius:24px;color:var(--ace-c-status-red);font-size:var(--ace-distance-md);text-align:left;min-height:20px;padding-left:var(--ace-distance-xs);box-shadow:0 3px 6px #00000029;z-index:1}.phone-input-atom__row__input--error[data-v-2a6ab0a6],.phone-input-atom__row__prefix-dropdown--error[data-v-2a6ab0a6]{background:var(--ace-c-status-pink);border-color:var(--ace-c-status-pink)}.phone-input-atom__row__input--error[data-v-2a6ab0a6]{padding-right:28px}.phone-input-atom--single-row[data-v-2a6ab0a6]{flex-direction:row;align-items:center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-bar-atom[data-v-14f55132]{display:flex;flex-direction:row;width:200px}.progress-bar-atom__wrapper[data-v-14f55132]{display:flex;flex-direction:column;width:100%}.progress-bar-atom__wrapper__label-container[data-v-14f55132]{display:flex;flex-direction:row}.progress-bar-atom__wrapper__label-container__glue[data-v-14f55132]{flex-grow:1}.progress-bar-atom__wrapper__label-container__label[data-v-14f55132]{white-space:nowrap}.progress-bar-atom__wrapper__bar[data-v-14f55132]{display:flex;position:relative;flex-direction:row;width:100%;height:16px;align-items:baseline}.progress-bar-atom__wrapper__bar--default[data-v-14f55132]{border-radius:9px;border:1px solid #000;overflow:hidden}.progress-bar-atom__wrapper__bar__ball-container[data-v-14f55132]{position:absolute;top:6px;display:flex;height:10px;width:16px;border-radius:50%;overflow:hidden;align-items:center}.progress-bar-atom__wrapper__bar__ball-container__ball[data-v-14f55132]{height:6px;width:6px;border:.5px solid #000;background-color:#fff;border-radius:4px}.progress-bar-atom__hole-container[data-v-14f55132]{display:flex;flex-direction:column-reverse}.progress-bar-atom__hole-container__hole[data-v-14f55132]{height:4px;width:16px;border-radius:50%;background-color:#000}.progress-bar-atom__wrapper__bar__progress[data-v-14f55132]{height:100%}.progress-bar-atom__wrapper__bar__progress--default[data-v-14f55132]{border-top-left-radius:8px;border-bottom-left-radius:8px;background-color:var(--ace-c-primary-blue)}.progress-bar-atom__wrapper__bar__progress--golf[data-v-14f55132]{border-bottom:1px solid #000}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-circle-atom[data-v-0ea51692]{display:flex;position:relative;justify-content:center}.progress-circle-atom__circle[data-v-0ea51692]{position:absolute;border-radius:50%;background-color:transparent;color:var(--ace-c-primary-blue)}.progress-circle-atom__append-mask[data-v-0ea51692]{position:absolute;height:100%;width:50%;left:50%}.progress-circle-atom__background[data-v-0ea51692]{border-color:var(--ace-c-primary-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radio-atom[data-v-7afba67e]{cursor:pointer}.radio-atom--disabled[data-v-7afba67e]{cursor:default}.radio-atom__button[data-v-7afba67e]{display:block;cursor:pointer;width:16px;height:16px;border-radius:50%;padding:0;border:1px solid var(--ace-c-text-black);box-sizing:border-box;background-color:var(--ace-c-primary-white)}.radio-atom__button[data-v-7afba67e]:hover{background-color:var(--ace-c-primary-blue-light)}.radio-atom__button--is-checked[data-v-7afba67e]:focus,.radio-atom__button[data-v-7afba67e]:focus:hover{box-shadow:0 0 0 2px var(--ace-c-primary-white),0 0 0 4px var(--ace-c-text-black)}.radio-atom__button--is-checked[data-v-7afba67e],.radio-atom__button--is-checked[data-v-7afba67e]:hover{background-color:var(--ace-c-text-black)}.radio-atom__wrapper[data-v-7afba67e]{padding:4px 0;display:grid;grid-template-columns:16px minmax(0,max-content)}.radio-atom__wrapper--inactive[data-v-7afba67e]{border-left:2px solid var(--ace-c-section-primary);padding:4px 0 4px 16px;cursor:none;pointer-events:none}.radio-atom__icon[data-v-7afba67e]{width:8px;height:8px;display:block;border-radius:50%;margin:3px;background-color:var(--ace-c-primary-white)}.radio-atom__icon--is-checked[data-v-7afba67e]{background-color:var(--ace-c-text-black)}.radio-atom__button--disabled[data-v-7afba67e]{cursor:none;pointer-events:none;background-color:var(--ace-c-status-gray)}.radio-atom__button--is-checked--disabled[data-v-7afba67e]{border:1px solid var(--ace-c-text-gray)}.radio-atom__button--disabled.radio-atom__button--is-checked[data-v-7afba67e]{border-color:var(--ace-c-text-gray)}.radio-atom__button--disabled .radio-atom__icon[data-v-7afba67e]{background-color:var(--ace-c-text-gray)}.radio-atom__label[data-v-7afba67e]{font-family:var(--ace-font-bold);font-size:14px;margin:4px 0;margin-bottom:8px;line-height:14px;display:block;flex-direction:column;height:14px}.radio-atom__label--disabled[data-v-7afba67e]{color:var(--ace-c-text-gray)}.radio-atom__label--inactive[data-v-7afba67e]{padding-left:16px;border-left:2px solid var(--ace-c-section-primary);font-family:var(--ace-font-bold);font-size:14px;line-height:21px;display:block;padding-bottom:8px;margin:0}.radio-atom__option[data-v-7afba67e]{font-size:16px;margin-left:6px;margin-right:8px;line-height:16px}.radio-atom__option--disabled[data-v-7afba67e]{color:var(--ace-c-text-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-atom[data-v-5455c1ff]{display:flex;position:relative;flex-direction:row;align-items:center;width:-moz-fit-content;width:fit-content;border-radius:18px}.search-atom__input[data-v-5455c1ff]{height:32px;line-height:20px;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;margin:none;padding:none;outline:none;border-radius:18px;border:1px solid var(--ace-c-text-black);padding-left:16px;padding-right:10px;transition:all .3s ease;flex-grow:1;color:var(--ace-c-text-black);font-family:BrixSansLight;font-size:16px}.search-atom__input[data-v-5455c1ff]:focus{border:1px solid var(--ace-c-text-blue);box-shadow:0 0 2px var(--ace-c-primary-blue)}.search-atom__input[data-v-5455c1ff]:active{border:1px solid var(--ace-c-text-black);box-shadow:inset 0 0 0 1px var(--ace-c-text-black)}.search-atom__input--disabled[data-v-5455c1ff]{pointer-events:none;border:1px solid var(--ace-c-text-gray);background-color:var(--ace-c-primary-gray)}.search-atom__icon[data-v-5455c1ff]{position:absolute;background-color:inherit;right:7px;aspect-ratio:1;height:18px;background-color:var(--ace-c-primary-white);padding:3px;cursor:pointer}.search-atom__icon--disabled[data-v-5455c1ff]{background-color:var(--ace-c-primary-gray);color:var(--ace-c-text-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchable-dropdown-atom__options[data-v-6690b1ef]{position:absolute;width:100%;top:36px;left:0;display:flex;flex-direction:column;transform-origin:50% 0;transition:all .2s ease;max-height:150px;background-color:var(--ace-c-primary-white);overflow-y:scroll;overflow-x:auto;transform:scaleY(0);box-sizing:border-box;resize:none;z-index:2;border:none}.searchable-dropdown-atom__options--open[data-v-6690b1ef]{transform:scale(1);border-bottom-left-radius:3px;border-bottom-right-radius:3px}.searchable-dropdown-atom__options--input-focus[data-v-6690b1ef]{border-right:1px solid var(--ace-c-text-blue);border-bottom:1px solid var(--ace-c-text-blue);border-left:1px solid var(--ace-c-text-blue);border-top:none}.searchable-dropdown-atom__options__option[data-v-6690b1ef]{cursor:pointer;line-height:36px;word-wrap:normal;border-bottom:1px solid var(--ace-c-primary-gray);padding-left:6px}.searchable-dropdown-atom__options--input-focus .searchable-dropdown-atom__options__option[data-v-6690b1ef]{padding-left:5px}.searchable-dropdown-atom__options__option[data-v-6690b1ef]:hover{background-color:var(--ace-c-primary-blue-gray)}.searchable-dropdown-atom__options__option--custom-focus[data-v-6690b1ef]{box-shadow:inset 0 0 0 2px var(--ace-c-text-black)}.searchable-dropdown-atom__options__option--none[data-v-6690b1ef]{color:var(--ace-c-text-gray);pointer-events:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchable-dropdown-atom[data-v-76513d4e]{display:flex;flex-direction:column;width:100%;font-size:18px;color:var(--ace-c-text-black)}.searchable-dropdown-atom__label[data-v-76513d4e]{padding-left:16px;border-left:2px solid var(--ace-c-section-primary);font-family:var(--ace-font-bold);display:block;line-height:21px}.searchable-dropdown-atom__row[data-v-76513d4e]{position:relative;display:flex;flex-direction:row;border-radius:15px;margin:4px 0}.searchable-dropdown-atom__row__input[data-v-76513d4e]{height:36px;padding:0 0 0 5px;transition:all .2s ease;background-color:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-gray);border-right:1px solid var(--ace-c-primary-gray);border-top:1px solid var(--ace-c-primary-gray);border-left:1px solid var(--ace-c-primary-gray);border-bottom:none;outline:none;font-size:inherit;box-sizing:border-box;display:flex;flex:1;align-items:center;outline:0;border-radius:3px;font-family:BrixSansLight;color:inherit}.searchable-dropdown-atom--disabled[data-v-76513d4e]{color:var(--ace-c-text-gray);pointer-events:none}.searchable-dropdown-atom__label--disabled[data-v-76513d4e]{border-left:2px solid var(--ace-c-text-gray)}.searchable-dropdown-atom__inactive-value[data-v-76513d4e]{border-left:2px solid var(--ace-c-section-primary);padding-left:16px;margin:0 4px;line-height:32px}.searchable-dropdown-atom__row[data-v-76513d4e]:focus{border-bottom-right-radius:15px;border-bottom-left-radius:15px}.searchable-dropdown-atom__row__input[data-v-76513d4e]:focus{border-bottom-right-radius:0;border-bottom-left-radius:0}.searchable-dropdown-atom__row__input--custom-focus[data-v-76513d4e]{background:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-blue);border-right:1px solid var(--ace-c-text-blue);border-top:1px solid var(--ace-c-text-blue);border-left:1px solid var(--ace-c-text-blue);border-bottom:none}.searchable-dropdown-atom__row__input[data-v-76513d4e]:active{background:var(--ace-c-primary-blue-light)}.searchable-dropdown-atom__error[data-v-76513d4e]{border:1px solid var(--ace-c-primary-white);border-radius:24px;color:var(--ace-c-status-red);font-size:var(--ace-distance-md);text-align:left;min-height:20px;padding-left:var(--ace-distance-xs);box-shadow:0 3px 6px #00000029;z-index:1;margin-top:-4px}.searchable-dropdown-atom__row__input--error[data-v-76513d4e]{background:var(--ace-c-status-pink);border-color:var(--ace-c-status-pink);padding-right:28px}.searchable-dropdown-atom__row__error-icon[data-v-76513d4e]{width:20px;height:20px;color:var(--ace-c-status-red);position:absolute;right:4px;top:5px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-atom[data-v-4351cc70]{margin-top:36px;margin-bottom:16px}.section-atom__wrapper[data-v-4351cc70]{display:inline-block;background:#efefef;padding:0 var(--ace-gutter);border-top-right-radius:36px;border-bottom-right-radius:36px;line-height:36px;margin-left:-16px}.section-atom__wrapper--modal[data-v-4351cc70]{margin-left:-40px}.section-atom--inline[data-v-4351cc70]{margin-top:0;margin-bottom:0;display:inline-block}.section-atom__emphasized[data-v-4351cc70]{font-family:BrixSansBlack}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".step-particle[data-v-1e2841b2]{display:flex;flex:1;flex-direction:row;align-items:center;gap:12px;font-size:14px}.step-particle--last[data-v-1e2841b2]{flex:0;white-space:nowrap}.step-particle--disabled[data-v-1e2841b2]{pointer-events:none}.step-particle__value[data-v-1e2841b2]{cursor:pointer;display:flex;align-items:center;justify-content:center;border:1px solid var(--ace-c-primary-gray);width:22px;min-width:22px;height:22px;border-radius:12px;text-align:center;color:var(--ace-c-text-gray)}.step-particle__value--completed[data-v-1e2841b2]{border-color:var(--ace-c-section-primary)}.step-particle--disabled .step-particle__value[data-v-1e2841b2]{color:var(--ace-c-text-gray);background-color:var(--ace-c-status-gray);border-color:var(--ace-c-status-gray)}.step-particle__value--current[data-v-1e2841b2]{border-color:var(--ace-c-section-primary);background:var(--ace-c-section-primary);color:#fff}.step-particle__value span[data-v-1e2841b2]{display:inline-block;font-size:14px;color:inherit;line-height:22px}.step-particle__value[data-v-1e2841b2] svg{height:14px;color:var(--ace-c-section-primary)}.step-particle__label[data-v-1e2841b2]{cursor:pointer;color:var(--ace-c-text-gray)}.step-particle__label--completed[data-v-1e2841b2],.step-particle__label--current[data-v-1e2841b2]{color:var(--ace-c-text-blue)}.step-particle--disabled .step-particle__label[data-v-1e2841b2]{color:var(--ace-c-text-gray)}.step-particle__tail[data-v-1e2841b2]{flex:1;height:1px;background:var(--ace-c-primary-gray)}.step-particle__tail--completed[data-v-1e2841b2]{background:var(--ace-c-section-primary)}@media (max-width:991.98px){.step-particle[data-v-1e2841b2]:not(.step-particle--current):not(.step-particle--current+.step-particle){display:none}.step-particle--current+.step-particle[data-v-1e2841b2]{flex:0}.step-particle--current+.step-particle .step-particle__tail[data-v-1e2841b2]{display:none}}@media (max-width:575.98px){.step-particle--current .step-particle__tail[data-v-1e2841b2],.step-particle--current+.step-particle[data-v-1e2841b2]{display:none}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".steps-atom[data-v-3cda9b10]{display:flex;flex-direction:row;gap:12px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky-footer-atom[data-v-0b46443a]{position:fixed;bottom:0;left:0;right:0;box-shadow:0 -3px 6px 0 rgba(0,0,0,.16);z-index:999}.sticky-footer-atom__header[data-v-0b46443a]{background:var(--ace-c-primary-blue);padding:1rem 8rem;display:flex;justify-content:space-between;align-items:center;width:100%;box-sizing:border-box}.sticky-footer-atom__header__values[data-v-0b46443a]{display:flex;-moz-column-gap:2rem;column-gap:2rem}.sticky-footer-atom__header__title[data-v-0b46443a]{border-left:3px solid var(--ace-c-primary-white);padding-left:.75rem;display:flex;flex-direction:column;justify-content:center;height:2.5rem}.sticky-footer-atom__header__title__label[data-v-0b46443a]{font-family:var(--ace-font-bold);font-size:14px;line-height:1;padding-bottom:8px}.sticky-footer-atom__header__title__value[data-v-0b46443a]{font-family:var(--ace-font-bold);font-size:18px;line-height:1}.sticky-footer-atom__actions[data-v-0b46443a]{display:flex;-moz-column-gap:.5rem;column-gap:.5rem}.sticky-footer-atom__content[data-v-0b46443a]{padding:2rem 8rem;box-sizing:border-box;background:var(--ace-c-primary-white);overflow:auto}.sticky-footer-atom__content[data-v-0b46443a]:empty{display:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-atom[data-v-418fcb97]{display:inline-flex;margin:0 var(--ace-distance-xs);padding:13px var(--ace-distance-md);border:0;background:var(--ace-c-primary-white);border-radius:var(--ace-radius-xs);font-size:var(--ace-font-size-button);line-height:var(--ace-font-height-button);outline:none;color:var(--ace-c-text-black)}.tab-atom.tab-atom--is-primary[data-v-418fcb97]:not(.tab-atom--is-selected):not(.tab-atom--is-disabled):hover{background:var(--ace-c-primary-blue-light);cursor:pointer}.tab-atom.tab-atom--is-primary[data-v-418fcb97]:not(.tab-atom--is-selected):not(.tab-atom--is-disabled):focus{box-shadow:0 0 0 2px var(--ace-c-text-black);background:var(--ace-c-primary-blue-light)}.tab-atom--is-primary.tab-atom--is-selected[data-v-418fcb97]{margin:0 var(--ace-distance-xs);background:var(--ace-c-primary-blue);font-family:var(--ace-font-bold);padding-bottom:30px;border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-4px}.tab-atom--is-primary.tab-atom--is-disabled[data-v-418fcb97]{background:var(--ace-c-status-gray)}.tab-atom__icon[data-v-418fcb97]{display:flex;justify-content:center;align-items:center;width:22px;height:22px;margin-left:30px;border:1px solid var(--ace-c-text-black);border-radius:24px}.tab-atom__icon[data-v-418fcb97] svg{max-height:32px;max-width:32px;margin-top:2px}.tab-atom__icon--is-selected[data-v-418fcb97]{background:var(--ace-c-text-black)}.tab-atom__icon--is-selected[data-v-418fcb97] svg{color:#fff;transform:rotate(180deg);margin-top:-2px}.tab-atom--is-secondary[data-v-418fcb97]{padding:8px 16px 0 0;margin:0;border:0;border-bottom:2px solid var(--ace-c-primary-gray);border-radius:0;background:transparent}.tab-atom.tab-atom--is-secondary[data-v-418fcb97]:not(.tab-atom--is-selected):not(.tab-atom--is-disabled):hover{border-color:var(--ace-c-text-gray);cursor:pointer}.tab-atom--is-secondary.tab-atom--is-selected[data-v-418fcb97]{border-bottom:2px solid var(--ace-c-text-black);font-family:var(--ace-font-bold);border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-4px}.tab-atom--is-secondary.tab-atom--is-disabled[data-v-418fcb97]{color:var(--ace-c-text-gray);border-color:var(--ace-c-status-gray)}.tab-atom.tab-atom--is-secondary[data-v-418fcb97]:not(.tab-atom--is-selected):not(.tab-atom--is-disabled):focus{box-shadow:0 0 0 2px var(--ace-c-text-black);background:var(--ace-c-primary-blue-light)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".more-button[data-v-95c9d970]{cursor:pointer;display:flex;flex-direction:row;align-items:center;margin-top:24px;transition:all .2s ease-in-out}.more-button[data-v-95c9d970]:hover{color:var(--ace-c-text-blue)}.more-button__icon[data-v-95c9d970]{width:24px;height:24px;margin-right:6px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container__table__row[data-v-efeb026c]{border-bottom:1px solid var(--ace-c-primary-gray)}.container__table__row--sum[data-v-efeb026c]{font-family:BrixSansBlack;border-bottom:0;border-top:2px solid var(--ace-c-section-primary)}.container__table__row__data[data-v-efeb026c]{padding:3px 10px;vertical-align:middle}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 8281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages[data-v-0152bd0e]{display:flex;flex-direction:row;align-items:center;padding-top:10px}.pages__previous[data-v-0152bd0e]{width:24px;height:24px;transform:rotate(90deg)}.pages__end-point[data-v-0152bd0e]{display:flex;flex-direction:row}.pages__button-box[data-v-0152bd0e]{display:flex;justify-content:center;align-items:center;margin-left:8px;margin-right:8px;width:20px;height:20px}.pages__index--active[data-v-0152bd0e]{cursor:default;font-weight:900;color:var(--ace-c-status-gray)}.pages__index--inactive[data-v-0152bd0e]{cursor:pointer}.pages__next[data-v-0152bd0e]{width:24px;height:24px;transform:rotate(-90deg)}.pages__element--disabled[data-v-0152bd0e]{color:var(--ace-c-status-gray)}.pages__element--active[data-v-0152bd0e]{cursor:pointer}.pages__number-of-visible-items[data-v-0152bd0e]{font-size:.8em;display:flex;justify-content:center}.pages--nested[data-v-0152bd0e]{padding-bottom:10px}.pages--nested .pages__element--disabled[data-v-0152bd0e],.pages--nested .pages__index--active[data-v-0152bd0e]{color:#b8b8b8}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-a6243cee]{flex-grow:1;display:flex;flex-direction:row;padding:10px;position:relative}.footer--shadow[data-v-a6243cee]{box-shadow:0 -4px 2px rgba(0,0,0,.2);position:relative;z-index:0}.footer__glue[data-v-a6243cee]{display:flex;flex-grow:1}.footer__expand-button[data-v-a6243cee]{cursor:pointer;display:flex;flex-direction:row;align-items:center;transition:all .2s ease-in-out}.footer__expand-button[data-v-a6243cee]:hover{color:var(--ace-c-text-blue)}.footer__expand-button__icon[data-v-a6243cee]{margin-left:6px;height:24px;width:24px}.icon-transform[data-v-a6243cee]{transform:rotate(180deg)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sorting-icons[data-v-2ecd1a79]{display:flex;flex-direction:column;width:14px;height:20px;position:relative}.sorting-icons__icon[data-v-2ecd1a79]{width:16px;height:16px;transition:all .2s ease-in-out;position:absolute}.sorting-icons__icon--up[data-v-2ecd1a79]{top:0;transform:rotate(180deg)}.sorting-icons__icon--down[data-v-2ecd1a79]{top:6px}.sorting-icons__icon--gray[data-v-2ecd1a79]{color:var(--ace-c-status-gray)}.sorting-icons__icon--black[data-v-2ecd1a79]{color:var(--ace-c-text-black)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-0289bfc2]{font-size:16px}.container--nested[data-v-0289bfc2]{background-color:var(--ace-c-section-secondary);border-radius:4px}.container__table[data-v-0289bfc2]{width:100%;table-layout:fixed}.container__table__header--sticky[data-v-0289bfc2]{position:sticky;top:0;background:var(--ace-c-primary-white);z-index:999}.container__table__header[data-v-0289bfc2]{display:flex;flex-direction:row;padding:10px;font-size:14px;align-items:center;font-family:BrixSansBold}.container__table__row[data-v-0289bfc2]{border-bottom:1px solid var(--ace-c-primary-gray)}.container__table__row--nested[data-v-0289bfc2]{border-bottom:1px solid var(--ace-c-text-gray)}.container__table__row--nested[data-v-0289bfc2]:last-child{border:none}.container__table__row--odd[data-v-0289bfc2]{background-color:var(--ace-c-section-secondary)}.container__table__row--details[data-v-0289bfc2],.container__table__row.container__table__row--highlight[data-v-0289bfc2]{background-color:var(--ace-c-section-table-highlight)}.container__table__row.container__table__row--dynamic[data-v-0289bfc2]{cursor:pointer}.container__table__row.container__table__row--dynamic[data-v-0289bfc2]:hover{background-color:var(--ace-c-section-table-hover)}.container__table__row__data[data-v-0289bfc2]{padding:3px 10px;vertical-align:middle}.container__table__row__data__wrapper[data-v-0289bfc2]{height:100%;width:100%;display:flex;align-items:center;box-sizing:border-box}.container__table__row__data__wrapper__clamp[data-v-0289bfc2]{overflow:hidden;text-overflow:ellipsis;line-clamp:1}.container__table__header--details[data-v-0289bfc2]{width:36px}.container__table__row__data--details[data-v-0289bfc2]{width:16px}.container__table__row__data__icon[data-v-0289bfc2]{display:block;width:16px;height:16px;cursor:pointer}.container__table__row__data__icon--active[data-v-0289bfc2]{transform:rotate(180deg)}.container__footer[data-v-0289bfc2]{position:relative;width:100%;display:flex;justify-content:center}.container__table__row__data__loader[data-v-0289bfc2]{height:27px}.container__table__row--sum[data-v-0289bfc2]{font-family:BrixSansBlack;border-bottom:0;border-top:2px solid var(--ace-c-section-primary)}@media (max-width:992px){.container__table[data-v-0289bfc2]{width:auto;min-width:100%}.container[data-v-0289bfc2]{overflow:auto;padding-bottom:4px}.container__table__header--stick[data-v-0289bfc2]{position:unset}}@media (max-width:1200px){.container__table__td--xl[data-v-0289bfc2],.container__table__th--xl[data-v-0289bfc2]{display:none}}@media (max-width:992px){.container__table__td--lg[data-v-0289bfc2],.container__table__th--lg[data-v-0289bfc2]{display:none}}@media (max-width:768px){.container__table__td--md[data-v-0289bfc2],.container__table__th--md[data-v-0289bfc2]{display:none}}@media (max-width:576px){.container__table__td--sm[data-v-0289bfc2],.container__table__th--sm[data-v-0289bfc2]{display:none}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-wrapper-atom__header[data-v-66cb53f5]{grid-template-columns:minmax(0,max-content) minmax(0,1fr);align-items:center}.table-wrapper-atom__header__summary__total[data-v-66cb53f5]{font-family:BrixSansBlack}.table-wrapper-atom__header__panel[data-v-66cb53f5]{flex:1;align-items:center;justify-content:flex-end;gap:12px}.table-wrapper-atom__no-records[data-v-66cb53f5]{display:flex;flex-direction:column;background:var(--ace-c-primary-gray);justify-content:center;height:175px;text-align:center}.table-wrapper-atom__no-records__icon[data-v-66cb53f5]{width:20px;height:20px}.table-wrapper-atom__footer[data-v-66cb53f5]{margin-top:4px;gap:4px}.table-wrapper-atom__no-records--nested[data-v-66cb53f5]{background-color:var(--ace-c-section-secondary);border-radius:4px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-area-atom__text-area[data-v-6b16cbeb]{min-height:80px;outline:none;resize:none}.ace-input-wrapper[data-v-6b16cbeb]{overflow-y:auto;position:relative}.text-area-atom__max-length[data-v-6b16cbeb]{position:absolute;bottom:1px;right:6px;font-size:10px;line-height:18px;background:var(--ace-c-primary-gray);padding-left:4px}.ace-input--has-max-length[data-v-6b16cbeb]{padding-bottom:18px}.text-area-atom__wrapper--inactive[data-v-6b16cbeb]{margin:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-atom__value[data-v-a8f664fa]{pointer-events:auto;min-height:36px;box-sizing:border-box}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-input-atom[data-v-3c31f7dc]{position:relative;display:flex;flex-direction:column;width:100%}.text-input-atom--single-row[data-v-3c31f7dc]{flex-direction:row;align-items:center;width:auto}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time-input-atom[data-v-5d0357f0]{position:relative;display:flex;flex-direction:column}.ace-input-wrapper[data-v-5d0357f0]{max-width:80px}.ace-input-wrapper--error[data-v-5d0357f0]{max-width:90px}.ace-input[data-v-5d0357f0]{padding-left:16px;padding-right:16px}.time-input-atom--inline[data-v-5d0357f0]{width:-moz-fit-content;width:fit-content}.time-input-atom--single-row[data-v-5d0357f0]{flex-direction:row;align-items:center}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time-input-atom__field[data-v-1979c359]{width:80px;padding:0 16px}.time-input-dropdown__time-box[data-v-1979c359]{display:flex;align-items:center;justify-content:center;gap:20px}.time-input-divider[data-v-1979c359]{font-size:14px}.ace-column[data-v-1979c359]{display:flex;flex-direction:column;align-items:center}.time-input-value[data-v-1979c359]{font-size:14px;font-weight:700}.time-controls__arrow_up[data-v-1979c359]{transform:rotate(180deg)}svg[data-v-1979c359]{width:16px;height:16px}.time-input-dropdown[data-v-1979c359]{position:absolute;z-index:9999;border-top:3px solid var(--ace-c-primary-blue);background:var(--ace-c-primary-white);box-shadow:0 3px 6px #00000029;border-radius:6px;opacity:1;width:150px}.time-input-dropdown[data-v-1979c359],.time-input-dropdown__time-box[data-v-1979c359],.time-input-value[data-v-1979c359]{-webkit-user-select:none;-moz-user-select:none;user-select:none}.time-input-dropdown__arrows[data-v-1979c359]{background-color:transparent}.time-input-dropdown__arrows[data-v-1979c359]:hover{cursor:pointer}.time-picker-dropdown__header[data-v-1979c359]{height:23px;margin-top:0;position:relative;justify-content:center;align-items:center;display:flex}.time-picker-dropdown__close-btn[data-v-1979c359]{height:8px;width:8px;border-radius:50%;position:absolute;top:8px;right:18px;cursor:pointer}.time-picker-dropdown__close-btn[data-v-1979c359]:hover{background:var(--ace-c-primary-blue-light);border-radius:50%;box-shadow:0 0 0 6px var(--ace-c-primary-blue-light);cursor:pointer}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-atom[data-v-e8c29e1c]{display:flex;flex-direction:row}.toggle-atom__option[data-v-e8c29e1c]{cursor:pointer;padding-left:16px;padding-right:16px;padding-bottom:2px;line-height:16px}.toggle-atom__option--primary[data-v-e8c29e1c]{font-family:BrixSansBold;background-color:var(--ace-c-primary-blue);border:2px solid var(--ace-c-primary-blue)}.toggle-atom__option--secondary[data-v-e8c29e1c]{font-family:BrixSansLight;background-color:var(--ace-c-primary-white);border:2px solid var(--ace-c-primary-white)}.toggle-atom__option[data-v-e8c29e1c]:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}.toggle-atom__option[data-v-e8c29e1c]:last-child{border-top-right-radius:3px;border-bottom-right-radius:3px}.toggle-atom__option[data-v-e8c29e1c]:hover{background-color:var(--ace-c-primary-blue-gray);border:2px solid var(--ace-c-primary-blue-gray)}.toggle-atom__option[data-v-e8c29e1c]:focus{border:2px solid var(--ace-c-text-black)}.toggle-atom__option--disabled[data-v-e8c29e1c]{background-color:var(--ace-c-primary-gray);border:2px solid var(--ace-c-primary-gray);pointer-events:none}.toggle-atom__option--disabled.toggle-atom__option--primary[data-v-e8c29e1c]{background-color:var(--ace-c-status-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".validation-atom[data-v-31cbd712]{gap:var(--ace-gutter)}.validation-atom[data-v-31cbd712],.validation-atom__anchor[data-v-31cbd712],.validation-atom__icon[data-v-31cbd712]{display:flex;align-items:center}.validation-atom__icon[data-v-31cbd712] svg{width:16px;height:16px}.validation-atom__icon--error[data-v-31cbd712]{color:var(--ace-c-status-red);--ace-c-fill:var(--ace-c-status-pink)}.validation-atom__icon--warning[data-v-31cbd712]{color:var(--ace-c-status-brown);--ace-c-fill:var(--ace-c-status-yellow)}.validation-atom__value[data-v-31cbd712]{font-family:BrixSansBlack}.validation-atom__value--has-number[data-v-31cbd712]{font-family:BrixSansLight}.validation-atom__value--error[data-v-31cbd712]{color:var(--ace-c-status-red)}.validation-atom__value--warning[data-v-31cbd712]{color:var(--ace-c-status-brown)}.validation-atom__anchor[data-v-31cbd712]{cursor:pointer}.validation-atom__anchor[data-v-31cbd712] svg{width:16px;height:16px}.validation-atom__anchor--error[data-v-31cbd712]{color:var(--ace-c-status-red);--ace-c-fill:var(--ace-c-status-pink)}.validation-atom__anchor--warning[data-v-31cbd712]{color:var(--ace-c-status-brown);--ace-c-fill:var(--ace-c-status-yellow)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions-molecule[data-v-1b7272f5]{position:relative}.actions-molecule__wrapper[data-v-1b7272f5]{top:16px;right:-50px;position:absolute;display:flex;flex-direction:column;align-items:flex-end}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".check-molecule__wrapper[data-v-1b21db05]{overflow-y:auto}.check-molecule__wrapper__layout[data-v-1b21db05]{margin-left:-4px;padding-left:4px;width:-moz-max-content;width:max-content;overflow-y:auto;padding-right:8px}.check-molecule__wrapper__layout--horizontal[data-v-1b21db05]{display:flex;flex-direction:row;gap:8px}.check-molecule__wrapper__layout--grid[data-v-1b21db05]{display:grid;grid-auto-flow:column;gap:0 8px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-molecule[data-v-101b3f82]{position:sticky;bottom:-16px;margin-bottom:-16px;z-index:999}@media (max-width:1024px){.footer-molecule[data-v-101b3f82]{position:static}}.footer-molecule--should-not-stick[data-v-101b3f82]{position:static}.footer-molecule--modal[data-v-101b3f82]{position:static;margin-bottom:0;bottom:unset;width:100%}.footer-molecule--headless[data-v-101b3f82]{margin-bottom:0;bottom:0;background:#fff;padding-bottom:16px}.footer-molecule__panel[data-v-101b3f82]{background:var(--ace-c-primary-gray);margin-top:var(--ace-gutter);display:flex;flex-direction:row;justify-content:flex-end;align-items:center;padding:var(--ace-gutter) 0;gap:var(--ace-gutter)}.footer-molecule__panel--sm[data-v-101b3f82]{flex-wrap:wrap}.footer-molecule__panel__validation[data-v-101b3f82]{flex:1;position:relative;margin-left:16px;margin-right:36px;height:36px}.footer-molecule__panel__validation--sm[data-v-101b3f82]{flex-basis:100%;margin-left:0}.footer-molecule__panel__validation__wrapper[data-v-101b3f82]{background:var(--ace-c-primary-white);padding:5px 16px;border-radius:20px;line-height:26px;position:absolute;width:100%;bottom:0}.footer-molecule__panel__validation__wrapper--expandable[data-v-101b3f82]{cursor:pointer}.footer-molecule__panel__validation__wrapper__header[data-v-101b3f82]{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,max-content);gap:var(--ace-gutter)}.footer-molecule__panel__validation__wrapper__header--expanded[data-v-101b3f82]{border-bottom:1px solid var(--ace-c-primary-gray);padding-bottom:8px;margin-bottom:8px}.footer-molecule__panel__validation__wrapper__header__expand[data-v-101b3f82]{display:flex;align-items:center;cursor:pointer}.footer-molecule__panel__validation__wrapper__header__expand svg[data-v-101b3f82]{width:16px;height:16px}.footer-molecule__panel__validation__wrapper__header__expand--hide svg[data-v-101b3f82]{transform:rotate(180deg)}.footer-molecule__panel__validation__wrapper__content[data-v-101b3f82]{max-height:50vh;overflow-y:auto}.footer-molecule__panel--headless[data-v-101b3f82],.footer-molecule__panel--modal[data-v-101b3f82]{background:transparent;margin-top:0;padding-bottom:0}.footer-molecule__panel--is-sticky[data-v-101b3f82]{border-top:4px solid var(--ace-c-primary-blue);box-shadow:0 -6px 4px -4px rgba(0,0,0,.16)}.footer-molecule__panel__description[data-v-101b3f82]{flex:1}.footer-molecule__modal-atom__buttons[data-v-101b3f82]{display:grid;gap:var(--ace-gutter);grid-template-columns:min-content min-content min-content;justify-content:end;margin-top:40px}.footer-molecule__close-button[data-v-101b3f82]{position:fixed;right:80px;top:130px;z-index:999}@media (max-width:992px){.footer-molecule__close-button[data-v-101b3f82]{top:77px;right:17px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 5846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-molecule[data-v-e85a9da2]{display:grid;grid-template-columns:min-content auto;grid-template-rows:minmax(80px,max-content);gap:var(--ace-gutter)}.header-molecule__header[data-v-e85a9da2]{display:flex;align-items:center;background:var(--ace-c-section-primary);font-family:var(--ace-font-bold);font-size:20px;line-height:24px;padding:0 32px;border-radius:4px}.header-molecule__content[data-v-e85a9da2]{display:grid;grid-template-columns:1fr max-content;gap:var(--ace-gutter);align-items:center}.header-molecule__content__row[data-v-e85a9da2]{font-size:16px;line-height:24px;vertical-align:middle;padding-left:32px;position:relative}.header-molecule__content__row[data-v-e85a9da2] svg{width:20px;height:20px;position:absolute;left:0;top:4px}.header-molecule__content__row__ingress[data-v-e85a9da2]{font-family:BrixSansBlack;font-size:20px;line-height:28px}@media (max-width:992px){.header-molecule[data-v-e85a9da2]{grid-template-columns:minmax(0,1fr);grid-template-rows:unset}.header-molecule__header[data-v-e85a9da2]{padding:8px 16px}}@media (max-width:576px){.header-molecule__content[data-v-e85a9da2]{grid-template-columns:minmax(0,1fr)}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".information-molecule[data-v-f5de3356]{display:grid;grid-template-columns:min-content auto;gap:var(--ace-gutter);align-items:center;border-radius:4px;overflow:hidden;border-left:4px solid var(--ace-c-secondary-orange);background:#fff}.information-molecule__icon-container[data-v-f5de3356]{padding:20px 0 20px 20px;height:100%;box-sizing:border-box}.information-molecule__icon-container__icon[data-v-f5de3356]{width:32px;height:32px;color:var(--ace-c-secondary-orange);display:block}.information-molecule .information-molecule__content h3[data-v-f5de3356]{font-family:BrixSansBlack;font-size:1.25em;margin-bottom:var(--ace-gutter)}.information-molecule__content[data-v-f5de3356]{padding:20px}.information-molecule__content__example[data-v-f5de3356]{margin-top:var(--ace-gutter);font-style:italic}.information-molecule .information-molecule__content span[data-v-f5de3356]{font-family:BrixSansBold}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ace-disable-scrolls,.ace-disable-scrolls *{overflow:hidden!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nested-app-molecule__iframe[data-v-59cb0435]{height:100%}.nested-app-molecule--headless[data-v-59cb0435] .modal-atom__content--is-overlay{width:100%!important;height:100%!important;box-shadow:0 0 12px 20px rgba(0,0,0,.16);border-left:0!important;border-right:0!important;border-bottom:0!important}.nested-app-molecule--has-nested-iframe[data-v-59cb0435] .modal-atom__content__title{box-shadow:inset 0 -32px 32px -32px #000!important}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auto-complete-atom__container--loader[data-v-28fe9692]{display:flex;justify-content:center;align-items:center;border-bottom:1px solid var(--ace-c-text-gray);border-top:1px solid var(--ace-c-text-gray);background-color:var(--ace-c-primary-gray)}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radio-molecule__wrapper[data-v-21e5928c]{margin-left:-4px;padding-left:4px;width:-moz-max-content;width:max-content;overflow-y:auto;padding-right:8px}.radio-molecule__wrapper--horizontal[data-v-21e5928c]{display:flex;flex-direction:row;gap:8px}.radio-molecule__wrapper--grid[data-v-21e5928c]{display:grid;gap:0 8px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-molecule[data-v-775c0a88]{position:relative;margin-top:-2px}.tab-molecule__tabs[data-v-775c0a88]{padding-top:2px;height:67px;overflow-x:auto;overflow-y:hidden;white-space:nowrap}.tab-molecule__tabs[data-v-775c0a88]::-webkit-scrollbar{height:0;width:0}.tab-molecule__tabs[data-v-775c0a88]::-webkit-scrollbar-track{border-radius:0;background-color:transparent;background-clip:content-box}.tab-molecule__tabs[data-v-775c0a88]::-webkit-scrollbar-thumb{border-radius:0;background-color:transparent}.tab-molecule__tabs[data-v-775c0a88]::-webkit-scrollbar-thumb:window-inactive{border-radius:0;background-color:transparent}.tab-molecule__scroll-button[data-v-775c0a88]{background:var(--ace-c-primary-gray);position:absolute;height:50px;padding-bottom:19px;top:0;display:flex;justify-content:center;align-items:center}.tab-molecule__scroll-button--modal[data-v-775c0a88]{background:#fff}.tab-molecule__scroll-button--left[data-v-775c0a88]{left:0;padding-right:8px}.tab-molecule__scroll-button--right[data-v-775c0a88]{right:0;padding-left:8px}.tab-molecule__scroll-button__button[data-v-775c0a88]{background:var(--ace-c-primary-blue);width:32px;height:32px;border-radius:32px;display:flex;justify-content:center;align-items:center;cursor:pointer}.tab-molecule__scroll-button__button[data-v-775c0a88] svg{width:26px;height:26px}.tab-molecule__scroll-button__button--left[data-v-775c0a88] svg{transform:rotate(90deg)}.tab-molecule__scroll-button__button--right[data-v-775c0a88] svg{transform:rotate(270deg)}.fade-enter-active[data-v-775c0a88],.fade-leave-active[data-v-775c0a88]{transition:opacity .4s}.fade-enter-from[data-v-775c0a88],.fade-leave-to[data-v-775c0a88]{opacity:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-editor-molecule[data-v-2072decc]{position:relative}.text-editor-molecule__header[data-v-2072decc]{display:grid;grid-template-columns:minmax(0,1fr) minmax(min-content,max-content);gap:var(--ace-gutter)}.text-editor-molecule__icon[data-v-2072decc]{height:12px;width:12px;cursor:pointer;text-align:center;justify-content:center}.text-editor-molecule__icon--active[data-v-2072decc],.text-editor-molecule__icon-wrapper[data-v-2072decc]{height:26px;width:26px;border-radius:26px;margin-left:8px;text-align:center;justify-content:center;cursor:pointer}.text-editor-molecule__icon--active[data-v-2072decc]{color:var(--ace-c-primary-white);fill:var(--ace-c-primary-white);background:var(--ace-c-text-black)}.text-editor-molecule__link[data-v-2072decc]{background:hsla(0,0%,100%,.9);position:absolute;width:100%;height:100%;top:0;left:0;z-index:9999;display:grid;gap:var(--ace-gutter);grid-template-columns:1fr max-content;align-items:center;justify-content:center}.text-editor-molecule__field[data-v-2072decc]{height:350px;overflow-y:scroll}.text-editor-molecule__field__editor[data-v-2072decc],.text-editor-molecule__field__editor[data-v-2072decc] .ProseMirror{height:100%;padding-left:4px}.text-editor-molecule__field__editor[data-v-2072decc] .ProseMirror:focus-visible{border:0;box-shadow:0;outline:none}.text-editor-molecule__action-bar[data-v-2072decc]{display:flex;justify-content:flex-end}.text-editor-molecule__meta[data-v-2072decc]{display:flex;padding:0 12px var(--distance-md) 12px}.text-editor-molecule__meta__text[data-v-2072decc]{font-size:.9em}.text-editor-molecule__meta__text--last[data-v-2072decc]{flex:1;text-align:right}.text-editor-molecule__field__editor[data-v-2072decc] .text-area-atom__text-area{height:350px}.text-editor-molecule__field__editor[data-v-2072decc] h1{font-weight:700}.text-editor-molecule__field__editor[data-v-2072decc] strong{font-weight:700}.text-editor-molecule__field__editor[data-v-2072decc] em{font-style:italic}.text-editor-molecule__field__editor[data-v-2072decc] ul{list-style:disc;padding-left:var(--distance-md)}.text-editor-molecule__field__editor[data-v-2072decc] ol{list-style-type:decimal;padding-left:var(--distance-md)}.text-editor-molecule__field__editor[data-v-2072decc] a{pointer-events:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unsaved-changes-molecule__buttons[data-v-13b9c5bc]{display:grid;gap:var(--ace-gutter);grid-template-columns:min-content min-content min-content;justify-content:end;margin-top:40px}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Reset_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7783);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Colors_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2352);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Typography_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1740);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Inputs_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4954);
// Imports






var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Reset_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Colors_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Typography_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Inputs_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--ace-gutter:16px;--ace-distance-xs:8px;--ace-distance-sm:12px;--ace-distance-md:16px;--ace-distance-xl:48px;--ace-radius-xs:5px;--ace-font-size-button:16px;--ace-font-height-button:24px;--ace-font-bold:\"BrixSansBlack\"}.app-shell,html.go-apps,html.go-apps body{min-height:100%;display:flex;flex:1}#app{flex:1}.go-apps--headless{height:100%}.app-shell{color:var(--ace-c-text-black);background:var(--ace-c-primary-gray)}.app-shell--headless{background:var(--ace-c-primary-white)}.app-shell hr{border-bottom:0;border-left:0;border-right:0}.app-shell .ace-info{margin:0;font-family:var(--ace-font-bold);font-size:16px;line-height:27px}.ace-shadow{box-shadow:0 3px 6px 0 rgba(0,0,0,.16)}.ace-clamp{overflow:hidden;text-overflow:ellipsis;line-clamp:1;-webkit-line-clamp:1;display:block;white-space:nowrap}.ace-no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ace-loader{animation-duration:1s;animation-name:loaderAnimation;animation-iteration-count:infinite;animation-direction:alternate}.ace-loader-mask{position:relative}.ace-loader-mask:after{content:\"\";width:100%;height:100%;position:absolute;animation-duration:1s;animation-name:loaderAnimation;animation-iteration-count:infinite;animation-direction:alternate;left:0}@keyframes loaderAnimation{0%{background-color:var(--ace-c-primary-gray)}to{background-color:var(--ace-c-status-gray)}}.ace-scroll::-webkit-scrollbar{height:8px;width:8px}.ace-scroll::-webkit-scrollbar-track{border-radius:8px;background-color:#ddd;background-clip:content-box}.ace-scroll::-webkit-scrollbar-thumb{border-radius:8px;background-color:var(--ace-c-text-black)}.ace-scroll::-webkit-scrollbar-thumb:window-inactive{border-radius:8px;background-color:var(--ace-c-text-black)}.ace-table-icon--check{width:12px;height:12px}.ace-table-icon--action{width:17px;height:17px;cursor:pointer}.ace-section-icon{color:var(--ace-c-section-primary);fill:var(--ace-c-section-primary)}.go-apps .ace-group{border-left:2px solid var(--ace-c-section-primary);padding-left:16px}.go-apps .ace-panel{background-color:var(--ace-c-section-secondary);border-radius:4px;padding:10px}.ace-center{align-items:center;justify-content:center}.ace-center,.ace-row{display:flex;flex-direction:row}.ace-row{gap:var(--ace-gutter);justify-self:center;align-self:center;align-content:center;flex-wrap:wrap;width:100%}.ace-column{grid-template-columns:minmax(0,1fr)}.ace-column,.ace-grid{display:grid;gap:var(--ace-gutter)}.ace-grid{grid-template-columns:repeat(12,minmax(0,1fr))}.ace-grid-hide{display:none}.ace-grid-show{display:block}.ace-grid-span-1,.ags-1{grid-column:auto/span 1}.ace-grid-span-2,.ags-2{grid-column:auto/span 2}.ace-grid-span-3,.ags-3{grid-column:auto/span 3}.ace-grid-span-4,.ags-4{grid-column:auto/span 4}.ace-grid-span-5,.ags-5{grid-column:auto/span 5}.ace-grid-span-6,.ags-6{grid-column:auto/span 6}.ace-grid-span-7,.ags-7{grid-column:auto/span 7}.ace-grid-span-8,.ags-8{grid-column:auto/span 8}.ace-grid-span-9,.ags-9{grid-column:auto/span 9}.ace-grid-span-10,.ags-10{grid-column:auto/span 10}.ace-grid-span-11,.ags-11{grid-column:auto/span 11}.ace-grid-span-12,.ags-12{grid-column:auto/span 12}@media (max-width:992px){.inmplayer-general,.inmplayer-launcher{display:none!important}}@media (max-width:1500px){.ace-grid-hide-lg{display:none}.ace-grid-show-lg{display:block}.ace-grid-span-lg-1,.ags-lg-1{grid-column:auto/span 1}.ace-grid-span-lg-2,.ags-lg-2{grid-column:auto/span 2}.ace-grid-span-lg-3,.ags-lg-3{grid-column:auto/span 3}.ace-grid-span-lg-4,.ags-lg-4{grid-column:auto/span 4}.ace-grid-span-lg-5,.ags-lg-5{grid-column:auto/span 5}.ace-grid-span-lg-6,.ags-lg-6{grid-column:auto/span 6}.ace-grid-span-lg-7,.ags-lg-7{grid-column:auto/span 7}.ace-grid-span-lg-8,.ags-lg-8{grid-column:auto/span 8}.ace-grid-span-lg-9,.ags-lg-9{grid-column:auto/span 9}.ace-grid-span-lg-10,.ags-lg-10{grid-column:auto/span 10}.ace-grid-span-lg-11,.ags-lg-11{grid-column:auto/span 11}.ace-grid-span-lg-12,.ags-lg-12{grid-column:auto/span 12}}@media (max-width:992px){.ace-grid-hide-md{display:none}.ace-grid-show-md{display:block}.ace-grid-span-md-1,.ags-md-1{grid-column:auto/span 1}.ace-grid-span-md-2,.ags-md-2{grid-column:auto/span 2}.ace-grid-span-md-3,.ags-md-3{grid-column:auto/span 3}.ace-grid-span-md-4,.ags-md-4{grid-column:auto/span 4}.ace-grid-span-md-5,.ags-md-5{grid-column:auto/span 5}.ace-grid-span-md-6,.ags-md-6{grid-column:auto/span 6}.ace-grid-span-md-7,.ags-md-7{grid-column:auto/span 7}.ace-grid-span-md-8,.ags-md-8{grid-column:auto/span 8}.ace-grid-span-md-9,.ags-md-9{grid-column:auto/span 9}.ace-grid-span-md-10,.ags-md-10{grid-column:auto/span 10}.ace-grid-span-md-11,.ags-md-11{grid-column:auto/span 11}.ace-grid-span-md-12,.ags-md-12{grid-column:auto/span 12}}@media (max-width:768px){.ace-grid-hide-sm{display:none}.ace-grid-show-sm{display:block}.ace-grid-span-sm-1,.ags-sm-1{grid-column:auto/span 1}.ace-grid-span-sm-2,.ags-sm-2{grid-column:auto/span 2}.ace-grid-span-sm-3,.ags-sm-3{grid-column:auto/span 3}.ace-grid-span-sm-4,.ags-sm-4{grid-column:auto/span 4}.ace-grid-span-sm-5,.ags-sm-5{grid-column:auto/span 5}.ace-grid-span-sm-6,.ags-sm-6{grid-column:auto/span 6}.ace-grid-span-sm-7,.ags-sm-7{grid-column:auto/span 7}.ace-grid-span-sm-8,.ags-sm-8{grid-column:auto/span 8}.ace-grid-span-sm-9,.ags-sm-9{grid-column:auto/span 9}.ace-grid-span-sm-10,.ags-sm-10{grid-column:auto/span 10}.ace-grid-span-sm-11,.ags-sm-11{grid-column:auto/span 11}.ace-grid-span-sm-12,.ags-sm-12{grid-column:auto/span 12}}@media (max-width:576px){.ace-grid-hide-xs{display:none}.ace-grid-show-xs{display:block}.ace-grid-span-xs-1,.ags-xs-1{grid-column:auto/span 1}.ace-grid-span-xs-2,.ags-xs-2{grid-column:auto/span 2}.ace-grid-span-xs-3,.ags-xs-3{grid-column:auto/span 3}.ace-grid-span-xs-4,.ags-xs-4{grid-column:auto/span 4}.ace-grid-span-xs-5,.ags-xs-5{grid-column:auto/span 5}.ace-grid-span-xs-6,.ags-xs-6{grid-column:auto/span 6}.ace-grid-span-xs-7,.ags-xs-7{grid-column:auto/span 7}.ace-grid-span-xs-8,.ags-xs-8{grid-column:auto/span 8}.ace-grid-span-xs-9,.ags-xs-9{grid-column:auto/span 9}.ace-grid-span-xs-10,.ags-xs-10{grid-column:auto/span 10}.ace-grid-span-xs-11,.ags-xs-11{grid-column:auto/span 11}.ace-grid-span-xs-12,.ags-xs-12{grid-column:auto/span 12}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 6915:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_ExtReset_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7497);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Colors_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2352);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_ExtTypography_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9564);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Inputs_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4954);
// Imports






var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_ExtReset_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Colors_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_ExtTypography_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
___CSS_LOADER_EXPORT___.i(_node_modules_css_loader_dist_cjs_js_clonedRuleSet_12_use_1_node_modules_vue_loader_dist_stylePostLoader_js_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_2_node_modules_postcss_loader_dist_cjs_js_clonedRuleSet_12_use_3_Resources_Inputs_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--ace-distance-xs:8px;--ace-distance-sm:12px;--ace-distance-md:16px;--ace-distance-xl:48px;--ace-radius-xs:5px;--ace-font-size-button:16px;--ace-font-height-button:24px;--ace-font-bold:\"BrixSansBlack\"}.ext-app-shell{min-height:100%;display:flex;flex:1;text-align:left;color:var(--ace-c-text-black);background:var(--ace-c-primary-gray)}.ext-app-shell hr{border-bottom:0;border-left:0;border-right:0}.ext-app-shell .ace-shadow{box-shadow:0 3px 6px 0 rgba(0,0,0,.16)}.ext-app-shell .ace-no-select{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ext-app-shell .ace-clamp{overflow:hidden;text-overflow:ellipsis;line-clamp:1;-webkit-line-clamp:1}.ace-loader-mask{position:relative}.ace-loader-mask:after{content:\"\";width:100%;height:100%;position:absolute;animation-duration:1s;animation-name:loaderAnimation;animation-iteration-count:infinite;animation-direction:alternate;left:0}@keyframes loaderAnimation{0%{background-color:var(--ace-c-primary-gray);opacity:1}to{background-color:#fcfcfc}}.ace-scroll::-webkit-scrollbar{height:8px;width:8px}.ace-scroll::-webkit-scrollbar-track{border-radius:8px;background-color:#ddd;background-clip:content-box}.ace-scroll::-webkit-scrollbar-thumb{border-radius:8px;background-color:var(--ace-c-text-black)}.ace-scroll::-webkit-scrollbar-thumb:window-inactive{border-radius:8px;background-color:var(--ace-c-text-black)}.ace-table-icon--check{width:12px;height:12px}.ace-table-icon--action{width:17px;height:17px;cursor:pointer}.ace-section-icon{color:var(--ace-c-section-primary);fill:var(--ace-c-section-primary);width:24px;height:24px}.ace-row{display:flex;flex-direction:row;justify-self:center;align-self:center;align-content:center;flex-wrap:wrap}.ace-grid,.ace-row{gap:var(--ace-gutter)}.ace-grid{display:grid;grid-template-columns:repeat(12,minmax(0,1fr))}.ace-grid-hide{display:none}.ace-grid-show{display:block}.ace-grid-span-1{grid-column:auto/span 1}.ace-grid-span-2{grid-column:auto/span 2}.ace-grid-span-3{grid-column:auto/span 3}.ace-grid-span-4{grid-column:auto/span 4}.ace-grid-span-5{grid-column:auto/span 5}.ace-grid-span-6{grid-column:auto/span 6}.ace-grid-span-7{grid-column:auto/span 7}.ace-grid-span-8{grid-column:auto/span 8}.ace-grid-span-9{grid-column:auto/span 9}.ace-grid-span-10{grid-column:auto/span 10}.ace-grid-span-11{grid-column:auto/span 11}.ace-grid-span-12{grid-column:auto/span 12}@media (max-width:1500px){.ace-grid-hide-lg{display:none}.ace-grid-show-lg{display:block}.ace-grid-span-lg-1{grid-column:auto/span 1}.ace-grid-span-lg-2{grid-column:auto/span 2}.ace-grid-span-lg-3{grid-column:auto/span 3}.ace-grid-span-lg-4{grid-column:auto/span 4}.ace-grid-span-lg-5{grid-column:auto/span 5}.ace-grid-span-lg-6{grid-column:auto/span 6}.ace-grid-span-lg-7{grid-column:auto/span 7}.ace-grid-span-lg-8{grid-column:auto/span 8}.ace-grid-span-lg-9{grid-column:auto/span 9}.ace-grid-span-lg-10{grid-column:auto/span 10}.ace-grid-span-lg-11{grid-column:auto/span 11}.ace-grid-span-lg-12{grid-column:auto/span 12}}@media (max-width:992px){.ace-grid-hide-md{display:none}.ace-grid-show-md{display:block}.ace-grid-span-md-1{grid-column:auto/span 1}.ace-grid-span-md-2{grid-column:auto/span 2}.ace-grid-span-md-3{grid-column:auto/span 3}.ace-grid-span-md-4{grid-column:auto/span 4}.ace-grid-span-md-5{grid-column:auto/span 5}.ace-grid-span-md-6{grid-column:auto/span 6}.ace-grid-span-md-7{grid-column:auto/span 7}.ace-grid-span-md-8{grid-column:auto/span 8}.ace-grid-span-md-9{grid-column:auto/span 9}.ace-grid-span-md-10{grid-column:auto/span 10}.ace-grid-span-md-11{grid-column:auto/span 11}.ace-grid-span-md-12{grid-column:auto/span 12}}@media (max-width:768px){.ace-grid-hide-sm{display:none}.ace-grid-show-sm{display:block}.ace-grid-span-sm-1{grid-column:auto/span 1}.ace-grid-span-sm-2{grid-column:auto/span 2}.ace-grid-span-sm-3{grid-column:auto/span 3}.ace-grid-span-sm-4{grid-column:auto/span 4}.ace-grid-span-sm-5{grid-column:auto/span 5}.ace-grid-span-sm-6{grid-column:auto/span 6}.ace-grid-span-sm-7{grid-column:auto/span 7}.ace-grid-span-sm-8{grid-column:auto/span 8}.ace-grid-span-sm-9{grid-column:auto/span 9}.ace-grid-span-sm-10{grid-column:auto/span 10}.ace-grid-span-sm-11{grid-column:auto/span 11}.ace-grid-span-sm-12{grid-column:auto/span 12}}@media (max-width:576px){.ace-grid-hide-xs{display:none}.ace-grid-show-xs{display:block}.ace-grid-span-xs-1{grid-column:auto/span 1}.ace-grid-span-xs-2{grid-column:auto/span 2}.ace-grid-span-xs-3{grid-column:auto/span 3}.ace-grid-span-xs-4{grid-column:auto/span 4}.ace-grid-span-xs-5{grid-column:auto/span 5}.ace-grid-span-xs-6{grid-column:auto/span 6}.ace-grid-span-xs-7{grid-column:auto/span 7}.ace-grid-span-xs-8{grid-column:auto/span 8}.ace-grid-span-xs-9{grid-column:auto/span 9}.ace-grid-span-xs-10{grid-column:auto/span 10}.ace-grid-span-xs-11{grid-column:auto/span 11}.ace-grid-span-xs-12{grid-column:auto/span 12}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 2352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--ace-c-section-primary:#9dd3ef;--ace-c-section-secondary:#e1eff7;--ace-c-section-table-highlight:#c6e6f5;--ace-c-section-table-hover:#e5edf6;--ace-c-primary-blue:#9dd3ef;--ace-c-primary-blue-light:#e1eff7;--ace-c-primary-white:#fff;--ace-c-primary-blue-gray:#e1ecee;--ace-c-primary-gray:#f4f4f4;--ace-c-secondary-yellow:#edce47;--ace-c-secondary-yellow-light:#fffcf0;--ace-c-secondary-green:#8bbb81;--ace-c-secondary-green-light:#e2eedf;--ace-c-secondary-orange:#eea971;--ace-c-secondary-orange-light:#fae7d7;--ace-c-secondary-red:#ed7050;--ace-c-secondary-red-light:#fad3c9;--ace-c-secondary-brown:#d6bba3;--ace-c-secondary-brown-light:#f4ece5;--ace-c-secondary-purple:#b38ac1;--ace-c-secondary-purple-light:#ece3ef;--ace-c-text-black:#303030;--ace-c-text-blue:#4d74a2;--ace-c-text-gray:#6c6c6c;--ace-c-status-yellow:#fcf1c3;--ace-c-status-brown:#765001;--ace-c-status-pink:#fdf0f0;--ace-c-status-red:#ce0000;--ace-c-status-mint:#defff5;--ace-c-status-green:#08826b;--ace-c-status-gray:#efefef;--ace-c-table-highlight-yellow:#fcf1c3;--ace-c-table-hover-yellow:#f4eed6;--ace-c-table-highlight-green:#b1d1ab;--ace-c-table-hover-green:#c8dfc3;--ace-c-table-highlight-orange:#fdd5b4;--ace-c-table-hover-orange:#fddccd;--ace-c-table-highlight-red:#ffaf9b;--ace-c-table-hover-red:#ffc5b5;--ace-c-table-highlight-brown:#e6d6c8;--ace-c-table-hover-brown:#f5e8df;--ace-c-table-highlight-purple:#ccbada;--ace-c-table-hover-purple:#f3edf5;--ace-c-fill:transparent}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ext-app-shell a,.ext-app-shell abbr,.ext-app-shell acronym,.ext-app-shell address,.ext-app-shell applet,.ext-app-shell article,.ext-app-shell aside,.ext-app-shell audio,.ext-app-shell b,.ext-app-shell big,.ext-app-shell blockquote,.ext-app-shell body,.ext-app-shell button,.ext-app-shell canvas,.ext-app-shell caption,.ext-app-shell center,.ext-app-shell cite,.ext-app-shell code,.ext-app-shell dd,.ext-app-shell del,.ext-app-shell details,.ext-app-shell dfn,.ext-app-shell div,.ext-app-shell dl,.ext-app-shell dt,.ext-app-shell em,.ext-app-shell embed,.ext-app-shell fieldset,.ext-app-shell figcaption,.ext-app-shell figure,.ext-app-shell footer,.ext-app-shell form,.ext-app-shell h1,.ext-app-shell h2,.ext-app-shell h3,.ext-app-shell h4,.ext-app-shell h5,.ext-app-shell h6,.ext-app-shell header,.ext-app-shell hgroup,.ext-app-shell html,.ext-app-shell i,.ext-app-shell iframe,.ext-app-shell img,.ext-app-shell ins,.ext-app-shell kbd,.ext-app-shell label,.ext-app-shell legend,.ext-app-shell li,.ext-app-shell mark,.ext-app-shell menu,.ext-app-shell nav,.ext-app-shell object,.ext-app-shell ol,.ext-app-shell output,.ext-app-shell p,.ext-app-shell pre,.ext-app-shell q,.ext-app-shell ruby,.ext-app-shell s,.ext-app-shell samp,.ext-app-shell section,.ext-app-shell small,.ext-app-shell span,.ext-app-shell strike,.ext-app-shell strong,.ext-app-shell sub,.ext-app-shell summary,.ext-app-shell sup,.ext-app-shell table,.ext-app-shell tbody,.ext-app-shell td,.ext-app-shell tfoot,.ext-app-shell th,.ext-app-shell thead,.ext-app-shell time,.ext-app-shell tr,.ext-app-shell tt,.ext-app-shell u,.ext-app-shell ul,.ext-app-shell var,.ext-app-shell video{border:0;font-size:100%;font:inherit;vertical-align:baseline;margin:0;padding:0}.ext-app-shell article,.ext-app-shell aside,.ext-app-shell details,.ext-app-shell figcaption,.ext-app-shell figure,.ext-app-shell footer,.ext-app-shell header,.ext-app-shell hgroup,.ext-app-shell menu,.ext-app-shell nav,.ext-app-shell section{display:block}.ext-app-shell body{line-height:1}.ext-app-shell ol,.ext-app-shell ul{list-style:none}.ext-app-shell blockquote,.ext-app-shell q{quotes:none}.ext-app-shell blockquote:after,.ext-app-shell blockquote:before,.ext-app-shell q:after,.ext-app-shell q:before{content:none}.ext-app-shell table{border-collapse:collapse;border-spacing:0}.ext-app-shell svg{box-sizing:content-box;vertical-align:unset;overflow:unset}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 9564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@font-face{font-family:BrixSansBlack;src:url(https://gocdnstorage.blob.core.windows.net/common/fonts/BrixSansBlack.otf) format(\"opentype\")}@font-face{font-family:BrixSansBold;src:url(https://gocdnstorage.blob.core.windows.net/common/fonts/BrixSansBold.otf) format(\"opentype\")}@font-face{font-family:BrixSansExtraLight;src:url(https://gocdnstorage.blob.core.windows.net/common/fonts/BrixSansExtraLight.otf) format(\"opentype\")}@font-face{font-family:BrixSansLight;src:url(https://gocdnstorage.blob.core.windows.net/common/fonts/BrixSansLight.otf) format(\"opentype\")}.ext-app-shell h1{font-size:24px}.ext-app-shell h1,.ext-app-shell h2{font-family:BrixSansBlack;line-height:30px}.ext-app-shell h2{font-size:20px}.ext-app-shell h6{font-family:BrixSansBlack;font-size:14px;line-height:21px}.ext-app-shell .ace-ingress,.ext-app-shell button{font-size:16px;line-height:24px}.ext-app-shell button{font-family:inherit}.ext-app-shell a{font-size:17px;line-height:27px;text-decoration:underline;cursor:pointer}.ext-app-shell label{font-size:14px;line-height:27px}.ext-app-shell{font-family:BrixSansLight;font-size:16px;line-height:27px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 4954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html body .ace-input{width:100%;height:36px;line-height:1.5;padding:0 0 0 16px;margin:0;border:1px solid var(--ace-c-text-gray);background:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-gray);border-radius:3px;font-size:18px;color:var(--ace-c-text-black);font-family:BrixSansLight;box-sizing:border-box}html body .ace-input:active{outline:none;background:var(--ace-c-primary-blue-light);box-shadow:0 0 0 1px var(--ace-c-text-black);border:1px solid var(--ace-c-text-black)}html body .ace-input:not(:active):focus{background:var(--ace-c-primary-gray);box-shadow:0 0 2 var(--ace-c-primary-blue);border:1px solid var(--ace-c-text-blue);outline:none}html body .ace-input-wrapper{display:flex;align-items:center;position:relative}html body .ace-input--disabled{color:var(--ace-c-text-gray);cursor:auto;pointer-events:none}html body .ace-input--inactive{width:100%;margin:0;padding-left:16px;font-size:18px;box-shadow:0 0 0 2px transparent;border:none;border-left:2px solid var(--ace-c-section-primary);border-radius:0;pointer-events:none;opacity:1;background:none;color:var(--ace-c-text-black);font-family:BrixSansLight}html body .ace-input--inactive:focus{background:none;border:1px solid #000;border-radius:3px}html body .ace-input--error{background:var(--ace-c-status-pink);border-color:var(--ace-c-status-pink);padding-right:28px}html body .ace-input-message--error{margin:0;border:1px solid var(--ace-c-primary-white);background:var(--ace-c-primary-white);border-radius:24px;color:var(--ace-c-status-red);font-size:var(--ace-distance-md);text-align:left;min-height:20px;padding:2px var(--ace-distance-xs);box-shadow:0 3px 6px #00000029}html body .ace-input-icon--error{width:20px;height:20px;box-sizing:content-box;position:absolute;top:8px;right:4px;color:var(--ace-c-status-red)}html body .ace-label{margin:0;margin-bottom:4px;font-family:var(--ace-font-bold);font-size:14px;line-height:21px;display:block;height:21px;position:relative}html body .ace-label--disabled{color:var(--ace-c-text-gray);height:21px}html body .ace-input-label{padding-left:16px;margin:0;margin-bottom:4px;border-left:2px solid var(--ace-c-section-primary);font-family:var(--ace-font-bold);font-size:14px;line-height:21px;display:block;height:21px;position:relative}html body .ace-input-label--disabled{color:var(--ace-c-text-gray);border-left:2px solid var(--ace-c-text-gray);height:21px}html body .ace-input-label--inactive{padding-bottom:4px;margin:0}html body .ace-input-label--single-row{margin-bottom:0;padding-left:8px;margin-right:8px;text-overflow:unset;overflow:unset}html body .ace-input--description{background:var(--ace-c-primary-white);box-shadow:0 3px 6px #00000029;border-radius:5px;padding:12px;font-size:16px;line-height:16px;z-index:9999;position:absolute;top:-8px;width:160px;right:0}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 7783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".go-apps a,.go-apps abbr,.go-apps acronym,.go-apps address,.go-apps applet,.go-apps article,.go-apps aside,.go-apps audio,.go-apps b,.go-apps big,.go-apps blockquote,.go-apps button,.go-apps canvas,.go-apps caption,.go-apps center,.go-apps cite,.go-apps code,.go-apps dd,.go-apps del,.go-apps details,.go-apps dfn,.go-apps div,.go-apps dl,.go-apps dt,.go-apps em,.go-apps embed,.go-apps fieldset,.go-apps figcaption,.go-apps figure,.go-apps footer,.go-apps form,.go-apps h1,.go-apps h2,.go-apps h3,.go-apps h4,.go-apps h5,.go-apps h6,.go-apps header,.go-apps hgroup,.go-apps i,.go-apps iframe,.go-apps img,.go-apps ins,.go-apps kbd,.go-apps label,.go-apps legend,.go-apps li,.go-apps mark,.go-apps menu,.go-apps nav,.go-apps object,.go-apps ol,.go-apps output,.go-apps p,.go-apps pre,.go-apps q,.go-apps ruby,.go-apps s,.go-apps samp,.go-apps section,.go-apps small,.go-apps span,.go-apps strike,.go-apps strong,.go-apps sub,.go-apps summary,.go-apps sup,.go-apps table,.go-apps tbody,.go-apps td,.go-apps tfoot,.go-apps th,.go-apps thead,.go-apps time,.go-apps tr,.go-apps tt,.go-apps u,.go-apps ul,.go-apps var,.go-apps video,html.go-apps,html.go-apps body{border:0;font-size:100%;font:inherit;vertical-align:baseline;margin:0;padding:0}.go-apps article,.go-apps aside,.go-apps details,.go-apps figcaption,.go-apps figure,.go-apps footer,.go-apps header,.go-apps hgroup,.go-apps menu,.go-apps nav,.go-apps section{display:block}.go-apps body{line-height:1}.go-apps ol,.go-apps ul{list-style:none}.go-apps blockquote,.go-apps q{quotes:none}.go-apps blockquote:after,.go-apps blockquote:before,.go-apps q:after,.go-apps q:before{content:none}.go-apps table{border-collapse:collapse;border-spacing:0}svg{--ace-icons-fill:none}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 1740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8081);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".go-apps h1{font-size:24px}.go-apps h1,.go-apps h2{font-family:BrixSansBlack;line-height:30px}.go-apps h2{font-size:20px}h6.go-apps{font-family:BrixSansBlack;font-size:14px;line-height:21px}.ace-ingress,.go-apps button,html.go-apps .app-shell button{font-size:16px;line-height:24px}.go-apps a{font-size:17px;line-height:27px;text-decoration:underline;cursor:pointer}.go-apps label{font-size:14px;line-height:21px}.go-apps body,html.go-apps .app-shell{font-family:BrixSansLight;font-size:16px;line-height:27px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);
// Exports
/* harmony default export */ __webpack_exports__.Z = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 3645:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 8081:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 3744:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 3172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8007);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("584908ed", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1771);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("24fb1fc0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5439);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6ad1d712", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2234);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("23a20453", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1798);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("0632dde6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7893:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4671);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("8e17ec90", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9905:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4438);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("922f02e6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5189);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("3912d22c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1456:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4050);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("942bab6c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7643:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1353);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("33870b68", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1578);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("f8cdd972", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7696);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("bdf80d84", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2413);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6040b98e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5663);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("426f1ce2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8722:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3759);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("15377ed0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2997);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("70b7e59e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3967);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("556cdbbe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3366);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("25b76e2a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6318);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6fc5e7fe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(618);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("3a50914e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6693);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("571a3bdc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5499);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("a7659a6e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4410);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("2ad99810", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3477);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("219d9e74", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8373:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5323);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("41617e4c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3976);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("227f5cf8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 5765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5267);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("5db2cc5c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4418);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("7d48d632", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1394);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("528570d7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4290);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("0489ecfa", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8009:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2158);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("0a5fd5a8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1265);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("8d0a5772", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9836);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("1769536b", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3104);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("5ddd560a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9115);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("b588ef0e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8281);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6a455f22", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4856);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6a1d90c2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 8646:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6822);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("b3f4b540", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9233);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("6f70f1f0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3178);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("a1bea102", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4390);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("e174fcf0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3484:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1690);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("ef4772ca", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4265);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("67b94c81", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(144);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("3e6086fe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9054);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("811e5f4e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(877);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("407a7d2e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 581:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7229);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("17968ce2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("f29261b8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2712);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("0268e601", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7089);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("53c2c779", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5846);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("488aa91f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6008);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("23ccf702", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 2476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3726);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("08d9357c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7332);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("1c8d7598", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 7915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6221);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("199b736e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 9194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3552);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("2dcb9f81", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("967976a6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 6238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4268);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("4a06f19e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 1462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(945);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("3058c1de", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4985);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("61d4943e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 3724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(6915);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(4402)/* ["default"] */ .Z)
var update = add("0b185017", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 4402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: function() { return /* binding */ addStylesClient; }
});

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ActionsMolecule: function() { return /* reexport */ ActionsMolecule; },
  AdvModalAtom: function() { return /* reexport */ AdvModalAtom; },
  AppShell: function() { return /* reexport */ AppShell; },
  AutoCompleteAtom: function() { return /* reexport */ AutoCompleteAtom; },
  BoxAtom: function() { return /* reexport */ BoxAtom; },
  ButtonAtom: function() { return /* reexport */ ButtonAtom; },
  CheckAtom: function() { return /* reexport */ CheckAtom; },
  CheckMolecule: function() { return /* reexport */ CheckMolecule; },
  ContainerAtom: function() { return /* reexport */ ContainerAtom; },
  DateFilterAtom: function() { return /* reexport */ DateFilterAtom; },
  DateInputAtom: function() { return /* reexport */ atoms_DateInputAtom; },
  DialogAtom: function() { return /* reexport */ DialogAtom; },
  DropdownAtom: function() { return /* reexport */ DropdownAtom; },
  ExpandAtom: function() { return /* reexport */ ExpandAtom; },
  ExportMolecule: function() { return /* reexport */ ExportMolecule; },
  ExtAppShell: function() { return /* reexport */ ExtAppShell; },
  FooterMolecule: function() { return /* reexport */ FooterMolecule; },
  HcpInputAtom: function() { return /* reexport */ HcpInputAtom; },
  HeaderAtom: function() { return /* reexport */ HeaderAtom; },
  HeaderMolecule: function() { return /* reexport */ HeaderMolecule; },
  InformationMolecule: function() { return /* reexport */ InformationMolecule; },
  LoaderAtom: function() { return /* reexport */ LoaderAtom; },
  ModalAtom: function() { return /* reexport */ ModalAtom; },
  NestedAppMolecule: function() { return /* reexport */ NestedAppMolecule; },
  NotificationAtom: function() { return /* reexport */ NotificationAtom; },
  NumberInputAtom: function() { return /* reexport */ NumberInputAtom; },
  PaginationAtom: function() { return /* reexport */ PaginationAtom; },
  PhoneInputAtom: function() { return /* reexport */ atoms_PhoneInputAtom; },
  PostalInformationMolecule: function() { return /* reexport */ PostalInformationMolecule; },
  PriceFilterAtom: function() { return /* reexport */ PriceFilterAtom; },
  ProfileBarAtom: function() { return /* reexport */ atoms_namespaceObject.ProfileBarAtom; },
  ProgressBarAtom: function() { return /* reexport */ ProgressBarAtom; },
  ProgressCircleAtom: function() { return /* reexport */ ProgressCircleAtom; },
  RadioAtom: function() { return /* reexport */ RadioAtom; },
  RadioMolecule: function() { return /* reexport */ RadioMolecule; },
  SearchAtom: function() { return /* reexport */ SearchAtom; },
  SearchableDropdownAtom: function() { return /* reexport */ atoms_SearchableDropdownAtom; },
  SectionAtom: function() { return /* reexport */ SectionAtom; },
  StepsAtom: function() { return /* reexport */ atoms_StepsAtom; },
  StickyFooterAtom: function() { return /* reexport */ StickyFooterAtom; },
  TabAtom: function() { return /* reexport */ TabAtom; },
  TabMolecule: function() { return /* reexport */ TabMolecule; },
  TableAtom: function() { return /* reexport */ atoms_TableAtom; },
  TableWrapperAtom: function() { return /* reexport */ TableWrapperAtom; },
  TextAreaAtom: function() { return /* reexport */ TextAreaAtom; },
  TextAtom: function() { return /* reexport */ TextAtom; },
  TextEditorMolecule: function() { return /* reexport */ molecules_TextEditorMolecule; },
  TextInputAtom: function() { return /* reexport */ TextInputAtom; },
  TimeInputAtom: function() { return /* reexport */ TimeInputAtom; },
  TimePickerAtom: function() { return /* reexport */ TimePickerAtom; },
  ToggleAtom: function() { return /* reexport */ ToggleAtom; },
  UnsavedChangesMolecule: function() { return /* reexport */ UnsavedChangesMolecule; },
  ValidationAtom: function() { return /* reexport */ ValidationAtom; },
  directives: function() { return /* reexport */ directives; },
  helpers: function() { return /* reexport */ helpers; },
  mixins: function() { return /* reexport */ mixins; }
});

// NAMESPACE OBJECT: ./src/components/atoms/index.js
var atoms_namespaceObject = {};
__webpack_require__.r(atoms_namespaceObject);
__webpack_require__.d(atoms_namespaceObject, {
  ck: function() { return AdvModalAtom; },
  WZ: function() { return AutoCompleteAtom; },
  Qc: function() { return BoxAtom; },
  mL: function() { return ButtonAtom; },
  of: function() { return CheckAtom; },
  U9: function() { return ContainerAtom; },
  pj: function() { return DateFilterAtom; },
  iP: function() { return atoms_DateInputAtom; },
  JS: function() { return DialogAtom; },
  $Q: function() { return DropdownAtom; },
  mY: function() { return ExpandAtom; },
  yY: function() { return HcpInputAtom; },
  Kl: function() { return HeaderAtom; },
  xE: function() { return LoaderAtom; },
  Ax: function() { return ModalAtom; },
  jY: function() { return NotificationAtom; },
  nk: function() { return NumberInputAtom; },
  gy: function() { return PaginationAtom; },
  g5: function() { return atoms_PhoneInputAtom; },
  jk: function() { return PriceFilterAtom; },
  yF: function() { return ProgressBarAtom; },
  vK: function() { return ProgressCircleAtom; },
  tm: function() { return RadioAtom; },
  ZD: function() { return SearchAtom; },
  CV: function() { return atoms_SearchableDropdownAtom; },
  rp: function() { return SectionAtom; },
  jV: function() { return atoms_StepsAtom; },
  fw: function() { return StickyFooterAtom; },
  yb: function() { return TabAtom; },
  rU: function() { return atoms_TableAtom; },
  tg: function() { return TableWrapperAtom; },
  Rb: function() { return TextAreaAtom; },
  Ce: function() { return TextAtom; },
  UN: function() { return TextInputAtom; },
  nD: function() { return TimeInputAtom; },
  WO: function() { return TimePickerAtom; },
  f1: function() { return ToggleAtom; },
  Cr: function() { return ValidationAtom; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/text-mask-core/src/constants.js
const constants_placeholderChar = '_'
const strFunction = 'function'

;// CONCATENATED MODULE: ./node_modules/text-mask-core/src/utilities.js


const emptyArray = []

function convertMaskToPlaceholder(mask = emptyArray, placeholderChar = constants_placeholderChar) {
  if (!isArray(mask)) {
    throw new Error(
      'Text-mask:convertMaskToPlaceholder; The mask property must be an array.'
    )
  }

  if (mask.indexOf(placeholderChar) !== -1) {
    throw new Error(
      'Placeholder character must not be used as part of the mask. Please specify a character ' +
      'that is not present in your mask as your placeholder character.\n\n' +
      `The placeholder character that was received is: ${JSON.stringify(placeholderChar)}\n\n` +
      `The mask that was received is: ${JSON.stringify(mask)}`
    )
  }

  return mask.map((char) => {
    return (char instanceof RegExp) ? placeholderChar : char
  }).join('')
}

function isArray(value) {
  return (Array.isArray && Array.isArray(value)) || value instanceof Array
}

function isString(value) {
  return typeof value === 'string' || value instanceof String
}

function isNumber(value) {
  return typeof value === 'number' && value.length === undefined && !isNaN(value)
}

function isNil(value) {
  return typeof value === 'undefined' || value === null
}

const strCaretTrap = '[]'
function processCaretTraps(mask) {
  const indexes = []

  let indexOfCaretTrap
  while(indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) { // eslint-disable-line
    indexes.push(indexOfCaretTrap)

    mask.splice(indexOfCaretTrap, 1)
  }

  return {maskWithoutCaretTraps: mask, indexes}
}

;// CONCATENATED MODULE: ./node_modules/text-mask-core/src/conformToMask.js



const conformToMask_emptyArray = []
const emptyString = ''

function conformToMask(rawValue = emptyString, mask = conformToMask_emptyArray, config = {}) {
  if (!isArray(mask)) {
    // If someone passes a function as the mask property, we should call the
    // function to get the mask array - Normally this is handled by the
    // `createTextMaskInputElement:update` function - this allows mask functions
    // to be used directly with `conformToMask`
    if (typeof mask === strFunction) {
      // call the mask function to get the mask array
      mask = mask(rawValue, config)

      // mask functions can setup caret traps to have some control over how the caret moves. We need to process
      // the mask for any caret traps. `processCaretTraps` will remove the caret traps from the mask
      mask = processCaretTraps(mask).maskWithoutCaretTraps
    } else {
      throw new Error(
        'Text-mask:conformToMask; The mask property must be an array.'
      )
    }
  }

  // These configurations tell us how to conform the mask
  const {
    guide = true,
    previousConformedValue = emptyString,
    placeholderChar = constants_placeholderChar,
    placeholder = convertMaskToPlaceholder(mask, placeholderChar),
    currentCaretPosition,
    keepCharPositions
  } = config

  // The configs below indicate that the user wants the algorithm to work in *no guide* mode
  const suppressGuide = guide === false && previousConformedValue !== undefined

  // Calculate lengths once for performance
  const rawValueLength = rawValue.length
  const previousConformedValueLength = previousConformedValue.length
  const placeholderLength = placeholder.length
  const maskLength = mask.length

  // This tells us the number of edited characters and the direction in which they were edited (+/-)
  const editDistance = rawValueLength - previousConformedValueLength

  // In *no guide* mode, we need to know if the user is trying to add a character or not
  const isAddition = editDistance > 0

  // Tells us the index of the first change. For (438) 394-4938 to (38) 394-4938, that would be 1
  const indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0)

  // We're also gonna need the index of last change, which we can derive as follows...
  const indexOfLastChange = indexOfFirstChange + Math.abs(editDistance)

  // If `conformToMask` is configured to keep character positions, that is, for mask 111, previous value
  // _2_ and raw value 3_2_, the new conformed value should be 32_, not 3_2 (default behavior). That's in the case of
  // addition. And in the case of deletion, previous value _23, raw value _3, the new conformed string should be
  // __3, not _3_ (default behavior)
  //
  // The next block of logic handles keeping character positions for the case of deletion. (Keeping
  // character positions for the case of addition is further down since it is handled differently.)
  // To do this, we want to compensate for all characters that were deleted
  if (keepCharPositions === true && !isAddition) {
    // We will be storing the new placeholder characters in this variable.
    let compensatingPlaceholderChars = emptyString

    // For every character that was deleted from a placeholder position, we add a placeholder char
    for (let i = indexOfFirstChange; i < indexOfLastChange; i++) {
      if (placeholder[i] === placeholderChar) {
        compensatingPlaceholderChars += placeholderChar
      }
    }

    // Now we trick our algorithm by modifying the raw value to make it contain additional placeholder characters
    // That way when the we start laying the characters again on the mask, it will keep the non-deleted characters
    // in their positions.
    rawValue = (
      rawValue.slice(0, indexOfFirstChange) +
      compensatingPlaceholderChars +
      rawValue.slice(indexOfFirstChange, rawValueLength)
    )
  }

  // Convert `rawValue` string to an array, and mark characters based on whether they are newly added or have
  // existed in the previous conformed value. Identifying new and old characters is needed for `conformToMask`
  // to work if it is configured to keep character positions.
  const rawValueArr = rawValue
    .split(emptyString)
    .map((char, i) => ({char, isNew: i >= indexOfFirstChange && i < indexOfLastChange}))

  // The loop below removes masking characters from user input. For example, for mask
  // `00 (111)`, the placeholder would be `00 (___)`. If user input is `00 (234)`, the loop below
  // would remove all characters but `234` from the `rawValueArr`. The rest of the algorithm
  // then would lay `234` on top of the available placeholder positions in the mask.
  for (let i = rawValueLength - 1; i >= 0; i--) {
    const {char} = rawValueArr[i]

    if (char !== placeholderChar) {
      const shouldOffset = i >= indexOfFirstChange && previousConformedValueLength === maskLength

      if (char === placeholder[(shouldOffset) ? i - editDistance : i]) {
        rawValueArr.splice(i, 1)
      }
    }
  }

  // This is the variable that we will be filling with characters as we figure them out
  // in the algorithm below
  let conformedValue = emptyString
  let someCharsRejected = false

  // Ok, so first we loop through the placeholder looking for placeholder characters to fill up.
  placeholderLoop: for (let i = 0; i < placeholderLength; i++) {
    const charInPlaceholder = placeholder[i]

    // We see one. Let's find out what we can put in it.
    if (charInPlaceholder === placeholderChar) {
      // But before that, do we actually have any user characters that need a place?
      if (rawValueArr.length > 0) {
        // We will keep chipping away at user input until either we run out of characters
        // or we find at least one character that we can map.
        while (rawValueArr.length > 0) {
          // Let's retrieve the first user character in the queue of characters we have left
          const {char: rawValueChar, isNew} = rawValueArr.shift()

          // If the character we got from the user input is a placeholder character (which happens
          // regularly because user input could be something like (540) 90_-____, which includes
          // a bunch of `_` which are placeholder characters) and we are not in *no guide* mode,
          // then we map this placeholder character to the current spot in the placeholder
          if (rawValueChar === placeholderChar && suppressGuide !== true) {
            conformedValue += placeholderChar

            // And we go to find the next placeholder character that needs filling
            continue placeholderLoop

          // Else if, the character we got from the user input is not a placeholder, let's see
          // if the current position in the mask can accept it.
          } else if (mask[i].test(rawValueChar)) {
            // we map the character differently based on whether we are keeping character positions or not.
            // If any of the conditions below are met, we simply map the raw value character to the
            // placeholder position.
            if (
              keepCharPositions !== true ||
              isNew === false ||
              previousConformedValue === emptyString ||
              guide === false ||
              !isAddition
            ) {
              conformedValue += rawValueChar
            } else {
              // We enter this block of code if we are trying to keep character positions and none of the conditions
              // above is met. In this case, we need to see if there's an available spot for the raw value character
              // to be mapped to. If we couldn't find a spot, we will discard the character.
              //
              // For example, for mask `1111`, previous conformed value `_2__`, raw value `942_2__`. We can map the
              // `9`, to the first available placeholder position, but then, there are no more spots available for the
              // `4` and `2`. So, we discard them and end up with a conformed value of `92__`.
              const rawValueArrLength = rawValueArr.length
              let indexOfNextAvailablePlaceholderChar = null

              // Let's loop through the remaining raw value characters. We are looking for either a suitable spot, ie,
              // a placeholder character or a non-suitable spot, ie, a non-placeholder character that is not new.
              // If we see a suitable spot first, we store its position and exit the loop. If we see a non-suitable
              // spot first, we exit the loop and our `indexOfNextAvailablePlaceholderChar` will stay as `null`.
              for (let i = 0; i < rawValueArrLength; i++) {
                const charData = rawValueArr[i]

                if (charData.char !== placeholderChar && charData.isNew === false) {
                  break
                }

                if (charData.char === placeholderChar) {
                  indexOfNextAvailablePlaceholderChar = i
                  break
                }
              }

              // If `indexOfNextAvailablePlaceholderChar` is not `null`, that means the character is not blocked.
              // We can map it. And to keep the character positions, we remove the placeholder character
              // from the remaining characters
              if (indexOfNextAvailablePlaceholderChar !== null) {
                conformedValue += rawValueChar
                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1)

              // If `indexOfNextAvailablePlaceholderChar` is `null`, that means the character is blocked. We have to
              // discard it.
              } else {
                i--
              }
            }

            // Since we've mapped this placeholder position. We move on to the next one.
            continue placeholderLoop
          } else {
            someCharsRejected = true
          }
        }
      }

      // We reach this point when we've mapped all the user input characters to placeholder
      // positions in the mask. In *guide* mode, we append the left over characters in the
      // placeholder to the `conformedString`, but in *no guide* mode, we don't wanna do that.
      //
      // That is, for mask `(111)` and user input `2`, we want to return `(2`, not `(2__)`.
      if (suppressGuide === false) {
        conformedValue += placeholder.substr(i, placeholderLength)
      }

      // And we break
      break

    // Else, the charInPlaceholder is not a placeholderChar. That is, we cannot fill it
    // with user input. So we just map it to the final output
    } else {
      conformedValue += charInPlaceholder
    }
  }

  // The following logic is needed to deal with the case of deletion in *no guide* mode.
  //
  // Consider the silly mask `(111) /// 1`. What if user tries to delete the last placeholder
  // position? Something like `(589) /// `. We want to conform that to `(589`. Not `(589) /// `.
  // That's why the logic below finds the last filled placeholder character, and removes everything
  // from that point on.
  if (suppressGuide && isAddition === false) {
    let indexOfLastFilledPlaceholderChar = null

    // Find the last filled placeholder position and substring from there
    for (let i = 0; i < conformedValue.length; i++) {
      if (placeholder[i] === placeholderChar) {
        indexOfLastFilledPlaceholderChar = i
      }
    }

    if (indexOfLastFilledPlaceholderChar !== null) {
      // We substring from the beginning until the position after the last filled placeholder char.
      conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1)
    } else {
      // If we couldn't find `indexOfLastFilledPlaceholderChar` that means the user deleted
      // the first character in the mask. So we return an empty string.
      conformedValue = emptyString
    }
  }

  return {conformedValue, meta: {someCharsRejected}}
}

;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/constants.js
/**
 * A special object to identify next character as optional
 * For example `?`
 *
 * @type {Object}
 */
const NEXT_CHAR_OPTIONAL = {
  __nextCharOptional__: true
};

/**
 * @type {MaskReplaces}
 */
const defaultMaskReplacers = {
  '#': /\d/,
  A: /[a-z]/i,
  N: /[a-z0-9]/i,
  '?': NEXT_CHAR_OPTIONAL,
  X: /./
};
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/utils/regexp.js
/**
 * @example
 * '/abc/g' -> /abc/g
 * @param {string} str - stringified regexp
 * @return {RegExp} - real regexp
 */
const stringToRegexp = str => {
  const lastSlash = str.lastIndexOf('/');
  return new RegExp(str.slice(1, lastSlash), str.slice(lastSlash + 1));
};

/**
 * Makes single-char regular express optional
 * @example
 * /\d/ -> /\d?/
 * @param {RegExp} charRegexp
 * @return {RegExp}
 */
const makeRegexpOptional = charRegexp => stringToRegexp(charRegexp.toString().replace(/.(\/)[gmiyus]{0,6}$/, match => match.replace('/', '?/')));

/**
 * @param {string} char
 * @return {string}
 */
const escapeIfNeeded = char => '[\\^$.|?*+()'.indexOf(char) > -1 ? `\\${char}` : char;

/**
 * Wraps static character to RegExp
 * @param {string} char
 * @return {RegExp}
 */
const charRegexp = char => new RegExp(`/[${escapeIfNeeded(char)}]/`);

/**
 * Determines if value is regular expression
 * @param {string|RegExp} entity
 * @return {boolean}
 */
const isRegexp = entity => entity instanceof RegExp;

/**
 * @param {string|RegExp} char
 * @return {RegExp}
 */
const castToRegexp = char => isRegexp(char) ? char : charRegexp(char);
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/utils/maskToRegExpMask.js



/**
 * @param {string[]} mask
 * @param {MaskReplaces} maskReplacers
 * @returns {RegExp[]}
 */
function maskToRegExpMask(mask, maskReplacers = defaultMaskReplacers) {
  return mask.map((char, index, array) => {
    const maskChar = maskReplacers[char] || char;
    const previousChar = array[index - 1];
    const previousMaskChar = maskReplacers[previousChar] || previousChar;
    if (maskChar === NEXT_CHAR_OPTIONAL) {
      return null;
    }
    if (previousMaskChar === NEXT_CHAR_OPTIONAL) {
      return makeRegexpOptional(castToRegexp(maskChar));
    }
    return maskChar;
  }).filter(Boolean);
}

/**
 * Converts mask from `v-mask` string format to `text-mask-core` format
 * @param {string} stringMask
 * @param {MaskReplaces} maskReplacers
 * @return {RegExp[]}
 */
function stringMaskToRegExpMask(stringMask, maskReplacers = defaultMaskReplacers) {
  return maskToRegExpMask(stringMask.split(''), maskReplacers);
}

/**
 * Converts mask from `v-mask` array format to `text-mask-core` format
 * @param {Array.<string|RegExp>} arrayMask
 * @param {MaskReplaces} maskReplacers
 * @return {RegExp[]}
 */
function arrayMaskToRegExpMask(arrayMask, maskReplacers = defaultMaskReplacers) {
  const flattenedMask = arrayMask.map(part => {
    if (part instanceof RegExp) {
      return part;
    }
    if (typeof part === 'string') {
      return part.split('');
    }
    return null;
  }).filter(Boolean).reduce((mask, part) => mask.concat(part), []);
  return maskToRegExpMask(flattenedMask, maskReplacers);
}
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/utils/index.js
/**
 * Notifies Vue about internal value change
 * @see https://github.com/vuejs/Discussion/issues/157#issuecomment-273301588
 *
 * @param {HTMLInputElement} el
 * @param {string}           type
 */
const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

/**
 * Extracts first input element inside given html element (if any)
 * @param {HTMLElement} el
 * @returns {HTMLElement|HTMLInputElement}
 */
const queryInputElementInside = el => el instanceof HTMLInputElement ? el : el.querySelector('input') || el;

/**
 * Determines whether the passed value is a function
 * @param {*} val
 * @returns {boolean}
 */
const isFunction = val => typeof val === 'function';

/**
 * Determines whether the passed value is a string
 * @param {*} val
 * @returns {boolean}
 */
const utils_isString = val => typeof val === 'string';

/**
 * Determines whether the passed value is a string
 * @param {*} val
 * @returns {boolean}
 */
const utils_isRegexp = val => val instanceof RegExp;
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/utils/parseMask.js



/**
 * @param {(string|RegExp)[]|Function|string} inputMask
 * @param maskReplacers
 * @returns {RegExp[]|*}
 */
function parseMask(inputMask, maskReplacers) {
  if (Array.isArray(inputMask)) {
    return arrayMaskToRegExpMask(inputMask, maskReplacers);
  }
  if (isFunction(inputMask)) {
    return inputMask;
  }
  if (utils_isString(inputMask) && inputMask.length > 0) {
    return stringMaskToRegExpMask(inputMask, maskReplacers);
  }
  return inputMask;
}
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/createOptions.js
function createOptions() {
  const elementOptions = new Map();
  const defaultOptions = {
    previousValue: '',
    mask: []
  };
  function get(el) {
    return elementOptions.get(el) || {
      ...defaultOptions
    };
  }
  function partiallyUpdate(el, newOptions) {
    elementOptions.set(el, {
      ...get(el),
      ...newOptions
    });
  }
  function remove(el) {
    elementOptions.delete(el);
  }
  return {
    partiallyUpdate,
    remove,
    get
  };
}
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/utils/extendMaskReplacers.js


/**
 * Merge custom mask replacers with default mask replacers
 * @param {MaskReplaces} maskReplacers
 * @param {MaskReplaces} baseMaskReplacers
 * @return {MaskReplaces} The extended mask replacers
 */
function extendMaskReplacers(maskReplacers, baseMaskReplacers = defaultMaskReplacers) {
  if (maskReplacers === null || Array.isArray(maskReplacers) || typeof maskReplacers !== 'object') {
    return baseMaskReplacers;
  }
  return Object.keys(maskReplacers).reduce((extendedMaskReplacers, key) => {
    const value = maskReplacers[key];
    if (value !== null && !(value instanceof RegExp)) {
      return extendedMaskReplacers;
    }
    return {
      ...extendedMaskReplacers,
      [key]: value
    };
  }, baseMaskReplacers);
}
/* harmony default export */ var utils_extendMaskReplacers = (extendMaskReplacers);
;// CONCATENATED MODULE: ./src/components/utilities/directives/mask/directive.js
/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies





const options = createOptions();
function triggerInputUpdate(el) {
  trigger(el, 'input');
}
function updateValue(el, force = false) {
  const {
    value
  } = el;
  const {
    previousValue,
    mask
  } = options.get(el);
  const isValueChanged = value !== previousValue;
  const isLengthIncreased = value.length > previousValue.length;
  const isUpdateNeeded = value && isValueChanged && isLengthIncreased;
  if ((force || isUpdateNeeded) && mask) {
    const {
      conformedValue
    } = conformToMask(value, mask, {
      guide: false
    });
    el.value = conformedValue;
    triggerInputUpdate(el);
  }
  options.partiallyUpdate(el, {
    previousValue: value
  });
}
function updateMask(el, inputMask, maskReplacers) {
  const mask = parseMask(inputMask, maskReplacers);
  options.partiallyUpdate(el, {
    mask
  });
}
function maskToString(mask) {
  const maskArray = Array.isArray(mask) ? mask : [mask];
  const filteredMaskArray = maskArray.filter(part => utils_isString(part) || utils_isRegexp(part));
  return filteredMaskArray.toString();
}
function createDirective(directiveOptions = {}) {
  const instanceMaskReplacers = utils_extendMaskReplacers(directiveOptions && directiveOptions.placeholders);
  return {
    mounted(el, {
      value
    }) {
      el = queryInputElementInside(el);
      updateMask(el, value, instanceMaskReplacers);
      updateValue(el);
    },
    updated(el, {
      value,
      oldValue
    }) {
      el = queryInputElementInside(el);
      const isMaskChanged = isFunction(value) || maskToString(oldValue) !== maskToString(value);
      if (isMaskChanged) {
        updateMask(el, value, instanceMaskReplacers);
      }
      updateValue(el, isMaskChanged);
    },
    unmounted(el) {
      el = queryInputElementInside(el);
      options.remove(el);
    }
  };
}
/* harmony default export */ var directive = (createDirective());
;// CONCATENATED MODULE: ./src/components/utilities/directives/anchor.js
/* harmony default export */ var directives_anchor = ({
  mounted(el, binding) {
    el.dataset.anchor = binding.value;
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/directives/inlinemanual.js
/* harmony default export */ var inlinemanual = ({
  mounted(el, binding) {
    if (window.InlineManual) {
      window.InlineManual('update');
    }
    el.dataset.inlinemanualtag = binding.value;
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/directives/clickoutside.js
/* harmony default export */ var clickoutside = ({
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/directives.js




/* harmony default export */ var directives = ({
  install(vue) {
    vue.directive('anchor', directives_anchor);
    vue.directive('inlinemanual', inlinemanual);
    vue.directive('clickoutside', clickoutside);
    vue.directive('mask', directive);
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/mixins.js
const screenWidth = {
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    $screenWidth() {
      return this.screenWidth;
    }
  },
  mounted() {
    window.addEventListener('resize', this.debouncedUpdateScreenWidth);
    this.updateScreenWidth();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.debouncedUpdateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    debounce(func, wait) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    },
    debouncedUpdateScreenWidth() {
      this.debounce(this.updateScreenWidth, 1000)();
    }
  }
};
/* harmony default export */ var mixins = ({
  install(vue) {
    vue.mixin(screenWidth);
  }
});
;// CONCATENATED MODULE: external "moment"
var external_moment_namespaceObject = require("moment");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_namespaceObject);
;// CONCATENATED MODULE: ./src/components/utilities/helpers.js

const formatPrice = value => {
  if (value === null || value === undefined) {
    return '';
  }
  let round = value.toFixed(2);
  let formated = round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  return formated.replace('.', ',').replace(',00', '');
};
const formatDate = value => {
  if (!value) {
    return value;
  }
  return external_moment_default()(value).format('YYYY-MM-DD');
};
/* harmony default export */ var helpers = ({
  formatPrice: formatPrice,
  formatDate: formatDate
});
;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ButtonAtom.vue?vue&type=template&id=4011c801&scoped=true

const _withScopeId = n => (_pushScopeId("data-v-4011c801"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["title"];
function ButtonAtomvue_type_template_id_4011c801_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("button", {
    ref: "button",
    class: (0,external_vue_namespaceObject.normalizeClass)(["button-atom", $options.getClass]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClick && $options.onClick(...args)),
    title: $options.calculatedTooltip
  }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.label), 1)], true)], 10, _hoisted_1);
}
;// CONCATENATED MODULE: ./src/components/atoms/ButtonAtom.vue?vue&type=template&id=4011c801&scoped=true

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(7658);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ButtonAtom.vue?vue&type=script&lang=js

/* harmony default export */ var ButtonAtomvue_type_script_lang_js = ({
  name: 'ButtonAtom',
  props: {
    type: {
      type: String,
      validator: val => {
        return ['primary', 'secondary', 'icon', 'icon-secondary', 'icon-action', 'action', 'link'].includes(val);
      },
      default: 'primary'
    },
    disabled: Boolean,
    label: String,
    invalid: Boolean,
    tooltip: String,
    truncated: Boolean
  },
  data() {
    return {
      firstSvg: false,
      lastSvg: false
    };
  },
  computed: {
    calculatedTooltip() {
      if (this.tooltip) {
        return this.tooltip;
      }
      if (this.truncated) {
        return this.label;
      }
      return undefined;
    },
    getClass: function () {
      var classes = [];
      classes.push('button-atom--' + this.type);
      if (this.disabled) classes.push('button-atom--disabled');
      if (this.invalid) classes.push('button-atom--invalid');
      if (this.firstSvg) classes.push('button-atom--has-svg-first');
      if (this.lastSvg) classes.push('button-atom--has-svg-last');
      if (this.truncated) classes.push('button-atom--truncated');
      return classes.join(' ');
    }
  },
  emits: ['click'],
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
    checkForSvg() {
      this.firstSvg = false;
      this.lastSvg = false;
      let defaultSlot = this.$slots.default;
      if (!defaultSlot) {
        return;
      }
      let slots = this.$slots.default();
      let numberOfSlots = slots.length;
      if (numberOfSlots > 1) {
        for (let i = 0; i < numberOfSlots; i++) {
          if (slots[i].type === 'svg') {
            if (i === 0) {
              this.firstSvg = true;
            } else if (i === numberOfSlots - 1) {
              this.lastSvg = true;
            }
          }
        }
      }
    }
  },
  mounted() {
    this.checkForSvg();
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ButtonAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ButtonAtom.vue?vue&type=style&index=0&id=4011c801&scoped=true&lang=css
var ButtonAtomvue_type_style_index_0_id_4011c801_scoped_true_lang_css = __webpack_require__(6331);
;// CONCATENATED MODULE: ./src/components/atoms/ButtonAtom.vue?vue&type=style&index=0&id=4011c801&scoped=true&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/components/atoms/ButtonAtom.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ButtonAtomvue_type_script_lang_js, [['render',ButtonAtomvue_type_template_id_4011c801_scoped_true_render],['__scopeId',"data-v-4011c801"]])

/* harmony default export */ var ButtonAtom = (__exports__);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ExpandAtom.vue?vue&type=template&id=e07e445c&scoped=true

const ExpandAtomvue_type_template_id_e07e445c_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-e07e445c"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ExpandAtomvue_type_template_id_e07e445c_scoped_true_hoisted_1 = {
  class: "expand-atom"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = /*#__PURE__*/ExpandAtomvue_type_template_id_e07e445c_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 0
};
function ExpandAtomvue_type_template_id_e07e445c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ExpandAtomvue_type_template_id_e07e445c_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("label", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["expand-atom__label", {
      'expand-atom__label--active': $options.isActive
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onLabelClick && $options.onLabelClick(...args))
  }, [!$options.isActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", _hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.isActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", _hoisted_3, (0,external_vue_namespaceObject.toDisplayString)($props.labelActive), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["expand-atom__label__icon", {
      'expand-atom__label__icon--active': $options.isActive
    }])
  }, _hoisted_5, 2))], 2), $options.isActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", _hoisted_6, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/ExpandAtom.vue?vue&type=template&id=e07e445c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ExpandAtom.vue?vue&type=script&lang=js
/* harmony default export */ var ExpandAtomvue_type_script_lang_js = ({
  name: 'ExpandAtom',
  props: {
    label: {
      type: String,
      default: 'Visa mer'
    },
    labelActive: {
      type: String,
      default: 'Visa mindre'
    },
    active: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    return {
      innerActive: false
    };
  },
  computed: {
    isActive() {
      if (this.active !== undefined) {
        return this.active;
      }
      return this.innerActive;
    }
  },
  emits: ['input'],
  methods: {
    onLabelClick() {
      if (this.active !== undefined) {
        this.$emit('input', !this.active);
      } else {
        this.innerActive = !this.innerActive;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ExpandAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ExpandAtom.vue?vue&type=style&index=0&id=e07e445c&scoped=true&lang=css
var ExpandAtomvue_type_style_index_0_id_e07e445c_scoped_true_lang_css = __webpack_require__(6901);
;// CONCATENATED MODULE: ./src/components/atoms/ExpandAtom.vue?vue&type=style&index=0&id=e07e445c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ExpandAtom.vue




;


const ExpandAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExpandAtomvue_type_script_lang_js, [['render',ExpandAtomvue_type_template_id_e07e445c_scoped_true_render],['__scopeId',"data-v-e07e445c"]])

/* harmony default export */ var ExpandAtom = (ExpandAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/CheckAtom.vue?vue&type=template&id=bd366528&scoped=true

const CheckAtomvue_type_template_id_bd366528_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-bd366528"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_1 = {
  class: "check-atom__wrapper"
};
const CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_2 = /*#__PURE__*/CheckAtomvue_type_template_id_bd366528_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#check-mark-secondary"
}, null, -1));
const CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_3 = [CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_2];
function CheckAtomvue_type_template_id_bd366528_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    onClick: _cache[0] || (_cache[0] = (0,external_vue_namespaceObject.withModifiers)((...args) => $options.onClick && $options.onClick(...args), ["stop"])),
    class: (0,external_vue_namespaceObject.normalizeClass)($options.checkAtomClasses)
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["check-atom__label", $options.labelClasses])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["check-atom__wrapper__button", $options.buttonClasses])
  }, [$props.value ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["check-atom__wrapper__button__icon", $options.iconClasses])
  }, CheckAtomvue_type_template_id_bd366528_scoped_true_hoisted_3, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $props.option ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["check-atom__wrapper__option", $options.optionsClasses])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.option), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/CheckAtom.vue?vue&type=template&id=bd366528&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/CheckAtom.vue?vue&type=script&lang=js
/* harmony default export */ var CheckAtomvue_type_script_lang_js = ({
  name: 'CheckAtom',
  props: {
    value: Boolean,
    disabled: Boolean,
    label: String,
    option: String
  },
  computed: {
    checkAtomClasses() {
      return {
        'check-atom--disabled': this.disabled,
        'check-atom': this.value
      };
    },
    buttonClasses() {
      return {
        'check-atom__wrapper__button--disabled': this.disabled,
        'check-atom__wrapper__button--checked': this.value
      };
    },
    iconClasses() {
      return {
        'check-atom__wrapper__button__icon--checked': this.value,
        'check-atom__wrapper__button__icon--disabled': this.disabled
      };
    },
    labelClasses() {
      return {
        'check-atom__label--disabled': this.disabled
      };
    },
    optionsClasses() {
      return {
        'check-atom__wrapper__option--disabled': this.disabled
      };
    }
  },
  emits: ['input'],
  methods: {
    onClick() {
      this.$emit('input', !this.value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/CheckAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/CheckAtom.vue?vue&type=style&index=0&id=bd366528&scoped=true&lang=css
var CheckAtomvue_type_style_index_0_id_bd366528_scoped_true_lang_css = __webpack_require__(7611);
;// CONCATENATED MODULE: ./src/components/atoms/CheckAtom.vue?vue&type=style&index=0&id=bd366528&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/CheckAtom.vue




;


const CheckAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CheckAtomvue_type_script_lang_js, [['render',CheckAtomvue_type_template_id_bd366528_scoped_true_render],['__scopeId',"data-v-bd366528"]])

/* harmony default export */ var CheckAtom = (CheckAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ContainerAtom.vue?vue&type=template&id=1971a400&scoped=true

const ContainerAtomvue_type_template_id_1971a400_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-1971a400"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_1 = {
  key: 1,
  class: "container-atom__action-panel"
};
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_2 = {
  class: "container-atom__action-panel__header"
};
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_3 = {
  class: "container-atom__action-panel__buttons"
};
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_4 = /*#__PURE__*/ContainerAtomvue_type_template_id_1971a400_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "container-atom__action-panel__buttons--flexer"
}, null, -1));
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_5 = {
  class: "container-atom__label__header"
};
const ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_6 = {
  key: 0,
  class: "container-atom__label__header__icon"
};
const _hoisted_7 = /*#__PURE__*/ContainerAtomvue_type_template_id_1971a400_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle"
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "container-atom__content"
};
function ContainerAtomvue_type_template_id_1971a400_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["container-atom", {
      'container-atom--grid': $props.mode === 'grid'
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["container-atom__box", {
      'container-atom__box--headless': $options.isHeadless
    }])
  }, [$props.step ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: "container-atom__box__step",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.stepStyle)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.step), 5)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$options.hasNoActionPanel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", null, [(0,external_vue_namespaceObject.createElementVNode)("h2", ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.header), 1)]), (0,external_vue_namespaceObject.createElementVNode)("div", ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_3, [ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_4, (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "actionPanel", {}, undefined, true)])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["container-atom__label", {
      'container-atom__label--has-no-label': $options.hasNoLabel
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("h2", ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_5, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", ContainerAtomvue_type_template_id_1971a400_scoped_true_hoisted_6, _hoisted_8)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", _hoisted_9, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.label ? (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "label", {
    key: 2
  }, undefined, true) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])], 2), (0,external_vue_namespaceObject.createElementVNode)("div", _hoisted_10, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, undefined, true), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)])], 2)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/ContainerAtom.vue?vue&type=template&id=1971a400&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ContainerAtom.vue?vue&type=script&lang=js
/* harmony default export */ var ContainerAtomvue_type_script_lang_js = ({
  name: 'ContainerAtom',
  props: {
    label: String,
    step: Number,
    stepPlacement: {
      type: Number,
      default: -60
    },
    header: String,
    mode: {
      type: String,
      default: 'normal',
      validator: value => {
        return ['normal', 'grid'].includes(value);
      }
    }
  },
  computed: {
    hasNoActionPanel() {
      return this.$slots.actionPanel === undefined;
    },
    hasNoLabel() {
      return this.$slots.label === undefined && this.label === undefined;
    },
    stepStyle() {
      if (this.stepPlacement < 0) {
        return 'right: ' + -1 * this.stepPlacement + 'px';
      }
      return 'left: ' + this.stepPlacement + 'px';
    },
    isHeadless() {
      return window.location.search.indexOf('?headless') !== -1;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ContainerAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ContainerAtom.vue?vue&type=style&index=0&id=1971a400&scoped=true&lang=css
var ContainerAtomvue_type_style_index_0_id_1971a400_scoped_true_lang_css = __webpack_require__(7893);
;// CONCATENATED MODULE: ./src/components/atoms/ContainerAtom.vue?vue&type=style&index=0&id=1971a400&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ContainerAtom.vue




;


const ContainerAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ContainerAtomvue_type_script_lang_js, [['render',ContainerAtomvue_type_template_id_1971a400_scoped_true_render],['__scopeId',"data-v-1971a400"]])

/* harmony default export */ var ContainerAtom = (ContainerAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateFilterAtom.vue?vue&type=template&id=e1835506

function DateFilterAtomvue_type_template_id_e1835506_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", null, (0,external_vue_namespaceObject.toDisplayString)($options.formattedDateValue), 1);
}
;// CONCATENATED MODULE: ./src/components/atoms/DateFilterAtom.vue?vue&type=template&id=e1835506

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateFilterAtom.vue?vue&type=script&lang=js

/* harmony default export */ var DateFilterAtomvue_type_script_lang_js = ({
  name: 'DateFilterAtom',
  props: {
    value: String
  },
  computed: {
    formattedDateValue() {
      return helpers.formatDate(this.value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DateFilterAtom.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/atoms/DateFilterAtom.vue




;
const DateFilterAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DateFilterAtomvue_type_script_lang_js, [['render',DateFilterAtomvue_type_template_id_e1835506_render]])

/* harmony default export */ var DateFilterAtom = (DateFilterAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=template&id=3d0dc3c3&scoped=true

const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-3d0dc3c3"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_1 = ["title"];
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_2 = {
  class: "date-input-atom__wrapper"
};
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_3 = /*#__PURE__*/DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "date-input-atom__wrapper__input__button__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down"
})], -1));
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_4 = [DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_3];
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_5 = ["value", "disabled"];
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_6 = /*#__PURE__*/DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "date-input-atom__wrapper__input__button__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down"
})], -1));
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_7 = [DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_6];
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_8 = /*#__PURE__*/DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_9 = [DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_8];
const DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_10 = {
  class: "date-input-atom__calendar"
};
function DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LabelParticle = (0,external_vue_namespaceObject.resolveComponent)("LabelParticle");
  const _component_MatrixParticle = (0,external_vue_namespaceObject.resolveComponent)("MatrixParticle");
  const _component_ShellParticle = (0,external_vue_namespaceObject.resolveComponent)("ShellParticle");
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom", {
      'date-input-atom--active': $data.isCalendarVisible
    }]),
    ref: "dateinputatom"
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__container", {
      'date-input-atom__container--single-row': $props.singleRow
    }]),
    title: $options.innerError
  }, [(0,external_vue_namespaceObject.createVNode)(_component_LabelParticle, {
    label: $props.label,
    disabled: $props.disabled,
    inactive: $props.inactive,
    singleRow: $props.singleRow
  }, null, 8, ["label", "disabled", "inactive", "singleRow"]), (0,external_vue_namespaceObject.createElementVNode)("div", DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__wrapper__input ace-input", $options.inputClasses])
  }, [$props.hasInputNavigation ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("button", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__wrapper__input__button", {
      'ace-input--disabled': $props.disabled
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onPrevDayClick && $options.onPrevDayClick(...args))
  }, DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_4, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.hasDayLabel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__wrapper__day-label", {
      'ace-input--disabled': $props.disabled
    }]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.openCalendar && $options.openCalendar(...args))
  }, (0,external_vue_namespaceObject.toDisplayString)($options.selectedDateDay) + ", ", 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__wrapper__inner-input", {
      'ace-input--disabled': $props.disabled
    }]),
    placeholder: "____-__-__",
    value: $data.innerValue,
    onInput: _cache[2] || (_cache[2] = (...args) => $options.onInnerValueInput && $options.onInnerValueInput(...args)),
    onBlur: _cache[3] || (_cache[3] = (...args) => $options.onInputValueBlur && $options.onInputValueBlur(...args)),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.openCalendar && $options.openCalendar(...args)),
    disabled: $props.disabled || $props.inactive
  }, null, 42, DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_5), [[_directive_mask, '####-##-##']]), $props.hasInputNavigation ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("button", {
    key: 2,
    class: (0,external_vue_namespaceObject.normalizeClass)(["date-input-atom__wrapper__input__button", {
      'ace-input--disabled': $props.disabled
    }]),
    onClick: _cache[5] || (_cache[5] = (...args) => $options.onNextDayClick && $options.onNextDayClick(...args))
  }, DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_7, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $options.innerError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-icon--error", {
      'ace-input-icon--has-navigation': $props.hasInputNavigation
    }])
  }, DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_9, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_10, [$data.isCalendarVisible ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ShellParticle, {
    key: 0,
    calendarDate: $data.calendarDate,
    direction: $props.direction,
    mode: $data.mode,
    onClose: $options.closeCalendar,
    onPrevButton: $options.onPrevCalendarButtonClick,
    onNextButton: $options.onNextCalendarButtonClick,
    onModeMonth: $options.onMonthClick,
    onModeYear: $options.onYearClick
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.monthList, (month, index) => {
      return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_MatrixParticle, {
        mode: $data.mode,
        key: index,
        calendarDate: month,
        today: $data.today,
        disablePreviousDates: $props.disablePreviousDates,
        disableNextDates: $props.disableNextDates,
        selectedDate: $data.selectedDate,
        onDateSelected: _cache[6] || (_cache[6] = $event => $options.onDateSelected($event)),
        holidays: $data.holidays
      }, null, 8, ["mode", "calendarDate", "today", "disablePreviousDates", "disableNextDates", "selectedDate", "holidays"]);
    }), 128)), (0,external_vue_namespaceObject.createElementVNode)("p", {
      class: "date-input-atom__today",
      onClick: _cache[7] || (_cache[7] = $event => $options.onDateSelected($data.today))
    }, " Idag ")]),
    _: 1
  }, 8, ["calendarDate", "direction", "mode", "onClose", "onPrevButton", "onNextButton", "onModeMonth", "onModeYear"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])])], 10, DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_hoisted_1)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=template&id=3d0dc3c3&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=template&id=10669f22&scoped=true

const MatrixParticlevue_type_template_id_10669f22_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-10669f22"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_1 = {
  class: "matrix-particle"
};
const MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_2 = {
  key: 0,
  class: "matrix-particle__header-year"
};
const MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_3 = {
  key: 0,
  class: "matrix-particle__weeks"
};
const MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_4 = /*#__PURE__*/MatrixParticlevue_type_template_id_10669f22_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "matrix-particle__weeks__header"
}, null, -1));
const MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_5 = ["onClick"];
function MatrixParticlevue_type_template_id_10669f22_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_1, [$options.isYear ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($options.monthDate), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["matrix-particle__layout", {
      'matrix-particle__layout--year': $options.isYear
    }])
  }, [!$options.isYear ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_3, [MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_4, ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.weeks, (week, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "matrix-particle__weeks__value",
      key: 'week_' + index
    }, (0,external_vue_namespaceObject.toDisplayString)(week), 1);
  }), 128))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["matrix-particle__container", $options.getYearContainer])
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.weekHeaders, (weekHeader, weekHeadersIndex) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "matrix-particle__matrix__header",
      key: `header-${weekHeadersIndex}`
    }, (0,external_vue_namespaceObject.toDisplayString)(weekHeader), 1);
  }), 128)), ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.calendar, (day, dayIndex) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["matrix-particle__matrix__cell", {
        'matrix-particle__matrix__cell--holiday': ($options.isHoliday(dayIndex) || $options.sundays[dayIndex]) && !($options.isDisabled(dayIndex) || $options.disableDates(dayIndex)),
        'matrix-particle__matrix__cell--disabled': $options.isDisabled(dayIndex),
        'matrix-particle__matrix__cell--disabled-date': $options.disableDates(dayIndex),
        'matrix-particle__matrix__cell--year': $options.isYear
      }]),
      key: dayIndex,
      onClick: $event => $options.onClick(dayIndex)
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      tabindex: "0",
      class: (0,external_vue_namespaceObject.normalizeClass)(["matrix-particle__matrix__cell__inner", {
        'matrix-particle__matrix__cell__inner--today': $options.isToday(dayIndex),
        'matrix-particle__matrix__cell__inner--selected': $options.isSelected(dayIndex),
        'matrix-particle__matrix__cell__inner--year': $options.isYear
      }])
    }, (0,external_vue_namespaceObject.toDisplayString)($options.dayDate(day)), 3)], 10, MatrixParticlevue_type_template_id_10669f22_scoped_true_hoisted_5);
  }), 128))], 2)], 2)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=template&id=10669f22&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=script&lang=js

/* harmony default export */ var MatrixParticlevue_type_script_lang_js = ({
  name: 'MatrixParticle',
  props: {
    today: Object,
    holidays: Array,
    selectedDate: Object,
    disablePreviousDates: Object,
    disableNextDates: Object,
    calendarDate: Object,
    mode: String
  },
  data() {
    return {
      isCalendarVisible: false
    };
  },
  computed: {
    monthDate() {
      return this.$moment(this.calendarDate).format('MMM');
    },
    isYear() {
      return this.mode === 'year';
    },
    weekHeaders() {
      if (!this.isYear) {
        return ['Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör', 'Sön'];
      } else {
        return [];
      }
    },
    getYearContainer() {
      if (this.isYear) {
        return 'matrix-particle__container--year';
      }
      return '';
    },
    calendar() {
      var startWeek = this.calendarDate.clone().startOf('month').startOf('week');
      var endWeek = this.calendarDate.clone().endOf('month');
      let calendar = [];
      for (startWeek; startWeek.diff(endWeek) < 0; startWeek.add(7, 'days')) {
        let weekDays = [];
        for (let i = 0; i < 7; i++) {
          weekDays.push(this.normalizeDay(startWeek).clone().add(i, 'day'));
        }
        calendar.push(...weekDays);
      }
      return calendar;
    },
    weeks() {
      return this.calendar.reduce((pv, cv) => {
        let weekNumber = cv.format('w');
        if (pv.indexOf(weekNumber) === -1) {
          pv.push(weekNumber);
        }
        return pv;
      }, []);
    },
    sundays() {
      let result = {};
      this.calendar.forEach((d, index) => {
        let isSunday = d.format('dddd') === 'söndag';
        if (isSunday) {
          result[index] = isSunday;
        }
      });
      return result;
    }
  },
  emits: ['dateSelected'],
  methods: {
    dayDate(day) {
      return this.$moment(day).format('D');
    },
    normalizeDay(moment) {
      return moment.startOf('day').add(12, 'hours');
    },
    onClick(index) {
      this.$emit('dateSelected', this.calendar[index]);
    },
    onTodayClick() {
      this.$emit('dateSelected', this.today);
    },
    isSelected(index) {
      if (this.calendar[index] && this.selectedDate) {
        var date = this.calendar[index].format('D MMM YY');
        var selectedDate = this.selectedDate.format('D MMM YY');
        return date == selectedDate;
      }
      return false;
    },
    isToday(index) {
      var calendarDate = this.calendar[index].format('D MMM YY');
      var todayDate = this.today.format('D MMM YY');
      return calendarDate === todayDate;
    },
    isHoliday(index) {
      var isHolidayDate = false;
      if (this.holidays !== undefined) {
        var calendarDate = this.calendar[index].format('D MMM YY');
        this.holidays.forEach(holiday => {
          if (this.$moment(holiday.date).format('D MMM YY') == calendarDate) isHolidayDate = true;
        });
      }
      return isHolidayDate;
    },
    isDisabled(index) {
      return this.calendar[index].month() !== this.calendarDate.month();
    },
    disableDates(index) {
      var date = this.calendar[index];
      if (this.disablePreviousDates && date.isBefore(this.normalizeDay(this.disablePreviousDates))) {
        return true;
      }
      if (this.disableNextDates && date.isAfter(this.normalizeDay(this.disableNextDates))) {
        return true;
      }
      return false;
    },
    getCalendar() {}
  },
  beforeMount() {
    this.getCalendar();
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=style&index=0&id=10669f22&scoped=true&lang=css
var MatrixParticlevue_type_style_index_0_id_10669f22_scoped_true_lang_css = __webpack_require__(1456);
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/MatrixParticle.vue?vue&type=style&index=0&id=10669f22&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/MatrixParticle.vue




;


const MatrixParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(MatrixParticlevue_type_script_lang_js, [['render',MatrixParticlevue_type_template_id_10669f22_scoped_true_render],['__scopeId',"data-v-10669f22"]])

/* harmony default export */ var MatrixParticle = (MatrixParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=template&id=75b4afe4&scoped=true

const ShellParticlevue_type_template_id_75b4afe4_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-75b4afe4"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_1 = {
  class: "shell-particle__header"
};
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_2 = /*#__PURE__*/ShellParticlevue_type_template_id_75b4afe4_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross"
}, null, -1));
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_3 = [ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_2];
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_4 = {
  class: "shell-particle__wrapper"
};
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_5 = /*#__PURE__*/ShellParticlevue_type_template_id_75b4afe4_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "shell-particle__icon-prev"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_6 = [ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_5];
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_7 = {
  class: "shell-particle__calendar-date"
};
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_8 = /*#__PURE__*/ShellParticlevue_type_template_id_75b4afe4_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "shell-particle__icon-next"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_9 = [ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_8];
function ShellParticlevue_type_template_id_75b4afe4_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["shell-particle ace-no-select", $options.getContainerClass]),
    ref: "shellparticle",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.getContainerStyles)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["shell-particle__header__button", $options.getMonthButtonClass]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.modeMonth && $options.modeMonth(...args))
  }, "Månad", 2), (0,external_vue_namespaceObject.createElementVNode)("button", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["shell-particle__header__button", $options.getYearButtonClass]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.modeYear && $options.modeYear(...args))
  }, "År", 2), ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "shell-particle__icon-cross",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.close && $options.close(...args))
  }, ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_3))]), (0,external_vue_namespaceObject.createElementVNode)("div", ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_4, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "shell-particle__button-prev",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.onPrev && $options.onPrev(...args))
  }, ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_6), (0,external_vue_namespaceObject.createElementVNode)("div", ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_7, (0,external_vue_namespaceObject.toDisplayString)($options.calendarTitle), 1), (0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "shell-particle__button-next",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.onNext && $options.onNext(...args))
  }, ShellParticlevue_type_template_id_75b4afe4_scoped_true_hoisted_9)]), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["shell-particle__wrapper-matrix", $options.getWrapperClass])
  }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)], 2)], 6);
}
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=template&id=75b4afe4&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=script&lang=js
/* harmony default export */ var ShellParticlevue_type_script_lang_js = ({
  name: 'ShellParticle',
  props: {
    calendarDate: Object,
    mode: String,
    direction: String
  },
  data() {
    return {
      bounds: {},
      originX: 0,
      originY: 0
    };
  },
  computed: {
    calendarTitle() {
      if (this.mode === 'year') {
        return this.$moment(this.calendarDate).format('YYYY');
      }
      if (this.mode === 'month') {
        return this.$moment(this.calendarDate).format('MMMM YYYY');
      }
      return '';
    },
    getMonthButtonClass() {
      if (this.mode === 'month') {
        return 'shell-particle__header__button--selected';
      }
      return '';
    },
    getYearButtonClass() {
      if (this.mode === 'year') {
        return 'shell-particle__header__button--selected';
      }
      return '';
    },
    getContainerClass() {
      return {
        'shell-particle--year': this.mode === 'year'
      };
    },
    getWrapperClass() {
      if (this.mode === 'year') {
        return 'shell-particle__wrapper-matrix--selected';
      }
      return '';
    },
    width() {
      return this.mode === 'year' ? 1000 : 324;
    },
    height() {
      return this.mode === 'year' ? 709 : 320;
    },
    isWidthOffscreen() {
      return this.originX + this.width > window.innerWidth;
    },
    widthOverflowCompensation() {
      return window.innerWidth - (this.originX + this.width);
    },
    isHeightOffscreen() {
      return this.originY + this.height > window.innerHeight;
    },
    heightOverflowCompensation() {
      return window.innerHeight - (this.originY + this.height);
    },
    getContainerStyles() {
      let result = {};
      if (this.isWidthOffscreen) {
        result['margin-left'] = this.widthOverflowCompensation + 'px';
      }
      if (this.isHeightOffscreen) {
        result['margin-top'] = this.heightOverflowCompensation + 'px';
      }
      return result;
    }
  },
  emits: ['close', 'prevButton', 'nextButton', 'modeMonth', 'modeYear'],
  methods: {
    close() {
      this.$emit('close');
    },
    onPrev() {
      this.$emit('prevButton');
    },
    onNext() {
      this.$emit('nextButton');
    },
    modeMonth() {
      this.$emit('modeMonth');
    },
    modeYear() {
      this.$emit('modeYear');
    },
    calculateOrigin() {
      let bounds = this.$refs.shellparticle.getBoundingClientRect();
      this.originX = bounds.x;
      this.originY = bounds.y;
    }
  },
  mounted() {
    this.calculateOrigin();
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=style&index=0&id=75b4afe4&scoped=true&lang=css
var ShellParticlevue_type_style_index_0_id_75b4afe4_scoped_true_lang_css = __webpack_require__(7643);
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/ShellParticle.vue?vue&type=style&index=0&id=75b4afe4&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/ShellParticle.vue




;


const ShellParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShellParticlevue_type_script_lang_js, [['render',ShellParticlevue_type_template_id_75b4afe4_scoped_true_render],['__scopeId',"data-v-75b4afe4"]])

/* harmony default export */ var ShellParticle = (ShellParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=template&id=4da1b9c0&scoped=true

const LabelParticlevue_type_template_id_4da1b9c0_scoped_true_withScopeId = n => (_pushScopeId("data-v-4da1b9c0"), n = n(), _popScopeId(), n);
const LabelParticlevue_type_template_id_4da1b9c0_scoped_true_hoisted_1 = {
  class: "label-particle"
};
const LabelParticlevue_type_template_id_4da1b9c0_scoped_true_hoisted_2 = ["title"];
function LabelParticlevue_type_template_id_4da1b9c0_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", LabelParticlevue_type_template_id_4da1b9c0_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("label", {
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.labelClasses])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, LabelParticlevue_type_template_id_4da1b9c0_scoped_true_hoisted_2)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=template&id=4da1b9c0&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=script&lang=js
/* harmony default export */ var LabelParticlevue_type_script_lang_js = ({
  name: 'LabelParticle',
  props: {
    label: String,
    isCalendarVisible: Boolean,
    disabled: Boolean,
    inactive: Boolean,
    singleRow: Boolean
  },
  computed: {
    labelClasses() {
      return {
        'ace-input-label--disabled': this.disabled,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    }
  },
  emits: ['open'],
  methods: {
    open() {
      if (this.disabled || this.inactive) {
        return;
      }
      this.$emit('open');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=style&index=0&id=4da1b9c0&scoped=true&lang=css
var LabelParticlevue_type_style_index_0_id_4da1b9c0_scoped_true_lang_css = __webpack_require__(6917);
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/LabelParticle.vue?vue&type=style&index=0&id=4da1b9c0&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/LabelParticle.vue




;


const LabelParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(LabelParticlevue_type_script_lang_js, [['render',LabelParticlevue_type_template_id_4da1b9c0_scoped_true_render],['__scopeId',"data-v-4da1b9c0"]])

/* harmony default export */ var LabelParticle = (LabelParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=script&lang=js




/* harmony default export */ var DateInputAtomvue_type_script_lang_js = ({
  name: 'DateInputAtom',
  components: {
    MatrixParticle: MatrixParticle,
    ShellParticle: ShellParticle,
    LabelParticle: LabelParticle
  },
  props: {
    label: String,
    value: String,
    disablePreviousDates: Object,
    disableNextDates: Object,
    disabled: Boolean,
    inactive: Boolean,
    error: String,
    hasInputNavigation: Boolean,
    propagateInvalidInput: Boolean,
    hasDayLabel: Boolean,
    singleRow: Boolean,
    direction: {
      type: String,
      default: undefined,
      validator: val => {
        return [undefined, 'bottom-left', 'bottom-right', 'top-left', 'top-right'].includes(val);
      }
    }
  },
  data() {
    return {
      mode: 'month',
      calendarDate: this.$moment(),
      today: this.$moment(),
      selectedDate: this.$moment(),
      date: this.$moment(),
      isCalendarVisible: false,
      innerValue: '',
      holidayAdded: false,
      holidays: []
    };
  },
  computed: {
    selectedDateDay() {
      return this.selectedDate.format('dddd');
    },
    inputMask() {
      if (this.mask) return this.mask;else return '';
    },
    monthList() {
      if (this.mode === 'month') {
        return [this.calendarDate.clone()];
      }
      let startMonth = this.calendarDate.clone().startOf('year');
      let result = [];
      for (let i = 0; i < 12; i++) {
        result.push(startMonth.clone());
        startMonth.add(1, 'months');
      }
      return result;
    },
    inputClasses() {
      return {
        'ace-input--disabled': this.disabled,
        'ace-input--inactive': this.inactive,
        'ace-input--has-navigation': this.hasInputNavigation,
        'ace-input--error': this.innerError
      };
    },
    isValid() {
      if (!this.innerValue || this.innerValue && this.innerValue.length < 10) {
        return false;
      }
      return this.$moment(this.innerValue, 'YYYY-MM-DD').isValid();
    },
    innerError() {
      if (this.error) {
        return this.error;
      }
      if (!this.isValid && this.innerValue && this.innerValue.length === 10) {
        return 'Ogiltigt format';
      }
      return '';
    }
  },
  emits: ['input'],
  methods: {
    onMonthClick() {
      this.mode = 'month';
    },
    onYearClick() {
      this.mode = 'year';
    },
    openCalendar() {
      this.isCalendarVisible = !this.isCalendarVisible;
    },
    closeCalendar() {
      this.isCalendarVisible = !this.isCalendarVisible;
      this.calendarDate = this.selectedDate;
    },
    onPrevCalendarButtonClick() {
      if (this.mode === 'month') {
        this.calendarDate = this.calendarDate.clone().add(-1, 'months');
      } else {
        this.calendarDate = this.calendarDate.clone().add(-1, 'years');
      }
    },
    onNextCalendarButtonClick() {
      if (this.mode === 'month') {
        this.calendarDate = this.calendarDate.clone().add(1, 'months');
      } else {
        this.calendarDate = this.calendarDate.clone().add(1, 'years');
      }
    },
    onPrevDayClick() {
      let newValue = this.$moment(this.value, 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD');
      // this.innerValue = newValue;
      this.processInput(newValue);
    },
    onNextDayClick() {
      let newValue = this.$moment(this.value, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      // this.innerValue = newValue;
      this.processInput(newValue);
    },
    onInput(e) {
      let newValue = e.target.value;
      if (!newValue) {
        this.processInput(newValue);
      }
      if (newValue.length === 10) {
        this.processInput(newValue);
      }
    },
    onInnerValueInput(e) {
      this.innerValue = e.target.value;
      if (this.innerValue === this.value) {
        return;
      }
      if (this.isValid || this.propagateInvalidInput) {
        this.processInput(e.target.value);
      }
    },
    onInputValueBlur() {
      if (!this.isValid && !this.propagateInvalidInput) {
        this.$emit('input', '');
      }
    },
    processInput(valueToProcess) {
      if (!valueToProcess) {
        this.$emit('input', null);
      }
      this.selectedDate = this.$moment(valueToProcess, 'YYYY-MM-DD');
      this.calendarDate = this.$moment(valueToProcess, 'YYYY-MM-DD');
      if (this.isValueAfterDisableNextDates(valueToProcess)) {
        this.selectedDate = this.disableNextDates;
        this.calendarDate = this.disableNextDates;
        valueToProcess = this.disableNextDates.format('YYYY-MM-DD');
      }
      if (this.isValueBeforeDisablePrevDates(valueToProcess)) {
        this.selectedDate = this.disablePreviousDates;
        this.calendarDate = this.disablePreviousDates;
        valueToProcess = this.disablePreviousDates.format('YYYY-MM-DD');
      }
      this.innerValue = valueToProcess;
      this.$emit('input', valueToProcess);
    },
    isValueAfterDisableNextDates(value) {
      if (this.disableNextDates && this.disableNextDates.format('YYYY-MM-DD') === value) {
        return true;
      }
      if (this.disableNextDates && this.$moment(value, 'YYYY-MM-DD').isAfter(this.disableNextDates)) {
        return true;
      }
      return false;
    },
    isValueBeforeDisablePrevDates(value) {
      if (this.disablePreviousDates && this.disablePreviousDates.format('YYYY-MM-DD') === value) {
        return true;
      }
      if (this.disablePreviousDates && this.$moment(value, 'YYYY-MM-DD').isBefore(this.disablePreviousDates)) {
        return true;
      }
      return false;
    },
    onDateSelected(date) {
      this.selectedDate = date;
      this.closeCalendar();
      this.parseSelectedDate();
    },
    parseSelectedDate() {
      let newValue = this.selectedDate.format('YYYY-MM-DD');
      this.innerValue = newValue;
      this.$emit('input', newValue);
    },
    setInnerValues(value) {
      if (value && !this.innerValue) {
        this.innerValue = value;
      }
      if (value && value !== this.selectedDate.format('YYYY-MM-DD')) {
        this.innerValue = this.value;
        this.selectedDate = this.$moment(value, 'YYYY-MM-DD');
        this.calendarDate = this.selectedDate.clone();
      }
      if (!value && this.innerValue) {
        this.innerValue = value;
      }
    },
    onClickOutside(event) {
      if (!this.$refs.dateinputatom.contains(event.target)) {
        this.isCalendarVisible = false;
      }
    },
    initializeHolidays() {
      if (window.location.host.indexOf('localhost') !== -1) {
        return;
      }
      let cachedData = window.goHolidays;
      try {
        if (cachedData) {
          this.holidays = cachedData;
          return;
        }
        if (!window.goFetchHolidays) {
          window.goFetchHolidays = fetch('/sysadmin/api/Holidays', {
            method: 'GET'
          });
        }
        window.goFetchHolidays.then(response => {
          return response.clone().json();
        }).then(holidays => {
          if (!window.goHolidays) {
            window.goHolidays = holidays;
          }
          this.holidays = holidays;
        });
      } catch (error) {
        return;
      }
    }
  },
  mounted() {
    this.setInnerValues(this.value);
    document.addEventListener('click', this.onClickOutside);
    document.addEventListener('touchstart', this.onClickOutside);
    this.initializeHolidays();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onClickOutside);
    document.removeEventListener('touchstart', this.onClickOutside);
  },
  watch: {
    value: function (val) {
      this.setInnerValues(val);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=style&index=0&id=3d0dc3c3&scoped=true&lang=css
var DateInputAtomvue_type_style_index_0_id_3d0dc3c3_scoped_true_lang_css = __webpack_require__(9905);
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/DateInputAtom.vue?vue&type=style&index=0&id=3d0dc3c3&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/DateInputAtom.vue




;


const DateInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DateInputAtomvue_type_script_lang_js, [['render',DateInputAtomvue_type_template_id_3d0dc3c3_scoped_true_render],['__scopeId',"data-v-3d0dc3c3"]])

/* harmony default export */ var DateInputAtom = (DateInputAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/DateInputAtom/index.js

/* harmony default export */ var atoms_DateInputAtom = (DateInputAtom);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DialogAtom.vue?vue&type=template&id=19cab3a4&scoped=true

const DialogAtomvue_type_template_id_19cab3a4_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-19cab3a4"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_1 = {
  class: "dialog-atom__shell ace-shadow"
};
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_2 = {
  class: "dialog-atom__shell__icon"
};
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_3 = ["xlink:href"];
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_4 = {
  class: "dialog-atom__shell__header"
};
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_5 = /*#__PURE__*/DialogAtomvue_type_template_id_19cab3a4_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross-secondary"
}, null, -1));
const DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_6 = [DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_5];
function DialogAtomvue_type_template_id_19cab3a4_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["dialog-atom", $options.dialogStyle])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("use", {
    "xlink:href": _ctx.icons[$props.type]
  }, null, 8, DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_3)])), (0,external_vue_namespaceObject.createElementVNode)("h2", DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)($options.getLabel), 1), $props.mode !== 'block' ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    key: 0,
    class: "dialog-atom__shell__x",
    onClick: _cache[0] || (_cache[0] = $event => $options.emitClose())
  }, DialogAtomvue_type_template_id_19cab3a4_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)])], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/DialogAtom.vue?vue&type=template&id=19cab3a4&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DialogAtom.vue?vue&type=script&lang=js

/* harmony default export */ var DialogAtomvue_type_script_lang_js = ({
  name: 'DialogAtom',
  props: {
    type: {
      type: String,
      validator: val => {
        return ['error', 'warning', 'success', 'notification', 'info'].includes(val);
      },
      default: 'info'
    },
    label: String,
    mode: {
      type: String,
      validator: val => {
        return ['fullscreen', 'block'].includes(val);
      },
      default: 'fullscreen'
    }
  },
  data: () => {
    return {
      colorClasses: {
        error: 'dialog-atom--red',
        warning: 'dialog-atom--brown',
        success: 'dialog-atom--green',
        notification: 'dialog-atom--black',
        info: 'dialog-atom--black'
      },
      icons: {
        error: '#info',
        warning: '#warning',
        success: '#check-mark-secondary',
        notification: '#info',
        info: '#info'
      }
    };
  },
  computed: {
    dialogStyle() {
      let result = [];
      if (this.mode === 'block') {
        result.push('dialog-atom--block');
      }
      if (this.mode === 'fullscreen') {
        result.push('dialog-atom--fullscreen');
      }
      result.push(this.colorClasses[this.type]);
      return result.join(' ');
    },
    getLabel() {
      if (!this.label && this.type === 'error') return 'Ett fel har inträffat';else return this.label;
    }
  },
  emits: ['close'],
  methods: {
    emitClose() {
      this.$emit('close');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DialogAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DialogAtom.vue?vue&type=style&index=0&id=19cab3a4&scoped=true&lang=css
var DialogAtomvue_type_style_index_0_id_19cab3a4_scoped_true_lang_css = __webpack_require__(3917);
;// CONCATENATED MODULE: ./src/components/atoms/DialogAtom.vue?vue&type=style&index=0&id=19cab3a4&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DialogAtom.vue




;


const DialogAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DialogAtomvue_type_script_lang_js, [['render',DialogAtomvue_type_template_id_19cab3a4_scoped_true_render],['__scopeId',"data-v-19cab3a4"]])

/* harmony default export */ var DialogAtom = (DialogAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DropdownAtom.vue?vue&type=template&id=71b958c4&scoped=true

const DropdownAtomvue_type_template_id_71b958c4_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-71b958c4"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_1 = ["title"];
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_2 = ["title"];
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_3 = /*#__PURE__*/DropdownAtomvue_type_template_id_71b958c4_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_4 = [DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_3];
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_5 = ["disabled", "value"];
const DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_6 = ["value", "disabled"];
function DropdownAtomvue_type_template_id_71b958c4_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["dropdown-atom", $options.getClass]),
    ref: "dropdown"
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["dropdown-atom__wrapper", $options.getWrapperClass]),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onSelect && $options.onSelect(...args)),
    title: $props.error
  }, [!$props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["dropdown-atom__wrapper__arrow", $options.getArrowClass])
  }, DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_4, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("select", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input", $options.selectClasses]),
    disabled: $options.isDisabled,
    value: String($props.value),
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args))
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.processedOptions, option => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("option", {
      class: "dropdown-atom__option",
      key: option.value,
      value: option.value === undefined || option.value === null ? '' : option.value,
      disabled: option.disabled
    }, (0,external_vue_namespaceObject.toDisplayString)(option.label), 9, DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_6);
  }), 128))], 42, DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_5)], 10, DropdownAtomvue_type_template_id_71b958c4_scoped_true_hoisted_2), $props.description ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getDescriptionClass)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/DropdownAtom.vue?vue&type=template&id=71b958c4&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DropdownAtom.vue?vue&type=script&lang=js
/* harmony default export */ var DropdownAtomvue_type_script_lang_js = ({
  name: 'DropdownAtom',
  props: {
    label: String,
    value: [Number, String, Boolean],
    options: Array,
    disabled: Boolean,
    inactive: Boolean,
    description: String,
    error: String,
    singleRow: Boolean,
    mode: {
      type: String,
      default: 'inline',
      validator: value => {
        return ['inline', 'fullwidth'].includes(value);
      }
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    fullwidth() {
      return this.mode === 'fullwidth';
    },
    processedOptions() {
      if (!this.options) {
        return [];
      }
      return this.options.map(x => {
        return {
          ...x,
          value: String(x.value)
        };
      });
    },
    getClass() {
      return {
        'dropdown-atom--inactive': this.inactive,
        'dropdown-atom--inline': !this.fullwidth,
        'dropdown-atom--single-row': this.singleRow
      };
    },
    getWrapperClass() {
      return {
        'dropdown-atom__wrapper--fullwidth': this.fullwidth,
        'dropdown-atom__wrapper--inactive': this.inactive
      };
    },
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    getErrorClass() {
      return {
        'dropdown-atom__error--fullwidth': this.fullwidth
      };
    },
    getArrowClass() {
      return {
        'dropdown-atom__wrapper__arrow--active': this.active
      };
    },
    getDescriptionClass() {
      return {
        'ace-input--description': this.description
      };
    },
    hasError() {
      return this.error ? true : false;
    },
    isDisabled() {
      if (this.disabled) {
        return true;
      }
      if (this.inactive) {
        return true;
      }
      return false;
    },
    selectClasses() {
      return {
        'dropdown-atom__select--inactive': !this.disabled && this.inactive,
        'dropdown-atom__select--disabled': this.disabled,
        'dropdown-atom__select--fullwidth': this.fullwidth,
        'dropdown-atom__select--error': this.hasError
      };
    }
  },
  emits: ['input'],
  methods: {
    onSelect() {
      if (this.disabled) {
        return;
      }
      this.active = !this.active;
    },
    onInput(e) {
      let val = e.target.value;
      if (val === 'undefined') {
        val = undefined;
      } else if (val === 'null') {
        val = null;
      } else if (val === 'true') {
        val = true;
      } else if (val === 'false') {
        val = false;
      } else if (!isNaN(Number(val))) {
        val = Number(val);
      }
      this.$emit('input', val);
    },
    close(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        if (this.active == true) {
          this.active = false;
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.close);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.close);
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/DropdownAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/DropdownAtom.vue?vue&type=style&index=0&id=71b958c4&scoped=true&lang=css
var DropdownAtomvue_type_style_index_0_id_71b958c4_scoped_true_lang_css = __webpack_require__(6018);
;// CONCATENATED MODULE: ./src/components/atoms/DropdownAtom.vue?vue&type=style&index=0&id=71b958c4&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/DropdownAtom.vue




;


const DropdownAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DropdownAtomvue_type_script_lang_js, [['render',DropdownAtomvue_type_template_id_71b958c4_scoped_true_render],['__scopeId',"data-v-71b958c4"]])

/* harmony default export */ var DropdownAtom = (DropdownAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HcpInputAtom.vue?vue&type=template&id=51995346&scoped=true

const HcpInputAtomvue_type_template_id_51995346_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-51995346"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_1 = ["title"];
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_2 = ["title"];
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_3 = ["value", "placeholder", "disabled"];
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_4 = {
  key: 0,
  class: "ace-input-icon--error"
};
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_5 = /*#__PURE__*/HcpInputAtomvue_type_template_id_51995346_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_6 = [HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_5];
function HcpInputAtomvue_type_template_id_51995346_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["hcp-input-atom", {
      'hcp-input-atom--single-row': $props.singleRow
    }])
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "ace-input-wrapper",
    title: $props.error
  }, [(0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input", $options.getInputClass]),
    value: $props.value,
    type: "text",
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    onKeydown: _cache[1] || (_cache[1] = (...args) => $options.onKeyDown && $options.onKeyDown(...args)),
    placeholder: $props.placeholder,
    disabled: $options.isDisabled
  }, null, 42, HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_3), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_4, HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 8, HcpInputAtomvue_type_template_id_51995346_scoped_true_hoisted_2), $props.description ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getDescriptionClass)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/HcpInputAtom.vue?vue&type=template&id=51995346&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HcpInputAtom.vue?vue&type=script&lang=js
/* harmony default export */ var HcpInputAtomvue_type_script_lang_js = ({
  name: 'HcpInputAtom',
  props: {
    min: Number,
    max: Number,
    error: String,
    label: String,
    value: [Number, String],
    disabled: Boolean,
    inactive: Boolean,
    description: String,
    placeholder: String,
    maxDecimal: Number,
    allowNinetyNine: {
      type: Boolean,
      default: false
    },
    singleRow: Boolean
  },
  data() {
    return {
      lastCharComma: false,
      lastValue: undefined
    };
  },
  computed: {
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled || this.description && !this.inactive,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    isDisabled() {
      return this.disabled || this.description || this.inactive;
    },
    getInputClass() {
      return {
        'ace-input--inactive': this.inactive && !this.disabled,
        'ace-input--disabled': this.isDisabled,
        'ace-input--error': this.error
      };
    },
    getDescriptionClass() {
      return {
        'ace-input--description': this.description
      };
    },
    hasError() {
      if (this.error) {
        return true;
      }
      return false;
    }
  },
  emits: ['input'],
  methods: {
    onInput(e) {
      if (e.data === null && e.target.value == '+0,' || e.data === null && e.target.value == '0') {
        return;
      }
      if (e.target.value === '+0' || e.target.value === '0') {
        if (e.data === null) {
          return;
        }
        e.target.value = e.target.value + ',';
      }
      if (e.data === '+') {
        return;
      }
      if (e.data === null && e.target.value === '+') {
        e.target.value = '';
      }
      if (e.data === null && !e.target.value) {
        this.$emit('input', null);
        return;
      }
      if (e.data === ',' || e.data === '+') {
        if (!e.target.value) {
          e.preventDefault();
          return;
        }
      }
      if (this.min !== undefined && this.min > Number(e.target.value)) {
        e.target.value = this.min;
        e.preventDefault();
        return;
      }
      this.$emit('input', e.target.value.toString());
    },
    onKeyDown(e) {
      let isNumber = e.key.match(/[0-9]/i) !== null;
      let isComma = e.key === ',';
      let isPlus = e.key === '+';
      let length = e.key.length;
      let value = e.target.value;
      let hasPlus = value.indexOf('+') !== -1;
      let hasComma = value.indexOf(',') !== -1;
      let caretPosition = e.target.selectionStart;
      let hasSelection = false;
      let selection = window.getSelection().toString();
      if (selection && selection.length > 0) {
        hasSelection = true;
      }
      if (hasSelection && selection.length !== value.length) {
        e.preventDefault();
        return;
      }
      if (this.allowNinetyNine) {
        if (value === '99' && (isNumber || isComma)) {
          e.preventDefault();
          return;
        }
      }
      let innerValue = new Number((isNumber ? value + e.key : value).replace('+', '-').replace(',', '.'));
      if (!hasSelection && innerValue && innerValue != 99) {
        if (innerValue > 54) {
          e.target.value = '54,0';
          this.onInput(e);
          e.preventDefault();
          return;
        } else if (innerValue < -8) {
          e.target.value = '+8,0';
          this.onInput(e);
          e.preventDefault();
          return;
        }
      }
      if (isPlus && value.length !== 0 && caretPosition !== 0 && !hasPlus) {
        e.preventDefault();
        return;
      }
      if (hasPlus && isPlus) {
        e.preventDefault();
        return;
      }
      if (hasPlus && value.length === 1 && isComma) {
        e.preventDefault();
        return;
      }
      if (hasComma && isComma) {
        e.preventDefault();
        return;
      }
      if (!hasPlus && !hasComma && value.length === 2 && !isComma && isNumber && !hasSelection) {
        e.preventDefault();
        return;
      }
      if (!hasPlus && hasComma && isNumber && !hasSelection && caretPosition > 1) {
        if (value.indexOf(',') === 1 && value.length === 3) {
          e.preventDefault();
          return;
        } else if (value.length === 4) {
          e.preventDefault();
          return;
        }
      }
      if (hasPlus && !hasComma && value.length === 3 && !isComma && isNumber && !hasSelection) {
        e.preventDefault();
        return;
      }
      if (hasPlus && hasComma && value.length === 4 && isNumber && !hasSelection) {
        if (value.indexOf(',') === 2 && value.length === 4) {
          e.preventDefault();
          return;
        } else if (value.length === 5) {
          e.preventDefault();
          return;
        }
      }
      if (hasPlus && hasComma && value.length === 5 && isNumber && !hasSelection) {
        e.preventDefault();
        return;
      }
      if (e.key === 'Dead') {
        e.preventDefault();
        return;
      }
      if (length === 1) {
        if (isComma || isPlus) {
          return;
        }
        if (!isNumber) {
          e.preventDefault();
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/HcpInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HcpInputAtom.vue?vue&type=style&index=0&id=51995346&scoped=true&lang=css
var HcpInputAtomvue_type_style_index_0_id_51995346_scoped_true_lang_css = __webpack_require__(6999);
;// CONCATENATED MODULE: ./src/components/atoms/HcpInputAtom.vue?vue&type=style&index=0&id=51995346&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/HcpInputAtom.vue




;


const HcpInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HcpInputAtomvue_type_script_lang_js, [['render',HcpInputAtomvue_type_template_id_51995346_scoped_true_render],['__scopeId',"data-v-51995346"]])

/* harmony default export */ var HcpInputAtom = (HcpInputAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HeaderAtom.vue?vue&type=template&id=700ba7ce&scoped=true

const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_withScopeId = n => (_pushScopeId("data-v-700ba7ce"), n = n(), _popScopeId(), n);
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_1 = {
  class: "header-atom"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_2 = {
  class: "header-atom__field__label"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_3 = {
  key: 0,
  class: "header-atom__field__label__counter"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_4 = {
  class: "header-atom__field__value"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_5 = {
  key: 0,
  class: "header-atom__main-row__buttons"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_6 = {
  class: "header-atom__field__label"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_7 = {
  key: 0,
  class: "header-atom__field__label__counter"
};
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_8 = ["title"];
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_9 = ["href"];
const HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_10 = {
  key: 1
};
function HeaderAtomvue_type_template_id_700ba7ce_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["header-atom__main-row", $options.mainRowClasses]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.mainRowStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "header-atom__main-row__title",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.titleStyle)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.title), 5), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["header-atom__main-row__fields", {
      'header-atom__main-row__fields--no-fields': $options.hasNoValues
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.mainRowValues, (value, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "header-atom__field",
      key: 'header-value_' + index
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)(value.label), 1), value.count ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_3, (0,external_vue_namespaceObject.toDisplayString)(value.count), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]), (0,external_vue_namespaceObject.createElementVNode)("div", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)(value.value), 1)]);
  }), 128))], 2), $options.hasButtons ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_5, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "buttons", {}, undefined, true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 6), $options.isExpanded ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: "header-atom__values",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.expandedValuesStyle)
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.expandedValues, (value, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "header-atom__field",
      key: 'header-value_' + index
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_6, [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)(value.label), 1), value.count ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_7, (0,external_vue_namespaceObject.toDisplayString)(value.count), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]), (0,external_vue_namespaceObject.createElementVNode)("div", {
      class: "header-atom__field__value ace-clamp",
      title: value.value
    }, [value.href ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("a", {
      key: 0,
      class: "header-atom__field__value header-atom__field__anchor ace-clamp",
      href: value.href
    }, (0,external_vue_namespaceObject.toDisplayString)($options.formatValue(value.value)), 9, HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_9)) : ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_10, (0,external_vue_namespaceObject.toDisplayString)($options.formatValue(value.value)), 1))], 8, HeaderAtomvue_type_template_id_700ba7ce_scoped_true_hoisted_8)]);
  }), 128))], 4)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/HeaderAtom.vue?vue&type=template&id=700ba7ce&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HeaderAtom.vue?vue&type=script&lang=js
/* harmony default export */ var HeaderAtomvue_type_script_lang_js = ({
  name: 'HeaderAtom',
  props: {
    title: String,
    titleWidth: Number,
    values: Array,
    mode: String,
    expandedBreakpoint: Number,
    expandedColumns: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    isExpanded() {
      if (this.mode === 'expanded') {
        return true;
      }
      if (this.expandedBreakpoint !== undefined && this.windowWidth < this.expandedBreakpoint) {
        return true;
      }
      return false;
    },
    mainRowClasses() {
      return {
        'header-atom__main-row--expanded': this.isExpanded,
        'header-atom__main-row--no-fields': this.hasNoValues
      };
    },
    hasNoValues() {
      if (!this.mainRowValues) {
        return true;
      }
      if (this.mainRowValues.length === 0) {
        return true;
      }
      return false;
    },
    hasButtons() {
      return this.$slots.buttons !== undefined;
    },
    mainRowStyle() {
      let result = {};
      if (this.titleWidth) {
        result['grid-template-columns'] = `minmax(0, ${this.titleWidth}px) minmax(0, 1fr) minmax(0, max-content)`;
      }
      if (this.isExpanded) {
        result['border-bottom-left-radius'] = '0';
      }
      return result;
    },
    mainRowValues() {
      if (!this.isExpanded) {
        return this.values;
      }
      return this.values.filter(x => x.main);
    },
    expandedValues() {
      return this.values.filter(x => !x.main);
    },
    titleStyle() {
      let result = {};
      if (this.isExpanded) {
        result['border-bottom-left-radius'] = '0';
      }
      return result;
    },
    expandedValuesStyle() {
      let result = {
        'grid-template-columns': `repeat(${this.expandedColumns}, minmax(0, 1fr))`
      };
      return result;
    }
  },
  methods: {
    formatValue(value) {
      return value === null || value === undefined || Array.isArray(value) && value.length === 0 ? '-' : value;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    if (this.expandedBreakpoint) {
      window.addEventListener('resize', this.onResize);
    }
  },
  beforeUnmount() {
    if (this.expandedBreakpoint) {
      window.removeEventListener('resize', this.onResize);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/HeaderAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/HeaderAtom.vue?vue&type=style&index=0&id=700ba7ce&scoped=true&lang=css
var HeaderAtomvue_type_style_index_0_id_700ba7ce_scoped_true_lang_css = __webpack_require__(8722);
;// CONCATENATED MODULE: ./src/components/atoms/HeaderAtom.vue?vue&type=style&index=0&id=700ba7ce&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/HeaderAtom.vue




;


const HeaderAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HeaderAtomvue_type_script_lang_js, [['render',HeaderAtomvue_type_template_id_700ba7ce_scoped_true_render],['__scopeId',"data-v-700ba7ce"]])

/* harmony default export */ var HeaderAtom = (HeaderAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/LoaderAtom.vue?vue&type=template&id=b6c448e2&scoped=true

const LoaderAtomvue_type_template_id_b6c448e2_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-b6c448e2"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const LoaderAtomvue_type_template_id_b6c448e2_scoped_true_hoisted_1 = /*#__PURE__*/LoaderAtomvue_type_template_id_b6c448e2_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#loader-primary"
}, null, -1));
const LoaderAtomvue_type_template_id_b6c448e2_scoped_true_hoisted_2 = [LoaderAtomvue_type_template_id_b6c448e2_scoped_true_hoisted_1];
function LoaderAtomvue_type_template_id_b6c448e2_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["loader-atom", $options.backgroundClass]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.loaderAtomStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["loader-atom__shell", $options.shellClass])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.loaderAtomShellIconStyle),
    class: (0,external_vue_namespaceObject.normalizeClass)(["loader-atom__shell__icon", $options.iconClass])
  }, LoaderAtomvue_type_template_id_b6c448e2_scoped_true_hoisted_2, 6)), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["loader-atom__shell__bold-text", {
      'loader-atom__shell__bold-text--block': $props.mode === 'block'
    }])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.header), 3), [[external_vue_namespaceObject.vShow, $options.showText]]), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "loader-atom__shell__light-text"
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 513), [[external_vue_namespaceObject.vShow, $options.showText]])], 2)], 6);
}
;// CONCATENATED MODULE: ./src/components/atoms/LoaderAtom.vue?vue&type=template&id=b6c448e2&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/LoaderAtom.vue?vue&type=script&lang=js

/* harmony default export */ var LoaderAtomvue_type_script_lang_js = ({
  name: 'LoaderAtom',
  props: {
    mode: {
      type: String,
      validator: val => {
        return ['action', 'inline', 'block', 'fullscreen', 'fullheight'].includes(val);
      },
      default: 'inline'
    },
    loaderWidth: String,
    header: {
      type: String,
      default: 'Hämtar...'
    },
    description: {
      type: String,
      default: 'Det kan ta några sekunder'
    },
    height: String,
    nested: Boolean
  },
  computed: {
    backgroundClass() {
      let classes = ['loader-atom--' + this.mode];
      if (this.mode === 'block') {
        classes.push('ace-loader');
      }
      if (this.nested) {
        classes.push('loader-atom--nested');
      }
      return classes;
    },
    loaderAtomStyle() {
      let result = {};
      if (this.height !== undefined) {
        result.height = this.height;
      }
      return result;
    },
    shellClass() {
      let cls = [];
      if (['fullscreen', 'fullheight'].includes(this.mode)) {
        cls.push('ace-shadow');
      }
      cls.push('loader-atom__shell--' + this.mode);
      return cls;
    },
    loaderAtomShellIconStyle() {
      if (this.loaderWidth) {
        return {
          width: this.loaderWidth
        };
      }
      return {};
    },
    iconClass() {
      return 'loader-atom__shell__icon--' + this.mode;
    },
    showText() {
      return ['fullscreen', 'fullheight', 'block'].includes(this.mode);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/LoaderAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/LoaderAtom.vue?vue&type=style&index=0&id=b6c448e2&scoped=true&lang=css
var LoaderAtomvue_type_style_index_0_id_b6c448e2_scoped_true_lang_css = __webpack_require__(4371);
;// CONCATENATED MODULE: ./src/components/atoms/LoaderAtom.vue?vue&type=style&index=0&id=b6c448e2&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/LoaderAtom.vue




;


const LoaderAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(LoaderAtomvue_type_script_lang_js, [['render',LoaderAtomvue_type_template_id_b6c448e2_scoped_true_render],['__scopeId',"data-v-b6c448e2"]])

/* harmony default export */ var LoaderAtom = (LoaderAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/MenuAtom.vue?vue&type=template&id=f52365b4&scoped=true

function MenuAtomvue_type_template_id_f52365b4_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: "menu-atom",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClick && $options.onClick(...args))
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)([$options.classes, "menu-atom__bar--first"])
  }, null, 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)([$options.classes, "menu-atom__bar--second"])
  }, null, 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)([$options.classes, "menu-atom__bar--third"])
  }, null, 2)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/MenuAtom.vue?vue&type=template&id=f52365b4&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/MenuAtom.vue?vue&type=script&lang=js

/* harmony default export */ var MenuAtomvue_type_script_lang_js = ({
  name: 'MenuAtom',
  props: {
    isActive: Boolean
  },
  computed: {
    classes() {
      let classes = ['menu-atom__bar'];
      if (this.isActive) {
        classes.push('menu-atom__bar--active');
      }
      return classes.join(' ');
    }
  },
  emits: ['click'],
  methods: {
    onClick(e) {
      this.$emit('click', e);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/MenuAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/MenuAtom.vue?vue&type=style&index=0&id=f52365b4&scoped=true&lang=css
var MenuAtomvue_type_style_index_0_id_f52365b4_scoped_true_lang_css = __webpack_require__(1502);
;// CONCATENATED MODULE: ./src/components/atoms/MenuAtom.vue?vue&type=style&index=0&id=f52365b4&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/MenuAtom.vue




;


const MenuAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(MenuAtomvue_type_script_lang_js, [['render',MenuAtomvue_type_template_id_f52365b4_scoped_true_render],['__scopeId',"data-v-f52365b4"]])

/* harmony default export */ var MenuAtom = ((/* unused pure expression or super */ null && (MenuAtom_exports_)));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ModalAtom.vue?vue&type=template&id=077de218&scoped=true

const ModalAtomvue_type_template_id_077de218_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-077de218"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_1 = /*#__PURE__*/ModalAtomvue_type_template_id_077de218_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross-secondary"
}, null, -1));
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_2 = [ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_1];
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_3 = /*#__PURE__*/ModalAtomvue_type_template_id_077de218_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "modal-atom__content__warning__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#warning"
})], -1));
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_4 = {
  class: "modal-atom__content__ingress-container"
};
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_5 = {
  class: "modal-atom__content__footer"
};
const ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_6 = {
  class: "modal-atom__content__footer__buttons"
};
function ModalAtomvue_type_template_id_077de218_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["modal-atom", {
      'modal-atom--headless': $options.isHeadless
    }]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.coverage)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["modal-atom__content", $options.contentClasses])
  }, [$props.disableClose != true ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    key: 0,
    class: "modal-atom__content__x",
    onClick: _cache[0] || (_cache[0] = $event => $options.close())
  }, ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "modal-atom__content__warning",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.warningStyle)
  }, [ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_3, (0,external_vue_namespaceObject.createTextVNode)(" Avbryt utan att spara? ")], 4), (0,external_vue_namespaceObject.createElementVNode)("h1", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["modal-atom__content__title", {
      'modal-atom__content__title--is-overlay': $props.isOverlay
    }])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.title), 3), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_4, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "ingress", {}, undefined, true)], 512), [[external_vue_namespaceObject.vShow, $options.ingressExists]]), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, undefined, true), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_5, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", ModalAtomvue_type_template_id_077de218_scoped_true_hoisted_6, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "buttons", {}, undefined, true)], 512), [[external_vue_namespaceObject.vShow, $props.mode == 'modification']])], 512), [[external_vue_namespaceObject.vShow, this.mode == 'modification']])], 2)], 6);
}
;// CONCATENATED MODULE: ./src/components/atoms/ModalAtom.vue?vue&type=template&id=077de218&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ModalAtom.vue?vue&type=script&lang=js

/* harmony default export */ var ModalAtomvue_type_script_lang_js = ({
  name: 'ModalAtom',
  data: () => {
    return {
      presentWarning: false
    };
  },
  props: {
    title: {
      type: String,
      default: 'Obs!'
    },
    type: {
      type: String,
      validator: val => {
        return ['fullheight', 'fullscreen'].includes(val);
      },
      default: 'fullheight'
    },
    size: {
      type: String,
      validator: val => {
        return ['sm', 'md', 'lg', 'xl'].includes(val);
      },
      default: 'md'
    },
    mode: {
      type: String,
      validator: val => {
        return ['modification', 'presentation'].includes(val);
      },
      default: 'presentation'
    },
    modified: {
      type: Boolean,
      default: false
    },
    disableClose: Boolean,
    isOverlay: Boolean
  },
  computed: {
    isHeadless() {
      return window.location.search.indexOf('?headless') !== -1;
    },
    coverage() {
      switch (this.type) {
        case 'fullheight':
          return {
            position: 'absolute'
          };
        case 'fullscreen':
          return {
            position: 'fixed'
          };
        default:
          return {
            position: 'absolute'
          };
      }
    },
    contentClasses() {
      let result = ['modal-atom__content--' + this.size];
      if (this.isOverlay) {
        result.push('modal-atom__content--is-overlay');
      }
      if (this.isHeadless) {
        result.push('modal-atom__content--headless');
      }
      return result;
    },
    warningStyle() {
      return this.presentWarning ? {
        transform: 'scale(1)'
      } : {
        transform: 'scale(0)'
      };
    },
    ingressExists() {
      return this.$slots.ingress;
    }
  },
  emits: ['close'],
  methods: {
    emitClose() {
      this.presentWarning = false;
      this.$emit('close');
    },
    close() {
      if (this.presentWarning || this.mode != 'modification' || this.mode == 'modification' && !this.modified) {
        this.emitClose();
      } else {
        this.presentWarning = true;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ModalAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ModalAtom.vue?vue&type=style&index=0&id=077de218&scoped=true&lang=css
var ModalAtomvue_type_style_index_0_id_077de218_scoped_true_lang_css = __webpack_require__(564);
;// CONCATENATED MODULE: ./src/components/atoms/ModalAtom.vue?vue&type=style&index=0&id=077de218&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ModalAtom.vue




;


const ModalAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ModalAtomvue_type_script_lang_js, [['render',ModalAtomvue_type_template_id_077de218_scoped_true_render],['__scopeId',"data-v-077de218"]])

/* harmony default export */ var ModalAtom = (ModalAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NotificationAtom.vue?vue&type=template&id=643a801c&scoped=true

const NotificationAtomvue_type_template_id_643a801c_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-643a801c"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_1 = {
  class: "notification-atom__notification__content__header"
};
const NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_2 = /*#__PURE__*/NotificationAtomvue_type_template_id_643a801c_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("br", null, null, -1));
const NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_3 = /*#__PURE__*/NotificationAtomvue_type_template_id_643a801c_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross-secondary"
}, null, -1));
const NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_4 = [NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_3];
const NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_5 = ["xlink:href"];
function NotificationAtomvue_type_template_id_643a801c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["notification-atom", $options.blockClasses])
  }, [$props.active ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["notification-atom__notification", $options.notificationClasses]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.notificationStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "notification-atom__notification__content",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.contentStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("span", NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_1, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1), NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_2, ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "notification-atom__notification__content__x",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.extended = false)
  }, NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_4)), ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.getValues, value => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["notification-atom__notification__content__text", {
        'notification-atom__notification__content__text--multiline': $props.multiline
      }]),
      key: value
    }, (0,external_vue_namespaceObject.toDisplayString)(value), 3);
  }), 128))], 4), ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "notification-atom__notification__icon",
    onClick: _cache[1] || (_cache[1] = (0,external_vue_namespaceObject.withModifiers)($event => _ctx.extended = !_ctx.extended, ["stop"]))
  }, [(0,external_vue_namespaceObject.createElementVNode)("use", {
    "xlink:href": _ctx.icons[$props.type]
  }, null, 8, NotificationAtomvue_type_template_id_643a801c_scoped_true_hoisted_5)]))], 6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/NotificationAtom.vue?vue&type=template&id=643a801c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NotificationAtom.vue?vue&type=script&lang=js
function cornerHelper(tl, tr, br, bl) {
  return {
    borderRadius: tl + 'px ' + tr + 'px ' + br + 'px ' + bl + 'px'
  };
}
function componentOrientationHelper(base, contactSide, xOffset, yOffset) {
  return {
    [base]: '0px',
    [contactSide]: '22px',
    transformOrigin: xOffset + ' ' + yOffset
  };
}
function componentOrientation(direction) {
  switch (direction) {
    case 'right':
      return {
        ...componentOrientationHelper('top', 'left', '0%', '11px'),
        ...cornerHelper(0, 11, 11, 11)
      };
    case 'left':
      return {
        ...componentOrientationHelper('top', 'right', '100%', '11px'),
        ...cornerHelper(11, 0, 11, 11)
      };
    case 'up':
      return {
        ...componentOrientationHelper('left', 'bottom', '11px', '100%'),
        ...cornerHelper(11, 11, 11, 0)
      };
    case 'up-left':
      return {
        ...componentOrientationHelper('right', 'bottom', '100%', '100%'),
        ...cornerHelper(11, 11, 0, 11)
      };
    case 'down':
      return {
        ...componentOrientationHelper('left', 'top', '11px', '0%'),
        ...cornerHelper(0, 11, 11, 11)
      };
  }
  return '';
}
/* harmony default export */ var NotificationAtomvue_type_script_lang_js = ({
  name: 'NotificationAtom',
  props: {
    type: {
      type: String,
      validator: val => {
        return ['error', 'warning', 'success', 'notification', 'info'].includes(val);
      },
      default: 'info'
    },
    direction: {
      type: String,
      validator: val => {
        return ['left', 'right', 'up', 'down', 'up-left'].includes(val);
      },
      default: 'right'
    },
    active: {
      type: Boolean,
      default: true
    },
    label: String,
    value: String,
    values: Array,
    multiline: Boolean,
    hideNumbers: Boolean,
    readonly: Boolean
  },
  data: () => {
    return {
      colorClasses: {
        error: 'notification-atom__notification--red',
        warning: 'notification-atom__notification--brown',
        success: 'notification-atom__notification--green',
        notification: 'notification-atom__notification--black',
        info: 'notification-atom__notification--black'
      },
      icons: {
        error: '#info',
        warning: '#warning',
        success: '#check-mark-secondary',
        notification: '#info',
        info: '#info'
      },
      extended: false
    };
  },
  computed: {
    blockClasses() {
      return {
        'notification-atom--has-slot': this.$slots.default
      };
    },
    notificationClasses() {
      return {
        [this.colorClasses[this.type]]: true,
        'notification-atom__notification--has-slot': this.$slots.default,
        'notification-atom__notification--readonly': this.readonly
      };
    },
    contentStyle() {
      let style = componentOrientation(this.direction);
      if (this.multiline && this.value) {
        let minWidth = this.value.length / 4 * 6;
        if (minWidth > 150) {
          style.minWidth = minWidth + 'px';
        }
      }
      if (this.multiline && this.values) {
        let longest = this.values.reduce((a, b) => {
          return a.length > b.length ? a : b;
        });
        let minWidth = longest.length / 4 * 6;
        if (minWidth > 150) {
          style.minWidth = minWidth + 'px';
        }
      }
      if (this.extended) {
        style.transform = 'scale(1)';
      } else {
        style.transform = 'scale(0)';
      }
      return style;
    },
    notificationStyle() {
      if (!this.extended) {
        return {
          borderRadius: '11px'
        };
      }
      switch (this.direction) {
        case 'right':
          return cornerHelper(11, 0, 0, 11);
        case 'left':
          return cornerHelper(0, 11, 11, 0);
        case 'up':
        case 'up-left':
          return cornerHelper(0, 0, 11, 11);
        case 'down':
          return cornerHelper(11, 11, 0, 0);
      }
      return '';
    },
    getValues() {
      if (this.values && !this.hideNumbers && this.values.length > 1) return this.values.map((v, index) => index + 1 + '. ' + v);else if (this.values) return this.values;else return [this.value];
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/NotificationAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NotificationAtom.vue?vue&type=style&index=0&id=643a801c&scoped=true&lang=css
var NotificationAtomvue_type_style_index_0_id_643a801c_scoped_true_lang_css = __webpack_require__(6239);
;// CONCATENATED MODULE: ./src/components/atoms/NotificationAtom.vue?vue&type=style&index=0&id=643a801c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/NotificationAtom.vue




;


const NotificationAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NotificationAtomvue_type_script_lang_js, [['render',NotificationAtomvue_type_template_id_643a801c_scoped_true_render],['__scopeId',"data-v-643a801c"]])

/* harmony default export */ var NotificationAtom = (NotificationAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NumberInputAtom.vue?vue&type=template&id=f7c21738&scoped=true

const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-f7c21738"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_1 = {
  novalidate: ""
};
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_2 = ["title"];
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_3 = ["title"];
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_4 = ["value", "max", "min", "placeholder", "disabled"];
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_5 = {
  key: 0,
  class: "ace-input-icon--error"
};
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_6 = /*#__PURE__*/NumberInputAtomvue_type_template_id_f7c21738_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_7 = [NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_6];
function NumberInputAtomvue_type_template_id_f7c21738_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["number-input-atom", {
      'number-input-atom--single-row': this.singleRow
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("form", NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_1, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "ace-input-wrapper",
    title: $props.error
  }, [(0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input", $options.getInputClass]),
    value: $props.value,
    type: "number",
    max: $props.max,
    min: $props.min,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    onKeydown: _cache[1] || (_cache[1] = (...args) => $options.onKeyDown && $options.onKeyDown(...args)),
    onKeyup: _cache[2] || (_cache[2] = (...args) => $options.onKeyUp && $options.onKeyUp(...args)),
    onBlur: _cache[3] || (_cache[3] = (...args) => $options.onBlue && $options.onBlue(...args)),
    placeholder: $props.placeholder,
    disabled: $options.isDisabled
  }, null, 42, NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_4), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_5, NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_7)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 8, NumberInputAtomvue_type_template_id_f7c21738_scoped_true_hoisted_3), $props.description ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getDescriptionClass)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/NumberInputAtom.vue?vue&type=template&id=f7c21738&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NumberInputAtom.vue?vue&type=script&lang=js
/* harmony default export */ var NumberInputAtomvue_type_script_lang_js = ({
  name: 'NumberInputAtom',
  props: {
    label: String,
    disabled: Boolean,
    inactive: Boolean,
    value: [Number, String],
    error: String,
    description: String,
    placeholder: String,
    min: Number,
    max: Number,
    maxDecimal: Number,
    noDecimal: Boolean,
    inlineError: Boolean,
    singleRow: Boolean,
    removeArrows: Boolean
  },
  data() {
    return {
      lastCharComma: false,
      lastValue: undefined,
      lastChar: undefined
    };
  },
  computed: {
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled || this.description && !this.inactive,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    isDisabled() {
      return this.disabled || this.description || this.inactive;
    },
    getInputClass() {
      return {
        'ace-input--inactive': this.inactive && !this.disabled,
        'ace-input--disabled': this.isDisabled,
        'ace-input--error': this.error,
        'remove-arrows': this.removeArrows
      };
    },
    getDescriptionClass() {
      return {
        'ace-input--description': this.description
      };
    },
    hasError() {
      if (this.error) {
        return true;
      }
      return false;
    }
  },
  emits: ['input'],
  methods: {
    onBlue(e) {
      let projection = e.target.value;
      if (this.max && this.max < Number(projection)) {
        e.target.value = this.max;
        this.emit(this.max);
        e.preventDefault();
        return;
      }
      if (this.min && this.min > Number(projection)) {
        e.target.value = this.min;
        this.emit(this.min);
        e.preventDefault();
        return;
      }
    },
    onInput(e) {
      this.lastChar = e.data;
      if (e.data === null && !e.target.value) {
        this.lastValue = undefined;
        this.$emit('input', null);
        return;
      }
      if (e.data === '.' || e.data === ',' || e.data === '-') {
        if (!e.target.value) {
          e.preventDefault();
          return;
        }
      }
      this.emit(e.target.value);
    },
    emit(val) {
      let value;
      if (this.noDecimal) {
        value = parseInt(val);
      } else {
        value = Number(val);
      }
      if (typeof this.value === 'string') {
        this.$emit('input', value.toString());
      } else {
        this.$emit('input', value);
      }
      this.lastValue = value;
    },
    onKeyUp(e) {
      if (e.key === ',') {
        this.lastCharComma = true;
      } else {
        this.lastCharComma = false;
      }
    },
    onKeyDown(e) {
      if (e.key === '-' && this.lastChar === '-') {
        e.preventDefault();
        return;
      }
      if (this.min !== undefined && this.min >= 0 && e.key === '-') {
        e.preventDefault();
        return;
      }
      if (e.key === '-' && this.lastValue) {
        e.preventDefault();
        return;
      }
      if (e.key === ',' && this.noDecimal) {
        e.preventDefault();
        return;
      }
      if (Number(e.key) || e.key === '0' || e.key === ',') {
        this.processKeyDown(e);
        return;
      }
      if (e.key === '.') {
        e.preventDefault();
        return;
      }
      if (e.key === 'e') {
        e.preventDefault();
        return;
      }
    },
    processKeyDown(e) {
      let projection = e.target.value;
      let selection = window.getSelection().toString();
      if (selection) {
        projection = projection.replace(selection, e.key);
      } else {
        if (this.lastCharComma) {
          projection = projection + '.' + e.key;
        } else {
          projection = projection + e.key;
        }
      }
      if (this.maxDecimal && projection.includes('.')) {
        let split = projection.split('.');
        if (split[1].length > this.maxDecimal) {
          e.preventDefault();
          return;
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/NumberInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/NumberInputAtom.vue?vue&type=style&index=0&id=f7c21738&scoped=true&lang=css
var NumberInputAtomvue_type_style_index_0_id_f7c21738_scoped_true_lang_css = __webpack_require__(6042);
;// CONCATENATED MODULE: ./src/components/atoms/NumberInputAtom.vue?vue&type=style&index=0&id=f7c21738&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/NumberInputAtom.vue




;


const NumberInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NumberInputAtomvue_type_script_lang_js, [['render',NumberInputAtomvue_type_template_id_f7c21738_scoped_true_render],['__scopeId',"data-v-f7c21738"]])

/* harmony default export */ var NumberInputAtom = (NumberInputAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PaginationAtom.vue?vue&type=template&id=4853b3f6&scoped=true

const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-4853b3f6"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_1 = {
  class: "pagination-atom ace-no-select"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_2 = {
  class: "pagination-atom__button-box"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_3 = /*#__PURE__*/PaginationAtomvue_type_template_id_4853b3f6_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_4 = [PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_3];
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_5 = {
  key: 0,
  class: "pagination-atom__end-point"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_6 = {
  key: 0,
  class: "pagination-atom__button-box"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_7 = ["onClick"];
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_8 = {
  key: 1,
  class: "pagination-atom__end-point"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_9 = {
  key: 0,
  class: "pagination-atom__button-box"
};
const PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_10 = {
  class: "pagination-atom__button-box"
};
const _hoisted_11 = /*#__PURE__*/PaginationAtomvue_type_template_id_4853b3f6_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const _hoisted_12 = [_hoisted_11];
function PaginationAtomvue_type_template_id_4853b3f6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_2, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["pagination-atom__previous", $options.previousClass]),
    onClick: _cache[0] || (_cache[0] = $event => $options.onNextPrevClick($props.currentPage - 1))
  }, PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_4, 2))]), $options.startIndex != 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_5, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "pagination-atom__button-box pagination-atom__index--inactive",
    onClick: _cache[1] || (_cache[1] = $event => $options.onChange(1))
  }, "1"), $options.startIndex > 2 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_6, "...")) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.pageOptions, item => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "pagination-atom__button-box",
      key: item
    }, [(0,external_vue_namespaceObject.createElementVNode)("span", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["pagination-atom__index", $options.indexClass(item)]),
      onClick: $event => $options.onChange(item)
    }, (0,external_vue_namespaceObject.toDisplayString)(item), 11, PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_7)]);
  }), 128)), $options.endIndex != $options.numberOfPages ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_8, [$options.endIndex < $options.numberOfPages - 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_9, "...")) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "pagination-atom__button-box pagination-atom__index--inactive",
    onClick: _cache[2] || (_cache[2] = $event => $options.onChange($options.numberOfPages))
  }, (0,external_vue_namespaceObject.toDisplayString)($options.numberOfPages), 1)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", PaginationAtomvue_type_template_id_4853b3f6_scoped_true_hoisted_10, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["pagination-atom__next", $options.nextClass]),
    onClick: _cache[3] || (_cache[3] = $event => $options.onNextPrevClick($props.currentPage + 1))
  }, _hoisted_12, 2))]), (0,external_vue_namespaceObject.createElementVNode)("div", null, (0,external_vue_namespaceObject.toDisplayString)($options.pageOptions), 1)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/PaginationAtom.vue?vue&type=template&id=4853b3f6&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PaginationAtom.vue?vue&type=script&lang=js

/* harmony default export */ var PaginationAtomvue_type_script_lang_js = ({
  name: 'PaginationAtom',
  props: {
    currentPage: Number,
    pageSize: {
      type: Number,
      default: 10
    },
    numberOfItems: Number,
    maxPagesDelta: {
      type: Number,
      default: 10
    }
  },
  computed: {
    page() {
      return this.currentPage - 1;
    },
    previousClass() {
      return this.disabledClass(1);
    },
    nextClass() {
      return this.disabledClass(this.numberOfPages);
    },
    startIndex() {
      return Math.max(this.page - this.maxPagesDelta, 1);
    },
    endIndex() {
      return Math.min(this.page + this.maxPagesDelta, this.numberOfPages);
    },
    numberOfPages() {
      if (!this.numberOfItems) {
        return 0;
      }
      return Math.ceil(this.numberOfItems / this.pageSize);
    },
    pageOptions() {
      if (this.numberOfPages <= this.maxPagesDelta * 2 + 1) {
        return this.numberOfPages;
      }
      let pageArray = [];
      for (let i = this.startIndex; i < this.endIndex + 1; i++) {
        pageArray.push(i);
      }
      return pageArray;
    }
  },
  emits: ['pageChanged'],
  methods: {
    indexClass(index) {
      if (index == this.currentPage) {
        return 'pagination-atom__index--active';
      }
      return 'pagination-atom__index--inactive';
    },
    disabledClass(index) {
      if (index == this.currentPage) {
        return 'pagination-atom__element--disabled';
      }
      return 'pagination-atom__element--active';
    },
    onNextPrevClick(index) {
      if (index < this.startIndex || index > this.endIndex) {
        return;
      }
      this.onChange(index);
    },
    onChange(index) {
      this.$emit('pageChanged', index);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/PaginationAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PaginationAtom.vue?vue&type=style&index=0&id=4853b3f6&scoped=true&lang=css
var PaginationAtomvue_type_style_index_0_id_4853b3f6_scoped_true_lang_css = __webpack_require__(9674);
;// CONCATENATED MODULE: ./src/components/atoms/PaginationAtom.vue?vue&type=style&index=0&id=4853b3f6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/PaginationAtom.vue




;


const PaginationAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PaginationAtomvue_type_script_lang_js, [['render',PaginationAtomvue_type_template_id_4853b3f6_scoped_true_render],['__scopeId',"data-v-4853b3f6"]])

/* harmony default export */ var PaginationAtom = (PaginationAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=template&id=2a6ab0a6&scoped=true

const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-2a6ab0a6"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_1 = ["title"];
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_2 = {
  key: 1,
  class: "ace-input--inactive"
};
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_3 = ["title"];
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_4 = /*#__PURE__*/PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "phone-input-atom__row__prefix-dropdown__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_5 = ["value", "placeholder", "disabled"];
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_6 = {
  key: 0,
  class: "ace-input-icon--error"
};
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_7 = /*#__PURE__*/PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_8 = [PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_7];
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_9 = {
  class: "phone-input-atom__options ace-scroll"
};
const PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_10 = ["onClick"];
function PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["phone-input-atom", $options.textColor])
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.labelClasses])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_2, "+" + (0,external_vue_namespaceObject.toDisplayString)(_ctx.code) + (0,external_vue_namespaceObject.toDisplayString)(_ctx.number), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 2,
    class: "phone-input-atom__row",
    tabindex: "0",
    title: $props.error
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["phone-input-atom__row__prefix-dropdown", $options.prefixClasses])
  }, [PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_4, (0,external_vue_namespaceObject.createElementVNode)("span", null, "+" + (0,external_vue_namespaceObject.toDisplayString)(_ctx.code), 1)], 2), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    type: "tel",
    class: (0,external_vue_namespaceObject.normalizeClass)(["phone-input-atom__row__input", $options.inputClasses]),
    value: _ctx.number,
    onInput: _cache[0] || (_cache[0] = $event => $options.changeNumber($event)),
    placeholder: $props.placeholder,
    disabled: $props.disabled,
    maxlength: "15"
  }, null, 42, PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_5), [[_directive_mask, $options.mask]]), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_6, PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_8)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_9, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.phoneCodes, (code, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "phone-input-atom__options__option",
      key: index,
      onClick: $event => $options.changeCode(code)
    }, (0,external_vue_namespaceObject.toDisplayString)(code.name) + " (+" + (0,external_vue_namespaceObject.toDisplayString)(code.number) + ") ", 9, PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_10);
  }), 128))])], 8, PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_hoisted_3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=template&id=2a6ab0a6&scoped=true

;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/country-phone-codes.js
const primaryPhoneCodes = [{
  number: 46,
  name: 'Sverige'
}, {
  number: 45,
  name: 'Danmark'
}, {
  number: 47,
  name: 'Norge'
}, {
  number: 358,
  name: 'Finland'
}];
const phoneCodes = [{
  number: 441624,
  name: 'Isle of Man'
}, {
  number: 441534,
  name: 'Jersey'
}, {
  number: 441481,
  name: 'Guernsey'
}, {
  number: 1876,
  name: 'Jamaica'
}, {
  number: 1869,
  name: 'Saint Kitts och Nevis'
}, {
  number: 1868,
  name: 'Trinidad och Tobago'
}, {
  number: 1809,
  name: 'Dominikanska republiken'
}, {
  number: 1787,
  name: 'Puerto Rico'
}, {
  number: 1784,
  name: 'Saint Vincent och Grenadinerna'
}, {
  number: 1767,
  name: 'Dominica'
}, {
  number: 1758,
  name: 'Saint Lucia'
}, {
  number: 1721,
  name: 'Sint Maarten'
}, {
  number: 1684,
  name: 'Amerikanska Samoa'
}, {
  number: 1671,
  name: 'Guam'
}, {
  number: 1670,
  name: 'Nordmarianerna'
}, {
  number: 1664,
  name: 'Montserrat'
}, {
  number: 1649,
  name: 'Turks- och Caicosöarna'
}, {
  number: 1473,
  name: 'Grenada'
}, {
  number: 1441,
  name: 'Bermuda'
}, {
  number: 1345,
  name: 'Caymanöarna'
}, {
  number: 1340,
  name: 'U.S. Virgin Islands'
}, {
  number: 1284,
  name: 'Brittiska Jungfruöarna'
}, {
  number: 1268,
  name: 'Antigua och Barbuda'
}, {
  number: 1264,
  name: 'Anguilla'
}, {
  number: 1246,
  name: 'Barbados'
}, {
  number: 1242,
  name: 'Bahamas'
}, {
  number: 998,
  name: 'Uzbekistan'
}, {
  number: 996,
  name: 'Kirgizistan'
}, {
  number: 995,
  name: 'Georgien'
}, {
  number: 994,
  name: 'Azerbajdzjan'
}, {
  number: 993,
  name: 'Turkmenistan'
}, {
  number: 992,
  name: 'Tadzjikistan'
}, {
  number: 977,
  name: 'Nepal'
}, {
  number: 976,
  name: 'Mongoliet'
}, {
  number: 975,
  name: 'Bhutan'
}, {
  number: 974,
  name: 'Qatar'
}, {
  number: 973,
  name: 'Bahrain'
}, {
  number: 972,
  name: 'Israel'
}, {
  number: 971,
  name: 'Förenade arabemiraten'
}, {
  number: 970,
  name: 'Palestina'
}, {
  number: 968,
  name: 'Oman'
}, {
  number: 967,
  name: 'Jemen'
}, {
  number: 966,
  name: 'Saudiarabien'
}, {
  number: 965,
  name: 'Kuwait'
}, {
  number: 964,
  name: 'Irak'
}, {
  number: 963,
  name: 'Syrien'
}, {
  number: 962,
  name: 'Jordanien'
}, {
  number: 961,
  name: 'Libanon'
}, {
  number: 960,
  name: 'Maldiverna'
}, {
  number: 886,
  name: 'Taiwan'
}, {
  number: 880,
  name: 'Bangladesh'
}, {
  number: 856,
  name: 'Laos'
}, {
  number: 855,
  name: 'Kambodja'
}, {
  number: 853,
  name: 'Macau'
}, {
  number: 852,
  name: 'Hong Kong'
}, {
  number: 850,
  name: 'Nordkorea'
}, {
  number: 692,
  name: 'Marshallöarna'
}, {
  number: 691,
  name: 'Mikronesien'
}, {
  number: 690,
  name: 'Tokelau'
}, {
  number: 689,
  name: 'Franska Polynesien'
}, {
  number: 688,
  name: 'Tuvalu'
}, {
  number: 687,
  name: 'Nya Kaledonien'
}, {
  number: 686,
  name: 'Kiribati'
}, {
  number: 685,
  name: 'Samoa'
}, {
  number: 683,
  name: 'Niue'
}, {
  number: 682,
  name: 'Cooköarna'
}, {
  number: 681,
  name: 'Wallis och Futuna'
}, {
  number: 680,
  name: 'Palau'
}, {
  number: 679,
  name: 'Fiji'
}, {
  number: 678,
  name: 'Vanuatu'
}, {
  number: 677,
  name: 'Salomonöarna'
}, {
  number: 676,
  name: 'Tonga'
}, {
  number: 675,
  name: 'Papua Nya Guinea'
}, {
  number: 674,
  name: 'Nauru'
}, {
  number: 673,
  name: 'Brunei'
}, {
  number: 672,
  name: 'Antarktis'
}, {
  number: 670,
  name: 'Östtimor'
}, {
  number: 599,
  name: 'Curacao'
}, {
  number: 599,
  name: 'Nederländska Antillerna'
}, {
  number: 598,
  name: 'Uruguay'
}, {
  number: 597,
  name: 'Surinam'
}, {
  number: 595,
  name: 'Paraguay'
}, {
  number: 593,
  name: 'Ecuador'
}, {
  number: 592,
  name: 'Guyana'
}, {
  number: 591,
  name: 'Bolivia'
}, {
  number: 590,
  name: 'Saint Barthelemy'
}, {
  number: 590,
  name: 'Saint Martin'
}, {
  number: 509,
  name: 'Haiti'
}, {
  number: 508,
  name: 'Saint Pierre och Miquelon'
}, {
  number: 507,
  name: 'Panama'
}, {
  number: 506,
  name: 'Costa Rica'
}, {
  number: 505,
  name: 'Nicaragua'
}, {
  number: 504,
  name: 'Honduras'
}, {
  number: 503,
  name: 'El Salvador'
}, {
  number: 502,
  name: 'Guatemala'
}, {
  number: 501,
  name: 'Belize'
}, {
  number: 500,
  name: 'Falklandsöarna'
}, {
  number: 423,
  name: 'Liechtenstein'
}, {
  number: 421,
  name: 'Slovakien'
}, {
  number: 420,
  name: 'Tjeckien'
}, {
  number: 389,
  name: 'Makedonien'
}, {
  number: 387,
  name: 'Bosnien och Hercegovina'
}, {
  number: 386,
  name: 'Slovenien'
}, {
  number: 385,
  name: 'Kroatien'
}, {
  number: 383,
  name: 'Kosovo'
}, {
  number: 382,
  name: 'Montenegro'
}, {
  number: 381,
  name: 'Serbien'
}, {
  number: 380,
  name: 'Ukraina'
}, {
  number: 379,
  name: 'Vatikanen'
}, {
  number: 378,
  name: 'San Marino'
}, {
  number: 377,
  name: 'Monaco'
}, {
  number: 376,
  name: 'Andorra'
}, {
  number: 375,
  name: 'Vitryssland'
}, {
  number: 374,
  name: 'Armenien'
}, {
  number: 373,
  name: 'Moldavien'
}, {
  number: 372,
  name: 'Estland'
}, {
  number: 371,
  name: 'Lettland'
}, {
  number: 370,
  name: 'Litauen'
}, {
  number: 359,
  name: 'Bulgarien'
}, {
  number: 357,
  name: 'Cypern'
}, {
  number: 356,
  name: 'Malta'
}, {
  number: 355,
  name: 'Albanien'
}, {
  number: 354,
  name: 'Island'
}, {
  number: 353,
  name: 'Irland'
}, {
  number: 352,
  name: 'Luxemburg'
}, {
  number: 351,
  name: 'Portugal'
}, {
  number: 350,
  name: 'Gibraltar'
}, {
  number: 299,
  name: 'Grönland'
}, {
  number: 298,
  name: 'Färöarna'
}, {
  number: 297,
  name: 'Aruba'
}, {
  number: 291,
  name: 'Eritrea'
}, {
  number: 290,
  name: 'Saint Helena'
}, {
  number: 269,
  name: 'Komorerna'
}, {
  number: 268,
  name: 'Swaziland'
}, {
  number: 267,
  name: 'Botswana'
}, {
  number: 266,
  name: 'Lesotho'
}, {
  number: 265,
  name: 'Malawi'
}, {
  number: 264,
  name: 'Namibia'
}, {
  number: 263,
  name: 'Zimbabwe'
}, {
  number: 262,
  name: 'Mayotte'
}, {
  number: 262,
  name: 'Réunion'
}, {
  number: 261,
  name: 'Madagaskar'
}, {
  number: 260,
  name: 'Zambia'
}, {
  number: 258,
  name: 'Moçambique'
}, {
  number: 257,
  name: 'Burundi'
}, {
  number: 256,
  name: 'Uganda'
}, {
  number: 255,
  name: 'Tanzania'
}, {
  number: 254,
  name: 'Kenya'
}, {
  number: 253,
  name: 'Djibouti'
}, {
  number: 252,
  name: 'Somalia'
}, {
  number: 251,
  name: 'Etiopien'
}, {
  number: 250,
  name: 'Rwanda'
}, {
  number: 249,
  name: 'Sudan'
}, {
  number: 248,
  name: 'Seychellerna'
}, {
  number: 246,
  name: 'Brittiska territoriet i Indiska oceanen'
}, {
  number: 245,
  name: 'Guinea-Bissau'
}, {
  number: 244,
  name: 'Angola'
}, {
  number: 243,
  name: 'Demokratiska republiken Kongo'
}, {
  number: 242,
  name: 'Republiken Kongo'
}, {
  number: 241,
  name: 'Gabon'
}, {
  number: 240,
  name: 'Ekvatorialguinea'
}, {
  number: 239,
  name: 'Sao Tome och Principe'
}, {
  number: 238,
  name: 'Cap Verde'
}, {
  number: 237,
  name: 'Kamerun'
}, {
  number: 236,
  name: 'Centralafrikanska republiken'
}, {
  number: 235,
  name: 'Tchad'
}, {
  number: 234,
  name: 'Nigeria'
}, {
  number: 233,
  name: 'Ghana'
}, {
  number: 232,
  name: 'Sierra Leone'
}, {
  number: 231,
  name: 'Liberia'
}, {
  number: 230,
  name: 'Mauritius'
}, {
  number: 229,
  name: 'Benin'
}, {
  number: 228,
  name: 'Togo'
}, {
  number: 227,
  name: 'Niger'
}, {
  number: 226,
  name: 'Burkina Faso'
}, {
  number: 225,
  name: 'Elfenbenskusten'
}, {
  number: 224,
  name: 'Guinea'
}, {
  number: 223,
  name: 'Mali'
}, {
  number: 222,
  name: 'Mauretanien'
}, {
  number: 221,
  name: 'Senegal'
}, {
  number: 220,
  name: 'Gambia'
}, {
  number: 218,
  name: 'Libyen'
}, {
  number: 216,
  name: 'Tunisien'
}, {
  number: 213,
  name: 'Algeriet'
}, {
  number: 212,
  name: 'Marocko'
}, {
  number: 212,
  name: 'Västra Sahara'
}, {
  number: 211,
  name: 'Södra Sudan'
}, {
  number: 98,
  name: 'Iran'
}, {
  number: 95,
  name: 'Myanmar'
}, {
  number: 94,
  name: 'Sri Lanka'
}, {
  number: 93,
  name: 'Afghanistan'
}, {
  number: 92,
  name: 'Pakistan'
}, {
  number: 91,
  name: 'Indien'
}, {
  number: 90,
  name: 'Kalkon'
}, {
  number: 86,
  name: 'Kina'
}, {
  number: 84,
  name: 'Vietnam'
}, {
  number: 82,
  name: 'Sydkorea'
}, {
  number: 81,
  name: 'Japan'
}, {
  number: 66,
  name: 'Thailand'
}, {
  number: 65,
  name: 'Singapore'
}, {
  number: 64,
  name: 'Nya Zeeland'
}, {
  number: 64,
  name: 'Pitcairn'
}, {
  number: 63,
  name: 'Filippinerna'
}, {
  number: 62,
  name: 'Indonesien'
}, {
  number: 61,
  name: 'Australien'
}, {
  number: 61,
  name: 'Julön'
}, {
  number: 61,
  name: 'Cocosöarna'
}, {
  number: 60,
  name: 'Malaysia'
}, {
  number: 58,
  name: 'Venezuela'
}, {
  number: 57,
  name: 'Colombia'
}, {
  number: 56,
  name: 'Chile'
}, {
  number: 55,
  name: 'Brasilien'
}, {
  number: 54,
  name: 'Argentina'
}, {
  number: 53,
  name: 'Kuba'
}, {
  number: 52,
  name: 'Mexico'
}, {
  number: 51,
  name: 'Peru'
}, {
  number: 49,
  name: 'Tyskland'
}, {
  number: 48,
  name: 'Polen'
}, {
  number: 47,
  name: 'Svalbard och Jan Mayen'
}, {
  number: 44,
  name: 'Storbritannien'
}, {
  number: 43,
  name: 'Österrike'
}, {
  number: 41,
  name: 'Schweiz'
}, {
  number: 40,
  name: 'Rumänien'
}, {
  number: 39,
  name: 'Italien'
}, {
  number: 36,
  name: 'Ungern'
}, {
  number: 34,
  name: 'Spanien'
}, {
  number: 33,
  name: 'Frankrike'
}, {
  number: 32,
  name: 'Belgien'
}, {
  number: 31,
  name: 'Nederländerna'
}, {
  number: 30,
  name: 'Grekland'
}, {
  number: 27,
  name: 'Sydafrika'
}, {
  number: 20,
  name: 'Egypten'
}, {
  number: 7,
  name: 'Kazakstan'
}, {
  number: 7,
  name: 'Ryssland'
}, {
  number: 1,
  name: 'Kanada'
}, {
  number: 1,
  name: 'USA'
}].sort((a, b) => a.name > b.name ? 1 : -1);

;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/PhoneInputAtom.logic.js

const defaultCode = {
  code: 46,
  codeIndex: 104
};
/* harmony default export */ var PhoneInputAtom_logic = ({
  matchPhoneWithCountry(phoneNumber) {
    if (!phoneNumber || phoneNumber === '') {
      return {
        ...defaultCode,
        phoneNumber: ''
      };
    }
    let number = phoneNumber.replace('+', '');
    let result;
    let prefixes = primaryPhoneCodes.concat(phoneCodes);
    prefixes.forEach(c => {
      let prefix = String(c.number);
      if (number.indexOf(prefix) === 0) {
        if (!result || String(result.number).length <= prefix.length) {
          result = c;
        }
      }
    });
    if (result === undefined) {
      return {
        ...defaultCode,
        phoneNumber: number
      };
    }
    return {
      code: result.number,
      codeIndex: prefixes.indexOf(result),
      phoneNumber: phoneNumber.replace('+' + result.number, '')
    };
  },
  getCountries() {
    return primaryPhoneCodes.concat(phoneCodes);
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=script&lang=js

/* harmony default export */ var PhoneInputAtomvue_type_script_lang_js = ({
  name: 'PhoneInputAtom',
  props: {
    label: String,
    value: {
      type: String,
      default: '+46'
    },
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    error: String,
    inactive: {
      type: Boolean,
      default: false
    },
    singleRow: Boolean
  },
  data: () => {
    return {
      code: undefined,
      number: undefined
    };
  },
  computed: {
    mask() {
      return '################';
    },
    phoneCodes() {
      return PhoneInputAtom_logic.getCountries();
    },
    prefixClasses() {
      return {
        'phone-input-atom__row__prefix-dropdown--error': this.error
      };
    },
    inputClasses() {
      return {
        'phone-input-atom__row__input--error': this.error
      };
    },
    textColor() {
      return {
        'phone-input-atom--disabled': this.disabled,
        'phone-input-atom--single-row': this.singleRow
      };
    },
    labelClasses() {
      return {
        'ace-input-label--disabled': this.disabled,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    }
  },
  emits: ['input'],
  methods: {
    emitInput() {
      if (!this.number) {
        this.$emit('input', '');
      } else {
        this.$emit('input', '+' + this.code + this.number);
      }
    },
    changeNumber(e) {
      if (!(this.number == e.target.value)) {
        this.number = e.target.value;
        this.emitInput();
      }
    },
    changeCode(code) {
      document.getElementsByClassName('phone-input-atom__row')[0].blur();
      this.code = code.number;
      this.emitInput();
    },
    updateNumber() {
      const res = PhoneInputAtom_logic.matchPhoneWithCountry(this.value);
      this.code = res.code;
      this.number = res.phoneNumber;
    }
  },
  mounted() {
    this.updateNumber();
  },
  watch: {
    value(nv, ov) {
      if (nv !== ov) {
        this.updateNumber();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=style&index=0&id=2a6ab0a6&scoped=true&lang=css
var PhoneInputAtomvue_type_style_index_0_id_2a6ab0a6_scoped_true_lang_css = __webpack_require__(6602);
;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue?vue&type=style&index=0&id=2a6ab0a6&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/PhoneInputAtom.vue




;


const PhoneInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PhoneInputAtomvue_type_script_lang_js, [['render',PhoneInputAtomvue_type_template_id_2a6ab0a6_scoped_true_render],['__scopeId',"data-v-2a6ab0a6"]])

/* harmony default export */ var PhoneInputAtom = (PhoneInputAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/PhoneInputAtom/index.js

/* harmony default export */ var atoms_PhoneInputAtom = (PhoneInputAtom);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PriceFilterAtom.vue?vue&type=template&id=a7b8b5c8

function PriceFilterAtomvue_type_template_id_a7b8b5c8_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", null, (0,external_vue_namespaceObject.toDisplayString)($options.formattedPriceValue), 1);
}
;// CONCATENATED MODULE: ./src/components/atoms/PriceFilterAtom.vue?vue&type=template&id=a7b8b5c8

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/PriceFilterAtom.vue?vue&type=script&lang=js

/* harmony default export */ var PriceFilterAtomvue_type_script_lang_js = ({
  name: 'PriceFilterAtom',
  props: {
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    formattedPriceValue() {
      return helpers.formatPrice(this.value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/PriceFilterAtom.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/atoms/PriceFilterAtom.vue




;
const PriceFilterAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PriceFilterAtomvue_type_script_lang_js, [['render',PriceFilterAtomvue_type_template_id_a7b8b5c8_render]])

/* harmony default export */ var PriceFilterAtom = (PriceFilterAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressBarAtom.vue?vue&type=template&id=14f55132&scoped=true

const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-14f55132"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_1 = {
  class: "progress-bar-atom"
};
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_2 = {
  class: "progress-bar-atom__wrapper"
};
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_3 = /*#__PURE__*/ProgressBarAtomvue_type_template_id_14f55132_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "progress-bar-atom__wrapper__label-container__glue"
}, null, -1));
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_4 = {
  class: "progress-bar-atom__wrapper__label-container__label"
};
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_5 = {
  key: 0,
  div: "",
  class: "progress-bar-atom__hole-container"
};
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_6 = /*#__PURE__*/ProgressBarAtomvue_type_template_id_14f55132_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "progress-bar-atom__hole-container__hole"
}, null, -1));
const ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_7 = [ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_6];
function ProgressBarAtomvue_type_template_id_14f55132_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-bar-atom__wrapper__label-container",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.labelProgressWidth)
  }, [ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_3, (0,external_vue_namespaceObject.createElementVNode)("span", ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)($options.getPercentage) + "% klart", 1)], 4), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["progress-bar-atom__wrapper__bar", $options.barModeClass])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["progress-bar-atom__wrapper__bar__progress", $options.progressModeClass]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.progressWidth)
  }, null, 6), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-bar-atom__wrapper__bar__ball-container",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.ballContainerStyle)
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-bar-atom__wrapper__bar__ball-container__ball",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.ballStyle)
  }, null, 4), [[external_vue_namespaceObject.vShow, $props.mode == 'golf']])], 4)], 2)]), $props.mode == 'golf' ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_5, ProgressBarAtomvue_type_template_id_14f55132_scoped_true_hoisted_7)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/ProgressBarAtom.vue?vue&type=template&id=14f55132&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressBarAtom.vue?vue&type=script&lang=js
/* harmony default export */ var ProgressBarAtomvue_type_script_lang_js = ({
  name: 'ProgressBarAtom',
  props: {
    percentage: Number,
    mode: {
      type: String,
      validator: value => {
        return ['default', 'golf'].includes(value);
      }
    }
  },
  computed: {
    progressWidth() {
      return {
        width: '' + this.getPercentage + '%'
      };
    },
    labelProgressWidth() {
      return {
        width: '' + this.getPercentage + '%'
      };
    },
    barModeClass() {
      switch (this.mode) {
        case 'default':
          return 'progress-bar-atom__wrapper__bar--default';
        default:
          return '';
      }
    },
    progressModeClass() {
      switch (this.mode) {
        case 'default':
          return 'progress-bar-atom__wrapper__bar__progress--default';
        case 'golf':
          return 'progress-bar-atom__wrapper__bar__progress--golf';
        default:
          return '';
      }
    },
    ballContainerStyle() {
      let style = {
        left: '' + this.getPercentage + '%'
      };
      return style;
    },
    ballStyle() {
      if (this.getPercentage == 100) {
        return {
          transition: 'transform 0.7s ease',
          transform: 'translate(50%, 100%)'
        };
      }
      return '';
    },
    getPercentage() {
      return Math.min(Math.max(this.percentage, 0), 100);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ProgressBarAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressBarAtom.vue?vue&type=style&index=0&id=14f55132&scoped=true&lang=css
var ProgressBarAtomvue_type_style_index_0_id_14f55132_scoped_true_lang_css = __webpack_require__(4684);
;// CONCATENATED MODULE: ./src/components/atoms/ProgressBarAtom.vue?vue&type=style&index=0&id=14f55132&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ProgressBarAtom.vue




;


const ProgressBarAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressBarAtomvue_type_script_lang_js, [['render',ProgressBarAtomvue_type_template_id_14f55132_scoped_true_render],['__scopeId',"data-v-14f55132"]])

/* harmony default export */ var ProgressBarAtom = (ProgressBarAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressCircleAtom.vue?vue&type=template&id=0ea51692&scoped=true

function ProgressCircleAtomvue_type_template_id_0ea51692_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: "progress-circle-atom",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.containerStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-circle-atom__background progress-circle-atom__circle",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.backgroundStyle)
  }, null, 4), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-circle-atom__circle",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.primaryCircleStyle)
  }, null, 4), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-circle-atom__append-mask",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.maskStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "progress-circle-atom__circle",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.appendCircleStyle)
  }, null, 4)], 4), (0,external_vue_namespaceObject.createElementVNode)("h3", null, (0,external_vue_namespaceObject.toDisplayString)($options.getPercentage) + "%", 1)], 4);
}
;// CONCATENATED MODULE: ./src/components/atoms/ProgressCircleAtom.vue?vue&type=template&id=0ea51692&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressCircleAtom.vue?vue&type=script&lang=js

function calculateAppendDegrees(percent) {
  const base = 45.0;
  return percent * 3.6 - base;
}
function calculateBorderFill(percent) {
  let output = [];
  const thresholds = [25.0, 50.0, 75.0, 100.0];
  for (const threshold of thresholds) {
    if (percent >= threshold) {
      output.push('currentColor');
    } else {
      output.push('transparent');
    }
  }
  return output.join(' ');
}
/* harmony default export */ var ProgressCircleAtomvue_type_script_lang_js = ({
  name: 'ProgressCircleAtom',
  props: {
    percentage: Number,
    radius: {
      type: Number,
      default: 50
    },
    thickness: {
      type: Number,
      default: 10
    }
  },
  computed: {
    containerStyle() {
      return {
        width: '' + 2 * (this.radius + this.thickness) + 'px',
        height: '' + 2 * (this.radius + this.thickness) + 'px',
        'line-height': '' + 2 * (this.radius + this.thickness) + 'px',
        'border-radius': '' + (this.radius + this.thickness) + 'px',
        'background-color': 'transparent'
      };
    },
    primaryCircleStyle() {
      return {
        height: '' + 2 * this.radius + 'px',
        width: '' + 2 * this.radius + 'px',
        border: '' + this.thickness + 'px solid',
        'border-color': calculateBorderFill(this.getPercentage),
        transform: 'rotate(45deg)'
      };
    },
    appendCircleStyle() {
      return {
        height: '' + 2 * this.radius + 'px',
        width: '' + 2 * this.radius + 'px',
        border: '' + this.thickness + 'px solid',
        'border-color': 'currentColor transparent transparent transparent',
        transform: 'rotate(' + calculateAppendDegrees(this.getPercentage) + 'deg)',
        left: '-100%'
      };
    },
    backgroundStyle() {
      return {
        height: '' + 2 * this.radius + 'px',
        width: '' + 2 * this.radius + 'px',
        border: '' + this.thickness + 'px solid #f4f4f4'
      };
    },
    maskStyle() {
      let style = {};
      if (this.getPercentage < 25.0) {
        style.overflow = 'hidden';
      }
      return style;
    },
    getPercentage() {
      return Math.min(Math.max(this.percentage, 0), 100);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ProgressCircleAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ProgressCircleAtom.vue?vue&type=style&index=0&id=0ea51692&scoped=true&lang=css
var ProgressCircleAtomvue_type_style_index_0_id_0ea51692_scoped_true_lang_css = __webpack_require__(4915);
;// CONCATENATED MODULE: ./src/components/atoms/ProgressCircleAtom.vue?vue&type=style&index=0&id=0ea51692&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ProgressCircleAtom.vue




;


const ProgressCircleAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressCircleAtomvue_type_script_lang_js, [['render',ProgressCircleAtomvue_type_template_id_0ea51692_scoped_true_render],['__scopeId',"data-v-0ea51692"]])

/* harmony default export */ var ProgressCircleAtom = (ProgressCircleAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/RadioAtom.vue?vue&type=template&id=7afba67e&scoped=true

const RadioAtomvue_type_template_id_7afba67e_scoped_true_withScopeId = n => (_pushScopeId("data-v-7afba67e"), n = n(), _popScopeId(), n);
const RadioAtomvue_type_template_id_7afba67e_scoped_true_hoisted_1 = ["title"];
const RadioAtomvue_type_template_id_7afba67e_scoped_true_hoisted_2 = {
  key: 0,
  class: "radio-atom__icon"
};
function RadioAtomvue_type_template_id_7afba67e_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-atom ace-no-select", {
      'radio-atom--disabled': $props.disabled
    }]),
    title: $options.tooltip,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClick && $options.onClick(...args))
  }, [$props.label != undefined ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-atom__label", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-atom__wrapper", $options.getWrapperClass])
  }, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-atom__button", $options.getClass])
  }, [$options.isSelected ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", RadioAtomvue_type_template_id_7afba67e_scoped_true_hoisted_2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $props.option ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-atom__option", $options.getOptionClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.option), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)], 10, RadioAtomvue_type_template_id_7afba67e_scoped_true_hoisted_1);
}
;// CONCATENATED MODULE: ./src/components/atoms/RadioAtom.vue?vue&type=template&id=7afba67e&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/RadioAtom.vue?vue&type=script&lang=js

/* harmony default export */ var RadioAtomvue_type_script_lang_js = ({
  name: 'RadioAtom',
  props: {
    label: String,
    value: [String, Boolean, Number],
    option: String,
    optionValue: [String, Boolean, Number],
    disabled: Boolean,
    inactive: Boolean,
    truncated: Boolean
  },
  computed: {
    tooltip() {
      if (this.truncated) {
        return this.option;
      }
      return undefined;
    },
    isSelected() {
      if (this.value === undefined) {
        return false;
      }
      return this.value === this.optionValue;
    },
    getLabelClass() {
      return {
        'radio-atom__label--disabled': this.disabled,
        'radio-atom__label--inactive': this.inactive
      };
    },
    getWrapperClass() {
      return {
        'radio-atom__wrapper--inactive': this.inactive
      };
    },
    getClass() {
      var classes = [];
      if (this.disabled) {
        classes.push('radio-atom__button--disabled');
      }
      if (this.isSelected) {
        classes.push('radio-atom__button--is-checked');
      }
      if (this.disabled && this.value) {
        classes.push('radio-atom__button--is-checked--disabled');
      }
      if (this.inactive) {
        classes.push('radio-atom__button--inactive');
      }
      return classes.join(' ');
    },
    getOptionClass() {
      return {
        'radio-atom__option--disabled': this.disabled,
        'ace-clamp': this.truncated
      };
    }
  },
  emits: ['input'],
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('input', this.optionValue);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/RadioAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/RadioAtom.vue?vue&type=style&index=0&id=7afba67e&scoped=true&lang=css
var RadioAtomvue_type_style_index_0_id_7afba67e_scoped_true_lang_css = __webpack_require__(8373);
;// CONCATENATED MODULE: ./src/components/atoms/RadioAtom.vue?vue&type=style&index=0&id=7afba67e&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/RadioAtom.vue




;


const RadioAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(RadioAtomvue_type_script_lang_js, [['render',RadioAtomvue_type_template_id_7afba67e_scoped_true_render],['__scopeId',"data-v-7afba67e"]])

/* harmony default export */ var RadioAtom = (RadioAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=template&id=76513d4e&scoped=true

const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-76513d4e"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_1 = {
  key: 0,
  class: "searchable-dropdown-atom__inactive-value"
};
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_2 = {
  key: 1,
  class: "searchable-dropdown-atom__row"
};
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_3 = ["value", "placeholder"];
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_4 = {
  key: 0,
  class: "searchable-dropdown-atom__row__error-icon"
};
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_5 = /*#__PURE__*/SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_6 = [SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_5];
const SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_7 = {
  key: 2,
  class: "searchable-dropdown-atom__error"
};
function SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OptionListParticle = (0,external_vue_namespaceObject.resolveComponent)("OptionListParticle");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["searchable-dropdown-atom", $options.textColor]),
    onKeyup: [_cache[6] || (_cache[6] = (0,external_vue_namespaceObject.withKeys)($event => $options.onEnter(), ["enter"])), _cache[7] || (_cache[7] = (0,external_vue_namespaceObject.withKeys)($event => $options.onEsc(), ["esc"]))]
  }, [(0,external_vue_namespaceObject.createElementVNode)("label", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["searchable-dropdown-atom__label", $options.labelClasses])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 3), $props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_1, (0,external_vue_namespaceObject.toDisplayString)($props.value), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("input", {
    type: "text",
    class: (0,external_vue_namespaceObject.normalizeClass)(["searchable-dropdown-atom__row__input", $options.inputClasses]),
    value: $props.value,
    onInput: _cache[0] || (_cache[0] = $event => $options.emitInput($event.target.value)),
    placeholder: $props.placeholder,
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.inputFocus = true),
    onBlur: _cache[2] || (_cache[2] = $event => $options.onInputBlur()),
    onKeyup: [_cache[3] || (_cache[3] = (0,external_vue_namespaceObject.withKeys)($event => $options.onUp(), ["up"])), _cache[4] || (_cache[4] = (0,external_vue_namespaceObject.withKeys)($event => $options.onDown(), ["down"]))]
  }, null, 42, SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_3), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_4, SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createVNode)(_component_OptionListParticle, {
    open: $options.open,
    focus: _ctx.inputFocus && _ctx.focusedOptionIndex == undefined,
    currentFocus: $options.getFilteredOptions[_ctx.focusedOptionIndex],
    options: $options.getFilteredOptions,
    value: $props.value,
    onChange: _cache[5] || (_cache[5] = $event => $options.emitInput($event))
  }, null, 8, ["open", "focus", "currentFocus", "options", "value"])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_hoisted_7, (0,external_vue_namespaceObject.toDisplayString)($props.error), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 34);
}
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=template&id=76513d4e&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=template&id=6690b1ef&scoped=true

const OptionListParticlevue_type_template_id_6690b1ef_scoped_true_withScopeId = n => (_pushScopeId("data-v-6690b1ef"), n = n(), _popScopeId(), n);
const OptionListParticlevue_type_template_id_6690b1ef_scoped_true_hoisted_1 = ["id", "onClick"];
const OptionListParticlevue_type_template_id_6690b1ef_scoped_true_hoisted_2 = {
  class: "searchable-dropdown-atom__options__option searchable-dropdown-atom__options__option--none"
};
function OptionListParticlevue_type_template_id_6690b1ef_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["searchable-dropdown-atom__options ace-scroll", $options.optionsClass])
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.options, (option, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      id: option,
      class: (0,external_vue_namespaceObject.normalizeClass)(["searchable-dropdown-atom__options__option", $options.optionClass(option)]),
      key: index,
      onClick: $event => $options.onOptionClick(option),
      tabindex: 0,
      onMousedown: _cache[0] || (_cache[0] = $event => $options.onOptionPressed())
    }, (0,external_vue_namespaceObject.toDisplayString)(option), 43, OptionListParticlevue_type_template_id_6690b1ef_scoped_true_hoisted_1);
  }), 128)), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("div", OptionListParticlevue_type_template_id_6690b1ef_scoped_true_hoisted_2, "Inga matchningar", 512), [[external_vue_namespaceObject.vShow, $props.options.length == 0]])], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=template&id=6690b1ef&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=script&lang=js
/* harmony default export */ var OptionListParticlevue_type_script_lang_js = ({
  name: 'OptionListParticle',
  props: {
    open: Boolean,
    focus: Boolean,
    options: Array,
    currentFocus: String
  },
  data: () => {
    return {
      optionPressed: false
    };
  },
  computed: {
    optionsClass() {
      return {
        'searchable-dropdown-atom__options--open': this.open || this.optionPressed,
        'searchable-dropdown-atom__options--input-focus': this.focus
      };
    }
  },
  emits: ['change'],
  methods: {
    optionClass(option) {
      return {
        'searchable-dropdown-atom__options__option--custom-focus': this.currentFocus == option
      };
    },
    onOptionPressed() {
      this.optionPressed = true;
    },
    onOptionClick(option) {
      this.optionPressed = false;
      this.$emit('change', option);
    }
  },
  watch: {
    currentFocus: val => {
      if (val != undefined) {
        document.getElementById(val).scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: 'smooth'
        });
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=style&index=0&id=6690b1ef&scoped=true&lang=css
var OptionListParticlevue_type_style_index_0_id_6690b1ef_scoped_true_lang_css = __webpack_require__(5765);
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue?vue&type=style&index=0&id=6690b1ef&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/OptionListParticle.vue




;


const OptionListParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(OptionListParticlevue_type_script_lang_js, [['render',OptionListParticlevue_type_template_id_6690b1ef_scoped_true_render],['__scopeId',"data-v-6690b1ef"]])

/* harmony default export */ var OptionListParticle = (OptionListParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=script&lang=js

/* harmony default export */ var SearchableDropdownAtomvue_type_script_lang_js = ({
  name: 'SearchableDropdownAtom',
  components: {
    OptionListParticle: OptionListParticle
  },
  props: {
    label: String,
    value: {
      type: String,
      default: ''
    },
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    error: String,
    inactive: {
      type: Boolean,
      default: false
    },
    options: Array
  },
  data: () => {
    return {
      inputFocus: false,
      optionPressed: false,
      filteredOptions: undefined,
      focusedOptionIndex: undefined,
      prevFilter: '',
      uniqueOptions: undefined
    };
  },
  computed: {
    inputClasses() {
      return {
        'searchable-dropdown-atom__row__input--error': this.error,
        'searchable-dropdown-atom__row__input--custom-focus': this.inputFocus && this.focusedOptionIndex == undefined
      };
    },
    textColor() {
      return {
        'searchable-dropdown-atom--disabled': this.disabled
      };
    },
    labelClasses() {
      return {
        'searchable-dropdown-atom__label--disabled': this.disabled
      };
    },
    open() {
      return this.inputFocus || this.optionPressed;
    },
    getOptions() {
      if (!this.uniqueOptions) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.uniqueOptions = [...new Set(this.options)];
      }
      return this.uniqueOptions;
    },
    getFilteredOptions() {
      if (this.value != this.prevFilter || !this.filteredOptions || this.value == '') {
        if (this.focusedOptionIndex) {
          const currOption = this.filteredOptions[this.focusedOptionIndex];
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.filteredOptions = this.filter(this.getOptions);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.focusedOptionIndex = this.filteredOptions.indexOf(currOption);
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.filteredOptions = this.filter(this.getOptions);
        }
      }
      return this.filteredOptions;
    }
  },
  emits: ['input'],
  methods: {
    emitInput(value) {
      this.$emit('input', value);
    },
    onInputBlur() {
      this.inputFocus = false;
      this.focusedOptionIndex = undefined;
    },
    filter(options) {
      if (this.value == '') return options;
      return options.filter(o => {
        let searchLength = this.value.length;
        if (searchLength <= o.length) {
          let optionString = o.substring(0, searchLength);
          return optionString.toLowerCase() == this.value.toLowerCase();
        }
      });
    },
    onEnter() {
      if (this.focusedOptionIndex != undefined) {
        this.emitInput(this.getFilteredOptions[this.focusedOptionIndex]);
        this.focusedOptionIndex = undefined;
        document.getElementsByClassName('searchable-dropdown-atom__row__input')[0].blur();
      }
    },
    adjustIndex() {
      if (this.focusedOptionIndex < 0) {
        this.focusedOptionIndex = this.filteredOptions.length - 1;
      }
      if (this.focusedOptionIndex == this.filteredOptions.length) {
        this.focusedOptionIndex = 0;
      }
    },
    onUp() {
      if (this.focusedOptionIndex == undefined) {
        this.focusedOptionIndex = this.getFilteredOptions.length - 1;
      } else {
        this.focusedOptionIndex -= 1;
      }
      this.adjustIndex();
    },
    onDown() {
      if (this.focusedOptionIndex == undefined) {
        this.focusedOptionIndex = 0;
      } else {
        this.focusedOptionIndex += 1;
      }
      this.adjustIndex();
    },
    onEsc() {
      document.getElementsByClassName('searchable-dropdown-atom__row__input')[0].blur();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=style&index=0&id=76513d4e&scoped=true&lang=css
var SearchableDropdownAtomvue_type_style_index_0_id_76513d4e_scoped_true_lang_css = __webpack_require__(9743);
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue?vue&type=style&index=0&id=76513d4e&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/SearchableDropdownAtom.vue




;


const SearchableDropdownAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SearchableDropdownAtomvue_type_script_lang_js, [['render',SearchableDropdownAtomvue_type_template_id_76513d4e_scoped_true_render],['__scopeId',"data-v-76513d4e"]])

/* harmony default export */ var SearchableDropdownAtom = (SearchableDropdownAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/SearchableDropdownAtom/index.js

/* harmony default export */ var atoms_SearchableDropdownAtom = (SearchableDropdownAtom);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchAtom.vue?vue&type=template&id=5455c1ff&scoped=true

const SearchAtomvue_type_template_id_5455c1ff_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-5455c1ff"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_1 = ["placeholder", "value", "disabled", "autofocus"];
const SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_2 = /*#__PURE__*/SearchAtomvue_type_template_id_5455c1ff_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#search"
}, null, -1));
const SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_3 = [SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_2];
function SearchAtomvue_type_template_id_5455c1ff_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: "search-atom",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.widthStyle)
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    ref: "input",
    class: (0,external_vue_namespaceObject.normalizeClass)(["search-atom__input", $options.inputClass]),
    placeholder: $props.placeholder,
    value: $props.value,
    disabled: $props.disabled,
    autofocus: $props.autofocus,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    onKeyup: _cache[1] || (_cache[1] = (0,external_vue_namespaceObject.withKeys)((...args) => $options.onSearch && $options.onSearch(...args), ["enter"]))
  }, null, 42, SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_1), [[_directive_mask, $options.inputMask]]), ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["search-atom__icon", $options.iconClass]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onSearch && $options.onSearch(...args))
  }, SearchAtomvue_type_template_id_5455c1ff_scoped_true_hoisted_3, 2))], 4);
}
;// CONCATENATED MODULE: ./src/components/atoms/SearchAtom.vue?vue&type=template&id=5455c1ff&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchAtom.vue?vue&type=script&lang=js
/* harmony default export */ var SearchAtomvue_type_script_lang_js = ({
  name: 'SearchAtom',
  props: {
    placeholder: String,
    disabled: Boolean,
    width: {
      type: [Number, String],
      default: 300
    },
    value: String,
    mask: String,
    autofocus: Boolean
  },
  computed: {
    widthStyle() {
      if (Number.isInteger(this.width)) {
        return 'width: ' + this.width + 'px';
      } else {
        return 'width: ' + this.width + '';
      }
    },
    inputClass() {
      return this.disabled ? 'search-atom__input--disabled' : '';
    },
    iconClass() {
      return this.disabled ? 'search-atom__icon--disabled' : '';
    },
    inputMask() {
      if (this.mask) return this.mask;else return '';
    }
  },
  emits: ['input', 'search'],
  methods: {
    onInput(e) {
      var val = e.target.value;
      if (val !== this.value) {
        this.$emit('input', val);
      }
    },
    onSearch() {
      this.$emit('search', this.value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/SearchAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SearchAtom.vue?vue&type=style&index=0&id=5455c1ff&scoped=true&lang=css
var SearchAtomvue_type_style_index_0_id_5455c1ff_scoped_true_lang_css = __webpack_require__(5580);
;// CONCATENATED MODULE: ./src/components/atoms/SearchAtom.vue?vue&type=style&index=0&id=5455c1ff&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/SearchAtom.vue




;


const SearchAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SearchAtomvue_type_script_lang_js, [['render',SearchAtomvue_type_template_id_5455c1ff_scoped_true_render],['__scopeId',"data-v-5455c1ff"]])

/* harmony default export */ var SearchAtom = (SearchAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=template&id=3cda9b10&scoped=true

const StepsAtomvue_type_template_id_3cda9b10_scoped_true_withScopeId = n => (_pushScopeId("data-v-3cda9b10"), n = n(), _popScopeId(), n);
const StepsAtomvue_type_template_id_3cda9b10_scoped_true_hoisted_1 = {
  class: "steps-atom"
};
function StepsAtomvue_type_template_id_3cda9b10_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_StepParticle = (0,external_vue_namespaceObject.resolveComponent)("StepParticle");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", StepsAtomvue_type_template_id_3cda9b10_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.steps, (step, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_StepParticle, {
      key: index,
      label: step.label,
      disabled: step.disabled,
      index: index,
      currentIndex: $options.currentIndex,
      maxIndex: $props.steps.length - 1,
      nonSequential: $props.nonSequential,
      onClick: $event => $options.emitStep(step)
    }, null, 8, ["label", "disabled", "index", "currentIndex", "maxIndex", "nonSequential", "onClick"]);
  }), 128))]);
}
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=template&id=3cda9b10&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=template&id=1e2841b2&scoped=true

const StepParticlevue_type_template_id_1e2841b2_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-1e2841b2"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_1 = {
  key: 0,
  class: "ace-no-select"
};
const StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_2 = {
  key: 1
};
const StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_3 = /*#__PURE__*/StepParticlevue_type_template_id_1e2841b2_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#check-mark-secondary"
}, null, -1));
const StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_4 = [StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_3];
function StepParticlevue_type_template_id_1e2841b2_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["step-particle", $options.getStepClasses])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["step-particle__value", $options.getValueClasses]),
    onClick: _cache[0] || (_cache[0] = $event => $options.emitClick())
  }, [!($options.isCompleted && !this.disabled) ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_1, (0,external_vue_namespaceObject.toDisplayString)(this.stepNumber), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.isCompleted && !this.disabled && !this.nonSequential ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_2, StepParticlevue_type_template_id_1e2841b2_scoped_true_hoisted_4)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["step-particle__label ace-no-select", $options.getLabelClasses]),
    onClick: _cache[1] || (_cache[1] = $event => $options.emitClick())
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 3), !$options.isLast ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["step-particle__tail", $options.getTailClasses])
  }, null, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=template&id=1e2841b2&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=script&lang=js

/* harmony default export */ var StepParticlevue_type_script_lang_js = ({
  name: 'StepParticle',
  props: {
    label: String,
    index: Number,
    currentIndex: Number,
    maxIndex: Number,
    disabled: Boolean,
    nonSequential: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stepNumber() {
      return this.nonSequential ? '' : this.index + 1;
    },
    isCompleted() {
      return this.index < this.currentIndex;
    },
    isLast() {
      return this.index === this.maxIndex;
    },
    isCurrent() {
      return this.index === this.currentIndex;
    },
    getStepClasses() {
      let result = [];
      if (this.isCompleted) {
        result.push('step-particle--completed');
      }
      if (this.isCurrent) {
        result.push('step-particle--current');
      }
      if (this.isLast) {
        result.push('step-particle--last');
      }
      if (this.disabled) {
        result.push('step-particle--disabled');
      }
      return result.join(' ');
    },
    getValueClasses() {
      let result = [];
      if (this.isCompleted && !this.disabled) {
        result.push('step-particle__value--completed');
      }
      if (this.isCurrent) {
        result.push('step-particle__value--current');
      }
      return result.join(' ');
    },
    getTailClasses() {
      let result = [];
      if (this.isCompleted) {
        result.push('step-particle__tail--completed');
      }
      return result.join(' ');
    },
    getLabelClasses() {
      let result = [];
      if (this.isCompleted) {
        result.push('step-particle__label--completed');
      }
      if (this.isCurrent) {
        result.push('step-particle__label--current');
      }
      return result.join(' ');
    }
  },
  emits: ['click'],
  methods: {
    emitClick() {
      this.$emit('click');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=style&index=0&id=1e2841b2&scoped=true&lang=css
var StepParticlevue_type_style_index_0_id_1e2841b2_scoped_true_lang_css = __webpack_require__(2839);
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepParticle.vue?vue&type=style&index=0&id=1e2841b2&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepParticle.vue




;


const StepParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(StepParticlevue_type_script_lang_js, [['render',StepParticlevue_type_template_id_1e2841b2_scoped_true_render],['__scopeId',"data-v-1e2841b2"]])

/* harmony default export */ var StepParticle = (StepParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=script&lang=js

/* harmony default export */ var StepsAtomvue_type_script_lang_js = ({
  name: 'StepsAtom',
  props: {
    steps: Array,
    value: String,
    nonSequential: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StepParticle: StepParticle
  },
  computed: {
    currentIndex() {
      return this.steps.map(x => x.value).indexOf(this.value);
    }
  },
  emits: ['input'],
  methods: {
    emitStep(step) {
      this.$emit('input', step.value);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=style&index=0&id=3cda9b10&scoped=true&lang=css
var StepsAtomvue_type_style_index_0_id_3cda9b10_scoped_true_lang_css = __webpack_require__(8009);
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepsAtom.vue?vue&type=style&index=0&id=3cda9b10&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/StepsAtom.vue




;


const StepsAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(StepsAtomvue_type_script_lang_js, [['render',StepsAtomvue_type_template_id_3cda9b10_scoped_true_render],['__scopeId',"data-v-3cda9b10"]])

/* harmony default export */ var StepsAtom = (StepsAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/StepsAtom/index.js

/* harmony default export */ var atoms_StepsAtom = (StepsAtom);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TabAtom.vue?vue&type=template&id=418fcb97&scoped=true

const TabAtomvue_type_template_id_418fcb97_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-418fcb97"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TabAtomvue_type_template_id_418fcb97_scoped_true_hoisted_1 = /*#__PURE__*/TabAtomvue_type_template_id_418fcb97_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const TabAtomvue_type_template_id_418fcb97_scoped_true_hoisted_2 = [TabAtomvue_type_template_id_418fcb97_scoped_true_hoisted_1];
function TabAtomvue_type_template_id_418fcb97_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("button", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["tab-atom ace-no-select", $options.atomClasses]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClick && $options.onClick(...args))
  }, [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.label), 1), $options.isPrimary ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["tab-atom__icon", {
      'tab-atom__icon--is-selected': $props.selected
    }])
  }, TabAtomvue_type_template_id_418fcb97_scoped_true_hoisted_2, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TabAtom.vue?vue&type=template&id=418fcb97&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TabAtom.vue?vue&type=script&lang=js

const tabType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
/* harmony default export */ var TabAtomvue_type_script_lang_js = ({
  name: 'TabAtom',
  props: {
    label: String,
    selected: Boolean,
    disabled: Boolean,
    type: {
      type: String,
      validator: val => {
        return [tabType.PRIMARY, tabType.SECONDARY].includes(val);
      },
      default: tabType.PRIMARY
    }
  },
  computed: {
    atomClasses() {
      let classes = [];
      if (!this.selected && !this.disabled && this.isPrimary) {
        classes.push('ace-shadow');
      }
      if (this.selected) {
        classes.push('tab-atom--is-selected');
      }
      if (this.disabled) {
        classes.push('tab-atom--is-disabled');
      }
      if (this.isPrimary) {
        classes.push('tab-atom--is-primary');
      }
      if (this.isSecondary) {
        classes.push('tab-atom--is-secondary');
      }
      return classes.join(' ');
    },
    isPrimary() {
      return this.type === tabType.PRIMARY;
    },
    isSecondary() {
      return this.type === tabType.SECONDARY;
    }
  },
  emits: ['click'],
  methods: {
    onClick(e) {
      if (this.disabled) {
        return;
      }
      if (this.selected) {
        return;
      }
      this.$emit('click', e);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TabAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TabAtom.vue?vue&type=style&index=0&id=418fcb97&scoped=true&lang=css
var TabAtomvue_type_style_index_0_id_418fcb97_scoped_true_lang_css = __webpack_require__(8884);
;// CONCATENATED MODULE: ./src/components/atoms/TabAtom.vue?vue&type=style&index=0&id=418fcb97&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TabAtom.vue




;


const TabAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TabAtomvue_type_script_lang_js, [['render',TabAtomvue_type_template_id_418fcb97_scoped_true_render],['__scopeId',"data-v-418fcb97"]])

/* harmony default export */ var TabAtom = (TabAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/TableAtom.vue?vue&type=template&id=0289bfc2&scoped=true

const TableAtomvue_type_template_id_0289bfc2_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-0289bfc2"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_1 = {
  class: "container__table"
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_2 = ["onClick"];
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_3 = ["title"];
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_4 = {
  class: "ace-no-select ace-clamp"
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_5 = {
  key: 0,
  class: "container__table__header--details"
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_6 = {
  key: 1
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_7 = ["onClick"];
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_8 = {
  class: "ace-clamp"
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_9 = {
  key: 0,
  class: "container__table__row__data container__table__row__data--details"
};
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_10 = ["onClick"];
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_11 = /*#__PURE__*/TableAtomvue_type_template_id_0289bfc2_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down"
}, null, -1));
const TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_12 = [TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_11];
const _hoisted_13 = ["colspan"];
const _hoisted_14 = {
  key: 2
};
const _hoisted_15 = /*#__PURE__*/TableAtomvue_type_template_id_0289bfc2_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "container__table__row__data__loader ace-loader"
}, null, -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  key: 3
};
const _hoisted_18 = {
  class: "container__table__row container__table__row--sum"
};
const _hoisted_19 = ["colspan"];
const _hoisted_20 = {
  class: "container__footer"
};
function TableAtomvue_type_template_id_0289bfc2_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SortingParticle = (0,external_vue_namespaceObject.resolveComponent)("SortingParticle");
  const _component_MultiSumParticle = (0,external_vue_namespaceObject.resolveComponent)("MultiSumParticle");
  const _component_PagesParticle = (0,external_vue_namespaceObject.resolveComponent)("PagesParticle");
  const _component_ExpandableParticle = (0,external_vue_namespaceObject.resolveComponent)("ExpandableParticle");
  const _component_ScrollableFooterParticle = (0,external_vue_namespaceObject.resolveComponent)("ScrollableFooterParticle");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["container ace-scroll ace-column", {
      'container--nested': $props.nested
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "ace-scroll",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.tableContainerStyle)
  }, [(0,external_vue_namespaceObject.createElementVNode)("table", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("tr", {
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getStickyClass)
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.columnData, (column, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("th", {
      key: index,
      onClick: $event => $options.sortBy(column),
      style: (0,external_vue_namespaceObject.normalizeStyle)({
        width: column.width ? column.width : 'auto',
        maxWidth: column.maxWidth ? column.maxWidth : 'none',
        minWidth: column.minWidth ? column.minWidth : 'none'
      }),
      class: (0,external_vue_namespaceObject.normalizeClass)({
        ['container__table__th--' + column.hide]: column.hide
      })
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      class: "container__table__header",
      style: (0,external_vue_namespaceObject.normalizeStyle)($options.headerStyle(column)),
      title: column.tooltip
    }, [(0,external_vue_namespaceObject.createElementVNode)("span", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)(column.header), 1), (0,external_vue_namespaceObject.createVNode)(_component_SortingParticle, {
      header: column,
      currentSort: _ctx.currentSort
    }, null, 8, ["header", "currentSort"])], 12, TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_3)], 14, TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_2);
  }), 128)), $props.details && !$props.expandedDetails ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("th", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_5)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $props.multiSum !== undefined && $props.multiSumPosition == 'top' ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_MultiSumParticle, {
    key: 0,
    multiSum: $props.multiSum,
    columnData: $options.columnData
  }, null, 8, ["multiSum", "columnData"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.data !== undefined ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("tbody", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_6, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.calculatedData, (row, rowIndex) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, {
      key: 'data-row-' + rowIndex
    }, [(0,external_vue_namespaceObject.createElementVNode)("tr", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["container__table__row", $options.highlight(row, rowIndex)])
    }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.columnData, (column, cellIndex) => {
      return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("td", {
        class: (0,external_vue_namespaceObject.normalizeClass)(["container__table__row__data", {
          ['container__table__td--' + column.hide]: column.hide
        }]),
        key: cellIndex,
        onClick: $event => $options.emitRow(row, column)
      }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
        class: "container__table__row__data__wrapper",
        style: (0,external_vue_namespaceObject.normalizeStyle)($options.cellStyle(column))
      }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, column.key, {
        value: row
      }, () => [(0,external_vue_namespaceObject.createElementVNode)("span", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_8, (0,external_vue_namespaceObject.toDisplayString)(row[column.key]), 1)], true)], 4)], 10, TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_7);
    }), 128)), $props.details && !$props.expandedDetails ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("td", TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_9, [!$options.hideDetailsForIndex[rowIndex] ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
      key: 0,
      class: (0,external_vue_namespaceObject.normalizeClass)(["container__table__row__data__icon", {
        'container__table__row__data__icon--active': _ctx.displayDetailsFor.includes(rowIndex)
      }]),
      onClick: $event => $options.onShowDetailsClick(rowIndex)
    }, TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_12, 10, TableAtomvue_type_template_id_0289bfc2_scoped_true_hoisted_10)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $props.details && $props.expandedDetails && !$options.hideDetailsForIndex[rowIndex] || $options.showDetails && !$options.hideDetailsForIndex[rowIndex] && _ctx.displayDetailsFor.includes(rowIndex) ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("tr", {
      key: 'details-row-' + rowIndex,
      class: (0,external_vue_namespaceObject.normalizeClass)(["container__table__row", {
        'container__table__row--details': !$props.expandedDetails,
        'container__table__row--odd': $props.expandedDetails && (rowIndex + 1) % 2 == 1
      }])
    }, [(0,external_vue_namespaceObject.createElementVNode)("td", {
      colspan: $options.detailsRowSpan,
      class: "container__table__row__data container__table__row__data--details-row"
    }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "details", {
      value: row
    }, undefined, true)], 8, _hoisted_13)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 64);
  }), 128))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.data === undefined ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("tbody", _hoisted_14, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)(5, n => {
    return (0,external_vue_namespaceObject.createElementVNode)("tr", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["container__table__row", {
        'container__table__row--odd': (n + 1) % 2 === 1
      }]),
      key: n
    }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.columnData, (cell, cellIndex) => {
      return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("td", {
        class: "container__table__row__data",
        key: cellIndex
      }, _hoisted_16);
    }), 128))], 2);
  }), 64))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.sum !== undefined ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("tbody", _hoisted_17, [(0,external_vue_namespaceObject.createElementVNode)("tr", _hoisted_18, [(0,external_vue_namespaceObject.createElementVNode)("td", {
    class: "container__table__row__data",
    colspan: $props.sum.colspan
  }, (0,external_vue_namespaceObject.toDisplayString)($props.sum.label), 9, _hoisted_19), (0,external_vue_namespaceObject.createElementVNode)("td", {
    class: "container__table__row__data",
    style: (0,external_vue_namespaceObject.normalizeStyle)({
      'text-align': $props.sum.align,
      'padding-right': $props.sum.align === 'right' ? '24px' : ''
    })
  }, (0,external_vue_namespaceObject.toDisplayString)($props.sum.value), 5)])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.multiSum !== undefined && $props.multiSumPosition == 'bottom' ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_MultiSumParticle, {
    key: 4,
    multiSum: $props.multiSum,
    columnData: $options.columnData
  }, null, 8, ["multiSum", "columnData"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])], 4), (0,external_vue_namespaceObject.createElementVNode)("div", _hoisted_20, [$options.showPaginated ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_PagesParticle, {
    key: 0,
    currentPage: _ctx.currentPage,
    pages: $options.pageAmount,
    pageLength: $props.pageLength,
    dataLength: $props.data.length,
    nested: $props.nested,
    onChange: $options.onPageChange,
    maxPagesDelta: 2
  }, null, 8, ["currentPage", "pages", "pageLength", "dataLength", "nested", "onChange"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.showExpand ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ExpandableParticle, {
    key: 1,
    onChange: _cache[0] || (_cache[0] = $event => _ctx.currentPage++)
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.mode == 'scrollable' && this.dataLength ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ScrollableFooterParticle, {
    key: 2,
    limit: $options.showScrollable,
    onExpand: _cache[1] || (_cache[1] = $event => _ctx.currentPage = 999),
    onFold: _cache[2] || (_cache[2] = $event => _ctx.currentPage = 1)
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "function", {}, undefined, true)]),
    _: 3
  }, 8, ["limit"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/TableAtom.vue?vue&type=template&id=0289bfc2&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=template&id=95c9d970&scoped=true

const ExpandableParticlevue_type_template_id_95c9d970_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-95c9d970"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_1 = /*#__PURE__*/ExpandableParticlevue_type_template_id_95c9d970_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "more-button__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-plus-secondary"
})], -1));
const ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_2 = /*#__PURE__*/ExpandableParticlevue_type_template_id_95c9d970_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("span", null, "Visa fler", -1));
const ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_3 = [ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_1, ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_2];
function ExpandableParticlevue_type_template_id_95c9d970_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: "more-button",
    onClick: _cache[0] || (_cache[0] = $event => $options.emitChange())
  }, ExpandableParticlevue_type_template_id_95c9d970_scoped_true_hoisted_3);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=template&id=95c9d970&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=script&lang=js
/* harmony default export */ var ExpandableParticlevue_type_script_lang_js = ({
  emits: ['change'],
  methods: {
    emitChange() {
      this.$emit('change');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=style&index=0&id=95c9d970&scoped=true&lang=css
var ExpandableParticlevue_type_style_index_0_id_95c9d970_scoped_true_lang_css = __webpack_require__(3570);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ExpandableParticle.vue?vue&type=style&index=0&id=95c9d970&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ExpandableParticle.vue




;


const ExpandableParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExpandableParticlevue_type_script_lang_js, [['render',ExpandableParticlevue_type_template_id_95c9d970_scoped_true_render],['__scopeId',"data-v-95c9d970"]])

/* harmony default export */ var ExpandableParticle = (ExpandableParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=template&id=0152bd0e&scoped=true

const PagesParticlevue_type_template_id_0152bd0e_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-0152bd0e"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_1 = {
  class: "pages__button-box"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_2 = /*#__PURE__*/PagesParticlevue_type_template_id_0152bd0e_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_3 = [PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_2];
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_4 = {
  key: 0,
  class: "pages__end-point"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_5 = {
  key: 0,
  class: "pages__button-box"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_6 = ["onClick"];
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_7 = {
  key: 1,
  class: "pages__end-point"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_8 = {
  key: 0,
  class: "pages__button-box"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_9 = {
  class: "pages__button-box"
};
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_10 = /*#__PURE__*/PagesParticlevue_type_template_id_0152bd0e_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_11 = [PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_10];
function PagesParticlevue_type_template_id_0152bd0e_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", null, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["pages", {
      'pages--nested': $props.nested
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["pages__previous", $options.previousClass]),
    onClick: _cache[0] || (_cache[0] = $event => $options.emitChange($props.currentPage - 1))
  }, PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_3, 2))]), $options.startIndex > 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_4, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "pages__button-box pages__index--inactive",
    onClick: _cache[1] || (_cache[1] = $event => $options.emitChange(1))
  }, "1"), $options.startIndex > 2 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_5, "...")) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.pageOptions, index => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "pages__button-box",
      key: index
    }, [(0,external_vue_namespaceObject.createElementVNode)("span", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["pages__index", $options.indexClass(index)]),
      onClick: $event => $options.emitChange(index)
    }, (0,external_vue_namespaceObject.toDisplayString)(index), 11, PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_6)]);
  }), 128)), $options.endIndex < $props.pages ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_7, [$options.endIndex < $props.pages - 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_8, "...")) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "pages__button-box pages__index--inactive",
    onClick: _cache[2] || (_cache[2] = $event => $options.emitChange($props.pages))
  }, (0,external_vue_namespaceObject.toDisplayString)($props.pages), 1)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_9, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["pages__next", $options.nextClass]),
    onClick: _cache[3] || (_cache[3] = $event => $options.emitChange($props.currentPage + 1))
  }, PagesParticlevue_type_template_id_0152bd0e_scoped_true_hoisted_11, 2))])], 2)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=template&id=0152bd0e&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=script&lang=js

/* harmony default export */ var PagesParticlevue_type_script_lang_js = ({
  props: {
    currentPage: Number,
    pages: Number,
    pageSize: {
      type: Number,
      default: 10
    },
    pageLength: Number,
    dataLength: Number,
    numberOfItems: Number,
    nested: Boolean,
    maxPagesDelta: {
      type: Number,
      default: 10
    }
  },
  computed: {
    numberOfVisibleItems() {
      let isLastPage = this.currentPage === this.endIndex;
      let lastItemNumber = isLastPage ? this.dataLength : this.pageLength * this.currentPage;
      let firstItemNumber = isLastPage ? this.pageLength * (this.currentPage - 1) + 1 : lastItemNumber - (this.pageLength - 1);
      return `${firstItemNumber}-${lastItemNumber} / ${this.dataLength}`;
    },
    numberOfPages() {
      if (!this.dataLength) {
        return 0;
      }
      return Math.ceil(this.dataLength / this.pageLength);
    },
    previousClass() {
      return this.disabledClass(this.currentPage - 1);
    },
    nextClass() {
      return this.disabledClass(this.currentPage + 1);
    },
    startIndex() {
      return Math.max(this.currentPage - this.maxPagesDelta, 1);
    },
    endIndex() {
      return Math.min(this.currentPage + this.maxPagesDelta, this.numberOfPages);
    },
    pageOptions() {
      const pages = [];
      for (let i = this.startIndex; i <= this.endIndex; i++) {
        // loop to go from startIndex to endIndex inclusive
        pages.push(i);
      }
      return pages;
    }
  },
  emits: ['change'],
  methods: {
    indexClass(index) {
      return index === this.currentPage ? 'pages__index--active' : 'pages__index--inactive';
    },
    disabledClass(index) {
      return index < 1 || index > this.pages ? 'pages__element--disabled' : 'pages__element--active';
    },
    emitChange(index) {
      if (index >= 1 && index <= this.pages) {
        this.$emit('change', index);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=style&index=0&id=0152bd0e&scoped=true&lang=css
var PagesParticlevue_type_style_index_0_id_0152bd0e_scoped_true_lang_css = __webpack_require__(3537);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/PagesParticle.vue?vue&type=style&index=0&id=0152bd0e&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/PagesParticle.vue




;


const PagesParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PagesParticlevue_type_script_lang_js, [['render',PagesParticlevue_type_template_id_0152bd0e_scoped_true_render],['__scopeId',"data-v-0152bd0e"]])

/* harmony default export */ var PagesParticle = (PagesParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=template&id=a6243cee&scoped=true

const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-a6243cee"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_1 = /*#__PURE__*/ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "footer__glue"
}, null, -1));
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_2 = /*#__PURE__*/ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("span", null, "Expandera tabell", -1));
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_3 = /*#__PURE__*/ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "footer__expand-button__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down-secondary"
})], -1));
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_4 = [ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_2, ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_3];
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_5 = /*#__PURE__*/ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("span", null, "Minimera tabell", -1));
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_6 = /*#__PURE__*/ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "footer__expand-button__icon icon-transform"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#circle-arrow-down-secondary"
})], -1));
const ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_7 = [ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_5, ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_6];
function ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["footer", $options.footerShadow])
  }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true), ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_1, $props.limit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: "footer__expand-button",
    onClick: _cache[0] || (_cache[0] = $event => $options.emitExpand())
  }, ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_4)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.limit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: "footer__expand-button",
    onClick: _cache[1] || (_cache[1] = $event => $options.emitFold())
  }, ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_hoisted_7)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=template&id=a6243cee&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=script&lang=js
/* harmony default export */ var ScrollableFooterParticlevue_type_script_lang_js = ({
  props: {
    limit: Boolean
  },
  computed: {
    footerShadow() {
      return this.limit ? 'footer--shadow' : '';
    }
  },
  emits: ['expand', 'fold'],
  methods: {
    emitExpand() {
      this.$emit('expand');
    },
    emitFold() {
      this.$emit('fold');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=style&index=0&id=a6243cee&scoped=true&lang=css
var ScrollableFooterParticlevue_type_style_index_0_id_a6243cee_scoped_true_lang_css = __webpack_require__(8515);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ScrollableFooterParticle.vue?vue&type=style&index=0&id=a6243cee&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/ScrollableFooterParticle.vue




;


const ScrollableFooterParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ScrollableFooterParticlevue_type_script_lang_js, [['render',ScrollableFooterParticlevue_type_template_id_a6243cee_scoped_true_render],['__scopeId',"data-v-a6243cee"]])

/* harmony default export */ var ScrollableFooterParticle = (ScrollableFooterParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=template&id=2ecd1a79&scoped=true

const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-2ecd1a79"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_1 = {
  key: 0,
  class: "sorting-icons"
};
const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_2 = /*#__PURE__*/SortingParticlevue_type_template_id_2ecd1a79_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_3 = [SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_2];
const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_4 = /*#__PURE__*/SortingParticlevue_type_template_id_2ecd1a79_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_5 = [SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_4];
function SortingParticlevue_type_template_id_2ecd1a79_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.header.sort ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["sorting-icons__icon sorting-icons__icon--up", $options.arrowClass($props.header, true)])
  }, SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_3, 2)), ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["sorting-icons__icon sorting-icons__icon--down", $options.arrowClass($props.header, false)])
  }, SortingParticlevue_type_template_id_2ecd1a79_scoped_true_hoisted_5, 2))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=template&id=2ecd1a79&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=script&lang=js
/* harmony default export */ var SortingParticlevue_type_script_lang_js = ({
  props: {
    header: Object,
    currentSort: Object
  },
  methods: {
    arrowClass(header, reverse) {
      if (this.currentSort.column && this.currentSort.column.key == header.key && this.currentSort.reverse == reverse) {
        return 'sorting-icons__icon--black';
      } else {
        return 'sorting-icons__icon--gray';
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=style&index=0&id=2ecd1a79&scoped=true&lang=css
var SortingParticlevue_type_style_index_0_id_2ecd1a79_scoped_true_lang_css = __webpack_require__(8646);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/SortingParticle.vue?vue&type=style&index=0&id=2ecd1a79&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/SortingParticle.vue




;


const SortingParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SortingParticlevue_type_script_lang_js, [['render',SortingParticlevue_type_template_id_2ecd1a79_scoped_true_render],['__scopeId',"data-v-2ecd1a79"]])

/* harmony default export */ var SortingParticle = (SortingParticle_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=template&id=efeb026c&scoped=true

const MultiSumParticlevue_type_template_id_efeb026c_scoped_true_withScopeId = n => (_pushScopeId("data-v-efeb026c"), n = n(), _popScopeId(), n);
const MultiSumParticlevue_type_template_id_efeb026c_scoped_true_hoisted_1 = {
  class: "container__table__row container__table__row--sum"
};
function MultiSumParticlevue_type_template_id_efeb026c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("tbody", null, [(0,external_vue_namespaceObject.createElementVNode)("tr", MultiSumParticlevue_type_template_id_efeb026c_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.columnData, (column, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("td", {
      key: index,
      class: "container__table__row__data",
      style: (0,external_vue_namespaceObject.normalizeStyle)({
        'text-align': $options.getMultiSumValue(index, 'align'),
        'padding-right': $options.getMultiSumValue(index, 'align') === 'right' ? '24px' : ''
      })
    }, (0,external_vue_namespaceObject.toDisplayString)($options.getMultiSumValue(index, 'value')), 5);
  }), 128))])]);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=template&id=efeb026c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=script&lang=js
/* harmony default export */ var MultiSumParticlevue_type_script_lang_js = ({
  props: {
    multiSum: Array,
    columnData: Array
  },
  methods: {
    getMultiSumValue(index, key) {
      return this.multiSum && this.multiSum[index] ? this.multiSum[index][key] : '';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=style&index=0&id=efeb026c&scoped=true&lang=css
var MultiSumParticlevue_type_style_index_0_id_efeb026c_scoped_true_lang_css = __webpack_require__(8385);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/MultiSumParticle.vue?vue&type=style&index=0&id=efeb026c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/MultiSumParticle.vue




;


const MultiSumParticle_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(MultiSumParticlevue_type_script_lang_js, [['render',MultiSumParticlevue_type_template_id_efeb026c_scoped_true_render],['__scopeId',"data-v-efeb026c"]])

/* harmony default export */ var MultiSumParticle = (MultiSumParticle_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/TableAtom.sort.logic.js
/* harmony default export */ var TableAtom_sort_logic = ({
  stringToSort(str, key) {
    switch (str) {
      case 'text':
        return (l, r) => {
          if (!l[key]) {
            return -1;
          }
          return l[key].localeCompare(r[key]);
        };
      case 'number':
        return (l, r) => {
          if (l[key] < r[key]) {
            return -1;
          }
          if (l[key] > r[key]) {
            return 1;
          }
          return 0;
        };
      case 'number-text':
        return (l, r) => {
          if (!l[key]) {
            return -1;
          }
          if (!r[key]) {
            return 1;
          }
          if (l[key].length < r[key].length) {
            return -1;
          }
          if (l[key].length > r[key].length) {
            return 1;
          }
          return l[key].localeCompare(r[key]);
        };
      case 'boolean':
        return (l, r) => {
          if (l[key] == r[key]) {
            return 0;
          }
          if (l[key]) {
            return -1;
          }
          return 1;
        };
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/TableAtom.vue?vue&type=script&lang=js







/* harmony default export */ var TableAtomvue_type_script_lang_js = ({
  name: 'TableAtom',
  components: {
    SortingParticle: SortingParticle,
    PagesParticle: PagesParticle,
    ExpandableParticle: ExpandableParticle,
    ScrollableFooterParticle: ScrollableFooterParticle,
    MultiSumParticle: MultiSumParticle
  },
  props: {
    data: {
      type: Array
    },
    columns: Array,
    pageLength: {
      type: Number,
      default: 4
    },
    multiSumPosition: {
      type: String,
      default: 'bottom'
    },
    mode: {
      type: String,
      default: 'paginated',
      validator: value => {
        return ['scrollable', 'expandable', 'paginated'].includes(value);
      }
    },
    sum: Object,
    multiSum: Array,
    details: Boolean,
    multiRowDetails: Boolean,
    emptyDetailsRule: Function,
    expandedDetails: Boolean,
    nested: Boolean,
    highLightRule: Function,
    sticky: Boolean
  },
  data: () => {
    return {
      currentSort: {
        column: undefined,
        reverse: false
      },
      currentPage: 1,
      limit: true,
      displayDetailsFor: []
    };
  },
  computed: {
    dataLength() {
      if (!this.data) return false;
      if (this.data.length > 5) {
        return true;
      }
      return false;
    },
    sortedData() {
      let copy = [...this.data];
      if (!this.currentSort.column) {
        return copy;
      }
      copy.sort((left, right) => {
        return this.currentSort.column.sort(left, right, this.currentSort.reverse);
      });
      if (this.currentSort.reverse) {
        copy.reverse();
      }
      return copy;
    },
    calculatedData() {
      if (this.mode == 'scrollable') {
        return this.sortedData;
      }
      let end = this.currentPage * this.pageLength;
      let start = end - this.pageLength;
      if (this.mode == 'expandable') {
        start = 0;
      }
      return this.sortedData.slice(start, end);
    },
    pagesLeft() {
      if (!this.data) return false;
      return this.data.length > this.currentPage * this.pageLength;
    },
    columnData() {
      let data = this.columns;
      for (const column of data) {
        if (!column.header) {
          column.header = column.key;
        }
        if (typeof column.sort === 'string') {
          column.sort = TableAtom_sort_logic.stringToSort(column.sort, column.key);
        }
      }
      return data;
    },
    pageAmount() {
      if (!this.data) {
        return 0;
      }
      return Math.ceil(this.data.length / this.pageLength);
    },
    tableContainerStyle() {
      let style = {};
      style.width = '100%';
      if (this.mode == 'scrollable') {
        style.overflowY = 'auto';
        if (this.showScrollable) {
          style.maxHeight = '245px';
        }
      }
      return style;
    },
    showExpand() {
      return this.mode == 'expandable' && this.pagesLeft;
    },
    showScrollable() {
      return this.mode == 'scrollable' && this.pagesLeft;
    },
    showPaginated() {
      return this.mode == 'paginated' && this.pageAmount > 1;
    },
    getStickyClass() {
      return {
        'container__table__header--sticky': this.sticky
      };
    },
    hideDetailsForIndex() {
      if (!this.emptyDetailsRule || !this.calculatedData) {
        return {};
      }
      let result = {};
      this.calculatedData.forEach((x, i) => {
        if (this.emptyDetailsRule(x)) {
          result[i] = true;
        }
      });
      return result;
    },
    showDetails() {
      if (!this.details) {
        return false;
      }
      return true;
    },
    detailsRowSpan() {
      if (this.expandedDetails) {
        return this.columnData.length;
      }
      return this.columnData.length + 1;
    }
  },
  emits: ['dataSorted', 'pageChanged', 'row'],
  methods: {
    sortBy(header) {
      //making the ProxyObject to normal object to be able to compare them
      const currentSortColumn = this.currentSort.column ? JSON.parse(JSON.stringify(this.currentSort.column)) : {};
      this.displayDetailsFor = [];
      if (currentSortColumn.header == header.header) {
        this.currentSort.reverse = !this.currentSort.reverse;
      } else if (header.sort) {
        this.currentSort.column = header;
        this.currentSort.reverse = false;
      }
      if (header.sort) {
        this.$emit('dataSorted');
      }
    },
    onPageChange(index) {
      this.displayDetailsFor = [];
      this.currentPage = index;
      this.$emit('pageChanged');
    },
    headerStyle(column) {
      return {
        cursor: column.sort ? 'pointer' : 'default',
        justifyContent: column.align ? column.align : 'left'
      };
    },
    cellStyle(column) {
      return {
        justifyContent: column.align ? column.align : 'left',
        'padding-right': column.align === 'right' && column.sort ? '14px' : '0'
      };
    },
    highlight(row, index) {
      let classes = [];
      if (row.cssClasses) {
        classes = classes.concat(row.cssClasses);
      }
      if ((index + 1) % 2 == 1) {
        classes.push('container__table__row--odd');
      }
      if (this.nested) {
        classes.push('container__table__row--nested');
      }
      if (this.displayDetailsFor.includes(index)) {
        classes.push('container__table__row--highlight');
      }
      if (this.highLightRule) {
        classes.push('container__table__row--dynamic');
        if (this.highLightRule(row)) {
          classes.push('container__table__row--highlight');
        }
      }
      return classes.join(' ');
    },
    emitRow(row, column) {
      if (column.disableClick) {
        return;
      }
      this.$emit('row', this.data.indexOf(row));
    },
    onShowDetailsClick(rowIndex) {
      if (this.displayDetailsFor.includes(rowIndex)) {
        if (this.multiRowDetails) {
          this.displayDetailsFor.splice(this.displayDetailsFor.indexOf(rowIndex), 1);
        } else {
          this.displayDetailsFor = [];
        }
      } else {
        if (this.multiRowDetails) {
          this.displayDetailsFor.push(rowIndex);
        } else {
          this.displayDetailsFor = [rowIndex];
        }
      }
    }
  },
  watch: {
    data: {
      handler() {
        this.displayDetailsFor = [];
      },
      deep: true
    },
    pageLength: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.currentPage = 1;
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/TableAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableAtom/TableAtom.vue?vue&type=style&index=0&id=0289bfc2&scoped=true&lang=css
var TableAtomvue_type_style_index_0_id_0289bfc2_scoped_true_lang_css = __webpack_require__(2088);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/TableAtom.vue?vue&type=style&index=0&id=0289bfc2&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/TableAtom.vue




;


const TableAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TableAtomvue_type_script_lang_js, [['render',TableAtomvue_type_template_id_0289bfc2_scoped_true_render],['__scopeId',"data-v-0289bfc2"]])

/* harmony default export */ var TableAtom = (TableAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/TableAtom/index.js

/* harmony default export */ var atoms_TableAtom = (TableAtom);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAreaAtom.vue?vue&type=template&id=6b16cbeb&scoped=true

const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-6b16cbeb"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_1 = {
  class: "text-area-atom"
};
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_2 = ["title"];
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_3 = ["disabled", "value", "maxlength", "autofocus"];
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_4 = {
  key: 0,
  class: "text-area-atom__max-length"
};
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_5 = {
  key: 1,
  class: "ace-input-icon--error"
};
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_6 = /*#__PURE__*/TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_7 = [TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_6];
function TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_1, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-wrapper", $options.getWrapperClass]),
    title: $props.error
  }, [(0,external_vue_namespaceObject.createElementVNode)("textarea", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-area-atom__text-area ace-input ace-scroll", $options.getTextAreaClass]),
    disabled: $props.disabled || $props.inactive,
    value: $props.value,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    maxlength: $props.maxlength,
    autofocus: $props.autofocus
  }, null, 42, TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_3), $props.maxlength ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)($options.charactersLeft), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.hasError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_5, TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_7)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 10, TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_hoisted_2)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/TextAreaAtom.vue?vue&type=template&id=6b16cbeb&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAreaAtom.vue?vue&type=script&lang=js
/* harmony default export */ var TextAreaAtomvue_type_script_lang_js = ({
  name: 'TextAreaAtom',
  props: {
    error: String,
    label: String,
    disabled: Boolean,
    value: String,
    inactive: Boolean,
    maxlength: Number,
    autofocus: Boolean
  },
  computed: {
    hasError() {
      if (this.error) {
        return true;
      }
      return false;
    },
    charactersLeft() {
      let currentLength = this.value ? this.value.length : 0;
      return `${this.maxlength - currentLength}/${this.maxlength}`;
    },
    getWrapperClass() {
      return {
        'text-area-atom__wrapper--inactive': this.inactive
      };
    },
    getLabelClass() {
      return {
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--disabled': this.disabled
      };
    },
    getTextAreaClass() {
      return {
        'ace-input--disabled': this.disabled,
        'ace-input--error': this.hasError,
        'ace-input--inactive': this.inactive,
        'ace-input--has-max-length': this.maxlength !== undefined
      };
    }
  },
  emits: ['input'],
  methods: {
    onInput(e) {
      if (this.value !== e.target.value) {
        this.$emit('input', e.target.value);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TextAreaAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAreaAtom.vue?vue&type=style&index=0&id=6b16cbeb&scoped=true&lang=css
var TextAreaAtomvue_type_style_index_0_id_6b16cbeb_scoped_true_lang_css = __webpack_require__(2438);
;// CONCATENATED MODULE: ./src/components/atoms/TextAreaAtom.vue?vue&type=style&index=0&id=6b16cbeb&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TextAreaAtom.vue




;


const TextAreaAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TextAreaAtomvue_type_script_lang_js, [['render',TextAreaAtomvue_type_template_id_6b16cbeb_scoped_true_render],['__scopeId',"data-v-6b16cbeb"]])

/* harmony default export */ var TextAreaAtom = (TextAreaAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextInputAtom.vue?vue&type=template&id=3c31f7dc&scoped=true

const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-3c31f7dc"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_1 = ["title"];
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_2 = ["title"];
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_3 = ["type", "value", "placeholder", "autocomplete", "disabled", "maxlength"];
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_4 = {
  key: 0,
  class: "ace-input-icon--error"
};
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_5 = /*#__PURE__*/TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_6 = [TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_5];
function TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-input-atom", {
      'text-input-atom--single-row': $props.singleRow
    }])
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "ace-input-wrapper",
    title: $props.error
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input", $options.getInputClass]),
    type: $props.type,
    value: $props.value,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    placeholder: $props.placeholder,
    autocomplete: $props.autocomplete,
    disabled: $options.isDisabled,
    maxlength: $props.maxlength,
    ref: "input"
  }, null, 42, TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_3), [[_directive_mask, $options.inputMask]]), $props.error ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_4, TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 8, TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_hoisted_2), $props.description ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getDescriptionClass)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TextInputAtom.vue?vue&type=template&id=3c31f7dc&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextInputAtom.vue?vue&type=script&lang=js
const types = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email'
};
/* harmony default export */ var TextInputAtomvue_type_script_lang_js = ({
  name: 'TextInputAtom',
  props: {
    error: String,
    label: String,
    value: String,
    disabled: Boolean,
    inactive: Boolean,
    uppercase: Boolean,
    description: String,
    placeholder: String,
    mask: [String, Function],
    autocomplete: String,
    maxlength: Number,
    singleRow: Boolean,
    type: {
      type: String
    },
    validator: val => {
      return Object.values(types).includes(val);
    },
    default: types.TEXT
  },
  computed: {
    isDisabled() {
      return this.disabled || this.description || this.inactive;
    },
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled || this.description && !this.inactive,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    getInputClass() {
      return {
        'ace-input--inactive': this.inactive,
        'ace-input--disabled': this.disabled || this.description,
        'ace-input--error': this.error
      };
    },
    getDescriptionClass() {
      return {
        'ace-input--description': this.description
      };
    },
    inputMask() {
      if (this.mask) return this.mask;else return '';
    },
    hasError() {
      if (this.error) {
        return true;
      }
      return false;
    }
  },
  emits: ['input', 'enter'],
  methods: {
    onInput(e) {
      var val = e.target.value;
      if (this.uppercase) {
        val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
      }
      if (val !== this.value) {
        this.$emit('input', val);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TextInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextInputAtom.vue?vue&type=style&index=0&id=3c31f7dc&scoped=true&lang=css
var TextInputAtomvue_type_style_index_0_id_3c31f7dc_scoped_true_lang_css = __webpack_require__(2328);
;// CONCATENATED MODULE: ./src/components/atoms/TextInputAtom.vue?vue&type=style&index=0&id=3c31f7dc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TextInputAtom.vue




;


const TextInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TextInputAtomvue_type_script_lang_js, [['render',TextInputAtomvue_type_template_id_3c31f7dc_scoped_true_render],['__scopeId',"data-v-3c31f7dc"]])

/* harmony default export */ var TextInputAtom = (TextInputAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimeInputAtom.vue?vue&type=template&id=5d0357f0&scoped=true

const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-5d0357f0"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_1 = ["title"];
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_2 = ["title"];
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_3 = ["value", "disabled"];
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_4 = {
  key: 0,
  class: "ace-input-icon--error"
};
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_5 = /*#__PURE__*/TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_6 = [TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_5];
function TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["time-input-atom", $options.getClass])
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-wrapper", {
      'ace-input-wrapper--error': $options.hasError
    }]),
    title: $options.innerError
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input", $options.getInputClass]),
    type: "text",
    placeholder: "__:__",
    value: $data.innerValue,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    disabled: $options.isDisabled,
    onBlur: _cache[1] || (_cache[1] = (...args) => $options.onBlur && $options.onBlur(...args))
  }, null, 42, TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_3), [[_directive_mask, '##:##']]), $options.hasError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_4, TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 10, TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_hoisted_2), $props.description ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)($options.getDescriptionClass)
  }, (0,external_vue_namespaceObject.toDisplayString)($props.description), 3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TimeInputAtom.vue?vue&type=template&id=5d0357f0&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimeInputAtom.vue?vue&type=script&lang=js
/* harmony default export */ var TimeInputAtomvue_type_script_lang_js = ({
  name: 'TimeInputAtom',
  props: {
    error: String,
    label: String,
    value: String,
    disabled: Boolean,
    inactive: Boolean,
    description: String,
    singleRow: Boolean,
    mode: {
      type: String,
      default: 'inline',
      validator: value => {
        return ['inline', 'fullwidth'].includes(value);
      }
    }
  },
  data() {
    return {
      innerValue: '',
      isTouched: false
    };
  },
  computed: {
    isValid() {
      if (this.innerValue && this.innerValue.length < 5) {
        return false;
      }
      return this.$moment(this.innerValue, 'HH:mm').isValid();
    },
    fullwidth() {
      return this.mode === 'fullwidth';
    },
    getClass() {
      return {
        'time-input-atom--inline': !this.fullwidth,
        'time-input-atom--single-row': this.singleRow
      };
    },
    isDisabled() {
      return this.disabled || this.description || this.inactive;
    },
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled || this.description && !this.inactive,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    getInputClass() {
      return {
        'ace-input--inactive': this.inactive,
        'ace-input--disabled': this.disabled || this.description,
        'ace-input--error': this.hasError
      };
    },
    getDescriptionClass() {
      return {
        'ace-input--description': this.description
      };
    },
    hasError() {
      if (this.innerError) {
        return true;
      }
      return false;
    },
    innerError() {
      if (this.error) {
        return this.error;
      }
      if (!this.isValid && this.innerValue && this.innerValue.length > 0 && this.isTouched) {
        return 'Ogiltigt format';
      }
      return '';
    }
  },
  emits: ['input'],
  methods: {
    onInput(e) {
      this.innerValue = e.target.value;
      if (this.isValid && this.innerValue === '24:00') {
        this.innerValue = '00:00';
        this.$emit('input', this.innerValue);
        return;
      }
      if (this.isValid) {
        this.$emit('input', e.target.value);
      } else {
        this.$emit('input', '');
      }
    },
    setInnerValue(value) {
      if (value !== this.innerValue) {
        this.innerValue = value;
      }
    },
    onBlur() {
      this.isTouched = true;
    }
  },
  watch: {
    value: function (value) {
      this.setInnerValue(value);
    }
  },
  mounted() {
    this.setInnerValue(this.value);
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TimeInputAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimeInputAtom.vue?vue&type=style&index=0&id=5d0357f0&scoped=true&lang=css
var TimeInputAtomvue_type_style_index_0_id_5d0357f0_scoped_true_lang_css = __webpack_require__(7608);
;// CONCATENATED MODULE: ./src/components/atoms/TimeInputAtom.vue?vue&type=style&index=0&id=5d0357f0&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TimeInputAtom.vue




;


const TimeInputAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TimeInputAtomvue_type_script_lang_js, [['render',TimeInputAtomvue_type_template_id_5d0357f0_scoped_true_render],['__scopeId',"data-v-5d0357f0"]])

/* harmony default export */ var TimeInputAtom = (TimeInputAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ToggleAtom.vue?vue&type=template&id=e8c29e1c&scoped=true

const ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_withScopeId = n => (_pushScopeId("data-v-e8c29e1c"), n = n(), _popScopeId(), n);
const ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_hoisted_1 = {
  class: "toggle-atom"
};
const ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_hoisted_2 = ["onClick", "tabindex"];
function ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_hoisted_1, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.options, (option, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      key: index,
      class: (0,external_vue_namespaceObject.normalizeClass)(["toggle-atom__option", $options.optionClass[option.value]]),
      onClick: $event => $options.emitInput(option.value),
      tabindex: index
    }, [(0,external_vue_namespaceObject.createElementVNode)("span", null, (0,external_vue_namespaceObject.toDisplayString)(option.label), 1)], 10, ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_hoisted_2);
  }), 128))]);
}
;// CONCATENATED MODULE: ./src/components/atoms/ToggleAtom.vue?vue&type=template&id=e8c29e1c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ToggleAtom.vue?vue&type=script&lang=js
/* harmony default export */ var ToggleAtomvue_type_script_lang_js = ({
  name: 'ToggleAtom',
  props: {
    options: Array,
    value: [String, Boolean, Number],
    disabled: Boolean
  },
  computed: {
    optionClass() {
      return this.options.reduce((pv, cv) => {
        pv[cv.value] = {
          'toggle-atom__option--primary': cv.value === this.value,
          'toggle-atom__option--secondary': cv.value !== this.value,
          'ace-shadow': cv.value !== this.value,
          'toggle-atom__option--disabled': this.disabled
        };
        return pv;
      }, {});
    }
  },
  emits: ['input'],
  methods: {
    emitInput(option) {
      this.$emit('input', option);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ToggleAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ToggleAtom.vue?vue&type=style&index=0&id=e8c29e1c&scoped=true&lang=css
var ToggleAtomvue_type_style_index_0_id_e8c29e1c_scoped_true_lang_css = __webpack_require__(6702);
;// CONCATENATED MODULE: ./src/components/atoms/ToggleAtom.vue?vue&type=style&index=0&id=e8c29e1c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ToggleAtom.vue




;


const ToggleAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ToggleAtomvue_type_script_lang_js, [['render',ToggleAtomvue_type_template_id_e8c29e1c_scoped_true_render],['__scopeId',"data-v-e8c29e1c"]])

/* harmony default export */ var ToggleAtom = (ToggleAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ValidationAtom.vue?vue&type=template&id=31cbd712&scoped=true

const ValidationAtomvue_type_template_id_31cbd712_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-31cbd712"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_1 = {
  key: 0
};
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_2 = /*#__PURE__*/ValidationAtomvue_type_template_id_31cbd712_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#warning"
}, null, -1));
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_3 = [ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_2];
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_4 = {
  key: 1
};
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_5 = /*#__PURE__*/ValidationAtomvue_type_template_id_31cbd712_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_6 = [ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_5];
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_7 = ["title"];
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_8 = {
  key: 0
};
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_9 = /*#__PURE__*/ValidationAtomvue_type_template_id_31cbd712_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#anchor"
})], -1));
const ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_10 = [ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_9];
function ValidationAtomvue_type_template_id_31cbd712_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["validation-atom ace-clamp", $options.validationClass])
  }, [!$props.number ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["validation-atom__icon", $options.iconClass])
  }, [!$options.isError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_1, ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_3)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.isError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_4, ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["validation-atom__value ace-clamp", $options.valueClass]),
    title: $props.value
  }, [$props.number ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_8, (0,external_vue_namespaceObject.toDisplayString)($props.number) + ". ", 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.value), 1)], 10, ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_7), $props.anchor ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: (0,external_vue_namespaceObject.normalizeClass)(["validation-atom__anchor", $options.anchorClass]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onAnchorClick && $options.onAnchorClick(...args))
  }, ValidationAtomvue_type_template_id_31cbd712_scoped_true_hoisted_10, 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/ValidationAtom.vue?vue&type=template&id=31cbd712&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ValidationAtom.vue?vue&type=script&lang=js
/* harmony default export */ var ValidationAtomvue_type_script_lang_js = ({
  name: 'ValidationAtom',
  props: {
    value: String,
    type: {
      type: String,
      default: 'error'
    },
    anchor: String,
    number: Number
  },
  computed: {
    validationClass() {
      return {
        'validation-atom--has-anchor': this.anchor !== undefined,
        'validation-atom--has-number': this.number !== undefined
      };
    },
    iconClass() {
      return {
        ['validation-atom__icon--' + this.type]: true
      };
    },
    valueClass() {
      return {
        ['validation-atom__value--' + this.type]: true,
        'validation-atom__value--has-number': this.number !== undefined
      };
    },
    isError() {
      if (this.type === 'error') {
        return true;
      }
      return false;
    },
    anchorClass() {
      return {
        ['validation-atom__anchor--' + this.type]: true
      };
    }
  },
  methods: {
    onAnchorClick() {
      let target = document.querySelector(`[data-anchor="${this.anchor}"]`);
      if (target) {
        target.scrollIntoView();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/ValidationAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/ValidationAtom.vue?vue&type=style&index=0&id=31cbd712&scoped=true&lang=css
var ValidationAtomvue_type_style_index_0_id_31cbd712_scoped_true_lang_css = __webpack_require__(581);
;// CONCATENATED MODULE: ./src/components/atoms/ValidationAtom.vue?vue&type=style&index=0&id=31cbd712&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/ValidationAtom.vue




;


const ValidationAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ValidationAtomvue_type_script_lang_js, [['render',ValidationAtomvue_type_template_id_31cbd712_scoped_true_render],['__scopeId',"data-v-31cbd712"]])

/* harmony default export */ var ValidationAtom = (ValidationAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SectionAtom.vue?vue&type=template&id=4351cc70&scoped=true

const SectionAtomvue_type_template_id_4351cc70_scoped_true_withScopeId = n => (_pushScopeId("data-v-4351cc70"), n = n(), _popScopeId(), n);
const SectionAtomvue_type_template_id_4351cc70_scoped_true_hoisted_1 = {
  key: 0
};
const SectionAtomvue_type_template_id_4351cc70_scoped_true_hoisted_2 = {
  key: 1,
  class: "section-atom__emphasized"
};
function SectionAtomvue_type_template_id_4351cc70_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["section-atom", {
      'section-atom--inline': $props.mode === 'inline'
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["section-atom__wrapper", {
      'section-atom__wrapper--modal': $props.mode === 'modal'
    }])
  }, [(0,external_vue_namespaceObject.createElementVNode)("span", null, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1), $props.label && $props.emphasized ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", SectionAtomvue_type_template_id_4351cc70_scoped_true_hoisted_1, ": ")) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.emphasized ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", SectionAtomvue_type_template_id_4351cc70_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.emphasized), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/SectionAtom.vue?vue&type=template&id=4351cc70&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SectionAtom.vue?vue&type=script&lang=js
/* harmony default export */ var SectionAtomvue_type_script_lang_js = ({
  name: 'SectionAtom',
  props: {
    label: String,
    emphasized: String,
    mode: String
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/SectionAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/SectionAtom.vue?vue&type=style&index=0&id=4351cc70&scoped=true&lang=css
var SectionAtomvue_type_style_index_0_id_4351cc70_scoped_true_lang_css = __webpack_require__(114);
;// CONCATENATED MODULE: ./src/components/atoms/SectionAtom.vue?vue&type=style&index=0&id=4351cc70&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/SectionAtom.vue




;


const SectionAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SectionAtomvue_type_script_lang_js, [['render',SectionAtomvue_type_template_id_4351cc70_scoped_true_render],['__scopeId',"data-v-4351cc70"]])

/* harmony default export */ var SectionAtom = (SectionAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AutoCompleteAtom.vue?vue&type=template&id=5b6dd989&scoped=true

const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-5b6dd989"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_1 = ["title"];
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_2 = ["title"];
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_3 = ["placeholder", "disabled"];
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_4 = {
  key: 0,
  class: "auto-complete-atom__row__prefix-dropdown__icon"
};
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_5 = /*#__PURE__*/AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
}, null, -1));
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_6 = [AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_5];
const AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_7 = ["onClick"];
function AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  const _directive_clickoutside = (0,external_vue_namespaceObject.resolveDirective)("clickoutside");
  return (0,external_vue_namespaceObject.withDirectives)(((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom", $options.divClasses])
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.labelClasses]),
    title: $props.label
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: $props.error,
    class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom__row", $options.getWrapperClass]),
    tabindex: "0",
    onKeydown: [_cache[3] || (_cache[3] = (0,external_vue_namespaceObject.withKeys)((0,external_vue_namespaceObject.withModifiers)($event => $data.selectedIndex < $options.filteredOptions.length - 1 && ($data.selectedIndex += 1), ["prevent"]), ["down"])), _cache[4] || (_cache[4] = (0,external_vue_namespaceObject.withKeys)((0,external_vue_namespaceObject.withModifiers)($event => $data.selectedIndex > 0 && ($data.selectedIndex -= 1), ["prevent"]), ["up"])), _cache[5] || (_cache[5] = (0,external_vue_namespaceObject.withKeys)((0,external_vue_namespaceObject.withModifiers)($event => $options.selectedOption($data.selectedIndex), ["prevent"]), ["enter"]))]
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    type: "text",
    class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom__row__input", $options.inputClasses]),
    ref: "input",
    placeholder: $props.placeholder,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
    disabled: $props.disabled,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.inputValue = $event)
  }, null, 42, AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_3), [[_directive_mask, $options.inputMask], [external_vue_namespaceObject.vModelText, $data.inputValue]]), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "loader", {}, undefined, true), !$props.inactive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom__row__prefix-dropdown", $options.prefixClasses]),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onClickDropdown && $options.onClickDropdown(...args))
  }, [$options.showArrow ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_4, AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom__options ace-scroll", $options.optionsClass])
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.filteredOptions, (option, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["auto-complete-atom__options__option", {
        'auto-complete-atom__options__option--target': $data.selectedIndex === index
      }]),
      key: option.value,
      onClick: $event => $options.changeInputValue(option)
    }, (0,external_vue_namespaceObject.toDisplayString)(option.label), 11, AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_7);
  }), 128))], 2)], 42, AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_hoisted_2)], 2)), [[_directive_clickoutside, $options.onClickOutside]]);
}
;// CONCATENATED MODULE: ./src/components/atoms/AutoCompleteAtom.vue?vue&type=template&id=5b6dd989&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AutoCompleteAtom.vue?vue&type=script&lang=js
/* harmony default export */ var AutoCompleteAtomvue_type_script_lang_js = ({
  name: 'AutoCompleteAtom',
  props: {
    label: String,
    inactive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    mask: [String, Function],
    value: String,
    error: String,
    placeholder: String,
    options: Array,
    singleRow: Boolean,
    mode: {
      type: String,
      default: 'fullwidth',
      validator: value => {
        return ['inline', 'fullwidth'].includes(value);
      }
    },
    loader: Boolean,
    autocomplete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: undefined,
      isActive: false,
      selectedIndex: -1,
      selectedCells: []
    };
  },
  computed: {
    labelClasses() {
      return {
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--disabled': this.disabled,
        'ace-input-label--single-row': this.singleRow
      };
    },
    prefixClasses() {
      return {
        'auto-complete-atom__row__prefix-dropdown--error': this.error
      };
    },
    inputClasses() {
      return {
        'auto-complete-atom__row__input--inactive': this.inactive,
        'auto-complete-atom__row__input--error': this.error
      };
    },
    getWrapperClass() {
      return {
        'auto-complete-atom__row--inactive': this.inactive
      };
    },
    divClasses() {
      return {
        'auto-complete-atom--inactive': this.inactive,
        'auto-complete-atom--disabled': this.disabled,
        'auto-complete-atom--inline': !this.fullwidth,
        'auto-complete-atom--fullwidth': this.fullwidth,
        'auto-complete-atom--single-row': this.singleRow
      };
    },
    optionsClass() {
      return {
        'auto-complete-atom__options--is-active': this.isActive
      };
    },
    fullwidth() {
      return this.mode === 'fullwidth';
    },
    filteredOptions() {
      let options = this.options;
      if (this.filter && this.inputValue) {
        options = options.filter(option => {
          return option.label.toLowerCase().includes(this.inputValue.toLowerCase());
        });
      }
      return options;
    },
    inputMask() {
      if (this.mask) return this.mask;else return '';
    },
    showArrow() {
      if (this.autocomplete && this.options.length == 0) {
        return false;
      }
      return true;
    }
  },
  emits: ['input', 'changeAddress'],
  methods: {
    emitInput() {
      this.$emit('input', this.inputValue ? this.inputValue : '');
    },
    onInput(e) {
      this.inputValue = e.target.value;
      this.emitInput();
      if (this.inputValue !== '') {
        let indexOfOption = this.filteredOptions.findIndex(object => {
          return object.label.toLowerCase().startsWith(e.target.value.toLowerCase());
        });
        this.selectedIndex = indexOfOption;
      } else {
        this.selectedIndex = -1;
      }
    },
    setInnerInputValue(value) {
      if (value || this.inputValue) {
        this.inputValue = value;
      }
    },
    changeInputValue(option) {
      if (option.address) {
        this.$emit('changeAddress', option);
      }
      this.inputValue = option.label;
      this.isActive = false;
      this.blurAndFocus();
      this.emitInput();
    },
    onClickDropdown() {
      this.isActive = !this.isActive;
      this.blurAndFocus();
    },
    blurAndFocus() {
      document.getElementsByClassName('auto-complete-atom__row')[0].blur();
      this.$refs.input.focus();
    },
    selectedOption(selectedIndex) {
      if (this.selectedIndex != -1) {
        let option = this.filteredOptions[selectedIndex];
        this.changeInputValue(option);
        this.selectedIndex = -1;
        this.isActive = false;
      }
    },
    onClickOutside() {
      this.isActive = false;
    }
  },
  mounted() {
    this.setInnerInputValue(this.value);
  },
  watch: {
    value: {
      handler(val) {
        this.setInnerInputValue(val);
      },
      deep: true
    },
    filteredOptions: {
      handler(newOptions) {
        if (this.autocomplete && newOptions.length > 0) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      },
      deep: true
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/AutoCompleteAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AutoCompleteAtom.vue?vue&type=style&index=0&id=5b6dd989&scoped=true&lang=css
var AutoCompleteAtomvue_type_style_index_0_id_5b6dd989_scoped_true_lang_css = __webpack_require__(968);
;// CONCATENATED MODULE: ./src/components/atoms/AutoCompleteAtom.vue?vue&type=style&index=0&id=5b6dd989&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/AutoCompleteAtom.vue




;


const AutoCompleteAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AutoCompleteAtomvue_type_script_lang_js, [['render',AutoCompleteAtomvue_type_template_id_5b6dd989_scoped_true_render],['__scopeId',"data-v-5b6dd989"]])

/* harmony default export */ var AutoCompleteAtom = (AutoCompleteAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AdvModalAtom.vue?vue&type=template&id=6255bb6b&scoped=true

const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-6255bb6b"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_1 = {
  class: "adv-modal-atom__modal__header__title"
};
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_2 = {
  class: "adv-modal-atom__modal__header__values"
};
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_3 = ["title"];
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_4 = ["title"];
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_5 = /*#__PURE__*/AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "adv-modal-atom__modal__header__close__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross"
})], -1));
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_6 = [AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_5];
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_7 = {
  key: 0,
  class: "adv-modal-atom__modal__panel"
};
const AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_8 = {
  class: "adv-modal-atom__modal__content ace-scroll"
};
function AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(external_vue_namespaceObject.Transition, {
    name: "adv-modal-atom"
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createElementVNode)("div", {
      ref: "advModalAtom",
      class: (0,external_vue_namespaceObject.normalizeClass)(["adv-modal-atom ace-scroll", $options.blockClass])
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["adv-modal-atom__modal ace-shadow", $options.modalClass])
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["adv-modal-atom__modal__header", {
        'adv-modal-atom__modal__header--overflowing': $data.isOverflowing
      }])
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_1, (0,external_vue_namespaceObject.toDisplayString)($props.title), 1), (0,external_vue_namespaceObject.createElementVNode)("div", AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_2, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.headerValues, (value, index) => {
      return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
        class: "adv-modal-atom__modal__header__values__value ace-clamp",
        key: 'header-value_' + index
      }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
        class: "adv-modal-atom__modal__header__values__value__label ace-clamp",
        title: value.label
      }, (0,external_vue_namespaceObject.toDisplayString)(value.label), 9, AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_3), (0,external_vue_namespaceObject.createElementVNode)("div", {
        class: "adv-modal-atom__modal__header__values__value__value ace-clamp",
        title: value.value
      }, (0,external_vue_namespaceObject.toDisplayString)(value.value), 9, AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_4)]);
    }), 128))]), !$props.hideClose ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      key: 0,
      class: "adv-modal-atom__modal__header__close",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
    }, AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $options.hasPanel && !$props.hidePanel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_7, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "panel", {}, undefined, true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_hoisted_8, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, undefined, true)]), $options.hasFooter ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      key: 1,
      class: (0,external_vue_namespaceObject.normalizeClass)(["adv-modal-atom__modal__footer", {
        'adv-modal-atom__modal__footer--overflowing': $data.isOverflowing
      }])
    }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "footer", {}, undefined, true)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)], 2)]),
    _: 3
  });
}
;// CONCATENATED MODULE: ./src/components/atoms/AdvModalAtom.vue?vue&type=template&id=6255bb6b&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AdvModalAtom.vue?vue&type=script&lang=js
/* harmony default export */ var AdvModalAtomvue_type_script_lang_js = ({
  name: 'AdvModalAtom',
  props: {
    title: {
      type: String,
      default: 'Obs!'
    },
    size: {
      type: String,
      validator: val => {
        return ['sm', 'md', 'lg', 'xl'].includes(val);
      },
      default: 'md'
    },
    nested: Boolean,
    stash: Boolean,
    headerValues: Array,
    hideClose: Boolean,
    hidePanel: Boolean
  },
  data() {
    return {
      isActive: false,
      isOverflowing: false
    };
  },
  computed: {
    blockClass() {
      return {
        'adv-modal-atom--regular': !this.nested,
        'adv-modal-atom--nested': this.nested,
        'adv-modal-atom--stash': this.stash,
        'adv-modal-atom--active': this.isActive
      };
    },
    modalClass() {
      return {
        ['adv-modal-atom__modal--' + this.size]: true
      };
    },
    hasFooter() {
      return this.$slots.footer !== undefined;
    },
    hasPanel() {
      return this.$slots.panel !== undefined;
    }
  },
  methods: {
    onResizeObserved(e) {
      e.forEach(entry => {
        if (entry.target.offsetHeight < entry.target.scrollHeight) {
          this.isOverflowing = true;
        } else {
          this.isOverflowing = false;
        }
      });
    }
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.onResizeObserved);
    this.resizeObserver.observe(this.$refs.advModalAtom);
    setTimeout(() => {
      this.isActive = true;
    }, 1);
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/AdvModalAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/AdvModalAtom.vue?vue&type=style&index=0&id=6255bb6b&scoped=true&lang=css
var AdvModalAtomvue_type_style_index_0_id_6255bb6b_scoped_true_lang_css = __webpack_require__(3172);
;// CONCATENATED MODULE: ./src/components/atoms/AdvModalAtom.vue?vue&type=style&index=0&id=6255bb6b&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/AdvModalAtom.vue




;


const AdvModalAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AdvModalAtomvue_type_script_lang_js, [['render',AdvModalAtomvue_type_template_id_6255bb6b_scoped_true_render],['__scopeId',"data-v-6255bb6b"]])

/* harmony default export */ var AdvModalAtom = (AdvModalAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/BoxAtom.vue?vue&type=template&id=424b7db8&scoped=true

const BoxAtomvue_type_template_id_424b7db8_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-424b7db8"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_1 = {
  class: "box-atom"
};
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_2 = ["title"];
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_3 = {
  class: "box-atom__header__label"
};
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_4 = {
  key: 0,
  class: "box-atom__header__icon-container"
};
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_5 = /*#__PURE__*/BoxAtomvue_type_template_id_424b7db8_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#edit"
}, null, -1));
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_6 = [BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_5];
const BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_7 = {
  class: "box-atom__content"
};
function BoxAtomvue_type_template_id_424b7db8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", null, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "box-atom__header ace-clamp",
    title: $props.label
  }, [(0,external_vue_namespaceObject.createElementVNode)("span", BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_3, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1), $props.hasEdit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_4, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClick && $options.onClick(...args)),
    class: "ace-table-icon--action"
  }, BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_6))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 8, BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_2)]), (0,external_vue_namespaceObject.createElementVNode)("div", BoxAtomvue_type_template_id_424b7db8_scoped_true_hoisted_7, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)])]);
}
;// CONCATENATED MODULE: ./src/components/atoms/BoxAtom.vue?vue&type=template&id=424b7db8&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/BoxAtom.vue?vue&type=script&lang=js
/* harmony default export */ var BoxAtomvue_type_script_lang_js = ({
  name: 'BoxAtom',
  props: {
    label: String,
    hasEdit: Boolean
  },
  emits: ['click'],
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/BoxAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/BoxAtom.vue?vue&type=style&index=0&id=424b7db8&scoped=true&lang=css
var BoxAtomvue_type_style_index_0_id_424b7db8_scoped_true_lang_css = __webpack_require__(6961);
;// CONCATENATED MODULE: ./src/components/atoms/BoxAtom.vue?vue&type=style&index=0&id=424b7db8&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/BoxAtom.vue




;


const BoxAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(BoxAtomvue_type_script_lang_js, [['render',BoxAtomvue_type_template_id_424b7db8_scoped_true_render],['__scopeId',"data-v-424b7db8"]])

/* harmony default export */ var BoxAtom = (BoxAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAtom.vue?vue&type=template&id=a8f664fa&scoped=true

const TextAtomvue_type_template_id_a8f664fa_scoped_true_withScopeId = n => (_pushScopeId("data-v-a8f664fa"), n = n(), _popScopeId(), n);
const TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_1 = {
  class: "text-atom"
};
const TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_2 = ["title"];
const TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_3 = ["title"];
function TextAtomvue_type_template_id_a8f664fa_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("label", {
    class: "ace-input-label ace-input-label--inactive ace-clamp",
    title: $props.label
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 9, TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "text-atom__value ace-input-wrapper ace-input--inactive",
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.valueStyle),
    title: $props.lines ? $props.value : undefined
  }, (0,external_vue_namespaceObject.toDisplayString)($options.innerValue), 13, TextAtomvue_type_template_id_a8f664fa_scoped_true_hoisted_3)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/TextAtom.vue?vue&type=template&id=a8f664fa&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAtom.vue?vue&type=script&lang=js
/* harmony default export */ var TextAtomvue_type_script_lang_js = ({
  name: 'TextAtom',
  props: {
    label: String,
    value: String,
    lines: Number
  },
  computed: {
    innerValue() {
      if (!this.value) {
        return '-';
      }
      return this.value;
    },
    valueStyle() {
      if (!this.lines) {
        return {};
      }
      let result = `overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: ${this.lines};
              -webkit-box-orient: vertical;`;
      if (this.lines === 1) {
        result += 'line-height:36px;';
      }
      return result;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TextAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TextAtom.vue?vue&type=style&index=0&id=a8f664fa&scoped=true&lang=css
var TextAtomvue_type_style_index_0_id_a8f664fa_scoped_true_lang_css = __webpack_require__(3484);
;// CONCATENATED MODULE: ./src/components/atoms/TextAtom.vue?vue&type=style&index=0&id=a8f664fa&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TextAtom.vue




;


const TextAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TextAtomvue_type_script_lang_js, [['render',TextAtomvue_type_template_id_a8f664fa_scoped_true_render],['__scopeId',"data-v-a8f664fa"]])

/* harmony default export */ var TextAtom = (TextAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableWrapperAtom.vue?vue&type=template&id=66cb53f5&scoped=true

const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-66cb53f5"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_1 = {
  class: "table-wrapper-atom"
};
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_2 = {
  class: "table-wrapper-atom__header ace-row"
};
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_3 = {
  class: "table-wrapper-atom__header__summary"
};
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_4 = {
  key: 0,
  class: "table-wrapper-atom__header__summary__total"
};
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_5 = {
  key: 0,
  class: "table-wrapper-atom__header__panel ace-row"
};
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_6 = /*#__PURE__*/TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("p", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "table-wrapper-atom__no-records__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#empty"
})])], -1));
const TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_7 = {
  key: 1,
  class: "table-wrapper-atom__footer ace-row"
};
function TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("div", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_3, [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.totalLabel) + " ", 1), $props.showTotal ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)($props.total), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]), $options.hasPanel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_5, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "panel", {}, undefined, true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, undefined, true), $props.total === 0 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["table-wrapper-atom__no-records", {
      'table-wrapper-atom__no-records--nested': $props.nested
    }])
  }, [TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_6, (0,external_vue_namespaceObject.createElementVNode)("span", null, (0,external_vue_namespaceObject.toDisplayString)($props.noRecordsLabel), 1)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.hasFooter ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_hoisted_7, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "footer", {}, undefined, true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/TableWrapperAtom.vue?vue&type=template&id=66cb53f5&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableWrapperAtom.vue?vue&type=script&lang=js
/* harmony default export */ var TableWrapperAtomvue_type_script_lang_js = ({
  name: 'TableWrapperAtom',
  props: {
    totalLabel: {
      type: String,
      default: 'Totalt antal poster:'
    },
    total: {
      type: Number,
      default: 0
    },
    noRecordsLabel: {
      type: String,
      default: 'Det finns inga poster'
    },
    nested: Boolean,
    showTotal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasFooter() {
      return this.$slots.footer !== undefined;
    },
    hasPanel() {
      return this.$slots.panel !== undefined;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TableWrapperAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TableWrapperAtom.vue?vue&type=style&index=0&id=66cb53f5&scoped=true&lang=css
var TableWrapperAtomvue_type_style_index_0_id_66cb53f5_scoped_true_lang_css = __webpack_require__(7249);
;// CONCATENATED MODULE: ./src/components/atoms/TableWrapperAtom.vue?vue&type=style&index=0&id=66cb53f5&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TableWrapperAtom.vue




;


const TableWrapperAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TableWrapperAtomvue_type_script_lang_js, [['render',TableWrapperAtomvue_type_template_id_66cb53f5_scoped_true_render],['__scopeId',"data-v-66cb53f5"]])

/* harmony default export */ var TableWrapperAtom = (TableWrapperAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StickyFooterAtom.vue?vue&type=template&id=0b46443a&scoped=true

const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_withScopeId = n => (_pushScopeId("data-v-0b46443a"), n = n(), _popScopeId(), n);
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_1 = {
  class: "sticky-footer-atom",
  role: ""
};
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_2 = {
  class: "sticky-footer-atom__header"
};
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_3 = {
  class: "sticky-footer-atom__header__values"
};
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_4 = {
  key: 0,
  class: "sticky-footer-atom__header__title__label"
};
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_5 = {
  class: "sticky-footer-atom__header__title__value"
};
const StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_6 = {
  class: "sticky-footer-atom__actions"
};
function StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("div", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_3, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.values, (title, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      class: "sticky-footer-atom__header__title",
      key: index
    }, [title.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("p", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)(title.label), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("p", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_5, (0,external_vue_namespaceObject.toDisplayString)(title.value), 1)]);
  }), 128))]), (0,external_vue_namespaceObject.createElementVNode)("div", StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_hoisted_6, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "actions", {}, undefined, true)])]), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: "sticky-footer-atom__content",
    style: (0,external_vue_namespaceObject.normalizeStyle)(`max-height: ${$props.maxContentHeight}`)
  }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, undefined, true)], 4)]);
}
;// CONCATENATED MODULE: ./src/components/atoms/StickyFooterAtom.vue?vue&type=template&id=0b46443a&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StickyFooterAtom.vue?vue&type=script&lang=js
/* harmony default export */ var StickyFooterAtomvue_type_script_lang_js = ({
  name: 'StickyFooterAtom',
  props: {
    values: {
      type: Array,
      required: true
    },
    maxContentHeight: {
      type: String,
      default: '25vh'
    }
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/StickyFooterAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/StickyFooterAtom.vue?vue&type=style&index=0&id=0b46443a&scoped=true&lang=css
var StickyFooterAtomvue_type_style_index_0_id_0b46443a_scoped_true_lang_css = __webpack_require__(3229);
;// CONCATENATED MODULE: ./src/components/atoms/StickyFooterAtom.vue?vue&type=style&index=0&id=0b46443a&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/StickyFooterAtom.vue




;


const StickyFooterAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(StickyFooterAtomvue_type_script_lang_js, [['render',StickyFooterAtomvue_type_template_id_0b46443a_scoped_true_render],['__scopeId',"data-v-0b46443a"]])

/* harmony default export */ var StickyFooterAtom = (StickyFooterAtom_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimePickerAtom.vue?vue&type=template&id=1979c359&scoped=true

const TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-1979c359"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_1 = ["title"];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_2 = ["title"];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_3 = ["value", "disabled"];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_4 = {
  key: 0,
  class: "ace-input-icon--error"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_5 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
}, null, -1));
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_6 = [TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_5];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_7 = {
  key: 1,
  class: "time-input-dropdown"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_8 = {
  class: "time-picker-dropdown__header"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_9 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross"
}, null, -1));
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_10 = [TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_9];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_11 = {
  class: "time-input-dropdown__time-box"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_12 = {
  class: "ace-column"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_13 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "time-controls__arrow_up"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down-secondary"
})], -1));
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_14 = [TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_13];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_15 = {
  class: "time-input-value"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_16 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down-secondary"
})], -1));
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_17 = [TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_16];
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_18 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "time-input-divider"
}, ":", -1));
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_19 = {
  class: "ace-column"
};
const TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_20 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "time-controls__arrow_up"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down-secondary"
})], -1));
const _hoisted_21 = [TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_20];
const _hoisted_22 = {
  class: "time-input-value"
};
const _hoisted_23 = /*#__PURE__*/TimePickerAtomvue_type_template_id_1979c359_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down-secondary"
})], -1));
const _hoisted_24 = [_hoisted_23];
function TimePickerAtomvue_type_template_id_1979c359_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = (0,external_vue_namespaceObject.resolveDirective)("mask");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["time-input-atom", $options.getClass]),
    ref: "timePicker"
  }, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("label", {
    key: 0,
    title: $props.label,
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-label ace-clamp", $options.getLabelClass])
  }, (0,external_vue_namespaceObject.toDisplayString)($props.label), 11, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["ace-input-wrapper", {
      'ace-input-wrapper--error': $options.hasError
    }]),
    title: $options.innerError
  }, [(0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("input", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["time-input-atom__field ace-input", $options.getInputClass]),
    type: "text",
    placeholder: "__:__",
    value: $data.innerValue,
    onKeydown: _cache[0] || (_cache[0] = (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args)),
    onInput: _cache[1] || (_cache[1] = (...args) => $options.onInput && $options.onInput(...args)),
    onBlur: _cache[2] || (_cache[2] = (...args) => $options.onBlur && $options.onBlur(...args)),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.toggleDropdown && $options.toggleDropdown(...args)),
    disabled: $options.isDisabled
  }, null, 42, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_3), [[_directive_mask, '##:##']]), $options.hasError ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_4, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_6)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 10, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_2), $data.isDropdownVisible ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_7, [(0,external_vue_namespaceObject.createElementVNode)("div", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_8, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "time-picker-dropdown__close-btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.hideDropdown && $options.hideDropdown(...args))
  }, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_10))]), (0,external_vue_namespaceObject.createElementVNode)("div", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_11, [(0,external_vue_namespaceObject.createElementVNode)("div", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_12, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "time-input-dropdown__arrows",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.incrementHour && $options.incrementHour(...args)),
    onMousedown: _cache[6] || (_cache[6] = $event => $options.startContinuousChange('hour', 'increment')),
    onMouseup: _cache[7] || (_cache[7] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args)),
    onMouseleave: _cache[8] || (_cache[8] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args))
  }, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_14, 32), (0,external_vue_namespaceObject.createElementVNode)("span", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_15, (0,external_vue_namespaceObject.toDisplayString)($options.formattedHour), 1), (0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "time-input-dropdown__arrows",
    onClick: _cache[9] || (_cache[9] = (...args) => $options.decrementHour && $options.decrementHour(...args)),
    onMousedown: _cache[10] || (_cache[10] = $event => $options.startContinuousChange('hour', 'decrement')),
    onMouseup: _cache[11] || (_cache[11] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args)),
    onMouseleave: _cache[12] || (_cache[12] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args))
  }, TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_17, 32)]), TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_18, (0,external_vue_namespaceObject.createElementVNode)("div", TimePickerAtomvue_type_template_id_1979c359_scoped_true_hoisted_19, [(0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "time-input-dropdown__arrows",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.incrementMinute && $options.incrementMinute(...args)),
    onMousedown: _cache[14] || (_cache[14] = $event => $options.startContinuousChange('minute', 'increment')),
    onMouseup: _cache[15] || (_cache[15] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args)),
    onMouseleave: _cache[16] || (_cache[16] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args))
  }, _hoisted_21, 32), (0,external_vue_namespaceObject.createElementVNode)("span", _hoisted_22, (0,external_vue_namespaceObject.toDisplayString)($options.formattedMinute), 1), (0,external_vue_namespaceObject.createElementVNode)("button", {
    class: "time-input-dropdown__arrows",
    onClick: _cache[17] || (_cache[17] = (...args) => $options.decrementMinute && $options.decrementMinute(...args)),
    onMousedown: _cache[18] || (_cache[18] = $event => $options.startContinuousChange('minute', 'decrement')),
    onMouseup: _cache[19] || (_cache[19] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args)),
    onMouseleave: _cache[20] || (_cache[20] = (...args) => $options.stopContinuousChange && $options.stopContinuousChange(...args))
  }, _hoisted_24, 32)])])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/atoms/TimePickerAtom.vue?vue&type=template&id=1979c359&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimePickerAtom.vue?vue&type=script&lang=js
/* harmony default export */ var TimePickerAtomvue_type_script_lang_js = ({
  name: 'TimePickerAtom',
  props: {
    error: String,
    label: String,
    value: String,
    disabled: Boolean,
    inactive: Boolean,
    singleRow: Boolean,
    mode: {
      type: String,
      default: 'inline',
      validator: value => {
        return ['inline', 'fullwidth'].includes(value);
      }
    }
  },
  data() {
    return {
      innerValue: '',
      isDropdownVisible: false,
      hour: null,
      minute: null,
      changeTimer: null,
      holdDelay: 300,
      isHolding: false
    };
  },
  computed: {
    formattedHour() {
      if (!this.innerValue.includes(':')) return '--';
      const hourPart = this.innerValue.split(':')[0];
      if (hourPart.length === 0) return '--';
      return hourPart.padEnd(2, '-');
    },
    formattedMinute() {
      if (!this.innerValue.includes(':')) return '--';
      const minutePart = this.innerValue.split(':')[1] || '';
      return minutePart.padEnd(2, '-');
    },
    isValid() {
      if (this.innerValue && this.innerValue.length < 5) {
        return false;
      }
      return this.$moment(this.innerValue, 'HH:mm').isValid();
    },
    getClass() {
      return {
        'time-input-atom--inline': this.mode === 'inline',
        'time-input-atom--single-row': this.singleRow
      };
    },
    isDisabled() {
      return this.disabled || this.inactive;
    },
    getLabelClass() {
      return {
        'ace-input-label--disabled': this.disabled || !this.inactive,
        'ace-input-label--inactive': this.inactive,
        'ace-input-label--single-row': this.singleRow
      };
    },
    getInputClass() {
      return {
        'ace-input--inactive': this.inactive,
        'ace-input--disabled': this.disabled,
        'ace-input--error': this.hasError
      };
    },
    hasError() {
      return !!this.innerError;
    },
    innerError() {
      if (this.error) {
        return this.error;
      }
      if (!this.isValid && this.innerValue && this.innerValue.length) {
        return 'Ogiltigt format';
      }
      return '';
    }
  },
  emits: ['input'],
  methods: {
    onInput(e) {
      this.innerValue = e.target.value;
      if (this.isValid && this.innerValue === '24:00') {
        this.innerValue = '00:00';
        this.$emit('input', this.innerValue);
        return;
      }
      if (this.isValid) {
        this.$emit('input', this.innerValue);
      } else {
        this.$emit('input', '');
      }
    },
    onBlur() {
      if (this.innerValue === '--:--' || this.innerValue && this.innerValue.length === 3 && this.innerValue.includes(':')) {
        this.innerValue = `${this.innerValue.substring(0, 2)}:00`;
        this.$emit('input', this.innerValue);
      }
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    hideDropdown() {
      this.isDropdownVisible = false;
    },
    syncTimeFromInput() {
      if (!this.innerValue.includes(':') || this.innerValue === '--:--') {
        this.hour = 0;
        this.minute = 0;
        return;
      }
      const [parsedHour, parsedMinute] = this.parseTime(this.innerValue);
      this.hour = parsedHour !== null ? parsedHour : 0;
      this.minute = parsedMinute !== null ? parsedMinute : 0;
    },
    incrementHour() {
      this.syncTimeFromInput();
      this.hour = (this.hour + 1) % 24;
      this.updateTime();
    },
    decrementHour() {
      this.syncTimeFromInput();
      this.hour = (this.hour - 1 + 24) % 24;
      this.updateTime();
    },
    incrementMinute() {
      this.syncTimeFromInput();
      this.minute = (this.minute + 1) % 60;
      this.updateTime();
    },
    decrementMinute() {
      this.syncTimeFromInput();
      this.minute = (this.minute - 1 + 60) % 60;
      this.updateTime();
    },
    startContinuousChange(type, direction) {
      this.isHolding = false;
      const action = direction === 'increment' ? this[`increment${type.charAt(0).toUpperCase() + type.slice(1)}`] : this[`decrement${type.charAt(0).toUpperCase() + type.slice(1)}`];
      this.changeTimer = setTimeout(() => {
        this.isHolding = true;
        this.changeTimer = setInterval(() => {
          action();
        }, 100);
      }, this.holdDelay);
    },
    stopContinuousChange() {
      if (this.changeTimer) {
        clearTimeout(this.changeTimer);
        clearInterval(this.changeTimer);
        this.changeTimer = null;
      }
      this.isHolding = false;
    },
    updateTime() {
      const hour = this.hour !== null ? String(this.hour).padStart(2, '0') : '--';
      const minute = this.minute !== null ? String(this.minute).padStart(2, '0') : '--';
      this.innerValue = `${hour}:${minute}`;
      this.$emit('input', this.innerValue);
    },
    parseTime(value) {
      const parts = value.split(':');
      if (parts.length !== 2) return [null, null];
      const hour = parseInt(parts[0], 10);
      const minute = parseInt(parts[1], 10);
      if (isNaN(hour) || isNaN(minute)) return [null, null];
      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return [null, null];
      return [hour, minute];
    },
    handleClickOutside(event) {
      if (this.$refs.timePicker && !this.$refs.timePicker.contains(event.target)) {
        this.hideDropdown();
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== this.innerValue) {
        this.innerValue = newValue;
        const [hour, minute] = this.parseTime(newValue);
        this.hour = hour;
        this.minute = minute;
      }
    }
  },
  mounted() {
    this.innerValue = this.value || '';
    const [hour, minute] = this.parseTime(this.innerValue);
    this.hour = hour;
    this.minute = minute;
    window.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    window.removeEventListener('click', this.handleClickOutside);
  }
});
;// CONCATENATED MODULE: ./src/components/atoms/TimePickerAtom.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/atoms/TimePickerAtom.vue?vue&type=style&index=0&id=1979c359&scoped=true&lang=css
var TimePickerAtomvue_type_style_index_0_id_1979c359_scoped_true_lang_css = __webpack_require__(9454);
;// CONCATENATED MODULE: ./src/components/atoms/TimePickerAtom.vue?vue&type=style&index=0&id=1979c359&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/atoms/TimePickerAtom.vue




;


const TimePickerAtom_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TimePickerAtomvue_type_script_lang_js, [['render',TimePickerAtomvue_type_template_id_1979c359_scoped_true_render],['__scopeId',"data-v-1979c359"]])

/* harmony default export */ var TimePickerAtom = (TimePickerAtom_exports_);
;// CONCATENATED MODULE: ./src/components/atoms/index.js








































;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/ActionsMolecule.vue?vue&type=template&id=1b7272f5&scoped=true

const ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-1b7272f5"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_1 = {
  class: "actions-molecule"
};
const ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_2 = {
  class: "actions-molecule__wrapper"
};
const ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_3 = /*#__PURE__*/ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#edit"
})], -1));
const ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_4 = /*#__PURE__*/ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross-secondary"
})], -1));
function ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true), (0,external_vue_namespaceObject.createElementVNode)("div", ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_2, [$props.isEdit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 0,
    type: "icon",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('edit'))
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_3]),
    _: 1
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.isEdit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 1,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('confirm')),
    disabled: $props.disabled
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)("Spara")]),
    _: 1
  }, 8, ["disabled"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.isEdit ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 2,
    type: "secondary",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('cancel')),
    disabled: $props.disabled
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($options.getSecondaryLabel) + " ", 1), ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_hoisted_4]),
    _: 1
  }, 8, ["disabled"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])]);
}
;// CONCATENATED MODULE: ./src/components/molecules/ActionsMolecule.vue?vue&type=template&id=1b7272f5&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/ActionsMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var ActionsMoleculevue_type_script_lang_js = ({
  name: 'ActionsMolecule',
  components: {
    ButtonAtom: ButtonAtom
  },
  props: {
    disabled: Boolean,
    isEdit: {
      type: Boolean,
      default: false
    },
    cancelLabel: String
  },
  computed: {
    getSecondaryLabel() {
      return this.cancelLabel ? this.cancelLabel : 'Avbryt';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/ActionsMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/ActionsMolecule.vue?vue&type=style&index=0&id=1b7272f5&scoped=true&lang=css
var ActionsMoleculevue_type_style_index_0_id_1b7272f5_scoped_true_lang_css = __webpack_require__(1746);
;// CONCATENATED MODULE: ./src/components/molecules/ActionsMolecule.vue?vue&type=style&index=0&id=1b7272f5&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/ActionsMolecule.vue




;


const ActionsMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ActionsMoleculevue_type_script_lang_js, [['render',ActionsMoleculevue_type_template_id_1b7272f5_scoped_true_render],['__scopeId',"data-v-1b7272f5"]])

/* harmony default export */ var ActionsMolecule = (ActionsMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/PostalInformationMolecule.vue?vue&type=template&id=28fe9692&scoped=true

const PostalInformationMoleculevue_type_template_id_28fe9692_scoped_true_withScopeId = n => (_pushScopeId("data-v-28fe9692"), n = n(), _popScopeId(), n);
const PostalInformationMoleculevue_type_template_id_28fe9692_scoped_true_hoisted_1 = {
  class: "auto-complete-atom__container--loader"
};
function PostalInformationMoleculevue_type_template_id_28fe9692_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoaderAtom = (0,external_vue_namespaceObject.resolveComponent)("LoaderAtom");
  const _component_AutoCompleteAtom = (0,external_vue_namespaceObject.resolveComponent)("AutoCompleteAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_AutoCompleteAtom, {
    ref: "autoCompleteAtom",
    label: $props.label,
    placeholder: $props.placeholder,
    error: $props.error,
    mask: $props.mask,
    options: $data.postalCodeOptions,
    value: $props.value,
    disabled: $props.disabled,
    inactive: $props.inactive,
    autocomplete: "",
    onInput: $options.handlePostalCodeInput,
    onChangeAddress: $options.onAddressInput
  }, {
    loader: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createElementVNode)("div", PostalInformationMoleculevue_type_template_id_28fe9692_scoped_true_hoisted_1, [$data.loading ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_LoaderAtom, {
      key: 0,
      mode: "action"
    })) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])]),
    _: 1
  }, 8, ["label", "placeholder", "error", "mask", "options", "value", "disabled", "inactive", "onInput", "onChangeAddress"]);
}
;// CONCATENATED MODULE: ./src/components/molecules/PostalInformationMolecule.vue?vue&type=template&id=28fe9692&scoped=true

;// CONCATENATED MODULE: ./src/components/utilities/debounce.js
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
;// CONCATENATED MODULE: ./src/components/molecules/PostalInformationMolecule.logic.js
/* harmony default export */ var PostalInformationMolecule_logic = ({
  //TEST
  // async onPostalCodeInput(newZipCode, context) {
  //   if (newZipCode.length === 5) {
  //     await this.fetchPostalCodeOptions(newZipCode, context);
  //   }
  // },
  // async fetchPostalCodeOptions(zipCode, context) {
  //   if (zipCode.length !== 5) {
  //     return;
  //   }
  //   context.loading = true;
  //   const mockData = {
  //     results: [
  //       {
  //         postalCode: '18652',
  //         postalAddress: 'Täby',
  //         postalRegion: 'Stockholms län',
  //         formattedAddress: `Täby, 18652, Sverige`,
  //       },
  //     ],
  //   };
  //   await new Promise((resolve) => setTimeout(resolve, 3000));
  //   context.loading = false;
  //   if (mockData && Array.isArray(mockData.results)) {
  //     context.postalCodeOptions = mockData.results.map((result) => ({
  //       label: result.formattedAddress,
  //       value: result.postalCode,
  //       address: result.postalAddress,
  //       region: result.postalRegion,
  //     }));
  //   }
  // },

  async onPostalCodeInput(postalCode, context) {
    if (postalCode.length === 5) {
      await this.fetchPostalCodeOptions(postalCode, context);
    }
  },
  async fetchPostalCodeOptions(postalCode, context) {
    const apiUrl = `/sysadmin/api/postal/${postalCode}`;
    context.loading = true;
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      context.loading = false;
      if (data && Array.isArray(data.results)) {
        context.postalCodeOptions = data.results.map(result => ({
          label: result.formattedAddress,
          value: result.postalCode,
          address: result.postalAddress,
          region: result.postalRegion
        }));
      }
    } catch (error) {
      context.loading = false;
      console.error('Error fetching postal code data:', error);
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/PostalInformationMolecule.vue?vue&type=script&lang=js



const debouncedOnPostalCodeInput = debounce(async function (value, context) {
  await PostalInformationMolecule_logic.onPostalCodeInput(value, context);
}, 500);
/* harmony default export */ var PostalInformationMoleculevue_type_script_lang_js = ({
  name: 'PostalInformationMolecule',
  props: {
    label: String,
    placeholder: String,
    error: String,
    disabled: Boolean,
    inactive: Boolean,
    mask: [String, Function],
    value: String,
    postalAddress: String,
    postalRegion: String
  },
  components: {
    LoaderAtom: LoaderAtom,
    AutoCompleteAtom: AutoCompleteAtom
  },
  data() {
    return {
      postalCode: this.value,
      originalPostalCode: null,
      address: this.postalAddress,
      region: this.postalRegion,
      postalCodeOptions: [],
      selectedPostalCode: null,
      loading: false
    };
  },
  emits: ['input'],
  methods: {
    async handlePostalCodeInput(value) {
      this.postalCode = value;
      this.emitInput();
      if (this.originalPostalCode === value || this.selectedPostalCode === value) {
        return;
      }
      debouncedOnPostalCodeInput(value, this);
    },
    onAddressInput(option) {
      const {
        value,
        address,
        region
      } = option;
      this.selectedPostalCode = value;
      this.region = region;
      this.address = address;
      this.emitInput();
    },
    emitInput() {
      this.$emit('input', {
        postalCode: this.postalCode,
        postalAddress: this.address,
        postalRegion: this.region
      });
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (!this.originalPostalCode && newValue) {
          this.originalPostalCode = newValue;
        }
      }
    },
    postalCodeOptions: {
      handler(newOptions) {
        if (newOptions.length > 0) {
          this.$refs.autoCompleteAtom.isActive = true;
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.value) {
      this.originalPostalCode = this.value;
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/PostalInformationMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/PostalInformationMolecule.vue?vue&type=style&index=0&id=28fe9692&scoped=true&lang=css
var PostalInformationMoleculevue_type_style_index_0_id_28fe9692_scoped_true_lang_css = __webpack_require__(7915);
;// CONCATENATED MODULE: ./src/components/molecules/PostalInformationMolecule.vue?vue&type=style&index=0&id=28fe9692&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/PostalInformationMolecule.vue




;


const PostalInformationMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PostalInformationMoleculevue_type_script_lang_js, [['render',PostalInformationMoleculevue_type_template_id_28fe9692_scoped_true_render],['__scopeId',"data-v-28fe9692"]])

/* harmony default export */ var PostalInformationMolecule = (PostalInformationMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/HeaderMolecule.vue?vue&type=template&id=e85a9da2&scoped=true

const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_withScopeId = n => (_pushScopeId("data-v-e85a9da2"), n = n(), _popScopeId(), n);
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_1 = {
  class: "header-molecule"
};
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_2 = {
  class: "header-molecule__header"
};
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_3 = {
  class: "header-molecule__content"
};
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_4 = {
  class: "header-molecule__content__row"
};
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_5 = ["xlink:href"];
const HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_6 = {
  class: "header-molecule__content__row__ingress"
};
function HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  const _component_ContainerAtom = (0,external_vue_namespaceObject.resolveComponent)("ContainerAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.title), 1), (0,external_vue_namespaceObject.createVNode)(_component_ContainerAtom, null, {
    content: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, () => [(0,external_vue_namespaceObject.createElementVNode)("div", HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_3, [(0,external_vue_namespaceObject.createElementVNode)("div", HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_4, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", null, [(0,external_vue_namespaceObject.createElementVNode)("use", {
      "xlink:href": $props.icon
    }, null, 8, HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_5)])), (0,external_vue_namespaceObject.createElementVNode)("span", HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_hoisted_6, (0,external_vue_namespaceObject.toDisplayString)($props.ingress), 1), (0,external_vue_namespaceObject.createTextVNode)(" " + (0,external_vue_namespaceObject.toDisplayString)($props.description), 1)]), (0,external_vue_namespaceObject.createElementVNode)("div", null, [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      disabled: $props.disabled || null,
      label: $props.buttonLabel,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click'))
    }, null, 8, ["disabled", "label"])])])], true)]),
    _: 3
  })]);
}
;// CONCATENATED MODULE: ./src/components/molecules/HeaderMolecule.vue?vue&type=template&id=e85a9da2&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/HeaderMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var HeaderMoleculevue_type_script_lang_js = ({
  name: 'HeaderMolecule',
  props: {
    title: String,
    icon: String,
    ingress: String,
    description: String,
    buttonLabel: String,
    disabled: Boolean
  },
  components: {
    ContainerAtom: ContainerAtom,
    ButtonAtom: ButtonAtom
  },
  emits: ['click']
});
;// CONCATENATED MODULE: ./src/components/molecules/HeaderMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/HeaderMolecule.vue?vue&type=style&index=0&id=e85a9da2&scoped=true&lang=css
var HeaderMoleculevue_type_style_index_0_id_e85a9da2_scoped_true_lang_css = __webpack_require__(6889);
;// CONCATENATED MODULE: ./src/components/molecules/HeaderMolecule.vue?vue&type=style&index=0&id=e85a9da2&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/HeaderMolecule.vue




;


const HeaderMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HeaderMoleculevue_type_script_lang_js, [['render',HeaderMoleculevue_type_template_id_e85a9da2_scoped_true_render],['__scopeId',"data-v-e85a9da2"]])

/* harmony default export */ var HeaderMolecule = (HeaderMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/FooterMolecule.vue?vue&type=template&id=101b3f82&scoped=true

const FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-101b3f82"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_1 = {
  key: 0,
  class: "footer-molecule__modal-atom__buttons"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_2 = /*#__PURE__*/FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross-secondary"
})], -1));
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_3 = {
  key: 1,
  class: "footer-molecule__modal-atom__buttons"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_4 = /*#__PURE__*/FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross"
})], -1));
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_5 = {
  key: 0,
  class: "footer-molecule__panel__validation__wrapper ace-shadow"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_6 = {
  key: 0,
  class: "footer-molecule__panel__validation__wrapper__header__expand footer-molecule__panel__validation__wrapper__header__expand--hide"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_7 = /*#__PURE__*/FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_8 = {
  key: 1,
  class: "footer-molecule__panel__validation__wrapper__header__expand"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_9 = /*#__PURE__*/FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_10 = {
  key: 0,
  class: "footer-molecule__panel__validation__wrapper__content ace-scroll"
};
const FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_11 = /*#__PURE__*/FooterMoleculevue_type_template_id_101b3f82_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#cross"
})], -1));
function FooterMoleculevue_type_template_id_101b3f82_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  const _component_NotificationAtom = (0,external_vue_namespaceObject.resolveComponent)("NotificationAtom");
  const _component_ModalAtom = (0,external_vue_namespaceObject.resolveComponent)("ModalAtom");
  const _component_ValidationAtom = (0,external_vue_namespaceObject.resolveComponent)("ValidationAtom");
  const _component_LoaderAtom = (0,external_vue_namespaceObject.resolveComponent)("LoaderAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["footer-molecule", {
      'footer-molecule--should-not-stick': !$data.shouldStick,
      'footer-molecule--modal': $props.mode === 'modal',
      'footer-molecule--headless': $options.isHeadless
    }]),
    ref: "footer"
  }, [$data.showWarning ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ModalAtom, {
    key: 0,
    type: "fullscreen",
    mode: "presentation",
    title: $props.modalTitle,
    size: "sm",
    onClose: _cache[2] || (_cache[2] = $event => $data.showWarning = false)
  }, {
    content: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createElementVNode)("div", null, (0,external_vue_namespaceObject.toDisplayString)($props.modalText), 1), !$props.alternativeWarning ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      type: "secondary",
      onClick: _cache[0] || (_cache[0] = $event => $data.showWarning = false)
    }, {
      default: (0,external_vue_namespaceObject.withCtx)(() => [FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_2, (0,external_vue_namespaceObject.createTextVNode)(" Avbryt ")]),
      _: 1
    }), (0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: "Nej",
      type: "secondary",
      onClick: $options.onConfirmCancelClick
    }, null, 8, ["onClick"]), (0,external_vue_namespaceObject.createVNode)(_component_NotificationAtom, {
      type: "error",
      label: "Obs!",
      direction: "up-left",
      value: $options.notificationValue,
      values: $options.multipleNotificationValues,
      active: $options.hasError
    }, {
      default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
        label: "Ja",
        onClick: $options.onConfirmClick,
        invalid: $options.hasError
      }, null, 8, ["onClick", "invalid"])]),
      _: 1
    }, 8, ["value", "values", "active"])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.alternativeWarning ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_3, [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: "Nej",
      type: "secondary",
      onClick: _cache[1] || (_cache[1] = $event => $data.showWarning = false)
    }), (0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: "Ja",
      onClick: $options.onConfirmCancelClick
    }, null, 8, ["onClick"])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]),
    _: 1
  }, 8, ["title"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.hasClose && !$options.isHeadless ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 1,
    class: "footer-molecule__close-button",
    type: "icon-action",
    onClick: $options.onCloseClick
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_4]),
    _: 1
  }, 8, ["onClick"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$props.hidePanel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 2,
    class: (0,external_vue_namespaceObject.normalizeClass)(["footer-molecule__panel", {
      'footer-molecule__panel--is-sticky': $data.isSticky,
      'footer-molecule__panel--modal': $props.mode === 'modal',
      'footer-molecule__panel--headless': $options.isHeadless,
      ['footer-molecule__panel--' + $props.size]: true
    }])
  }, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "panel", {}, () => [$options.hasError || $options.hasWarning ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["footer-molecule__panel__validation", {
      ['footer-molecule__panel__validation--' + $props.size]: true
    }])
  }, [$options.innerValidation.length === 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_5, [(0,external_vue_namespaceObject.createVNode)(_component_ValidationAtom, {
    value: $options.innerValidation[0].value,
    type: $options.innerValidation[0].type,
    anchor: $options.innerValidation[0].anchor
  }, null, 8, ["value", "type", "anchor"])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.innerValidation.length > 1 ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 1,
    class: "footer-molecule__panel__validation__wrapper footer-molecule__panel__validation__wrapper--expandable ace-shadow",
    onClick: _cache[3] || (_cache[3] = $event => $data.expandValidation = !$data.expandValidation)
  }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["footer-molecule__panel__validation__wrapper__header", {
      'footer-molecule__panel__validation__wrapper__header--expanded': $data.expandValidation
    }])
  }, [(0,external_vue_namespaceObject.createVNode)(_component_ValidationAtom, {
    value: $options.validationHeader.value,
    type: $options.validationHeader.type
  }, null, 8, ["value", "type"]), $data.expandValidation ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_6, [(0,external_vue_namespaceObject.createTextVNode)(" Dölj alla "), FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_7])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), !$data.expandValidation ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_8, [(0,external_vue_namespaceObject.createTextVNode)(" Se alla "), FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_9])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2), $data.expandValidation ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_10, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($options.innerValidation, (validation, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ValidationAtom, {
      key: index,
      value: validation.value,
      type: validation.type,
      anchor: validation.anchor,
      number: index + 1
    }, null, 8, ["value", "type", "anchor", "number"]);
  }), 128))])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.isLoading ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_LoaderAtom, {
    key: 1,
    mode: "action"
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "buttons", {}, () => [!$props.hideCancel ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 0,
    type: "secondary",
    disabled: $props.disabled || $props.disableCancel,
    onClick: _cache[4] || (_cache[4] = $event => $options.onCancelClick())
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [FooterMoleculevue_type_template_id_101b3f82_scoped_true_hoisted_11, (0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.cancelLabel), 1)]),
    _: 1
  }, 8, ["disabled"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.hasBack ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 1,
    type: "secondary",
    label: $props.backLabel,
    disabled: $props.disabled || $props.disableBack,
    onClick: $options.onBackClick
  }, null, 8, ["label", "disabled", "onClick"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.hasSaveAndClose ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 2,
    label: $props.saveAndCloseLabel,
    disabled: $props.disabled || $props.disableConfirm,
    invalid: $options.hasError,
    onClick: _cache[5] || (_cache[5] = $event => $options.onConfirmClick({
      closeAfterSave: true
    }))
  }, null, 8, ["label", "disabled", "invalid"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createVNode)(_component_NotificationAtom, {
    type: $options.notificationType,
    active: $options.hasWarning,
    readonly: ""
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: $props.confirmLabel,
      disabled: $props.disabled || $props.disableConfirm || $options.hasError,
      onClick: $options.onConfirmClick
    }, null, 8, ["label", "disabled", "onClick"])]),
    _: 1
  }, 8, ["type", "active"])], true)], true)], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/molecules/FooterMolecule.vue?vue&type=template&id=101b3f82&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/FooterMolecule.vue?vue&type=script&lang=js


/* harmony default export */ var FooterMoleculevue_type_script_lang_js = ({
  props: {
    direction: {
      type: String,
      default: 'up-left'
    },
    containerSelector: {
      type: String,
      default: '#ace-main-content'
    },
    cancelLabel: {
      type: String,
      default: 'Avbryt'
    },
    disableCancel: Boolean,
    confirmLabel: {
      type: String,
      default: 'Spara'
    },
    disableConfirm: Boolean,
    hasBack: Boolean,
    backLabel: {
      type: String,
      default: 'Tillbaka'
    },
    disableBack: Boolean,
    description: String,
    disabled: Boolean,
    validation: Array,
    error: String,
    errors: Array,
    warning: String,
    warnings: Array,
    hasChanges: Boolean,
    hasClose: Boolean,
    hidePanel: Boolean,
    hideCancel: Boolean,
    multilineNotification: Boolean,
    isLoading: Boolean,
    alternativeWarning: Boolean,
    size: {
      type: String,
      default: 'regular'
    },
    modalText: {
      type: String,
      default: 'Du har förändrat information! Vill du spara innan du stänger?'
    },
    modalTitle: {
      type: String,
      default: 'Obs!'
    },
    mode: {
      type: String,
      default: 'sticky',
      validator: val => {
        return ['sticky', 'modal'].includes(val);
      }
    },
    hasSaveAndClose: Boolean,
    saveAndCloseLabel: {
      type: String,
      default: 'Spara och stäng'
    }
  },
  components: {
    ButtonAtom: ButtonAtom,
    NotificationAtom: NotificationAtom,
    ModalAtom: ModalAtom,
    LoaderAtom: LoaderAtom,
    ValidationAtom: ValidationAtom
  },
  data() {
    return {
      showWarning: false,
      shouldStick: true,
      isSticky: false,
      resizeObserver: undefined,
      closePage: false,
      hasConfirmedCancel: false,
      toRoute: undefined,
      currentRoute: undefined,
      navigationGuardHook: undefined,
      expandValidation: false
    };
  },
  computed: {
    showNotification() {
      if (this.hasWarning || this.hasError) {
        return true;
      }
      return false;
    },
    notificationType() {
      if (this.hasWarning) {
        return 'warning';
      }
      return undefined;
    },
    notificationValue() {
      if (this.hasError) {
        return this.error;
      }
      return this.warning;
    },
    multipleNotificationValues() {
      if (this.hasError) return this.errors;else return this.warnings;
    },
    hasWarning() {
      if (this.warning || this.warnings || this.hasValidationWarnings) {
        return true;
      }
      return false;
    },
    hasError() {
      if (this.error || this.errors || this.hasValidationErrors) {
        return true;
      }
      return false;
    },
    isHeadless() {
      return window.location.search.indexOf('?headless') !== -1;
    },
    isModal() {
      return this.mode === 'modal';
    },
    hasValidationErrors() {
      if (!this.validation) {
        return false;
      }
      return this.validation.some(x => x.type === 'error');
    },
    hasValidationWarnings() {
      if (!this.validation) {
        return false;
      }
      return this.validation.some(x => x.type === 'warning');
    },
    innerValidation() {
      let result = [];
      if (this.validation) {
        result = result.concat(this.validation);
      }
      if (this.error) {
        result.push({
          value: this.error,
          type: 'error'
        });
      }
      if (this.errors) {
        result = result.concat(this.errors.map(x => {
          return {
            value: x,
            type: 'error'
          };
        }));
      }
      if (this.warning) {
        result.push({
          value: this.warning,
          type: 'warning'
        });
      }
      if (this.warnings) {
        result = result.concat(this.warnings.map(x => {
          return {
            value: x,
            type: 'warning'
          };
        }));
      }
      if (this.hasError) {
        return result.filter(x => x.type === 'error');
      }
      return result;
    },
    validationHeader() {
      if (this.hasError) {
        return {
          value: 'Du måste åtgärda ' + this.innerValidation.length + ' fel innan du kan spara.',
          type: 'error'
        };
      } else {
        return {
          value: 'Det finns ' + this.innerValidation.length + ' saker som du bör kontrollera innan du sparar.',
          type: 'warning'
        };
      }
    }
  },
  methods: {
    onCancelClick() {
      this.closePage = false;
      if (this.hasChanges) {
        this.showWarning = true;
      } else {
        this.emitCancel();
      }
    },
    onCloseClick() {
      if (this.hasChanges && !this.showWarning) {
        this.showWarning = true;
        this.closePage = true;
      } else {
        this.$emit('close');
      }
    },
    onConfirmCancelClick() {
      if (this.closePage) this.$emit('close');else this.emitCancel();
      if (!this.isModal) {
        this.showWarning = false;
        this.hasConfirmedCancel = true;
        if (this.toRoute && this.toRoute.name !== this.currentRoute) {
          this.$router.push(this.toRoute);
          //this.cleanupConfirm();
        }
      }
    },

    onBackClick() {
      this.$emit('back');
    },
    onConfirmClick(e = {}) {
      if (this.hasError) {
        return;
      }
      if (this.showWarning) {
        this.showWarning = false;
      }
      if (this.closePage || e.closeAfterSave) this.emitConfirm(true);else this.emitConfirm();
      this.closePage = false;
      this.cleanupConfirm();
    },
    emitCancel(closeAfterCancel) {
      this.$emit('cancel', {
        closeAfterCancel: closeAfterCancel
      });
    },
    emitConfirm(closeAfterSave) {
      this.$emit('confirm', {
        closeAfterSave: closeAfterSave,
        toRoute: this.toRoute?.fullPath
      });
    },
    checkIfSticky(ele) {
      if (this.mode === 'modal') {
        return;
      }
      let scrollingProgress = ele.scrollTop / (ele.scrollHeight - ele.clientHeight);
      if (isNaN(scrollingProgress)) {
        if (this.isSticky) {
          this.isSticky = false;
        }
        return;
      }
      if (scrollingProgress < 1 && !this.isSticky) {
        this.isSticky = true;
      } else if (scrollingProgress === 1 && this.isSticky) {
        this.isSticky = false;
      }
    },
    onResizeObserved(e) {
      e.forEach(entry => {
        this.checkIfSticky(entry.target);
      });
    },
    onContainerScroll(e) {
      this.checkIfSticky(e.target);
    },
    cleanupConfirm() {
      this.toRoute = undefined;
      this.hasConfirmedCancel = false;
      this.showWarning = false;
    },
    onBeforeUnload(e) {
      const expires = document.cookie.split('; ').find(row => row.startsWith('goatExpires='))?.split('=')[1];
      if (expires && this.hasChanges) {
        return 'Du har förändrat information! Vill du lämna?';
      }
      return undefined;
    }
  },
  mounted() {
    if (this.mode === 'sticky') {
      let scrollingContainer = document.querySelector(this.containerSelector);
      if (scrollingContainer) {
        scrollingContainer.addEventListener('scroll', this.onContainerScroll);
        this.checkIfSticky(scrollingContainer);
        this.resizeObserver = new ResizeObserver(this.onResizeObserved);
        this.resizeObserver.observe(scrollingContainer);
      } else {
        this.shouldStick = false;
      }
    }
    if (!this.isModal) {
      this.currentRoute = this.$route.name;
      this.navigationGuardHook = this.$router.beforeResolve((to, from, next) => {
        this.toRoute = to;
        if (to.params.force) {
          next();
          return;
        }
        if (from.fullPath !== '/' && to.fullPath.indexOf(from.fullPath) !== -1) {
          next();
          return;
        }
        if (from.name !== this.currentRoute) {
          next();
          return;
        }
        if (this.hasChanges && !this.hasConfirmedCancel) {
          this.showWarning = true;
        }
        if (this.hasChanges && this.hasConfirmedCancel || !this.hasChanges) {
          next();
        }
      });
      window.onbeforeunload = this.onBeforeUnload;
    }
  },
  beforeUnmount() {
    if (this.mode === 'sticky') {
      this.navigationGuardHook();
      window.removeEventListener('beforeunload', this.onBeforeUnload);
      this.cleanupConfirm();
      this.currentRoute = undefined;
      let scrollingContainer = document.querySelector(this.containerSelector);
      if (scrollingContainer) {
        scrollingContainer.removeEventListener('scroll', this.onContainerScroll);
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/FooterMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/FooterMolecule.vue?vue&type=style&index=0&id=101b3f82&scoped=true&lang=css
var FooterMoleculevue_type_style_index_0_id_101b3f82_scoped_true_lang_css = __webpack_require__(4255);
;// CONCATENATED MODULE: ./src/components/molecules/FooterMolecule.vue?vue&type=style&index=0&id=101b3f82&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/FooterMolecule.vue




;


const FooterMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FooterMoleculevue_type_script_lang_js, [['render',FooterMoleculevue_type_template_id_101b3f82_scoped_true_render],['__scopeId',"data-v-101b3f82"]])

/* harmony default export */ var FooterMolecule = (FooterMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/InformationMolecule.vue?vue&type=template&id=f5de3356&scoped=true

const InformationMoleculevue_type_template_id_f5de3356_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-f5de3356"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_1 = {
  class: "information-molecule ace-shadow ace-scroll"
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_2 = /*#__PURE__*/InformationMoleculevue_type_template_id_f5de3356_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("div", {
  class: "information-molecule__icon-container"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", {
  class: "information-molecule__icon-container__icon"
}, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#info"
})])], -1));
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_3 = {
  class: "information-molecule__content"
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_4 = {
  key: 0
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_5 = {
  key: 1
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_6 = {
  key: 0
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_7 = {
  key: 0
};
const InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_8 = {
  key: 2,
  class: "information-molecule__content__example"
};
function InformationMoleculevue_type_template_id_f5de3356_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_1, [InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_2, (0,external_vue_namespaceObject.createElementVNode)("div", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_3, [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "content", {}, () => [$props.header ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("h3", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_4, (0,external_vue_namespaceObject.toDisplayString)($props.header), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.text || $props.intro ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("p", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_5, [$props.intro ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_6, (0,external_vue_namespaceObject.toDisplayString)($props.intro), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createTextVNode)(" " + (0,external_vue_namespaceObject.toDisplayString)($props.text), 1)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), ((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.texts, (introText, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("p", {
      key: index
    }, [introText.intro ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("span", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_7, (0,external_vue_namespaceObject.toDisplayString)(introText.intro), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createTextVNode)(" " + (0,external_vue_namespaceObject.toDisplayString)(introText.text), 1)]);
  }), 128)), $props.example && $data.expand ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("p", InformationMoleculevue_type_template_id_f5de3356_scoped_true_hoisted_8, (0,external_vue_namespaceObject.toDisplayString)($props.example), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.example ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ButtonAtom, {
    key: 3,
    type: "action",
    label: $data.expand ? 'Dölj exempel' : 'Visa exempel',
    style: {
      "margin-top": "16px"
    },
    onClick: _cache[0] || (_cache[0] = $event => $data.expand = !$data.expand)
  }, null, 8, ["label"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)], true)])]);
}
;// CONCATENATED MODULE: ./src/components/molecules/InformationMolecule.vue?vue&type=template&id=f5de3356&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/InformationMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var InformationMoleculevue_type_script_lang_js = ({
  name: 'InformationMolecule',
  props: {
    header: String,
    intro: String,
    text: String,
    texts: Array,
    example: String
  },
  components: {
    ButtonAtom: ButtonAtom
  },
  data() {
    return {
      expand: false
    };
  },
  computed: {}
});
;// CONCATENATED MODULE: ./src/components/molecules/InformationMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/InformationMolecule.vue?vue&type=style&index=0&id=f5de3356&scoped=true&lang=css
var InformationMoleculevue_type_style_index_0_id_f5de3356_scoped_true_lang_css = __webpack_require__(3432);
;// CONCATENATED MODULE: ./src/components/molecules/InformationMolecule.vue?vue&type=style&index=0&id=f5de3356&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/InformationMolecule.vue




;


const InformationMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(InformationMoleculevue_type_script_lang_js, [['render',InformationMoleculevue_type_template_id_f5de3356_scoped_true_render],['__scopeId',"data-v-f5de3356"]])

/* harmony default export */ var InformationMolecule = (InformationMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=template&id=13b9c5bc&scoped=true

const UnsavedChangesMoleculevue_type_template_id_13b9c5bc_scoped_true_withScopeId = n => (_pushScopeId("data-v-13b9c5bc"), n = n(), _popScopeId(), n);
const UnsavedChangesMoleculevue_type_template_id_13b9c5bc_scoped_true_hoisted_1 = {
  class: "unsaved-changes-molecule__buttons"
};
function UnsavedChangesMoleculevue_type_template_id_13b9c5bc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  const _component_NotificationAtom = (0,external_vue_namespaceObject.resolveComponent)("NotificationAtom");
  const _component_ModalAtom = (0,external_vue_namespaceObject.resolveComponent)("ModalAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ModalAtom, {
    type: "fullscreen",
    mode: "presentation",
    size: "sm",
    onClose: $options.emitClose
  }, {
    content: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createElementVNode)("div", null, (0,external_vue_namespaceObject.toDisplayString)($props.description), 1), (0,external_vue_namespaceObject.createElementVNode)("div", UnsavedChangesMoleculevue_type_template_id_13b9c5bc_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: "Avbryt",
      type: "secondary",
      onClick: $options.emitClose
    }, null, 8, ["onClick"]), (0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
      label: "Nej",
      type: "secondary",
      onClick: $options.emitCancel
    }, null, 8, ["onClick"]), (0,external_vue_namespaceObject.createVNode)(_component_NotificationAtom, {
      type: "error",
      label: "Obs!",
      direction: "up-left",
      value: $props.error,
      active: $options.hasError
    }, {
      default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
        label: "Ja",
        onClick: $options.onConfirmClick,
        invalid: $options.hasError
      }, null, 8, ["onClick", "invalid"])]),
      _: 1
    }, 8, ["value", "active"])])]),
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)(" >")]),
    _: 1
  }, 8, ["onClose"]);
}
;// CONCATENATED MODULE: ./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=template&id=13b9c5bc&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var UnsavedChangesMoleculevue_type_script_lang_js = ({
  name: 'UnsavedChangesMolecule',
  props: {
    error: String,
    description: {
      type: String,
      default: 'Du har förändrat information! Vill du spara innan du stänger?'
    }
  },
  components: {
    ButtonAtom: ButtonAtom,
    NotificationAtom: NotificationAtom,
    ModalAtom: ModalAtom
  },
  computed: {
    hasError() {
      if (this.error) {
        return true;
      }
      return false;
    }
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    emitCancel() {
      this.$emit('cancel');
    },
    onConfirmClick() {
      if (this.hasError) {
        return;
      }
      this.emitConfirm();
    },
    emitConfirm() {
      this.$emit('confirm');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=style&index=0&id=13b9c5bc&scoped=true&lang=css
var UnsavedChangesMoleculevue_type_style_index_0_id_13b9c5bc_scoped_true_lang_css = __webpack_require__(1462);
;// CONCATENATED MODULE: ./src/components/molecules/UnsavedChangesMolecule.vue?vue&type=style&index=0&id=13b9c5bc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/UnsavedChangesMolecule.vue




;


const UnsavedChangesMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(UnsavedChangesMoleculevue_type_script_lang_js, [['render',UnsavedChangesMoleculevue_type_template_id_13b9c5bc_scoped_true_render],['__scopeId',"data-v-13b9c5bc"]])

/* harmony default export */ var UnsavedChangesMolecule = (UnsavedChangesMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/ExportMolecule.vue?vue&type=template&id=af610272

const ExportMoleculevue_type_template_id_af610272_hoisted_1 = {
  class: "export-molecule"
};
const ExportMoleculevue_type_template_id_af610272_hoisted_2 = {
  ref: "downloadLink"
};
function ExportMoleculevue_type_template_id_af610272_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  const _component_LoaderAtom = (0,external_vue_namespaceObject.resolveComponent)("LoaderAtom");
  const _component_DialogAtom = (0,external_vue_namespaceObject.resolveComponent)("DialogAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ExportMoleculevue_type_template_id_af610272_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("a", ExportMoleculevue_type_template_id_af610272_hoisted_2, null, 512), (0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
    tooltip: $props.label,
    type: $props.buttonType,
    disabled: $props.disabled,
    truncated: "",
    onClick: $options.onStartExport
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($props.label), 1)])]),
    _: 3
  }, 8, ["tooltip", "type", "disabled", "onClick"]), $data.isLoaderActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_LoaderAtom, {
    key: 0,
    mode: "fullscreen",
    header: "Hämtar..."
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $data.isErrorActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_DialogAtom, {
    key: 1,
    type: "error",
    onClose: _cache[0] || (_cache[0] = $event => $data.isErrorActive = false)
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)("Det gick inte att hämta filen.")]),
    _: 1
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $data.isWarningActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_DialogAtom, {
    key: 2,
    type: "warning",
    label: "Varning",
    onClose: _cache[1] || (_cache[1] = $event => $data.isWarningActive = false)
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($data.warningMessage), 1)]),
    _: 1
  })) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/molecules/ExportMolecule.vue?vue&type=template&id=af610272

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(6229);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(7330);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(2062);
;// CONCATENATED MODULE: ./src/components/molecules/ExportMolecule.logic.js



function _getUrl(baseUrl, url) {
  return `${baseUrl}${url}`;
}
/* harmony default export */ var ExportMolecule_logic = ({
  async getFile(baseUrl, url, accessToken) {
    let endpoint = _getUrl(baseUrl, url);
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + accessToken);
    try {
      let response = await fetch(endpoint, {
        headers
      });
      if (response.status === 400) {
        let warningJson = await response.json();
        return warningJson;
      }
      if (response.status === 401) {
        return 'Din session avslutades.';
      }
      if (!response.ok) {
        throw 'Error processing file';
      }
      let blobby = await response.blob();
      return blobby;
    } catch (e) {
      return 'Det uppstod ett problem med att hämta filen.';
    }
  },
  async getFileViaPost(baseUrl, url, accessToken, payload) {
    let endpoint = _getUrl(baseUrl, url);
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + accessToken);
    try {
      let response = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
      });
      if (response.status === 400) {
        let warningJson = await response.json();
        return warningJson;
      }
      if (response.status === 401) {
        return 'Din session avslutades.';
      }
      if (!response.ok) {
        throw 'Error processing file';
      }
      let blobby = await response.blob();
      return blobby;
    } catch (e) {
      return 'Det uppstod ett problem med att hämta filen.';
    }
  },
  triggerFileDownload(blobby, anchor, fileFullname) {
    let objectUrl = window.URL.createObjectURL(blobby);
    anchor.href = objectUrl;
    anchor.download = `${fileFullname}`;
    anchor.click();
    window.URL.revokeObjectURL(objectUrl);
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/ExportMolecule.vue?vue&type=script&lang=js


/* harmony default export */ var ExportMoleculevue_type_script_lang_js = ({
  name: 'ExportMolecule',
  components: {
    ButtonAtom: ButtonAtom,
    LoaderAtom: LoaderAtom,
    DialogAtom: DialogAtom
  },
  props: {
    disabled: Boolean,
    label: {
      type: String,
      default: 'Exportera'
    },
    buttonType: {
      type: String,
      default: 'action'
    },
    baseUrl: String,
    url: String,
    accessToken: String,
    fileFullname: String,
    payload: [Object, Array],
    method: {
      type: String,
      default: 'GET'
    }
  },
  data() {
    return {
      isLoaderActive: false,
      isErrorActive: false,
      isWarningActive: false,
      warningMessage: ''
    };
  },
  methods: {
    onStartExport() {
      this.isLoaderActive = true;
      this.downloadFile();
    },
    async downloadFile() {
      let anchor = this.$refs.downloadLink;
      try {
        let result;
        if (this.method === 'GET') {
          result = await ExportMolecule_logic.getFile(this.baseUrl, this.url, this.accessToken);
          if (!(result instanceof Blob)) {
            this.warningMessage = result;
            this.isWarningActive = true;
            this.isLoaderActive = false;
            return;
          }
        } else if (this.method === 'POST') {
          result = await ExportMolecule_logic.getFileViaPost(this.baseUrl, this.url, this.accessToken, this.payload);
          if (!(result instanceof Blob)) {
            this.warningMessage = result;
            this.isWarningActive = true;
            this.isLoaderActive = false;
            return;
          }
        }
        ExportMolecule_logic.triggerFileDownload(result, anchor, this.fileFullname);
      } catch (e) {
        this.isErrorActive = true;
      }
      this.isLoaderActive = false;
      if (!this.isErrorActive) {
        this.$emit('downloadingDone');
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/ExportMolecule.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/molecules/ExportMolecule.vue




;
const ExportMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExportMoleculevue_type_script_lang_js, [['render',ExportMoleculevue_type_template_id_af610272_render]])

/* harmony default export */ var ExportMolecule = (ExportMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=template&id=2072decc&scoped=true

const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-2072decc"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_1 = {
  class: "text-editor-molecule"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_2 = {
  class: "text-editor-molecule__header"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_3 = {
  class: "ace-input-label"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_4 = {
  key: 0,
  class: "text-editor-molecule__action-bar"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_5 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-header"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_6 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_5];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_7 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-bold"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_8 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_7];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_9 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-italic"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_10 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_9];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_11 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-link"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_12 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_11];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_13 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-list-dot"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_14 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_13];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_15 = /*#__PURE__*/TextEditorMoleculevue_type_template_id_2072decc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#editor-list-number"
}, null, -1));
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_16 = [TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_15];
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_17 = {
  key: 0,
  class: "text-editor-molecule__link"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_18 = {
  class: "ace-input-wrapper"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_19 = {
  class: "text-editor-molecule__meta"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_20 = {
  class: "text-editor-molecule__meta__text"
};
const TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_21 = {
  class: "text-editor-molecule__meta__text text-editor-molecule__meta__text--last"
};
function TextEditorMoleculevue_type_template_id_2072decc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextInputAtom = (0,external_vue_namespaceObject.resolveComponent)("TextInputAtom");
  const _component_ButtonAtom = (0,external_vue_namespaceObject.resolveComponent)("ButtonAtom");
  const _component_EditorContent = (0,external_vue_namespaceObject.resolveComponent)("EditorContent");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createElementVNode)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_2, [(0,external_vue_namespaceObject.createElementVNode)("label", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_3, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1), (0,external_vue_namespaceObject.createElementVNode)("div", null, [$data.editor ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_4, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Header",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('heading', {
        level: 1
      })
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[0] || (_cache[0] = $event => $data.editor.chain().focus().toggleHeading({
      level: 1
    }).run())
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_6))], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Bold",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('bold')
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[1] || (_cache[1] = $event => $data.editor.chain().focus().toggleBold().run())
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_8))], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Italic",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('italic')
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[2] || (_cache[2] = $event => $data.editor.chain().focus().toggleItalic().run())
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_10))], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Link",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('link')
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showLinkMenu && $options.showLinkMenu(...args))
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_12))], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Dotted list",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('bulletList')
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[4] || (_cache[4] = $event => $data.editor.chain().focus().toggleBulletList().run())
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_14))], 2), (0,external_vue_namespaceObject.createElementVNode)("div", {
    title: "Numbered list",
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__icon-wrapper", {
      'text-editor-molecule__icon--active': $data.editor.isActive('orderedList')
    }])
  }, [((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", {
    class: "text-editor-molecule__icon",
    onClick: _cache[5] || (_cache[5] = $event => $data.editor.chain().focus().toggleOrderedList().run())
  }, TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_16))], 2), $data.linkMenuIsActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_17, [(0,external_vue_namespaceObject.createVNode)(_component_TextInputAtom, {
    placeholder: "https://",
    value: $data.linkUrl,
    onInput: $options.onHrefInput
  }, null, 8, ["value", "onInput"]), (0,external_vue_namespaceObject.createElementVNode)("div", null, [(0,external_vue_namespaceObject.createVNode)(_component_ButtonAtom, {
    class: "text-editor-molecule__link__button",
    size: "small",
    onClick: $options.setLinkUrl
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [(0,external_vue_namespaceObject.createTextVNode)("OK")]),
    _: 1
  }, 8, ["onClick"])])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)])]), (0,external_vue_namespaceObject.createElementVNode)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_18, [$data.editor ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_vue_namespaceObject.normalizeClass)(["text-editor-molecule__field ace-input ace-scroll", {
      'ace-input--error': $props.error
    }])
  }, [(0,external_vue_namespaceObject.createVNode)(_component_EditorContent, {
    class: "text-editor-molecule__field__editor",
    editor: $data.editor
  }, null, 8, ["editor"])], 2)) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]), (0,external_vue_namespaceObject.createElementVNode)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_19, [(0,external_vue_namespaceObject.createElementVNode)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_20, "Max " + (0,external_vue_namespaceObject.toDisplayString)(this.maxSize) + " tecken", 1), (0,external_vue_namespaceObject.createElementVNode)("div", TextEditorMoleculevue_type_template_id_2072decc_scoped_true_hoisted_21, (0,external_vue_namespaceObject.toDisplayString)($options.charactersLeft) + " tecken kvar", 1)])]);
}
;// CONCATENATED MODULE: ./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=template&id=2072decc&scoped=true

;// CONCATENATED MODULE: ./node_modules/orderedmap/dist/index.js
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var result = {};
    this.forEach(function(key, value) { result[key] = value; });
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

/* harmony default export */ var dist = (OrderedMap);

;// CONCATENATED MODULE: ./node_modules/prosemirror-model/dist/index.js


function findDiffStart(a, b, pos) {
    for (let i = 0;; i++) {
        if (i == a.childCount || i == b.childCount)
            return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB))
            return pos;
        if (childA.isText && childA.text != childB.text) {
            for (let j = 0; childA.text[j] == childB.text[j]; j++)
                pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null)
                return inner;
        }
        pos += childA.nodeSize;
    }
}
function findDiffEnd(a, b, posA, posB) {
    for (let iA = a.childCount, iB = b.childCount;;) {
        if (iA == 0 || iB == 0)
            return iA == iB ? null : { a: posA, b: posB };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB))
            return { a: posA, b: posB };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
                same++;
                posA--;
                posB--;
            }
            return { a: posA, b: posB };
        }
        if (childA.content.size || childB.content.size) {
            let inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner)
                return inner;
        }
        posA -= size;
        posB -= size;
    }
}

/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/
class dist_Fragment {
    /**
    @internal
    */
    constructor(
    /**
    The child nodes in this fragment.
    */
    content, size) {
        this.content = content;
        this.size = size || 0;
        if (size == null)
            for (let i = 0; i < content.length; i++)
                this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */
    nodesBetween(from, to, f, nodeStart = 0, parent) {
        for (let i = 0, pos = 0; pos < to; i++) {
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */
    descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */
    textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos) => {
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos)
                : !node.isLeaf ? ""
                    : leafText ? (typeof leafText === "function" ? leafText(node) : leafText)
                        : node.type.spec.leafText ? node.type.spec.leafText(node)
                            : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first)
                    first = false;
                else
                    text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */
    append(other) {
        if (!other.size)
            return this;
        if (!this.size)
            return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for (; i < other.content.length; i++)
            content.push(other.content[i]);
        return new dist_Fragment(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */
    cut(from, to = this.size) {
        if (from == 0 && to == this.size)
            return this;
        let result = [], size = 0;
        if (to > from)
            for (let i = 0, pos = 0; pos < to; i++) {
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText)
                            child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else
                            child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
        return new dist_Fragment(result, size);
    }
    /**
    @internal
    */
    cutByIndex(from, to) {
        if (from == to)
            return dist_Fragment.empty;
        if (from == 0 && to == this.content.length)
            return this;
        return new dist_Fragment(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */
    replaceChild(index, node) {
        let current = this.content[index];
        if (current == node)
            return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new dist_Fragment(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */
    addToStart(node) {
        return new dist_Fragment([node].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */
    addToEnd(node) {
        return new dist_Fragment(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */
    eq(other) {
        if (this.content.length != other.content.length)
            return false;
        for (let i = 0; i < this.content.length; i++)
            if (!this.content[i].eq(other.content[i]))
                return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */
    get firstChild() { return this.content.length ? this.content[0] : null; }
    /**
    The last child of the fragment, or `null` if it is empty.
    */
    get lastChild() { return this.content.length ? this.content[this.content.length - 1] : null; }
    /**
    The number of child nodes in this fragment.
    */
    get childCount() { return this.content.length; }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */
    child(index) {
        let found = this.content[index];
        if (!found)
            throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */
    maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */
    forEach(f) {
        for (let i = 0, p = 0; i < this.content.length; i++) {
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */
    findDiffStart(other, pos = 0) {
        return findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */
    findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */
    findIndex(pos, round = -1) {
        if (pos == 0)
            return retIndex(0, pos);
        if (pos == this.size)
            return retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0)
            throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for (let i = 0, curPos = 0;; i++) {
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0)
                    return retIndex(i + 1, end);
                return retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */
    toString() { return "<" + this.toStringInner() + ">"; }
    /**
    @internal
    */
    toStringInner() { return this.content.join(", "); }
    /**
    Create a JSON-serializeable representation of this fragment.
    */
    toJSON() {
        return this.content.length ? this.content.map(n => n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */
    static fromJSON(schema, value) {
        if (!value)
            return dist_Fragment.empty;
        if (!Array.isArray(value))
            throw new RangeError("Invalid input for Fragment.fromJSON");
        return new dist_Fragment(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */
    static fromArray(array) {
        if (!array.length)
            return dist_Fragment.empty;
        let joined, size = 0;
        for (let i = 0; i < array.length; i++) {
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined)
                    joined = array.slice(0, i);
                joined[joined.length - 1] = node
                    .withText(joined[joined.length - 1].text + node.text);
            }
            else if (joined) {
                joined.push(node);
            }
        }
        return new dist_Fragment(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */
    static from(nodes) {
        if (!nodes)
            return dist_Fragment.empty;
        if (nodes instanceof dist_Fragment)
            return nodes;
        if (Array.isArray(nodes))
            return this.fromArray(nodes);
        if (nodes.attrs)
            return new dist_Fragment([nodes], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" +
            (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/
dist_Fragment.empty = new dist_Fragment([], 0);
const found = { index: 0, offset: 0 };
function retIndex(index, offset) {
    found.index = index;
    found.offset = offset;
    return found;
}

function compareDeep(a, b) {
    if (a === b)
        return true;
    if (!(a && typeof a == "object") ||
        !(b && typeof b == "object"))
        return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array)
        return false;
    if (array) {
        if (a.length != b.length)
            return false;
        for (let i = 0; i < a.length; i++)
            if (!compareDeep(a[i], b[i]))
                return false;
    }
    else {
        for (let p in a)
            if (!(p in b) || !compareDeep(a[p], b[p]))
                return false;
        for (let p in b)
            if (!(p in a))
                return false;
    }
    return true;
}

/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/
class Mark {
    /**
    @internal
    */
    constructor(
    /**
    The type of this mark.
    */
    type, 
    /**
    The attributes associated with this mark.
    */
    attrs) {
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */
    addToSet(set) {
        let copy, placed = false;
        for (let i = 0; i < set.length; i++) {
            let other = set[i];
            if (this.eq(other))
                return set;
            if (this.type.excludes(other.type)) {
                if (!copy)
                    copy = set.slice(0, i);
            }
            else if (other.type.excludes(this.type)) {
                return set;
            }
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy)
                        copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy)
                    copy.push(other);
            }
        }
        if (!copy)
            copy = set.slice();
        if (!placed)
            copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */
    removeFromSet(set) {
        for (let i = 0; i < set.length; i++)
            if (this.eq(set[i]))
                return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */
    isInSet(set) {
        for (let i = 0; i < set.length; i++)
            if (this.eq(set[i]))
                return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */
    eq(other) {
        return this == other ||
            (this.type == other.type && compareDeep(this.attrs, other.attrs));
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */
    toJSON() {
        let obj = { type: this.type.name };
        for (let _ in this.attrs) {
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */
    static fromJSON(schema, json) {
        if (!json)
            throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type)
            throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */
    static sameSet(a, b) {
        if (a == b)
            return true;
        if (a.length != b.length)
            return false;
        for (let i = 0; i < a.length; i++)
            if (!a[i].eq(b[i]))
                return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */
    static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0)
            return Mark.none;
        if (marks instanceof Mark)
            return [marks];
        let copy = marks.slice();
        copy.sort((a, b) => a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/
Mark.none = [];

/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/
class ReplaceError extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/
/**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/
class dist_Slice {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */
    constructor(
    /**
    The slice's content.
    */
    content, 
    /**
    The open depth at the start of the fragment.
    */
    openStart, 
    /**
    The open depth at the end.
    */
    openEnd) {
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */
    get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */
    insertAt(pos, fragment) {
        let content = insertInto(this.content, pos + this.openStart, fragment);
        return content && new dist_Slice(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */
    removeBetween(from, to) {
        return new dist_Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */
    eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */
    toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */
    toJSON() {
        if (!this.content.size)
            return null;
        let json = { content: this.content.toJSON() };
        if (this.openStart > 0)
            json.openStart = this.openStart;
        if (this.openEnd > 0)
            json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */
    static fromJSON(schema, json) {
        if (!json)
            return dist_Slice.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number")
            throw new RangeError("Invalid input for Slice.fromJSON");
        return new dist_Slice(dist_Fragment.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */
    static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for (let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)
            openStart++;
        for (let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)
            openEnd++;
        return new dist_Slice(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/
dist_Slice.empty = new dist_Slice(dist_Fragment.empty, 0, 0);
function removeRange(content, from, to) {
    let { index, offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText)
            throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo)
        throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function insertInto(content, dist, insert, parent) {
    let { index, offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert))
            return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function replace($from, $to, slice) {
    if (slice.openStart > $from.depth)
        throw new ReplaceError("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
        throw new ReplaceError("Inconsistent open depths");
    return replaceOuter($from, $to, slice, 0);
}
function replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    }
    else if (!slice.content.size) {
        return dist_close(node, replaceTwoWay($from, $to, depth));
    }
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
        let parent = $from.parent, content = parent.content;
        return dist_close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    }
    else {
        let { start, end } = prepareSliceForReplace(slice, $from);
        return dist_close(node, replaceThreeWay($from, start, end, $to, depth));
    }
}
function checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type))
        throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function joinable($before, $after, depth) {
    let node = $before.node(depth);
    checkJoin(node, $after.node(depth));
    return node;
}
function addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last]))
        target[last] = child.withText(target[last].text + child.text);
    else
        target.push(child);
}
function addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) {
            startIndex++;
        }
        else if ($start.textOffset) {
            addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for (let i = startIndex; i < endIndex; i++)
        addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset)
        addNode($end.nodeBefore, target);
}
function dist_close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && joinable($end, $to, depth + 1);
    let content = [];
    addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        checkJoin(openStart, openEnd);
        addNode(dist_close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    }
    else {
        if (openStart)
            addNode(dist_close(openStart, replaceTwoWay($from, $start, depth + 1)), content);
        addRange($start, $end, depth, content);
        if (openEnd)
            addNode(dist_close(openEnd, replaceTwoWay($end, $to, depth + 1)), content);
    }
    addRange($to, null, depth, content);
    return new dist_Fragment(content);
}
function replaceTwoWay($from, $to, depth) {
    let content = [];
    addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = joinable($from, $to, depth + 1);
        addNode(dist_close(type, replaceTwoWay($from, $to, depth + 1)), content);
    }
    addRange($to, null, depth, content);
    return new dist_Fragment(content);
}
function prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for (let i = extra - 1; i >= 0; i--)
        node = $along.node(i).copy(dist_Fragment.from(node));
    return { start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra) };
}

/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/
class ResolvedPos {
    /**
    @internal
    */
    constructor(
    /**
    The position that was resolved.
    */
    pos, 
    /**
    @internal
    */
    path, 
    /**
    The offset this position has into its parent node.
    */
    parentOffset) {
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */
    resolveDepth(val) {
        if (val == null)
            return this.depth;
        if (val < 0)
            return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */
    get parent() { return this.node(this.depth); }
    /**
    The root node in which the position was resolved.
    */
    get doc() { return this.node(0); }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */
    node(depth) { return this.path[this.resolveDepth(depth) * 3]; }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */
    index(depth) { return this.path[this.resolveDepth(depth) * 3 + 1]; }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */
    indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */
    start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */
    end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */
    before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth)
            throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */
    after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth)
            throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */
    get textOffset() { return this.pos - this.path[this.path.length - 1]; }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */
    get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount)
            return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */
    get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff)
            return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */
    posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for (let i = 0; i < index; i++)
            pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */
    marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0)
            return Mark.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset)
            return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for (var i = 0; i < marks.length; i++)
            if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
                marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */
    marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline)
            return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for (var i = 0; i < marks.length; i++)
            if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
                marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */
    sharedDepth(pos) {
        for (let depth = this.depth; depth > 0; depth--)
            if (this.start(depth) <= pos && this.end(depth) >= pos)
                return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */
    blockRange(other = this, pred) {
        if (other.pos < this.pos)
            return other.blockRange(this);
        for (let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
            if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
                return new NodeRange(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */
    sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */
    max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */
    min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */
    toString() {
        let str = "";
        for (let i = 1; i <= this.depth; i++)
            str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */
    static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size))
            throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for (let node = doc;;) {
            let { index, offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem)
                break;
            node = node.child(index);
            if (node.isText)
                break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new ResolvedPos(pos, path, parentOffset);
    }
    /**
    @internal
    */
    static resolveCached(doc, pos) {
        let cache = resolveCache.get(doc);
        if (cache) {
            for (let i = 0; i < cache.elts.length; i++) {
                let elt = cache.elts[i];
                if (elt.pos == pos)
                    return elt;
            }
        }
        else {
            resolveCache.set(doc, cache = new ResolveCache);
        }
        let result = cache.elts[cache.i] = ResolvedPos.resolve(doc, pos);
        cache.i = (cache.i + 1) % resolveCacheSize;
        return result;
    }
}
class ResolveCache {
    constructor() {
        this.elts = [];
        this.i = 0;
    }
}
const resolveCacheSize = 12, resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/
class NodeRange {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */
    constructor(
    /**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */
    $from, 
    /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */
    $to, 
    /**
    The depth of the node that this range points into.
    */
    depth) {
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */
    get start() { return this.$from.before(this.depth + 1); }
    /**
    The position at the end of the range.
    */
    get end() { return this.$to.after(this.depth + 1); }
    /**
    The parent node that the range points into.
    */
    get parent() { return this.$from.node(this.depth); }
    /**
    The start index of the range in the parent node.
    */
    get startIndex() { return this.$from.index(this.depth); }
    /**
    The end index of the range in the parent node.
    */
    get endIndex() { return this.$to.indexAfter(this.depth); }
}

const emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/
class Node {
    /**
    @internal
    */
    constructor(
    /**
    The type of node that this is.
    */
    type, 
    /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */
    attrs, 
    // A fragment holding the node's children.
    content, 
    /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */
    marks = Mark.none) {
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || dist_Fragment.empty;
    }
    /**
    The array of this node's child nodes.
    */
    get children() { return this.content.content; }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */
    get nodeSize() { return this.isLeaf ? 1 : 2 + this.content.size; }
    /**
    The number of children that the node has.
    */
    get childCount() { return this.content.childCount; }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */
    child(index) { return this.content.child(index); }
    /**
    Get the child node at the given index, if it exists.
    */
    maybeChild(index) { return this.content.maybeChild(index); }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */
    forEach(f) { this.content.forEach(f); }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */
    nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */
    descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */
    get textContent() {
        return (this.isLeaf && this.type.spec.leafText)
            ? this.type.spec.leafText(this)
            : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */
    textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */
    get firstChild() { return this.content.firstChild; }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */
    get lastChild() { return this.content.lastChild; }
    /**
    Test whether two nodes represent the same piece of document.
    */
    eq(other) {
        return this == other || (this.sameMarkup(other) && this.content.eq(other.content));
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */
    sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */
    hasMarkup(type, attrs, marks) {
        return this.type == type &&
            compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
            Mark.sameSet(this.marks, marks || Mark.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */
    copy(content = null) {
        if (content == this.content)
            return this;
        return new Node(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */
    mark(marks) {
        return marks == this.marks ? this : new Node(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */
    cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size)
            return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */
    slice(from, to = this.content.size, includeParents = false) {
        if (from == to)
            return dist_Slice.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new dist_Slice(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */
    replace(from, to, slice) {
        return replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */
    nodeAt(pos) {
        for (let node = this;;) {
            let { index, offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node)
                return null;
            if (offset == pos || node.isText)
                return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */
    childAfter(pos) {
        let { index, offset } = this.content.findIndex(pos);
        return { node: this.content.maybeChild(index), index, offset };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */
    childBefore(pos) {
        if (pos == 0)
            return { node: null, index: 0, offset: 0 };
        let { index, offset } = this.content.findIndex(pos);
        if (offset < pos)
            return { node: this.content.child(index), index, offset };
        let node = this.content.child(index - 1);
        return { node, index: index - 1, offset: offset - node.nodeSize };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */
    resolve(pos) { return ResolvedPos.resolveCached(this, pos); }
    /**
    @internal
    */
    resolveNoCache(pos) { return ResolvedPos.resolve(this, pos); }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */
    rangeHasMark(from, to, type) {
        let found = false;
        if (to > from)
            this.nodesBetween(from, to, node => {
                if (type.isInSet(node.marks))
                    found = true;
                return !found;
            });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */
    get isBlock() { return this.type.isBlock; }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */
    get isTextblock() { return this.type.isTextblock; }
    /**
    True when this node allows inline content.
    */
    get inlineContent() { return this.type.inlineContent; }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */
    get isInline() { return this.type.isInline; }
    /**
    True when this is a text node.
    */
    get isText() { return this.type.isText; }
    /**
    True when this is a leaf node.
    */
    get isLeaf() { return this.type.isLeaf; }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */
    get isAtom() { return this.type.isAtom; }
    /**
    Return a string representation of this node for debugging
    purposes.
    */
    toString() {
        if (this.type.spec.toDebugString)
            return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size)
            name += "(" + this.content.toStringInner() + ")";
        return wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */
    contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match)
            throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */
    canReplace(from, to, replacement = dist_Fragment.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd)
            return false;
        for (let i = start; i < end; i++)
            if (!this.type.allowsMarks(replacement.child(i).marks))
                return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */
    canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks))
            return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */
    canAppend(other) {
        if (other.content.size)
            return this.canReplace(this.childCount, this.childCount, other.content);
        else
            return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */
    check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = Mark.none;
        for (let i = 0; i < this.marks.length; i++) {
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!Mark.sameSet(copy, this.marks))
            throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map(m => m.type.name)}`);
        this.content.forEach(node => node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */
    toJSON() {
        let obj = { type: this.type.name };
        for (let _ in this.attrs) {
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size)
            obj.content = this.content.toJSON();
        if (this.marks.length)
            obj.marks = this.marks.map(n => n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */
    static fromJSON(schema, json) {
        if (!json)
            throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks))
                throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string")
                throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = dist_Fragment.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
Node.prototype.text = undefined;
class TextNode extends Node {
    /**
    @internal
    */
    constructor(type, attrs, content, marks) {
        super(type, attrs, null, marks);
        if (!content)
            throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString)
            return this.type.spec.toDebugString(this);
        return wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() { return this.text; }
    textBetween(from, to) { return this.text.slice(from, to); }
    get nodeSize() { return this.text.length; }
    mark(marks) {
        return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text)
            return this;
        return new TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length)
            return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function wrapMarks(marks, str) {
    for (let i = marks.length - 1; i >= 0; i--)
        str = marks[i].type.name + "(" + str + ")";
    return str;
}

/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/
class ContentMatch {
    /**
    @internal
    */
    constructor(
    /**
    True when this match state represents a valid end of the node.
    */
    validEnd) {
        this.validEnd = validEnd;
        /**
        @internal
        */
        this.next = [];
        /**
        @internal
        */
        this.wrapCache = [];
    }
    /**
    @internal
    */
    static parse(string, nodeTypes) {
        let stream = new TokenStream(string, nodeTypes);
        if (stream.next == null)
            return ContentMatch.empty;
        let expr = parseExpr(stream);
        if (stream.next)
            stream.err("Unexpected trailing text");
        let match = dfa(nfa(expr));
        checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */
    matchType(type) {
        for (let i = 0; i < this.next.length; i++)
            if (this.next[i].type == type)
                return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */
    matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for (let i = start; cur && i < end; i++)
            cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */
    get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */
    get defaultType() {
        for (let i = 0; i < this.next.length; i++) {
            let { type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs()))
                return type;
        }
        return null;
    }
    /**
    @internal
    */
    compatible(other) {
        for (let i = 0; i < this.next.length; i++)
            for (let j = 0; j < other.next.length; j++)
                if (this.next[i].type == other.next[j].type)
                    return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */
    fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [this];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd))
                return dist_Fragment.from(types.map(tp => tp.createAndFill()));
            for (let i = 0; i < match.next.length; i++) {
                let { type, next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found)
                        return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */
    findWrapping(target) {
        for (let i = 0; i < this.wrapCache.length; i += 2)
            if (this.wrapCache[i] == target)
                return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */
    computeWrapping(target) {
        let seen = Object.create(null), active = [{ match: this, type: null, via: null }];
        while (active.length) {
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for (let obj = current; obj.type; obj = obj.via)
                    result.push(obj.type);
                return result.reverse();
            }
            for (let i = 0; i < match.next.length; i++) {
                let { type, next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({ match: type.contentMatch, type, via: current });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */
    get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */
    edge(n) {
        if (n >= this.next.length)
            throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */
    toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for (let i = 0; i < m.next.length; i++)
                if (seen.indexOf(m.next[i].next) == -1)
                    scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i) => {
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for (let i = 0; i < m.next.length; i++)
                out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/
ContentMatch.empty = new ContentMatch(true);
class TokenStream {
    constructor(string, nodeTypes) {
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "")
            this.tokens.pop();
        if (this.tokens[0] == "")
            this.tokens.shift();
    }
    get next() { return this.tokens[this.pos]; }
    eat(tok) { return this.next == tok && (this.pos++ || true); }
    err(str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')"); }
}
function parseExpr(stream) {
    let exprs = [];
    do {
        exprs.push(parseExprSeq(stream));
    } while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
}
function parseExprSeq(stream) {
    let exprs = [];
    do {
        exprs.push(parseExprSubscript(stream));
    } while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : { type: "seq", exprs };
}
function parseExprSubscript(stream) {
    let expr = parseExprAtom(stream);
    for (;;) {
        if (stream.eat("+"))
            expr = { type: "plus", expr };
        else if (stream.eat("*"))
            expr = { type: "star", expr };
        else if (stream.eat("?"))
            expr = { type: "opt", expr };
        else if (stream.eat("{"))
            expr = parseExprRange(stream, expr);
        else
            break;
    }
    return expr;
}
function parseNum(stream) {
    if (/\D/.test(stream.next))
        stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function parseExprRange(stream, expr) {
    let min = parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}")
            max = parseNum(stream);
        else
            max = -1;
    }
    if (!stream.eat("}"))
        stream.err("Unclosed braced range");
    return { type: "range", min, max, expr };
}
function resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type)
        return [type];
    let result = [];
    for (let typeName in types) {
        let type = types[typeName];
        if (type.isInGroup(name))
            result.push(type);
    }
    if (result.length == 0)
        stream.err("No node type or group '" + name + "' found");
    return result;
}
function parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = parseExpr(stream);
        if (!stream.eat(")"))
            stream.err("Missing closing paren");
        return expr;
    }
    else if (!/\W/.test(stream.next)) {
        let exprs = resolveName(stream, stream.next).map(type => {
            if (stream.inline == null)
                stream.inline = type.isInline;
            else if (stream.inline != type.isInline)
                stream.err("Mixing inline and block content");
            return { type: "name", value: type };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
    }
    else {
        stream.err("Unexpected token '" + stream.next + "'");
    }
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
    let nfa = [[]];
    connect(compile(expr, 0), node());
    return nfa;
    function node() { return nfa.push([]) - 1; }
    function edge(from, to, term) {
        let edge = { term, to };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach(edge => edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") {
            return expr.exprs.reduce((out, expr) => out.concat(compile(expr, from)), []);
        }
        else if (expr.type == "seq") {
            for (let i = 0;; i++) {
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1)
                    return next;
                connect(next, from = node());
            }
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [edge(loop)];
        }
        else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [edge(loop)];
        }
        else if (expr.type == "opt") {
            return [edge(from)].concat(compile(expr.expr, from));
        }
        else if (expr.type == "range") {
            let cur = from;
            for (let i = 0; i < expr.min; i++) {
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) {
                connect(compile(expr.expr, cur), cur);
            }
            else {
                for (let i = expr.min; i < expr.max; i++) {
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
            }
            return [edge(cur)];
        }
        else if (expr.type == "name") {
            return [edge(from, undefined, expr.value)];
        }
        else {
            throw new Error("Unknown expr type");
        }
    }
}
function cmp(a, b) { return b - a; }
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort(cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term)
            return scan(edges[0].to);
        result.push(node);
        for (let i = 0; i < edges.length; i++) {
            let { term, to } = edges[i];
            if (!term && result.indexOf(to) == -1)
                scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
    let labeled = Object.create(null);
    return explore(nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach(node => {
            nfa[node].forEach(({ term, to }) => {
                if (!term)
                    return;
                let set;
                for (let i = 0; i < out.length; i++)
                    if (out[i][0] == term)
                        set = out[i][1];
                nullFrom(nfa, to).forEach(node => {
                    if (!set)
                        out.push([term, set = []]);
                    if (set.indexOf(node) == -1)
                        set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
        for (let i = 0; i < out.length; i++) {
            let states = out[i][1].sort(cmp);
            state.next.push({ type: out[i][0], next: labeled[states.join(",")] || explore(states) });
        }
        return state;
    }
}
function checkForDeadEnds(match, stream) {
    for (let i = 0, work = [match]; i < work.length; i++) {
        let state = work[i], dead = !state.validEnd, nodes = [];
        for (let j = 0; j < state.next.length; j++) {
            let { type, next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs()))
                dead = false;
            if (work.indexOf(next) == -1)
                work.push(next);
        }
        if (dead)
            stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for (let attrName in attrs) {
        let attr = attrs[attrName];
        if (!attr.hasDefault)
            return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function computeAttrs(attrs, value) {
    let built = Object.create(null);
    for (let name in attrs) {
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault)
                given = attr.default;
            else
                throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function checkAttrs(attrs, values, type, name) {
    for (let name in values)
        if (!(name in attrs))
            throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for (let name in attrs) {
        let attr = attrs[name];
        if (attr.validate)
            attr.validate(values[name]);
    }
}
function initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs)
        for (let name in attrs)
            result[name] = new Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/
class NodeType {
    /**
    @internal
    */
    constructor(
    /**
    The name the node type has in this schema.
    */
    name, 
    /**
    A link back to the `Schema` the node type belongs to.
    */
    schema, 
    /**
    The spec that this type is based on
    */
    spec) {
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */
        this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = initAttrs(name, spec.attrs);
        this.defaultAttrs = defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */
    get isInline() { return !this.isBlock; }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */
    get isTextblock() { return this.isBlock && this.inlineContent; }
    /**
    True for node types that allow no content.
    */
    get isLeaf() { return this.contentMatch == ContentMatch.empty; }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */
    get isAtom() { return this.isLeaf || !!this.spec.atom; }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */
    isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */
    get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */
    hasRequiredAttrs() {
        for (let n in this.attrs)
            if (this.attrs[n].isRequired)
                return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */
    compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */
    computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs)
            return this.defaultAttrs;
        else
            return computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */
    create(attrs = null, content, marks) {
        if (this.isText)
            throw new Error("NodeType.create can't construct text nodes");
        return new Node(this, this.computeAttrs(attrs), dist_Fragment.from(content), Mark.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */
    createChecked(attrs = null, content, marks) {
        content = dist_Fragment.from(content);
        this.checkContent(content);
        return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */
    createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = dist_Fragment.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before)
                return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore(dist_Fragment.empty, true);
        if (!after)
            return null;
        return new Node(this, attrs, content.append(after), Mark.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */
    validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd)
            return false;
        for (let i = 0; i < content.childCount; i++)
            if (!this.allowsMarks(content.child(i).marks))
                return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */
    checkContent(content) {
        if (!this.validContent(content))
            throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */
    checkAttrs(attrs) {
        checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */
    allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */
    allowsMarks(marks) {
        if (this.markSet == null)
            return true;
        for (let i = 0; i < marks.length; i++)
            if (!this.allowsMarkType(marks[i].type))
                return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */
    allowedMarks(marks) {
        if (this.markSet == null)
            return marks;
        let copy;
        for (let i = 0; i < marks.length; i++) {
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy)
                    copy = marks.slice(0, i);
            }
            else if (copy) {
                copy.push(marks[i]);
            }
        }
        return !copy ? marks : copy.length ? copy : Mark.none;
    }
    /**
    @internal
    */
    static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec) => result[name] = new NodeType(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType])
            throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text)
            throw new RangeError("Every schema needs a 'text' type");
        for (let _ in result.text.attrs)
            throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value) => {
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0)
            throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class Attribute {
    constructor(typeName, attrName, options) {
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/
class MarkType {
    /**
    @internal
    */
    constructor(
    /**
    The name of the mark type.
    */
    name, 
    /**
    @internal
    */
    rank, 
    /**
    The schema that this mark type instance is part of.
    */
    schema, 
    /**
    The spec on which the type is based.
    */
    spec) {
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = defaultAttrs(this.attrs);
        this.instance = defaults ? new Mark(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */
    create(attrs = null) {
        if (!attrs && this.instance)
            return this.instance;
        return new Mark(this, computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */
    static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec) => result[name] = new MarkType(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */
    removeFromSet(set) {
        for (var i = 0; i < set.length; i++)
            if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */
    isInSet(set) {
        for (let i = 0; i < set.length; i++)
            if (set[i].type == this)
                return set[i];
    }
    /**
    @internal
    */
    checkAttrs(attrs) {
        checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */
    excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/
class Schema {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */
    constructor(spec) {
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */
        this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */
        this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for (let prop in spec)
            instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = dist.from(spec.nodes),
            instanceSpec.marks = dist.from(spec.marks || {}),
            this.nodes = NodeType.compile(this.spec.nodes, this);
        this.marks = MarkType.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for (let prop in this.nodes) {
            if (prop in this.marks)
                throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] ||
                (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement)
                    throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf)
                    throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null :
                markExpr ? gatherMarks(this, markExpr.split(" ")) :
                    markExpr == "" || !type.inlineContent ? [] : null;
        }
        for (let prop in this.marks) {
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [type] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */
    node(type, attrs = null, content, marks) {
        if (typeof type == "string")
            type = this.nodeType(type);
        else if (!(type instanceof NodeType))
            throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this)
            throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */
    text(text, marks) {
        let type = this.nodes.text;
        return new TextNode(type, type.defaultAttrs, text, Mark.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */
    mark(type, attrs) {
        if (typeof type == "string")
            type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */
    nodeFromJSON(json) {
        return Node.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */
    markFromJSON(json) {
        return Mark.fromJSON(this, json);
    }
    /**
    @internal
    */
    nodeType(name) {
        let found = this.nodes[name];
        if (!found)
            throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function gatherMarks(schema, marks) {
    let found = [];
    for (let i = 0; i < marks.length; i++) {
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) {
            found.push(mark);
        }
        else {
            for (let prop in schema.marks) {
                let mark = schema.marks[prop];
                if (name == "_" || (mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1))
                    found.push(ok = mark);
            }
        }
        if (!ok)
            throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}

function isTagRule(rule) { return rule.tag != null; }
function isStyleRule(rule) { return rule.style != null; }
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/
class dist_DOMParser {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */
    constructor(
    /**
    The schema into which the parser parses.
    */
    schema, 
    /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */
    rules) {
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */
        this.tags = [];
        /**
        @internal
        */
        this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach(rule => {
            if (isTagRule(rule)) {
                this.tags.push(rule);
            }
            else if (isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0)
                    matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some(r => {
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
                return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */
    parse(dom, options = {}) {
        let context = new ParseContext(this, options, false);
        context.addAll(dom, Mark.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */
    parseSlice(dom, options = {}) {
        let context = new ParseContext(this, options, true);
        context.addAll(dom, Mark.none, options.from, options.to);
        return dist_Slice.maxOpen(context.finish());
    }
    /**
    @internal
    */
    matchTag(dom, context, after) {
        for (let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
            let rule = this.tags[i];
            if (matches(dom, rule.tag) &&
                (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
                (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false)
                        continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */
    matchStyle(prop, value, context, after) {
        for (let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 ||
                rule.context && !context.matchesContext(rule.context) ||
                // Test that the style string either precisely matches the prop,
                // or has an '=' sign after the prop, followed by the given
                // value.
                style.length > prop.length &&
                    (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value))
                continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false)
                    continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */
    static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for (; i < result.length; i++) {
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority)
                    break;
            }
            result.splice(i, 0, rule);
        }
        for (let name in schema.marks) {
            let rules = schema.marks[name].spec.parseDOM;
            if (rules)
                rules.forEach(rule => {
                    insert(rule = copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark))
                        rule.mark = name;
                });
        }
        for (let name in schema.nodes) {
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules)
                rules.forEach(rule => {
                    insert(rule = copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark))
                        rule.node = name;
                });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */
    static fromSchema(schema) {
        return schema.cached.domParser ||
            (schema.cached.domParser = new dist_DOMParser(schema, dist_DOMParser.schemaRules(schema)));
    }
}
const blockTags = {
    address: true, article: true, aside: true, blockquote: true, canvas: true,
    dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
    footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
    h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
    output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};
const ignoreTags = {
    head: true, noscript: true, object: true, script: true, style: true, title: true
};
const listTags = { ol: true, ul: true };
// Using a bitfield for node context options
const OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null)
        return (preserveWhitespace ? OPT_PRESERVE_WS : 0) |
            (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base & ~OPT_OPEN_LEFT;
}
class NodeContext {
    constructor(type, attrs, marks, solid, match, options) {
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = Mark.none;
        this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type)
                return [];
            let fill = this.type.contentMatch.fillBefore(dist_Fragment.from(node));
            if (fill) {
                this.match = this.type.contentMatch.matchFragment(fill);
            }
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                }
                else {
                    return null;
                }
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length)
                    this.content.pop();
                else
                    this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = dist_Fragment.from(this.content);
        if (!openEnd && this.match)
            content = content.append(this.match.fillBefore(dist_Fragment.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type)
            return this.type.inlineContent;
        if (this.content.length)
            return this.content[0].isInline;
        return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class ParseContext {
    constructor(
    // The parser we are using.
    parser, 
    // The options passed to this parse.
    options, isOpen) {
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
        if (topNode)
            topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen)
            topContext = new NodeContext(null, null, Mark.none, true, null, topOptions);
        else
            topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions);
        this.nodes = [topContext];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3)
            this.addTextNode(dom, marks);
        else if (dom.nodeType == 1)
            this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = (top.options & OPT_PRESERVE_WS_FULL) ? "full"
            : this.localPreserveWS || (top.options & OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" ||
            top.inlineContext(dom) ||
            /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore ||
                        (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
                        (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
                        value = value.slice(1);
                }
            }
            else if (preserveWS !== "full") {
                value = value.replace(/\r?\n|\r/g, " ");
            }
            else {
                value = value.replace(/\r\n?/g, "\n");
            }
            if (value)
                this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        }
        else {
            this.findInside(dom);
        }
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace))
            this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if (listTags.hasOwnProperty(name) && this.parser.normalizeLists)
            normalizeList(dom);
        let rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) ||
            (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        }
        else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent)
                this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType)
                dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if (blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type)
                    this.needsBlock = true;
            }
            else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks)
                this.addAll(dom, innerMarks);
            if (sync)
                this.sync(top);
            this.needsBlock = oldNeedsBlock;
        }
        else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks)
                this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
            this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
            this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length)
            for (let i = 0; i < this.parser.matchedStyles.length; i++) {
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value)
                    for (let after = undefined;;) {
                        let rule = this.parser.matchStyle(name, value, this, after);
                        if (!rule)
                            break;
                        if (rule.ignore)
                            return null;
                        if (rule.clearMark)
                            marks = marks.filter(m => !rule.clearMark(m));
                        else
                            marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                        if (rule.consuming === false)
                            after = rule;
                        else
                            break;
                    }
            }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            }
            else if (!this.insertNode(nodeType.create(rule.attrs), marks)) {
                this.leafFallback(dom, marks);
            }
        }
        else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) {
            this.findInside(dom);
        }
        else if (continueAfter) {
            this.addElement(dom, marks, continueAfter);
        }
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach(node => this.insertNode(node, marks));
        }
        else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string")
                contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function")
                contentDOM = rule.contentElement(dom);
            else if (rule.contentElement)
                contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn))
            this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for (let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index) {
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for (let depth = this.open; depth >= 0; depth--) {
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length)
                    break;
            }
            if (cx.solid)
                break;
        }
        if (!route)
            return null;
        this.sync(sync);
        for (let i = 0; i < route.length; i++)
            marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block)
                marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match)
                top.match = top.match.matchType(node.type);
            let nodeMarks = Mark.none;
            for (let m of innerMarks.concat(node.marks))
                if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, node.type))
                    nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks)
            innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = wsOptionsFor(type, preserveWS, top.options);
        if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0)
            options |= OPT_OPEN_LEFT;
        let applyMarks = Mark.none;
        marks = marks.filter(m => {
            if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for (; i > this.open; i--)
                this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for (let i = this.open; i >= 0; i--) {
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            else if (this.localPreserveWS) {
                this.nodes[i].options |= OPT_PRESERVE_WS;
            }
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for (let i = this.open; i >= 0; i--) {
            let content = this.nodes[i].content;
            for (let j = content.length - 1; j >= 0; j--)
                pos += content[j].nodeSize;
            if (i)
                pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].node == parent && this.find[i].offset == offset)
                    this.find[i].pos = this.currentPos;
            }
    }
    findInside(parent) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
                    this.find[i].pos = this.currentPos;
            }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4))
                        this.find[i].pos = this.currentPos;
                }
            }
    }
    findInText(textNode) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].node == textNode)
                    this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1)
            return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth) => {
            for (; i >= 0; i--) {
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0)
                        continue;
                    for (; depth >= minDepth; depth--)
                        if (match(i - 1, depth))
                            return true;
                    return false;
                }
                else {
                    let next = depth > 0 || (depth == 0 && useRoot) ? this.nodes[depth].type
                        : option && depth >= minDepth ? option.node(depth - minDepth).type
                            : null;
                    if (!next || (next.name != part && !next.isInGroup(part)))
                        return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context)
            for (let d = $context.depth; d >= 0; d--) {
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs)
                    return deflt;
            }
        for (let name in this.parser.schema.nodes) {
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs)
                return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
    for (let child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        }
        else if (name == "li") {
            prevItem = child;
        }
        else if (name) {
            prevItem = null;
        }
    }
}
// Apply a CSS selector.
function matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function copy(obj) {
    let copy = {};
    for (let prop in obj)
        copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for (let name in nodes) {
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType))
            continue;
        let seen = [], scan = (match) => {
            seen.push(match);
            for (let i = 0; i < match.edgeCount; i++) {
                let { type, next } = match.edge(i);
                if (type == nodeType)
                    return true;
                if (seen.indexOf(next) < 0 && scan(next))
                    return true;
            }
        };
        if (scan(parent.contentMatch))
            return true;
    }
}

/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/
class DOMSerializer {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */
    constructor(
    /**
    The node serialization functions.
    */
    nodes, 
    /**
    The mark serialization functions.
    */
    marks) {
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */
    serializeFragment(fragment, options = {}, target) {
        if (!target)
            target = doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach(node => {
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while (keep < active.length && rendered < node.marks.length) {
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false)
                        break;
                    keep++;
                    rendered++;
                }
                while (keep < active.length)
                    top = active.pop()[1];
                while (rendered < node.marks.length) {
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([add, top]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */
    serializeNodeInner(node, options) {
        let { dom, contentDOM } = renderSpec(doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf)
                throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */
    serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for (let i = node.marks.length - 1; i >= 0; i--) {
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */
    serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && renderSpec(doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */
    static fromSchema(schema) {
        return schema.cached.domSerializer ||
            (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */
    static nodesFromSchema(schema) {
        let result = gatherToDOM(schema.nodes);
        if (!result.text)
            result.text = node => node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */
    static marksFromSchema(schema) {
        return gatherToDOM(schema.marks);
    }
}
function gatherToDOM(obj) {
    let result = {};
    for (let name in obj) {
        let toDOM = obj[name].spec.toDOM;
        if (toDOM)
            result[name] = toDOM;
    }
    return result;
}
function doc(options) {
    return options.document || window.document;
}
const suspiciousAttributeCache = new WeakMap();
function suspiciousAttributes(attrs) {
    let value = suspiciousAttributeCache.get(attrs);
    if (value === undefined)
        suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
    return value;
}
function suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result)
                        result = [];
                    result.push(value);
                }
                else {
                    for (let i = 0; i < value.length; i++)
                        scan(value[i]);
                }
            }
            else {
                for (let prop in value)
                    scan(value[prop]);
            }
        }
    }
    scan(attrs);
    return result;
}
function renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string")
        return { dom: doc.createTextNode(structure) };
    if (structure.nodeType != null)
        return { dom: structure };
    if (structure.dom && structure.dom.nodeType != null)
        return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string")
        throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) &&
        suspicious.indexOf(structure) > -1)
        throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = (xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName));
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for (let name in attrs)
            if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0)
                    dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else
                    dom.setAttribute(name, attrs[name]);
            }
    }
    for (let i = start; i < structure.length; i++) {
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start)
                throw new RangeError("Content hole must be the only child of its parent node");
            return { dom, contentDOM: dom };
        }
        else {
            let { dom: inner, contentDOM: innerContent } = renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM)
                    throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return { dom, contentDOM };
}



;// CONCATENATED MODULE: ./node_modules/prosemirror-transform/dist/index.js


// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const lower16 = 0xffff;
const factor16 = Math.pow(2, 16);
function makeRecover(index, offset) { return index + offset * factor16; }
function recoverIndex(value) { return value & lower16; }
function recoverOffset(value) { return (value - (value & lower16)) / factor16; }
const DEL_BEFORE = 1, DEL_AFTER = 2, DEL_ACROSS = 4, DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/
class MapResult {
    /**
    @internal
    */
    constructor(
    /**
    The mapped version of the position.
    */
    pos, 
    /**
    @internal
    */
    delInfo, 
    /**
    @internal
    */
    recover) {
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */
    get deleted() { return (this.delInfo & DEL_SIDE) > 0; }
    /**
    Tells you whether the token before the mapped position was deleted.
    */
    get deletedBefore() { return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0; }
    /**
    True when the token after the mapped position was deleted.
    */
    get deletedAfter() { return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0; }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */
    get deletedAcross() { return (this.delInfo & DEL_ACROSS) > 0; }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/
class StepMap {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */
    constructor(
    /**
    @internal
    */
    ranges, 
    /**
    @internal
    */
    inverted = false) {
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && StepMap.empty)
            return StepMap.empty;
    }
    /**
    @internal
    */
    recover(value) {
        let diff = 0, index = recoverIndex(value);
        if (!this.inverted)
            for (let i = 0; i < index; i++)
                diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + recoverOffset(value);
    }
    mapResult(pos, assoc = 1) { return this._map(pos, assoc, false); }
    map(pos, assoc = 1) { return this._map(pos, assoc, true); }
    /**
    @internal
    */
    _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos)
                break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple)
                    return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : makeRecover(i / 3, pos - start);
                let del = pos == start ? DEL_AFTER : pos == end ? DEL_BEFORE : DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end)
                    del |= DEL_SIDE;
                return new MapResult(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new MapResult(pos + diff, 0, null);
    }
    /**
    @internal
    */
    touches(pos, recover) {
        let diff = 0, index = recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos)
                break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3)
                return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */
    forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0, diff = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */
    invert() {
        return new StepMap(this.ranges, !this.inverted);
    }
    /**
    @internal
    */
    toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */
    static offset(n) {
        return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
    }
}
/**
A StepMap that contains no changed ranges.
*/
StepMap.empty = new StepMap([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/
class Mapping {
    /**
    Create a new mapping with the given position maps.
    */
    constructor(
    /**
    The step maps in this mapping.
    */
    maps = [], 
    /**
    @internal
    */
    mirror, 
    /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */
    from = 0, 
    /**
    The end position in the `maps` array.
    */
    to = maps.length) {
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */
    slice(from = 0, to = this.maps.length) {
        return new Mapping(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */
    copy() {
        return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */
    appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null)
            this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */
    appendMapping(mapping) {
        for (let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */
    getMirror(n) {
        if (this.mirror)
            for (let i = 0; i < this.mirror.length; i++)
                if (this.mirror[i] == n)
                    return this.mirror[i + (i % 2 ? -1 : 1)];
    }
    /**
    @internal
    */
    setMirror(n, m) {
        if (!this.mirror)
            this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */
    appendMappingInverted(mapping) {
        for (let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */
    invert() {
        let inverse = new Mapping;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */
    map(pos, assoc = 1) {
        if (this.mirror)
            return this._map(pos, assoc, true);
        for (let i = this.from; i < this.to; i++)
            pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */
    mapResult(pos, assoc = 1) { return this._map(pos, assoc, false); }
    /**
    @internal
    */
    _map(pos, assoc, simple) {
        let delInfo = 0;
        for (let i = this.from; i < this.to; i++) {
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new MapResult(pos, delInfo, null);
    }
}

const stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/
class Step {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */
    getMap() { return StepMap.empty; }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */
    merge(other) { return null; }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */
    static fromJSON(schema, json) {
        if (!json || !json.stepType)
            throw new RangeError("Invalid input for Step.fromJSON");
        let type = stepsByID[json.stepType];
        if (!type)
            throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */
    static jsonID(id, stepClass) {
        if (id in stepsByID)
            throw new RangeError("Duplicate use of step JSON ID " + id);
        stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/
class StepResult {
    /**
    @internal
    */
    constructor(
    /**
    The transformed document, if successful.
    */
    doc, 
    /**
    The failure message, if unsuccessful.
    */
    failed) {
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */
    static ok(doc) { return new StepResult(doc, null); }
    /**
    Create a failed step result.
    */
    static fail(message) { return new StepResult(null, message); }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */
    static fromReplace(doc, from, to, slice) {
        try {
            return StepResult.ok(doc.replace(from, to, slice));
        }
        catch (e) {
            if (e instanceof ReplaceError)
                return StepResult.fail(e.message);
            throw e;
        }
    }
}

function mapFragment(fragment, f, parent) {
    let mapped = [];
    for (let i = 0; i < fragment.childCount; i++) {
        let child = fragment.child(i);
        if (child.content.size)
            child = child.copy(mapFragment(child.content, f, child));
        if (child.isInline)
            child = f(child, parent, i);
        mapped.push(child);
    }
    return dist_Fragment.fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/
class AddMarkStep extends Step {
    /**
    Create a mark step.
    */
    constructor(
    /**
    The start of the marked range.
    */
    from, 
    /**
    The end of the marked range.
    */
    to, 
    /**
    The mark to add.
    */
    mark) {
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new dist_Slice(mapFragment(oldSlice.content, (node, parent) => {
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type))
                return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new RemoveMarkStep(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos)
            return null;
        return new AddMarkStep(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof AddMarkStep &&
            other.mark.eq(this.mark) &&
            this.from <= other.to && this.to >= other.from)
            return new AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return { stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("addMark", AddMarkStep);
/**
Remove a mark from all inline content between two positions.
*/
class RemoveMarkStep extends Step {
    /**
    Create a mark-removing step.
    */
    constructor(
    /**
    The start of the unmarked range.
    */
    from, 
    /**
    The end of the unmarked range.
    */
    to, 
    /**
    The mark to remove.
    */
    mark) {
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new dist_Slice(mapFragment(oldSlice.content, node => {
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new AddMarkStep(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos)
            return null;
        return new RemoveMarkStep(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof RemoveMarkStep &&
            other.mark.eq(this.mark) &&
            this.from <= other.to && this.to >= other.from)
            return new RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return { stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("removeMark", RemoveMarkStep);
/**
Add a mark to a specific node.
*/
class AddNodeMarkStep extends Step {
    /**
    Create a node mark step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The mark to add.
    */
    mark) {
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new dist_Slice(dist_Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for (let i = 0; i < node.marks.length; i++)
                    if (!node.marks[i].isInSet(newSet))
                        return new AddNodeMarkStep(this.pos, node.marks[i]);
                return new AddNodeMarkStep(this.pos, this.mark);
            }
        }
        return new RemoveNodeMarkStep(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new AddNodeMarkStep(pos.pos, this.mark);
    }
    toJSON() {
        return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.pos != "number")
            throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("addNodeMark", AddNodeMarkStep);
/**
Remove a mark from a specific node.
*/
class RemoveNodeMarkStep extends Step {
    /**
    Create a mark-removing step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The mark to remove.
    */
    mark) {
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new dist_Slice(dist_Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks))
            return this;
        return new AddNodeMarkStep(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new RemoveNodeMarkStep(pos.pos, this.mark);
    }
    toJSON() {
        return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.pos != "number")
            throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);

/**
Replace a part of the document with a slice of new content.
*/
class ReplaceStep extends Step {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */
    constructor(
    /**
    The start position of the replaced range.
    */
    from, 
    /**
    The end position of the replaced range.
    */
    to, 
    /**
    The slice to insert.
    */
    slice, 
    /**
    @internal
    */
    structure = false) {
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && contentBetween(doc, this.from, this.to))
            return StepResult.fail("Structure replace would overwrite content");
        return StepResult.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new StepMap([this.from, this.to - this.from, this.slice.size]);
    }
    invert(doc) {
        return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross)
            return null;
        return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof ReplaceStep) || other.structure || this.structure)
            return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? dist_Slice.empty
                : new dist_Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure);
        }
        else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? dist_Slice.empty
                : new dist_Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new ReplaceStep(other.from, this.to, slice, this.structure);
        }
        else {
            return null;
        }
    }
    toJSON() {
        let json = { stepType: "replace", from: this.from, to: this.to };
        if (this.slice.size)
            json.slice = this.slice.toJSON();
        if (this.structure)
            json.structure = true;
        return json;
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new ReplaceStep(json.from, json.to, dist_Slice.fromJSON(schema, json.slice), !!json.structure);
    }
}
Step.jsonID("replace", ReplaceStep);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/
class ReplaceAroundStep extends Step {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */
    constructor(
    /**
    The start position of the replaced range.
    */
    from, 
    /**
    The end position of the replaced range.
    */
    to, 
    /**
    The start of preserved range.
    */
    gapFrom, 
    /**
    The end of preserved range.
    */
    gapTo, 
    /**
    The slice to insert.
    */
    slice, 
    /**
    The position in the slice where the preserved range should be
    inserted.
    */
    insert, 
    /**
    @internal
    */
    structure = false) {
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
            contentBetween(doc, this.gapTo, this.to)))
            return StepResult.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd)
            return StepResult.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted)
            return StepResult.fail("Content does not fit in gap");
        return StepResult.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new StepMap([this.from, this.gapFrom - this.from, this.insert,
            this.gapTo, this.to - this.gapTo, this.slice.size - this.insert]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if ((from.deletedAcross && to.deletedAcross) || gapFrom < from.pos || gapTo > to.pos)
            return null;
        return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = { stepType: "replaceAround", from: this.from, to: this.to,
            gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert };
        if (this.slice.size)
            json.slice = this.slice.toJSON();
        if (this.structure)
            json.structure = true;
        return json;
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" ||
            typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
            throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, dist_Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while (dist > 0) {
            if (!next || next.isLeaf)
                return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}

function addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent) => {
        if (!node.isInline)
            return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for (let i = 0; i < marks.length; i++) {
                if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i]))
                        removing.to = end;
                    else
                        removed.push(removing = new RemoveMarkStep(start, end, marks[i]));
                }
            }
            if (adding && adding.to == start)
                adding.to = end;
            else
                added.push(adding = new AddMarkStep(start, end, mark));
        }
    });
    removed.forEach(s => tr.step(s));
    added.forEach(s => tr.step(s));
}
function removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isInline)
            return;
        step++;
        let toRemove = null;
        if (mark instanceof MarkType) {
            let set = node.marks, found;
            while (found = mark.isInSet(set)) {
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        }
        else if (mark) {
            if (mark.isInSet(node.marks))
                toRemove = [mark];
        }
        else {
            toRemove = node.marks;
        }
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for (let i = 0; i < toRemove.length; i++) {
                let style = toRemove[i], found;
                for (let j = 0; j < matched.length; j++) {
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style))
                        found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                }
                else {
                    matched.push({ style, from: Math.max(pos, from), to: end, step });
                }
            }
        }
    });
    matched.forEach(m => tr.step(new RemoveMarkStep(m.from, m.to, m.style)));
}
function clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for (let i = 0; i < node.childCount; i++) {
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) {
            replSteps.push(new ReplaceStep(cur, end, dist_Slice.empty));
        }
        else {
            match = allowed;
            for (let j = 0; j < child.marks.length; j++)
                if (!parentType.allowsMarkType(child.marks[j].type))
                    tr.step(new RemoveMarkStep(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while (m = newline.exec(child.text)) {
                    if (!slice)
                        slice = new dist_Slice(dist_Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore(dist_Fragment.empty, true);
        tr.replace(cur, cur, new dist_Slice(fill, 0, 0));
    }
    for (let i = replSteps.length - 1; i >= 0; i--)
        tr.step(replSteps[i]);
}

function canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) &&
        (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/
function liftTarget(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for (let depth = range.depth;; --depth) {
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content))
            return depth;
        if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex))
            break;
    }
    return null;
}
function lift(tr, range, target) {
    let { $from, $to, depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = dist_Fragment.empty, openStart = 0;
    for (let d = depth, splitting = false; d > target; d--)
        if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = dist_Fragment.from($from.node(d).copy(before));
            openStart++;
        }
        else {
            start--;
        }
    let after = dist_Fragment.empty, openEnd = 0;
    for (let d = depth, splitting = false; d > target; d--)
        if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = dist_Fragment.from($to.node(d).copy(after));
            openEnd++;
        }
        else {
            end++;
        }
    tr.step(new ReplaceAroundStep(start, end, gapStart, gapEnd, new dist_Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/
function findWrapping(range, nodeType, attrs = null, innerRange = range) {
    let around = findWrappingOutside(range, nodeType);
    let inner = around && findWrappingInside(innerRange, nodeType);
    if (!inner)
        return null;
    return around.map(withAttrs)
        .concat({ type: nodeType, attrs }).concat(inner.map(withAttrs));
}
function withAttrs(type) { return { type, attrs: null }; }
function findWrappingOutside(range, type) {
    let { parent, startIndex, endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around)
        return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range, type) {
    let { parent, startIndex, endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside)
        return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for (let i = startIndex; innerMatch && i < endIndex; i++)
        innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd)
        return null;
    return inside;
}
function wrap(tr, range, wrappers) {
    let content = dist_Fragment.empty;
    for (let i = wrappers.length - 1; i >= 0; i--) {
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd)
                throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = dist_Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new ReplaceAroundStep(start, end, start, end, new dist_Slice(content, 0, 0), wrappers.length, true));
}
function setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock)
        throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos) => {
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) &&
            canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak)
                    convertNewlines = false;
                else if (!pre && supportLinebreak)
                    convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false)
                replaceLinebreaks(tr, node, pos, mapFrom);
            clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new dist_Slice(dist_Fragment.from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true)
                replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset) => {
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while (m = newline.exec(child.text)) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset) => {
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/
function setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node)
        throw new RangeError("No node at given position");
    if (!type)
        type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf)
        return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content))
        throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new dist_Slice(dist_Fragment.from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/
function dist_canSplit(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating ||
        !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
        !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
        return false;
    for (let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating)
            return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild)
            rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = (typesAfter && typesAfter[i]) || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest))
            return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = dist_Fragment.empty, after = dist_Fragment.empty;
    for (let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
        before = dist_Fragment.from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = dist_Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new ReplaceStep(pos, pos, new dist_Slice(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/
function dist_canJoin(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return dist_joinable($pos.nodeBefore, $pos.nodeAfter) &&
        $pos.parent.canReplace(index, index + 1);
}
function canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size)
        a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement } = a.type.schema;
    for (let i = 0; i < b.childCount; i++) {
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match)
            return false;
        if (!a.type.allowsMarks(child.marks))
            return false;
    }
    return match.validEnd;
}
function dist_joinable(a, b) {
    return !!(a && b && !a.isLeaf && canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/
function joinPoint(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for (let d = $pos.depth;; d--) {
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        }
        else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        }
        else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && dist_joinable(before, after) &&
            $pos.node(d).canReplace(index, index + 1))
            return pos;
        if (d == 0)
            break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak)
            convertNewlines = false;
        else if (!pre && supportLinebreak)
            convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent)
        clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new ReplaceStep(start, mapping.map(pos + depth, -1), dist_Slice.empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/
function insertPoint(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType))
        return pos;
    if ($pos.parentOffset == 0)
        for (let d = $pos.depth - 1; d >= 0; d--) {
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType))
                return $pos.before(d + 1);
            if (index > 0)
                return null;
        }
    if ($pos.parentOffset == $pos.parent.content.size)
        for (let d = $pos.depth - 1; d >= 0; d--) {
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType))
                return $pos.after(d + 1);
            if (index < $pos.node(d).childCount)
                return null;
        }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/
function dropPoint(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size)
        return pos;
    let content = slice.content;
    for (let i = 0; i < slice.openStart; i++)
        content = content.firstChild.content;
    for (let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
        for (let d = $pos.depth; d >= 0; d--) {
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) {
                fits = parent.canReplace(insertPos, insertPos, content);
            }
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits)
                return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
    }
    return null;
}

/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/
function replaceStep(doc, from, to = from, slice = dist_Slice.empty) {
    if (from == to && !slice.size)
        return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if (fitsTrivially($from, $to, slice))
        return new ReplaceStep(from, to, slice);
    return new Fitter($from, $to, slice).fit();
}
function fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
        $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class Fitter {
    constructor($from, $to, unplaced) {
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = dist_Fragment.empty;
        for (let i = 0; i <= $from.depth; i++) {
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for (let i = $from.depth; i > 0; i--)
            this.placed = dist_Fragment.from($from.node(i).copy(this.placed));
    }
    get depth() { return this.frontier.length - 1; }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while (this.unplaced.size) {
            let fit = this.findFittable();
            if (fit)
                this.placeNodes(fit);
            else
                this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to)
            return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while (openStart && openEnd && content.childCount == 1) { // Normalize by dropping open parent nodes
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new dist_Slice(content, openStart, openEnd);
        if (moveInline > -1)
            return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) // Don't generate no-op steps
            return new ReplaceStep($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for (let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++) {
            let node = cur.firstChild;
            if (cur.childCount > 1)
                openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for (let pass = 1; pass <= 2; pass++) {
            for (let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                }
                else {
                    fragment = this.unplaced.content;
                }
                let first = fragment.firstChild;
                for (let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
                    let { type, match } = this.frontier[frontierDepth], wrap, inject = null;
                    // In pass 1, if the next node matches, or there is no next
                    // node but the parents look compatible, we've found a
                    // place.
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(dist_Fragment.from(first), false))
                        : parent && type.compatibleContent(parent.type)))
                        return { sliceDepth, frontierDepth, parent, inject };
                    // In pass 2, look for a set of wrapping nodes that make
                    // `first` fit here.
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type)))
                        return { sliceDepth, frontierDepth, parent, wrap };
                    // Don't continue looking further up if the parent node
                    // would fit here.
                    if (parent && match.matchType(parent.type))
                        break;
                }
            }
        }
    }
    openMore() {
        let { content, openStart, openEnd } = this.unplaced;
        let inner = contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf)
            return false;
        this.unplaced = new dist_Slice(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content, openStart, openEnd } = this.unplaced;
        let inner = contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new dist_Slice(dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        }
        else {
            this.unplaced = new dist_Slice(dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth, frontierDepth, parent, inject, wrap }) {
        while (this.depth > frontierDepth)
            this.closeFrontierNode();
        if (wrap)
            for (let i = 0; i < wrap.length; i++)
                this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match, type } = this.frontier[frontierDepth];
        if (inject) {
            for (let i = 0; i < inject.childCount; i++)
                add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = (fragment.size + sliceDepth) - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while (taken < fragment.childCount) {
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches)
                break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) { // Drop empty open nodes
                match = matches;
                add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd)
            openEndCount = -1;
        this.placed = addToFragment(this.placed, frontierDepth, dist_Fragment.from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1)
            this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for (let i = 0, cur = fragment; i < openEndCount; i++) {
            let node = cur.lastChild;
            this.frontier.push({ type: node.type, match: node.contentMatchAt(node.childCount) });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new dist_Slice(dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd)
            : sliceDepth == 0 ? dist_Slice.empty
                : new dist_Slice(dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock)
            return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) ||
            (this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth))
            return -1;
        let { depth } = this.$to, after = this.$to.after(depth);
        while (depth > 1 && after == this.$to.end(--depth))
            ++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for (let i = Math.min(this.depth, $to.depth); i >= 0; i--) {
            let { match, type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = contentAfterFits($to, i, type, match, dropInner);
            if (!fit)
                continue;
            for (let d = i - 1; d >= 0; d--) {
                let { match, type } = this.frontier[d];
                let matches = contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount)
                    continue scan;
            }
            return { depth: i, fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close)
            return null;
        while (this.depth > close.depth)
            this.closeFrontierNode();
        if (close.fit.childCount)
            this.placed = addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for (let d = close.depth + 1; d <= $to.depth; d++) {
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = addToFragment(this.placed, this.depth, dist_Fragment.from(type.create(attrs, content)));
        this.frontier.push({ type, match: type.contentMatch });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore(dist_Fragment.empty, true);
        if (add.childCount)
            this.placed = addToFragment(this.placed, this.frontier.length, add);
    }
}
function dropFromFragment(fragment, depth, count) {
    if (depth == 0)
        return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function addToFragment(fragment, depth, content) {
    if (depth == 0)
        return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function contentAt(fragment, depth) {
    for (let i = 0; i < depth; i++)
        fragment = fragment.firstChild.content;
    return fragment;
}
function closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0)
        return node;
    let frag = node.content;
    if (openStart > 1)
        frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0)
            frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(dist_Fragment.empty, true));
    }
    return node.copy(frag);
}
function contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type))
        return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !invalidMarks(type, node.content, index) ? fit : null;
}
function invalidMarks(type, fragment, start) {
    for (let i = start; i < fragment.childCount; i++)
        if (!type.allowsMarks(fragment.child(i).marks))
            return true;
    return false;
}
function definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function replaceRange(tr, from, to, slice) {
    if (!slice.size)
        return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if (fitsTrivially($from, $to, slice))
        return tr.step(new ReplaceStep(from, to, slice));
    let targetDepths = coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0)
        targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for (let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating)
            break;
        if (targetDepths.indexOf(d) > -1)
            preferredTarget = d;
        else if ($from.before(d) == pos)
            targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for (let content = slice.content, i = 0;; i++) {
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart)
            break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for (let d = preferredDepth - 1; d >= 0; d--) {
        let leftNode = leftNodes[d], def = definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1)))
            preferredDepth = d;
        else if (def || !leftNode.type.isTextblock)
            break;
    }
    for (let j = slice.openStart; j >= 0; j--) {
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert)
            continue;
        for (let i = 0; i < targetDepths.length; i++) {
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks))
                return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new dist_Slice(closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for (let i = targetDepths.length - 1; i >= 0; i--) {
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps)
            break;
        let depth = targetDepths[i];
        if (depth < 0)
            continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore(dist_Fragment.empty, true));
    }
    return fragment;
}
function replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = insertPoint(tr.doc, from, node.type);
        if (point != null)
            from = to = point;
    }
    tr.replaceRange(from, to, new dist_Slice(dist_Fragment.from(node), 0, 0));
}
function deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = coveredDepths($from, $to);
    for (let i = 0; i < covered.length; i++) {
        let depth = covered[i], last = i == covered.length - 1;
        if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
            return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
            return tr.delete($from.before(depth), $to.after(depth));
    }
    for (let d = 1; d <= $from.depth && d <= $to.depth; d++) {
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d &&
            $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1)))
            return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for (let d = minDepth; d >= 0; d--) {
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) ||
            $to.end(d) > $to.pos + ($to.depth - d) ||
            $from.node(d).type.spec.isolating ||
            $to.node(d).type.spec.isolating)
            break;
        if (start == $to.start(d) ||
            (d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent &&
                d && $to.start(d - 1) == start - 1))
            result.push(d);
    }
    return result;
}

/**
Update an attribute in a specific node.
*/
class AttrStep extends Step {
    /**
    Construct an attribute step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The attribute to set.
    */
    attr, 
    // The attribute's new value.
    value) {
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for (let name in node.attrs)
            attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new dist_Slice(dist_Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return StepMap.empty;
    }
    invert(doc) {
        return new AttrStep(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new AttrStep(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string")
            throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new AttrStep(json.pos, json.attr, json.value);
    }
}
Step.jsonID("attr", AttrStep);
/**
Update an attribute in the doc node.
*/
class DocAttrStep extends Step {
    /**
    Construct an attribute step.
    */
    constructor(
    /**
    The attribute to set.
    */
    attr, 
    // The attribute's new value.
    value) {
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for (let name in doc.attrs)
            attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return StepResult.ok(updated);
    }
    getMap() {
        return StepMap.empty;
    }
    invert(doc) {
        return new DocAttrStep(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return { stepType: "docAttr", attr: this.attr, value: this.value };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string")
            throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new DocAttrStep(json.attr, json.value);
    }
}
Step.jsonID("docAttr", DocAttrStep);

/**
@internal
*/
let TransformError = class extends Error {
};
TransformError = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/
class Transform {
    /**
    Create a transform that starts with the given document.
    */
    constructor(
    /**
    The current document (the result of applying the steps in the
    transform).
    */
    doc) {
        this.doc = doc;
        /**
        The steps in this transform.
        */
        this.steps = [];
        /**
        The documents before each of the steps.
        */
        this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */
        this.mapping = new Mapping;
    }
    /**
    The starting document.
    */
    get before() { return this.docs.length ? this.docs[0] : this.doc; }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */
    step(step) {
        let result = this.maybeStep(step);
        if (result.failed)
            throw new TransformError(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */
    maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed)
            this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */
    get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */
    addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */
    replace(from, to = from, slice = dist_Slice.empty) {
        let step = replaceStep(this.doc, from, to, slice);
        if (step)
            this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */
    replaceWith(from, to, content) {
        return this.replace(from, to, new dist_Slice(dist_Fragment.from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */
    delete(from, to) {
        return this.replace(from, to, dist_Slice.empty);
    }
    /**
    Insert the given content at the given position.
    */
    insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */
    replaceRange(from, to, slice) {
        replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */
    replaceRangeWith(from, to, node) {
        replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */
    deleteRange(from, to) {
        deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */
    lift(range, target) {
        lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */
    join(pos, depth = 1) {
        join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */
    wrap(range, wrappers) {
        wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */
    setBlockType(from, to = from, type, attrs = null) {
        setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */
    setNodeMarkup(pos, type, attrs = null, marks) {
        setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */
    setNodeAttribute(pos, attr, value) {
        this.step(new AttrStep(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */
    setDocAttribute(attr, value) {
        this.step(new DocAttrStep(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */
    addNodeMark(pos, mark) {
        this.step(new AddNodeMarkStep(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */
    removeNodeMark(pos, mark) {
        if (!(mark instanceof Mark)) {
            let node = this.doc.nodeAt(pos);
            if (!node)
                throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark)
                return this;
        }
        this.step(new RemoveNodeMarkStep(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */
    split(pos, depth = 1, typesAfter) {
        split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */
    addMark(from, to, mark) {
        addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */
    removeMark(from, to, mark) {
        removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */
    clearIncompatible(pos, parentType, match) {
        clearIncompatible(this, pos, parentType, match);
        return this;
    }
}



;// CONCATENATED MODULE: ./node_modules/prosemirror-state/dist/index.js



const classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/
class dist_Selection {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */
    constructor(
    /**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */
    $anchor, 
    /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */
    $head, ranges) {
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [new dist_SelectionRange($anchor.min($head), $anchor.max($head))];
    }
    /**
    The selection's anchor, as an unresolved position.
    */
    get anchor() { return this.$anchor.pos; }
    /**
    The selection's head.
    */
    get head() { return this.$head.pos; }
    /**
    The lower bound of the selection's main range.
    */
    get from() { return this.$from.pos; }
    /**
    The upper bound of the selection's main range.
    */
    get to() { return this.$to.pos; }
    /**
    The resolved lower  bound of the selection's main range.
    */
    get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */
    get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */
    get empty() {
        let ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++)
            if (ranges[i].$from.pos != ranges[i].$to.pos)
                return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */
    content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */
    replace(tr, content = dist_Slice.empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for (let i = 0; i < content.openEnd; i++) {
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let { $from, $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? dist_Slice.empty : content);
            if (i == 0)
                selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */
    replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let { $from, $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) {
                tr.deleteRange(from, to);
            }
            else {
                tr.replaceRangeWith(from, to, node);
                selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */
    static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new TextSelection($pos)
            : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner)
            return inner;
        for (let depth = $pos.depth - 1; depth >= 0; depth--) {
            let found = dir < 0
                ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
                : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found)
                return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */
    static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */
    static atStart(doc) {
        return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */
    static atEnd(doc) {
        return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */
    static fromJSON(doc, json) {
        if (!json || !json.type)
            throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = classesById[json.type];
        if (!cls)
            throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */
    static jsonID(id, selectionClass) {
        if (id in classesById)
            throw new RangeError("Duplicate use of selection JSON ID " + id);
        classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */
    getBookmark() {
        return TextSelection.between(this.$anchor, this.$head).getBookmark();
    }
}
dist_Selection.prototype.visible = true;
/**
Represents a selected range in a document.
*/
class dist_SelectionRange {
    /**
    Create a range.
    */
    constructor(
    /**
    The lower bound of the range.
    */
    $from, 
    /**
    The upper bound of the range.
    */
    $to) {
        this.$from = $from;
        this.$to = $to;
    }
}
let warnedAboutTextSelection = false;
function checkTextSelection($pos) {
    if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
        warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/
class TextSelection extends dist_Selection {
    /**
    Construct a text selection between the given points.
    */
    constructor($anchor, $head = $anchor) {
        checkTextSelection($anchor);
        checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */
    get $cursor() { return this.$anchor.pos == this.$head.pos ? this.$head : null; }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent)
            return dist_Selection.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = dist_Slice.empty) {
        super.replace(tr, content);
        if (content == dist_Slice.empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks)
                tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return { type: "text", anchor: this.anchor, head: this.head };
    }
    /**
    @internal
    */
    static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number")
            throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */
    static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */
    static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos)
            bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = dist_Selection.findFrom($head, bias, true) || dist_Selection.findFrom($head, -bias, true);
            if (found)
                $head = found.$head;
            else
                return dist_Selection.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) {
                $anchor = $head;
            }
            else {
                $anchor = (dist_Selection.findFrom($anchor, -bias, true) || dist_Selection.findFrom($anchor, bias, true)).$anchor;
                if (($anchor.pos < $head.pos) != (dPos < 0))
                    $anchor = $head;
            }
        }
        return new TextSelection($anchor, $head);
    }
}
dist_Selection.jsonID("text", TextSelection);
class TextBookmark {
    constructor(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/
class dist_NodeSelection extends dist_Selection {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */
    constructor($pos) {
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted, pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted)
            return dist_Selection.near($pos);
        return new dist_NodeSelection($pos);
    }
    content() {
        return new dist_Slice(dist_Fragment.from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof dist_NodeSelection && other.anchor == this.anchor;
    }
    toJSON() {
        return { type: "node", anchor: this.anchor };
    }
    getBookmark() { return new NodeBookmark(this.anchor); }
    /**
    @internal
    */
    static fromJSON(doc, json) {
        if (typeof json.anchor != "number")
            throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new dist_NodeSelection(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */
    static create(doc, from) {
        return new dist_NodeSelection(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */
    static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
dist_NodeSelection.prototype.visible = false;
dist_Selection.jsonID("node", dist_NodeSelection);
class NodeBookmark {
    constructor(anchor) {
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted, pos } = mapping.mapResult(this.anchor);
        return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && dist_NodeSelection.isSelectable(node))
            return new dist_NodeSelection($pos);
        return dist_Selection.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/
class AllSelection extends dist_Selection {
    /**
    Create an all-selection over the given document.
    */
    constructor(doc) {
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = dist_Slice.empty) {
        if (content == dist_Slice.empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = dist_Selection.atStart(tr.doc);
            if (!sel.eq(tr.selection))
                tr.setSelection(sel);
        }
        else {
            super.replace(tr, content);
        }
    }
    toJSON() { return { type: "all" }; }
    /**
    @internal
    */
    static fromJSON(doc) { return new AllSelection(doc); }
    map(doc) { return new AllSelection(doc); }
    eq(other) { return other instanceof AllSelection; }
    getBookmark() { return AllBookmark; }
}
dist_Selection.jsonID("all", AllSelection);
const AllBookmark = {
    map() { return this; },
    resolve(doc) { return new AllSelection(doc); }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent)
        return TextSelection.create(doc, pos);
    for (let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner)
                return inner;
        }
        else if (!text && dist_NodeSelection.isSelectable(child)) {
            return dist_NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        }
        pos += child.nodeSize * dir;
    }
    return null;
}
function selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen)
        return;
    let step = tr.steps[last];
    if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep))
        return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo) => { if (end == null)
        end = newTo; });
    tr.setSelection(dist_Selection.near(tr.doc.resolve(end), bias));
}

const UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/
class Transaction extends Transform {
    /**
    @internal
    */
    constructor(state) {
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */
    get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */
    setSelection(selection) {
        if (selection.$from.doc != this.doc)
            throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */
    get selectionSet() {
        return (this.updated & UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */
    setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */
    ensureMarks(marks) {
        if (!Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
            this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */
    addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */
    removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */
    get storedMarksSet() {
        return (this.updated & UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */
    addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */
    setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */
    replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */
    replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks)
            node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || Mark.none)));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */
    deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */
    insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text)
                return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        }
        else {
            if (to == null)
                to = from;
            to = to == null ? from : to;
            if (!text)
                return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty)
                this.setSelection(dist_Selection.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */
    setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */
    getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */
    get isGeneric() {
        for (let _ in this.meta)
            return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */
    scrollIntoView() {
        this.updated |= UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */
    get scrolledIntoView() {
        return (this.updated & UPDATED_SCROLL) > 0;
    }
}

function bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class FieldDesc {
    constructor(name, desc, self) {
        this.name = name;
        this.init = bind(desc.init, self);
        this.apply = bind(desc.apply, self);
    }
}
const baseFields = [
    new FieldDesc("doc", {
        init(config) { return config.doc || config.schema.topNodeType.createAndFill(); },
        apply(tr) { return tr.doc; }
    }),
    new FieldDesc("selection", {
        init(config, instance) { return config.selection || dist_Selection.atStart(instance.doc); },
        apply(tr) { return tr.selection; }
    }),
    new FieldDesc("storedMarks", {
        init(config) { return config.storedMarks || null; },
        apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null; }
    }),
    new FieldDesc("scrollToSelection", {
        init() { return 0; },
        apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev; }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class Configuration {
    constructor(schema, plugins) {
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = baseFields.slice();
        if (plugins)
            plugins.forEach(plugin => {
                if (this.pluginsByKey[plugin.key])
                    throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state)
                    this.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/
class EditorState {
    /**
    @internal
    */
    constructor(
    /**
    @internal
    */
    config) {
        this.config = config;
    }
    /**
    The schema of the state's document.
    */
    get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */
    get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */
    apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */
    filterTransaction(tr, ignore = -1) {
        for (let i = 0; i < this.config.plugins.length; i++)
            if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
                    return false;
            }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */
    applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr))
            return { state: this, transactions: [] };
        let trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for (;;) {
            let haveNew = false;
            for (let i = 0; i < this.config.plugins.length; i++) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length &&
                        plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for (let j = 0; j < this.config.plugins.length; j++)
                                seen.push(j < i ? { state: newState, n: trs.length } : { state: this, n: 0 });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen)
                        seen[i] = { state: newState, n: trs.length };
                }
            }
            if (!haveNew)
                return { state: newState, transactions: trs };
        }
    }
    /**
    @internal
    */
    applyInner(tr) {
        if (!tr.before.eq(this.doc))
            throw new RangeError("Applying a mismatched transaction");
        let newInstance = new EditorState(this.config), fields = this.config.fields;
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */
    get tr() { return new Transaction(this); }
    /**
    Create a new state.
    */
    static create(config) {
        let $config = new Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new EditorState($config);
        for (let i = 0; i < $config.fields.length; i++)
            instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */
    reconfigure(config) {
        let $config = new Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new EditorState($config);
        for (let i = 0; i < fields.length; i++) {
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */
    toJSON(pluginFields) {
        let result = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
        if (this.storedMarks)
            result.storedMarks = this.storedMarks.map(m => m.toJSON());
        if (pluginFields && typeof pluginFields == 'object')
            for (let prop in pluginFields) {
                if (prop == "doc" || prop == "selection")
                    throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON)
                    result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */
    static fromJSON(config, json, pluginFields) {
        if (!json)
            throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema)
            throw new RangeError("Required config field 'schema' missing");
        let $config = new Configuration(config.schema, config.plugins);
        let instance = new EditorState($config);
        $config.fields.forEach(field => {
            if (field.name == "doc") {
                instance.doc = Node.fromJSON(config.schema, json.doc);
            }
            else if (field.name == "selection") {
                instance.selection = dist_Selection.fromJSON(instance.doc, json.selection);
            }
            else if (field.name == "storedMarks") {
                if (json.storedMarks)
                    instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            }
            else {
                if (pluginFields)
                    for (let prop in pluginFields) {
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON &&
                            Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}

function bindProps(obj, self, target) {
    for (let prop in obj) {
        let val = obj[prop];
        if (val instanceof Function)
            val = val.bind(self);
        else if (prop == "handleDOMEvents")
            val = bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/
class Plugin {
    /**
    Create a plugin.
    */
    constructor(
    /**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */
    spec) {
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */
        this.props = {};
        if (spec.props)
            bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */
    getState(state) { return state[this.key]; }
}
const keys = Object.create(null);
function createKey(name) {
    if (name in keys)
        return name + "$" + ++keys[name];
    keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/
class PluginKey {
    /**
    Create a plugin key.
    */
    constructor(name = "key") { this.key = createKey(name); }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */
    get(state) { return state.config.pluginsByKey[this.key]; }
    /**
    Get the plugin's state from an editor state.
    */
    getState(state) { return state[this.key]; }
}



;// CONCATENATED MODULE: ./node_modules/prosemirror-view/dist/index.js




const domIndex = function (node) {
    for (var index = 0;; index++) {
        node = node.previousSibling;
        if (!node)
            return index;
    }
};
const parentNode = function (node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const textRange = function (node, from, to) {
    let range = reusedRange || (reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const clearReusedRange = function () {
    reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const isEquivalentPosition = function (node, off, targetNode, targetOff) {
    return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
        scanFor(node, off, targetNode, targetOff, 1));
};
const atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node, off, targetNode, targetOff, dir) {
    for (;;) {
        if (node == targetNode && off == targetOff)
            return true;
        if (off == (dir < 0 ? 0 : nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) ||
                node.contentEditable == "false")
                return false;
            off = domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        }
        else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false")
                return false;
            off = dir < 0 ? nodeSize(node) : 0;
        }
        else {
            return false;
        }
    }
}
function nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function textNodeBefore$1(node, offset) {
    for (;;) {
        if (node.nodeType == 3 && offset)
            return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false")
                return null;
            node = node.childNodes[offset - 1];
            offset = nodeSize(node);
        }
        else if (node.parentNode && !hasBlockDesc(node)) {
            offset = domIndex(node);
            node = node.parentNode;
        }
        else {
            return null;
        }
    }
}
function textNodeAfter$1(node, offset) {
    for (;;) {
        if (node.nodeType == 3 && offset < node.nodeValue.length)
            return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false")
                return null;
            node = node.childNodes[offset];
            offset = 0;
        }
        else if (node.parentNode && !hasBlockDesc(node)) {
            offset = domIndex(node) + 1;
            node = node.parentNode;
        }
        else {
            return null;
        }
    }
}
function isOnEdge(node, offset, parent) {
    for (let atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
        if (node == parent)
            return true;
        let index = domIndex(node);
        node = node.parentNode;
        if (!node)
            return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == nodeSize(node);
    }
}
function hasBlockDesc(dom) {
    let desc;
    for (let cur = dom; cur; cur = cur.parentNode)
        if (desc = cur.pmViewDesc)
            break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const selectionCollapsed = function (domSel) {
    return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function deepActiveElement(doc) {
    let elt = doc.activeElement;
    while (elt && elt.shadowRoot)
        elt = elt.shadowRoot.activeElement;
    return elt;
}
function caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) {
        try { // Firefox throws for this call in hard-to-predict circumstances (#994)
            let pos = doc.caretPositionFromPoint(x, y);
            // Clip the offset, because Chrome will return a text offset
            // into <input> nodes, which can't be treated as a regular DOM
            // offset
            if (pos)
                return { node: pos.offsetNode, offset: Math.min(nodeSize(pos.offsetNode), pos.offset) };
        }
        catch (_) { }
    }
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range)
            return { node: range.startContainer, offset: Math.min(nodeSize(range.startContainer), range.startOffset) };
    }
}

const nav = typeof navigator != "undefined" ? navigator : null;
const dist_doc = typeof document != "undefined" ? document : null;
const agent = (nav && nav.userAgent) || "";
const ie_edge = /Edge\/(\d+)/.exec(agent);
const ie_upto10 = /MSIE \d/.exec(agent);
const ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
const ie = !!(ie_upto10 || ie_11up || ie_edge);
const ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
const gecko = !ie && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
const _chrome = !ie && /Chrome\/(\d+)/.exec(agent);
const chrome = !!_chrome;
const chrome_version = _chrome ? +_chrome[1] : 0;
const safari = !ie && !!nav && /Apple Computer/.test(nav.vendor);
// Is true for both iOS and iPadOS for convenience
const ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
const mac = ios || (nav ? /Mac/.test(nav.platform) : false);
const windows = nav ? /Win/.test(nav.platform) : false;
const android = /Android \d/.test(agent);
const webkit = !!dist_doc && "webkitFontSmoothing" in dist_doc.documentElement.style;
const webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;

function windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp)
        return {
            left: 0, right: vp.width,
            top: 0, bottom: vp.height
        };
    return { left: 0, right: doc.documentElement.clientWidth,
        top: 0, bottom: doc.documentElement.clientHeight };
}
function getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = (rect.width / node.offsetWidth) || 1;
    let scaleY = (rect.height / node.offsetHeight) || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return { left: rect.left, right: rect.left + node.clientWidth * scaleX,
        top: rect.top, bottom: rect.top + node.clientHeight * scaleY };
}
function scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for (let parent = startDOM || view.dom;; parent = parentNode(parent)) {
        if (!parent)
            break;
        if (parent.nodeType != 1)
            continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? windowRect(doc) : clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
            moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
            moveY = rect.bottom - rect.top > bounding.bottom - bounding.top
                ? rect.top + getSide(scrollMargin, "top") - bounding.top
                : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
            moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
            moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) {
                doc.defaultView.scrollBy(moveX, moveY);
            }
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY)
                    elt.scrollTop += moveY;
                if (moveX)
                    elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = { left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position))
            break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for (let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom))
            continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return { refDOM: refDOM, refTop: refTop, stack: scrollStack(view.dom) };
}
function scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for (let cur = dom; cur; cur = parentNode(cur)) {
        stack.push({ dom: cur, top: cur.scrollTop, left: cur.scrollLeft });
        if (dom == doc)
            break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos({ refDOM, refTop, stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
    for (let i = 0; i < stack.length; i++) {
        let { dom, top, left } = stack[i];
        if (dom.scrollTop != top + dTop)
            dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left)
            dom.scrollLeft = left;
    }
}
let preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
    if (dom.setActive)
        return dom.setActive(); // in IE
    if (preventScrollSupported)
        return dom.focus(preventScrollSupported);
    let stored = scrollStack(dom);
    dom.focus(preventScrollSupported == null ? {
        get preventScroll() {
            preventScrollSupported = { preventScroll: true };
            return true;
        }
    } : undefined);
    if (!preventScrollSupported) {
        preventScrollSupported = false;
        restoreScrollStack(stored, 0);
    }
}
function findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for (let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
        let rects;
        if (child.nodeType == 1)
            rects = child.getClientRects();
        else if (child.nodeType == 3)
            rects = textRange(child).getClientRects();
        else
            continue;
        for (let i = 0; i < rects.length; i++) {
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left
                    : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx)
                        offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            }
            else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = { left: Math.max(rect.left, Math.min(rect.right, coords.left)), top: rect.top };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                coords.left >= rect.left && coords.top >= rect.bottom))
                offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3)
        return findOffsetInText(closest, coordsClosest);
    if (!closest || (dxClosest && closest.nodeType == 1))
        return { node, offset };
    return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for (let i = 0; i < len; i++) {
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = singleRect(range, 1);
        if (rect.top == rect.bottom)
            continue;
        if (inRect(coords, rect))
            return { node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0) };
    }
    return { node, offset: 0 };
}
function inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 &&
        coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
        return parent;
    return dom;
}
function posFromElement(view, elt, coords) {
    let { node, offset } = findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for (let cur = node, sawBlock = false;;) {
        if (cur == view.dom)
            break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc)
            return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) &&
            // Ignore elements with zero-size bounding rectangles
            ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top)
                    outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top)
                    outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2
                    : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) {
        for (let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
            let child = element.childNodes[i];
            if (child.nodeType == 1) {
                let rects = child.getClientRects();
                for (let j = 0; j < rects.length; j++) {
                    let rect = rects[j];
                    if (inRect(coords, rect))
                        return elementFromPoint(child, coords, rect);
                }
            }
            if ((i = (i + 1) % len) == startI)
                break;
        }
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = caretFromPoint(doc, coords.left, coords.top);
    if (caret)
        ({ node, offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc)
        .elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!inRect(coords, box))
            return null;
        elt = elementFromPoint(view.dom, coords, box);
        if (!elt)
            return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if (safari) {
        for (let p = elt; node && p; p = parentNode(p))
            if (p.draggable)
                node = undefined;
    }
    elt = targetKludge(elt, coords);
    if (node) {
        if (gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left &&
                    box.bottom > coords.top)
                    offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if (webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 &&
            prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top)
            offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
            coords.top > node.lastChild.getBoundingClientRect().bottom)
            pos = view.state.doc.content.size;
        // Ignore positions directly after a BR, since caret*FromPoint
        // 'round up' positions that would be more accurately placed
        // before the BR node.
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
            pos = posFromCaret(view, node, offset, coords);
    }
    if (pos == null)
        pos = posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return { pos, inside: desc ? desc.posAtStart - desc.border : -1 };
}
function nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if (nonZero(first))
            return first;
    }
    return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
const BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos, side) {
    let { node, offset, atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = webkit || gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = singleRect(textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if (gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top)
                        return flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        }
        else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            }
            else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            }
            else if (side < 0) {
                from--;
            }
            else {
                to++;
            }
            return flattenV(singleRect(textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1)
                return flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1)
                return flattenH(after.getBoundingClientRect(), true);
        }
        return flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? textRange(before, nodeSize(before) - (supportEmptyRange ? 0 : 1))
            // BR nodes tend to only return the rectangle before them.
            // Only use them if they are the last element in their parent
            : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target)
            return flattenV(singleRect(target, 1), false);
    }
    if (atom == null && offset < nodeSize(node)) {
        let after = node.childNodes[offset];
        while (after.pmViewDesc && after.pmViewDesc.ignoreForCoords)
            after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? textRange(after, 0, (supportEmptyRange ? 0 : 1))
            : after.nodeType == 1 ? after : null;
        if (target)
            return flattenV(singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0);
}
function flattenV(rect, left) {
    if (rect.width == 0)
        return rect;
    let x = left ? rect.left : rect.right;
    return { top: rect.top, bottom: rect.bottom, left: x, right: x };
}
function flattenH(rect, top) {
    if (rect.height == 0)
        return rect;
    let y = top ? rect.top : rect.bottom;
    return { top: y, bottom: y, left: rect.left, right: rect.right };
}
function withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state)
        view.updateState(state);
    if (active != view.dom)
        view.focus();
    try {
        return f();
    }
    finally {
        if (viewState != state)
            view.updateState(viewState);
        if (active != view.dom && active)
            active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return withFlushedState(view, state, () => {
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for (;;) {
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest)
                break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = coordsAtPos(view, $pos.pos, 1);
        for (let child = dom.firstChild; child; child = child.nextSibling) {
            let boxes;
            if (child.nodeType == 1)
                boxes = child.getClientRects();
            else if (child.nodeType == 3)
                boxes = textRange(child, 0, child.nodeValue.length).getClientRects();
            else
                continue;
            for (let i = 0; i < boxes.length; i++) {
                let box = boxes[i];
                if (box.bottom > box.top + 1 &&
                    (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2
                        : box.bottom - coords.bottom > (coords.bottom - box.top) * 2))
                    return false;
            }
        }
        return true;
    });
}
const maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
    let { $head } = state.selection;
    if (!$head.parent.isTextblock)
        return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel)
        return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
        return dir == "left" || dir == "backward" ? atStart : atEnd;
    return withFlushedState(view, state, () => {
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode, anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) ||
            (oldNode == newNode && oldOff == newOff);
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend)
                sel.extend(oldNode, oldOff);
        }
        catch (_) { }
        if (oldBidiLevel != null)
            sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let cachedState = null;
let cachedDir = null;
let cachedResult = false;
function endOfTextblock(view, state, dir) {
    if (cachedState == state && cachedDir == dir)
        return cachedResult;
    cachedState = state;
    cachedDir = dir;
    return cachedResult = dir == "up" || dir == "down"
        ? endOfTextblockVertical(view, state, dir)
        : endOfTextblockHorizontal(view, state, dir);
}

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class ViewDesc {
    constructor(parent, children, dom, 
    // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM) {
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) { return false; }
    matchesMark(mark) { return false; }
    matchesNode(node, outerDeco, innerDeco) { return false; }
    matchesHack(nodeName) { return false; }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() { return null; }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) { return false; }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for (let i = 0; i < this.children.length; i++)
            size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() { return 0; }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this)
            this.dom.pmViewDesc = undefined;
        for (let i = 0; i < this.children.length; i++)
            this.children[i].destroy();
    }
    posBeforeChild(child) {
        for (let i = 0, pos = this.posAtStart;; i++) {
            let cur = this.children[i];
            if (cur == child)
                return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) {
                    domBefore = dom.childNodes[offset - 1];
                }
                else {
                    while (dom.parentNode != this.contentDOM)
                        dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))
                    domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            }
            else {
                let domAfter, desc;
                if (dom == this.contentDOM) {
                    domAfter = dom.childNodes[offset];
                }
                else {
                    while (dom.parentNode != this.contentDOM)
                        dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while (domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))
                    domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) {
            atEnd = offset > domIndex(this.contentDOM);
        }
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
            atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        }
        else if (this.dom.firstChild) {
            if (offset == 0)
                for (let search = dom;; search = search.parentNode) {
                    if (search == this.dom) {
                        atEnd = false;
                        break;
                    }
                    if (search.previousSibling)
                        break;
                }
            if (atEnd == null && offset == dom.childNodes.length)
                for (let search = dom;; search = search.parentNode) {
                    if (search == this.dom) {
                        atEnd = true;
                        break;
                    }
                    if (search.nextSibling)
                        break;
                }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for (let first = true, cur = dom; cur; cur = cur.parentNode) {
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) &&
                    !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom))
                    first = false;
                else
                    return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for (let cur = desc; cur; cur = cur.parent)
            if (cur == this)
                return desc;
    }
    posFromDOM(dom, offset, bias) {
        for (let scan = dom; scan; scan = scan.parentNode) {
            let desc = this.getDesc(scan);
            if (desc)
                return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for (let i = 0, offset = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while (!child.border && child.children.length) {
                    for (let i = 0; i < child.children.length; i++) {
                        let inner = child.children[i];
                        if (inner.size) {
                            child = inner;
                            break;
                        }
                    }
                }
                return child;
            }
            if (pos < end)
                return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM)
            return { node: this.dom, offset: 0, atom: pos + 1 };
        // First find the position in the child array
        let i = 0, offset = 0;
        for (let curPos = 0; i < this.children.length; i++) {
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset)
            return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for (let prev; i && !(prev = this.children[i - 1]).size && prev instanceof WidgetViewDesc && prev.side >= 0; i--) { }
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for (;; i--, enter = false) {
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM)
                    break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom)
                return prev.domFromPos(prev.size, side);
            return { node: this.contentDOM, offset: prev ? domIndex(prev.dom) + 1 : 0 };
        }
        else {
            let next, enter = true;
            for (;; i++, enter = false) {
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM)
                    break;
            }
            if (next && enter && !next.border && !next.domAtom)
                return next.domFromPos(0, side);
            return { node: this.contentDOM, offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0)
            return { node: this.contentDOM, from, to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
        let fromOffset = -1, toOffset = -1;
        for (let offset = base, i = 0;; i++) {
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node &&
                    child.contentDOM && this.contentDOM.contains(child.contentDOM))
                    return child.parseRange(from, to, childBase);
                from = offset;
                for (let j = i; j > 0; j--) {
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1)
                    fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for (let j = i + 1; j < this.children.length; j++) {
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1)
                    toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return { node: this.contentDOM, from, to, fromOffset, toOffset };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length)
            return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node, offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length)
            throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for (let i = 0, offset = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end)
                return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if ((gecko || safari) && anchor == head) {
            let { node, offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) {
                    for (let scan = node, after; scan; scan = scan.parentNode) {
                        if (after = scan.nextSibling) {
                            if (after.nodeName == "BR")
                                anchorDOM = headDOM = { node: after.parentNode, offset: domIndex(after) + 1 };
                            break;
                        }
                        let desc = scan.pmViewDesc;
                        if (desc && desc.node && desc.node.isBlock)
                            break;
                    }
                }
            }
            else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false")
                force = true;
        }
        if (!(force || brKludge && safari) &&
            isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) &&
            isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset))
            return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head)
                    domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            }
            catch (_) {
                // In some cases with Chrome the selection is empty after calling
                // collapse, even when it should be valid. This appears to be a bug, but
                // it is difficult to isolate. If this happens fallback to the old path
                // without using extend.
                // Similarly, this could crash on Safari if the editor is hidden, and
                // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for (let offset = 0, i = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
                    if (from == startInside && to == endInside &&
                        (child.contentLost || child.dom.parentNode != this.contentDOM))
                        child.dirty = NODE_DIRTY;
                    else
                        child.markDirty(from - startInside, to - startInside);
                    return;
                }
                else {
                    child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length
                        ? CONTENT_DIRTY : NODE_DIRTY;
                }
            }
            offset = end;
        }
        this.dirty = CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for (let node = this.parent; node; node = node.parent, level++) {
            let dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
            if (node.dirty < dirty)
                node.dirty = dirty;
        }
    }
    get domAtom() { return false; }
    get ignoreForCoords() { return false; }
    isText(text) { return false; }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class WidgetViewDesc extends ViewDesc {
    constructor(parent, widget, view, pos) {
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function")
            dom = dom(view, () => {
                if (!self)
                    return pos;
                if (self.parent)
                    return self.parent.posBeforeChild(self);
            });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() { return { ignore: true }; }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() { return true; }
    get side() { return this.widget.type.side; }
}
class CompositionViewDesc extends ViewDesc {
    constructor(parent, dom, textDOM, text) {
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() { return this.text.length; }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM)
            return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return { node: this.textDOM, offset: pos };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class MarkViewDesc extends ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec) {
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom)
            spec = DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if ((this.dirty & NODE_DIRTY) || this.mark.type.spec.reparseInView)
            return null;
        return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
    }
    matchesMark(mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark); }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != NOT_DIRTY) {
            let parent = this.parent;
            while (!parent.node)
                parent = parent.parent;
            if (parent.dirty < this.dirty)
                parent.dirty = this.dirty;
            this.dirty = NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size)
            nodes = replaceNodes(nodes, to, size, view);
        if (from > 0)
            nodes = replaceNodes(nodes, 0, from, view);
        for (let i = 0; i < nodes.length; i++)
            nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy)
            this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class NodeViewDesc extends ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, () => {
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj)
                return pos;
            if (descObj.parent)
                return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom)
                dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3)
                throw new RangeError("Text must be rendered as a DOM text node");
        }
        else if (!dom) {
            let spec = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom, contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
            if (!dom.hasAttribute("contenteditable"))
                dom.contentEditable = "false";
            if (node.type.spec.draggable)
                dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = applyOuterDeco(dom, outerDeco, node);
        if (spec)
            return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText)
            return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else
            return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView)
            return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = { node: this.node.type.name, attrs: this.node.attrs };
        if (this.node.type.whitespace == "pre")
            rule.preserveWhitespace = "full";
        if (!this.contentDOM) {
            rule.getContent = () => this.node.content;
        }
        else if (!this.contentLost) {
            rule.contentElement = this.contentDOM;
        }
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for (let i = this.children.length - 1; i >= 0; i--) {
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement)
                rule.getContent = () => dist_Fragment.empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == NOT_DIRTY && node.eq(this.node) &&
            sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() { return this.node.nodeSize; }
    get border() { return this.node.isLeaf ? 0 : 1; }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
        iterDeco(this.node, this.innerDeco, (widget, i, insideNode) => {
            if (widget.spec.marks)
                updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode)
                updater.syncToMarks(i == this.node.childCount ? Mark.none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i) => {
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off &&
                view.state.selection.to < off + child.nodeSize &&
                (compIndex = updater.findIndexWithChild(composition.node)) > -1 &&
                updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else {
                // Add it as a new view
                updater.addNode(child, outerDeco, innerDeco, view, off);
            }
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock)
            updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition)
                this.protectLocalComposition(view, localComposition);
            renderDescs(this.contentDOM, this.children, view);
            if (ios)
                iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from, to } = view.state.selection;
        if (!(view.state.selection instanceof TextSelection) || from < pos || to > pos + this.node.content.size)
            return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode))
            return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : { node: textNode, pos: textPos, text };
        }
        else {
            return { node: textNode, pos: -1, text: "" };
        }
    }
    protectLocalComposition(view, { node, pos, text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node))
            return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for (;; topNode = topNode.parentNode) {
            if (topNode.parentNode == this.contentDOM)
                break;
            while (topNode.previousSibling)
                topNode.parentNode.removeChild(topNode.previousSibling);
            while (topNode.nextSibling)
                topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc)
                topNode.pmViewDesc = undefined;
        }
        let desc = new CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY ||
            !node.sameMarkup(this.node))
            return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM)
            this.updateChildren(view, this.posAtStart);
        this.dirty = NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if (sameOuterDeco(outerDeco, this.outerDeco))
            return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1)
            this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable)
            this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable)
                this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() { return this.node.isAtom; }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    applyOuterDeco(dom, outerDeco, doc);
    let docView = new NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM)
        docView.updateChildren(view, 0);
    return docView;
}
class TextViewDesc extends NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while (skip && skip != this.dom && !skip.pmIsDeco)
            skip = skip.parentNode;
        return { skip: (skip || true) };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
            !node.sameMarkup(this.node))
            return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM)
                view.trackWrites = null;
        }
        this.node = node;
        this.dirty = NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for (let n = this.nodeDOM; n; n = n.parentNode)
            if (n == parentDOM)
                return true;
        return false;
    }
    domFromPos(pos) {
        return { node: this.nodeDOM, offset: pos };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM)
            return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length))
            this.dirty = NODE_DIRTY;
    }
    get domAtom() { return false; }
    isText(text) { return this.node.text == text; }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class TrailingHackViewDesc extends ViewDesc {
    parseRule() { return { ignore: true }; }
    matchesHack(nodeName) { return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName; }
    get domAtom() { return true; }
    get ignoreForCoords() { return this.dom.nodeName == "IMG"; }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class CustomNodeViewDesc extends NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY)
            return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result)
                this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        }
        else if (!this.contentDOM && !node.isLeaf) {
            return false;
        }
        else {
            return super.update(node, outerDeco, innerDeco, view);
        }
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root)
            : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy)
            this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for (let i = 0; i < descs.length; i++) {
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while (childDOM != dom) {
                dom = rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        }
        else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while (dom) {
        dom = rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM)
        view.trackWrites = null;
}
const OuterDecoLevel = function (nodeName) {
    if (nodeName)
        this.nodeName = nodeName;
};
OuterDecoLevel.prototype = Object.create(null);
const noDeco = [new OuterDecoLevel];
function computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0)
        return noDeco;
    let top = needsWrap ? noDeco[0] : new OuterDecoLevel, result = [top];
    for (let i = 0; i < outerDeco.length; i++) {
        let attrs = outerDeco[i].type.attrs;
        if (!attrs)
            continue;
        if (attrs.nodeName)
            result.push(top = new OuterDecoLevel(attrs.nodeName));
        for (let name in attrs) {
            let val = attrs[name];
            if (val == null)
                continue;
            if (needsWrap && result.length == 1)
                result.push(top = new OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class")
                top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style")
                top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName")
                top[name] = val;
        }
    }
    return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == noDeco && curComputed == noDeco)
        return nodeDOM;
    let curDOM = nodeDOM;
    for (let i = 0; i < curComputed.length; i++) {
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
                (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) {
                curDOM = parent;
            }
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = noDeco[0];
                curDOM = parent;
            }
        }
        patchAttributes(curDOM, prev || noDeco[0], deco);
    }
    return curDOM;
}
function patchAttributes(dom, prev, cur) {
    for (let name in prev)
        if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
            dom.removeAttribute(name);
    for (let name in cur)
        if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name])
            dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for (let i = 0; i < prevList.length; i++)
            if (curList.indexOf(prevList[i]) == -1)
                dom.classList.remove(prevList[i]);
        for (let i = 0; i < curList.length; i++)
            if (prevList.indexOf(curList[i]) == -1)
                dom.classList.add(curList[i]);
        if (dom.classList.length == 0)
            dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while (m = prop.exec(prev.style))
                dom.style.removeProperty(m[1]);
        }
        if (cur.style)
            dom.style.cssText += cur.style;
    }
}
function applyOuterDeco(dom, deco, node) {
    return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
    if (a.length != b.length)
        return false;
    for (let i = 0; i < a.length; i++)
        if (!a[i].type.eq(b[i].type))
            return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class ViewTreeUpdater {
    constructor(top, lock, view) {
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end)
            return;
        for (let i = start; i < end; i++)
            this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while (keep < maxKeep &&
            (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1])
                .matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
            keep++;
        while (keep < depth) {
            this.destroyRest();
            this.top.dirty = NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while (depth < marks.length) {
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for (let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            }
            else {
                let markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index &&
            (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top &&
            targetDesc.matchesNode(node, outerDeco, innerDeco)) {
            found = this.top.children.indexOf(targetDesc, this.index);
        }
        else {
            for (let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
                let child = this.top.children[i];
                if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                    found = i;
                    break;
                }
            }
        }
        if (found < 0)
            return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM)
            child.dirty = CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view))
            return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for (;;) {
            let parent = domNode.parentNode;
            if (!parent)
                return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc)
                    for (let i = this.index; i < this.top.children.length; i++) {
                        if (this.top.children[i] == desc)
                            return i;
                    }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for (let i = this.index; i < this.top.children.length; i++) {
            let next = this.top.children[i];
            if (next instanceof NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index)
                    return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) &&
                    !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text &&
                        next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM)
                        this.changed = true;
                    this.index++;
                    return true;
                }
                else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length ||
            !next.node.content.eq(node.content) ||
            !sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco))
            return null;
        let wrapper = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)
                ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM)
            desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) &&
            (widget == next.widget || !next.widget.type.toDOM.parentNode)) {
            this.index++;
        }
        else {
            let desc = new WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while (lastChild instanceof MarkViewDesc) {
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
            !(lastChild instanceof TextViewDesc) ||
            /\n$/.test(lastChild.node.text) ||
            (this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text))) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false")
                this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) {
            this.index++;
        }
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR")
                dom.className = "ProseMirror-trailingBreak";
            let hack = new TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top)
                parent.children.push(hack);
            else
                parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while (fI > 0) {
        let desc;
        for (;;) {
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                }
                else {
                    desc = next;
                    descI--;
                    break;
                }
            }
            else if (curDesc == parentDesc) {
                break outer;
            }
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node)
            continue;
        if (node != frag.child(fI - 1))
            break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return { index: fI, matched, matches: matches.reverse() };
}
function compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for (let i = 0; i < parent.childCount; i++) {
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for (let parentIndex = 0;;) {
        let widget, widgets;
        while (decoIndex < locals.length && locals[decoIndex].to == offset) {
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget)
                    widget = next;
                else
                    (widgets || (widgets = [widget])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort(compareSide);
                for (let i = 0; i < widgets.length; i++)
                    onWidget(widgets[i], parentIndex, !!restNode);
            }
            else {
                onWidget(widget, parentIndex, !!restNode);
            }
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        }
        else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        }
        else {
            break;
        }
        for (let i = 0; i < active.length; i++)
            if (active[i].to <= offset)
                active.splice(i--, 1);
        while (decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)
            active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt)
                cutAt = locals[decoIndex].from;
            for (let i = 0; i < active.length; i++)
                if (active[i].to < cutAt)
                    cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        }
        else {
            while (decoIndex < locals.length && locals[decoIndex].to < end)
                decoIndex++;
        }
        let outerDeco = child.isInline && !child.isLeaf ? active.filter(d => !d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function findTextInFragment(frag, text, from, to) {
    for (let i = 0, pos = 0; i < frag.childCount && pos <= to;) {
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText)
            continue;
        let str = child.text;
        while (i < frag.childCount) {
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText)
                break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text)
                return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from)
                return childStart + found;
            if (from == to && str.length >= (to + text.length) - childStart &&
                str.slice(to - childStart, to - childStart + text.length) == text)
                return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for (let i = 0, off = 0; i < nodes.length; i++) {
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) {
            result.push(child);
        }
        else {
            if (start < from)
                result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to)
                result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}

function selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode)
        return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0)
        return null;
    let $head = doc.resolve(head), anchor, selection;
    if (selectionCollapsed(domSel)) {
        anchor = head;
        while (nearestDesc && !nearestDesc.node)
            nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && dist_NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent
            && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new dist_NodeSelection(head == pos ? $head : doc.resolve(pos));
        }
    }
    else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for (let i = 0; i < domSel.rangeCount; i++) {
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0)
                return null;
            [anchor, head] = max == view.state.selection.anchor ? [max, min] : [min, max];
            $head = doc.resolve(head);
        }
        else {
            anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        }
        if (anchor < 0)
            return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || (view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
        selection = selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() :
        hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    syncNodeSelection(view, sel);
    if (!editorOwnsSelection(view))
        return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode &&
            isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) {
        selectCursorWrapper(view);
    }
    else {
        let { anchor, head } = sel, resetEditableFrom, resetEditableTo;
        if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
            if (!sel.$from.parent.inlineContent)
                resetEditableFrom = temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent)
                resetEditableTo = temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if (brokenSelectBetweenUneditable) {
            if (resetEditableFrom)
                resetEditable(resetEditableFrom);
            if (resetEditableTo)
                resetEditable(resetEditableTo);
        }
        if (sel.visible) {
            view.dom.classList.remove("ProseMirror-hideselection");
        }
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document)
                removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
    let { node, offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if (safari && after && after.contentEditable == "false")
        return setEditable(after);
    if ((!after || after.contentEditable == "false") &&
        (!before || before.contentEditable == "false")) {
        if (after)
            return setEditable(after);
        else if (before)
            return setEditable(before);
    }
}
function setEditable(element) {
    element.contentEditable = "true";
    if (safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = () => {
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(() => {
                if (!editorOwnsSelection(view) || view.state.selection.visible)
                    view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel)
        return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img)
        range.setStart(node.parentNode, domIndex(node) + 1);
    else
        range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && ie && ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function syncNodeSelection(view, sel) {
    if (sel instanceof dist_NodeSelection) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            clearNodeSelection(view);
            if (desc)
                desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    }
    else {
        clearNodeSelection(view);
    }
}
// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent)
            view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", f => f(view, $anchor, $head))
        || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus())
        return false;
    return hasSelection(view);
}
function hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode)
        return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
            (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    }
    catch (_) {
        return false;
    }
}
function anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}

function moveSelectionBlock(state, dir) {
    let { $anchor, $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && dist_Selection.findFrom($start, dir);
}
function apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof TextSelection) {
        if (mods.indexOf("s") > -1) {
            let { $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf)
                return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return apply(view, new TextSelection(sel.$anchor, $newHead));
        }
        else if (!sel.empty) {
            return false;
        }
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = moveSelectionBlock(view.state, dir);
            if (next && (next instanceof dist_NodeSelection))
                return apply(view, next);
            return false;
        }
        else if (!(mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText)
                return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM))
                return false;
            if (dist_NodeSelection.isSelectable(node)) {
                return apply(view, new dist_NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            }
            else if (webkit) {
                // Chrome and Safari will introduce extra pointless cursor
                // positions around inline uneditable nodes, so we have to
                // take over and move the cursor past them (#937)
                return apply(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            }
            else {
                return false;
            }
        }
    }
    else if (sel instanceof dist_NodeSelection && sel.node.isInline) {
        return apply(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
    }
    else {
        let next = moveSelectionBlock(view.state, dir);
        if (next)
            return apply(view, next);
        return false;
    }
}
function nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
    return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node)
        return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if (gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset], -1))
        force = true;
    for (;;) {
        if (offset > 0) {
            if (node.nodeType != 1) {
                break;
            }
            else {
                let before = node.childNodes[offset - 1];
                if (isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                }
                else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                }
                else
                    break;
            }
        }
        else if (isBlockNode(node)) {
            break;
        }
        else {
            let prev = node.previousSibling;
            while (prev && isIgnorable(prev, -1)) {
                moveNode = node.parentNode;
                moveOffset = domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom)
                    break;
                offset = 0;
            }
            else {
                node = prev;
                offset = nodeLen(node);
            }
        }
    }
    if (force)
        setSelFocus(view, node, offset);
    else if (moveNode)
        setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node)
        return;
    let len = nodeLen(node);
    let moveNode, moveOffset;
    for (;;) {
        if (offset < len) {
            if (node.nodeType != 1)
                break;
            let after = node.childNodes[offset];
            if (isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            }
            else
                break;
        }
        else if (isBlockNode(node)) {
            break;
        }
        else {
            let next = node.nextSibling;
            while (next && isIgnorable(next, 1)) {
                moveNode = next.parentNode;
                moveOffset = domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom)
                    break;
                offset = len = 0;
            }
            else {
                node = next;
                offset = 0;
                len = nodeLen(node);
            }
        }
    }
    if (moveNode)
        setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node, offset) {
    while (node && offset == node.childNodes.length && !hasBlockDesc(node)) {
        offset = domIndex(node) + 1;
        node = node.parentNode;
    }
    while (node && offset < node.childNodes.length) {
        let next = node.childNodes[offset];
        if (next.nodeType == 3)
            return next;
        if (next.nodeType == 1 && next.contentEditable == "false")
            break;
        node = next;
        offset = 0;
    }
}
function textNodeBefore(node, offset) {
    while (node && !offset && !hasBlockDesc(node)) {
        offset = domIndex(node);
        node = node.parentNode;
    }
    while (node && offset) {
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3)
            return next;
        if (next.nodeType == 1 && next.contentEditable == "false")
            break;
        node = next;
        offset = node.childNodes.length;
    }
}
function setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        }
        else if (before = textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel)
        return;
    if (selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    }
    else if (sel.extend) {
        sel.extend(node, offset);
    }
    view.domObserver.setCurSelection();
    let { state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(() => {
        if (view.state == state)
            selectionToDOM(view);
    }, 50);
}
function findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!(chrome || windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1)
                return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1)
                return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1)
        return false;
    if (mac && mods.indexOf("m") > -1)
        return false;
    let { $from, $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = moveSelectionBlock(view.state, dir);
        if (next && (next instanceof dist_NodeSelection))
            return apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof AllSelection ? dist_Selection.near(side, dir) : dist_Selection.findFrom(side, dir);
        return beyond ? apply(view, beyond) : false;
    }
    return false;
}
function stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof TextSelection))
        return true;
    let { $head, $anchor, empty } = view.state.selection;
    if (!$head.sameParent($anchor))
        return true;
    if (!empty)
        return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward"))
        return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0)
            tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else
            tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function safariDownArrowBug(view) {
    if (!safari || view.state.selection.$head.parentOffset > 0)
        return false;
    let { focusNode, focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
        focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        switchEditable(view, child, "true");
        setTimeout(() => switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function getMods(event) {
    let result = "";
    if (event.ctrlKey)
        result += "c";
    if (event.metaKey)
        result += "m";
    if (event.altKey)
        result += "a";
    if (event.shiftKey)
        result += "s";
    return result;
}
function captureKeyDown(view, event) {
    let code = event.keyCode, mods = getMods(event);
    if (code == 8 || (mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
        return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
    }
    else if ((code == 46 && !event.shiftKey) || (mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
        return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
    }
    else if (code == 13 || code == 27) { // Enter, Esc
        return true;
    }
    else if (code == 37 || (mac && code == 66 && mods == "c")) { // Left arrow, Ctrl-b on Mac
        let dir = code == 37 ? (findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1) : -1;
        return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
    }
    else if (code == 39 || (mac && code == 70 && mods == "c")) { // Right arrow, Ctrl-f on Mac
        let dir = code == 39 ? (findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1) : 1;
        return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
    }
    else if (code == 38 || (mac && code == 80 && mods == "c")) { // Up arrow, Ctrl-p on Mac
        return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
    }
    else if (code == 40 || (mac && code == 78 && mods == "c")) { // Down arrow, Ctrl-n on Mac
        return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
    }
    else if (mods == (mac ? "m" : "c") &&
        (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
        return true;
    }
    return false;
}

function serializeForClipboard(view, slice) {
    view.someProp("transformCopied", f => { slice = f(slice, view); });
    let context = [], { content, openStart, openEnd } = slice;
    while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
    let doc = detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, { document: doc }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
        for (let i = needsWrap.length - 1; i >= 0; i--) {
            let wrapper = doc.createElement(needsWrap[i]);
            while (wrap.firstChild)
                wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1)
        firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", f => f(slice, view)) ||
        slice.content.textBetween(0, slice.content.size, "\n\n");
    return { dom: wrap, text, slice };
}
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text)
        return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", f => { text = f(text, inCode || plainText, view); });
        if (inCode)
            return text ? new dist_Slice(dist_Fragment.from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : dist_Slice.empty;
        let parsed = view.someProp("clipboardTextParser", f => f(text, $context, plainText, view));
        if (parsed) {
            slice = parsed;
        }
        else {
            let marks = $context.marks();
            let { schema } = view.state, serializer = DOMSerializer.fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach(block => {
                let p = dom.appendChild(document.createElement("p"));
                if (block)
                    p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    }
    else {
        view.someProp("transformPastedHTML", f => { html = f(html, view); });
        dom = readHTML(html);
        if (webkit)
            restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3])
        for (let i = +sliceData[3]; i > 0; i--) {
            let child = dom.firstChild;
            while (child && child.nodeType != 1)
                child = child.nextSibling;
            if (!child)
                break;
            dom = child;
        }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || dist_DOMParser.fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode(dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling &&
                    dom.parentNode && !inlineParents.test(dom.parentNode.nodeName))
                    return { ignore: true };
                return null;
            }
        });
    }
    if (sliceData) {
        slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    }
    else { // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
        slice = dist_Slice.maxOpen(normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for (let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild) { }
            for (let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild) { }
            slice = closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", f => { slice = f(slice, view); });
    return slice;
}
const inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2)
        return fragment;
    for (let d = $context.depth; d >= 0; d--) {
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach(node => {
            if (!result)
                return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap)
                return result = null;
            if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
                result[result.length - 1] = inLast;
            }
            else {
                if (result.length)
                    result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result)
            return dist_Fragment.from(result);
    }
    return fragment;
}
function withWrappers(node, wrap, from = 0) {
    for (let i = wrap.length - 1; i >= from; i--)
        node = wrap[i].create(null, dist_Fragment.from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner)
            return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
            return sibling.copy(sibling.content.append(dist_Fragment.from(withWrappers(node, wrap, depth + 1))));
    }
}
function closeRight(node, depth) {
    if (depth == 0)
        return node;
    let fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore(dist_Fragment.empty, true);
    return node.copy(fragment.append(fill));
}
function closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1)
        openEnd = 0;
    if (depth < to - 1)
        inner = closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from)
        inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner)
            : inner.append(node.contentMatchAt(node.childCount).fillBefore(dist_Fragment.empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart)
        slice = new dist_Slice(closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd)
        slice = new dist_Slice(closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const wrapMap = {
    thead: ["table"],
    tbody: ["table"],
    tfoot: ["table"],
    caption: ["table"],
    colgroup: ["table"],
    col: ["table", "colgroup"],
    tr: ["table", "tbody"],
    td: ["table", "tbody", "tr"],
    th: ["table", "tbody", "tr"]
};
let _detachedDoc = null;
function detachedDoc() {
    return _detachedDoc || (_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let _policy = null;
function maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes)
        return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!_policy)
        _policy = trustedTypes.createPolicy("ProseMirrorClipboard", { createHTML: (s) => s });
    return _policy.createHTML(html);
}
function readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas)
        html = html.slice(metas[0].length);
    let elt = detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()])
        html = wrap.map(n => "<" + n + ">").join("") + html + wrap.map(n => "</" + n + ">").reverse().join("");
    elt.innerHTML = maybeWrapTrusted(html);
    if (wrap)
        for (let i = 0; i < wrap.length; i++)
            elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode)
            node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function addContext(slice, context) {
    if (!slice.size)
        return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    }
    catch (e) {
        return slice;
    }
    let { content, openStart, openEnd } = slice;
    for (let i = array.length - 2; i >= 0; i -= 2) {
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs())
            break;
        content = dist_Fragment.from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new dist_Slice(content, openStart, openEnd);
}

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const handlers = {};
const editHandlers = {};
const passiveHandlers = { touchstart: true, touchmove: true };
class InputState {
    constructor() {
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = { time: 0, x: 0, y: 0, type: "" };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -2e8;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function initInput(view) {
    for (let event in handlers) {
        let handler = handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event) => {
            if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
                (view.editable || !(event.type in editHandlers)))
                handler(view, event);
        }, passiveHandlers[event] ? { passive: true } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if (safari)
        view.dom.addEventListener("input", () => null);
    ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
    view.domObserver.stop();
    for (let type in view.input.eventHandlers)
        view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
    view.someProp("handleDOMEvents", currentHandlers => {
        for (let type in currentHandlers)
            if (!view.input.eventHandlers[type])
                view.dom.addEventListener(type, view.input.eventHandlers[type] = event => runCustomHandler(view, event));
    });
}
function runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", handlers => {
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function eventBelongsToView(view, event) {
    if (!event.bubbles)
        return true;
    if (event.defaultPrevented)
        return false;
    for (let node = event.target; node != view.dom; node = node.parentNode)
        if (!node || node.nodeType == 11 ||
            (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
            return false;
    return true;
}
function dispatchEvent(view, event) {
    if (!runCustomHandler(view, event) && handlers[event.type] &&
        (view.editable || !(event.type in editHandlers)))
        handlers[event.type](view, event);
}
editHandlers.keydown = (view, _event) => {
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if (inOrNearComposition(view, event))
        return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if (android && chrome && event.keyCode == 13)
        return;
    if (event.keyCode != 229)
        view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    }
    else if (view.someProp("handleKeyDown", f => f(view, event)) || captureKeyDown(view, event)) {
        event.preventDefault();
    }
    else {
        setSelectionOrigin(view, "key");
    }
};
editHandlers.keyup = (view, event) => {
    if (event.keyCode == 16)
        view.input.shiftKey = false;
};
editHandlers.keypress = (view, _event) => {
    let event = _event;
    if (inOrNearComposition(view, event) || !event.charCode ||
        event.ctrlKey && !event.altKey || mac && event.metaKey)
        return;
    if (view.someProp("handleKeyPress", f => f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", f => f(view, sel.$from.pos, sel.$to.pos, text)))
            view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function eventCoords(event) { return { left: event.clientX, top: event.clientY }; }
function isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1)
        return false;
    let $pos = view.state.doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        if (view.someProp(propName, f => i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
            : f(view, pos, $pos.node(i), $pos.before(i), event, false)))
            return true;
    }
    return false;
}
function updateSelection(view, selection, origin) {
    if (!view.focused)
        view.focus();
    if (view.state.selection.eq(selection))
        return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer")
        tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function selectClickedLeaf(view, inside) {
    if (inside == -1)
        return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && dist_NodeSelection.isSelectable(node)) {
        updateSelection(view, new dist_NodeSelection($pos), "pointer");
        return true;
    }
    return false;
}
function selectClickedNode(view, inside) {
    if (inside == -1)
        return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof dist_NodeSelection)
        selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if (dist_NodeSelection.isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 &&
                i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
                selectAt = $pos.before(sel.$from.depth);
            else
                selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        updateSelection(view, dist_NodeSelection.create(view.state.doc, selectAt), "pointer");
        return true;
    }
    else {
        return false;
    }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
    return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
        view.someProp("handleClick", f => f(view, pos, event)) ||
        (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
    return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
        view.someProp("handleDoubleClick", f => f(view, pos, event));
}
function handleTripleClick(view, pos, inside, event) {
    return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
        view.someProp("handleTripleClick", f => f(view, pos, event)) ||
        defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
    if (event.button != 0)
        return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            updateSelection(view, TextSelection.create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent)
            updateSelection(view, TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if (dist_NodeSelection.isSelectable(node))
            updateSelection(view, dist_NodeSelection.create(doc, nodePos), "pointer");
        else
            continue;
        return true;
    }
}
function forceDOMFlush(view) {
    return endComposition(view);
}
const selectNodeModifier = mac ? "metaKey" : "ctrlKey";
handlers.mousedown = (view, _event) => {
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick")
            type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick")
            type = "tripleClick";
    }
    view.input.lastClick = { time: now, x: event.clientX, y: event.clientY, type };
    let pos = view.posAtCoords(eventCoords(event));
    if (!pos)
        return;
    if (type == "singleClick") {
        if (view.input.mouseDown)
            view.input.mouseDown.done();
        view.input.mouseDown = new MouseDown(view, pos, event, !!flushed);
    }
    else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
        event.preventDefault();
    }
    else {
        setSelectionOrigin(view, "pointer");
    }
};
class MouseDown {
    constructor(view, pos, event, flushed) {
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        }
        else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection } = view.state;
        if (event.button == 0 &&
            targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
            selection instanceof dist_NodeSelection && selection.from <= targetPos && selection.to > targetPos)
            this.mightDrag = {
                node: targetNode,
                pos: targetPos,
                addAttr: !!(this.target && !this.target.draggable),
                setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
            };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr)
                this.target.draggable = true;
            if (this.mightDrag.setUneditable)
                setTimeout(() => {
                    if (this.view.input.mouseDown == this)
                        this.target.setAttribute("contentEditable", "false");
                }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr)
                this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable)
                this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync)
            setTimeout(() => selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target))
            return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc)
            pos = this.view.posAtCoords(eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) {
            setSelectionOrigin(this.view, "pointer");
        }
        else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
            event.preventDefault();
        }
        else if (event.button == 0 &&
            (this.flushed ||
                // Safari ignores clicks on draggable elements
                (safari && this.mightDrag && !this.mightDrag.node.isAtom) ||
                // Chrome will sometimes treat a node selection as a
                // cursor, but still report that the node is selected
                // when asked through getSelection. You'll then get a
                // situation where clicking at the point where that
                // (hidden) cursor is doesn't change the selection, and
                // thus doesn't get a reaction from ProseMirror. This
                // works around that.
                (chrome && !this.view.state.selection.visible &&
                    Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2))) {
            updateSelection(this.view, dist_Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        }
        else {
            setSelectionOrigin(this.view, "pointer");
        }
    }
    move(event) {
        this.updateAllowDefault(event);
        setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0)
            this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
            Math.abs(this.event.y - event.clientY) > 4))
            this.allowDefault = true;
    }
}
handlers.touchstart = view => {
    view.input.lastTouch = Date.now();
    forceDOMFlush(view);
    setSelectionOrigin(view, "pointer");
};
handlers.touchmove = view => {
    view.input.lastTouch = Date.now();
    setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = view => forceDOMFlush(view);
function inOrNearComposition(view, event) {
    if (view.composing)
        return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if (safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -2e8;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const timeoutComposition = android ? 5000 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = view => {
    if (!view.composing) {
        view.domObserver.flush();
        let { state } = view, $pos = state.selection.$to;
        if (state.selection instanceof TextSelection &&
            (state.storedMarks ||
                (!$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(m => m.type.spec.inclusive === false)))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            endComposition(view, true);
            view.markCursor = null;
        }
        else {
            endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for (let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before)
                        break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel)
                            sel.collapse(before, before.nodeValue.length);
                        break;
                    }
                    else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    scheduleComposeEnd(view, timeoutComposition);
};
editHandlers.compositionend = (view, event) => {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges)
            Promise.resolve().then(() => view.domObserver.flush());
        view.input.compositionID++;
        scheduleComposeEnd(view, 20);
    }
};
function scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1)
        view.input.composingTimeout = setTimeout(() => endComposition(view), delay);
}
function clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = timestampFromCustomEvent();
    }
    while (view.input.compositionNodes.length > 0)
        view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode)
        return null;
    let textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged)
            return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) {
            return textAfter;
        }
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue)))
                return textAfter;
        }
    }
    return textBefore || textAfter;
}
function timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/
function endComposition(view, restarting = false) {
    if (android && view.domObserver.flushingSoon >= 0)
        return;
    view.domObserver.forceFlush();
    clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection))
            view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty)
            view.dispatch(view.state.tr.deleteSelection());
        else
            view.updateState(view.state);
        return true;
    }
    return false;
}
function captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode)
        return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(() => {
        if (wrap.parentNode)
            wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const brokenClipboardAPI = (ie && ie_version < 15) ||
    (ios && webkit_version < 604);
handlers.copy = editHandlers.cut = (view, _event) => {
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty)
        return;
    // IE and Edge's clipboard interface is completely broken
    let data = brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom, text } = serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    }
    else {
        captureCopy(view, dom);
    }
    if (cut)
        view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function capturePaste(view, event) {
    if (!view.dom.parentNode)
        return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText)
        target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(() => {
        view.focus();
        if (target.parentNode)
            target.parentNode.removeChild(target);
        if (plainText)
            doPaste(view, target.value, null, plain, event);
        else
            doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function doPaste(view, text, html, preferPlain, event) {
    let slice = parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", f => f(view, event, slice || dist_Slice.empty)))
        return true;
    if (!slice)
        return false;
    let singleNode = sliceSingleNode(slice);
    let tr = singleNode
        ? view.state.tr.replaceSelectionWith(singleNode, preferPlain)
        : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text)
        return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = (view, _event) => {
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !android)
        return;
    let data = brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && doPaste(view, getText(data), data.getData("text/html"), plain, event))
        event.preventDefault();
    else
        capturePaste(view, event);
};
class Dragging {
    constructor(slice, move, node) {
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const dragCopyModifier = mac ? "altKey" : "ctrlKey";
handlers.dragstart = (view, _event) => {
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown)
        mouseDown.done();
    if (!event.dataTransfer)
        return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof dist_NodeSelection ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) {
        node = dist_NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
    }
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView)
            node = dist_NodeSelection.create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom, text, slice } = serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !chrome || chrome_version > 120)
        event.dataTransfer.clearData();
    event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!brokenClipboardAPI)
        event.dataTransfer.setData("text/plain", text);
    view.dragging = new Dragging(slice, !event[dragCopyModifier], node);
};
handlers.dragend = view => {
    let dragging = view.dragging;
    window.setTimeout(() => {
        if (view.dragging == dragging)
            view.dragging = null;
    }, 50);
};
editHandlers.dragover = editHandlers.dragenter = (_, e) => e.preventDefault();
editHandlers.drop = (view, _event) => {
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer)
        return;
    let eventPos = view.posAtCoords(eventCoords(event));
    if (!eventPos)
        return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) {
        view.someProp("transformPasted", f => { slice = f(slice, view); });
    }
    else {
        slice = parseFromClipboard(view, getText(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    }
    let move = !!(dragging && !event[dragCopyModifier]);
    if (view.someProp("handleDrop", f => f(view, event, slice || dist_Slice.empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice)
        return;
    event.preventDefault();
    let insertPos = slice ? dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null)
        insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node } = dragging;
        if (node)
            node.replace(tr);
        else
            tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode)
        tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else
        tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert))
        return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && dist_NodeSelection.isSelectable(slice.content.firstChild) &&
        $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) {
        tr.setSelection(new dist_NodeSelection($pos));
    }
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo) => end = newTo);
        tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
handlers.focus = view => {
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(() => {
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange()))
                selectionToDOM(view);
        }, 20);
    }
};
handlers.blur = (view, _event) => {
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget))
            view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
handlers.beforeinput = (view, _event) => {
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if (chrome && android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount } = view.input;
        setTimeout(() => {
            if (view.input.domChangeCount != domChangeCount)
                return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", f => f(view, keyEvent(8, "Backspace"))))
                return;
            let { $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0)
                view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for (let prop in editHandlers)
    handlers[prop] = editHandlers[prop];

function compareObjs(a, b) {
    if (a == b)
        return true;
    for (let p in a)
        if (a[p] !== b[p])
            return false;
    for (let p in b)
        if (!(p in a))
            return false;
    return true;
}
class WidgetType {
    constructor(toDOM, spec) {
        this.toDOM = toDOM;
        this.spec = spec || noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos, deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new Decoration(pos - offset, pos - offset, this);
    }
    valid() { return true; }
    eq(other) {
        return this == other ||
            (other instanceof WidgetType &&
                (this.spec.key && this.spec.key == other.spec.key ||
                    this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)));
    }
    destroy(node) {
        if (this.spec.destroy)
            this.spec.destroy(node);
    }
}
class InlineType {
    constructor(attrs, spec) {
        this.attrs = attrs;
        this.spec = spec || noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new Decoration(from, to, this);
    }
    valid(_, span) { return span.from < span.to; }
    eq(other) {
        return this == other ||
            (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
                compareObjs(this.spec, other.spec));
    }
    static is(span) { return span.type instanceof InlineType; }
    destroy() { }
}
class dist_NodeType {
    constructor(attrs, spec) {
        this.attrs = attrs;
        this.spec = spec || noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted)
            return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos)
            return null;
        return new Decoration(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index, offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other ||
            (other instanceof dist_NodeType && compareObjs(this.attrs, other.attrs) &&
                compareObjs(this.spec, other.spec));
    }
    destroy() { }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/
class Decoration {
    /**
    @internal
    */
    constructor(
    /**
    The start position of the decoration.
    */
    from, 
    /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */
    to, 
    /**
    @internal
    */
    type) {
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */
    copy(from, to) {
        return new Decoration(from, to, this.type);
    }
    /**
    @internal
    */
    eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */
    map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */
    static widget(pos, toDOM, spec) {
        return new Decoration(pos, pos, new WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */
    static inline(from, to, attrs, spec) {
        return new Decoration(from, to, new InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */
    static node(from, to, attrs, spec) {
        return new Decoration(from, to, new dist_NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */
    get spec() { return this.type.spec; }
    /**
    @internal
    */
    get inline() { return this.type instanceof InlineType; }
    /**
    @internal
    */
    get widget() { return this.type instanceof WidgetType; }
}
const none = [], noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/
class DecorationSet {
    /**
    @internal
    */
    constructor(local, children) {
        this.local = local.length ? local : none;
        this.children = children.length ? children : none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */
    static create(doc, decorations) {
        return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */
    find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for (let i = 0; i < this.local.length; i++) {
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
                result.push(span.copy(span.from + offset, span.to + offset));
        }
        for (let i = 0; i < this.children.length; i += 3) {
            if (this.children[i] < end && this.children[i + 1] > start) {
                let childOff = this.children[i] + 1;
                this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
            }
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */
    map(mapping, doc, options) {
        if (this == empty || mapping.maps.length == 0)
            return this;
        return this.mapInner(mapping, doc, 0, 0, options || noSpec);
    }
    /**
    @internal
    */
    mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for (let i = 0; i < this.local.length; i++) {
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped))
                (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove)
                options.onRemove(this.local[i].spec);
        }
        if (this.children.length)
            return mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else
            return newLocal ? new DecorationSet(newLocal.sort(byPos), none) : empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */
    add(doc, decorations) {
        if (!decorations.length)
            return this;
        if (this == empty)
            return DecorationSet.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset) => {
            let baseOffset = childOffset + offset, found;
            if (!(found = takeSpansForNode(decorations, childNode, baseOffset)))
                return;
            if (!children)
                children = this.children.slice();
            while (childIndex < children.length && children[childIndex] < childOffset)
                childIndex += 3;
            if (children[childIndex] == childOffset)
                children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else
                children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec));
            childIndex += 3;
        });
        let local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
        for (let i = 0; i < local.length; i++)
            if (!local[i].type.valid(doc, local[i]))
                local.splice(i--, 1);
        return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */
    remove(decorations) {
        if (decorations.length == 0 || this == empty)
            return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for (let i = 0; i < children.length; i += 3) {
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for (let j = 0, span; j < decorations.length; j++)
                if (span = decorations[j]) {
                    if (span.from > from && span.to < to) {
                        decorations[j] = null;
                        (found || (found = [])).push(span);
                    }
                }
            if (!found)
                continue;
            if (children == this.children)
                children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != empty) {
                children[i + 2] = removed;
            }
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length)
            for (let i = 0, span; i < decorations.length; i++)
                if (span = decorations[i]) {
                    for (let j = 0; j < local.length; j++)
                        if (local[j].eq(span, offset)) {
                            if (local == this.local)
                                local = this.local.slice();
                            local.splice(j--, 1);
                        }
                }
        if (children == this.children && local == this.local)
            return this;
        return local.length || children.length ? new DecorationSet(local, children) : empty;
    }
    forChild(offset, node) {
        if (this == empty)
            return this;
        if (node.isLeaf)
            return DecorationSet.empty;
        let child, local;
        for (let i = 0; i < this.children.length; i += 3)
            if (this.children[i] >= offset) {
                if (this.children[i] == offset)
                    child = this.children[i + 2];
                break;
            }
        let start = offset + 1, end = start + node.content.size;
        for (let i = 0; i < this.local.length; i++) {
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to)
                    (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new DecorationSet(local.sort(byPos), none);
            return child ? new DecorationGroup([localSet, child]) : localSet;
        }
        return child || empty;
    }
    /**
    @internal
    */
    eq(other) {
        if (this == other)
            return true;
        if (!(other instanceof DecorationSet) ||
            this.local.length != other.local.length ||
            this.children.length != other.children.length)
            return false;
        for (let i = 0; i < this.local.length; i++)
            if (!this.local[i].eq(other.local[i]))
                return false;
        for (let i = 0; i < this.children.length; i += 3)
            if (this.children[i] != other.children[i] ||
                this.children[i + 1] != other.children[i + 1] ||
                !this.children[i + 2].eq(other.children[i + 2]))
                return false;
        return true;
    }
    /**
    @internal
    */
    locals(node) {
        return removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */
    localsInner(node) {
        if (this == empty)
            return none;
        if (node.inlineContent || !this.local.some(InlineType.is))
            return this.local;
        let result = [];
        for (let i = 0; i < this.local.length; i++) {
            if (!(this.local[i].type instanceof InlineType))
                result.push(this.local[i]);
        }
        return result;
    }
    forEachSet(f) { f(this); }
}
/**
The empty set of decorations.
*/
DecorationSet.empty = new DecorationSet([], []);
/**
@internal
*/
DecorationSet.removeOverlap = removeOverlap;
const empty = DecorationSet.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class DecorationGroup {
    constructor(members) {
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map(member => member.map(mapping, doc, noSpec));
        return DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf)
            return DecorationSet.empty;
        let found = [];
        for (let i = 0; i < this.members.length; i++) {
            let result = this.members[i].forChild(offset, child);
            if (result == empty)
                continue;
            if (result instanceof DecorationGroup)
                found = found.concat(result.members);
            else
                found.push(result);
        }
        return DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof DecorationGroup) ||
            other.members.length != this.members.length)
            return false;
        for (let i = 0; i < this.members.length; i++)
            if (!this.members[i].eq(other.members[i]))
                return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for (let i = 0; i < this.members.length; i++) {
            let locals = this.members[i].localsInner(node);
            if (!locals.length)
                continue;
            if (!result) {
                result = locals;
            }
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for (let j = 0; j < locals.length; j++)
                    result.push(locals[j]);
            }
        }
        return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch (members.length) {
            case 0: return empty;
            case 1: return members[0];
            default: return new DecorationGroup(members.every(m => m instanceof DecorationSet) ? members :
                members.reduce((r, m) => r.concat(m instanceof DecorationSet ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for (let i = 0; i < this.members.length; i++)
            this.members[i].forEachSet(f);
    }
}
function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for (let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++) {
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd) => {
            let dSize = (newEnd - newStart) - (oldEnd - oldStart);
            for (let i = 0; i < children.length; i += 3) {
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved)
                    continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) {
                    children[i + 1] = oldStart <= start ? -2 : -1;
                }
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for (let i = 0; i < children.length; i += 3)
        if (children[i + 1] < 0) { // Touched nodes
            if (children[i + 1] == -2) {
                mustRebuild = true;
                children[i + 1] = -1;
                continue;
            }
            let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
            if (fromLocal < 0 || fromLocal >= node.content.size) {
                mustRebuild = true;
                continue;
            }
            // Must read oldChildren because children was tagged with -1
            let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
            let { index, offset: childOffset } = node.content.findIndex(fromLocal);
            let childNode = node.maybeChild(index);
            if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
                let mapped = children[i + 2]
                    .mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
                if (mapped != empty) {
                    children[i] = fromLocal;
                    children[i + 1] = toLocal;
                    children[i + 2] = mapped;
                }
                else {
                    children[i + 1] = -2;
                    mustRebuild = true;
                }
            }
            else {
                mustRebuild = true;
            }
        }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for (let i = 0; i < children.length; i += 3)
            if (children[i + 1] < 0) {
                children.splice(i, 3);
                i -= 3;
            }
        for (let i = 0, j = 0; i < built.children.length; i += 3) {
            let from = built.children[i];
            while (j < children.length && children[j] < from)
                j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset) {
    if (!offset || !spans.length)
        return spans;
    let result = [];
    for (let i = 0; i < spans.length; i++) {
        let span = spans[i];
        result.push(new Decoration(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for (let i = 0; i < set.local.length; i++) {
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped)
                decorations.push(mapped);
            else if (options.onRemove)
                options.onRemove(set.local[i].spec);
        }
        for (let i = 0; i < set.children.length; i += 3)
            gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for (let i = 0; i < children.length; i += 3)
        if (children[i + 1] == -1)
            gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function takeSpansForNode(spans, node, offset) {
    if (node.isLeaf)
        return null;
    let end = offset + node.nodeSize, found = null;
    for (let i = 0, span; i < spans.length; i++) {
        if ((span = spans[i]) && span.from > offset && span.to < end) {
            (found || (found = [])).push(span);
            spans[i] = null;
        }
    }
    return found;
}
function withoutNulls(array) {
    let result = [];
    for (let i = 0; i < array.length; i++)
        if (array[i] != null)
            result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart) => {
        let found = takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != empty)
                children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
    for (let i = 0; i < locals.length; i++)
        if (!locals[i].type.valid(node, locals[i])) {
            if (options.onRemove)
                options.onRemove(locals[i].spec);
            locals.splice(i--, 1);
        }
    return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
    let working = spans;
    for (let i = 0; i < working.length - 1; i++) {
        let span = working[i];
        if (span.from != span.to)
            for (let j = i + 1; j < working.length; j++) {
                let next = working[j];
                if (next.from == span.from) {
                    if (next.to != span.to) {
                        if (working == spans)
                            working = spans.slice();
                        // Followed by a partially overlapping larger span. Split that
                        // span.
                        working[j] = next.copy(next.from, span.to);
                        insertAhead(working, j + 1, next.copy(span.to, next.to));
                    }
                    continue;
                }
                else {
                    if (next.from < span.to) {
                        if (working == spans)
                            working = spans.slice();
                        // The end of this one overlaps with a subsequent span. Split
                        // this one.
                        working[i] = span.copy(span.from, next.from);
                        insertAhead(working, j, span.copy(next.from, span.to));
                    }
                    break;
                }
            }
    }
    return working;
}
function insertAhead(array, i, deco) {
    while (i < array.length && byPos(deco, array[i]) > 0)
        i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
    let found = [];
    view.someProp("decorations", f => {
        let result = f(view.state);
        if (result && result != empty)
            found.push(result);
    });
    if (view.cursorWrapper)
        found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
    return DecorationGroup.from(found);
}

const observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const useCharData = ie && ie_version <= 11;
class SelectionState {
    constructor() {
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset &&
            sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class DOMObserver {
    constructor(view, handleDOMChange) {
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver &&
            new window.MutationObserver(mutations => {
                for (let i = 0; i < mutations.length; i++)
                    this.queue.push(mutations[i]);
                // IE11 will sometimes (on backspacing out a single character
                // text node after a BR node) call the observer callback
                // before actually updating the DOM, which will cause
                // ProseMirror to miss the change (see #930)
                if (ie && ie_version <= 11 && mutations.some(m => m.type == "childList" && m.removedNodes.length ||
                    m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length))
                    this.flushSoon();
                else
                    this.flush();
            });
        if (useCharData) {
            this.onCharData = e => {
                this.queue.push({ target: e.target, type: "characterData", oldValue: e.prevValue });
                this.flushSoon();
            };
        }
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0)
            this.flushingSoon = window.setTimeout(() => { this.flushingSoon = -1; this.flush(); }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, observeOptions);
        }
        if (this.onCharData)
            this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for (let i = 0; i < take.length; i++)
                    this.queue.push(take[i]);
                window.setTimeout(() => this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData)
            this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(() => this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!hasFocusAndSelection(this.view))
            return;
        if (this.suppressingSelectionUpdates)
            return selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if (ie && ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
                return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode)
            return true;
        let ancestors = new Set, container;
        for (let scan = sel.focusNode; scan; scan = parentNode(scan))
            ancestors.add(scan);
        for (let scan = sel.anchorNode; scan; scan = parentNode(scan))
            if (ancestors.has(scan)) {
                container = scan;
                break;
            }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer)
            for (let mut of this.observer.takeRecords())
                this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view } = this;
        if (!view.docView || this.flushingSoon > -1)
            return;
        let mutations = this.pendingRecords();
        if (mutations.length)
            this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) {
            for (let i = 0; i < mutations.length; i++) {
                let result = this.registerMutation(mutations[i], added);
                if (result) {
                    from = from < 0 ? result.from : Math.min(result.from, from);
                    to = to < 0 ? result.to : Math.max(result.to, to);
                    if (result.typeOver)
                        typeOver = true;
                }
            }
        }
        if (gecko && added.length) {
            let brs = added.filter(n => n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode)
                    b.remove();
                else
                    a.remove();
            }
            else {
                let { focusNode } = this.currentSelection;
                for (let br of brs) {
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent))
                        br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 &&
            Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 &&
            selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) &&
            readSel.eq(dist_Selection.near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            selectionToDOM(view);
            this.currentSelection.set(sel);
        }
        else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty)
                view.updateState(view.state);
            else if (!this.currentSelection.eq(sel))
                selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1)
            return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" &&
            (desc == this.view.docView || mut.attributeName == "contenteditable" ||
                // Firefox sometimes fires spurious events for null/empty styles
                (mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))))
            return null;
        if (!desc || desc.ignoreMutation(mut))
            return null;
        if (mut.type == "childList") {
            for (let i = 0; i < mut.addedNodes.length; i++) {
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3)
                    this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target))
                return { from: desc.posBefore, to: desc.posAfter };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if (ie && ie_version <= 11 && mut.addedNodes.length) {
                // IE11 gives us incorrect next/prev siblings for some
                // insertions, so if there are added nodes, recompute those
                for (let i = 0; i < mut.addedNodes.length; i++) {
                    let { previousSibling, nextSibling } = mut.addedNodes[i];
                    if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0)
                        prev = previousSibling;
                    if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0)
                        next = nextSibling;
                }
            }
            let fromOffset = prev && prev.parentNode == mut.target
                ? domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target
                ? domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return { from, to };
        }
        else if (mut.type == "attributes") {
            return { from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border };
        }
        else { // "characterData"
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let cssChecked = new WeakMap();
let cssCheckWarned = false;
function checkCSS(view) {
    if (cssChecked.has(view))
        return;
    cssChecked.set(view, null);
    if (['normal', 'nowrap', 'pre-line'].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = gecko;
        if (cssCheckWarned)
            return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        cssCheckWarned = true;
    }
}
function rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset))
        [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
    return { anchorNode, anchorOffset, focusNode, focusOffset };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range)
            return rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? rangeToSelectionRange(view, found) : null;
}
function blockParent(view, node) {
    for (let p = node.parentNode; p && p != view.dom; p = p.parentNode) {
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock)
            return p;
    }
    return null;
}

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function parseBetween(view, from_, to_) {
    let { node: parent, fromOffset, toOffset, from, to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [{ node: anchor, offset: domSel.anchorOffset }];
        if (!selectionCollapsed(domSel))
            find.push({ node: domSel.focusNode, offset: domSel.focusOffset });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if (chrome && view.input.lastKeyCode === 8) {
        for (let off = toOffset; off > fromOffset; off--) {
            let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
            if (node.nodeName == "BR" && !desc) {
                toOffset = off;
                break;
            }
            if (!desc || desc.size)
                break;
        }
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || dist_DOMParser.fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null)
            head = anchor;
        sel = { anchor: anchor + from, head: head + from };
    }
    return { doc, sel, from, to };
}
function ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) {
        return desc.parseRule();
    }
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return { skip };
        }
        else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
            return { ignore: true };
        }
    }
    else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
        return { ignore: true };
    }
    return null;
}
const isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if (chrome && android &&
                view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime &&
                view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter"))))
                return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer")
                tr.setMeta("pointer", true);
            else if (origin == "key")
                tr.scrollIntoView();
            if (compositionID)
                tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    }
    else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change)
        view.input.domChangeCount++;
    if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) &&
        addedNodes.some(n => n.nodeType == 1 && !isInline.test(n.nodeName)) &&
        (!change || change.endA >= change.endB) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) &&
            !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
            change = { start: sel.from, endA: sel.to, endB: sel.to };
        }
        else {
            if (parse.sel) {
                let sel = resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID)
                        tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to &&
        change.start == change.endB &&
        view.state.selection instanceof TextSelection) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 &&
            view.state.selection.from >= parse.from) {
            change.start = view.state.selection.from;
        }
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 &&
            view.state.selection.to <= parse.to) {
            change.endB += (view.state.selection.to - change.endA);
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if (ie && ie_version <= 11 && change.endB == change.start + 1 &&
        change.endA == change.start && change.start > parse.from &&
        parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (((ios && view.input.lastIOSEnter > Date.now() - 225 &&
        (!inlineChange || addedNodes.some(n => n.nodeName == "DIV" || n.nodeName == "P"))) ||
        (!inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) &&
            (nextSel = dist_Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
            nextSel.head == $to.pos)) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start &&
        looksLikeBackspace(doc, change.start, change.endA, $from, $to) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(8, "Backspace")))) {
        if (android && chrome)
            view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if (chrome && change.endB == change.start)
        view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth &&
        parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(() => {
            view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) { // Deletion
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if (ie && ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(() => selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        }
        else if ( // Adding or removing a mark
        change.endA == change.endB &&
            (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add")
                tr.addMark(chFrom, chTo, markChange.mark);
            else
                tr.removeMark(chFrom, chTo, markChange.mark);
        }
        else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", f => f(view, chFrom, chTo, text)))
                return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr)
        tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !(chrome && view.composing && sel.empty &&
            (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) &&
            (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) ||
            ie && sel.empty && sel.head == chFrom))
            tr.setSelection(sel);
    }
    if (storedMarks)
        tr.ensureMarks(storedMarks);
    if (compositionID)
        tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size)
        return null;
    return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for (let i = 0; i < prevMarks.length; i++)
        added = prevMarks[i].removeFromSet(added);
    for (let i = 0; i < curMarks.length; i++)
        removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node) => node.mark(mark.addToSet(node.marks));
    }
    else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node) => node.mark(mark.removeFromSet(node.marks));
    }
    else {
        return null;
    }
    let updated = [];
    for (let i = 0; i < prev.childCount; i++)
        updated.push(update(prev.child(i)));
    if (dist_Fragment.from(updated).eq(cur))
        return { mark, type };
}
function looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if ( // The content must have shrunk
    end - start <= $newEnd.pos - $newStart.pos ||
        // newEnd must point directly at or after the end of the block that newStart points into
        skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
        return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
        return false;
    let $next = old.resolve(skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end ||
        skipClosingAndOpening($next, true, false) < end)
        return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while (next && !next.isLeaf) {
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null)
        return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && isSurrogatePair(b.textBetween(start - 1, start + 1)))
            start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    }
    else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && isSurrogatePair(a.textBetween(start - 1, start + 1)))
            start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return { start, endA, endB };
}
function isSurrogatePair(str) {
    if (str.length != 2)
        return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}

/**
@internal
*/
const __parseFromClipboard = (/* unused pure expression or super */ null && (parseFromClipboard));
/**
@internal
*/
const __endComposition = (/* unused pure expression or super */ null && (endComposition));
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/
class EditorView {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */
    constructor(place, props) {
        this._root = null;
        /**
        @internal
        */
        this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */
        this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */
        this.markCursor = null;
        /**
        @internal
        */
        this.cursorWrapper = null;
        /**
        @internal
        */
        this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */
        this.input = new InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */
        this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */
        this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach(checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = (place && place.mount) || document.createElement("div");
        if (place) {
            if (place.appendChild)
                place.appendChild(this.dom);
            else if (typeof place == "function")
                place(this.dom);
            else if (place.mount)
                this.mounted = true;
        }
        this.editable = getEditable(this);
        updateCursorWrapper(this);
        this.nodeViews = buildNodeViews(this);
        this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
        this.domObserver = new DOMObserver(this, (from, to, typeOver, added) => readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */
    get composing() { return this.input.composing; }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */
    get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for (let name in prev)
                this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */
    update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents)
            ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach(checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */
    setProps(props) {
        let updated = {};
        for (let name in this._props)
            updated[name] = this._props[name];
        updated.state = this.state;
        for (let name in props)
            updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */
    updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = buildNodeViews(this);
            if (changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) {
            ensureListeners(this);
        }
        this.editable = getEditable(this);
        updateCursorWrapper(this);
        let innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset"
            : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection))
            updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && (ie || chrome) && !this.composing &&
                !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = chrome ? (this.trackWrites = this.domSelectionRange().focusNode) : null;
                if (this.composing)
                    this.input.compositionNode = findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites)
                    forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate ||
                !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) &&
                    anchorInRightPlace(this))) {
                selectionToDOM(this, forceSelUpdate);
            }
            else {
                syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc))
            this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") {
            this.dom.scrollTop = 0;
        }
        else if (scroll == "to selection") {
            this.scrollToSelection();
        }
        else if (oldScrollPos) {
            resetScrollPos(oldScrollPos);
        }
    }
    /**
    @internal
    */
    scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", f => f(this))) ;
        else if (this.state.selection instanceof dist_NodeSelection) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1)
                scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        }
        else {
            scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
        }
    }
    destroyPluginViews() {
        let view;
        while (view = this.pluginViews.pop())
            if (view.destroy)
                view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for (let i = 0; i < this.directPlugins.length; i++) {
                let plugin = this.directPlugins[i];
                if (plugin.spec.view)
                    this.pluginViews.push(plugin.spec.view(this));
            }
            for (let i = 0; i < this.state.plugins.length; i++) {
                let plugin = this.state.plugins[i];
                if (plugin.spec.view)
                    this.pluginViews.push(plugin.spec.view(this));
            }
        }
        else {
            for (let i = 0; i < this.pluginViews.length; i++) {
                let pluginView = this.pluginViews[i];
                if (pluginView.update)
                    pluginView.update(this, prevState);
            }
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) {
            found = sel.from;
        }
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node)
                found = movedPos;
        }
        this.dragging = new Dragging(dragging.slice, dragging.move, found < 0 ? undefined : dist_NodeSelection.create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop))
            return value;
        for (let i = 0; i < this.directPlugins.length; i++) {
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop))
                return value;
        }
        let plugins = this.state.plugins;
        if (plugins)
            for (let i = 0; i < plugins.length; i++) {
                let prop = plugins[i].props[propName];
                if (prop != null && (value = f ? f(prop) : prop))
                    return value;
            }
    }
    /**
    Query whether the view has focus.
    */
    hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if (ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom)
                return true;
            if (!node || !this.dom.contains(node))
                return false;
            while (node && this.dom != node && this.dom.contains(node)) {
                if (node.contentEditable == 'false')
                    return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */
    focus() {
        this.domObserver.stop();
        if (this.editable)
            focusPreventScroll(this.dom);
        selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */
    get root() {
        let cached = this._root;
        if (cached == null)
            for (let search = this.dom.parentNode; search; search = search.parentNode) {
                if (search.nodeType == 9 || (search.nodeType == 11 && search.host)) {
                    if (!search.getSelection)
                        Object.getPrototypeOf(search).getSelection = () => search.ownerDocument.getSelection();
                    return this._root = search;
                }
            }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */
    updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */
    posAtCoords(coords) {
        return posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */
    coordsAtPos(pos, side = 1) {
        return coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */
    domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */
    nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */
    posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null)
            throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */
    endOfTextblock(dir, state) {
        return endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */
    pasteHTML(html, event) {
        return doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */
    pasteText(text, event) {
        return doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */
    serializeForClipboard(slice) {
        return serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */
    destroy() {
        if (!this.docView)
            return;
        destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], viewDecorations(this), this);
            this.dom.textContent = "";
        }
        else if (this.dom.parentNode) {
            this.dom.parentNode.removeChild(this.dom);
        }
        this.docView.destroy();
        this.docView = null;
        clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */
    get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */
    dispatchEvent(event) {
        return dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */
    dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction)
            dispatchTransaction.call(this, tr);
        else
            this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */
    domSelectionRange() {
        let sel = this.domSelection();
        if (!sel)
            return { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
        return safari && this.root.nodeType === 11 &&
            deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */
    domSelection() {
        return this.root.getSelection();
    }
}
function computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", value => {
        if (typeof value == "function")
            value = value(view.state);
        if (value)
            for (let attr in value) {
                if (attr == "class")
                    attrs.class += " " + value[attr];
                else if (attr == "style")
                    attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
                else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
                    attrs[attr] = String(value[attr]);
            }
    });
    if (!attrs.translate)
        attrs.translate = "no";
    return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = { dom, deco: Decoration.widget(view.state.selection.from, dom, { raw: true, marks: view.markCursor }) };
    }
    else {
        view.cursorWrapper = null;
    }
}
function getEditable(view) {
    return !view.someProp("editable", value => value(view.state) === false);
}
function selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for (let prop in obj)
            if (!Object.prototype.hasOwnProperty.call(result, prop))
                result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for (let prop in a) {
        if (a[prop] != b[prop])
            return true;
        nA++;
    }
    for (let _ in b)
        nB++;
    return nA != nB;
}
function checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction)
        throw new RangeError("Plugins passed directly to the view must not have a state component");
}



;// CONCATENATED MODULE: ./node_modules/w3c-keyname/index.js
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\""
}

var w3c_keyname_mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
var w3c_keyname_ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent)

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i)

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32)
  shift[i] = String.fromCharCode(i)
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code]

function keyName(event) {
  // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
  // On IE, shift effect is never included in `.key`.
  var ignoreKey = w3c_keyname_mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey ||
      w3c_keyname_ie && event.shiftKey && event.key && event.key.length == 1 ||
      event.key == "Unidentified"
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified"
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape"
  if (name == "Del") name = "Delete"
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft"
  if (name == "Up") name = "ArrowUp"
  if (name == "Right") name = "ArrowRight"
  if (name == "Down") name = "ArrowDown"
  return name
}

;// CONCATENATED MODULE: ./node_modules/prosemirror-keymap/dist/index.js



const dist_mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space")
        result = " ";
    let alt, ctrl, shift, meta;
    for (let i = 0; i < parts.length - 1; i++) {
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod))
            meta = true;
        else if (/^a(lt)?$/i.test(mod))
            alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod))
            ctrl = true;
        else if (/^s(hift)?$/i.test(mod))
            shift = true;
        else if (/^mod$/i.test(mod)) {
            if (dist_mac)
                meta = true;
            else
                ctrl = true;
        }
        else
            throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt)
        result = "Alt-" + result;
    if (ctrl)
        result = "Ctrl-" + result;
    if (meta)
        result = "Meta-" + result;
    if (shift)
        result = "Shift-" + result;
    return result;
}
function normalize(map) {
    let copy = Object.create(null);
    for (let prop in map)
        copy[normalizeKeyName(prop)] = map[prop];
    return copy;
}
function modifiers(name, event, shift = true) {
    if (event.altKey)
        name = "Alt-" + name;
    if (event.ctrlKey)
        name = "Ctrl-" + name;
    if (event.metaKey)
        name = "Meta-" + name;
    if (shift && event.shiftKey)
        name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/
function keymap(bindings) {
    return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/
function keydownHandler(bindings) {
    let map = normalize(bindings);
    return function (view, event) {
        let name = keyName(event), baseName, direct = map[modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view))
            return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view))
                    return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) &&
                (baseName = base[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view))
                    return true;
            }
        }
        return false;
    };
}



;// CONCATENATED MODULE: ./node_modules/prosemirror-commands/dist/index.js




/**
Delete the selection, if there is one.
*/
const deleteSelection = (state, dispatch) => {
    if (state.selection.empty)
        return false;
    if (dispatch)
        dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function atBlockStart(state, view) {
    let { $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state)
        : $cursor.parentOffset > 0))
        return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/
const joinBackward = (state, dispatch, view) => {
    let $cursor = atBlockStart(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && liftTarget(range);
        if (target == null)
            return false;
        if (dispatch)
            dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if (deleteBarrier(state, $cut, dispatch, -1))
        return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 &&
        (textblockAt(before, "end") || dist_NodeSelection.isSelectable(before))) {
        for (let depth = $cursor.depth;; depth--) {
            let delStep = replaceStep(state.doc, $cursor.before(depth), $cursor.after(depth), dist_Slice.empty);
            if (delStep && delStep.slice.size < delStep.to - delStep.from) {
                if (dispatch) {
                    let tr = state.tr.step(delStep);
                    tr.setSelection(textblockAt(before, "end")
                        ? dist_Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                        : dist_NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            if (depth == 1 || $cursor.node(depth - 1).childCount > 1)
                break;
        }
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch)
            dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/
const joinTextblockBackward = (state, dispatch, view) => {
    let $cursor = atBlockStart(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutBefore($cursor);
    return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/
const joinTextblockForward = (state, dispatch, view) => {
    let $cursor = atBlockEnd(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutAfter($cursor);
    return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
function joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for (; !beforeText.isTextblock; beforePos--) {
        if (beforeText.type.spec.isolating)
            return false;
        let child = beforeText.lastChild;
        if (!child)
            return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for (; !afterText.isTextblock; afterPos++) {
        if (afterText.type.spec.isolating)
            return false;
        let child = afterText.firstChild;
        if (!child)
            return false;
        afterText = child;
    }
    let step = replaceStep(state.doc, beforePos, afterPos, dist_Slice.empty);
    if (!step || step.from != beforePos ||
        step instanceof ReplaceStep && step.slice.size >= afterPos - beforePos)
        return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection(TextSelection.create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function textblockAt(node, side, only = false) {
    for (let scan = node; scan; scan = (side == "start" ? scan.firstChild : scan.lastChild)) {
        if (scan.isTextblock)
            return true;
        if (only && scan.childCount != 1)
            return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/
const selectNodeBackward = (state, dispatch, view) => {
    let { $head, empty } = state.selection, $cut = $head;
    if (!empty)
        return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0)
            return false;
        $cut = findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !dist_NodeSelection.isSelectable(node))
        return false;
    if (dispatch)
        dispatch(state.tr.setSelection(dist_NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating)
        for (let i = $pos.depth - 1; i >= 0; i--) {
            if ($pos.index(i) > 0)
                return $pos.doc.resolve($pos.before(i + 1));
            if ($pos.node(i).type.spec.isolating)
                break;
        }
    return null;
}
function atBlockEnd(state, view) {
    let { $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state)
        : $cursor.parentOffset < $cursor.parent.content.size))
        return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/
const joinForward = (state, dispatch, view) => {
    let $cursor = atBlockEnd(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut)
        return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if (deleteBarrier(state, $cut, dispatch, 1))
        return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 &&
        (textblockAt(after, "start") || dist_NodeSelection.isSelectable(after))) {
        let delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), dist_Slice.empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection(textblockAt(after, "start") ? dist_Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                    : dist_NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch)
            dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/
const selectNodeForward = (state, dispatch, view) => {
    let { $head, empty } = state.selection, $cut = $head;
    if (!empty)
        return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size)
            return false;
        $cut = findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !dist_NodeSelection.isSelectable(node))
        return false;
    if (dispatch)
        dispatch(state.tr.setSelection(dist_NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating)
        for (let i = $pos.depth - 1; i >= 0; i--) {
            let parent = $pos.node(i);
            if ($pos.index(i) + 1 < parent.childCount)
                return $pos.doc.resolve($pos.after(i + 1));
            if (parent.type.spec.isolating)
                break;
        }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/
const joinUp = (state, dispatch) => {
    let sel = state.selection, nodeSel = sel instanceof dist_NodeSelection, point;
    if (nodeSel) {
        if (sel.node.isTextblock || !dist_canJoin(state.doc, sel.from))
            return false;
        point = sel.from;
    }
    else {
        point = joinPoint(state.doc, sel.from, -1);
        if (point == null)
            return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel)
            tr.setSelection(dist_NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/
const joinDown = (state, dispatch) => {
    let sel = state.selection, point;
    if (sel instanceof dist_NodeSelection) {
        if (sel.node.isTextblock || !dist_canJoin(state.doc, sel.to))
            return false;
        point = sel.to;
    }
    else {
        point = joinPoint(state.doc, sel.to, 1);
        if (point == null)
            return false;
    }
    if (dispatch)
        dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/
const dist_lift = (state, dispatch) => {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to), target = range && liftTarget(range);
    if (target == null)
        return false;
    if (dispatch)
        dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/
const newlineInCode = (state, dispatch) => {
    let { $head, $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
        return false;
    if (dispatch)
        dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function defaultBlockAt(match) {
    for (let i = 0; i < match.edgeCount; i++) {
        let { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs())
            return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/
const exitCode = (state, dispatch) => {
    let { $head, $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
        return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type))
        return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection(dist_Selection.near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/
const createParagraphNear = (state, dispatch) => {
    let sel = state.selection, { $from, $to } = sel;
    if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent)
        return false;
    let type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock)
        return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection(TextSelection.create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/
const liftEmptyBlock = (state, dispatch) => {
    let { $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size)
        return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if (dist_canSplit(state.doc, before)) {
            if (dispatch)
                dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && liftTarget(range);
    if (target == null)
        return false;
    if (dispatch)
        dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/
function splitBlockAs(splitNode) {
    return (state, dispatch) => {
        let { $from, $to } = state.selection;
        if (state.selection instanceof dist_NodeSelection && state.selection.node.isBlock) {
            if (!$from.parentOffset || !dist_canSplit(state.doc, $from.pos))
                return false;
            if (dispatch)
                dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth)
            return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for (let d = $from.depth;; d--) {
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? { type: deflt } : null));
                splitDepth = d;
                break;
            }
            else {
                if (d == 1)
                    return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof TextSelection || state.selection instanceof AllSelection)
            tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = dist_canSplit(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? { type: deflt } : null;
            can = dist_canSplit(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt))
                tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch)
            dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/
const splitBlock = splitBlockAs();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/
const splitBlockKeepMarks = (state, dispatch) => {
    return splitBlock(state, dispatch && (tr => {
        let marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
        if (marks)
            tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/
const selectParentNode = (state, dispatch) => {
    let { $from, to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0)
        return false;
    pos = $from.before(same);
    if (dispatch)
        dispatch(state.tr.setSelection(dist_NodeSelection.create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/
const selectAll = (state, dispatch) => {
    if (dispatch)
        dispatch(state.tr.setSelection(new AllSelection(state.doc)));
    return true;
};
function joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type))
        return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch)
            dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || dist_canJoin(state.doc, $pos.pos)))
        return false;
    if (dispatch)
        dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && joinMaybeClear(state, $cut, dispatch))
        return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter &&
        (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
        match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = dist_Fragment.empty;
            for (let i = conn.length - 1; i >= 0; i--)
                wrap = dist_Fragment.from(conn[i].create(null, wrap));
            wrap = dist_Fragment.from(before.copy(wrap));
            let tr = state.tr.step(new ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new dist_Slice(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type &&
                dist_canJoin(tr.doc, $joinAt.pos))
                tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || (dir > 0 && isolated) ? null : dist_Selection.findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch)
            dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
        let at = before, wrap = [];
        for (;;) {
            wrap.push(at);
            if (at.isTextblock)
                break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for (; !afterText.isTextblock; afterText = afterText.firstChild)
            afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = dist_Fragment.empty;
                for (let i = wrap.length - 1; i >= 0; i--)
                    end = dist_Fragment.from(wrap[i].copy(end));
                let tr = state.tr.step(new ReplaceAroundStep($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new dist_Slice(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function selectTextblockSide(side) {
    return function (state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while ($pos.node(depth).isInline) {
            if (!depth)
                return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock)
            return false;
        if (dispatch)
            dispatch(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/
const selectTextblockStart = selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/
const selectTextblockEnd = selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/
function wrapIn(nodeType, attrs = null) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && findWrapping(range, nodeType, attrs);
        if (!wrapping)
            return false;
        if (dispatch)
            dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/
function dist_setBlockType(nodeType, attrs = null) {
    return function (state, dispatch) {
        let applicable = false;
        for (let i = 0; i < state.selection.ranges.length && !applicable; i++) {
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos) => {
                if (applicable)
                    return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs))
                    return;
                if (node.type == nodeType) {
                    applicable = true;
                }
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable)
            return false;
        if (dispatch) {
            let tr = state.tr;
            for (let i = 0; i < state.selection.ranges.length; i++) {
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function markApplies(doc, ranges, type, enterAtoms) {
    for (let i = 0; i < ranges.length; i++) {
        let { $from, $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos)
                return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can)
            return true;
    }
    return false;
}
function removeInlineAtoms(ranges) {
    let result = [];
    for (let i = 0; i < ranges.length; i++) {
        let { $from, $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos)
                    result.push(new SelectionRange($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos)
            result.push(new SelectionRange($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/
function toggleMark(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function (state, dispatch) {
        let { empty, $cursor, ranges } = state.selection;
        if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType, enterAtoms))
            return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks()))
                    dispatch(state.tr.removeStoredMark(markType));
                else
                    dispatch(state.tr.addStoredMark(markType.create(attrs)));
            }
            else {
                let add, tr = state.tr;
                if (!enterAtoms)
                    ranges = removeInlineAtoms(ranges);
                if (removeWhenPresent) {
                    add = !ranges.some(r => state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                }
                else {
                    add = !ranges.every(r => {
                        let missing = false;
                        tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent) => {
                            if (missing)
                                return false;
                            missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) &&
                                !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                        });
                        return !missing;
                    });
                }
                for (let i = 0; i < ranges.length; i++) {
                    let { $from, $to } = ranges[i];
                    if (!add) {
                        tr.removeMark($from.pos, $to.pos, markType);
                    }
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr) => {
        if (!tr.isGeneric)
            return dispatch(tr);
        let ranges = [];
        for (let i = 0; i < tr.mapping.maps.length; i++) {
            let map = tr.mapping.maps[i];
            for (let j = 0; j < ranges.length; j++)
                ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to) => ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for (let i = 0; i < ranges.length; i += 2) {
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for (let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
                let after = parent.maybeChild(index);
                if (!after)
                    break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after))
                        joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b) => a - b);
        for (let i = joinable.length - 1; i >= 0; i--) {
            if (canJoin(tr.doc, joinable[i]))
                tr.join(joinable[i]);
        }
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/
function autoJoin(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node) => isJoinable.indexOf(node.type.name) > -1
        : isJoinable;
    return (state, dispatch, view) => command(state, dispatch && wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/
function chainCommands(...commands) {
    return function (state, dispatch, view) {
        for (let i = 0; i < commands.length; i++)
            if (commands[i](state, dispatch, view))
                return true;
        return false;
    };
}
let backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
let del = chainCommands(deleteSelection, joinForward, selectNodeForward);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/
const pcBaseKeymap = {
    "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
    "Mod-Enter": exitCode,
    "Backspace": backspace,
    "Mod-Backspace": backspace,
    "Shift-Backspace": backspace,
    "Delete": del,
    "Mod-Delete": del,
    "Mod-a": selectAll
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/
const macBaseKeymap = {
    "Ctrl-h": pcBaseKeymap["Backspace"],
    "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
    "Ctrl-d": pcBaseKeymap["Delete"],
    "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
    "Alt-Delete": pcBaseKeymap["Mod-Delete"],
    "Alt-d": pcBaseKeymap["Mod-Delete"],
    "Ctrl-a": selectTextblockStart,
    "Ctrl-e": selectTextblockEnd
};
for (let key in pcBaseKeymap)
    macBaseKeymap[key] = pcBaseKeymap[key];
const prosemirror_commands_dist_mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform)
    // @ts-ignore
    : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/
const baseKeymap = (/* unused pure expression or super */ null && (prosemirror_commands_dist_mac ? macBaseKeymap : pcBaseKeymap));



;// CONCATENATED MODULE: ./node_modules/prosemirror-schema-list/dist/index.js




const olDOM = ["ol", 0], ulDOM = ["ul", 0], liDOM = ["li", 0];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/
const orderedList = {
    attrs: { order: { default: 1, validate: "number" } },
    parseDOM: [{ tag: "ol", getAttrs(dom) {
                return { order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1 };
            } }],
    toDOM(node) {
        return node.attrs.order == 1 ? olDOM : ["ol", { start: node.attrs.order }, 0];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/
const bulletList = {
    parseDOM: [{ tag: "ul" }],
    toDOM() { return ulDOM; }
};
/**
A list item (`<li>`) spec.
*/
const listItem = {
    parseDOM: [{ tag: "li" }],
    toDOM() { return liDOM; },
    defining: true
};
function add(obj, props) {
    let copy = {};
    for (let prop in obj)
        copy[prop] = obj[prop];
    for (let prop in props)
        copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/
function addListNodes(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: add(orderedList, { content: "list_item+", group: listGroup }),
        bullet_list: add(bulletList, { content: "list_item+", group: listGroup }),
        list_item: add(listItem, { content: itemContent })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/
function wrapInList(listType, attrs = null) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to);
        if (!range)
            return false;
        let tr = dispatch ? state.tr : null;
        if (!wrapRangeInList(tr, range, listType, attrs))
            return false;
        if (dispatch)
            dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Try to wrap the given node range in a list of the given type.
Return `true` when this is possible, `false` otherwise. When `tr`
is non-null, the wrapping is added to that transaction. When it is
`null`, the function only queries whether the wrapping is
possible.
*/
function wrapRangeInList(tr, range, listType, attrs = null) {
    let doJoin = false, outerRange = range, doc = range.$from.doc;
    // This is at the top of an existing list item
    if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
        // Don't do anything if this is the top of the list
        if (range.$from.index(range.depth - 1) == 0)
            return false;
        let $insert = doc.resolve(range.start - 2);
        outerRange = new NodeRange($insert, $insert, range.depth);
        if (range.endIndex < range.parent.childCount)
            range = new NodeRange(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
        doJoin = true;
    }
    let wrap = findWrapping(outerRange, listType, attrs, range);
    if (!wrap)
        return false;
    if (tr)
        doWrapInList(tr, range, wrap, doJoin, listType);
    return true;
}
function doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = dist_Fragment.empty;
    for (let i = wrappers.length - 1; i >= 0; i--)
        content = dist_Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new dist_Slice(content, 0, 0), wrappers.length, true));
    let found = 0;
    for (let i = 0; i < wrappers.length; i++)
        if (wrappers[i].type == listType)
            found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for (let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false) {
        if (!first && dist_canSplit(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/
function splitListItem(itemType, itemAttrs) {
    return function (state, dispatch) {
        let { $from, $to, node } = state.selection;
        if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to))
            return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType)
            return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType ||
                $from.index(-2) != $from.node(-2).childCount - 1)
                return false;
            if (dispatch) {
                let wrap = Fragment.empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)
                    wrap = Fragment.from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1
                    : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append(Fragment.from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos) => {
                    if (sel > -1)
                        return false;
                    if (node.isTextblock && node.content.size == 0)
                        sel = pos + 1;
                });
                if (sel > -1)
                    tr.setSelection(Selection.near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [itemAttrs ? { type: itemType, attrs: itemAttrs } : null, { type: nextType }] : undefined;
        if (!canSplit(tr.doc, $from.pos, 2, types))
            return false;
        if (dispatch)
            dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/
function splitListItemKeepMarks(itemType, itemAttrs) {
    let split = splitListItem(itemType, itemAttrs);
    return (state, dispatch) => {
        return split(state, dispatch && (tr => {
            let marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
            if (marks)
                tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/
function liftListItem(itemType) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to, node => node.childCount > 0 && node.firstChild.type == itemType);
        if (!range)
            return false;
        if (!dispatch)
            return true;
        if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
            return liftToOuterList(state, dispatch, itemType, range);
        else // Outer list node
            return liftOutOfList(state, dispatch, range);
    };
}
function liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new ReplaceAroundStep(end - 1, endOfList, end, endOfList, new dist_Slice(dist_Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = liftTarget(range);
    if (target == null)
        return false;
    tr.lift(range, target);
    let after = tr.mapping.map(end, -1) - 1;
    if (dist_canJoin(tr.doc, after))
        tr.join(after);
    dispatch(tr.scrollIntoView());
    return true;
}
function liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize)
        return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? dist_Fragment.empty : dist_Fragment.from(list))))
        return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new dist_Slice((atStart ? dist_Fragment.empty : dist_Fragment.from(list.copy(dist_Fragment.empty)))
        .append(atEnd ? dist_Fragment.empty : dist_Fragment.from(list.copy(dist_Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/
function sinkListItem(itemType) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to, node => node.childCount > 0 && node.firstChild.type == itemType);
        if (!range)
            return false;
        let startIndex = range.startIndex;
        if (startIndex == 0)
            return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType)
            return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = dist_Fragment.from(nestedBefore ? itemType.create() : null);
            let slice = new dist_Slice(dist_Fragment.from(itemType.create(null, dist_Fragment.from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true))
                .scrollIntoView());
        }
        return true;
    };
}



;// CONCATENATED MODULE: ./node_modules/@tiptap/core/dist/index.js








/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */
function createChainableState(config) {
    const { state, transaction } = config;
    let { selection } = transaction;
    let { doc } = transaction;
    let { storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks() {
            return storedMarks;
        },
        get selection() {
            return selection;
        },
        get doc() {
            return doc;
        },
        get tr() {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        },
    };
}

class CommandManager {
    constructor(props) {
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const { tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            const method = (...args) => {
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) {
                    view.dispatch(tr);
                }
                return callback;
            };
            return [name, method];
        }));
    }
    get chain() {
        return () => this.createChain();
    }
    get can() {
        return () => this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = () => {
            if (!hasStartTransaction
                && shouldDispatch
                && !tr.getMeta('preventDispatch')
                && !this.hasCustomState) {
                view.dispatch(tr);
            }
            return callbacks.every(callback => callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                const chainedCommand = (...args) => {
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [name, chainedCommand];
            })),
            run,
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands, state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            return [name, (...args) => command(...args)({ ...props, dispatch: undefined })];
        }));
        return {
            ...formattedCommands,
            chain: () => this.createChain(tr, dispatch),
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const props = {
            tr,
            editor,
            view,
            state: createChainableState({
                state,
                transaction: tr,
            }),
            dispatch: shouldDispatch ? () => undefined : undefined,
            chain: () => this.createChain(tr, shouldDispatch),
            can: () => this.createCan(tr),
            get commands() {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                    return [name, (...args) => command(...args)(props)];
                }));
            },
        };
        return props;
    }
}

class EventEmitter {
    constructor() {
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            callbacks.forEach(callback => callback.apply(this, args));
        }
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) {
                this.callbacks[event] = callbacks.filter(callback => callback !== fn);
            }
            else {
                delete this.callbacks[event];
            }
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args) => {
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}

/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */
function getExtensionField(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) {
        return getExtensionField(extension.parent, field, context);
    }
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent
                ? getExtensionField(extension.parent, field, context)
                : null,
        });
        return value;
    }
    return extension.config[field];
}

function splitExtensions(extensions) {
    const baseExtensions = extensions.filter(extension => extension.type === 'extension');
    const nodeExtensions = extensions.filter(extension => extension.type === 'node');
    const markExtensions = extensions.filter(extension => extension.type === 'mark');
    return {
        baseExtensions,
        nodeExtensions,
        markExtensions,
    };
}

/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */
function getAttributesFromExtensions(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false,
    };
    extensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions,
        };
        const addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) {
            return;
        }
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach(globalAttribute => {
            globalAttribute.types.forEach(type => {
                Object
                    .entries(globalAttribute.attributes)
                    .forEach(([name, attribute]) => {
                    extensionAttributes.push({
                        type,
                        name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute,
                        },
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const addAttributes = getExtensionField(extension, 'addAttributes', context);
        if (!addAttributes) {
            return;
        }
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object
            .entries(attributes)
            .forEach(([name, attribute]) => {
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute,
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') {
                mergedAttr.default = mergedAttr.default();
            }
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) {
                delete mergedAttr.default;
            }
            extensionAttributes.push({
                type: extension.name,
                name,
                attribute: mergedAttr,
            });
        });
    });
    return extensionAttributes;
}

function getNodeType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) {
            throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}

function mergeAttributes(...objects) {
    return objects
        .filter(item => !!item)
        .reduce((items, item) => {
        const mergedAttributes = { ...items };
        Object.entries(item).forEach(([key, value]) => {
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                const valueClasses = value ? String(value).split(' ') : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
                const insertClasses = valueClasses.filter(valueClass => !existingClasses.includes(valueClass));
                mergedAttributes[key] = [...existingClasses, ...insertClasses].join(' ');
            }
            else if (key === 'style') {
                const newStyles = value ? value.split(';').map((style) => style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map((style) => style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val]) => `${property}: ${val}`).join('; ');
            }
            else {
                mergedAttributes[key] = value;
            }
        });
        return mergedAttributes;
    }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
    return extensionAttributes
        .filter(attribute => attribute.type === nodeOrMark.type.name)
        .filter(item => item.attribute.rendered)
        .map(item => {
        if (!item.attribute.renderHTML) {
            return {
                [item.name]: nodeOrMark.attrs[item.name],
            };
        }
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    })
        .reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function dist_isFunction(value) {
    return typeof value === 'function';
}

/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */
function callOrReturn(value, context = undefined, ...props) {
    if (dist_isFunction(value)) {
        if (context) {
            return value.bind(context)(...props);
        }
        return value(...props);
    }
    return value;
}

function isEmptyObject(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
        return Number(value);
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return value;
}

/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
    if ('style' in parseRule) {
        return parseRule;
    }
    return {
        ...parseRule,
        getAttrs: (node) => {
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) {
                return false;
            }
            const newAttributes = extensionAttributes.reduce((items, item) => {
                const value = item.attribute.parseHTML
                    ? item.attribute.parseHTML(node)
                    : fromString((node).getAttribute(item.name));
                if (value === null || value === undefined) {
                    return items;
                }
                return {
                    ...items,
                    [item.name]: value,
                };
            }, {});
            return { ...oldAttributes, ...newAttributes };
        },
    };
}

function cleanUpSchemaItem(data) {
    return Object.fromEntries(
    // @ts-ignore
    Object.entries(data).filter(([key, value]) => {
        if (key === 'attrs' && isEmptyObject(value)) {
            return false;
        }
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */
function getSchemaByResolvedExtensions(extensions, editor) {
    var _a;
    const allAttributes = getAttributesFromExtensions(extensions);
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const topNode = (_a = nodeExtensions.find(extension => getExtensionField(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraNodeFields = extensions.reduce((fields, e) => {
            const extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...(extendNodeSchema ? extendNodeSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraNodeFields,
            content: callOrReturn(getExtensionField(extension, 'content', context)),
            marks: callOrReturn(getExtensionField(extension, 'marks', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            inline: callOrReturn(getExtensionField(extension, 'inline', context)),
            atom: callOrReturn(getExtensionField(extension, 'atom', context)),
            selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
            draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            whitespace: callOrReturn(getExtensionField(extension, 'whitespace', context)),
            linebreakReplacement: callOrReturn(getExtensionField(extension, 'linebreakReplacement', context)),
            defining: callOrReturn(getExtensionField(extension, 'defining', context)),
            isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = node => renderHTML({
                node,
                HTMLAttributes: getRenderedAttributes(node, extensionAttributes),
            });
        }
        const renderText = getExtensionField(extension, 'renderText', context);
        if (renderText) {
            schema.toText = renderText;
        }
        return [extension.name, schema];
    }));
    const marks = Object.fromEntries(markExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraMarkFields = extensions.reduce((fields, e) => {
            const extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...(extendMarkSchema ? extendMarkSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
            excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = mark => renderHTML({
                mark,
                HTMLAttributes: getRenderedAttributes(mark, extensionAttributes),
            });
        }
        return [extension.name, schema];
    }));
    return new Schema({
        topNode,
        nodes,
        marks,
    });
}

/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */
function getSchemaTypeByName(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
    if (Array.isArray(enabled)) {
        return enabled.some(enabledExtension => {
            const name = typeof enabledExtension === 'string'
                ? enabledExtension
                : enabledExtension.name;
            return name === extension.name;
        });
    }
    return enabled;
}

function getHTMLFromFragment(fragment, schema) {
    const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}

/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */
const getTextContentFromNodes = ($from, maxMatch = 500) => {
    let textBefore = '';
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index) => {
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node,
            pos,
            parent,
            index,
        }))
            || node.textContent
            || '%leaf%';
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};

function isRegExp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}

class InputRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const inputRuleMatcherHandler = (text, find) => {
    if (isRegExp(find)) {
        return find.exec(text);
    }
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) {
        return null;
    }
    const result = [inputRuleMatch.text];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
            console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        }
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function run$1(config) {
    var _a;
    const { editor, from, to, text, rules, plugin, } = config;
    const { view } = editor;
    if (view.composing) {
        return false;
    }
    const $from = view.state.doc.resolve(from);
    if (
    // check for code node
    $from.parent.type.spec.code
        // check for code mark
        || !!((_a = ($from.nodeBefore || $from.nodeAfter)) === null || _a === void 0 ? void 0 : _a.marks.find(mark => mark.type.spec.code))) {
        return false;
    }
    let matched = false;
    const textBefore = getTextContentFromNodes($from) + text;
    rules.forEach(rule => {
        if (matched) {
            return;
        }
        const match = inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) {
            return;
        }
        const tr = view.state.tr;
        const state = createChainableState({
            state: view.state,
            transaction: tr,
        });
        const range = {
            from: from - (match[0].length - text.length),
            to,
        };
        const { commands, chain, can } = new CommandManager({
            editor,
            state,
        });
        const handler = rule.handler({
            state,
            range,
            match,
            commands,
            chain,
            can,
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) {
            return;
        }
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from,
            to,
            text,
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */
function inputRulesPlugin(props) {
    const { editor, rules } = props;
    const plugin = new Plugin({
        state: {
            init() {
                return null;
            },
            apply(tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) {
                    return stored;
                }
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta('applyInputRules');
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) {
                    setTimeout(() => {
                        let { text } = simulatedInputMeta;
                        if (typeof text === 'string') {
                            text = text;
                        }
                        else {
                            text = getHTMLFromFragment(dist_Fragment.from(text), state.schema);
                        }
                        const { from } = simulatedInputMeta;
                        const to = from + text.length;
                        run$1({
                            editor,
                            from,
                            to,
                            text,
                            rules,
                            plugin,
                        });
                    });
                }
                return tr.selectionSet || tr.docChanged ? null : prev;
            },
        },
        props: {
            handleTextInput(view, from, to, text) {
                return run$1({
                    editor,
                    from,
                    to,
                    text,
                    rules,
                    plugin,
                });
            },
            handleDOMEvents: {
                compositionend: view => {
                    setTimeout(() => {
                        const { $cursor } = view.state.selection;
                        if ($cursor) {
                            run$1({
                                editor,
                                from: $cursor.pos,
                                to: $cursor.pos,
                                text: '',
                                rules,
                                plugin,
                            });
                        }
                    });
                    return false;
                },
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown(view, event) {
                if (event.key !== 'Enter') {
                    return false;
                }
                const { $cursor } = view.state.selection;
                if ($cursor) {
                    return run$1({
                        editor,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: '\n',
                        rules,
                        plugin,
                    });
                }
                return false;
            },
        },
        // @ts-ignore
        isInputRules: true,
    });
    return plugin;
}

// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject(value) {
    if (getType(value) !== 'Object') {
        return false;
    }
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
    const output = { ...target };
    if (isPlainObject(target) && isPlainObject(source)) {
        Object.keys(source).forEach(key => {
            if (isPlainObject(source[key]) && isPlainObject(target[key])) {
                output[key] = mergeDeep(target[key], source[key]);
            }
            else {
                output[key] = source[key];
            }
        });
    }
    return output;
}

/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class dist_Mark {
    constructor(config = {}) {
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new dist_Mark(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new dist_Mark(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    static handleExit({ editor, mark }) {
        const { tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) {
                return false;
            }
            const removeMark = currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) {
                tr.removeStoredMark(removeMark);
            }
            tr.insertText(' ', currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}

function dist_isNumber(value) {
    return typeof value === 'number';
}

/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
class PasteRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const pasteRuleMatcherHandler = (text, find, event) => {
    if (isRegExp(find)) {
        return [...text.matchAll(find)];
    }
    const matches = find(text, event);
    if (!matches) {
        return [];
    }
    return matches.map(pasteRuleMatch => {
        const result = [pasteRuleMatch.text];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
                console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            }
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function run(config) {
    const { editor, state, from, to, rule, pasteEvent, dropEvent, } = config;
    const { commands, chain, can } = new CommandManager({
        editor,
        state,
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isTextblock || node.type.spec.code) {
            return;
        }
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach(match => {
            if (match.index === undefined) {
                return;
            }
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end),
            };
            const handler = rule.handler({
                state,
                range,
                match,
                commands,
                chain,
                can,
                pasteEvent,
                dropEvent,
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every(handler => handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let tiptapDragFromOtherEditor = null;
const createClipboardPasteEvent = (text) => {
    var _a;
    const event = new ClipboardEvent('paste', {
        clipboardData: new DataTransfer(),
    });
    (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */
function pasteRulesPlugin(props) {
    const { editor, rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    }
    catch {
        dropEvent = null;
    }
    const processEvent = ({ state, from, to, rule, pasteEvt, }) => {
        const tr = state.tr;
        const chainableState = createChainableState({
            state,
            transaction: tr,
        });
        const handler = run({
            editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule,
            pasteEvent: pasteEvt,
            dropEvent,
        });
        if (!handler || !tr.steps.length) {
            return;
        }
        try {
            dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
        }
        catch {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
        return tr;
    };
    const plugins = rules.map(rule => {
        return new Plugin({
            // we register a global drag handler to track the current drag source element
            view(view) {
                const handleDragstart = (event) => {
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))
                        ? view.dom.parentElement
                        : null;
                    if (dragSourceElement) {
                        tiptapDragFromOtherEditor = editor;
                    }
                };
                const handleDragend = () => {
                    if (tiptapDragFromOtherEditor) {
                        tiptapDragFromOtherEditor = null;
                    }
                };
                window.addEventListener('dragstart', handleDragstart);
                window.addEventListener('dragend', handleDragend);
                return {
                    destroy() {
                        window.removeEventListener('dragstart', handleDragstart);
                        window.removeEventListener('dragend', handleDragend);
                    },
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event) => {
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor) {
                                // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                                setTimeout(() => {
                                    const selection = dragFromOtherEditor.state.selection;
                                    if (selection) {
                                        dragFromOtherEditor.commands.deleteRange({ from: selection.from, to: selection.to });
                                    }
                                }, 10);
                            }
                        }
                        return false;
                    },
                    paste: (_view, event) => {
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    },
                },
            },
            appendTransaction: (transactions, oldState, state) => {
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta('applyPasteRules');
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) {
                    return;
                }
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text } = simulatedPasteMeta;
                    if (typeof text === 'string') {
                        text = text;
                    }
                    else {
                        text = getHTMLFromFragment(dist_Fragment.from(text), state.schema);
                    }
                    const { from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = createClipboardPasteEvent(text);
                    return processEvent({
                        rule,
                        state,
                        from,
                        to: { b: to },
                        pasteEvt,
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!dist_isNumber(from) || !to || from === to.b) {
                    return;
                }
                return processEvent({
                    rule,
                    state,
                    from,
                    to,
                    pasteEvt: pasteEvent,
                });
            },
        });
    });
    return plugins;
}

function findDuplicates(items) {
    const filtered = items.filter((el, index) => items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}

class ExtensionManager {
    constructor(extensions, editor) {
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = ExtensionManager.resolve(extensions);
        this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */
    static resolve(extensions) {
        const resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
        const duplicatedNames = findDuplicates(resolvedExtensions.map(extension => extension.name));
        if (duplicatedNames.length) {
            console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames
                .map(item => `'${item}'`)
                .join(', ')}]. This can lead to issues.`);
        }
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */
    static flatten(extensions) {
        return (extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
            };
            const addExtensions = getExtensionField(extension, 'addExtensions', context);
            if (addExtensions) {
                return [extension, ...this.flatten(addExtensions())];
            }
            return extension;
        })
            // `Infinity` will break TypeScript so we set a number that is probably high enough
            .flat(10));
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */
    static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b) => {
            const priorityA = getExtensionField(a, 'priority') || defaultPriority;
            const priorityB = getExtensionField(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) {
                return -1;
            }
            if (priorityA < priorityB) {
                return 1;
            }
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */
    get commands() {
        return this.extensions.reduce((commands, extension) => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const addCommands = getExtensionField(extension, 'addCommands', context);
            if (!addCommands) {
                return commands;
            }
            return {
                ...commands,
                ...addCommands(),
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */
    get plugins() {
        const { editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = ExtensionManager.sort([...this.extensions].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const plugins = [];
            const addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === 'mark' && getExtensionField(extension, 'exitable', context)) {
                defaultBindings.ArrowRight = () => dist_Mark.handleExit({ editor, mark: extension });
            }
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method]) => {
                    return [shortcut, () => method({ editor })];
                }));
                defaultBindings = { ...defaultBindings, ...bindings };
            }
            const keyMapPlugin = keymap(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = getExtensionField(extension, 'addInputRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
                inputRules.push(...addInputRules());
            }
            const addPasteRules = getExtensionField(extension, 'addPasteRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
                pasteRules.push(...addPasteRules());
            }
            const addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        })
            .flat();
        return [
            inputRulesPlugin({
                editor,
                rules: inputRules,
            }),
            ...pasteRulesPlugin({
                editor,
                rules: pasteRules,
            }),
            ...allPlugins,
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */
    get attributes() {
        return getAttributesFromExtensions(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */
    get nodeViews() {
        const { editor } = this;
        const { nodeExtensions } = splitExtensions(this.extensions);
        return Object.fromEntries(nodeExtensions
            .filter(extension => !!getExtensionField(extension, 'addNodeView'))
            .map(extension => {
            const extensionAttributes = this.attributes.filter(attribute => attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getNodeType(extension.name, this.schema),
            };
            const addNodeView = getExtensionField(extension, 'addNodeView', context);
            if (!addNodeView) {
                return [];
            }
            const nodeview = (node, view, getPos, decorations, innerDecorations) => {
                const HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
                return addNodeView()({
                    // pass-through
                    node,
                    view,
                    getPos: getPos,
                    decorations,
                    innerDecorations,
                    // tiptap-specific
                    editor,
                    extension,
                    HTMLAttributes,
                });
            };
            return [extension.name, nodeview];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */
    setupExtensions() {
        this.extensions.forEach(extension => {
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) {
                    this.splittableMarks.push(extension.name);
                }
            }
            const onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);
            const onCreate = getExtensionField(extension, 'onCreate', context);
            const onUpdate = getExtensionField(extension, 'onUpdate', context);
            const onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);
            const onTransaction = getExtensionField(extension, 'onTransaction', context);
            const onFocus = getExtensionField(extension, 'onFocus', context);
            const onBlur = getExtensionField(extension, 'onBlur', context);
            const onDestroy = getExtensionField(extension, 'onDestroy', context);
            if (onBeforeCreate) {
                this.editor.on('beforeCreate', onBeforeCreate);
            }
            if (onCreate) {
                this.editor.on('create', onCreate);
            }
            if (onUpdate) {
                this.editor.on('update', onUpdate);
            }
            if (onSelectionUpdate) {
                this.editor.on('selectionUpdate', onSelectionUpdate);
            }
            if (onTransaction) {
                this.editor.on('transaction', onTransaction);
            }
            if (onFocus) {
                this.editor.on('focus', onFocus);
            }
            if (onBlur) {
                this.editor.on('blur', onBlur);
            }
            if (onDestroy) {
                this.editor.on('destroy', onDestroy);
            }
        });
    }
}

/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Extension {
    constructor(config = {}) {
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Extension(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Extension({ ...this.config, ...extendedConfig });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */
function getTextBetween(startNode, range, options) {
    const { from, to } = range;
    const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
    let text = '';
    startNode.nodesBetween(from, to, (node, pos, parent, index) => {
        var _a;
        if (node.isBlock && pos > from) {
            text += blockSeparator;
        }
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) {
                text += textSerializer({
                    node,
                    pos,
                    parent,
                    index,
                    range,
                });
            }
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) {
            text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
        }
    });
    return text;
}

/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */
function getTextSerializersFromSchema(schema) {
    return Object.fromEntries(Object.entries(schema.nodes)
        .filter(([, node]) => node.spec.toText)
        .map(([name, node]) => [name, node.spec.toText]));
}

const ClipboardTextSerializer = Extension.create({
    name: 'clipboardTextSerializer',
    addOptions() {
        return {
            blockSeparator: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: () => {
                        const { editor } = this;
                        const { state, schema } = editor;
                        const { doc, selection } = state;
                        const { ranges } = selection;
                        const from = Math.min(...ranges.map(range => range.$from.pos));
                        const to = Math.max(...ranges.map(range => range.$to.pos));
                        const textSerializers = getTextSerializersFromSchema(schema);
                        const range = { from, to };
                        return getTextBetween(doc, range, {
                            ...(this.options.blockSeparator !== undefined
                                ? { blockSeparator: this.options.blockSeparator }
                                : {}),
                            textSerializers,
                        });
                    },
                },
            }),
        ];
    },
});

const dist_blur = () => ({ editor, view }) => {
    requestAnimationFrame(() => {
        var _a;
        if (!editor.isDestroyed) {
            view.dom.blur();
            // Browsers should remove the caret on blur but safari does not.
            // See: https://github.com/ueberdosis/tiptap/issues/2405
            (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        }
    });
    return true;
};

const clearContent = (emitUpdate = false) => ({ commands }) => {
    return commands.setContent('', emitUpdate);
};

const clearNodes = () => ({ state, tr, dispatch }) => {
    const { selection } = tr;
    const { ranges } = selection;
    if (!dispatch) {
        return true;
    }
    ranges.forEach(({ $from, $to }) => {
        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (node.type.isText) {
                return;
            }
            const { doc, mapping } = tr;
            const $mappedFrom = doc.resolve(mapping.map(pos));
            const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
            const nodeRange = $mappedFrom.blockRange($mappedTo);
            if (!nodeRange) {
                return;
            }
            const targetLiftDepth = liftTarget(nodeRange);
            if (node.type.isTextblock) {
                const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                tr.setNodeMarkup(nodeRange.start, defaultType);
            }
            if (targetLiftDepth || targetLiftDepth === 0) {
                tr.lift(nodeRange, targetLiftDepth);
            }
        });
    });
    return true;
};

const command = fn => props => {
    return fn(props);
};

const dist_createParagraphNear = () => ({ state, dispatch }) => {
    return createParagraphNear(state, dispatch);
};

const cut = (originRange, targetPos) => ({ editor, tr }) => {
    const { state } = editor;
    const contentSlice = state.doc.slice(originRange.from, originRange.to);
    tr.deleteRange(originRange.from, originRange.to);
    const newPos = tr.mapping.map(targetPos);
    tr.insert(newPos, contentSlice.content);
    tr.setSelection(new TextSelection(tr.doc.resolve(newPos - 1)));
    return true;
};

const deleteCurrentNode = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const currentNode = selection.$anchor.node();
    // if there is content inside the current node, break out of this command
    if (currentNode.content.size > 0) {
        return false;
    }
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === currentNode.type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const deleteNode = typeOrName => ({ tr, state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const dist_deleteRange = range => ({ tr, dispatch }) => {
    const { from, to } = range;
    if (dispatch) {
        tr.delete(from, to);
    }
    return true;
};

const dist_deleteSelection = () => ({ state, dispatch }) => {
    return deleteSelection(state, dispatch);
};

const enter = () => ({ commands }) => {
    return commands.keyboardShortcut('Enter');
};

const dist_exitCode = () => ({ state, dispatch }) => {
    return exitCode(state, dispatch);
};

/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */
function objectIncludes(object1, object2, options = { strict: true }) {
    const keys = Object.keys(object2);
    if (!keys.length) {
        return true;
    }
    return keys.every(key => {
        if (options.strict) {
            return object2[key] === object1[key];
        }
        if (isRegExp(object2[key])) {
            return object2[key].test(object1[key]);
        }
        return object2[key] === object1[key];
    });
}

function findMarkInSet(marks, type, attributes = {}) {
    return marks.find(item => {
        return (item.type === type
            && objectIncludes(
            // Only check equality for the attributes that are provided
            Object.fromEntries(Object.keys(attributes).map(k => [k, item.attrs[k]])), attributes));
    });
}
function isMarkInSet(marks, type, attributes = {}) {
    return !!findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */
function getMarkRange(
/**
 * The position to get the mark range for.
 */
$pos, 
/**
 * The mark type to get the range for.
 */
type, 
/**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */
attributes) {
    var _a;
    if (!$pos || !type) {
        return;
    }
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        start = $pos.parent.childBefore($pos.parentOffset);
    }
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        return;
    }
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = findMarkInSet([...start.node.marks], type, attributes);
    if (!mark) {
        return;
    }
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while (startIndex > 0
        && isMarkInSet([...$pos.parent.child(startIndex - 1).marks], type, attributes)) {
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while (endIndex < $pos.parent.childCount
        && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attributes)) {
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos,
    };
}

function getMarkType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) {
            throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.marks[nameOrType];
    }
    return nameOrType;
}

const extendMarkRange = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const type = getMarkType(typeOrName, state.schema);
    const { doc, selection } = tr;
    const { $from, from, to } = selection;
    if (dispatch) {
        const range = getMarkRange($from, type, attributes);
        if (range && range.from <= from && range.to >= to) {
            const newSelection = TextSelection.create(doc, range.from, range.to);
            tr.setSelection(newSelection);
        }
    }
    return true;
};

const first = commands => props => {
    const items = typeof commands === 'function'
        ? commands(props)
        : commands;
    for (let i = 0; i < items.length; i += 1) {
        if (items[i](props)) {
            return true;
        }
    }
    return false;
};

function isTextSelection(value) {
    return value instanceof TextSelection;
}

function minMax(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc, position = null) {
    if (!position) {
        return null;
    }
    const selectionAtStart = dist_Selection.atStart(doc);
    const selectionAtEnd = dist_Selection.atEnd(doc);
    if (position === 'start' || position === true) {
        return selectionAtStart;
    }
    if (position === 'end') {
        return selectionAtEnd;
    }
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') {
        return TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
    }
    return TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

function isAndroid() {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}

function isiOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

const dist_focus = (position = null, options = {}) => ({ editor, view, tr, dispatch, }) => {
    options = {
        scrollIntoView: true,
        ...options,
    };
    const delayedFocus = () => {
        // focus within `requestAnimationFrame` breaks focus on iOS and Android
        // so we have to call this
        if (isiOS() || isAndroid()) {
            view.dom.focus();
        }
        // For React we have to focus asynchronously. Otherwise wild things happen.
        // see: https://github.com/ueberdosis/tiptap/issues/1520
        requestAnimationFrame(() => {
            if (!editor.isDestroyed) {
                view.focus();
                if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
                    editor.commands.scrollIntoView();
                }
            }
        });
    };
    if ((view.hasFocus() && position === null) || position === false) {
        return true;
    }
    // we don’t try to resolve a NodeSelection or CellSelection
    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
        delayedFocus();
        return true;
    }
    // pass through tr.doc instead of editor.state.doc
    // since transactions could change the editors state before this command has been run
    const selection = resolveFocusPosition(tr.doc, position) || editor.state.selection;
    const isSameSelection = editor.state.selection.eq(selection);
    if (dispatch) {
        if (!isSameSelection) {
            tr.setSelection(selection);
        }
        // `tr.setSelection` resets the stored marks
        // so we’ll restore them if the selection is the same as before
        if (isSameSelection && tr.storedMarks) {
            tr.setStoredMarks(tr.storedMarks);
        }
        delayedFocus();
    }
    return true;
};

const forEach = (items, fn) => props => {
    return items.every((item, index) => fn(item, { ...props, index }));
};

const insertContent = (value, options) => ({ tr, commands }) => {
    return commands.insertContentAt({ from: tr.selection.from, to: tr.selection.to }, value, options);
};

const removeWhitespaces = (node) => {
    const children = node.childNodes;
    for (let i = children.length - 1; i >= 0; i -= 1) {
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
            node.removeChild(child);
        }
        else if (child.nodeType === 1) {
            removeWhitespaces(child);
        }
    }
    return node;
};
function elementFromString(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
    return removeWhitespaces(html);
}

/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */
function createNodeFromContent(content, schema, options) {
    if (content instanceof Node || content instanceof dist_Fragment) {
        return content;
    }
    options = {
        slice: true,
        parseOptions: {},
        ...options,
    };
    const isJSONContent = typeof content === 'object' && content !== null;
    const isTextContent = typeof content === 'string';
    if (isJSONContent) {
        try {
            const isArrayContent = Array.isArray(content) && content.length > 0;
            // if the JSON Content is an array of nodes, create a fragment for each node
            if (isArrayContent) {
                return dist_Fragment.fromArray(content.map(item => schema.nodeFromJSON(item)));
            }
            const node = schema.nodeFromJSON(content);
            if (options.errorOnInvalidContent) {
                node.check();
            }
            return node;
        }
        catch (error) {
            if (options.errorOnInvalidContent) {
                throw new Error('[tiptap error]: Invalid JSON content', { cause: error });
            }
            console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
            return createNodeFromContent('', schema, options);
        }
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = '';
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new Schema({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: 'inline*',
                        group: 'block',
                        parseDOM: [
                            {
                                tag: '*',
                                getAttrs: e => {
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === 'string' ? e : e.outerHTML;
                                    return null;
                                },
                            },
                        ],
                    },
                }),
            });
            if (options.slice) {
                dist_DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content), options.parseOptions);
            }
            else {
                dist_DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content), options.parseOptions);
            }
            if (options.errorOnInvalidContent && hasInvalidContent) {
                throw new Error('[tiptap error]: Invalid HTML content', { cause: new Error(`Invalid element found: ${invalidContent}`) });
            }
        }
        const parser = dist_DOMParser.fromSchema(schema);
        if (options.slice) {
            return parser.parseSlice(elementFromString(content), options.parseOptions).content;
        }
        return parser.parse(elementFromString(content), options.parseOptions);
    }
    return createNodeFromContent('', schema, options);
}

// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function dist_selectionToInsertionEnd(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) {
        return;
    }
    const step = tr.steps[last];
    if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
        return;
    }
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo) => {
        if (end === 0) {
            end = newTo;
        }
    });
    tr.setSelection(dist_Selection.near(tr.doc.resolve(end), bias));
}

const isFragment = (nodeOrFragment) => {
    return !('type' in nodeOrFragment);
};
const insertContentAt = (position, value, options) => ({ tr, dispatch, editor }) => {
    var _a;
    if (dispatch) {
        options = {
            parseOptions: editor.options.parseOptions,
            updateSelection: true,
            applyInputRules: false,
            applyPasteRules: false,
            ...options,
        };
        let content;
        try {
            content = createNodeFromContent(value, editor.schema, {
                parseOptions: {
                    preserveWhitespace: 'full',
                    ...options.parseOptions,
                },
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
            });
        }
        catch (e) {
            editor.emit('contentError', {
                editor,
                error: e,
                disableCollaboration: () => {
                    if (editor.storage.collaboration) {
                        editor.storage.collaboration.isDisabled = true;
                    }
                },
            });
            return false;
        }
        let { from, to } = typeof position === 'number' ? { from: position, to: position } : { from: position.from, to: position.to };
        let isOnlyTextContent = true;
        let isOnlyBlockContent = true;
        const nodes = isFragment(content) ? content : [content];
        nodes.forEach(node => {
            // check if added node is valid
            node.check();
            isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
            isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
        });
        // check if we can replace the wrapping node by
        // the newly inserted content
        // example:
        // replace an empty paragraph by an inserted image
        // instead of inserting the image below the paragraph
        if (from === to && isOnlyBlockContent) {
            const { parent } = tr.doc.resolve(from);
            const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
            if (isEmptyTextBlock) {
                from -= 1;
                to += 1;
            }
        }
        let newContent;
        // if there is only plain text we have to use `insertText`
        // because this will keep the current marks
        if (isOnlyTextContent) {
            // if value is string, we can use it directly
            // otherwise if it is an array, we have to join it
            if (Array.isArray(value)) {
                newContent = value.map(v => v.text || '').join('');
            }
            else if (value instanceof dist_Fragment) {
                let text = '';
                value.forEach(node => {
                    if (node.text) {
                        text += node.text;
                    }
                });
                newContent = text;
            }
            else if (typeof value === 'object' && !!value && !!value.text) {
                newContent = value.text;
            }
            else {
                newContent = value;
            }
            tr.insertText(newContent, from, to);
        }
        else {
            newContent = content;
            tr.replaceWith(from, to, newContent);
        }
        // set cursor at end of inserted content
        if (options.updateSelection) {
            dist_selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
        }
        if (options.applyInputRules) {
            tr.setMeta('applyInputRules', { from, text: newContent });
        }
        if (options.applyPasteRules) {
            tr.setMeta('applyPasteRules', { from, text: newContent });
        }
    }
    return true;
};

const dist_joinUp = () => ({ state, dispatch }) => {
    return joinUp(state, dispatch);
};
const dist_joinDown = () => ({ state, dispatch }) => {
    return joinDown(state, dispatch);
};
const dist_joinBackward = () => ({ state, dispatch }) => {
    return joinBackward(state, dispatch);
};
const dist_joinForward = () => ({ state, dispatch }) => {
    return joinForward(state, dispatch);
};

const joinItemBackward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = joinPoint(state.doc, state.selection.$from.pos, -1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const joinItemForward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = joinPoint(state.doc, state.selection.$from.pos, +1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const dist_joinTextblockBackward = () => ({ state, dispatch }) => {
    return joinTextblockBackward(state, dispatch);
};

const dist_joinTextblockForward = () => ({ state, dispatch }) => {
    return joinTextblockForward(state, dispatch);
};

function isMacOS() {
    return typeof navigator !== 'undefined'
        ? /Mac/.test(navigator.platform)
        : false;
}

function dist_normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') {
        result = ' ';
    }
    let alt;
    let ctrl;
    let shift;
    let meta;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) {
            meta = true;
        }
        else if (/^a(lt)?$/i.test(mod)) {
            alt = true;
        }
        else if (/^(c|ctrl|control)$/i.test(mod)) {
            ctrl = true;
        }
        else if (/^s(hift)?$/i.test(mod)) {
            shift = true;
        }
        else if (/^mod$/i.test(mod)) {
            if (isiOS() || isMacOS()) {
                meta = true;
            }
            else {
                ctrl = true;
            }
        }
        else {
            throw new Error(`Unrecognized modifier name: ${mod}`);
        }
    }
    if (alt) {
        result = `Alt-${result}`;
    }
    if (ctrl) {
        result = `Ctrl-${result}`;
    }
    if (meta) {
        result = `Meta-${result}`;
    }
    if (shift) {
        result = `Shift-${result}`;
    }
    return result;
}
const keyboardShortcut = name => ({ editor, view, tr, dispatch, }) => {
    const keys = dist_normalizeKeyName(name).split(/-(?!$)/);
    const key = keys.find(item => !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item));
    const event = new KeyboardEvent('keydown', {
        key: key === 'Space'
            ? ' '
            : key,
        altKey: keys.includes('Alt'),
        ctrlKey: keys.includes('Ctrl'),
        metaKey: keys.includes('Meta'),
        shiftKey: keys.includes('Shift'),
        bubbles: true,
        cancelable: true,
    });
    const capturedTransaction = editor.captureTransaction(() => {
        view.someProp('handleKeyDown', f => f(view, event));
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(step => {
        const newStep = step.map(tr.mapping);
        if (newStep && dispatch) {
            tr.maybeStep(newStep);
        }
    });
    return true;
};

function isNodeActive(state, typeOrName, attributes = {}) {
    const { from, to, empty } = state.selection;
    const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.isText) {
            return;
        }
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node,
            from: relativeFrom,
            to: relativeTo,
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges
        .filter(nodeRange => {
        if (!type) {
            return true;
        }
        return type.name === nodeRange.node.type.name;
    })
        .filter(nodeRange => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
    if (empty) {
        return !!matchedNodeRanges.length;
    }
    const range = matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}

const core_dist_lift = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (!isActive) {
        return false;
    }
    return dist_lift(state, dispatch);
};

const dist_liftEmptyBlock = () => ({ state, dispatch }) => {
    return liftEmptyBlock(state, dispatch);
};

const dist_liftListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return liftListItem(type)(state, dispatch);
};

const dist_newlineInCode = () => ({ state, dispatch }) => {
    return newlineInCode(state, dispatch);
};

/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */
function getSchemaTypeNameByName(name, schema) {
    if (schema.nodes[name]) {
        return 'node';
    }
    if (schema.marks[name]) {
        return 'mark';
    }
    return null;
}

/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */
function deleteProps(obj, propOrProps) {
    const props = typeof propOrProps === 'string'
        ? [propOrProps]
        : propOrProps;
    return Object
        .keys(obj)
        .reduce((newObj, prop) => {
        if (!props.includes(prop)) {
            newObj[prop] = obj[prop];
        }
        return newObj;
    }, {});
}

const resetAttributes = (typeOrName, attributes) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach(range => {
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
                if (nodeType && nodeType === node.type) {
                    tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
                }
                if (markType && node.marks.length) {
                    node.marks.forEach(mark => {
                        if (markType === mark.type) {
                            tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
                        }
                    });
                }
            });
        });
    }
    return true;
};

const scrollIntoView = () => ({ tr, dispatch }) => {
    if (dispatch) {
        tr.scrollIntoView();
    }
    return true;
};

const dist_selectAll = () => ({ tr, dispatch }) => {
    if (dispatch) {
        const selection = new AllSelection(tr.doc);
        tr.setSelection(selection);
    }
    return true;
};

const dist_selectNodeBackward = () => ({ state, dispatch }) => {
    return selectNodeBackward(state, dispatch);
};

const dist_selectNodeForward = () => ({ state, dispatch }) => {
    return selectNodeForward(state, dispatch);
};

const dist_selectParentNode = () => ({ state, dispatch }) => {
    return selectParentNode(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const dist_selectTextblockEnd = () => ({ state, dispatch }) => {
    return selectTextblockEnd(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const dist_selectTextblockStart = () => ({ state, dispatch }) => {
    return selectTextblockStart(state, dispatch);
};

/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */
function createDocument(content, schema, parseOptions = {}, options = {}) {
    return createNodeFromContent(content, schema, {
        slice: false,
        parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent,
    });
}

const setContent = (content, emitUpdate = false, parseOptions = {}, options = {}) => ({ editor, tr, dispatch, commands, }) => {
    var _a, _b;
    const { doc } = tr;
    // This is to keep backward compatibility with the previous behavior
    // TODO remove this in the next major version
    if (parseOptions.preserveWhitespace !== 'full') {
        const document = createDocument(content, editor.schema, parseOptions, {
            errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
        });
        if (dispatch) {
            tr.replaceWith(0, doc.content.size, document).setMeta('preventUpdate', !emitUpdate);
        }
        return true;
    }
    if (dispatch) {
        tr.setMeta('preventUpdate', !emitUpdate);
    }
    return commands.insertContentAt({ from: 0, to: doc.content.size }, content, {
        parseOptions,
        errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck,
    });
};

function getMarkAttributes(state, typeOrName) {
    const type = getMarkType(typeOrName, state.schema);
    const { from, to, empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) {
            marks.push(...state.storedMarks);
        }
        marks.push(...state.selection.$head.marks());
    }
    else {
        state.doc.nodesBetween(from, to, node => {
            marks.push(...node.marks);
        });
    }
    const mark = marks.find(markItem => markItem.type.name === type.name);
    if (!mark) {
        return {};
    }
    return { ...mark.attrs };
}

/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */
function combineTransactionSteps(oldDoc, transactions) {
    const transform = new Transform(oldDoc);
    transactions.forEach(transaction => {
        transaction.steps.forEach(step => {
            transform.step(step);
        });
    });
    return transform;
}

/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */
function dist_defaultBlockAt(match) {
    for (let i = 0; i < match.edgeCount; i += 1) {
        const { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) {
            return type;
        }
    }
    return null;
}

/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */
function findChildren(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */
function findChildrenInRange(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */
function findParentNodeClosestToPos($pos, predicate) {
    for (let i = $pos.depth; i > 0; i -= 1) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
}

/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */
function findParentNode(predicate) {
    return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}

function getSchema(extensions, editor) {
    const resolvedExtensions = ExtensionManager.resolve(extensions);
    return getSchemaByResolvedExtensions(resolvedExtensions, editor);
}

/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */
function generateHTML(doc, extensions) {
    const schema = getSchema(extensions);
    const contentNode = Node$1.fromJSON(schema, doc);
    return getHTMLFromFragment(contentNode.content, schema);
}

/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */
function generateJSON(html, extensions) {
    const schema = getSchema(extensions);
    const dom = elementFromString(html);
    return DOMParser.fromSchema(schema).parse(dom).toJSON();
}

/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */
function dist_getText(node, options) {
    const range = {
        from: 0,
        to: node.content.size,
    };
    return getTextBetween(node, range, options);
}

/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */
function generateText(doc, extensions, options) {
    const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
    const schema = getSchema(extensions);
    const contentNode = Node$1.fromJSON(schema, doc);
    return dist_getText(contentNode, {
        blockSeparator,
        textSerializers: {
            ...getTextSerializersFromSchema(schema),
            ...textSerializers,
        },
    });
}

function getNodeAttributes(state, typeOrName) {
    const type = getNodeType(typeOrName, state.schema);
    const { from, to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, node => {
        nodes.push(node);
    });
    const node = nodes.reverse().find(nodeItem => nodeItem.type.name === type.name);
    if (!node) {
        return {};
    }
    return { ...node.attrs };
}

/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */
function getAttributes(state, typeOrName) {
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') {
        return getNodeAttributes(state, typeOrName);
    }
    if (schemaType === 'mark') {
        return getMarkAttributes(state, typeOrName);
    }
    return {};
}

/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */
function simplifyChangedRanges(changes) {
    const uniqueChanges = removeDuplicates(changes);
    return uniqueChanges.length === 1
        ? uniqueChanges
        : uniqueChanges.filter((change, index) => {
            const rest = uniqueChanges.filter((_, i) => i !== index);
            return !rest.some(otherChange => {
                return change.oldRange.from >= otherChange.oldRange.from
                    && change.oldRange.to <= otherChange.oldRange.to
                    && change.newRange.from >= otherChange.newRange.from
                    && change.newRange.to <= otherChange.newRange.to;
            });
        });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */
function getChangedRanges(transform) {
    const { mapping, steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index) => {
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from, to } = steps[index];
            if (from === undefined || to === undefined) {
                return;
            }
            ranges.push({ from, to });
        }
        else {
            stepMap.forEach((from, to) => {
                ranges.push({ from, to });
            });
        }
        ranges.forEach(({ from, to }) => {
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd,
                },
                newRange: {
                    from: newStart,
                    to: newEnd,
                },
            });
        });
    });
    return simplifyChangedRanges(changes);
}

function getDebugJSON(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map(mark => {
        const output = {
            type: mark.type.name,
        };
        if (Object.keys(mark.attrs).length) {
            output.attrs = { ...mark.attrs };
        }
        return output;
    });
    const attrs = { ...node.attrs };
    const output = {
        type: node.type.name,
        from,
        to,
    };
    if (Object.keys(attrs).length) {
        output.attrs = attrs;
    }
    if (marks.length) {
        output.marks = marks;
    }
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset) => {
            var _a;
            (_a = output.content) === null || _a === void 0 ? void 0 : _a.push(getDebugJSON(child, startOffset + offset + increment));
        });
    }
    if (node.text) {
        output.text = node.text;
    }
    return output;
}

function getMarksBetween(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) {
        doc
            .resolve(from)
            .marks()
            .forEach(mark => {
            const $pos = doc.resolve(from);
            const range = getMarkRange($pos, mark.type);
            if (!range) {
                return;
            }
            marks.push({
                mark,
                ...range,
            });
        });
    }
    else {
        doc.nodesBetween(from, to, (node, pos) => {
            if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) {
                return;
            }
            marks.push(...node.marks.map(mark => ({
                from: pos,
                to: pos + node.nodeSize,
                mark,
            })));
        });
    }
    return marks;
}

/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */
const getNodeAtPosition = (state, typeOrName, pos, maxDepth = 20) => {
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while (currentDepth > 0 && node === null) {
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) {
            node = currentNode;
        }
        else {
            currentDepth -= 1;
        }
    }
    return [node, currentDepth];
};

/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */
function getSplittedAttributes(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object
        .entries(attributes)
        .filter(([name]) => {
        const extensionAttribute = extensionAttributes.find(item => {
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) {
            return false;
        }
        return extensionAttribute.attribute.keepOnSplit;
    }));
}

function isMarkActive(state, typeOrName, attributes = {}) {
    const { empty, ranges } = state.selection;
    const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
    if (empty) {
        return !!(state.storedMarks || state.selection.$from.marks())
            .filter(mark => {
            if (!type) {
                return true;
            }
            return type.name === mark.type.name;
        })
            .find(mark => objectIncludes(mark.attrs, attributes, { strict: false }));
    }
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from, $to }) => {
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos) => {
            if (!node.isText && !node.marks.length) {
                return;
            }
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map(mark => ({
                mark,
                from: relativeFrom,
                to: relativeTo,
            })));
        });
    });
    if (selectionRange === 0) {
        return false;
    }
    // calculate range of matched mark
    const matchedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return type.name === markRange.mark.type.name;
    })
        .filter(markRange => objectIncludes(markRange.mark.attrs, attributes, { strict: false }))
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    })
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}

function isActive(state, name, attributes = {}) {
    if (!name) {
        return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
    }
    const schemaType = getSchemaTypeNameByName(name, state.schema);
    if (schemaType === 'node') {
        return isNodeActive(state, name, attributes);
    }
    if (schemaType === 'mark') {
        return isMarkActive(state, name, attributes);
    }
    return false;
}

const isAtEndOfNode = (state, nodeType) => {
    const { $from, $to, $anchor } = state.selection;
    if (nodeType) {
        const parentNode = findParentNode(node => node.type.name === nodeType)(state.selection);
        if (!parentNode) {
            return false;
        }
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) {
            return true;
        }
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) {
        return false;
    }
    return true;
};

const isAtStartOfNode = (state) => {
    const { $from, $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) {
        return false;
    }
    return true;
};

function isList(name, extensions) {
    const { nodeExtensions } = splitExtensions(extensions);
    const extension = nodeExtensions.find(item => item.name === name);
    if (!extension) {
        return false;
    }
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
    };
    const group = callOrReturn(getExtensionField(extension, 'group', context));
    if (typeof group !== 'string') {
        return false;
    }
    return group.split(' ').includes('list');
}

/**
 * Returns true if the given prosemirror node is empty.
 */
function isNodeEmpty(node, { checkChildren = true, ignoreWhitespace = false, } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === 'hardBreak') {
            // Hard breaks are considered empty
            return true;
        }
        if (node.isText) {
            return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
        }
    }
    if (node.isText) {
        return !node.text;
    }
    if (node.isAtom || node.isLeaf) {
        return false;
    }
    if (node.content.childCount === 0) {
        return true;
    }
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach(childNode => {
            if (isContentEmpty === false) {
                // Exit early for perf
                return;
            }
            if (!isNodeEmpty(childNode, { ignoreWhitespace, checkChildren })) {
                isContentEmpty = false;
            }
        });
        return isContentEmpty;
    }
    return false;
}

function isNodeSelection(value) {
    return value instanceof dist_NodeSelection;
}

function posToDOMRect(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = minMax(from, minPos, maxPos);
    const resolvedEnd = minMax(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top,
        bottom,
        left,
        right,
        width,
        height,
        x,
        y,
    };
    return {
        ...data,
        toJSON: () => data,
    };
}

/**
 * The actual implementation of the rewriteUnknownContent function
 */
function rewriteUnknownContentInner({ json, validMarks, validNodes, options, rewrittenContent = [], }) {
    if (json.marks && Array.isArray(json.marks)) {
        json.marks = json.marks.filter(mark => {
            const name = typeof mark === 'string' ? mark : mark.type;
            if (validMarks.has(name)) {
                return true;
            }
            rewrittenContent.push({
                original: JSON.parse(JSON.stringify(mark)),
                unsupported: name,
            });
            // Just ignore any unknown marks
            return false;
        });
    }
    if (json.content && Array.isArray(json.content)) {
        json.content = json.content
            .map(value => rewriteUnknownContentInner({
            json: value,
            validMarks,
            validNodes,
            options,
            rewrittenContent,
        }).json)
            .filter(a => a !== null && a !== undefined);
    }
    if (json.type && !validNodes.has(json.type)) {
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(json)),
            unsupported: json.type,
        });
        if (json.content && Array.isArray(json.content) && ((options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false)) {
            // Just treat it like a paragraph and hope for the best
            json.type = 'paragraph';
            return {
                json,
                rewrittenContent,
            };
        }
        // or just omit it entirely
        return {
            json: null,
            rewrittenContent,
        };
    }
    return { json, rewrittenContent };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */
function rewriteUnknownContent(
/**
 * The JSON content to clean of unknown nodes and marks
 */
json, 
/**
 * The schema to use for validation
 */
schema, 
/**
 * Options for the cleaning process
 */
options) {
    return rewriteUnknownContentInner({
        json,
        validNodes: new Set(Object.keys(schema.nodes)),
        validMarks: new Set(Object.keys(schema.marks)),
        options,
    });
}

function canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection } = tr;
    let cursor = null;
    if (isTextSelection(selection)) {
        cursor = selection.$cursor;
    }
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return (!!newMarkType.isInSet(currentMarks)
            || !currentMarks.some(mark => mark.type.excludes(newMarkType)));
    }
    const { ranges } = selection;
    return ranges.some(({ $from, $to }) => {
        let someNodeSupportsMark = $from.depth === 0
            ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType)
            : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent) => {
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) {
                return false;
            }
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks)
                    || !node.marks.some(otherMark => otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const setMark = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    const type = getMarkType(typeOrName, state.schema);
    if (dispatch) {
        if (empty) {
            const oldAttributes = getMarkAttributes(state, type);
            tr.addStoredMark(type.create({
                ...oldAttributes,
                ...attributes,
            }));
        }
        else {
            ranges.forEach(range => {
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos) => {
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find(mark => mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) {
                        node.marks.forEach(mark => {
                            if (type === mark.type) {
                                tr.addMark(trimmedFrom, trimmedTo, type.create({
                                    ...mark.attrs,
                                    ...attributes,
                                }));
                            }
                        });
                    }
                    else {
                        tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                    }
                });
            });
        }
    }
    return canSetMark(state, tr, type);
};

const setMeta = (key, value) => ({ tr }) => {
    tr.setMeta(key, value);
    return true;
};

const setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
    const type = getNodeType(typeOrName, state.schema);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    // TODO: use a fallback like insertContent?
    if (!type.isTextblock) {
        console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
        return false;
    }
    return (chain()
        // try to convert node to default node if needed
        .command(({ commands }) => {
        const canSetBlock = dist_setBlockType(type, { ...attributesToCopy, ...attributes })(state);
        if (canSetBlock) {
            return true;
        }
        return commands.clearNodes();
    })
        .command(({ state: updatedState }) => {
        return dist_setBlockType(type, { ...attributesToCopy, ...attributes })(updatedState, dispatch);
    })
        .run());
};

const setNodeSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const from = minMax(position, 0, doc.content.size);
        const selection = dist_NodeSelection.create(doc, from);
        tr.setSelection(selection);
    }
    return true;
};

const setTextSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const { from, to } = typeof position === 'number' ? { from: position, to: position } : position;
        const minPos = TextSelection.atStart(doc).from;
        const maxPos = TextSelection.atEnd(doc).to;
        const resolvedFrom = minMax(from, minPos, maxPos);
        const resolvedEnd = minMax(to, minPos, maxPos);
        const selection = TextSelection.create(doc, resolvedFrom, resolvedEnd);
        tr.setSelection(selection);
    }
    return true;
};

const dist_sinkListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return sinkListItem(type)(state, dispatch);
};

function ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) {
        const filteredMarks = marks.filter(mark => splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const dist_splitBlock = ({ keepMarks = true } = {}) => ({ tr, state, dispatch, editor, }) => {
    const { selection, doc } = tr;
    const { $from, $to } = selection;
    const extensionAttributes = editor.extensionManager.attributes;
    const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    if (selection instanceof dist_NodeSelection && selection.node.isBlock) {
        if (!$from.parentOffset || !dist_canSplit(doc, $from.pos)) {
            return false;
        }
        if (dispatch) {
            if (keepMarks) {
                ensureMarks(state, editor.extensionManager.splittableMarks);
            }
            tr.split($from.pos).scrollIntoView();
        }
        return true;
    }
    if (!$from.parent.isBlock) {
        return false;
    }
    const atEnd = $to.parentOffset === $to.parent.content.size;
    const deflt = $from.depth === 0
        ? undefined
        : dist_defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    let types = atEnd && deflt
        ? [
            {
                type: deflt,
                attrs: newAttributes,
            },
        ]
        : undefined;
    let can = dist_canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types
        && !can
        && dist_canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : undefined)) {
        can = true;
        types = deflt
            ? [
                {
                    type: deflt,
                    attrs: newAttributes,
                },
            ]
            : undefined;
    }
    if (dispatch) {
        if (can) {
            if (selection instanceof TextSelection) {
                tr.deleteSelection();
            }
            tr.split(tr.mapping.map($from.pos), 1, types);
            if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                const first = tr.mapping.map($from.before());
                const $first = tr.doc.resolve(first);
                if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
                    tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
        }
        if (keepMarks) {
            ensureMarks(state, editor.extensionManager.splittableMarks);
        }
        tr.scrollIntoView();
    }
    return can;
};

const dist_splitListItem = (typeOrName, overrideAttrs = {}) => ({ tr, state, dispatch, editor, }) => {
    var _a;
    const type = getNodeType(typeOrName, state.schema);
    const { $from, $to } = state.selection;
    // @ts-ignore
    // eslint-disable-next-line
    const node = state.selection.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) {
        return false;
    }
    const grandParent = $from.node(-1);
    if (grandParent.type !== type) {
        return false;
    }
    const extensionAttributes = editor.extensionManager.attributes;
    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
        // In an empty block. If this is a nested list, the wrapping
        // list item should be split. Otherwise, bail out and let next
        // command handle lifting.
        if ($from.depth === 2
            || $from.node(-3).type !== type
            || $from.index(-2) !== $from.node(-2).childCount - 1) {
            return false;
        }
        if (dispatch) {
            let wrap = dist_Fragment.empty;
            // eslint-disable-next-line
            const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
            // Build a fragment containing empty versions of the structure
            // from the outer list item to the parent node of the cursor
            for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
                wrap = dist_Fragment.from($from.node(d).copy(wrap));
            }
            // eslint-disable-next-line
            const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
            // Add a second list item with an empty default start node
            const newNextTypeAttributes = {
                ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
                ...overrideAttrs,
            };
            const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
            wrap = wrap.append(dist_Fragment.from(type.createAndFill(null, nextType) || undefined));
            const start = $from.before($from.depth - (depthBefore - 1));
            tr.replace(start, $from.after(-depthAfter), new dist_Slice(wrap, 4 - depthBefore, 0));
            let sel = -1;
            tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos) => {
                if (sel > -1) {
                    return false;
                }
                if (n.isTextblock && n.content.size === 0) {
                    sel = pos + 1;
                }
            });
            if (sel > -1) {
                tr.setSelection(TextSelection.near(tr.doc.resolve(sel)));
            }
            tr.scrollIntoView();
        }
        return true;
    }
    const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    const newTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs),
        ...overrideAttrs,
    };
    const newNextTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
        ...overrideAttrs,
    };
    tr.delete($from.pos, $to.pos);
    const types = nextType
        ? [
            { type, attrs: newTypeAttributes },
            { type: nextType, attrs: newNextTypeAttributes },
        ]
        : [{ type, attrs: newTypeAttributes }];
    if (!dist_canSplit(tr.doc, $from.pos, 2)) {
        return false;
    }
    if (dispatch) {
        const { selection, storedMarks } = state;
        const { splittableMarks } = editor.extensionManager;
        const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
        tr.split($from.pos, 2, types).scrollIntoView();
        if (!marks || !dispatch) {
            return true;
        }
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
    }
    return true;
};

const joinListBackwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) {
        return true;
    }
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && dist_canJoin(tr.doc, list.pos);
    if (!canJoinBackwards) {
        return true;
    }
    tr.join(list.pos);
    return true;
};
const joinListForwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) {
        return true;
    }
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && dist_canJoin(tr.doc, after);
    if (!canJoinForwards) {
        return true;
    }
    tr.join(after);
    return true;
};
const toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {}) => ({ editor, tr, state, dispatch, chain, commands, can, }) => {
    const { extensions, splittableMarks } = editor.extensionManager;
    const listType = getNodeType(listTypeOrName, state.schema);
    const itemType = getNodeType(itemTypeOrName, state.schema);
    const { selection, storedMarks } = state;
    const { $from, $to } = selection;
    const range = $from.blockRange($to);
    const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
    if (!range) {
        return false;
    }
    const parentList = findParentNode(node => isList(node.type.name, extensions))(selection);
    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
        // remove list
        if (parentList.node.type === listType) {
            return commands.liftListItem(itemType);
        }
        // change list type
        if (isList(parentList.node.type.name, extensions)
            && listType.validContent(parentList.node.content)
            && dispatch) {
            return chain()
                .command(() => {
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            })
                .command(() => joinListBackwards(tr, listType))
                .command(() => joinListForwards(tr, listType))
                .run();
        }
    }
    if (!keepMarks || !marks || !dispatch) {
        return chain()
            // try to convert node to default node if needed
            .command(() => {
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) {
                return true;
            }
            return commands.clearNodes();
        })
            .wrapInList(listType, attributes)
            .command(() => joinListBackwards(tr, listType))
            .command(() => joinListForwards(tr, listType))
            .run();
    }
    return (chain()
        // try to convert node to default node if needed
        .command(() => {
        const canWrapInList = can().wrapInList(listType, attributes);
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
        if (canWrapInList) {
            return true;
        }
        return commands.clearNodes();
    })
        .wrapInList(listType, attributes)
        .command(() => joinListBackwards(tr, listType))
        .command(() => joinListForwards(tr, listType))
        .run());
};

const dist_toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands }) => {
    const { extendEmptyMarkRange = false } = options;
    const type = getMarkType(typeOrName, state.schema);
    const isActive = isMarkActive(state, type, attributes);
    if (isActive) {
        return commands.unsetMark(type, { extendEmptyMarkRange });
    }
    return commands.setMark(type, attributes);
};

const toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const toggleType = getNodeType(toggleTypeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    if (isActive) {
        return commands.setNode(toggleType, attributesToCopy);
    }
    // If the node is not active, we want to set the new node type with the given attributes
    // Copying over the attributes from the current node if the selection is pointing to a node of the same type
    return commands.setNode(type, { ...attributesToCopy, ...attributes });
};

const toggleWrap = (typeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (isActive) {
        return commands.lift(type);
    }
    return commands.wrapIn(type, attributes);
};

const undoInputRule = () => ({ state, dispatch }) => {
    const plugins = state.plugins;
    for (let i = 0; i < plugins.length; i += 1) {
        const plugin = plugins[i];
        let undoable;
        // @ts-ignore
        // eslint-disable-next-line
        if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
            if (dispatch) {
                const tr = state.tr;
                const toUndo = undoable.transform;
                for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) {
                    tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                }
                if (undoable.text) {
                    const marks = tr.doc.resolve(undoable.from).marks();
                    tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                }
                else {
                    tr.delete(undoable.from, undoable.to);
                }
            }
            return true;
        }
    }
    return false;
};

const unsetAllMarks = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    if (empty) {
        return true;
    }
    if (dispatch) {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
    }
    return true;
};

const unsetMark = (typeOrName, options = {}) => ({ tr, state, dispatch }) => {
    var _a;
    const { extendEmptyMarkRange = false } = options;
    const { selection } = tr;
    const type = getMarkType(typeOrName, state.schema);
    const { $from, empty, ranges } = selection;
    if (!dispatch) {
        return true;
    }
    if (empty && extendEmptyMarkRange) {
        let { from, to } = selection;
        const attrs = (_a = $from.marks().find(mark => mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
        const range = getMarkRange($from, type, attrs);
        if (range) {
            from = range.from;
            to = range.to;
        }
        tr.removeMark(from, to, type);
    }
    else {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
    }
    tr.removeStoredMark(type);
    return true;
};

const updateAttributes = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach((range) => {
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                });
            }
            else {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (pos < from && nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                    if (pos >= from && pos <= to) {
                        if (nodeType && nodeType === node.type) {
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                ...attributes,
                            });
                        }
                        if (markType && node.marks.length) {
                            node.marks.forEach((mark) => {
                                if (markType === mark.type) {
                                    const trimmedFrom2 = Math.max(pos, from);
                                    const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                                    tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                        ...mark.attrs,
                                        ...attributes,
                                    }));
                                }
                            });
                        }
                    }
                });
            }
            if (lastNode) {
                if (lastPos !== undefined) {
                    tr.setNodeMarkup(lastPos, undefined, {
                        ...lastNode.attrs,
                        ...attributes,
                    });
                }
                if (markType && lastNode.marks.length) {
                    lastNode.marks.forEach((mark) => {
                        if (markType === mark.type) {
                            tr.addMark(trimmedFrom, trimmedTo, markType.create({
                                ...mark.attrs,
                                ...attributes,
                            }));
                        }
                    });
                }
            }
        });
    }
    return true;
};

const dist_wrapIn = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapIn(type, attributes)(state, dispatch);
};

const dist_wrapInList = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapInList(type, attributes)(state, dispatch);
};

var commands = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: dist_blur,
  clearContent: clearContent,
  clearNodes: clearNodes,
  command: command,
  createParagraphNear: dist_createParagraphNear,
  cut: cut,
  deleteCurrentNode: deleteCurrentNode,
  deleteNode: deleteNode,
  deleteRange: dist_deleteRange,
  deleteSelection: dist_deleteSelection,
  enter: enter,
  exitCode: dist_exitCode,
  extendMarkRange: extendMarkRange,
  first: first,
  focus: dist_focus,
  forEach: forEach,
  insertContent: insertContent,
  insertContentAt: insertContentAt,
  joinBackward: dist_joinBackward,
  joinDown: dist_joinDown,
  joinForward: dist_joinForward,
  joinItemBackward: joinItemBackward,
  joinItemForward: joinItemForward,
  joinTextblockBackward: dist_joinTextblockBackward,
  joinTextblockForward: dist_joinTextblockForward,
  joinUp: dist_joinUp,
  keyboardShortcut: keyboardShortcut,
  lift: core_dist_lift,
  liftEmptyBlock: dist_liftEmptyBlock,
  liftListItem: dist_liftListItem,
  newlineInCode: dist_newlineInCode,
  resetAttributes: resetAttributes,
  scrollIntoView: scrollIntoView,
  selectAll: dist_selectAll,
  selectNodeBackward: dist_selectNodeBackward,
  selectNodeForward: dist_selectNodeForward,
  selectParentNode: dist_selectParentNode,
  selectTextblockEnd: dist_selectTextblockEnd,
  selectTextblockStart: dist_selectTextblockStart,
  setContent: setContent,
  setMark: setMark,
  setMeta: setMeta,
  setNode: setNode,
  setNodeSelection: setNodeSelection,
  setTextSelection: setTextSelection,
  sinkListItem: dist_sinkListItem,
  splitBlock: dist_splitBlock,
  splitListItem: dist_splitListItem,
  toggleList: toggleList,
  toggleMark: dist_toggleMark,
  toggleNode: toggleNode,
  toggleWrap: toggleWrap,
  undoInputRule: undoInputRule,
  unsetAllMarks: unsetAllMarks,
  unsetMark: unsetMark,
  updateAttributes: updateAttributes,
  wrapIn: dist_wrapIn,
  wrapInList: dist_wrapInList
});

const Commands = Extension.create({
    name: 'commands',
    addCommands() {
        return {
            ...commands,
        };
    },
});

const Drop = Extension.create({
    name: 'drop',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tiptapDrop'),
                props: {
                    handleDrop: (_, e, slice, moved) => {
                        this.editor.emit('drop', {
                            editor: this.editor,
                            event: e,
                            slice,
                            moved,
                        });
                    },
                },
            }),
        ];
    },
});

const Editable = Extension.create({
    name: 'editable',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('editable'),
                props: {
                    editable: () => this.editor.options.editable,
                },
            }),
        ];
    },
});

const FocusEvents = Extension.create({
    name: 'focusEvents',
    addProseMirrorPlugins() {
        const { editor } = this;
        return [
            new Plugin({
                key: new PluginKey('focusEvents'),
                props: {
                    handleDOMEvents: {
                        focus: (view, event) => {
                            editor.isFocused = true;
                            const transaction = editor.state.tr
                                .setMeta('focus', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event) => {
                            editor.isFocused = false;
                            const transaction = editor.state.tr
                                .setMeta('blur', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                    },
                },
            }),
        ];
    },
});

const Keymap = Extension.create({
    name: 'keymap',
    addKeyboardShortcuts() {
        const handleBackspace = () => this.editor.commands.first(({ commands }) => [
            () => commands.undoInputRule(),
            // maybe convert first text block node to default node
            () => commands.command(({ tr }) => {
                const { selection, doc } = tr;
                const { empty, $anchor } = selection;
                const { pos, parent } = $anchor;
                const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                const parentPos = $anchor.pos - $anchor.parentOffset;
                const isAtStart = (parentIsIsolating && $parentPos.parent.childCount === 1)
                    ? parentPos === $anchor.pos
                    : dist_Selection.atStart(doc).from === pos;
                if (!empty
                    || !parent.type.isTextblock
                    || parent.textContent.length
                    || !isAtStart
                    || (isAtStart && $anchor.parent.type.name === 'paragraph') // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                ) {
                    return false;
                }
                return commands.clearNodes();
            }),
            () => commands.deleteSelection(),
            () => commands.joinBackward(),
            () => commands.selectNodeBackward(),
        ]);
        const handleDelete = () => this.editor.commands.first(({ commands }) => [
            () => commands.deleteSelection(),
            () => commands.deleteCurrentNode(),
            () => commands.joinForward(),
            () => commands.selectNodeForward(),
        ]);
        const handleEnter = () => this.editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
        ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': () => this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': () => this.editor.commands.selectAll(),
        };
        const pcKeymap = {
            ...baseKeymap,
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': () => this.editor.commands.selectTextblockStart(),
            'Ctrl-e': () => this.editor.commands.selectTextblockEnd(),
        };
        if (isiOS() || isMacOS()) {
            return macKeymap;
        }
        return pcKeymap;
    },
    addProseMirrorPlugins() {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new Plugin({
                key: new PluginKey('clearDocument'),
                appendTransaction: (transactions, oldState, newState) => {
                    if (transactions.some(tr => tr.getMeta('composition'))) {
                        return;
                    }
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some(transaction => transaction.getMeta('preventClearDocument'));
                    if (!docChanges || ignoreTr) {
                        return;
                    }
                    const { empty, from, to } = oldState.selection;
                    const allFrom = dist_Selection.atStart(oldState.doc).from;
                    const allEnd = dist_Selection.atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) {
                        return;
                    }
                    const isEmpty = isNodeEmpty(newState.doc);
                    if (!isEmpty) {
                        return;
                    }
                    const tr = newState.tr;
                    const state = createChainableState({
                        state: newState,
                        transaction: tr,
                    });
                    const { commands } = new CommandManager({
                        editor: this.editor,
                        state,
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
            }),
        ];
    },
});

const Paste = Extension.create({
    name: 'paste',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tiptapPaste'),
                props: {
                    handlePaste: (_view, e, slice) => {
                        this.editor.emit('paste', {
                            editor: this.editor,
                            event: e,
                            slice,
                        });
                    },
                },
            }),
        ];
    },
});

const Tabindex = Extension.create({
    name: 'tabindex',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tabindex'),
                props: {
                    attributes: () => (this.editor.isEditable ? { tabindex: '0' } : {}),
                },
            }),
        ];
    },
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: ClipboardTextSerializer,
  Commands: Commands,
  Drop: Drop,
  Editable: Editable,
  FocusEvents: FocusEvents,
  Keymap: Keymap,
  Paste: Paste,
  Tabindex: Tabindex
});

class NodePos {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null) {
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({ from, to }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) {
            return this.pos;
        }
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to,
        };
    }
    get to() {
        if (this.isBlock) {
            return this.pos + this.size;
        }
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) {
            return null;
        }
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new NodePos($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.from - 3);
        }
        return new NodePos($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.to + 3);
        }
        return new NodePos($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset) => {
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) {
                return;
            }
            const childNodePos = new NodePos($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) {
                childNodePos.actualDepth = this.depth + 1;
            }
            children.push(new NodePos($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while (currentNode && !node) {
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for (let index = 0; index < attrKeys.length; index += 1) {
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) {
                            break;
                        }
                    }
                }
                else {
                    node = currentNode;
                }
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) {
            return nodes;
        }
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */
        this.children.forEach(childPos => {
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every(key => attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) {
                    nodes.push(childPos);
                }
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes,
        });
        this.editor.view.dispatch(tr);
    }
}

const style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;

function createStyleTag(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ''}]`);
    if (tiptapStyleTag !== null) {
        return tiptapStyleTag;
    }
    const styleNode = document.createElement('style');
    if (nonce) {
        styleNode.setAttribute('nonce', nonce);
    }
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ''}`, '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}

class dist_Editor extends EventEmitter {
    constructor(options = {}) {
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */
        this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            onBeforeCreate: () => null,
            onCreate: () => null,
            onUpdate: () => null,
            onSelectionUpdate: () => null,
            onTransaction: () => null,
            onFocus: () => null,
            onBlur: () => null,
            onDestroy: () => null,
            onContentError: ({ error }) => { throw error; },
            onPaste: () => null,
            onDrop: () => null,
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', { editor: this });
        this.on('contentError', this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        this.on('drop', ({ event, slice, moved }) => this.options.onDrop(event, slice, moved));
        this.on('paste', ({ event, slice }) => this.options.onPaste(event, slice));
        window.setTimeout(() => {
            if (this.isDestroyed) {
                return;
            }
            this.commands.focus(this.options.autofocus);
            this.emit('create', { editor: this });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */
    get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */
    get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */
    chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */
    can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */
    injectCSS() {
        if (this.options.injectCSS && document) {
            this.css = createStyleTag(style, this.options.injectNonce);
        }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */
    setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options,
        };
        if (!this.view || !this.state || this.isDestroyed) {
            return;
        }
        if (this.options.editorProps) {
            this.view.setProps(this.options.editorProps);
        }
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */
    setEditable(editable, emitUpdate = true) {
        this.setOptions({ editable });
        if (emitUpdate) {
            this.emit('update', { editor: this, transaction: this.state.tr });
        }
    }
    /**
     * Returns whether the editor is editable.
     */
    get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */
    get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */
    registerPlugin(plugin, handlePlugins) {
        const plugins = dist_isFunction(handlePlugins)
            ? handlePlugins(plugin, [...this.state.plugins])
            : [...this.state.plugins, plugin];
        const state = this.state.reconfigure({ plugins });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */
    unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) {
            return undefined;
        }
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach(nameOrPluginKey => {
            // @ts-ignore
            const name = typeof nameOrPluginKey === 'string' ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = prevPlugins.filter(plugin => !plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) {
            // No plugin was removed, so we don’t need to update the state
            return undefined;
        }
        const state = this.state.reconfigure({
            plugins,
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */
    createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            Editable,
            ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator,
            }),
            Commands,
            FocusEvents,
            Keymap,
            Tabindex,
            Drop,
            Paste,
        ].filter(ext => {
            if (typeof this.options.enableCoreExtensions === 'object') {
                return this.options.enableCoreExtensions[ext.name] !== false;
            }
            return true;
        }) : [];
        const allExtensions = [...coreExtensions, ...this.options.extensions].filter(extension => {
            return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */
    createCommandManager() {
        this.commandManager = new CommandManager({
            editor: this,
        });
    }
    /**
     * Creates a ProseMirror schema.
     */
    createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */
    createView() {
        var _a;
        let doc;
        try {
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
        }
        catch (e) {
            if (!(e instanceof Error) || !['[tiptap error]: Invalid JSON content', '[tiptap error]: Invalid HTML content'].includes(e.message)) {
                // Not the content error we were expecting
                throw e;
            }
            this.emit('contentError', {
                editor: this,
                error: e,
                disableCollaboration: () => {
                    if (this.storage.collaboration) {
                        this.storage.collaboration.isDisabled = true;
                    }
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter(extension => extension.name !== 'collaboration');
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                },
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: false });
        }
        const selection = resolveFocusPosition(doc, this.options.autofocus);
        this.view = new EditorView(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: 'textbox',
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes,
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: EditorState.create({
                doc,
                selection: selection || undefined,
            }),
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins,
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */
    createNodeViews() {
        if (this.view.isDestroyed) {
            return;
        }
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews,
        });
    }
    /**
     * Prepend class name to element.
     */
    prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */
    dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) {
            return;
        }
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach(step => { var _a; return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step); });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit('beforeTransaction', {
            editor: this,
            transaction,
            nextState: state,
        });
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction,
        });
        if (selectionHasChanged) {
            this.emit('selectionUpdate', {
                editor: this,
                transaction,
            });
        }
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) {
            this.emit('focus', {
                editor: this,
                event: focus.event,
                transaction,
            });
        }
        if (blur) {
            this.emit('blur', {
                editor: this,
                event: blur.event,
                transaction,
            });
        }
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
            return;
        }
        this.emit('update', {
            editor: this,
            transaction,
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */
    getAttributes(nameOrType) {
        return getAttributes(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
        return isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */
    getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */
    getHTML() {
        return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */
    getText(options) {
        const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
        return dist_getText(this.state.doc, {
            blockSeparator,
            textSerializers: {
                ...getTextSerializersFromSchema(this.schema),
                ...textSerializers,
            },
        });
    }
    /**
     * Check if there is no content.
     */
    get isEmpty() {
        return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */
    getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */
    destroy() {
        this.emit('destroy');
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) {
                delete dom.editor;
            }
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */
    get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new NodePos($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}

/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function markInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function nodeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const { tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) {
                    matchStart = end;
                }
                else {
                    end = matchStart + match[1].length;
                }
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            }
            else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        },
    });
}

/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function textblockTypeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const $start = state.doc.resolve(range.from);
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
                return null;
            }
            state.tr
                .delete(range.from, range.to)
                .setBlockType(range.from, range.from, config.type, attributes);
        },
    });
}

/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function textInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function wrappingInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match, chain, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && findWrapping(blockRange, config.type, attributes);
            if (!wrapping) {
                return null;
            }
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection, storedMarks } = state;
                const { splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
                if (marks) {
                    const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */
                const nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before
                && before.type === config.type
                && dist_canJoin(tr.doc, range.from - 1)
                && (!config.joinPredicate || config.joinPredicate(match, before))) {
                tr.join(range.from - 1);
            }
        },
    });
}

/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class dist_Node {
    constructor(config = {}) {
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new dist_Node(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new dist_Node(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */
class dist_NodeView {
    constructor(component, props, options) {
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options,
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3
            ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]')
            : target.closest('[data-drag-handle]');
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) {
            return;
        }
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        (_g = event.dataTransfer) === null || _g === void 0 ? void 0 : _g.setDragImage(this.dom, x, y);
        const pos = this.getPos();
        if (typeof pos !== 'number') {
            return;
        }
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = NodeSelection.create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) {
            return false;
        }
        if (typeof this.options.stopEvent === 'function') {
            return this.options.stopEvent({ event });
        }
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) {
            return false;
        }
        const isDragEvent = event.type.startsWith('drag');
        const isDropEvent = event.type === 'drop';
        const isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) {
            return true;
        }
        const { isEditable } = this.editor;
        const { isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = NodeSelection.isSelectable(this.node);
        const isCopyEvent = event.type === 'copy';
        const isPasteEvent = event.type === 'paste';
        const isCutEvent = event.type === 'cut';
        const isClickEvent = event.type === 'mousedown';
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) {
            event.preventDefault();
        }
        if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest('[data-drag-handle]');
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener('dragend', () => {
                    this.isDragging = false;
                }, { once: true });
                document.addEventListener('drop', () => {
                    this.isDragging = false;
                }, { once: true });
                document.addEventListener('mouseup', () => {
                    this.isDragging = false;
                }, { once: true });
            }
        }
        // these events are handled by prosemirror
        if (isDragging
            || isDropEvent
            || isCopyEvent
            || isPasteEvent
            || isCutEvent
            || (isClickEvent && isSelectable)) {
            return false;
        }
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */
    ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) {
            return true;
        }
        if (typeof this.options.ignoreMutation === 'function') {
            return this.options.ignoreMutation({ mutation });
        }
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) {
            return true;
        }
        // ProseMirror should handle any selections
        if (mutation.type === 'selection') {
            return false;
        }
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target)
            && mutation.type === 'childList'
            && (isiOS() || isAndroid())
            && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes),
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every(node => node.isContentEditable)) {
                return false;
            }
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === 'attributes') {
            return true;
        }
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) {
            return false;
        }
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */
    updateAttributes(attributes) {
        this.editor.commands.command(({ tr }) => {
            const pos = this.getPos();
            if (typeof pos !== 'number') {
                return false;
            }
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes,
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */
    deleteNode() {
        const from = this.getPos();
        if (typeof from !== 'number') {
            return;
        }
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({ from, to });
    }
}

/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function markPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match, pasteEvent, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

// source: https://stackoverflow.com/a/6969486
function escapeForRegEx(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function dist_isString(value) {
    return typeof value === 'string';
}

/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function nodePasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler({ match, chain, range, pasteEvent, }) {
            const attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
            const content = callOrReturn(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) {
                return null;
            }
            const node = { type: config.type.name, attrs: attributes };
            if (content) {
                node.content = content;
            }
            if (match.input) {
                chain().deleteRange(range).insertContentAt(range.from, node);
            }
        },
    });
}

/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function textPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        },
    });
}

class Tracker {
    constructor(transaction) {
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps
            .slice(this.currentStep)
            .reduce((newPosition, step) => {
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) {
                deleted = true;
            }
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted,
        };
    }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle_getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle_getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle_getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle_getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce_debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce_debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle_getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle_getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle_getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.esm.js
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function tippy_esm_hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function tippy_esm_debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function tippy_esm_getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function tippy_esm_isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (tippy_esm_isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = tippy_esm_getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (false) {}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {}

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !tippy_esm_hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (tippy_esm_isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function tippy_esm_setContent(content, props) {
  if (tippy_esm_isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function tippy_esm_render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  tippy_esm_setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      tippy_esm_setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

tippy_esm_render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {}

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = popper_createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {}
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = tippy_esm_debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (false) {} // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {}

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (false) {}

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {}

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) { var isMoreThanOneReferenceElement, isSingleContentElement; }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return tippy_esm_isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, modifiers_applyStyles, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {}

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {}

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {}

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(tippy_esm_getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: tippy_esm_render
});

/* harmony default export */ var tippy_esm = (tippy);

//# sourceMappingURL=tippy.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bubble-menu/dist/index.js




class BubbleMenuView {
    constructor({ editor, element, view, tippyOptions = {}, updateDelay = 250, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state, from, to, }) => {
            const { doc, selection } = state;
            const { empty } = selection;
            // Sometime check for `empty` is not enough.
            // Doubleclick an empty paragraph returns a node size of 2.
            // So we check also for an empty text size.
            const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);
            // When clicking on a element inside the bubble menu the editor "blur" event
            // is called and the bubble menu item is focussed. In this case we should
            // consider the menu as part of the editor and keep showing the menu
            const isChildOfMenu = this.element.contains(document.activeElement);
            const hasEditorFocus = view.hasFocus() || isChildOfMenu;
            if (!hasEditorFocus || empty || isEmptyTextBlock || !this.editor.isEditable) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.dragstartHandler = () => {
            this.hide();
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) {
                return;
            }
            this.hide();
        };
        this.tippyBlurHandler = (event) => {
            this.blurHandler({ event });
        };
        this.handleDebouncedUpdate = (view, oldState) => {
            const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
            const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
            if (!selectionChanged && !docChanged) {
                return;
            }
            if (this.updateDebounceTimer) {
                clearTimeout(this.updateDebounceTimer);
            }
            this.updateDebounceTimer = window.setTimeout(() => {
                this.updateHandler(view, selectionChanged, docChanged, oldState);
            }, this.updateDelay);
        };
        this.updateHandler = (view, selectionChanged, docChanged, oldState) => {
            var _a, _b, _c;
            const { state, composing } = view;
            const { selection } = state;
            const isSame = !selectionChanged && !docChanged;
            if (composing || isSame) {
                return;
            }
            this.createTooltip();
            // support for CellSelections
            const { ranges } = selection;
            const from = Math.min(...ranges.map(range => range.$from.pos));
            const to = Math.max(...ranges.map(range => range.$to.pos));
            const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
                editor: this.editor,
                element: this.element,
                view,
                state,
                oldState,
                from,
                to,
            });
            if (!shouldShow) {
                this.hide();
                return;
            }
            (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
                getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect)
                    || (() => {
                        if (isNodeSelection(state.selection)) {
                            let node = view.nodeDOM(from);
                            if (node) {
                                const nodeViewWrapper = node.dataset.nodeViewWrapper ? node : node.querySelector('[data-node-view-wrapper]');
                                if (nodeViewWrapper) {
                                    node = nodeViewWrapper.firstChild;
                                }
                                if (node) {
                                    return node.getBoundingClientRect();
                                }
                            }
                        }
                        return posToDOMRect(view, from, to);
                    }),
            });
            this.show();
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        this.updateDelay = updateDelay;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.addEventListener('dragstart', this.dragstartHandler);
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy_esm(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'top',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
        }
    }
    update(view, oldState) {
        const { state } = view;
        const hasValidSelection = state.selection.from !== state.selection.to;
        if (this.updateDelay > 0 && hasValidSelection) {
            this.handleDebouncedUpdate(view, oldState);
            return;
        }
        const selectionChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.selection.eq(view.state.selection));
        const docChanged = !(oldState === null || oldState === void 0 ? void 0 : oldState.doc.eq(view.state.doc));
        this.updateHandler(view, selectionChanged, docChanged, oldState);
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
            this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.view.dom.removeEventListener('dragstart', this.dragstartHandler);
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const BubbleMenuPlugin = (options) => {
    return new Plugin({
        key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
        view: view => new BubbleMenuView({ view, ...options }),
    });
};

/**
 * This extension allows you to create a bubble menu.
 * @see https://tiptap.dev/api/extensions/bubble-menu
 */
const BubbleMenu = Extension.create({
    name: 'bubbleMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'bubbleMenu',
            updateDelay: undefined,
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            BubbleMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                updateDelay: this.options.updateDelay,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-floating-menu/dist/index.js




class FloatingMenuView {
    getTextContent(node) {
        return dist_getText(node, { textSerializers: getTextSerializersFromSchema(this.editor.schema) });
    }
    constructor({ editor, element, view, tippyOptions = {}, shouldShow, }) {
        this.preventHide = false;
        this.shouldShow = ({ view, state }) => {
            const { selection } = state;
            const { $anchor, empty } = selection;
            const isRootDepth = $anchor.depth === 1;
            const isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent && $anchor.parent.childCount === 0 && !this.getTextContent($anchor.parent);
            if (!view.hasFocus()
                || !empty
                || !isRootDepth
                || !isEmptyTextBlock
                || !this.editor.isEditable) {
                return false;
            }
            return true;
        };
        this.mousedownHandler = () => {
            this.preventHide = true;
        };
        this.focusHandler = () => {
            // we use `setTimeout` to make sure `selection` is already updated
            setTimeout(() => this.update(this.editor.view));
        };
        this.blurHandler = ({ event }) => {
            var _a;
            if (this.preventHide) {
                this.preventHide = false;
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
                return;
            }
            if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === this.editor.view.dom) {
                return;
            }
            this.hide();
        };
        this.tippyBlurHandler = (event) => {
            this.blurHandler({ event });
        };
        this.editor = editor;
        this.element = element;
        this.view = view;
        if (shouldShow) {
            this.shouldShow = shouldShow;
        }
        this.element.addEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.on('focus', this.focusHandler);
        this.editor.on('blur', this.blurHandler);
        this.tippyOptions = tippyOptions;
        // Detaches menu content from its current parent
        this.element.remove();
        this.element.style.visibility = 'visible';
    }
    createTooltip() {
        const { element: editorElement } = this.editor.options;
        const editorIsAttached = !!editorElement.parentElement;
        if (this.tippy || !editorIsAttached) {
            return;
        }
        this.tippy = tippy_esm(editorElement, {
            duration: 0,
            getReferenceClientRect: null,
            content: this.element,
            interactive: true,
            trigger: 'manual',
            placement: 'right',
            hideOnClick: 'toggle',
            ...this.tippyOptions,
        });
        // maybe we have to hide tippy on its own blur event as well
        if (this.tippy.popper.firstChild) {
            this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
        }
    }
    update(view, oldState) {
        var _a, _b, _c;
        const { state } = view;
        const { doc, selection } = state;
        const { from, to } = selection;
        const isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);
        if (isSame) {
            return;
        }
        this.createTooltip();
        const shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
            editor: this.editor,
            view,
            state,
            oldState,
        });
        if (!shouldShow) {
            this.hide();
            return;
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
            getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || (() => posToDOMRect(view, from, to)),
        });
        this.show();
    }
    show() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
    hide() {
        var _a;
        (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
    destroy() {
        var _a, _b;
        if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
            this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
        }
        (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
        this.element.removeEventListener('mousedown', this.mousedownHandler, { capture: true });
        this.editor.off('focus', this.focusHandler);
        this.editor.off('blur', this.blurHandler);
    }
}
const FloatingMenuPlugin = (options) => {
    return new Plugin({
        key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
        view: view => new FloatingMenuView({ view, ...options }),
    });
};

/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */
const FloatingMenu = Extension.create({
    name: 'floatingMenu',
    addOptions() {
        return {
            element: null,
            tippyOptions: {},
            pluginKey: 'floatingMenu',
            shouldShow: null,
        };
    },
    addProseMirrorPlugins() {
        if (!this.options.element) {
            return [];
        }
        return [
            FloatingMenuPlugin({
                pluginKey: this.options.pluginKey,
                editor: this.editor,
                element: this.options.element,
                tippyOptions: this.options.tippyOptions,
                shouldShow: this.options.shouldShow,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/vue-3/dist/index.js






const dist_BubbleMenu = (0,external_vue_namespaceObject.defineComponent)({
    name: 'BubbleMenu',
    props: {
        pluginKey: {
            type: [String, Object],
            default: 'bubbleMenu',
        },
        editor: {
            type: Object,
            required: true,
        },
        updateDelay: {
            type: Number,
            default: undefined,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        shouldShow: {
            type: Function,
            default: null,
        },
    },
    setup(props, { slots }) {
        const root = (0,external_vue_namespaceObject.ref)(null);
        (0,external_vue_namespaceObject.onMounted)(() => {
            const { updateDelay, editor, pluginKey, shouldShow, tippyOptions, } = props;
            editor.registerPlugin(BubbleMenuPlugin({
                updateDelay,
                editor,
                element: root.value,
                pluginKey,
                shouldShow,
                tippyOptions,
            }));
        });
        (0,external_vue_namespaceObject.onBeforeUnmount)(() => {
            const { pluginKey, editor } = props;
            editor.unregisterPlugin(pluginKey);
        });
        return () => { var _a; return (0,external_vue_namespaceObject.h)('div', { ref: root }, (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)); };
    },
});

/* eslint-disable react-hooks/rules-of-hooks */
function useDebouncedRef(value) {
    return (0,external_vue_namespaceObject.customRef)((track, trigger) => {
        return {
            get() {
                track();
                return value;
            },
            set(newValue) {
                // update state
                value = newValue;
                // update view as soon as possible
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        trigger();
                    });
                });
            },
        };
    });
}
class Editor extends dist_Editor {
    constructor(options = {}) {
        super(options);
        this.contentComponent = null;
        this.appContext = null;
        this.reactiveState = useDebouncedRef(this.view.state);
        this.reactiveExtensionStorage = useDebouncedRef(this.extensionStorage);
        this.on('beforeTransaction', ({ nextState }) => {
            this.reactiveState.value = nextState;
            this.reactiveExtensionStorage.value = this.extensionStorage;
        });
        return (0,external_vue_namespaceObject.markRaw)(this); // eslint-disable-line
    }
    get state() {
        return this.reactiveState ? this.reactiveState.value : this.view.state;
    }
    get storage() {
        return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
    }
    /**
     * Register a ProseMirror plugin.
     */
    registerPlugin(plugin, handlePlugins) {
        const nextState = super.registerPlugin(plugin, handlePlugins);
        if (this.reactiveState) {
            this.reactiveState.value = nextState;
        }
        return nextState;
    }
    /**
     * Unregister a ProseMirror plugin.
     */
    unregisterPlugin(nameOrPluginKey) {
        const nextState = super.unregisterPlugin(nameOrPluginKey);
        if (this.reactiveState && nextState) {
            this.reactiveState.value = nextState;
        }
        return nextState;
    }
}

const EditorContent = (0,external_vue_namespaceObject.defineComponent)({
    name: 'EditorContent',
    props: {
        editor: {
            default: null,
            type: Object,
        },
    },
    setup(props) {
        const rootEl = (0,external_vue_namespaceObject.ref)();
        const instance = (0,external_vue_namespaceObject.getCurrentInstance)();
        (0,external_vue_namespaceObject.watchEffect)(() => {
            const editor = props.editor;
            if (editor && editor.options.element && rootEl.value) {
                (0,external_vue_namespaceObject.nextTick)(() => {
                    if (!rootEl.value || !editor.options.element.firstChild) {
                        return;
                    }
                    const element = (0,external_vue_namespaceObject.unref)(rootEl.value);
                    rootEl.value.append(...editor.options.element.childNodes);
                    // @ts-ignore
                    editor.contentComponent = instance.ctx._;
                    if (instance) {
                        editor.appContext = {
                            ...instance.appContext,
                            // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
                            // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
                            // @ts-expect-error forward instance's 'provides' into appContext
                            provides: instance.provides,
                        };
                    }
                    editor.setOptions({
                        element,
                    });
                    editor.createNodeViews();
                });
            }
        });
        (0,external_vue_namespaceObject.onBeforeUnmount)(() => {
            const editor = props.editor;
            if (!editor) {
                return;
            }
            editor.contentComponent = null;
            editor.appContext = null;
        });
        return { rootEl };
    },
    render() {
        return (0,external_vue_namespaceObject.h)('div', {
            ref: (el) => { this.rootEl = el; },
        });
    },
});

const dist_FloatingMenu = (0,external_vue_namespaceObject.defineComponent)({
    name: 'FloatingMenu',
    props: {
        pluginKey: {
            // TODO: TypeScript breaks :(
            // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
            type: null,
            default: 'floatingMenu',
        },
        editor: {
            type: Object,
            required: true,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        shouldShow: {
            type: Function,
            default: null,
        },
    },
    setup(props, { slots }) {
        const root = (0,external_vue_namespaceObject.ref)(null);
        (0,external_vue_namespaceObject.onMounted)(() => {
            const { pluginKey, editor, tippyOptions, shouldShow, } = props;
            editor.registerPlugin(FloatingMenuPlugin({
                pluginKey,
                editor,
                element: root.value,
                tippyOptions,
                shouldShow,
            }));
        });
        (0,external_vue_namespaceObject.onBeforeUnmount)(() => {
            const { pluginKey, editor } = props;
            editor.unregisterPlugin(pluginKey);
        });
        return () => { var _a; return (0,external_vue_namespaceObject.h)('div', { ref: root }, (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)); };
    },
});

const NodeViewContent = (0,external_vue_namespaceObject.defineComponent)({
    name: 'NodeViewContent',
    props: {
        as: {
            type: String,
            default: 'div',
        },
    },
    render() {
        return (0,external_vue_namespaceObject.h)(this.as, {
            style: {
                whiteSpace: 'pre-wrap',
            },
            'data-node-view-content': '',
        });
    },
});

const NodeViewWrapper = (0,external_vue_namespaceObject.defineComponent)({
    name: 'NodeViewWrapper',
    props: {
        as: {
            type: String,
            default: 'div',
        },
    },
    inject: ['onDragStart', 'decorationClasses'],
    render() {
        var _a, _b;
        return (0,external_vue_namespaceObject.h)(this.as, {
            // @ts-ignore
            class: this.decorationClasses,
            style: {
                whiteSpace: 'normal',
            },
            'data-node-view-wrapper': '',
            // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
            onDragstart: this.onDragStart,
        }, (_b = (_a = this.$slots).default) === null || _b === void 0 ? void 0 : _b.call(_a));
    },
});

const useEditor = (options = {}) => {
    const editor = shallowRef();
    onMounted(() => {
        editor.value = new Editor(options);
    });
    onBeforeUnmount(() => {
        var _a, _b, _c;
        // Cloning root node (and its children) to avoid content being lost by destroy
        const nodes = (_a = editor.value) === null || _a === void 0 ? void 0 : _a.options.element;
        const newEl = nodes === null || nodes === void 0 ? void 0 : nodes.cloneNode(true);
        (_b = nodes === null || nodes === void 0 ? void 0 : nodes.parentNode) === null || _b === void 0 ? void 0 : _b.replaceChild(newEl, nodes);
        (_c = editor.value) === null || _c === void 0 ? void 0 : _c.destroy();
    });
    return editor;
};

/**
 * This class is used to render Vue components inside the editor.
 */
class VueRenderer {
    constructor(component, { props = {}, editor }) {
        this.editor = editor;
        this.component = markRaw(component);
        this.el = document.createElement('div');
        this.props = reactive(props);
        this.renderedComponent = this.renderComponent();
    }
    get element() {
        return this.renderedComponent.el;
    }
    get ref() {
        var _a, _b, _c, _d;
        // Composition API
        if ((_b = (_a = this.renderedComponent.vNode) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.exposed) {
            return this.renderedComponent.vNode.component.exposed;
        }
        // Option API
        return (_d = (_c = this.renderedComponent.vNode) === null || _c === void 0 ? void 0 : _c.component) === null || _d === void 0 ? void 0 : _d.proxy;
    }
    renderComponent() {
        let vNode = h(this.component, this.props);
        if (this.editor.appContext) {
            vNode.appContext = this.editor.appContext;
        }
        if (typeof document !== 'undefined' && this.el) {
            render(vNode, this.el);
        }
        const destroy = () => {
            if (this.el) {
                render(null, this.el);
            }
            this.el = null;
            vNode = null;
        };
        return { vNode, destroy, el: this.el ? this.el.firstElementChild : null };
    }
    updateProps(props = {}) {
        Object.entries(props).forEach(([key, value]) => {
            this.props[key] = value;
        });
        this.renderComponent();
    }
    destroy() {
        this.renderedComponent.destroy();
    }
}

/* eslint-disable no-underscore-dangle */
const nodeViewProps = {
    editor: {
        type: Object,
        required: true,
    },
    node: {
        type: Object,
        required: true,
    },
    decorations: {
        type: Object,
        required: true,
    },
    selected: {
        type: Boolean,
        required: true,
    },
    extension: {
        type: Object,
        required: true,
    },
    getPos: {
        type: Function,
        required: true,
    },
    updateAttributes: {
        type: Function,
        required: true,
    },
    deleteNode: {
        type: Function,
        required: true,
    },
    view: {
        type: Object,
        required: true,
    },
    innerDecorations: {
        type: Object,
        required: true,
    },
    HTMLAttributes: {
        type: Object,
        required: true,
    },
};
class VueNodeView extends (/* unused pure expression or super */ null && (NodeView)) {
    mount() {
        const props = {
            editor: this.editor,
            node: this.node,
            decorations: this.decorations,
            innerDecorations: this.innerDecorations,
            view: this.view,
            selected: false,
            extension: this.extension,
            HTMLAttributes: this.HTMLAttributes,
            getPos: () => this.getPos(),
            updateAttributes: (attributes = {}) => this.updateAttributes(attributes),
            deleteNode: () => this.deleteNode(),
        };
        const onDragStart = this.onDragStart.bind(this);
        this.decorationClasses = ref(this.getDecorationClasses());
        const extendedComponent = defineComponent({
            extends: { ...this.component },
            props: Object.keys(props),
            template: this.component.template,
            setup: reactiveProps => {
                var _a, _b;
                provide('onDragStart', onDragStart);
                provide('decorationClasses', this.decorationClasses);
                return (_b = (_a = this.component).setup) === null || _b === void 0 ? void 0 : _b.call(_a, reactiveProps, {
                    expose: () => undefined,
                });
            },
            // add support for scoped styles
            // @ts-ignore
            // eslint-disable-next-line
            __scopeId: this.component.__scopeId,
            // add support for CSS Modules
            // @ts-ignore
            // eslint-disable-next-line
            __cssModules: this.component.__cssModules,
            // add support for vue devtools
            // @ts-ignore
            // eslint-disable-next-line
            __name: this.component.__name,
            // @ts-ignore
            // eslint-disable-next-line
            __file: this.component.__file,
        });
        this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
        this.editor.on('selectionUpdate', this.handleSelectionUpdate);
        this.renderer = new VueRenderer(extendedComponent, {
            editor: this.editor,
            props,
        });
    }
    /**
     * Return the DOM element.
     * This is the element that will be used to display the node view.
     */
    get dom() {
        if (!this.renderer.element || !this.renderer.element.hasAttribute('data-node-view-wrapper')) {
            throw Error('Please use the NodeViewWrapper component for your node view.');
        }
        return this.renderer.element;
    }
    /**
     * Return the content DOM element.
     * This is the element that will be used to display the rich-text content of the node.
     */
    get contentDOM() {
        if (this.node.isLeaf) {
            return null;
        }
        return this.dom.querySelector('[data-node-view-content]');
    }
    /**
     * On editor selection update, check if the node is selected.
     * If it is, call `selectNode`, otherwise call `deselectNode`.
     */
    handleSelectionUpdate() {
        const { from, to } = this.editor.state.selection;
        const pos = this.getPos();
        if (typeof pos !== 'number') {
            return;
        }
        if (from <= pos && to >= pos + this.node.nodeSize) {
            if (this.renderer.props.selected) {
                return;
            }
            this.selectNode();
        }
        else {
            if (!this.renderer.props.selected) {
                return;
            }
            this.deselectNode();
        }
    }
    /**
     * On update, update the React component.
     * To prevent unnecessary updates, the `update` option can be used.
     */
    update(node, decorations, innerDecorations) {
        const rerenderComponent = (props) => {
            this.decorationClasses.value = this.getDecorationClasses();
            this.renderer.updateProps(props);
        };
        if (typeof this.options.update === 'function') {
            const oldNode = this.node;
            const oldDecorations = this.decorations;
            const oldInnerDecorations = this.innerDecorations;
            this.node = node;
            this.decorations = decorations;
            this.innerDecorations = innerDecorations;
            return this.options.update({
                oldNode,
                oldDecorations,
                newNode: node,
                newDecorations: decorations,
                oldInnerDecorations,
                innerDecorations,
                updateProps: () => rerenderComponent({ node, decorations, innerDecorations }),
            });
        }
        if (node.type !== this.node.type) {
            return false;
        }
        if (node === this.node && this.decorations === decorations && this.innerDecorations === innerDecorations) {
            return true;
        }
        this.node = node;
        this.decorations = decorations;
        this.innerDecorations = innerDecorations;
        rerenderComponent({ node, decorations, innerDecorations });
        return true;
    }
    /**
     * Select the node.
     * Add the `selected` prop and the `ProseMirror-selectednode` class.
     */
    selectNode() {
        this.renderer.updateProps({
            selected: true,
        });
        if (this.renderer.element) {
            this.renderer.element.classList.add('ProseMirror-selectednode');
        }
    }
    /**
     * Deselect the node.
     * Remove the `selected` prop and the `ProseMirror-selectednode` class.
     */
    deselectNode() {
        this.renderer.updateProps({
            selected: false,
        });
        if (this.renderer.element) {
            this.renderer.element.classList.remove('ProseMirror-selectednode');
        }
    }
    getDecorationClasses() {
        return (this.decorations
            // @ts-ignore
            .map(item => item.type.attrs.class)
            .flat()
            .join(' '));
    }
    destroy() {
        this.renderer.destroy();
        this.editor.off('selectionUpdate', this.handleSelectionUpdate);
    }
}
function VueNodeViewRenderer(component, options) {
    return props => {
        // try to get the parent component
        // this is important for vue devtools to show the component hierarchy correctly
        // maybe it’s `undefined` because <editor-content> isn’t rendered yet
        if (!props.editor.contentComponent) {
            return {};
        }
        // check for class-component and normalize if neccessary
        const normalizedComponent = typeof component === 'function' && '__vccOpts' in component
            ? component.__vccOpts
            : component;
        return new VueNodeView(normalizedComponent, props, options);
    };
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-blockquote/dist/index.js


/**
 * Matches a blockquote to a `>` as input.
 */
const inputRegex = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */
const Blockquote = dist_Node.create({
    name: 'blockquote',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseHTML() {
        return [
            { tag: 'blockquote' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['blockquote', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBlockquote: () => ({ commands }) => {
                return commands.wrapIn(this.name);
            },
            toggleBlockquote: () => ({ commands }) => {
                return commands.toggleWrap(this.name);
            },
            unsetBlockquote: () => ({ commands }) => {
                return commands.lift(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-b': () => this.editor.commands.toggleBlockquote(),
        };
    },
    addInputRules() {
        return [
            wrappingInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bold/dist/index.js


/**
 * Matches bold text via `**` as input.
 */
const starInputRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */
const starPasteRegex = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */
const underscoreInputRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */
const underscorePasteRegex = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */
const Bold = dist_Mark.create({
    name: 'bold',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'strong',
            },
            {
                tag: 'b',
                getAttrs: node => node.style.fontWeight !== 'normal' && null,
            },
            {
                style: 'font-weight=400',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-weight',
                getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['strong', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBold: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleBold: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetBold: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-b': () => this.editor.commands.toggleBold(),
            'Mod-B': () => this.editor.commands.toggleBold(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegex,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegex,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-bullet-list/dist/index.js


const ListItemName = 'listItem';
const TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */
const dist_inputRegex = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */
const BulletList = dist_Node.create({
    name: 'bulletList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false,
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML() {
        return [
            { tag: 'ul' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleBulletList: () => ({ commands, chain }) => {
                if (this.options.keepAttributes) {
                    return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName)).run();
                }
                return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
        };
    },
    addInputRules() {
        let inputRule = wrappingInputRule({
            find: dist_inputRegex,
            type: this.type,
        });
        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = wrappingInputRule({
                find: dist_inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: () => { return this.editor.getAttributes(TextStyleName); },
                editor: this.editor,
            });
        }
        return [
            inputRule,
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-code/dist/index.js


/**
 * Regular expressions to match inline code blocks enclosed in backticks.
 *  It matches:
 *     - An opening backtick, followed by
 *     - Any text that doesn't include a backtick (captured for marking), followed by
 *     - A closing backtick.
 *  This ensures that any text between backticks is formatted as code,
 *  regardless of the surrounding characters (exception being another backtick).
 */
const extension_code_dist_inputRegex = /(^|[^`])`([^`]+)`(?!`)/;
/**
 * Matches inline code while pasting.
 */
const pasteRegex = /(^|[^`])`([^`]+)`(?!`)/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */
const Code = dist_Mark.create({
    name: 'code',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    excludes: '_',
    code: true,
    exitable: true,
    parseHTML() {
        return [
            { tag: 'code' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['code', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setCode: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleCode: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetCode: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-e': () => this.editor.commands.toggleCode(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: extension_code_dist_inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-code-block/dist/index.js



/**
 * Matches a code block with backticks.
 */
const backtickInputRegex = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */
const tildeInputRegex = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */
const CodeBlock = dist_Node.create({
    name: 'codeBlock',
    addOptions() {
        return {
            languageClassPrefix: 'language-',
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            defaultLanguage: null,
            HTMLAttributes: {},
        };
    },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    addAttributes() {
        return {
            language: {
                default: this.options.defaultLanguage,
                parseHTML: element => {
                    var _a;
                    const { languageClassPrefix } = this.options;
                    const classNames = [...(((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || [])];
                    const languages = classNames
                        .filter(className => className.startsWith(languageClassPrefix))
                        .map(className => className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) {
                        return null;
                    }
                    return language;
                },
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'pre',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            [
                'code',
                {
                    class: node.attrs.language
                        ? this.options.languageClassPrefix + node.attrs.language
                        : null,
                },
                0,
            ],
        ];
    },
    addCommands() {
        return {
            setCodeBlock: attributes => ({ commands }) => {
                return commands.setNode(this.name, attributes);
            },
            toggleCodeBlock: attributes => ({ commands }) => {
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-c': () => this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: () => {
                const { empty, $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) {
                    return false;
                }
                if (isAtStart || !$anchor.parent.textContent.length) {
                    return this.editor.commands.clearNodes();
                }
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor }) => {
                if (!this.options.exitOnTripleEnter) {
                    return false;
                }
                const { state } = editor;
                const { selection } = state;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');
                if (!isAtEnd || !endsWithDoubleNewline) {
                    return false;
                }
                return editor
                    .chain()
                    .command(({ tr }) => {
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                })
                    .exitCode()
                    .run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor }) => {
                if (!this.options.exitOnArrowDown) {
                    return false;
                }
                const { state } = editor;
                const { selection, doc } = state;
                const { $from, empty } = selection;
                if (!empty || $from.parent.type !== this.type) {
                    return false;
                }
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) {
                    return false;
                }
                const after = $from.after();
                if (after === undefined) {
                    return false;
                }
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) {
                    return editor.commands.command(({ tr }) => {
                        tr.setSelection(dist_Selection.near(doc.resolve(after)));
                        return true;
                    });
                }
                return editor.commands.exitCode();
            },
        };
    },
    addInputRules() {
        return [
            textblockTypeInputRule({
                find: backtickInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
            textblockTypeInputRule({
                find: tildeInputRegex,
                type: this.type,
                getAttributes: match => ({
                    language: match[1],
                }),
            }),
        ];
    },
    addProseMirrorPlugins() {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new Plugin({
                key: new PluginKey('codeBlockVSCodeHandler'),
                props: {
                    handlePaste: (view, event) => {
                        if (!event.clipboardData) {
                            return false;
                        }
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) {
                            return false;
                        }
                        const text = event.clipboardData.getData('text/plain');
                        const vscode = event.clipboardData.getData('vscode-editor-data');
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) {
                            return false;
                        }
                        const { tr, schema } = view.state;
                        // prepare a text node
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        const textNode = schema.text(text.replace(/\r\n?/g, '\n'));
                        // create a code block with the text node
                        // replace selection with the code block
                        tr.replaceSelectionWith(this.type.create({ language }, textNode));
                        if (tr.selection.$from.parent.type !== this.type) {
                            // put cursor inside the newly created code block
                            tr.setSelection(TextSelection.near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        }
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta('paste', true);
                        view.dispatch(tr);
                        return true;
                    },
                },
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-document/dist/index.js


/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */
const Document = dist_Node.create({
    name: 'doc',
    topNode: true,
    content: 'block+',
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/prosemirror-dropcursor/dist/index.js



/**
Create a plugin that, when added to a ProseMirror instance,
causes a decoration to show up at the drop position when something
is dragged over the editor.

Nodes may add a `disableDropCursor` property to their spec to
control the showing of a drop cursor inside them. This may be a
boolean or a function, which will be called with a view and a
position, and should return a boolean.
*/
function dropCursor(options = {}) {
    return new Plugin({
        view(editorView) { return new DropCursorView(editorView, options); }
    });
}
class DropCursorView {
    constructor(editorView, options) {
        var _a;
        this.editorView = editorView;
        this.cursorPos = null;
        this.element = null;
        this.timeout = -1;
        this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
        this.color = options.color === false ? undefined : (options.color || "black");
        this.class = options.class;
        this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(name => {
            let handler = (e) => { this[name](e); };
            editorView.dom.addEventListener(name, handler);
            return { name, handler };
        });
    }
    destroy() {
        this.handlers.forEach(({ name, handler }) => this.editorView.dom.removeEventListener(name, handler));
    }
    update(editorView, prevState) {
        if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
            if (this.cursorPos > editorView.state.doc.content.size)
                this.setCursor(null);
            else
                this.updateOverlay();
        }
    }
    setCursor(pos) {
        if (pos == this.cursorPos)
            return;
        this.cursorPos = pos;
        if (pos == null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        }
        else {
            this.updateOverlay();
        }
    }
    updateOverlay() {
        let $pos = this.editorView.state.doc.resolve(this.cursorPos);
        let isBlock = !$pos.parent.inlineContent, rect;
        if (isBlock) {
            let before = $pos.nodeBefore, after = $pos.nodeAfter;
            if (before || after) {
                let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                if (node) {
                    let nodeRect = node.getBoundingClientRect();
                    let top = before ? nodeRect.bottom : nodeRect.top;
                    if (before && after)
                        top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
                    rect = { left: nodeRect.left, right: nodeRect.right, top: top - this.width / 2, bottom: top + this.width / 2 };
                }
            }
        }
        if (!rect) {
            let coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = { left: coords.left - this.width / 2, right: coords.left + this.width / 2, top: coords.top, bottom: coords.bottom };
        }
        let parent = this.editorView.dom.offsetParent;
        if (!this.element) {
            this.element = parent.appendChild(document.createElement("div"));
            if (this.class)
                this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
            if (this.color) {
                this.element.style.backgroundColor = this.color;
            }
        }
        this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
        this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
        let parentLeft, parentTop;
        if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
            parentLeft = -pageXOffset;
            parentTop = -pageYOffset;
        }
        else {
            let rect = parent.getBoundingClientRect();
            parentLeft = rect.left - parent.scrollLeft;
            parentTop = rect.top - parent.scrollTop;
        }
        this.element.style.left = (rect.left - parentLeft) + "px";
        this.element.style.top = (rect.top - parentTop) + "px";
        this.element.style.width = (rect.right - rect.left) + "px";
        this.element.style.height = (rect.bottom - rect.top) + "px";
    }
    scheduleRemoval(timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.setCursor(null), timeout);
    }
    dragover(event) {
        if (!this.editorView.editable)
            return;
        let pos = this.editorView.posAtCoords({ left: event.clientX, top: event.clientY });
        let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
        let disableDropCursor = node && node.type.spec.disableDropCursor;
        let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
        if (pos && !disabled) {
            let target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                let point = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (point != null)
                    target = point;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    }
    dragend() {
        this.scheduleRemoval(20);
    }
    drop() {
        this.scheduleRemoval(20);
    }
    dragleave(event) {
        if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget))
            this.setCursor(null);
    }
}



;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-dropcursor/dist/index.js



/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */
const Dropcursor = Extension.create({
    name: 'dropCursor',
    addOptions() {
        return {
            color: 'currentColor',
            width: 1,
            class: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            dropCursor(this.options),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/prosemirror-gapcursor/dist/index.js





/**
Gap cursor selections are represented using this class. Its
`$anchor` and `$head` properties both point at the cursor position.
*/
class GapCursor extends dist_Selection {
    /**
    Create a gap cursor.
    */
    constructor($pos) {
        super($pos, $pos);
    }
    map(doc, mapping) {
        let $pos = doc.resolve(mapping.map(this.head));
        return GapCursor.valid($pos) ? new GapCursor($pos) : dist_Selection.near($pos);
    }
    content() { return dist_Slice.empty; }
    eq(other) {
        return other instanceof GapCursor && other.head == this.head;
    }
    toJSON() {
        return { type: "gapcursor", pos: this.head };
    }
    /**
    @internal
    */
    static fromJSON(doc, json) {
        if (typeof json.pos != "number")
            throw new RangeError("Invalid input for GapCursor.fromJSON");
        return new GapCursor(doc.resolve(json.pos));
    }
    /**
    @internal
    */
    getBookmark() { return new GapBookmark(this.anchor); }
    /**
    @internal
    */
    static valid($pos) {
        let parent = $pos.parent;
        if (parent.isTextblock || !closedBefore($pos) || !closedAfter($pos))
            return false;
        let override = parent.type.spec.allowGapCursor;
        if (override != null)
            return override;
        let deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    /**
    @internal
    */
    static findGapCursorFrom($pos, dir, mustMove = false) {
        search: for (;;) {
            if (!mustMove && GapCursor.valid($pos))
                return $pos;
            let pos = $pos.pos, next = null;
            // Scan up from this position
            for (let d = $pos.depth;; d--) {
                let parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                }
                else if (d == 0) {
                    return null;
                }
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur))
                    return $cur;
            }
            // And then down into the next node
            for (;;) {
                let inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !dist_NodeSelection.isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if (GapCursor.valid($cur))
                    return $cur;
            }
            return null;
        }
    }
}
GapCursor.prototype.visible = false;
GapCursor.findFrom = GapCursor.findGapCursorFrom;
dist_Selection.jsonID("gapcursor", GapCursor);
class GapBookmark {
    constructor(pos) {
        this.pos = pos;
    }
    map(mapping) {
        return new GapBookmark(mapping.map(this.pos));
    }
    resolve(doc) {
        let $pos = doc.resolve(this.pos);
        return GapCursor.valid($pos) ? new GapCursor($pos) : dist_Selection.near($pos);
    }
}
function closedBefore($pos) {
    for (let d = $pos.depth; d >= 0; d--) {
        let index = $pos.index(d), parent = $pos.node(d);
        // At the start of this parent, look at next one
        if (index == 0) {
            if (parent.type.spec.isolating)
                return true;
            continue;
        }
        // See if the node before (or its first ancestor) is closed
        for (let before = parent.child(index - 1);; before = before.lastChild) {
            if ((before.childCount == 0 && !before.inlineContent) || before.isAtom || before.type.spec.isolating)
                return true;
            if (before.inlineContent)
                return false;
        }
    }
    // Hit start of document
    return true;
}
function closedAfter($pos) {
    for (let d = $pos.depth; d >= 0; d--) {
        let index = $pos.indexAfter(d), parent = $pos.node(d);
        if (index == parent.childCount) {
            if (parent.type.spec.isolating)
                return true;
            continue;
        }
        for (let after = parent.child(index);; after = after.firstChild) {
            if ((after.childCount == 0 && !after.inlineContent) || after.isAtom || after.type.spec.isolating)
                return true;
            if (after.inlineContent)
                return false;
        }
    }
    return true;
}

/**
Create a gap cursor plugin. When enabled, this will capture clicks
near and arrow-key-motion past places that don't have a normally
selectable position nearby, and create a gap cursor selection for
them. The cursor is drawn as an element with class
`ProseMirror-gapcursor`. You can either include
`style/gapcursor.css` from the package's directory or add your own
styles to make it visible.
*/
function gapCursor() {
    return new Plugin({
        props: {
            decorations: drawGapCursor,
            createSelectionBetween(_view, $anchor, $head) {
                return $anchor.pos == $head.pos && GapCursor.valid($head) ? new GapCursor($head) : null;
            },
            handleClick,
            handleKeyDown,
            handleDOMEvents: { beforeinput: beforeinput }
        }
    });
}
const handleKeyDown = keydownHandler({
    "ArrowLeft": dist_arrow("horiz", -1),
    "ArrowRight": dist_arrow("horiz", 1),
    "ArrowUp": dist_arrow("vert", -1),
    "ArrowDown": dist_arrow("vert", 1)
});
function dist_arrow(axis, dir) {
    const dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
    return function (state, dispatch, view) {
        let sel = state.selection;
        let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
        if (sel instanceof TextSelection) {
            if (!view.endOfTextblock(dirStr) || $start.depth == 0)
                return false;
            mustMove = false;
            $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
        }
        let $found = GapCursor.findGapCursorFrom($start, dir, mustMove);
        if (!$found)
            return false;
        if (dispatch)
            dispatch(state.tr.setSelection(new GapCursor($found)));
        return true;
    };
}
function handleClick(view, pos, event) {
    if (!view || !view.editable)
        return false;
    let $pos = view.state.doc.resolve(pos);
    if (!GapCursor.valid($pos))
        return false;
    let clickPos = view.posAtCoords({ left: event.clientX, top: event.clientY });
    if (clickPos && clickPos.inside > -1 && dist_NodeSelection.isSelectable(view.state.doc.nodeAt(clickPos.inside)))
        return false;
    view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
    return true;
}
// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function beforeinput(view, event) {
    if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor))
        return false;
    let { $from } = view.state.selection;
    let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
    if (!insert)
        return false;
    let frag = dist_Fragment.empty;
    for (let i = insert.length - 1; i >= 0; i--)
        frag = dist_Fragment.from(insert[i].createAndFill(null, frag));
    let tr = view.state.tr.replace($from.pos, $from.pos, new dist_Slice(frag, 0, 0));
    tr.setSelection(TextSelection.near(tr.doc.resolve($from.pos + 1)));
    view.dispatch(tr);
    return false;
}
function drawGapCursor(state) {
    if (!(state.selection instanceof GapCursor))
        return null;
    let node = document.createElement("div");
    node.className = "ProseMirror-gapcursor";
    return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node, { key: "gapcursor" })]);
}



;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-gapcursor/dist/index.js



/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */
const Gapcursor = Extension.create({
    name: 'gapCursor',
    addProseMirrorPlugins() {
        return [
            gapCursor(),
        ];
    },
    extendNodeSchema(extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        return {
            allowGapCursor: (_a = callOrReturn(getExtensionField(extension, 'allowGapCursor', context))) !== null && _a !== void 0 ? _a : null,
        };
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-hard-break/dist/index.js


/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */
const HardBreak = dist_Node.create({
    name: 'hardBreak',
    addOptions() {
        return {
            keepMarks: true,
            HTMLAttributes: {},
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    linebreakReplacement: true,
    parseHTML() {
        return [
            { tag: 'br' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['br', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    renderText() {
        return '\n';
    },
    addCommands() {
        return {
            setHardBreak: () => ({ commands, chain, state, editor, }) => {
                return commands.first([
                    () => commands.exitCode(),
                    () => commands.command(() => {
                        const { selection, storedMarks } = state;
                        if (selection.$from.parent.type.spec.isolating) {
                            return false;
                        }
                        const { keepMarks } = this.options;
                        const { splittableMarks } = editor.extensionManager;
                        const marks = storedMarks
                            || (selection.$to.parentOffset && selection.$from.marks());
                        return chain()
                            .insertContent({ type: this.name })
                            .command(({ tr, dispatch }) => {
                            if (dispatch && marks && keepMarks) {
                                const filteredMarks = marks
                                    .filter(mark => splittableMarks.includes(mark.type.name));
                                tr.ensureMarks(filteredMarks);
                            }
                            return true;
                        })
                            .run();
                    }),
                ]);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Enter': () => this.editor.commands.setHardBreak(),
            'Shift-Enter': () => this.editor.commands.setHardBreak(),
        };
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-heading/dist/index.js


/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */
const Heading = dist_Node.create({
    name: 'heading',
    addOptions() {
        return {
            levels: [1, 2, 3, 4, 5, 6],
            HTMLAttributes: {},
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes() {
        return {
            level: {
                default: 1,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return this.options.levels
            .map((level) => ({
            tag: `h${level}`,
            attrs: { level },
        }));
    },
    renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel
            ? node.attrs.level
            : this.options.levels[0];
        return [`h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.setNode(this.name, attributes);
            },
            toggleHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return this.options.levels.reduce((items, level) => ({
            ...items,
            ...{
                [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level }),
            },
        }), {});
    },
    addInputRules() {
        return this.options.levels.map(level => {
            return textblockTypeInputRule({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level,
                },
            });
        });
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/rope-sequence/dist/index.js
var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

/* harmony default export */ var rope_sequence_dist = (RopeSequence);

;// CONCATENATED MODULE: ./node_modules/prosemirror-history/dist/index.js




// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const max_empty_items = 500;
class Branch {
    constructor(items, eventCount) {
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0)
            return null;
        let end = this.items.length;
        for (;; end--) {
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i) => {
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map)
                    remap.appendMap(map, mapFrom);
            }
            else {
                transform.maybeStep(item.step);
            }
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return { remaining: remaining, transform, selection: selection };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for (let i = 0; i < transform.steps.length; i++) {
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i)
                    newItems.pop();
                else
                    oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems)
                lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > DEPTH_OVERFLOW) {
            oldItems = cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new Mapping;
        this.items.forEach((item, i) => {
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
                ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0)
            return this;
        return new Branch(this.items.append(array.map(map => new Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount)
            return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach(item => { if (item.selection)
            eventCount--; }, start);
        let iRebased = rebasedCount;
        this.items.forEach(item => {
            let pos = mapping.getMirror(--iRebased);
            if (pos == null)
                return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection)
                    eventCount++;
                rebasedItems.push(new Item(map, step, selection));
            }
            else {
                rebasedItems.push(new Item(map));
            }
        }, start);
        let newMaps = [];
        for (let i = rebasedCount; i < newUntil; i++)
            newMaps.push(new Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new Branch(items, eventCount);
        if (branch.emptyItemCount() > max_empty_items)
            branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach(item => { if (!item.step)
            count++; });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i) => {
            if (i >= upto) {
                items.push(item);
                if (item.selection)
                    events++;
            }
            else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map)
                    remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection)
                        events++;
                    let newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem))
                        items[last] = merged;
                    else
                        items.push(newItem);
                }
            }
            else if (item.map) {
                mapFrom--;
            }
        }, this.items.length, 0);
        return new Branch(rope_sequence_dist.from(items.reverse()), events);
    }
}
Branch.empty = new Branch(rope_sequence_dist.empty, 0);
function cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i) => {
        if (item.selection && (n-- == 0)) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class Item {
    constructor(
    // The (forward) step map for this item.
    map, 
    // The inverted step
    step, 
    // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, 
    // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset) {
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step)
                return new Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition) {
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta(historyKey), rebased;
    if (historyTr)
        return historyTr.historyState;
    if (tr.getMeta(closeHistoryKey))
        history = new HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) {
        return history;
    }
    else if (appended && appended.getMeta(historyKey)) {
        if (appended.getMeta(historyKey).redo)
            return new HistoryState(history.done.addTransform(tr, undefined, options, mustPreserveItems(state)), history.undone, rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else
            return new HistoryState(history.done, history.undone.addTransform(tr, undefined, options, mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    }
    else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 ||
            (!appended && history.prevComposition != composition &&
                (history.prevTime < (tr.time || 0) - options.newGroupDelay || !isAdjacentTo(tr, history.prevRanges)));
        let prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps);
        return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    }
    else if (rebased = tr.getMeta("rebased")) {
        // Used by the collab module to tell the history that some of its
        // content has been rebased.
        return new HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    }
    else {
        return new HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    }
}
function isAdjacentTo(transform, prevRanges) {
    if (!prevRanges)
        return false;
    if (!transform.docChanged)
        return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end) => {
        for (let i = 0; i < prevRanges.length; i += 2)
            if (start <= prevRanges[i + 1] && end >= prevRanges[i])
                adjacent = true;
    });
    return adjacent;
}
function rangesFor(maps) {
    let result = [];
    for (let i = maps.length - 1; i >= 0 && result.length == 0; i--)
        maps[i].forEach((_from, _to, from, to) => result.push(from, to));
    return result;
}
function mapRanges(ranges, mapping) {
    if (!ranges)
        return null;
    let result = [];
    for (let i = 0; i < ranges.length; i += 2) {
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to)
            result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, redo) {
    let preserveItems = mustPreserveItems(state);
    let histOptions = historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop)
        return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta(historyKey, { redo, historyState: newHist });
}
let cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
    let plugins = state.plugins;
    if (cachedPreserveItemsPlugins != plugins) {
        cachedPreserveItems = false;
        cachedPreserveItemsPlugins = plugins;
        for (let i = 0; i < plugins.length; i++)
            if (plugins[i].spec.historyPreserveItems) {
                cachedPreserveItems = true;
                break;
            }
    }
    return cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/
function closeHistory(tr) {
    return tr.setMeta(closeHistoryKey, true);
}
const historyKey = new PluginKey("history");
const closeHistoryKey = new PluginKey("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/
function dist_history(config = {}) {
    config = { depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500 };
    return new Plugin({
        key: historyKey,
        state: {
            init() {
                return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
            },
            apply(tr, hist, state) {
                return applyTransaction(hist, state, tr, config);
            }
        },
        config,
        props: {
            handleDOMEvents: {
                beforeinput(view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
                    if (!command)
                        return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function buildCommand(redo, scroll) {
    return (state, dispatch) => {
        let hist = historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0)
            return false;
        if (dispatch) {
            let tr = histTransaction(hist, state, redo);
            if (tr)
                dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/
const undo = buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/
const redo = buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/
const undoNoScroll = buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/
const redoNoScroll = buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/
function undoDepth(state) {
    let hist = historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/
function redoDepth(state) {
    let hist = historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}



;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-history/dist/index.js



/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */
const History = Extension.create({
    name: 'history',
    addOptions() {
        return {
            depth: 100,
            newGroupDelay: 500,
        };
    },
    addCommands() {
        return {
            undo: () => ({ state, dispatch }) => {
                return undo(state, dispatch);
            },
            redo: () => ({ state, dispatch }) => {
                return redo(state, dispatch);
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            dist_history(this.options),
        ];
    },
    addKeyboardShortcuts() {
        return {
            'Mod-z': () => this.editor.commands.undo(),
            'Shift-Mod-z': () => this.editor.commands.redo(),
            'Mod-y': () => this.editor.commands.redo(),
            // Russian keyboard layouts
            'Mod-я': () => this.editor.commands.undo(),
            'Shift-Mod-я': () => this.editor.commands.redo(),
        };
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-horizontal-rule/dist/index.js



/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */
const HorizontalRule = dist_Node.create({
    name: 'horizontalRule',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    parseHTML() {
        return [{ tag: 'hr' }];
    },
    renderHTML({ HTMLAttributes }) {
        return ['hr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands() {
        return {
            setHorizontalRule: () => ({ chain, state }) => {
                const { selection } = state;
                const { $from: $originFrom, $to: $originTo } = selection;
                const currentChain = chain();
                if ($originFrom.parentOffset === 0) {
                    currentChain.insertContentAt({
                        from: Math.max($originFrom.pos - 1, 0),
                        to: $originTo.pos,
                    }, {
                        type: this.name,
                    });
                }
                else if (isNodeSelection(selection)) {
                    currentChain.insertContentAt($originTo.pos, {
                        type: this.name,
                    });
                }
                else {
                    currentChain.insertContent({ type: this.name });
                }
                return (currentChain
                    // set cursor after horizontal rule
                    .command(({ tr, dispatch }) => {
                    var _a;
                    if (dispatch) {
                        const { $to } = tr.selection;
                        const posAfter = $to.end();
                        if ($to.nodeAfter) {
                            if ($to.nodeAfter.isTextblock) {
                                tr.setSelection(TextSelection.create(tr.doc, $to.pos + 1));
                            }
                            else if ($to.nodeAfter.isBlock) {
                                tr.setSelection(dist_NodeSelection.create(tr.doc, $to.pos));
                            }
                            else {
                                tr.setSelection(TextSelection.create(tr.doc, $to.pos));
                            }
                        }
                        else {
                            // add node after horizontal rule if it’s the end of the document
                            const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                            if (node) {
                                tr.insert(posAfter, node);
                                tr.setSelection(TextSelection.create(tr.doc, posAfter + 1));
                            }
                        }
                        tr.scrollIntoView();
                    }
                    return true;
                })
                    .run());
            },
        };
    },
    addInputRules() {
        return [
            nodeInputRule({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-italic/dist/index.js


/**
 * Matches an italic to a *italic* on input.
 */
const dist_starInputRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */
const dist_starPasteRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */
const dist_underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */
const dist_underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */
const Italic = dist_Mark.create({
    name: 'italic',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'em',
            },
            {
                tag: 'i',
                getAttrs: node => node.style.fontStyle !== 'normal' && null,
            },
            {
                style: 'font-style=normal',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-style=italic',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setItalic: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleItalic: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetItalic: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-i': () => this.editor.commands.toggleItalic(),
            'Mod-I': () => this.editor.commands.toggleItalic(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: dist_starInputRegex,
                type: this.type,
            }),
            markInputRule({
                find: dist_underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: dist_starPasteRegex,
                type: this.type,
            }),
            markPasteRule({
                find: dist_underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-list-item/dist/index.js


/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */
const ListItem = dist_Node.create({
    name: 'listItem',
    addOptions() {
        return {
            HTMLAttributes: {},
            bulletListTypeName: 'bulletList',
            orderedListTypeName: 'orderedList',
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML() {
        return [
            {
                tag: 'li',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addKeyboardShortcuts() {
        return {
            Enter: () => this.editor.commands.splitListItem(this.name),
            Tab: () => this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': () => this.editor.commands.liftListItem(this.name),
        };
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-ordered-list/dist/index.js


const dist_ListItemName = 'listItem';
const dist_TextStyleName = 'textStyle';
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */
const extension_ordered_list_dist_inputRegex = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */
const OrderedList = dist_Node.create({
    name: 'orderedList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false,
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes() {
        return {
            start: {
                default: 1,
                parseHTML: element => {
                    return element.hasAttribute('start')
                        ? parseInt(element.getAttribute('start') || '', 10)
                        : 1;
                },
            },
            type: {
                default: undefined,
                parseHTML: element => element.getAttribute('type'),
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'ol',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        const { start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1
            ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0]
            : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleOrderedList: () => ({ commands, chain }) => {
                if (this.options.keepAttributes) {
                    return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(dist_ListItemName, this.editor.getAttributes(dist_TextStyleName)).run();
                }
                return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-7': () => this.editor.commands.toggleOrderedList(),
        };
    },
    addInputRules() {
        let inputRule = wrappingInputRule({
            find: extension_ordered_list_dist_inputRegex,
            type: this.type,
            getAttributes: match => ({ start: +match[1] }),
            joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
        });
        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = wrappingInputRule({
                find: extension_ordered_list_dist_inputRegex,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: match => ({ start: +match[1], ...this.editor.getAttributes(dist_TextStyleName) }),
                joinPredicate: (match, node) => node.childCount + node.attrs.start === +match[1],
                editor: this.editor,
            });
        }
        return [
            inputRule,
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-paragraph/dist/index.js


/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */
const Paragraph = dist_Node.create({
    name: 'paragraph',
    priority: 1000,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML() {
        return [
            { tag: 'p' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setParagraph: () => ({ commands }) => {
                return commands.setNode(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-0': () => this.editor.commands.setParagraph(),
        };
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-strike/dist/index.js


/**
 * Matches a strike to a ~~strike~~ on input.
 */
const extension_strike_dist_inputRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */
const dist_pasteRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */
const Strike = dist_Mark.create({
    name: 'strike',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 's',
            },
            {
                tag: 'del',
            },
            {
                tag: 'strike',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('line-through') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['s', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setStrike: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleStrike: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetStrike: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-s': () => this.editor.commands.toggleStrike(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: extension_strike_dist_inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: dist_pasteRegex,
                type: this.type,
            }),
        ];
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-text/dist/index.js


/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */
const Text = dist_Node.create({
    name: 'text',
    group: 'inline',
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@tiptap/starter-kit/dist/index.js




















/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */
const StarterKit = Extension.create({
    name: 'starterKit',
    addExtensions() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const extensions = [];
        if (this.options.bold !== false) {
            extensions.push(Bold.configure((_a = this.options) === null || _a === void 0 ? void 0 : _a.bold));
        }
        if (this.options.blockquote !== false) {
            extensions.push(Blockquote.configure((_b = this.options) === null || _b === void 0 ? void 0 : _b.blockquote));
        }
        if (this.options.bulletList !== false) {
            extensions.push(BulletList.configure((_c = this.options) === null || _c === void 0 ? void 0 : _c.bulletList));
        }
        if (this.options.code !== false) {
            extensions.push(Code.configure((_d = this.options) === null || _d === void 0 ? void 0 : _d.code));
        }
        if (this.options.codeBlock !== false) {
            extensions.push(CodeBlock.configure((_e = this.options) === null || _e === void 0 ? void 0 : _e.codeBlock));
        }
        if (this.options.document !== false) {
            extensions.push(Document.configure((_f = this.options) === null || _f === void 0 ? void 0 : _f.document));
        }
        if (this.options.dropcursor !== false) {
            extensions.push(Dropcursor.configure((_g = this.options) === null || _g === void 0 ? void 0 : _g.dropcursor));
        }
        if (this.options.gapcursor !== false) {
            extensions.push(Gapcursor.configure((_h = this.options) === null || _h === void 0 ? void 0 : _h.gapcursor));
        }
        if (this.options.hardBreak !== false) {
            extensions.push(HardBreak.configure((_j = this.options) === null || _j === void 0 ? void 0 : _j.hardBreak));
        }
        if (this.options.heading !== false) {
            extensions.push(Heading.configure((_k = this.options) === null || _k === void 0 ? void 0 : _k.heading));
        }
        if (this.options.history !== false) {
            extensions.push(History.configure((_l = this.options) === null || _l === void 0 ? void 0 : _l.history));
        }
        if (this.options.horizontalRule !== false) {
            extensions.push(HorizontalRule.configure((_m = this.options) === null || _m === void 0 ? void 0 : _m.horizontalRule));
        }
        if (this.options.italic !== false) {
            extensions.push(Italic.configure((_o = this.options) === null || _o === void 0 ? void 0 : _o.italic));
        }
        if (this.options.listItem !== false) {
            extensions.push(ListItem.configure((_p = this.options) === null || _p === void 0 ? void 0 : _p.listItem));
        }
        if (this.options.orderedList !== false) {
            extensions.push(OrderedList.configure((_q = this.options) === null || _q === void 0 ? void 0 : _q.orderedList));
        }
        if (this.options.paragraph !== false) {
            extensions.push(Paragraph.configure((_r = this.options) === null || _r === void 0 ? void 0 : _r.paragraph));
        }
        if (this.options.strike !== false) {
            extensions.push(Strike.configure((_s = this.options) === null || _s === void 0 ? void 0 : _s.strike));
        }
        if (this.options.text !== false) {
            extensions.push(Text.configure((_t = this.options) === null || _t === void 0 ? void 0 : _t.text));
        }
        return extensions;
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/linkifyjs/dist/linkify.es.js
// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const encodedTlds = 'aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2';
// Internationalized domain names containing non-ASCII
const encodedUtlds = 'ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2';

/**
 * @template A
 * @template B
 * @param {A} target
 * @param {B} properties
 * @return {A & B}
 */
const linkify_es_assign = (target, properties) => {
  for (const key in properties) {
    target[key] = properties[key];
  }
  return target;
};

/**
 * Finite State Machine generation utilities
 */

/**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */

/**
 * @typedef {{ [group: string]: true }} Flags
 */

// Keys in scanner Collections instances
const numeric = 'numeric';
const ascii = 'ascii';
const alpha = 'alpha';
const asciinumeric = 'asciinumeric';
const alphanumeric = 'alphanumeric';
const domain = 'domain';
const emoji = 'emoji';
const scheme = 'scheme';
const slashscheme = 'slashscheme';
const whitespace = 'whitespace';

/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */
function registerGroup(name, groups) {
  if (!(name in groups)) {
    groups[name] = [];
  }
  return groups[name];
}

/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */
function addToGroups(t, flags, groups) {
  if (flags[numeric]) {
    flags[asciinumeric] = true;
    flags[alphanumeric] = true;
  }
  if (flags[ascii]) {
    flags[asciinumeric] = true;
    flags[alpha] = true;
  }
  if (flags[asciinumeric]) {
    flags[alphanumeric] = true;
  }
  if (flags[alpha]) {
    flags[alphanumeric] = true;
  }
  if (flags[alphanumeric]) {
    flags[domain] = true;
  }
  if (flags[emoji]) {
    flags[domain] = true;
  }
  for (const k in flags) {
    const group = registerGroup(k, groups);
    if (group.indexOf(t) < 0) {
      group.push(t);
    }
  }
}

/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */
function flagsForToken(t, groups) {
  const result = {};
  for (const c in groups) {
    if (groups[c].indexOf(t) >= 0) {
      result[c] = true;
    }
  }
  return result;
}

/**
 * @template T
 * @typedef {null | T } Transition
 */

/**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */
function State(token = null) {
  // this.n = null; // DEBUG: State name
  /** @type {{ [input: string]: State<T> }} j */
  this.j = {}; // IMPLEMENTATION 1
  // this.j = []; // IMPLEMENTATION 2
  /** @type {[RegExp, State<T>][]} jr */
  this.jr = [];
  /** @type {?State<T>} jd */
  this.jd = null;
  /** @type {?T} t */
  this.t = token;
}

/**
 * Scanner token groups
 * @type Collections<string>
 */
State.groups = {};
State.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(input) {
    const state = this;
    const nextState = state.j[input];
    if (nextState) {
      return nextState;
    }
    for (let i = 0; i < state.jr.length; i++) {
      const regex = state.jr[i][0];
      const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
      if (nextState && regex.test(input)) {
        return nextState;
      }
    }
    // Nowhere left to jump! Return default, if any
    return state.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(input, exactOnly = false) {
    return exactOnly ? input in this.j : !!this.go(input);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(inputs, next, flags, groups) {
    for (let i = 0; i < inputs.length; i++) {
      this.tt(inputs[i], next, flags, groups);
    }
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(regexp, next, flags, groups) {
    groups = groups || State.groups;
    let nextState;
    if (next && next.j) {
      nextState = next;
    } else {
      // Token with maybe token groups
      nextState = new State(next);
      if (flags && groups) {
        addToGroups(next, flags, groups);
      }
    }
    this.jr.push([regexp, nextState]);
    return nextState;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(input, next, flags, groups) {
    let state = this;
    const len = input.length;
    if (!len) {
      return state;
    }
    for (let i = 0; i < len - 1; i++) {
      state = state.tt(input[i]);
    }
    return state.tt(input[len - 1], next, flags, groups);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(input, next, flags, groups) {
    groups = groups || State.groups;
    const state = this;

    // Check if existing state given, just a basic transition
    if (next && next.j) {
      state.j[input] = next;
      return next;
    }
    const t = next;

    // Take the transition with the usual default mechanisms and use that as
    // a template for creating the next state
    let nextState,
      templateState = state.go(input);
    if (templateState) {
      nextState = new State();
      linkify_es_assign(nextState.j, templateState.j);
      nextState.jr.push.apply(nextState.jr, templateState.jr);
      nextState.jd = templateState.jd;
      nextState.t = templateState.t;
    } else {
      nextState = new State();
    }
    if (t) {
      // Ensure newly token is in the same groups as the old token
      if (groups) {
        if (nextState.t && typeof nextState.t === 'string') {
          const allFlags = linkify_es_assign(flagsForToken(nextState.t, groups), flags);
          addToGroups(t, allFlags, groups);
        } else if (flags) {
          addToGroups(t, flags, groups);
        }
      }
      nextState.t = t; // overwrite anything that was previously there
    }
    state.j[input] = nextState;
    return nextState;
  }
};

// Helper functions to improve minification (not exported outside linkifyjs module)

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ta = (state, input, next, flags, groups) => state.ta(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const tr = (state, regexp, next, flags, groups) => state.tr(regexp, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ts = (state, input, next, flags, groups) => state.ts(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */
const tt = (state, input, next, flags, groups) => state.tt(input, next, flags, groups);

/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/

// A valid web domain token
const WORD = 'WORD'; // only contains a-z
const UWORD = 'UWORD'; // contains letters other than a-z, used for IDN
const ASCIINUMERICAL = 'ASCIINUMERICAL'; // contains a-z, 0-9
const ALPHANUMERICAL = 'ALPHANUMERICAL'; // contains numbers and letters other than a-z, used for IDN

// Special case of word
const LOCALHOST = 'LOCALHOST';

// Valid top-level domain, special case of WORD (see tlds.js)
const TLD = 'TLD';

// Valid IDN TLD, special case of UWORD (see tlds.js)
const UTLD = 'UTLD';

// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const SCHEME = 'SCHEME';

// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const SLASH_SCHEME = 'SLASH_SCHEME';

// Any sequence of digits 0-9
const NUM = 'NUM';

// Any number of consecutive whitespace characters that are not newline
const WS = 'WS';

// New line (unix style)
const NL = 'NL'; // \n

// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const OPENBRACE = 'OPENBRACE'; // {
const CLOSEBRACE = 'CLOSEBRACE'; // }
const OPENBRACKET = 'OPENBRACKET'; // [
const CLOSEBRACKET = 'CLOSEBRACKET'; // ]
const OPENPAREN = 'OPENPAREN'; // (
const CLOSEPAREN = 'CLOSEPAREN'; // )
const OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <
const CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >
const FULLWIDTHLEFTPAREN = 'FULLWIDTHLEFTPAREN'; // （
const FULLWIDTHRIGHTPAREN = 'FULLWIDTHRIGHTPAREN'; // ）
const LEFTCORNERBRACKET = 'LEFTCORNERBRACKET'; // 「
const RIGHTCORNERBRACKET = 'RIGHTCORNERBRACKET'; // 」
const LEFTWHITECORNERBRACKET = 'LEFTWHITECORNERBRACKET'; // 『
const RIGHTWHITECORNERBRACKET = 'RIGHTWHITECORNERBRACKET'; // 』
const FULLWIDTHLESSTHAN = 'FULLWIDTHLESSTHAN'; // ＜
const FULLWIDTHGREATERTHAN = 'FULLWIDTHGREATERTHAN'; // ＞

// Various symbols
const AMPERSAND = 'AMPERSAND'; // &
const APOSTROPHE = 'APOSTROPHE'; // '
const ASTERISK = 'ASTERISK'; // *
const AT = 'AT'; // @
const BACKSLASH = 'BACKSLASH'; // \
const BACKTICK = 'BACKTICK'; // `
const CARET = 'CARET'; // ^
const COLON = 'COLON'; // :
const COMMA = 'COMMA'; // ,
const DOLLAR = 'DOLLAR'; // $
const DOT = 'DOT'; // .
const EQUALS = 'EQUALS'; // =
const EXCLAMATION = 'EXCLAMATION'; // !
const HYPHEN = 'HYPHEN'; // -
const PERCENT = 'PERCENT'; // %
const PIPE = 'PIPE'; // |
const PLUS = 'PLUS'; // +
const POUND = 'POUND'; // #
const QUERY = 'QUERY'; // ?
const QUOTE = 'QUOTE'; // "
const FULLWIDTHMIDDLEDOT = 'FULLWIDTHMIDDLEDOT'; // ・

const SEMI = 'SEMI'; // ;
const SLASH = 'SLASH'; // /
const TILDE = 'TILDE'; // ~
const UNDERSCORE = 'UNDERSCORE'; // _

// Emoji symbol
const EMOJI$1 = 'EMOJI';

// Default token - anything that is not one of the above
const SYM = 'SYM';

var tk = /*#__PURE__*/Object.freeze({
	__proto__: null,
	WORD: WORD,
	UWORD: UWORD,
	ASCIINUMERICAL: ASCIINUMERICAL,
	ALPHANUMERICAL: ALPHANUMERICAL,
	LOCALHOST: LOCALHOST,
	TLD: TLD,
	UTLD: UTLD,
	SCHEME: SCHEME,
	SLASH_SCHEME: SLASH_SCHEME,
	NUM: NUM,
	WS: WS,
	NL: NL,
	OPENBRACE: OPENBRACE,
	CLOSEBRACE: CLOSEBRACE,
	OPENBRACKET: OPENBRACKET,
	CLOSEBRACKET: CLOSEBRACKET,
	OPENPAREN: OPENPAREN,
	CLOSEPAREN: CLOSEPAREN,
	OPENANGLEBRACKET: OPENANGLEBRACKET,
	CLOSEANGLEBRACKET: CLOSEANGLEBRACKET,
	FULLWIDTHLEFTPAREN: FULLWIDTHLEFTPAREN,
	FULLWIDTHRIGHTPAREN: FULLWIDTHRIGHTPAREN,
	LEFTCORNERBRACKET: LEFTCORNERBRACKET,
	RIGHTCORNERBRACKET: RIGHTCORNERBRACKET,
	LEFTWHITECORNERBRACKET: LEFTWHITECORNERBRACKET,
	RIGHTWHITECORNERBRACKET: RIGHTWHITECORNERBRACKET,
	FULLWIDTHLESSTHAN: FULLWIDTHLESSTHAN,
	FULLWIDTHGREATERTHAN: FULLWIDTHGREATERTHAN,
	AMPERSAND: AMPERSAND,
	APOSTROPHE: APOSTROPHE,
	ASTERISK: ASTERISK,
	AT: AT,
	BACKSLASH: BACKSLASH,
	BACKTICK: BACKTICK,
	CARET: CARET,
	COLON: COLON,
	COMMA: COMMA,
	DOLLAR: DOLLAR,
	DOT: DOT,
	EQUALS: EQUALS,
	EXCLAMATION: EXCLAMATION,
	HYPHEN: HYPHEN,
	PERCENT: PERCENT,
	PIPE: PIPE,
	PLUS: PLUS,
	POUND: POUND,
	QUERY: QUERY,
	QUOTE: QUOTE,
	FULLWIDTHMIDDLEDOT: FULLWIDTHMIDDLEDOT,
	SEMI: SEMI,
	SLASH: SLASH,
	TILDE: TILDE,
	UNDERSCORE: UNDERSCORE,
	EMOJI: EMOJI$1,
	SYM: SYM
});

// Note that these two Unicode ones expand into a really big one with Babel
const ASCII_LETTER = /[a-z]/;
const LETTER = /\p{L}/u; // Any Unicode character with letter data type
const EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const EMOJI_VARIATION$1 = /\ufe0f/;
const DIGIT = /\d/;
const SPACE = /\s/;

var regexp = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ASCII_LETTER: ASCII_LETTER,
	LETTER: LETTER,
	EMOJI: EMOJI,
	EMOJI_VARIATION: EMOJI_VARIATION$1,
	DIGIT: DIGIT,
	SPACE: SPACE
});

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/
const CR = '\r'; // carriage-return character
const LF = '\n'; // line-feed character
const EMOJI_VARIATION = '\ufe0f'; // Variation selector, follows heart and others
const EMOJI_JOINER = '\u200d'; // zero-width joiner
const OBJECT_REPLACEMENT = '\ufffc'; // whitespace placeholder that sometimes appears in rich text editors

let tlds = null,
  utlds = null; // don't change so only have to be computed once

/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */

/**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */

/**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */
function init$2(customSchemes = []) {
  // Frequently used states (name argument removed during minification)
  /** @type Collections<string> */
  const groups = {}; // of tokens
  State.groups = groups;
  /** @type State<string> */
  const Start = new State();
  if (tlds == null) {
    tlds = decodeTlds(encodedTlds);
  }
  if (utlds == null) {
    utlds = decodeTlds(encodedUtlds);
  }

  // States for special URL symbols that accept immediately after start
  tt(Start, "'", APOSTROPHE);
  tt(Start, '{', OPENBRACE);
  tt(Start, '}', CLOSEBRACE);
  tt(Start, '[', OPENBRACKET);
  tt(Start, ']', CLOSEBRACKET);
  tt(Start, '(', OPENPAREN);
  tt(Start, ')', CLOSEPAREN);
  tt(Start, '<', OPENANGLEBRACKET);
  tt(Start, '>', CLOSEANGLEBRACKET);
  tt(Start, '（', FULLWIDTHLEFTPAREN);
  tt(Start, '）', FULLWIDTHRIGHTPAREN);
  tt(Start, '「', LEFTCORNERBRACKET);
  tt(Start, '」', RIGHTCORNERBRACKET);
  tt(Start, '『', LEFTWHITECORNERBRACKET);
  tt(Start, '』', RIGHTWHITECORNERBRACKET);
  tt(Start, '＜', FULLWIDTHLESSTHAN);
  tt(Start, '＞', FULLWIDTHGREATERTHAN);
  tt(Start, '&', AMPERSAND);
  tt(Start, '*', ASTERISK);
  tt(Start, '@', AT);
  tt(Start, '`', BACKTICK);
  tt(Start, '^', CARET);
  tt(Start, ':', COLON);
  tt(Start, ',', COMMA);
  tt(Start, '$', DOLLAR);
  tt(Start, '.', DOT);
  tt(Start, '=', EQUALS);
  tt(Start, '!', EXCLAMATION);
  tt(Start, '-', HYPHEN);
  tt(Start, '%', PERCENT);
  tt(Start, '|', PIPE);
  tt(Start, '+', PLUS);
  tt(Start, '#', POUND);
  tt(Start, '?', QUERY);
  tt(Start, '"', QUOTE);
  tt(Start, '/', SLASH);
  tt(Start, ';', SEMI);
  tt(Start, '~', TILDE);
  tt(Start, '_', UNDERSCORE);
  tt(Start, '\\', BACKSLASH);
  tt(Start, '・', FULLWIDTHMIDDLEDOT);
  const Num = tr(Start, DIGIT, NUM, {
    [numeric]: true
  });
  tr(Num, DIGIT, Num);
  const Asciinumeric = tr(Num, ASCII_LETTER, ASCIINUMERICAL, {
    [asciinumeric]: true
  });
  const Alphanumeric = tr(Num, LETTER, ALPHANUMERICAL, {
    [alphanumeric]: true
  });

  // State which emits a word token
  const Word = tr(Start, ASCII_LETTER, WORD, {
    [ascii]: true
  });
  tr(Word, DIGIT, Asciinumeric);
  tr(Word, ASCII_LETTER, Word);
  tr(Asciinumeric, DIGIT, Asciinumeric);
  tr(Asciinumeric, ASCII_LETTER, Asciinumeric);

  // Same as previous, but specific to non-fsm.ascii alphabet words
  const UWord = tr(Start, LETTER, UWORD, {
    [alpha]: true
  });
  tr(UWord, ASCII_LETTER); // Non-accepting
  tr(UWord, DIGIT, Alphanumeric);
  tr(UWord, LETTER, UWord);
  tr(Alphanumeric, DIGIT, Alphanumeric);
  tr(Alphanumeric, ASCII_LETTER); // Non-accepting
  tr(Alphanumeric, LETTER, Alphanumeric); // Non-accepting

  // Whitespace jumps
  // Tokens of only non-newline whitespace are arbitrarily long
  // If any whitespace except newline, more whitespace!
  const Nl = tt(Start, LF, NL, {
    [whitespace]: true
  });
  const Cr = tt(Start, CR, WS, {
    [whitespace]: true
  });
  const Ws = tr(Start, SPACE, WS, {
    [whitespace]: true
  });
  tt(Start, OBJECT_REPLACEMENT, Ws);
  tt(Cr, LF, Nl); // \r\n
  tt(Cr, OBJECT_REPLACEMENT, Ws);
  tr(Cr, SPACE, Ws);
  tt(Ws, CR); // non-accepting state to avoid mixing whitespaces
  tt(Ws, LF); // non-accepting state to avoid mixing whitespaces
  tr(Ws, SPACE, Ws);
  tt(Ws, OBJECT_REPLACEMENT, Ws);

  // Emoji tokens. They are not grouped by the scanner except in cases where a
  // zero-width joiner is present
  const Emoji = tr(Start, EMOJI, EMOJI$1, {
    [emoji]: true
  });
  tt(Emoji, '#'); // no transition, emoji regex seems to match #
  tr(Emoji, EMOJI, Emoji);
  tt(Emoji, EMOJI_VARIATION, Emoji);
  // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy

  const EmojiJoiner = tt(Emoji, EMOJI_JOINER);
  tt(EmojiJoiner, '#');
  tr(EmojiJoiner, EMOJI, Emoji);
  // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy

  // Generates states for top-level domains
  // Note that this is most accurate when tlds are in alphabetical order
  const wordjr = [[ASCII_LETTER, Word], [DIGIT, Asciinumeric]];
  const uwordjr = [[ASCII_LETTER, null], [LETTER, UWord], [DIGIT, Alphanumeric]];
  for (let i = 0; i < tlds.length; i++) {
    fastts(Start, tlds[i], TLD, WORD, wordjr);
  }
  for (let i = 0; i < utlds.length; i++) {
    fastts(Start, utlds[i], UTLD, UWORD, uwordjr);
  }
  addToGroups(TLD, {
    tld: true,
    ascii: true
  }, groups);
  addToGroups(UTLD, {
    utld: true,
    alpha: true
  }, groups);

  // Collect the states generated by different protocols. NOTE: If any new TLDs
  // get added that are also protocols, set the token to be the same as the
  // protocol to ensure parsing works as expected.
  fastts(Start, 'file', SCHEME, WORD, wordjr);
  fastts(Start, 'mailto', SCHEME, WORD, wordjr);
  fastts(Start, 'http', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'https', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftp', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftps', SLASH_SCHEME, WORD, wordjr);
  addToGroups(SCHEME, {
    scheme: true,
    ascii: true
  }, groups);
  addToGroups(SLASH_SCHEME, {
    slashscheme: true,
    ascii: true
  }, groups);

  // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
  customSchemes = customSchemes.sort((a, b) => a[0] > b[0] ? 1 : -1);
  for (let i = 0; i < customSchemes.length; i++) {
    const sch = customSchemes[i][0];
    const optionalSlashSlash = customSchemes[i][1];
    const flags = optionalSlashSlash ? {
      [scheme]: true
    } : {
      [slashscheme]: true
    };
    if (sch.indexOf('-') >= 0) {
      flags[domain] = true;
    } else if (!ASCII_LETTER.test(sch)) {
      flags[numeric] = true; // numbers only
    } else if (DIGIT.test(sch)) {
      flags[asciinumeric] = true;
    } else {
      flags[ascii] = true;
    }
    ts(Start, sch, sch, flags);
  }

  // Localhost token
  ts(Start, 'localhost', LOCALHOST, {
    ascii: true
  });

  // Set default transition for start state (some symbol)
  Start.jd = new State(SYM);
  return {
    start: Start,
    tokens: linkify_es_assign({
      groups
    }, tk)
  };
}

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/
function linkify_es_run$1(start, str) {
  // State machine is not case sensitive, so input is tokenized in lowercased
  // form (still returns regular case). Uses selective `toLowerCase` because
  // lowercasing the entire string causes the length and character position to
  // vary in some non-English strings with V8-based runtimes.
  const iterable = stringToArray(str.replace(/[A-Z]/g, c => c.toLowerCase()));
  const charCount = iterable.length; // <= len if there are emojis, etc
  const tokens = []; // return value

  // cursor through the string itself, accounting for characters that have
  // width with length 2 such as emojis
  let cursor = 0;

  // Cursor through the array-representation of the string
  let charCursor = 0;

  // Tokenize the string
  while (charCursor < charCount) {
    let state = start;
    let nextState = null;
    let tokenLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    let charsSinceAccepts = -1;
    while (charCursor < charCount && (nextState = state.go(iterable[charCursor]))) {
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }
      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    }

    // Roll back to the latest accepting state
    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts;

    // No more jumps, just make a new token from the last accepting one
    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.slice(cursor - tokenLength, cursor),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor // end index (excluding)
    });
  }
  return tokens;
}

/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */
function stringToArray(str) {
  const result = [];
  const len = str.length;
  let index = 0;
  while (index < len) {
    let first = str.charCodeAt(index);
    let second;
    let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
    : str.slice(index, index + 2); // two-index characters
    result.push(char);
    index += char.length;
  }
  return result;
}

/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */
function fastts(state, input, t, defaultt, jr) {
  let next;
  const len = input.length;
  for (let i = 0; i < len - 1; i++) {
    const char = input[i];
    if (state.j[char]) {
      next = state.j[char];
    } else {
      next = new State(defaultt);
      next.jr = jr.slice();
      state.j[char] = next;
    }
    state = next;
  }
  next = new State(t);
  next.jr = jr.slice();
  state.j[input[len - 1]] = next;
  return next;
}

/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */
function decodeTlds(encoded) {
  const words = [];
  const stack = [];
  let i = 0;
  let digits = '0123456789';
  while (i < encoded.length) {
    let popDigitCount = 0;
    while (digits.indexOf(encoded[i + popDigitCount]) >= 0) {
      popDigitCount++; // encountered some digits, have to pop to go one level up trie
    }
    if (popDigitCount > 0) {
      words.push(stack.join('')); // whatever preceded the pop digits must be a word
      for (let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--) {
        stack.pop();
      }
      i += popDigitCount;
    } else {
      stack.push(encoded[i]); // drop down a level into the trie
      i++;
    }
  }
  return words;
}

/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */

/**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */

/**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */

/**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */

/**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */

/**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */

/**
 * @type Required<Opts>
 */
const defaults = {
  defaultProtocol: 'http',
  events: null,
  format: noop,
  formatHref: noop,
  nl2br: false,
  tagName: 'a',
  target: null,
  rel: null,
  validate: true,
  truncate: Infinity,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};

/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */
function Options(opts, defaultRender = null) {
  let o = linkify_es_assign({}, defaults);
  if (opts) {
    o = linkify_es_assign(o, opts instanceof Options ? opts.o : opts);
  }

  // Ensure all ignored tags are uppercase
  const ignoredTags = o.ignoreTags;
  const uppercaseIgnoredTags = [];
  for (let i = 0; i < ignoredTags.length; i++) {
    uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
  }
  /** @protected */
  this.o = o;
  if (defaultRender) {
    this.defaultRender = defaultRender;
  }
  this.ignoreTags = uppercaseIgnoredTags;
}
Options.prototype = {
  o: defaults,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(ir) {
    return ir;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(token) {
    return this.get('validate', token.toString(), token);
  },
  // Private methods

  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(key, operator, token) {
    const isCallable = operator != null;
    let option = this.o[key];
    if (!option) {
      return option;
    }
    if (typeof option === 'object') {
      option = token.t in option ? option[token.t] : defaults[key];
      if (typeof option === 'function' && isCallable) {
        option = option(operator, token);
      }
    } else if (typeof option === 'function' && isCallable) {
      option = option(operator, token.t, token);
    }
    return option;
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(key, operator, token) {
    let obj = this.o[key];
    if (typeof obj === 'function' && operator != null) {
      obj = obj(operator, token.t, token);
    }
    return obj;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(token) {
    const ir = token.render(this); // intermediate representation
    const renderFn = this.get('render', null, token) || this.defaultRender;
    return renderFn(ir, token.t, token);
  }
};
function noop(val) {
  return val;
}

var linkify_es_options = /*#__PURE__*/Object.freeze({
	__proto__: null,
	defaults: defaults,
	Options: Options,
	assign: linkify_es_assign
});

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

/**
 * @param {string} value
 * @param {Token[]} tokens
 */
function MultiToken(value, tokens) {
  this.t = 'token';
  this.v = value;
  this.tk = tokens;
}

/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */
MultiToken.prototype = {
  isLink: false,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(scheme) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(options) {
    const val = this.toString();
    const truncate = options.get('truncate', val, this);
    const formatted = options.get('format', val, this);
    return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + '…' : formatted;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(options) {
    return options.get('formatHref', this.toHref(options.get('defaultProtocol')), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(protocol = defaults.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(options) {
    return {
      type: this.t,
      value: this.toFormattedString(options),
      isLink: this.isLink,
      href: this.toFormattedHref(options),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(options) {
    return options.get('validate', this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(options) {
    const token = this;
    const href = this.toHref(options.get('defaultProtocol'));
    const formattedHref = options.get('formatHref', href, this);
    const tagName = options.get('tagName', href, token);
    const content = this.toFormattedString(options);
    const attributes = {};
    const className = options.get('className', href, token);
    const target = options.get('target', href, token);
    const rel = options.get('rel', href, token);
    const attrs = options.getObj('attributes', href, token);
    const eventListeners = options.getObj('events', href, token);
    attributes.href = formattedHref;
    if (className) {
      attributes.class = className;
    }
    if (target) {
      attributes.target = target;
    }
    if (rel) {
      attributes.rel = rel;
    }
    if (attrs) {
      linkify_es_assign(attributes, attrs);
    }
    return {
      tagName,
      attributes,
      content,
      eventListeners
    };
  }
};

/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */
function createTokenClass(type, props) {
  class Token extends MultiToken {
    constructor(value, tokens) {
      super(value, tokens);
      this.t = type;
    }
  }
  for (const p in props) {
    Token.prototype[p] = props[p];
  }
  Token.t = type;
  return Token;
}

/**
	Represents a list of tokens making up a valid email address
*/
const Email = createTokenClass('email', {
  isLink: true,
  toHref() {
    return 'mailto:' + this.toString();
  }
});

/**
	Represents some plain text
*/
const linkify_es_Text = createTokenClass('text');

/**
	Multi-linebreak token - represents a line break
	@class Nl
*/
const Nl = createTokenClass('nl');

/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/
const Url = createTokenClass('url', {
  isLink: true,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(scheme = defaults.defaultProtocol) {
    // Check if already has a prefix scheme
    return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const tokens = this.tk;
    return tokens.length >= 2 && tokens[0].t !== LOCALHOST && tokens[1].t === COLON;
  }
});

var multi = /*#__PURE__*/Object.freeze({
	__proto__: null,
	MultiToken: MultiToken,
	Base: MultiToken,
	createTokenClass: createTokenClass,
	Email: Email,
	Text: linkify_es_Text,
	Nl: Nl,
	Url: Url
});

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/
const makeState = arg => new State(arg);

/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */
function init$1({
  groups
}) {
  // Types of characters the URL can definitely end in
  const qsAccepting = groups.domain.concat([AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, NUM, PERCENT, PIPE, PLUS, POUND, SLASH, SYM, TILDE, UNDERSCORE]);

  // Types of tokens that can follow a URL and be part of the query string
  // but cannot be the very last characters
  // Characters that cannot appear in the URL at all should be excluded
  const qsNonAccepting = [COLON, COMMA, DOT, EXCLAMATION, PERCENT, QUERY, QUOTE, SEMI, OPENANGLEBRACKET, CLOSEANGLEBRACKET, OPENBRACE, CLOSEBRACE, CLOSEBRACKET, OPENBRACKET, OPENPAREN, CLOSEPAREN, FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN, LEFTCORNERBRACKET, RIGHTCORNERBRACKET, LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET, FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN];

  // For addresses without the mailto prefix
  // Tokens allowed in the localpart of the email
  const localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, OPENBRACE, CLOSEBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, UNDERSCORE];

  // The universal starting state.
  /**
   * @type State<Token>
   */
  const Start = makeState();
  const Localpart = tt(Start, TILDE); // Local part of the email address
  ta(Localpart, localpartAccepting, Localpart);
  ta(Localpart, groups.domain, Localpart);
  const Domain = makeState(),
    Scheme = makeState(),
    SlashScheme = makeState();
  ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
  ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
  ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'

  ta(Domain, localpartAccepting, Localpart);
  ta(Domain, groups.domain, Domain);
  const LocalpartAt = tt(Domain, AT); // Local part of the email address plus @

  tt(Localpart, AT, LocalpartAt); // close to an email address now

  // Local part of an email address can be e.g. 'http' or 'mailto'
  tt(Scheme, AT, LocalpartAt);
  tt(SlashScheme, AT, LocalpartAt);
  const LocalpartDot = tt(Localpart, DOT); // Local part of the email address plus '.' (localpart cannot end in .)
  ta(LocalpartDot, localpartAccepting, Localpart);
  ta(LocalpartDot, groups.domain, Localpart);
  const EmailDomain = makeState();
  ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
  ta(EmailDomain, groups.domain, EmailDomain);
  const EmailDomainDot = tt(EmailDomain, DOT); // domain followed by DOT
  ta(EmailDomainDot, groups.domain, EmailDomain);
  const Email$1 = makeState(Email); // Possible email address (could have more tlds)
  ta(EmailDomainDot, groups.tld, Email$1);
  ta(EmailDomainDot, groups.utld, Email$1);
  tt(LocalpartAt, LOCALHOST, Email$1);

  // Hyphen can jump back to a domain name
  const EmailDomainHyphen = tt(EmailDomain, HYPHEN); // parsed string starts with local email info + @ with a potential domain name
  tt(EmailDomainHyphen, HYPHEN, EmailDomainHyphen);
  ta(EmailDomainHyphen, groups.domain, EmailDomain);
  ta(Email$1, groups.domain, EmailDomain);
  tt(Email$1, DOT, EmailDomainDot);
  tt(Email$1, HYPHEN, EmailDomainHyphen);

  // Final possible email states
  const EmailColon = tt(Email$1, COLON); // URL followed by colon (potential port number here)
  /*const EmailColonPort = */
  ta(EmailColon, groups.numeric, Email); // URL followed by colon and port number

  // Account for dots and hyphens. Hyphens are usually parts of domain names
  // (but not TLDs)
  const DomainHyphen = tt(Domain, HYPHEN); // domain followed by hyphen
  const DomainDot = tt(Domain, DOT); // domain followed by DOT
  tt(DomainHyphen, HYPHEN, DomainHyphen);
  ta(DomainHyphen, groups.domain, Domain);
  ta(DomainDot, localpartAccepting, Localpart);
  ta(DomainDot, groups.domain, Domain);
  const DomainDotTld = makeState(Url); // Simplest possible URL with no query string
  ta(DomainDot, groups.tld, DomainDotTld);
  ta(DomainDot, groups.utld, DomainDotTld);
  ta(DomainDotTld, groups.domain, Domain);
  ta(DomainDotTld, localpartAccepting, Localpart);
  tt(DomainDotTld, DOT, DomainDot);
  tt(DomainDotTld, HYPHEN, DomainHyphen);
  tt(DomainDotTld, AT, LocalpartAt);
  const DomainDotTldColon = tt(DomainDotTld, COLON); // URL followed by colon (potential port number here)
  const DomainDotTldColonPort = makeState(Url); // TLD followed by a port number
  ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);

  // Long URL with optional port and maybe query string
  const Url$1 = makeState(Url);

  // URL with extra symbols at the end, followed by an opening bracket
  const UrlNonaccept = makeState(); // URL followed by some symbols (will not be part of the final URL)

  // Query strings
  ta(Url$1, qsAccepting, Url$1);
  ta(Url$1, qsNonAccepting, UrlNonaccept);
  ta(UrlNonaccept, qsAccepting, Url$1);
  ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);

  // Become real URLs after `SLASH` or `COLON NUM SLASH`
  // Here works with or without scheme:// prefix
  tt(DomainDotTld, SLASH, Url$1);
  tt(DomainDotTldColonPort, SLASH, Url$1);

  // Note that domains that begin with schemes are treated slighly differently
  const SchemeColon = tt(Scheme, COLON); // e.g., 'mailto:'
  const SlashSchemeColon = tt(SlashScheme, COLON); // e.g., 'http:'
  const SlashSchemeColonSlash = tt(SlashSchemeColon, SLASH); // e.g., 'http:/'

  const UriPrefix = tt(SlashSchemeColonSlash, SLASH); // e.g., 'http://'

  // Scheme states can transition to domain states
  ta(Scheme, groups.domain, Domain);
  tt(Scheme, DOT, DomainDot);
  tt(Scheme, HYPHEN, DomainHyphen);
  ta(SlashScheme, groups.domain, Domain);
  tt(SlashScheme, DOT, DomainDot);
  tt(SlashScheme, HYPHEN, DomainHyphen);

  // Force URL with scheme prefix followed by anything sane
  ta(SchemeColon, groups.domain, Url$1);
  tt(SchemeColon, SLASH, Url$1);
  tt(SchemeColon, QUERY, Url$1);
  ta(UriPrefix, groups.domain, Url$1);
  ta(UriPrefix, qsAccepting, Url$1);
  tt(UriPrefix, SLASH, Url$1);
  const bracketPairs = [[OPENBRACE, CLOSEBRACE],
  // {}
  [OPENBRACKET, CLOSEBRACKET],
  // []
  [OPENPAREN, CLOSEPAREN],
  // ()
  [OPENANGLEBRACKET, CLOSEANGLEBRACKET],
  // <>
  [FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN],
  // （）
  [LEFTCORNERBRACKET, RIGHTCORNERBRACKET],
  // 「」
  [LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET],
  // 『』
  [FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN] // ＜＞
  ];
  for (let i = 0; i < bracketPairs.length; i++) {
    const [OPEN, CLOSE] = bracketPairs[i];
    const UrlOpen = tt(Url$1, OPEN); // URL followed by open bracket

    // Continue not accepting for open brackets
    tt(UrlNonaccept, OPEN, UrlOpen);

    // Closing bracket component. This character WILL be included in the URL
    tt(UrlOpen, CLOSE, Url$1);

    // URL that beings with an opening bracket, followed by a symbols.
    // Note that the final state can still be `UrlOpen` (if the URL has a
    // single opening bracket for some reason).
    const UrlOpenQ = makeState(Url);
    ta(UrlOpen, qsAccepting, UrlOpenQ);
    const UrlOpenSyms = makeState(); // UrlOpen followed by some symbols it cannot end it
    ta(UrlOpen, qsNonAccepting);

    // URL that begins with an opening bracket, followed by some symbols
    ta(UrlOpenQ, qsAccepting, UrlOpenQ);
    ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
    ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
    ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);

    // Close brace/bracket to become regular URL
    tt(UrlOpenQ, CLOSE, Url$1);
    tt(UrlOpenSyms, CLOSE, Url$1);
  }
  tt(Start, LOCALHOST, DomainDotTld); // localhost is a valid URL state
  tt(Start, NL, Nl); // single new line

  return {
    start: Start,
    tokens: tk
  };
}

/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */
function linkify_es_run(start, input, tokens) {
  let len = tokens.length;
  let cursor = 0;
  let multis = [];
  let textTokens = [];
  while (cursor < len) {
    let state = start;
    let secondState = null;
    let nextState = null;
    let multiLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    while (cursor < len && !(secondState = state.go(tokens[cursor].t))) {
      // Starting tokens with nowhere to jump to.
      // Consider these to be just plain text
      textTokens.push(tokens[cursor++]);
    }
    while (cursor < len && (nextState = secondState || state.go(tokens[cursor].t))) {
      // Get the next state
      secondState = null;
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }
      cursor++;
      multiLength++;
    }
    if (sinceAccepts < 0) {
      // No accepting state was found, part of a regular text token add
      // the first text token to the text tokens array and try again from
      // the next
      cursor -= multiLength;
      if (cursor < len) {
        textTokens.push(tokens[cursor]);
        cursor++;
      }
    } else {
      // Accepting state!
      // First close off the textTokens (if available)
      if (textTokens.length > 0) {
        multis.push(initMultiToken(linkify_es_Text, input, textTokens));
        textTokens = [];
      }

      // Roll back to the latest accepting state
      cursor -= sinceAccepts;
      multiLength -= sinceAccepts;

      // Create a new multitoken
      const Multi = latestAccepting.t;
      const subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(initMultiToken(Multi, input, subtokens));
    }
  }

  // Finally close off the textTokens (if available)
  if (textTokens.length > 0) {
    multis.push(initMultiToken(linkify_es_Text, input, textTokens));
  }
  return multis;
}

/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */
function initMultiToken(Multi, input, tokens) {
  const startIdx = tokens[0].s;
  const endIdx = tokens[tokens.length - 1].e;
  const value = input.slice(startIdx, endIdx);
  return new Multi(value, tokens);
}

const warn = typeof console !== 'undefined' && console && console.warn || (() => {});
const warnAdvice = 'until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.';

// Side-effect initialization state
const INIT = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: false
};

/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */

/**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */

/**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */

/**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */

/**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */
function linkify_es_reset() {
  State.groups = {};
  INIT.scanner = null;
  INIT.parser = null;
  INIT.tokenQueue = [];
  INIT.pluginQueue = [];
  INIT.customSchemes = [];
  INIT.initialized = false;
  return INIT;
}

/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */
function registerTokenPlugin(name, plugin) {
  if (typeof plugin !== 'function') {
    throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
  }
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    if (name === INIT.tokenQueue[i][0]) {
      warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
      INIT.tokenQueue[i] = [name, plugin];
      return;
    }
  }
  INIT.tokenQueue.push([name, plugin]);
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${warnAdvice}`);
  }
}

/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */
function registerPlugin(name, plugin) {
  if (typeof plugin !== 'function') {
    throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
  }
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    if (name === INIT.pluginQueue[i][0]) {
      warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
      INIT.pluginQueue[i] = [name, plugin];
      return;
    }
  }
  INIT.pluginQueue.push([name, plugin]);
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register plugin "${name}" ${warnAdvice}`);
  }
}

/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} scheme
 * @param {boolean} [optionalSlashSlash]
 */
function registerCustomProtocol(scheme, optionalSlashSlash = false) {
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${warnAdvice}`);
  }
  if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) {
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  }
  INIT.customSchemes.push([scheme, optionalSlashSlash]);
}

/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */
function init() {
  // Initialize scanner state machine and plugins
  INIT.scanner = init$2(INIT.customSchemes);
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    INIT.tokenQueue[i][1]({
      scanner: INIT.scanner
    });
  }

  // Initialize parser state machine and plugins
  INIT.parser = init$1(INIT.scanner.tokens);
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser
    });
  }
  INIT.initialized = true;
  return INIT;
}

/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */
function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }
  return linkify_es_run(INIT.parser.start, str, linkify_es_run$1(INIT.scanner.start, str));
}
tokenize.scan = linkify_es_run$1; // for testing

/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */
function find(str, type = null, opts = null) {
  if (type && typeof type === 'object') {
    if (opts) {
      throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
    }
    opts = type;
    type = null;
  }
  const options = new Options(opts);
  const tokens = tokenize(str);
  const filtered = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.isLink && (!type || token.t === type) && options.check(token)) {
      filtered.push(token.toFormattedObject(options));
    }
  }
  return filtered;
}

/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */
function test(str, type = null) {
  const tokens = tokenize(str);
  return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}



;// CONCATENATED MODULE: ./node_modules/@tiptap/extension-link/dist/index.js




/**
 * Check if the provided tokens form a valid link structure, which can either be a single link token
 * or a link token surrounded by parentheses or square brackets.
 *
 * This ensures that only complete and valid text is hyperlinked, preventing cases where a valid
 * top-level domain (TLD) is immediately followed by an invalid character, like a number. For
 * example, with the `find` method from Linkify, entering `example.com1` would result in
 * `example.com` being linked and the trailing `1` left as plain text. By using the `tokenize`
 * method, we can perform more comprehensive validation on the input text.
 */
function isValidLinkStructure(tokens) {
    if (tokens.length === 1) {
        return tokens[0].isLink;
    }
    if (tokens.length === 3 && tokens[1].isLink) {
        return ['()', '[]'].includes(tokens[0].value + tokens[2].value);
    }
    return false;
}
/**
 * This plugin allows you to automatically add links to your editor.
 * @param options The plugin options
 * @returns The plugin instance
 */
function autolink(options) {
    return new Plugin({
        key: new PluginKey('autolink'),
        appendTransaction: (transactions, oldState, newState) => {
            /**
             * Does the transaction change the document?
             */
            const docChanges = transactions.some(transaction => transaction.docChanged) && !oldState.doc.eq(newState.doc);
            /**
             * Prevent autolink if the transaction is not a document change or if the transaction has the meta `preventAutolink`.
             */
            const preventAutolink = transactions.some(transaction => transaction.getMeta('preventAutolink'));
            /**
             * Prevent autolink if the transaction is not a document change
             * or if the transaction has the meta `preventAutolink`.
             */
            if (!docChanges || preventAutolink) {
                return;
            }
            const { tr } = newState;
            const transform = combineTransactionSteps(oldState.doc, [...transactions]);
            const changes = getChangedRanges(transform);
            changes.forEach(({ newRange }) => {
                // Now let’s see if we can add new links.
                const nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, node => node.isTextblock);
                let textBlock;
                let textBeforeWhitespace;
                if (nodesInChangedRanges.length > 1) {
                    // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
                }
                else if (nodesInChangedRanges.length
                    // We want to make sure to include the block seperator argument to treat hard breaks like spaces.
                    && newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ').endsWith(' ')) {
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
                }
                if (textBlock && textBeforeWhitespace) {
                    const wordsBeforeWhitespace = textBeforeWhitespace.split(' ').filter(s => s !== '');
                    if (wordsBeforeWhitespace.length <= 0) {
                        return false;
                    }
                    const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
                    const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
                    if (!lastWordBeforeSpace) {
                        return false;
                    }
                    const linksBeforeSpace = tokenize(lastWordBeforeSpace).map(t => t.toObject(options.defaultProtocol));
                    if (!isValidLinkStructure(linksBeforeSpace)) {
                        return false;
                    }
                    linksBeforeSpace
                        .filter(link => link.isLink)
                        // Calculate link position.
                        .map(link => ({
                        ...link,
                        from: lastWordAndBlockOffset + link.start + 1,
                        to: lastWordAndBlockOffset + link.end + 1,
                    }))
                        // ignore link inside code mark
                        .filter(link => {
                        if (!newState.schema.marks.code) {
                            return true;
                        }
                        return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
                    })
                        // validate link
                        .filter(link => options.validate(link.value))
                        // check whether should autolink
                        .filter(link => options.shouldAutoLink(link.value))
                        // Add link mark.
                        .forEach(link => {
                        if (getMarksBetween(link.from, link.to, newState.doc).some(item => item.mark.type === options.type)) {
                            return;
                        }
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href,
                        }));
                    });
                }
            });
            if (!tr.steps.length) {
                return;
            }
            return tr;
        },
    });
}

function clickHandler(options) {
    return new Plugin({
        key: new PluginKey('handleClickLink'),
        props: {
            handleClick: (view, pos, event) => {
                var _a, _b;
                if (event.button !== 0) {
                    return false;
                }
                if (!view.editable) {
                    return false;
                }
                let a = event.target;
                const els = [];
                while (a.nodeName !== 'DIV') {
                    els.push(a);
                    a = a.parentNode;
                }
                if (!els.find(value => value.nodeName === 'A')) {
                    return false;
                }
                const attrs = getAttributes(view.state, options.type.name);
                const link = event.target;
                const href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
                const target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;
                if (link && href) {
                    window.open(href, target);
                    return true;
                }
                return false;
            },
        },
    });
}

function pasteHandler(options) {
    return new Plugin({
        key: new PluginKey('handlePasteLink'),
        props: {
            handlePaste: (view, event, slice) => {
                const { state } = view;
                const { selection } = state;
                const { empty } = selection;
                if (empty) {
                    return false;
                }
                let textContent = '';
                slice.content.forEach(node => {
                    textContent += node.textContent;
                });
                const link = find(textContent, { defaultProtocol: options.defaultProtocol }).find(item => item.isLink && item.value === textContent);
                if (!textContent || !link) {
                    return false;
                }
                return options.editor.commands.setMark(options.type, {
                    href: link.href,
                });
            },
        },
    });
}

const extension_link_dist_pasteRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi;
// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.js
// eslint-disable-next-line no-control-regex
const ATTR_WHITESPACE = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function isAllowedUri(uri, protocols) {
    const allowedProtocols = [
        'http',
        'https',
        'ftp',
        'ftps',
        'mailto',
        'tel',
        'callto',
        'sms',
        'cid',
        'xmpp',
    ];
    if (protocols) {
        protocols.forEach(protocol => {
            const nextProtocol = typeof protocol === 'string' ? protocol : protocol.scheme;
            if (nextProtocol) {
                allowedProtocols.push(nextProtocol);
            }
        });
    }
    return (!uri
        || uri
            .replace(ATTR_WHITESPACE, '')
            .match(new RegExp(
        // eslint-disable-next-line no-useless-escape
        `^(?:(?:${allowedProtocols.join('|')}):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))`, 'i')));
}
/**
 * This extension allows you to create links.
 * @see https://www.tiptap.dev/api/marks/link
 */
const Link = dist_Mark.create({
    name: 'link',
    priority: 1000,
    keepOnSplit: false,
    exitable: true,
    onCreate() {
        if (this.options.validate && !this.options.shouldAutoLink) {
            // Copy the validate function to the shouldAutoLink option
            this.options.shouldAutoLink = this.options.validate;
            console.warn('The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.');
        }
        this.options.protocols.forEach(protocol => {
            if (typeof protocol === 'string') {
                registerCustomProtocol(protocol);
                return;
            }
            registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
        });
    },
    onDestroy() {
        linkify_es_reset();
    },
    inclusive() {
        return this.options.autolink;
    },
    addOptions() {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            protocols: [],
            defaultProtocol: 'http',
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer nofollow',
                class: null,
            },
            isAllowedUri: (url, ctx) => !!isAllowedUri(url, ctx.protocols),
            validate: url => !!url,
            shouldAutoLink: url => !!url,
        };
    },
    addAttributes() {
        return {
            href: {
                default: null,
                parseHTML(element) {
                    return element.getAttribute('href');
                },
            },
            target: {
                default: this.options.HTMLAttributes.target,
            },
            rel: {
                default: this.options.HTMLAttributes.rel,
            },
            class: {
                default: this.options.HTMLAttributes.class,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'a[href]',
                getAttrs: dom => {
                    const href = dom.getAttribute('href');
                    // prevent XSS attacks
                    if (!href
                        || !this.options.isAllowedUri(href, {
                            defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                            protocols: this.options.protocols,
                            defaultProtocol: this.options.defaultProtocol,
                        })) {
                        return false;
                    }
                    return null;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        // prevent XSS attacks
        if (!this.options.isAllowedUri(HTMLAttributes.href, {
            defaultValidate: href => !!isAllowedUri(href, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol,
        })) {
            // strip out the href
            return [
                'a',
                mergeAttributes(this.options.HTMLAttributes, { ...HTMLAttributes, href: '' }),
                0,
            ];
        }
        return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain().setMark(this.name, attributes).setMeta('preventAutolink', true).run();
            },
            toggleLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain()
                    .toggleMark(this.name, attributes, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
            unsetLink: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
        };
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: text => {
                    const foundLinks = [];
                    if (text) {
                        const { protocols, defaultProtocol } = this.options;
                        const links = find(text).filter(item => item.isLink
                            && this.options.isAllowedUri(item.value, {
                                defaultValidate: href => !!isAllowedUri(href, protocols),
                                protocols,
                                defaultProtocol,
                            }));
                        if (links.length) {
                            links.forEach(link => foundLinks.push({
                                text: link.value,
                                data: {
                                    href: link.href,
                                },
                                index: link.start,
                            }));
                        }
                    }
                    return foundLinks;
                },
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return {
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    };
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        const plugins = [];
        const { protocols, defaultProtocol } = this.options;
        if (this.options.autolink) {
            plugins.push(autolink({
                type: this.type,
                defaultProtocol: this.options.defaultProtocol,
                validate: url => this.options.isAllowedUri(url, {
                    defaultValidate: href => !!isAllowedUri(href, protocols),
                    protocols,
                    defaultProtocol,
                }),
                shouldAutoLink: this.options.shouldAutoLink,
            }));
        }
        if (this.options.openOnClick === true) {
            plugins.push(clickHandler({
                type: this.type,
            }));
        }
        if (this.options.linkOnPaste) {
            plugins.push(pasteHandler({
                editor: this.editor,
                defaultProtocol: this.options.defaultProtocol,
                type: this.type,
            }));
        }
        return plugins;
    },
});


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=script&lang=js




/* harmony default export */ var TextEditorMoleculevue_type_script_lang_js = ({
  name: 'TextEditorMolecule',
  compatConfig: {
    RENDER_FUNCTION: false
  },
  components: {
    EditorContent: EditorContent,
    TextInputAtom: TextInputAtom,
    ButtonAtom: ButtonAtom
  },
  props: {
    label: String,
    value: String,
    maxSize: {
      type: Number,
      default: 4000
    },
    error: String,
    includeTags: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      linkUrl: null,
      linkMenuIsActive: false,
      editor: undefined
    };
  },
  computed: {
    charactersLeft() {
      let remaining;
      if (this.includeTags) {
        remaining = this.maxSize - this.value.length;
      } else {
        var regex = /(&nbsp;|<([^>]+)>)/gi;
        var result = this.value.replace(regex, '');
        remaining = this.maxSize - result.length;
      }
      return Math.max(0, remaining);
    }
  },
  emits: ['input'],
  methods: {
    onHrefInput(v) {
      this.linkUrl = v;
    },
    showLinkMenu() {
      let href = this.editor.getAttributes('link').href;
      if (!href) {
        this.linkUrl = '';
      } else {
        this.linkUrl = href;
      }
      this.linkMenuIsActive = true;
    },
    hideLinkMenu() {
      this.linkUrl = null;
      this.linkMenuIsActive = false;
    },
    setLinkUrl() {
      let url = this.linkUrl;
      if (url === '') {
        this.editor.chain().focus().unsetLink().run();
      } else {
        this.editor.chain().focus().setLink({
          href: url
        }).run();
      }
      this.hideLinkMenu();
    },
    onEditorContentUpdated(e) {
      let html = e.editor.getHTML();
      let emailText = html == '<p></p>' ? '' : html;
      this.$emit('input', emailText);
    }
  },
  mounted() {
    let includeTags = this.includeTags;
    let getCharactersLeft = () => {
      if (includeTags) {
        return maxSize - this.value.length;
      }
      return maxSize - this.value.replace(/(&nbsp;|<([^>]+)>)/gi, '').length;
    };
    let maxSize = this.maxSize;
    let adjustedContent = `<p></p>${this.value}`;
    this.editor = new Editor({
      content: adjustedContent,
      onUpdate: this.onEditorContentUpdated,
      extensions: [StarterKit, Link.configure({
        openOnClick: false
      })],
      editorProps: {
        handleTextInput(view) {
          if (getCharactersLeft() == 0) {
            return true;
          }
          if (view.state.doc.textContent.length >= maxSize && view.state.selection.empty) {
            return true;
          }
        },
        handlePaste(view, event) {
          const pastedText = (event.clipboardData || window.clipboardData).getData('text');
          const currentLength = view.state.doc.textContent.length;
          if (currentLength + pastedText.length > maxSize) {
            event.preventDefault();
            return true;
          }
        }
      }
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=style&index=0&id=2072decc&scoped=true&lang=css
var TextEditorMoleculevue_type_style_index_0_id_2072decc_scoped_true_lang_css = __webpack_require__(6238);
;// CONCATENATED MODULE: ./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue?vue&type=style&index=0&id=2072decc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/TextEditorMolecule/TextEditorMolecule.vue




;


const TextEditorMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TextEditorMoleculevue_type_script_lang_js, [['render',TextEditorMoleculevue_type_template_id_2072decc_scoped_true_render],['__scopeId',"data-v-2072decc"]])

/* harmony default export */ var TextEditorMolecule = (TextEditorMolecule_exports_);
;// CONCATENATED MODULE: ./src/components/molecules/TextEditorMolecule/index.js

/* harmony default export */ var molecules_TextEditorMolecule = (TextEditorMolecule);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/NestedAppMolecule.vue?vue&type=template&id=59cb0435&scoped=true

const NestedAppMoleculevue_type_template_id_59cb0435_scoped_true_withScopeId = n => (_pushScopeId("data-v-59cb0435"), n = n(), _popScopeId(), n);
const NestedAppMoleculevue_type_template_id_59cb0435_scoped_true_hoisted_1 = ["src"];
function NestedAppMoleculevue_type_template_id_59cb0435_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoaderAtom = (0,external_vue_namespaceObject.resolveComponent)("LoaderAtom");
  const _component_ModalAtom = (0,external_vue_namespaceObject.resolveComponent)("ModalAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_ModalAtom, {
    class: (0,external_vue_namespaceObject.normalizeClass)(["nested-app-molecule", {
      'nested-app-molecule--headless': $options.isHeadless,
      'nested-app-molecule--has-nested-iframe': $data.hasInnerIframeMounted
    }]),
    type: "fullscreen",
    size: "xl",
    isOverlay: "",
    title: $props.title,
    onClose: _cache[1] || (_cache[1] = $event => _ctx.$emit('close'))
  }, {
    content: (0,external_vue_namespaceObject.withCtx)(() => [$data.loading ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_LoaderAtom, {
      key: 0,
      mode: "block",
      height: "100%"
    })) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.withDirectives)((0,external_vue_namespaceObject.createElementVNode)("iframe", {
      class: "nested-app-molecule__iframe ace-scroll",
      src: $options.iframeSource,
      onLoad: _cache[0] || (_cache[0] = (...args) => $options.onLoad && $options.onLoad(...args))
    }, null, 40, NestedAppMoleculevue_type_template_id_59cb0435_scoped_true_hoisted_1), [[external_vue_namespaceObject.vShow, !$data.loading]])]),
    _: 1
  }, 8, ["class", "title"]);
}
;// CONCATENATED MODULE: ./src/components/molecules/NestedAppMolecule.vue?vue&type=template&id=59cb0435&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/NestedAppMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var NestedAppMoleculevue_type_script_lang_js = ({
  name: 'NestedAppMolecule',
  props: {
    title: String,
    src: String
  },
  components: {
    ModalAtom: ModalAtom,
    LoaderAtom: LoaderAtom
  },
  data() {
    return {
      loading: true,
      hasInnerIframeMounted: false
    };
  },
  computed: {
    iframeSource() {
      return this.src.replace('?headless', '?headless&' + Math.round(Math.random(100) * 1000000));
    },
    isHeadless() {
      return window.location.search.indexOf('?headless') !== -1;
    }
  },
  methods: {
    onLoad(e) {
      this.loading = false;
      e.target.contentDocument.body.style.paddingLeft = '8px';
      e.target.contentDocument.body.style.paddingRight = '8px';
    },
    receiveMessage(event) {
      if (event.data === 'iframeMounted') {
        this.hasInnerIframeMounted = true;
        return;
      }
      if (event.data === 'iframeDestroyed') {
        this.hasInnerIframeMounted = false;
        return;
      }
      this.$emit('receiveMessage', event.data);
    }
  },
  mounted() {
    document.body.classList.add('ace-disable-scrolls');
    window.addEventListener('message', this.receiveMessage);
    if (window.parent.location.href !== window.location.href) {
      window.parent.postMessage('iframeMounted', '*');
    }
  },
  beforeUnmount() {
    document.body.classList.remove('ace-disable-scrolls');
    window.removeEventListener('message', this.receiveMessage);
    window.parent.postMessage('iframeDestroyed', '*');
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/NestedAppMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/NestedAppMolecule.vue?vue&type=style&index=0&id=59cb0435&lang=css
var NestedAppMoleculevue_type_style_index_0_id_59cb0435_lang_css = __webpack_require__(2476);
;// CONCATENATED MODULE: ./src/components/molecules/NestedAppMolecule.vue?vue&type=style&index=0&id=59cb0435&lang=css

// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/NestedAppMolecule.vue?vue&type=style&index=1&id=59cb0435&scoped=true&lang=css
var NestedAppMoleculevue_type_style_index_1_id_59cb0435_scoped_true_lang_css = __webpack_require__(3281);
;// CONCATENATED MODULE: ./src/components/molecules/NestedAppMolecule.vue?vue&type=style&index=1&id=59cb0435&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/NestedAppMolecule.vue




;



const NestedAppMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NestedAppMoleculevue_type_script_lang_js, [['render',NestedAppMoleculevue_type_template_id_59cb0435_scoped_true_render],['__scopeId',"data-v-59cb0435"]])

/* harmony default export */ var NestedAppMolecule = (NestedAppMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TabMolecule.vue?vue&type=template&id=775c0a88&scoped=true

const TabMoleculevue_type_template_id_775c0a88_scoped_true_withScopeId = n => ((0,external_vue_namespaceObject.pushScopeId)("data-v-775c0a88"), n = n(), (0,external_vue_namespaceObject.popScopeId)(), n);
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_1 = {
  class: "tab-molecule"
};
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_2 = /*#__PURE__*/TabMoleculevue_type_template_id_775c0a88_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_3 = [TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_2];
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_4 = {
  class: "tab-molecule__tabs",
  ref: "tabsContainer"
};
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_5 = /*#__PURE__*/TabMoleculevue_type_template_id_775c0a88_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("svg", null, [/*#__PURE__*/(0,external_vue_namespaceObject.createElementVNode)("use", {
  "xlink:href": "#arrow-down"
})], -1));
const TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_6 = [TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_5];
function TabMoleculevue_type_template_id_775c0a88_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabAtom = (0,external_vue_namespaceObject.resolveComponent)("TabAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_1, [(0,external_vue_namespaceObject.createVNode)(external_vue_namespaceObject.Transition, {
    name: "fade"
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [$options.isLeftVisible ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      key: 0,
      class: "tab-molecule__scroll-button tab-molecule__scroll-button--left",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.onPrev && $options.onPrev(...args))
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["tab-molecule__scroll-button__button tab-molecule__scroll-button__button--left", {
        'tab-molecule__scroll-button__button--modal': $options.isModal
      }])
    }, TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_3, 2)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]),
    _: 1
  }), (0,external_vue_namespaceObject.createElementVNode)("div", TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_4, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.tabs, (tab, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_TabAtom, {
      ref_for: true,
      ref: 'tab_' + index,
      key: index,
      label: tab.label,
      selected: tab.value === $props.value,
      disabled: tab.disabled,
      onClick: $event => _ctx.$emit('click', tab.value)
    }, null, 8, ["label", "selected", "disabled", "onClick"]);
  }), 128))], 512), (0,external_vue_namespaceObject.createVNode)(external_vue_namespaceObject.Transition, {
    name: "fade"
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(() => [$options.isRightVisible ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
      key: 0,
      class: "tab-molecule__scroll-button tab-molecule__scroll-button--right",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.onNext && $options.onNext(...args))
    }, [(0,external_vue_namespaceObject.createElementVNode)("div", {
      class: (0,external_vue_namespaceObject.normalizeClass)(["tab-molecule__scroll-button__button tab-molecule__scroll-button__button--right", {
        'tab-molecule__scroll-button__button--modal': $options.isModal
      }])
    }, TabMoleculevue_type_template_id_775c0a88_scoped_true_hoisted_6, 2)])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]),
    _: 1
  })]);
}
;// CONCATENATED MODULE: ./src/components/molecules/TabMolecule.vue?vue&type=template&id=775c0a88&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TabMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var TabMoleculevue_type_script_lang_js = ({
  name: 'TabMolecule',
  props: {
    tabs: Array,
    value: [String, Number],
    mode: {
      type: String,
      default: 'mainContent'
    }
  },
  components: {
    TabAtom: TabAtom
  },
  data() {
    return {
      isOverflowing: false,
      scrollPosition: 0,
      maxScrollPosition: 0,
      innerWidth: 0
    };
  },
  computed: {
    isModal() {
      return this.mode === 'modal';
    },
    isLeftVisible() {
      if (!this.isOverflowing) {
        return false;
      }
      if (this.scrollPosition < 40) {
        return false;
      }
      return true;
    },
    isRightVisible() {
      if (!this.isOverflowing) {
        return false;
      }
      if (this.scrollPosition > this.maxScrollPosition - this.innerWidth - 100) {
        return false;
      }
      return true;
    }
  },
  methods: {
    handleScroll() {
      this.scrollPosition = this.$refs.tabsContainer.scrollLeft;
    },
    processOverflowing() {
      let element = this.$refs.tabsContainer;
      if (element.scrollWidth > element.clientWidth) {
        this.isOverflowing = true;
      }
      this.maxScrollPosition = element.scrollWidth;
      this.innerWidth = element.clientWidth;
    },
    onPrev() {
      let lastElement;
      this.tabs.forEach((x, index) => {
        let ele = this.$refs['tab_' + index][0].$el;
        if (ele.offsetLeft < this.scrollPosition) {
          lastElement = ele;
        }
      });
      if (!lastElement) {
        this.$refs.tabsContainer.scrollTo(0, 0);
      } else {
        lastElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    },
    onNext() {
      let lastElement;
      this.tabs.forEach((x, index) => {
        let ele = this.$refs['tab_' + index][0].$el;
        if (ele.offsetLeft > this.scrollPosition + this.innerWidth - 40) {
          if (!lastElement) {
            lastElement = ele;
          }
        }
      });
      if (!lastElement) {
        this.$refs.tabsContainer.scrollTo(this.maxScrollPosition, 0);
      } else {
        lastElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    },
    scrollToActive() {
      this.tabs.forEach((x, index) => {
        if (x.value === this.value) {
          let ele = this.$refs['tab_' + index][0].$el;
          let calc = ele.offsetLeft - this.innerWidth + ele.offsetWidth + 50;
          this.$refs.tabsContainer.scrollTo(calc, 0);
        }
      });
    },
    handleResize() {
      this.processOverflowing();
      this.scrollToActive();
    }
  },
  mounted() {
    this.processOverflowing();
    this.$refs.tabsContainer.addEventListener('scroll', this.handleScroll);
    this.scrollToActive();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    this.$refs.tabsContainer.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  emits: ['click']
});
;// CONCATENATED MODULE: ./src/components/molecules/TabMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/TabMolecule.vue?vue&type=style&index=0&id=775c0a88&scoped=true&lang=css
var TabMoleculevue_type_style_index_0_id_775c0a88_scoped_true_lang_css = __webpack_require__(3808);
;// CONCATENATED MODULE: ./src/components/molecules/TabMolecule.vue?vue&type=style&index=0&id=775c0a88&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/TabMolecule.vue




;


const TabMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TabMoleculevue_type_script_lang_js, [['render',TabMoleculevue_type_template_id_775c0a88_scoped_true_render],['__scopeId',"data-v-775c0a88"]])

/* harmony default export */ var TabMolecule = (TabMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/CheckMolecule.vue?vue&type=template&id=1b21db05&scoped=true

const CheckMoleculevue_type_template_id_1b21db05_scoped_true_withScopeId = n => (_pushScopeId("data-v-1b21db05"), n = n(), _popScopeId(), n);
const CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_1 = {
  class: "check-molecule"
};
const CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_2 = {
  key: 0,
  class: "ace-input-label"
};
const CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_3 = {
  key: 1
};
const CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_4 = {
  class: "check-molecule__wrapper ace-scroll"
};
function CheckMoleculevue_type_template_id_1b21db05_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckAtom = (0,external_vue_namespaceObject.resolveComponent)("CheckAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_1, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $props.hasAll ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_3, [(0,external_vue_namespaceObject.createVNode)(_component_CheckAtom, {
    option: "Alla",
    value: $options.allSelected,
    onInput: $options.onAllInput,
    disabled: $props.disabled
  }, null, 8, ["value", "onInput", "disabled"])])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", CheckMoleculevue_type_template_id_1b21db05_scoped_true_hoisted_4, [(0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["check-molecule__wrapper__layout ace-scroll", $options.wrapperClass]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.wrapperStyle)
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.options, (option, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_CheckAtom, {
      key: index,
      option: option.option,
      disabled: $props.disabled,
      value: $options.selectedValues[option.value],
      onInput: $event => $options.onCheckInput(option.value)
    }, null, 8, ["option", "disabled", "value", "onInput"]);
  }), 128))], 6)])]);
}
;// CONCATENATED MODULE: ./src/components/molecules/CheckMolecule.vue?vue&type=template&id=1b21db05&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/CheckMolecule.vue?vue&type=script&lang=js


/* harmony default export */ var CheckMoleculevue_type_script_lang_js = ({
  name: 'CheckMolecule',
  props: {
    type: {
      type: String,
      default: 'vertical',
      validator: val => {
        return ['vertical', 'horizontal', 'grid'].includes(val);
      }
    },
    height: Number,
    columns: {
      type: Number,
      default: 1
    },
    label: String,
    options: Array,
    value: Array,
    disabled: Boolean,
    hasAll: Boolean
  },
  components: {
    CheckAtom: CheckAtom
  },
  computed: {
    wrapperClass() {
      return {
        'check-molecule__wrapper__layout--horizontal': this.type === 'horizontal',
        'check-molecule__wrapper__layout--grid': this.type === 'grid'
      };
    },
    wrapperStyle() {
      let result = {};
      if (this.height) {
        result.height = this.height + 'px';
      }
      if (this.type === 'grid') {
        result['grid-template-rows'] = `repeat(${Math.ceil(this.options.length / this.columns)}, minmax(0, 1fr))`;
      }
      return result;
    },
    selectedValues() {
      if (!this.value) {
        return {};
      }
      return this.value.reduce((pv, cv) => {
        pv[cv] = true;
        return pv;
      }, {});
    },
    allSelected() {
      if (!this.value) {
        return false;
      }
      return this.options.map(x => x.value).every(x => this.value.includes(x));
    }
  },
  emits: ['input'],
  methods: {
    onCheckInput(e) {
      if (!this.value) {
        return;
      }
      if (this.value.includes(e)) {
        let index = this.value.indexOf(e);
        let newValues = [...this.value];
        newValues.splice(index, 1);
        this.$emit('input', newValues);
      } else {
        let newValues = [...this.value];
        newValues.push(e);
        this.$emit('input', newValues);
      }
    },
    onAllInput(e) {
      if (!this.value) {
        return false;
      }
      if (e) {
        this.$emit('input', this.options.map(x => x.value));
      } else {
        this.$emit('input', []);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/CheckMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/CheckMolecule.vue?vue&type=style&index=0&id=1b21db05&scoped=true&lang=css
var CheckMoleculevue_type_style_index_0_id_1b21db05_scoped_true_lang_css = __webpack_require__(4719);
;// CONCATENATED MODULE: ./src/components/molecules/CheckMolecule.vue?vue&type=style&index=0&id=1b21db05&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/CheckMolecule.vue




;


const CheckMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CheckMoleculevue_type_script_lang_js, [['render',CheckMoleculevue_type_template_id_1b21db05_scoped_true_render],['__scopeId',"data-v-1b21db05"]])

/* harmony default export */ var CheckMolecule = (CheckMolecule_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/RadioMolecule.vue?vue&type=template&id=21e5928c&scoped=true

const RadioMoleculevue_type_template_id_21e5928c_scoped_true_withScopeId = n => (_pushScopeId("data-v-21e5928c"), n = n(), _popScopeId(), n);
const RadioMoleculevue_type_template_id_21e5928c_scoped_true_hoisted_1 = {
  class: "radio-molecule"
};
const RadioMoleculevue_type_template_id_21e5928c_scoped_true_hoisted_2 = {
  key: 0,
  class: "ace-input-label"
};
function RadioMoleculevue_type_template_id_21e5928c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioAtom = (0,external_vue_namespaceObject.resolveComponent)("RadioAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", RadioMoleculevue_type_template_id_21e5928c_scoped_true_hoisted_1, [$props.label ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", RadioMoleculevue_type_template_id_21e5928c_scoped_true_hoisted_2, (0,external_vue_namespaceObject.toDisplayString)($props.label), 1)) : (0,external_vue_namespaceObject.createCommentVNode)("", true), (0,external_vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["radio-molecule__wrapper ace-scroll", $options.wrapperClass]),
    style: (0,external_vue_namespaceObject.normalizeStyle)($options.wrapperStyle)
  }, [((0,external_vue_namespaceObject.openBlock)(true), (0,external_vue_namespaceObject.createElementBlock)(external_vue_namespaceObject.Fragment, null, (0,external_vue_namespaceObject.renderList)($props.options, (option, index) => {
    return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_RadioAtom, {
      key: index,
      option: option.option,
      disabled: $props.disabled || option.disabled,
      optionValue: option.value,
      value: $props.value,
      onInput: _cache[0] || (_cache[0] = $event => $options.onInput($event))
    }, null, 8, ["option", "disabled", "optionValue", "value"]);
  }), 128))], 6)]);
}
;// CONCATENATED MODULE: ./src/components/molecules/RadioMolecule.vue?vue&type=template&id=21e5928c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/RadioMolecule.vue?vue&type=script&lang=js

/* harmony default export */ var RadioMoleculevue_type_script_lang_js = ({
  name: 'RadioMolecule',
  props: {
    type: {
      type: String,
      default: 'vertical',
      validator: val => {
        return ['vertical', 'horizontal', 'grid'].includes(val);
      }
    },
    height: Number,
    columns: Number,
    label: String,
    options: Array,
    value: [String, Number, Boolean],
    disabled: Boolean
  },
  components: {
    RadioAtom: RadioAtom
  },
  computed: {
    wrapperClass() {
      return {
        'radio-molecule__wrapper--horizontal': this.type === 'horizontal',
        'radio-molecule__wrapper--grid': this.type === 'grid'
      };
    },
    wrapperStyle() {
      let result = {};
      if (this.height) {
        result.height = this.height + 'px';
      }
      if (this.type === 'grid') {
        result['grid-template-columns'] = `repeat(${this.columns}, minmax(0, max-content))`;
      }
      return result;
    }
  },
  emits: ['input'],
  methods: {
    onInput(v) {
      this.$emit('input', v);
    }
  }
});
;// CONCATENATED MODULE: ./src/components/molecules/RadioMolecule.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/molecules/RadioMolecule.vue?vue&type=style&index=0&id=21e5928c&scoped=true&lang=css
var RadioMoleculevue_type_style_index_0_id_21e5928c_scoped_true_lang_css = __webpack_require__(9194);
;// CONCATENATED MODULE: ./src/components/molecules/RadioMolecule.vue?vue&type=style&index=0&id=21e5928c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/molecules/RadioMolecule.vue




;


const RadioMolecule_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(RadioMoleculevue_type_script_lang_js, [['render',RadioMoleculevue_type_template_id_21e5928c_scoped_true_render],['__scopeId',"data-v-21e5928c"]])

/* harmony default export */ var RadioMolecule = (RadioMolecule_exports_);
;// CONCATENATED MODULE: ./src/components/molecules/index.js













;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/AppShell/AppShell.vue?vue&type=template&id=5cda9a5f

function AppShellvue_type_template_id_5cda9a5f_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icons = (0,external_vue_namespaceObject.resolveComponent)("Icons");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_vue_namespaceObject.normalizeClass)(["app-shell", {
      'app-shell--headless': $options.isHeadless
    }])
  }, [(0,external_vue_namespaceObject.createVNode)(_component_Icons), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default")], 2);
}
;// CONCATENATED MODULE: ./src/components/utilities/AppShell/AppShell.vue?vue&type=template&id=5cda9a5f

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/Resources/Icons.vue?vue&type=template&id=5418c725

const Iconsvue_type_template_id_5418c725_hoisted_1 = {
  width: "0",
  height: "0",
  style: {
    "display": "none"
  }
};
const Iconsvue_type_template_id_5418c725_hoisted_2 = /*#__PURE__*/(0,external_vue_namespaceObject.createStaticVNode)("<symbol id=\"circle-minus\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M22.5 16h-13\"></path><circle cx=\"16\" cy=\"16\" r=\"14.2\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-miterlimit:10;\"></circle></symbol><symbol id=\"circle-plus\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M22.4 15.9H9.6M16 9.5v12.8\"></path><circle cx=\"16\" cy=\"15.9\" r=\"14.6\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-miterlimit:10;\"></circle></symbol><symbol id=\"adress\" viewBox=\"0 0 35.6 32.4\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\"><path d=\"m33.201 15.454-13.2-13c-1.2-1.2-3.2-1.2-4.4 0l-13.2 13c-1.1 1.1-1.1 3 0 4.1.6.6 1.4.9 2.2.8h3.1v7.6c0 1.5 1.3 2.8 2.9 2.7h14.3c1.5 0 2.8-1.2 2.9-2.7v-7.6h3.1c1.6.1 3-1.1 3.1-2.7.1-.8-.2-1.6-.8-2.2z\"></path><path d=\"M21.801 29.454v-6.5h-7.9v6.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path stroke-linecap=\"round\" d=\"M27.401 8.854v-6\"></path></g></symbol><symbol id=\"circle-arrow-down\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" d=\"m10.5 14.5 5.5 5.6 5.6-5.6\"></path><circle cx=\"15.9\" cy=\"16\" r=\"14.6\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-miterlimit=\"10\"></circle></symbol><symbol id=\"arrow-down\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" d=\"m10.4 12.8 5.6 5.6 5.5-5.6\"></path></symbol><symbol id=\"bin\" viewBox=\"0 0 32 35.3\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"M26.2 16.7v10.5c0 3.5-2.8 6.3-6.3 6.3H11c-3.5 0-6.3-2.8-6.3-6.3V11.6M9.4 5.7c0-2.3 1.9-4.2 4.2-4.2h4.7c2.3 0 4.2 1.9 4.2 4.2v4.4M1.6 4.3l28.7 8.8M12 16.2v12.1M18.9 16.2v12.1\"></path></symbol><symbol id=\"calendar\" viewBox=\"0 0 32 35.2\"><g id=\"Group_776\" transform=\"translate(-64.242 -150.501)\"><path id=\"Line_325\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M74.1 151.9v5.3\"></path><path id=\"Line_326\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M86.1 151.9v5.3\"></path><path id=\"Path_261\" d=\"M89.9 154.6H70.8c-2.4 0-4.4 1.9-4.5 4.3v20.7c0 2.3 1.8 4.3 4.2 4.3h.3c4.9-.5 19.1-4.3 19.1-4.3 2.4-.7 4.5-2.7 4.5-6.3v-14.4c0-2.5-2-4.4-4.5-4.3z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\"></path><path id=\"Line_327\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M67 164.3h26.9\"></path><path id=\"Line_328\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M72 170.6h.9\"></path><path id=\"Line_329\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M72 176.3h.9\"></path><path id=\"Line_330\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M79.7 170.6h.9\"></path><path id=\"Line_331\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M79.7 176.3h.9\"></path><path id=\"Line_332\" style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M87.4 170.6h1\"></path></g></symbol><symbol id=\"contact\" viewBox=\"0 0 24.9 35.3\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"M16.7 2.1v3.7H8.1V2.1M10.2 29.2h4.4\"></path><path d=\"M17 33.2H7.9c-3.3 0-6-2.7-6-6V7.7c0-3.3 2.7-6 6-6H17c3.3 0 6 2.7 6 6v19.5c0 3.3-2.7 6-6 6z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.67\" stroke-miterlimit=\"10\"></path></symbol><symbol id=\"edit\" viewBox=\"0 0 33.4 35.3\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"m24.8 13.5 2.4-2.8c1.2-1.4 1-3.4-.3-4.6L24.4 4c-1.4-1.2-3.4-1-4.6.3l-.5.7M16.1 8.7 3.7 23.1c-.5.6-1.3 6.7-1.3 6.7-.2 1.2 1.1 2.3 2.3 2 0 0 5.9-1.7 6.4-2.3l10.4-12.1M19.3 5l5.5 8.5M4.5 25l4.6 4M17.6 32.2h13.9\"></path></symbol><symbol id=\"email\" viewBox=\"0 0 32.9 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;\" d=\"M26.3 29.8H6.4c-2.6 0-4.6-1.8-4.6-4.1V6c0-2.3 2.1-4.1 4.6-4.1L26.3 6c2.5.7 4.6 2.6 4.6 6v13.7c0 2.3-2.1 4.1-4.6 4.1z\"></path><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;\" d=\"m2.7 3.5 10.5 12.1c2 2.3 5.2 2.3 7.1 0l7.5-8.8\"></path></symbol><symbol id=\"external-link\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M26.3 17.8v8.7c0 2.1-1.7 3.7-3.7 3.7H5.2c-2.1 0-3.7-1.7-3.7-3.7V9.1c0-2.1 1.7-3.7 3.7-3.7h8.7M20.9 1.4h9.6M30.5 11.6V2M16.3 15.7l12-11.9\"></path></symbol><symbol id=\"group\" viewBox=\"0 0 63.5 35.3\"><circle style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-miterlimit:10;\" cx=\"32.3\" cy=\"10.4\" r=\"7.6\"></circle><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"M21.8 33.5s-1-7.2 4.1-9.7c6.2-2.9 18.1 4.7 21.2 9.9M1.9 27.9c0-4.1 3.3-7.4 7.4-7.4s7.4 3.3 7.4 7.4M46.7 23.7c1.4-1.4 3.2-2.3 5.2-2.4 4.7-.4 8.8 3.4 9.2 8.3\"></path><circle style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-miterlimit:10;\" cx=\"9.3\" cy=\"11\" r=\"5.6\"></circle><circle style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-miterlimit:10;\" cx=\"53.8\" cy=\"11.7\" r=\"4.9\"></circle></symbol><symbol id=\"info\" viewBox=\"0 0 32 32\"><circle cx=\"16.2\" cy=\"16\" r=\"14.6\" fill=\"var(--ace-c-fill)\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-miterlimit=\"10\"></circle><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" d=\"M15.9 7.8v10.4\"></path><circle cx=\"15.9\" cy=\"24.1\" r=\"1.4\" fill=\"currentColor\" stroke=\"currentColor\"></circle></symbol><symbol id=\"lock\" viewBox=\"0 0 25.6 34\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;\" d=\"M6.3 11.2V8.4C6.3 4.9 9.2 2 12.8 2s6.5 2.9 6.5 6.4v6\"></path><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;\" d=\"M20.2 32.2H5.4c-1.9 0-3.5-1.4-3.5-3.1V14.3c0-1.7 1.6-3.1 3.5-3.1l14.9 3.1c1.9.5 3.5 1.9 3.5 4.5v10.3c-.1 1.7-1.6 3.1-3.6 3.1z\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" d=\"M12.4 24.8v2.9\"></path><circle cx=\"12.4\" cy=\"21.1\" r=\"3.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-miterlimit=\"10\"></circle></symbol><symbol id=\"lock-open\" viewBox=\"0 0 25.6 36.6\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M19.3 11V8.2c0-3.6-2.9-6.4-6.4-6.4-3.6 0-6.4 2.9-6.4 6.4v6\"></path><path d=\"M20.2 35.2H5.4c-1.9 0-3.5-1.4-3.5-3.1V17.3c0-1.7 1.6-3.1 3.5-3.1l14.9 3.1c1.9.5 3.5 1.9 3.5 4.5v10.3c-.1 1.7-1.6 3.1-3.6 3.1z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\"></path><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"M12.4 27.5v2.9\"></path><circle cx=\"12.4\" cy=\"23.8\" r=\"3.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-miterlimit=\"10\"></circle></symbol><symbol id=\"search\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"M18.8 2.4c4.1 2.7 6.1 7.9 4.8 12.8-1.7 6.1-7.9 9.6-14 7.8-6.1-1.8-9.7-8.2-8-14.3.9-3.4 3.3-6.1 6.3-7.4M21.2 20.8l9.6 9.6\"></path></symbol><symbol id=\"user\" viewBox=\"0 0 32 35.3\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" d=\"M3.4 33.5s-1-7.3 4.1-9.7c6.2-2.9 18.1 4.7 21.2 9.9\"></path><circle style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round;\" cx=\"13.8\" cy=\"10\" r=\"8.2\"></circle></symbol><symbol id=\"warning\" viewBox=\"0 0 32 32\"><path d=\"M12.2 4.6 2 22.4C.3 25.3 2.4 29 5.8 29h20.6c3.4 0 5.5-3.6 3.8-6.6L19.8 4.6c-1.7-2.9-5.9-2.9-7.6 0z\" fill=\"var(--ace-c-fill)\" stroke=\"currentColor\" stroke-width=\"2.8\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" d=\"M16 10v8.6\"></path><circle fill=\"currentColor\" stroke=\"currentColor\" cx=\"15.9\" cy=\"23.8\" r=\"1.4\"></circle></symbol><symbol id=\"circle-cross\" viewBox=\"0 0 32 32\"><circle fill=\"var(--ace-c-fill)\" cx=\"15.9\" cy=\"16\" r=\"14.6\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-miterlimit=\"10\"></circle><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;stroke-miterlimit:10;\" d=\"m9.8 10.1 12 12M21.8 10.1l-12 12\"></path></symbol><symbol id=\"cross\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:2.8;stroke-linecap:round;\" d=\"m1.4 1.4 29.2 29.2M30.6 1.4 1.4 30.6\"></path></symbol><symbol id=\"circle\" viewBox=\"0 0 32 32\"><path stroke=\"currentColor\" d=\"M16 26c-5.525 0-10-4.475-10-10S10.475 6 16 6s10 4.475 10 10-4.475 10-10 10z\"></path></symbol><symbol id=\"hide\" viewBox=\"0 0 32 32\"><g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2.8\"><path d=\"M23.77 23.77A13.17 13.17 0 0 1 16 26.46C6.85 26.46 1.62 16 1.62 16c1.63-3.03 3.88-5.68 6.62-7.77m5.02-2.38c.9-.21 1.82-.32 2.75-.31C25.16 5.54 30.39 16 30.39 16a23.92 23.92 0 0 1-2.83 4.17m-8.79-1.4c-1.47 1.59-3.96 1.68-5.54.21s-1.68-3.96-.21-5.54l.21-.21\"></path><path stroke=\"currentColor\" stroke-linejoin=\"round\" d=\"m1.62 1.62 28.76 28.76\"></path></g></symbol><symbol id=\"show\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M0 16S5.8 4.4 16 4.4 32 16 32 16s-5.8 11.6-16 11.6S0 16 0 16z\"></path><path d=\"M16 7.2C9.5 7.2 4.9 13.3 3.2 16c1.7 2.7 6.3 8.8 12.8 8.8s11.1-6.1 12.8-8.8c-1.7-2.7-6.3-8.8-12.8-8.8m0-2.8C26.2 4.4 32 16 32 16s-5.8 11.6-16 11.6S0 16 0 16 5.8 4.4 16 4.4z\"></path><g><path fill=\"none\" d=\"M20.337 15.973c0 2.4-2 4.4-4.4 4.4-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4 4.4 2 4.4 4.4z\"></path><path d=\"M16.037 14.473c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6 1.6-.7 1.6-1.6-.8-1.6-1.6-1.6m0-2.8c2.4 0 4.4 2 4.4 4.4 0 2.4-2 4.4-4.4 4.4-2.4 0-4.4-2-4.4-4.4 0-2.5 2-4.4 4.4-4.4z\"></path></g></symbol><symbol id=\"question-mark-circle\" viewBox=\"0 0 32 32\"><g data-name=\"Group 823\"><path d=\"M16 2.8a13.2 13.2 0 0 0-9.334 22.534A13.2 13.2 0 1 0 25.334 6.666 13.114 13.114 0 0 0 16 2.8M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0Z\" data-name=\"Ellipse 235\"></path><circle cx=\"1.4\" cy=\"1.4\" r=\"1.4\" data-name=\"Ellipse 236\" transform=\"translate(14.205 22.454)\"></circle><path d=\"M15.357 19.948a1.4 1.4 0 0 1-1.4-1.363c-.073-2.763 1.832-4.1 2.969-4.906.111-.078.215-.151.309-.22a2.475 2.475 0 0 0 .943-2.594 1.694 1.694 0 0 0-.845-1.263 2.816 2.816 0 0 0-2.179-.046 1.938 1.938 0 0 0-1.235 1.624v-.024l-2.8-.053a4.569 4.569 0 0 1 .393-1.643 4.718 4.718 0 0 1 2.556-2.485 5.572 5.572 0 0 1 4.576.154 4.423 4.423 0 0 1 2.279 3.188 5.248 5.248 0 0 1-2.036 5.4c-.114.083-.234.167-.349.249-1.13.8-1.814 1.364-1.783 2.543a1.4 1.4 0 0 1-1.357 1.438Z\" data-name=\"Path 278\"></path></g></symbol><symbol id=\"question-mark\" viewBox=\"0 0 32 32\"><g fill=\"#040405\" data-name=\"Group 2876\"><path d=\"M7.947 28.388a1.807 1.807 0 1 1-1.807 1.807 1.806 1.806 0 0 1 1.807-1.807\" data-name=\"Path 1092\"></path><path d=\"M7.551 25.434a1.59 1.59 0 0 1-1.587-1.547c-.14-5.085 3.351-7.545 5.662-9.172.232-.165.455-.322.667-.476a6.545 6.545 0 0 0 2.52-6.761 4.925 4.925 0 0 0-2.477-3.632A7.2 7.2 0 0 0 6.6 3.7a5.487 5.487 0 0 0-3.425 4.665 1.614 1.614 0 0 1-1.7 1.47A1.59 1.59 0 0 1 0 8.135 8.672 8.672 0 0 1 5.391.757a10.418 10.418 0 0 1 8.434.28 8.029 8.029 0 0 1 4.094 5.773 9.7 9.7 0 0 1-3.752 10c-.225.166-.464.333-.711.509C11.39 18.77 9.048 20.42 9.141 23.8A1.588 1.588 0 0 1 7.6 25.433h-.049\" data-name=\"Path 1093\"></path></g></symbol><symbol id=\"empty\" viewBox=\"0 0 20 20\"><path fill=\"currentColor\" stroke=\"none\" d=\"M14 14v-1c0-.55.45-1 1-1h3v5c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5h3c.55 0 1 .45 1 1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2Zm-2-2v2H8v-2c0-1.1-.9-2-2-2H2l1.6-8h12.8l1.6 8h-4c-1.1 0-2 .9-2 2Zm8-2L18.16.8c-.09-.47-.5-.8-.98-.8H2.82c-.48 0-.89.33-.98.8L0 10v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8Z\" fill-rule=\"evenodd\"></path></symbol><symbol id=\"credits\" viewBox=\"0 0 32 25\"><path d=\"M7.79.05C4.233.39 1.354 1.73.511 3.442l-.266.536v17.05l.266.528c.508 1.043 1.906 2.05 3.633 2.636 2.62.887 6.144 1.07 9.109.473 1.133-.223 1.398-.328 1.621-.691.234-.36.184-1.075-.098-1.368-.41-.44-.808-.52-1.593-.308-1.532.398-4.637.46-6.457.121-1.536-.285-2.883-.781-3.598-1.352-.559-.445-.602-.55-.602-1.691 0-.559.016-1.008.028-1.008.023 0 .304.117.625.27 2.02.902 5.027 1.367 7.715 1.164 1.226-.09 1.468-.18 1.793-.645.164-.226.183-.347.164-.691-.04-.356-.082-.469-.34-.715l-.285-.293-2.23-.008c-1.93 0-2.349-.023-3.173-.172-1.847-.347-3.355-.98-4.004-1.683l-.293-.317v-1.039c0-1.203-.105-1.129.918-.675.832.359 1.848.652 3.047.863.824.144 1.258.172 3.047.172 2.399 0 2.496-.02 2.824-.668.215-.407.184-.75-.058-1.149-.293-.469-.344-.472-2.442-.488-1.355-.008-2.164-.047-2.73-.145-2.156-.343-3.973-1.128-4.446-1.894-.14-.211-.16-.399-.16-1.27V7.977l.336.171c1.524.77 3.727 1.235 6.153 1.317 4.738.152 8.648-1.242 9.757-3.45.282-.558.301-.663.301-1.285 0-.593-.027-.738-.262-1.226-.78-1.625-3.187-2.879-6.449-3.34C11.27.008 8.875-.046 7.79.051Zm3.964 2.415c2.723.363 4.96 1.383 4.96 2.27 0 .777-1.948 1.785-4.253 2.183-2.488.426-5.66.207-7.7-.527-1.41-.504-2.34-1.25-2.206-1.774.074-.281.672-.812 1.254-1.113.96-.496 2.742-.969 4.125-1.098.847-.082 3.046-.047 3.82.059Zm0 0\"></path><path d=\"M21.762 7.7a8.75 8.75 0 0 0-4.871 2.53c-.75.77-1.2 1.407-1.618 2.293-1.148 2.375-1.136 5.032.028 7.391 1.297 2.625 3.715 4.383 6.61 4.805.917.129 2.417.058 3.296-.172 1.602-.406 2.816-1.098 4.055-2.324 1.168-1.164 1.84-2.325 2.285-3.934.164-.594.191-.848.191-2.102-.011-1.218-.035-1.519-.191-2.078-.66-2.433-2.258-4.418-4.465-5.554a8.743 8.743 0 0 0-5.32-.856Zm3.164 2.503c.633.195 1.465.602 1.883.902.554.41 1.296 1.204 1.656 1.774 2.258 3.578.34 8.336-3.781 9.375-.864.223-2.258.223-3.137 0-1.266-.324-2.54-1.113-3.34-2.098-.465-.574-1.035-1.707-1.227-2.422-.222-.78-.199-2.39.036-3.203.656-2.27 2.43-3.918 4.78-4.457.74-.164 2.415-.105 3.13.13Zm0 0\"></path><path d=\"M22.762 10.945c-.344.153-.528.39-.582.746-.035.278-.07.329-.36.457-.465.211-1 .766-1.242 1.286-.172.363-.215.578-.223 1.046 0 .516.04.668.266 1.125.426.868 1.133 1.356 2.156 1.504.774.106.985.211 1.11.52.148.348.074.61-.219.855-.418.356-1.04.235-1.406-.27-.309-.413-1-.472-1.39-.12-.2.191-.34.625-.274.91.074.332.715 1.008 1.172 1.234.308.149.39.235.39.399 0 .3.219.652.485.789.574.293 1.207.008 1.367-.64.074-.294.148-.384.59-.645 1.082-.692 1.523-1.97 1.082-3.153-.317-.832-1.258-1.562-2.164-1.675-.766-.09-.868-.126-1.075-.329-.574-.574.172-1.511.965-1.218.125.05.36.234.516.406.851.976 2.215-.121 1.449-1.168-.273-.367-.668-.719-1.031-.887-.2-.097-.258-.18-.301-.426-.059-.3-.434-.777-.625-.777a.923.923 0 0 1-.258-.043c-.09-.023-.265.008-.398.074Zm0 0\"></path></symbol><symbol id=\"info-circle\" viewBox=\"0 0 32 32\"><g fill=\"currentColor\" clip-path=\"url(#a)\"><path d=\"M29 16a13 13 0 1 0-26 0 13 13 0 0 0 26 0ZM0 16a16 16 0 1 1 32 0 16 16 0 0 1-32 0Z\"></path><path d=\"M14 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-2 6c0-.738.596-1.333 1.333-1.333H16c.738 0 1.333.595 1.333 1.333v9.333h1.334c.737 0 1.333.596 1.333 1.334 0 .737-.596 1.333-1.333 1.333h-5.334A1.332 1.332 0 0 1 12 24.667c0-.738.596-1.334 1.333-1.334h1.334v-8h-1.334A1.332 1.332 0 0 1 12 14Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h32v32H0z\"></path></clipPath></defs></symbol><symbol id=\"golfcart\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\" data-name=\"Rectangle 1\"></path></clipPath></defs><g clip-path=\"url(#a)\"><g data-name=\"Layer 2\"><g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" data-name=\"Layer 1\" transform=\"translate(2.496 3.852)\"><path fill=\"none\" d=\"m26 15.674-5.417-.083\" data-name=\"Line 3\"></path><path fill=\"none\" d=\"M15.871 18.643c-.854 0-3.101.018-3.101.018\" data-name=\"Line 4\"></path><circle cx=\"3.414\" cy=\"3.414\" r=\"3.414\" fill=\"none\" stroke-linejoin=\"round\" data-name=\"Ellipse 1\" transform=\"translate(5.817 15.434)\"></circle><circle cx=\"3.414\" cy=\"3.414\" r=\"3.414\" fill=\"none\" stroke-linejoin=\"round\" data-name=\"Ellipse 2\" transform=\"translate(16.006 15.434)\"></circle><path fill=\"none\" d=\"m23.542 15.107-5.726-4.796\" data-name=\"Line 5\"></path><path fill=\"none\" d=\"m18.653 7.927-2.791 3.687\" data-name=\"Line 6\"></path><path fill=\"currentColor\" stroke-linejoin=\"round\" d=\"m4.808.761 7.971 17.367\" data-name=\"Line 7\"></path><path fill=\"none\" d=\"M4.115 15.27h6.23\" data-name=\"Line 8\"></path><path fill=\"none\" d=\"M24.618 14.574V8.905c0-2.764-2.013-4.506-5.986-5.738s-3.876-1.045-9.569-2.6-5.765 1.4-5.765 4.946v9.19\" data-name=\"Line 5\"></path><path d=\"M5.246 18.664H.949a1.709 1.709 0 1 1 0-3.394h5.476M22.959 15.27h3.099a1.709 1.709 0 1 1 0 3.394h-3.18\" data-name=\"Line 4\"></path></g></g></g></symbol><symbol id=\"note\" viewBox=\"0 0 32 32\"><path fill=\"none\" d=\"M0 0h32v32H0z\"></path><g stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"2\" data-name=\"Group 2\"><path fill=\"none\" d=\"M24 26H8V5h9.267L24 11.732v14.267Z\" data-name=\"Subtraction 3\"></path><path fill=\"none\" d=\"M21.513 12.049h-4.634V7.14\" data-name=\"Path 5\"></path></g></symbol><symbol id=\"company\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><g data-name=\"Layer 2\"><g fill=\"none\" stroke=\"currentColor\" data-name=\"Layer 1\" transform=\"translate(1 3)\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m8.011 3-.071-.78A2.077 2.077 0 0 1 9.834 0h10.433a1.808 1.808 0 0 1 1.347.663 2.354 2.354 0 0 1 .538 1.557l.031 2.788\" data-name=\"Path 1\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M25.8 26.25H4.1a4.037 4.037 0 0 1-4.1-4V6.67a4.127 4.127 0 0 1 1.218-2.968A3.6 3.6 0 0 1 4.1 2.67c5.69 1 21.708 3.06 21.708 3.06a5.651 5.651 0 0 1 4.1 5.85v10.7a4.035 4.035 0 0 1-4.108 3.97Z\" data-name=\"Path 2\"></path><rect width=\"10.11\" height=\"6.05\" stroke-width=\"1.97\" data-name=\"Rectangle 1\" rx=\"2.19\" transform=\"translate(9.977 12.884)\"></rect><path stroke-width=\"1.97\" d=\"M.05 10.539 10.5 15.5\" data-name=\"Line 1\"></path><path stroke-width=\"1.97\" d=\"M19.664 15.521 30 12.391\" data-name=\"Path 3\"></path></g></g></g></symbol><symbol id=\"editor-header\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><text transform=\"translate(0 -15)\" font-size=\"56\" font-family=\"CourierNewPSMT, Courier New\"><tspan x=\"-.803\" y=\"47\">H</tspan></text></g></symbol><symbol id=\"editor-italic\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><text transform=\"translate(-3 -15)\" font-size=\"56\" font-family=\"CourierNewPS-ItalicMT, Courier New\" font-style=\"italic\"><tspan x=\"-.803\" y=\"47\">I</tspan></text></g></symbol><symbol id=\"editor-bold\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><text transform=\"translate(0 -13)\" font-size=\"54\" font-family=\"CourierNewPS-BoldMT, Courier New\" font-weight=\"700\"><tspan x=\"-.203\" y=\"45\">B</tspan></text></g></symbol><symbol id=\"editor-list-dot\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><g data-name=\"Group 1\"><g data-name=\"Ellipse 1\" transform=\"translate(1)\" fill=\"currentColor\" stroke=\"currentColor\"><circle cx=\"3.5\" cy=\"3.5\" r=\"3.5\" stroke=\"none\"></circle><circle cx=\"3.5\" cy=\"3.5\" r=\"3\" fill=\"none\"></circle></g><g data-name=\"Ellipse 2\" transform=\"translate(1 12)\" fill=\"currentColor\" stroke=\"currentColor\"><circle cx=\"3.5\" cy=\"3.5\" r=\"3.5\" stroke=\"none\"></circle><circle cx=\"3.5\" cy=\"3.5\" r=\"3\" fill=\"none\"></circle></g><g data-name=\"Ellipse 3\" transform=\"translate(1 24)\" fill=\"currentColor\" stroke=\"currentColor\"><circle cx=\"3.5\" cy=\"3.5\" r=\"3.5\" stroke=\"none\"></circle><circle cx=\"3.5\" cy=\"3.5\" r=\"3\" fill=\"none\"></circle></g><g data-name=\"Component 1 – 1\"><path data-name=\"Line 1\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M12 4h17\"></path></g><g data-name=\"Component 1 – 7\"><path data-name=\"Line 1\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M12 16h17\"></path></g><g data-name=\"Component 1 – 8\"><path data-name=\"Line 1\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M12 28h17\"></path></g></g></g></symbol><symbol id=\"editor-list-number\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g clip-path=\"url(#a)\"><text data-name=\"1\" transform=\"translate(5 8)\" font-size=\"9\" font-family=\"CourierNewPS-BoldMT, Courier New\" font-weight=\"700\"><tspan x=\"-2.7\" y=\"0\">1</tspan></text><text data-name=\"2\" transform=\"translate(5 19)\" font-size=\"9\" font-family=\"CourierNewPS-BoldMT, Courier New\" font-weight=\"700\"><tspan x=\"-2.7\" y=\"0\">2</tspan></text><text data-name=\"3\" transform=\"translate(5 30)\" font-size=\"9\" font-family=\"CourierNewPS-BoldMT, Courier New\" font-weight=\"700\" opacity=\".9\"><tspan x=\"-2.7\" y=\"0\">3</tspan></text><path data-name=\"Path 4\" d=\"M11.5 5.25h17\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\"></path><path data-name=\"Line 5\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M11.5 26.75h17\"></path><path data-name=\"Line 6\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"5\" d=\"M11.5 16.25h17\"></path><path data-name=\"Line 4\" fill=\"none\" stroke=\"currentColor\" d=\"M18.5 5.75\"></path></g></symbol><symbol id=\"editor-link\" viewBox=\"0 0 32 32\"><defs><clipPath id=\"a\"><path d=\"M0 0h32v32H0z\"></path></clipPath></defs><g data-name=\"SuperMegaIconOfAwesome – 5\" clip-path=\"url(#a)\" fill=\"none\" stroke-linecap=\"round\"><g data-name=\"Path 2\"><path d=\"M27.404 2.614a6.725 6.725 0 0 1-.304 9.497l-6.03 6.03a6.725 6.725 0 0 1-9.497.305 6.725 6.725 0 0 1 .304-9.497l6.03-6.03a6.725 6.725 0 0 1 9.497-.305Z\"></path><path d=\"M25.283 4.736c-1.365-1.365-3.722-1.229-5.254.303L14 11.07c-1.533 1.533-1.67 3.89-.305 5.254 1.365 1.365 3.722 1.228 5.254-.304l6.03-6.03c1.533-1.533 1.67-3.89.305-5.254m2.121-2.122c2.539 2.539 2.403 6.79-.304 9.497l-6.03 6.03c-2.707 2.707-6.959 2.843-9.497.304-2.538-2.538-2.402-6.79.304-9.496l6.03-6.03c2.707-2.707 6.959-2.843 9.497-.305Z\" fill=\"currentColor\"></path></g><g data-name=\"Path 3\"><path d=\"M20.427 13.614a6.725 6.725 0 0 1-.304 9.497l-6.03 6.03a6.725 6.725 0 0 1-9.497.305 6.725 6.725 0 0 1 .304-9.497l6.03-6.03a6.725 6.725 0 0 1 9.497-.305Z\"></path><path d=\"M18.306 15.736c-1.365-1.365-3.722-1.229-5.254.303l-6.03 6.031c-1.533 1.533-1.67 3.89-.305 5.254 1.365 1.365 3.722 1.228 5.254-.304l6.03-6.03c1.533-1.533 1.67-3.89.305-5.254m2.121-2.122c2.539 2.539 2.403 6.79-.304 9.497l-6.03 6.03c-2.707 2.707-6.959 2.843-9.497.304-2.538-2.538-2.402-6.79.304-9.496l6.03-6.03c2.707-2.707 6.959-2.843 9.497-.305Z\" fill=\"currentColor\"></path></g></g></symbol><symbol id=\"round-check\" viewBox=\"0 0 32 32\"><g><g><path d=\"M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0Zm0 29.94C8.31 29.94 2.06 23.69 2.06 16S8.31 2.06 16 2.06 29.94 8.31 29.94 16 23.69 29.94 16 29.94Z\" fill=\"currentColor\"></path><path d=\"M22.89 9.23 13.7 21.1l-4.71-4.39c-.42-.39-1.06-.36-1.46.05-.39.41-.36 1.07.05 1.45l6.36 5.94 10.57-13.66c.35-.45.27-1.1-.18-1.44-.45-.35-1.1-.27-1.45.19Z\" fill=\"currentColor\"></path></g></g></symbol><symbol id=\"agreement\" viewBox=\"0 0 32 32\" fill=\"currentColor\"><path d=\"M26.39 3.48 5.9.05c-1.6-.2-3 .18-4.07 1.09C.67 2.12 0 3.68 0 5.41v21.23C0 29.6 2.59 32 5.78 32h20.44c3.19 0 5.78-2.41 5.78-5.36V10.9c0-3.7-2.06-6.47-5.61-7.42Zm3.63 23.16c0 1.91-1.7 3.46-3.79 3.46H5.78c-2.09 0-3.79-1.55-3.79-3.46V5.41c0-1.16.43-2.23 1.16-2.84.52-.44 1.18-.66 1.95-.66.17 0 .34.01.52.03l20.35 3.4c1.22.33 4.06 1.53 4.06 5.57v15.73Z\"></path><path d=\"M8.17 12.06h7.04c.55 0 .99-.43.99-.95s-.44-.95-.99-.95H8.17c-.55 0-.99.43-.99.95s.44.95.99.95ZM24.1 15.97H8.17c-.55 0-.99.43-.99.95s.44.95.99.95H24.1c.55 0 .99-.43.99-.95s-.44-.95-.99-.95ZM24.1 21.79H8.17c-.55 0-.99.43-.99.95s.44.95.99.95H24.1c.55 0 .99-.43.99-.95s-.44-.95-.99-.95Z\"></path></symbol><symbol id=\"block\" viewBox=\"0 0 32 32\" fill=\"currentColor\"><path d=\"M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0Zm0 2c7.72 0 14 6.28 14 14 0 2.85-.86 5.51-2.33 7.72L5.6 6.66C8.17 3.81 11.87 2 16 2Zm0 28C8.28 30 2 23.72 2 16c0-2.87.87-5.55 2.36-7.77L26.44 25.3C23.87 28.18 20.15 30 16 30Z\"></path></symbol><symbol id=\"copy\" viewBox=\"0 0 29.35 32\" fill=\"currentColor\"><path d=\"M4.16 25.23C1.87 25.23 0 23.28 0 20.88V7.94c0-2.95 1.45-5.17 3.89-5.92L17.9 0h.02c2.41 0 4.27 1.95 4.27 4.34 0 .5-.41.91-.91.91s-.91-.41-.91-.91c0-1.4-1.05-2.53-2.34-2.53L4.28 3.78c-1.52.48-2.47 2.01-2.47 4.16v12.94c0 1.4 1.05 2.53 2.34 2.53.5 0 .91.41.91.91s-.41.91-.91.91Z\"></path><path d=\"M25.19 32H11.32c-2.29 0-4.16-1.95-4.16-4.34V14.71c0-2.95 1.45-5.16 3.88-5.92l14.02-2.02h.02c2.41 0 4.27 1.95 4.27 4.34v16.55c0 2.4-1.86 4.34-4.16 4.34Zm0-23.42-13.75 1.98c-1.52.48-2.47 2.01-2.47 4.16v12.94c0 1.39 1.05 2.53 2.34 2.53h13.87c1.29 0 2.34-1.13 2.34-2.53V11.11c0-1.4-1.05-2.53-2.34-2.53Z\"></path></symbol><symbol id=\"mail\" viewBox=\"0 0 32 30.8\" fill=\"currentColor\"><path d=\"M31.99 11.51c.15-3.47-2.2-6.52-5.61-7.27L5.88.01C2.84-.18.2 2.16 0 5.27v20.32c.19 2.93 2.65 5.21 5.5 5.21.11 0 .21 0 .32-.01h20.32c3.03.18 5.65-2.17 5.85-5.26V11.51Zm-6.05-5.2c.07.01.13.04.19.06l-6.92 8.11c-.17.21-.37.41-.59.59-.75.6-1.7.88-2.65.75-.95-.11-1.81-.59-2.43-1.38L3.46 2.84c.61-.48 1.37-.77 2.15-.74l20.34 4.21Zm.29 22.37H5.76c-1.87.14-3.52-1.33-3.64-3.15V5.34c.01-.24.06-.47.12-.7l9.68 11.15c.95 1.2 2.3 1.95 3.81 2.13.23.02.45.04.68.04 1.28 0 2.51-.43 3.53-1.23.35-.28.67-.6.92-.91l7.22-8.46a5.04 5.04 0 0 1 1.81 4.1v14c-.12 1.89-1.77 3.32-3.65 3.22Z\"></path></symbol><symbol id=\"move\" viewBox=\"0 0 32 28.5\" fill=\"currentColor\"><path d=\"M22.41 20.45c-.5 0-.9.4-.9.9v2.17c0 1.76-1.13 3.18-2.53 3.18H4.33c-1.39 0-2.53-1.43-2.53-3.18V4.98c0-1.76 1.13-3.18 2.45-3.19l14.53 1.24c1.73.66 2.73 2.52 2.73 5.12 0 .5.4.9.9.9s.9-.4.9-.9c0-3.41-1.51-5.97-4.03-6.85L4.33 0C1.94 0 0 2.23 0 4.98v18.54c0 2.75 1.94 4.98 4.33 4.98h14.65c2.39 0 4.33-2.23 4.33-4.98v-2.17c0-.5-.4-.9-.9-.9Z\"></path><path d=\"m31.74 13.86-4.6-4.6c-.35-.35-.92-.35-1.27 0s-.35.92 0 1.27l3.14 3.14s-.06-.02-.09-.02H14.31c-.5 0-.9.4-.9.9s.4.9.9.9h14.56l-3.26 3.26a.9.9 0 0 0 0 1.27c.18.18.41.26.64.26s.46-.09.64-.26l4.6-4.6s.07-.1.1-.15c.05-.03.11-.06.15-.1a.9.9 0 0 0 0-1.27Zm-1.95.6.04.04-.03.03s-.01-.04-.01-.07Z\"></path></symbol><symbol id=\"i\" viewBox=\"0 0 32 32\" fill=\"currentColor\"><g data-name=\"Group 2187\"><path data-name=\"Union 26\" d=\"M17.33 24.29h-4.31v-1.57h1.63V13.9h-1.63v-1.58h4.34v10.39h1.63v1.57h-1.66Z\"></path><path data-name=\"Path 479\" d=\"M15.98 10.64c.81.04 1.5-.59 1.54-1.4v-.02c.05-.78-.54-1.45-1.32-1.5h-.22c-.76-.07-1.43.5-1.5 1.26v.24c0 .78.63 1.42 1.41 1.42h.09Z\"></path></g></symbol><symbol id=\"import\" viewBox=\"0 0 25.8 27.6\" fill=\"currentColor\"><path d=\"M23.8 5.3c-.4-.3-.9-.3-1.3.1s-.3.9.1 1.3c.9.8 1.4 1.9 1.4 3.3v13.2c0 1.4-1.3 2.6-2.9 2.6H4.7c-1.6 0-2.9-1.2-2.9-2.6V6.4c0-1.4 1.3-2.6 2.9-2.6h4.6c.5 0 .9-.4.9-.9S9.8 2 9.3 2H4.7C2.1 2 0 4 0 6.4v16.8c0 2.4 2.1 4.4 4.7 4.4h16.4c2.6 0 4.7-2 4.7-4.4V10c0-1.9-.7-3.5-2-4.7z\"></path><path d=\"M7.7 11.9c-.3-.4-.9-.4-1.3 0-.4.3-.4.9 0 1.3l5.8 6c.2.2.4.3.6.3.2 0 .5-.1.6-.3l6.2-6.1c.4-.4.4-.9 0-1.3s-.9-.4-1.3 0l-4.7 4.6C12.7 10.3 16 3.3 21 1.8c.5-.2.7-.7.6-1.1-.2-.5-.7-.7-1.1-.6C14.8 1.9 11 9.4 12 16.3l-4.3-4.4z\"></path></symbol><symbol id=\"print\" viewBox=\"0 0 32 32\"><path d=\"M26.26 8.75h-.14V6.98c0-3.58-3.69-4.7-5.01-5.09L11.14.08c-1.79-.3-2.96.28-3.62.83-1.1.91-1.73 2.47-1.73 4.26v3.58h-.04C2.59 8.76.02 11.29.02 14.4v5.71c-.19 2.1.82 4.1 2.63 5.22.16.1.34.15.52.15.33 0 .65-.16.83-.45a.953.953 0 0 0-.31-1.33c-1.18-.73-1.84-2.04-1.71-3.49v-5.79c0-2.05 1.69-3.71 3.77-3.71h20.51c2.08 0 3.77 1.67 3.77 3.71v5.86c.09 1.25-.47 2.46-1.47 3.24a.95.95 0 0 0-.17 1.35c.33.42.95.5 1.37.17 1.52-1.17 2.35-2.99 2.23-4.82v-5.79c0-3.11-2.57-5.64-5.73-5.64ZM7.75 5.18c0-1.21.39-2.25 1.03-2.79.5-.41 1.18-.56 2.02-.41l9.84 1.78c3.12.94 3.52 2.22 3.52 3.22v1.77H7.75V5.17Z\"></path><path d=\"M10.49 16.07H6.78c-.54 0-.98-.43-.98-.96s.44-.96.98-.96h3.71c.54 0 .98.43.98.96s-.44.96-.98.96ZM25.65 19.88H6.81c-.54 0-.98.43-.98.96s.44.96.98.96h.51v5.22c0 1.52.94 2.5 2.84 2.95l12.01 2.02c1.66 0 3-1.33 3-2.96V21.8h.48c.54 0 .98-.43.98-.96s-.44-.96-.98-.96Zm-2.44 9.16c0 .57-.47 1.03-.88 1.05L10.56 28.1c-1.28-.3-1.28-.74-1.28-1.06v-5.22h13.93v7.23Z\"></path><path d=\"M19.48 25.83h-6.47c-.54 0-.98-.43-.98-.96s.44-.96.98-.96h6.47c.54 0 .98.43.98.96s-.44.96-.98.96Z\"></path></symbol><symbol id=\"anchor\" viewBox=\"0 0 12 12\" fill=\"currentColor\"><path d=\"M11.7 4.3 8.2.8 4.7 4.3c-.4.4-.4 1.1 0 1.5.2.1.4.2.7.2.3 0 .5-.1.7-.3l1.4-1.4c0 .4.1.9.1 1.3 0 1.2-.3 2.8-1.3 3.4-1 .9-2.4.8-3.3.1-.6-.4-1.1-1-1.6-1.6-.2-.3-.7-.4-1-.2-.4.2-.5.7-.3 1.1.9 1.3 2.2 2.3 3.8 2.8.3.1.5.1.8.1.8 0 1.7-.3 2.4-.8 1.3-.8 1.9-2.4 2-4.8V4.6l1.2 1.2c.4.4 1.1.4 1.5 0 .3-.5.3-1.1-.1-1.5z\"></path></symbol><symbol id=\"nineHole\" viewBox=\"2.955 5.694 21 21\"><path fill=\"#303030\" stroke=\"#fff\" stroke-width=\"2\" d=\"m3.85 25.79 19.2-19.2v19.2H3.85z\" vector-effect=\"non-scaling-stroke\"></path></symbol><symbol id=\"circle-minus-secondary\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" d=\"M22.5 16h-13\"></path><circle cx=\"16\" cy=\"16\" r=\"14.2\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-miterlimit=\"10\"></circle></symbol><symbol id=\"circle-plus-secondary\" viewBox=\"0 0 32 32\"><path d=\"M22.4 15.9H9.6M16 9.5v12.8\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><circle cx=\"16\" cy=\"15.9\" r=\"14.6\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle></symbol><symbol id=\"adress-secondary\" viewBox=\"0 0 35.6 32.4\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\"><path d=\"m33.201 15.454-13.2-13c-1.2-1.2-3.2-1.2-4.4 0l-13.2 13c-1.1 1.1-1.1 3 0 4.1.6.6 1.4.9 2.2.8h3.1v7.6c0 1.5 1.3 2.8 2.9 2.7h14.3c1.5 0 2.8-1.2 2.9-2.7v-7.6h3.1c1.6.1 3-1.1 3.1-2.7.1-.8-.2-1.6-.8-2.2z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M21.801 30.354v-7.5h-7.9v7.5\"></path><path stroke-linecap=\"round\" d=\"M27.401 9.754v-6.9\"></path></g></symbol><symbol id=\"circle-arrow-down-secondary\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"ro-secondaryund\" stroke-width=\"1.8\" d=\"m10.5 14.5 5.5 5.6 5.6-5.6\"></path><circle cx=\"15.9\" cy=\"16\" r=\"14.6\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle></symbol><symbol id=\"arrow-down-secondary\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.8\" d=\"m10.4 12.8 5.6 5.6 5.5-5.6\"></path></symbol><symbol id=\"bin-secondary\" viewBox=\"0 0 32 35.3\"><path d=\"M26.2 16.7v10.5c0 3.5-2.8 6.3-6.3 6.3H11c-3.5 0-6.3-2.8-6.3-6.3V11.6M9.4 5.7c0-2.3 1.9-4.2 4.2-4.2h4.7c2.3 0 4.2 1.9 4.2 4.2v4.4M1.6 4.3l28.7 8.8M12 16.2v12.1M18.9 16.2v12.1\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;\"></path></symbol><symbol id=\"calendar-secondary\" viewBox=\"0 0 32 35.2\"><g id=\"Group_776\" transform=\"translate(-64.242 -150.501)\"><path id=\"Line_325\" d=\"M74.1 151.9v5.3\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Line_326\" d=\"M86.1 151.9v5.3\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Path_261\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" d=\"M89.9 154.6H70.8c-2.4 0-4.4 1.9-4.5 4.3v20.7c0 2.3 1.8 4.3 4.2 4.3h.3c4.9-.5 19.1-4.3 19.1-4.3 2.4-.7 4.5-2.7 4.5-6.3v-14.4c0-2.5-2-4.4-4.5-4.3z\"></path><path id=\"Line_327\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1.8\" d=\"M67 164.3h26.9\"></path><path id=\"Line_328\" d=\"M72 170.6h.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Line_329\" d=\"M72 176.3h.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Line_330\" d=\"M79.7 170.6h.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Line_331\" d=\"M79.7 176.3h.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path id=\"Line_332\" d=\"M87.4 170.6h1\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path></g></symbol><symbol id=\"contact-secondary\" viewBox=\"0 0 24.9 35.3\"><path d=\"M16.7 2.1v3.7H8.1V2.1M10.2 29.2h4.4\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\" d=\"M17 33.2H7.9c-3.3 0-6-2.7-6-6V7.7c0-3.3 2.7-6 6-6H17c3.3 0 6 2.7 6 6v19.5c0 3.3-2.7 6-6 6z\"></path></symbol><symbol id=\"edit-secondary\" viewBox=\"0 0 33.4 35.3\"><path d=\"m24.8 13.5 2.4-2.8c1.2-1.4 1-3.4-.3-4.6L24.4 4c-1.4-1.2-3.4-1-4.6.3l-.5.7M16.1 8.7 3.7 23.1c-.5.6-1.3 6.7-1.3 6.7-.2 1.2 1.1 2.3 2.3 2 0 0 5.9-1.7 6.4-2.3l10.4-12.1M19.3 5l5.5 8.5M3.9 24.2l6 5.4M17.6 32.2h13.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;\"></path></symbol><symbol id=\"email-secondary\" viewBox=\"0 0 32.9 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:1.8;\" d=\"M26.3 29.8H6.4c-2.6 0-4.6-1.8-4.6-4.1V6c0-2.3 2.1-4.1 4.6-4.1L26.3 6c2.5.7 4.6 2.6 4.6 6v13.7c0 2.3-2.1 4.1-4.6 4.1z\"></path><path style=\"fill:none;stroke:currentColor;stroke-width:1.8;\" d=\"m2.7 3.5 10.5 12.1c2 2.3 5.2 2.3 7.1 0l7.5-8.8\"></path></symbol><symbol id=\"external-link-secondary\" viewBox=\"0 0 32 32\"><path style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\" d=\"M26.3 17.8v8.7c0 2.1-1.7 3.7-3.7 3.7H5.2c-2.1 0-3.7-1.7-3.7-3.7V9.1c0-2.1 1.7-3.7 3.7-3.7h8.7M20.9 1.4h9.6\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.836\" d=\"M30.5 11.6v-10\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2.001\" d=\"M16.3 15.7 29.5 2.3\"></path></symbol><symbol id=\"group-secondary\" viewBox=\"0 0 63.5 35.3\"><circle cx=\"32.3\" cy=\"10.4\" r=\"7.6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-miterlimit:10;\"></circle><path d=\"M21.8 33.5s-1-7.2 4.1-9.7c6.2-2.9 18.1 4.7 21.2 9.9M1.9 27.9c0-4.1 3.3-7.4 7.4-7.4s7.4 3.3 7.4 7.4M46.7 23.7c1.4-1.4 3.2-2.3 5.2-2.4 4.7-.4 8.8 3.4 9.2 8.3\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;\"></path><circle cx=\"9.3\" cy=\"11\" r=\"5.6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-miterlimit:10;\"></circle><circle cx=\"53.8\" cy=\"11.7\" r=\"4.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-miterlimit:10;\"></circle></symbol><symbol id=\"info-secondary\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.911\" d=\"M16 7.8v11.7\"></path><circle cx=\"16.2\" cy=\"16\" r=\"14.6\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle><circle cx=\"16\" cy=\"24.6\" r=\".9\" fill=\"currentColor\"></circle></symbol><symbol id=\"lock-secondary\" viewBox=\"0 0 25.6 34\"><path d=\"M6.3 11.2V8.4C6.3 4.9 9.2 2 12.8 2s6.5 2.9 6.5 6.4v6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;\"></path><path d=\"M20.2 32.2H5.4c-1.9 0-3.5-1.4-3.5-3.1V14.3c0-1.7 1.6-3.1 3.5-3.1l14.9 3.1c1.9.5 3.5 1.9 3.5 4.5v10.3c-.1 1.7-1.6 3.1-3.6 3.1z\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.8\" d=\"M12.4 24.8v2.9\"></path><circle cx=\"12.4\" cy=\"21.1\" r=\"3.2\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle></symbol><symbol id=\"unlock-secondary\" viewBox=\"0 0 25.6 36.6\"><path d=\"M19.3 11V8.2c0-3.6-2.9-6.4-6.4-6.4-3.6 0-6.4 2.9-6.4 6.4v6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" d=\"M20.2 35.2H5.4c-1.9 0-3.5-1.4-3.5-3.1V17.3c0-1.7 1.6-3.1 3.5-3.1l14.9 3.1c1.9.5 3.5 1.9 3.5 4.5v10.3c-.1 1.7-1.6 3.1-3.6 3.1z\"></path><path d=\"M12.4 27.5v2.9\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path><circle cx=\"12.4\" cy=\"23.8\" r=\"3.2\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle></symbol><symbol id=\"search-secondary\" viewBox=\"0 0 32 32\"><path d=\"M18.8 2.4c4.1 2.7 6.1 7.9 4.8 12.8-1.7 6.1-7.9 9.6-14 7.8-6.1-1.8-9.7-8.2-8-14.3.9-3.4 3.3-6.1 6.3-7.4M21.2 20.8l9.6 9.6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;\"></path></symbol><symbol id=\"warning-secondary\" viewBox=\"0 0 32 32\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.8\" d=\"M15.8 10v8.6\"></path><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" d=\"M11.9 4.6 1.7 22.4C0 25.3 2.1 29 5.5 29h20.6c3.4 0 5.5-3.6 3.8-6.6L19.5 4.6c-1.7-2.9-5.9-2.9-7.6 0z\"></path><circle cx=\"15.8\" cy=\"24.3\" r=\".9\" fill=\"currentColor\"></circle></symbol><symbol id=\"circle-cross-secondary\" viewBox=\"0 0 32 32\"><circle cx=\"15.9\" cy=\"16\" r=\"14.6\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.8\"></circle><path d=\"m9.8 10.1 12 12M21.8 10.1l-12 12\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:10;\"></path></symbol><symbol id=\"cross-secondary\" viewBox=\"0 0 32 32\"><path d=\"m1.4 1.4 29.2 29.2M30.6 1.4 1.4 30.6\" style=\"fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;\"></path></symbol><symbol id=\"check-mark-secondary\" viewBox=\"0 0 8.483 7.495\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.8\" d=\"M1.262 4.562l2.163 1.667 3.797-4.967\" data-name=\"arrow no circle 32 secondary\"></path></symbol><symbol id=\"loader-primary\" viewBox=\"0 0 46 46\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"5\"><path stroke-linecap=\"round\" d=\"M 23 3 A 20 20 45 0 1 43 23\"></path><path stroke-linecap=\"round\" d=\"M 23 43 A 20 20 45 0 1 3 23\"></path></g></symbol><symbol id=\"question-mark-circle-secondary\" viewBox=\"0 0 32 32\"><g data-name=\"Group 827\" transform=\"translate(-63.154 -1376.607)\"><path d=\"M79.154 1378.407a14.2 14.2 0 0 0-10.041 24.241 14.2 14.2 0 0 0 20.082-20.082 14.107 14.107 0 0 0-10.041-4.159m0-1.8a16 16 0 1 1-16 16 16 16 0 0 1 16-16Z\" data-name=\"Ellipse 243\"></path><circle cx=\".9\" cy=\".9\" r=\".9\" data-name=\"Ellipse 244\" transform=\"translate(78.254 1400.06)\"></circle><path d=\"M78.96 1396.055a.9.9 0 0 1-.9-.876c-.066-2.5 1.633-3.693 2.758-4.484l.316-.225a3 3 0 0 0 1.138-3.1 2.162 2.162 0 0 0-1.1-1.606 3.316 3.316 0 0 0-2.609-.066 2.45 2.45 0 0 0-1.54 2.061v-.01l-1.8-.034a4.24 4.24 0 0 1 2.642-3.677 5.12 5.12 0 0 1 4.149.136 3.959 3.959 0 0 1 2.021 2.843 4.759 4.759 0 0 1-1.841 4.9c-.111.081-.223.16-.342.243-1 .7-2.035 1.434-2 2.965a.9.9 0 0 1-.876.923Z\" data-name=\"Path 282\"></path></g></symbol>", 70);
const _hoisted_72 = [Iconsvue_type_template_id_5418c725_hoisted_2];
function Iconsvue_type_template_id_5418c725_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("svg", Iconsvue_type_template_id_5418c725_hoisted_1, _hoisted_72);
}
;// CONCATENATED MODULE: ./src/components/utilities/Resources/Icons.vue?vue&type=template&id=5418c725

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/Resources/Icons.vue?vue&type=script&lang=js
/* harmony default export */ var Iconsvue_type_script_lang_js = ({
  name: 'ExtAppShell'
});
;// CONCATENATED MODULE: ./src/components/utilities/Resources/Icons.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/utilities/Resources/Icons.vue




;
const Icons_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Iconsvue_type_script_lang_js, [['render',Iconsvue_type_template_id_5418c725_render]])

/* harmony default export */ var Icons = (Icons_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/AppShell/AppShell.vue?vue&type=script&lang=js

/* harmony default export */ var AppShellvue_type_script_lang_js = ({
  name: 'AppShell',
  components: {
    Icons: Icons
  },
  computed: {
    isHeadless() {
      return window.location.search && window.location.search.indexOf('?headless') !== -1;
    }
  },
  mounted() {
    document.getElementsByTagName('html')[0].classList.add('go-apps');
    if (this.isHeadless) {
      document.getElementsByTagName('html')[0].classList.add('go-apps--headless');
      document.getElementsByTagName('html')[0].classList.add('ace-scroll');
    }
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/AppShell/AppShell.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/AppShell/AppShell.vue?vue&type=style&index=0&id=5cda9a5f&lang=css
var AppShellvue_type_style_index_0_id_5cda9a5f_lang_css = __webpack_require__(3688);
;// CONCATENATED MODULE: ./src/components/utilities/AppShell/AppShell.vue?vue&type=style&index=0&id=5cda9a5f&lang=css

;// CONCATENATED MODULE: ./src/components/utilities/AppShell/AppShell.vue




;


const AppShell_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AppShellvue_type_script_lang_js, [['render',AppShellvue_type_template_id_5cda9a5f_render]])

/* harmony default export */ var AppShell = (AppShell_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=template&id=7dbc985a

const ExtAppShellvue_type_template_id_7dbc985a_hoisted_1 = {
  class: "ext-app-shell"
};
function ExtAppShellvue_type_template_id_7dbc985a_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icons = (0,external_vue_namespaceObject.resolveComponent)("Icons");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", ExtAppShellvue_type_template_id_7dbc985a_hoisted_1, [(0,external_vue_namespaceObject.createVNode)(_component_Icons), (0,external_vue_namespaceObject.renderSlot)(_ctx.$slots, "default")]);
}
;// CONCATENATED MODULE: ./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=template&id=7dbc985a

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=script&lang=js

/* harmony default export */ var ExtAppShellvue_type_script_lang_js = ({
  name: 'ExtAppShell',
  components: {
    Icons: Icons
  }
});
;// CONCATENATED MODULE: ./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=style&index=0&id=7dbc985a&lang=css
var ExtAppShellvue_type_style_index_0_id_7dbc985a_lang_css = __webpack_require__(3724);
;// CONCATENATED MODULE: ./src/components/utilities/ExtAppShell/ExtAppShell.vue?vue&type=style&index=0&id=7dbc985a&lang=css

;// CONCATENATED MODULE: ./src/components/utilities/ExtAppShell/ExtAppShell.vue




;


const ExtAppShell_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ExtAppShellvue_type_script_lang_js, [['render',ExtAppShellvue_type_template_id_7dbc985a_render]])

/* harmony default export */ var ExtAppShell = (ExtAppShell_exports_);
;// CONCATENATED MODULE: ./src/components/utilities/index.js



;// CONCATENATED MODULE: ./src/index.js







;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=go-ace-ui.common.js.map